// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/dripicons-v2.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/dripicons-v2.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/dripicons-v2.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/dripicons-v2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28185.4, 190.8, 196.2%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2334c38f%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f46a6a%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f46a6a%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2876.5, 99, 207%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/sidebar/img1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/sidebar/img2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/sidebar/img3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../images/sidebar/img4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../images/bg-auth-overlay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../images/crypto/bg-ico-hero.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=5.8.55" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "#dripicons-v2" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-check::before {
  content: "\\f1538";
}

.mdi-access-point-minus::before {
  content: "\\f1539";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-access-point-off::before {
  content: "\\f1511";
}

.mdi-access-point-plus::before {
  content: "\\f153a";
}

.mdi-access-point-remove::before {
  content: "\\f153b";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-reactivate::before {
  content: "\\f152b";
}

.mdi-account-reactivate-outline::before {
  content: "\\f152c";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\f14ec";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-adobe::before {
  content: "\\f0936";
}

.mdi-adobe-acrobat::before {
  content: "\\f0f9d";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-humidifier-off::before {
  content: "\\f1466";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-panel::before {
  content: "\\f15c4";
}

.mdi-alarm-panel-outline::before {
  content: "\\f15c5";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-minus::before {
  content: "\\f14bb";
}

.mdi-alert-minus-outline::before {
  content: "\\f14be";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-plus::before {
  content: "\\f14ba";
}

.mdi-alert-plus-outline::before {
  content: "\\f14bd";
}

.mdi-alert-remove::before {
  content: "\\f14bc";
}

.mdi-alert-remove-outline::before {
  content: "\\f14bf";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-amazon::before {
  content: "\\f002d";
}

.mdi-amazon-alexa::before {
  content: "\\f08c6";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-auto::before {
  content: "\\f0a8e";
}

.mdi-android-debug-bridge::before {
  content: "\\f0033";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-airplay::before {
  content: "\\f001f";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f0614";
}

.mdi-application-cog::before {
  content: "\\f1577";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-application-settings::before {
  content: "\\f1555";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-alert::before {
  content: "\\f14fd";
}

.mdi-archive-alert-outline::before {
  content: "\\f14fe";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\f1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\f1595";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\f1599";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\f159a";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\f1598";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\f1593";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\f1594";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\f1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-info::before {
  content: "\\f140e";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-buggy::before {
  content: "\\f13e0";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-bag-suitcase::before {
  content: "\\f158b";
}

.mdi-bag-suitcase-off::before {
  content: "\\f158d";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\f158e";
}

.mdi-bag-suitcase-outline::before {
  content: "\\f158c";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bandcamp::before {
  content: "\\f0675";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-check::before {
  content: "\\f1655";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-off::before {
  content: "\\f1656";
}

.mdi-bank-off-outline::before {
  content: "\\f1657";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-baseball-diamond::before {
  content: "\\f15ec";
}

.mdi-baseball-diamond-outline::before {
  content: "\\f15ed";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-minus::before {
  content: "\\f1523";
}

.mdi-basket-minus-outline::before {
  content: "\\f1524";
}

.mdi-basket-off::before {
  content: "\\f1525";
}

.mdi-basket-off-outline::before {
  content: "\\f1526";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-plus::before {
  content: "\\f1527";
}

.mdi-basket-plus-outline::before {
  content: "\\f1528";
}

.mdi-basket-remove::before {
  content: "\\f1529";
}

.mdi-basket-remove-outline::before {
  content: "\\f152a";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-battlenet::before {
  content: "\\f0b60";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-off-outline::before {
  content: "\\f13ed";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beekeeper::before {
  content: "\\f14e2";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-cancel::before {
  content: "\\f13e7";
}

.mdi-bell-cancel-outline::before {
  content: "\\f13e8";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-minus::before {
  content: "\\f13e9";
}

.mdi-bell-minus-outline::before {
  content: "\\f13ea";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-remove::before {
  content: "\\f13eb";
}

.mdi-bell-remove-outline::before {
  content: "\\f13ec";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bicycle-electric::before {
  content: "\\f15b4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\f15e9";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bird::before {
  content: "\\f15c6";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blogger::before {
  content: "\\f00ae";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolnisi-cross::before {
  content: "\\f0ced";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alert::before {
  content: "\\f167c";
}

.mdi-book-alert-outline::before {
  content: "\\f167d";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-arrow-down::before {
  content: "\\f167e";
}

.mdi-book-arrow-down-outline::before {
  content: "\\f167f";
}

.mdi-book-arrow-left::before {
  content: "\\f1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\f1681";
}

.mdi-book-arrow-right::before {
  content: "\\f1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\f1683";
}

.mdi-book-arrow-up::before {
  content: "\\f1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\f1685";
}

.mdi-book-cancel::before {
  content: "\\f1686";
}

.mdi-book-cancel-outline::before {
  content: "\\f1687";
}

.mdi-book-check::before {
  content: "\\f14f3";
}

.mdi-book-check-outline::before {
  content: "\\f14f4";
}

.mdi-book-clock::before {
  content: "\\f1688";
}

.mdi-book-clock-outline::before {
  content: "\\f1689";
}

.mdi-book-cog::before {
  content: "\\f168a";
}

.mdi-book-cog-outline::before {
  content: "\\f168b";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-edit::before {
  content: "\\f168c";
}

.mdi-book-edit-outline::before {
  content: "\\f168d";
}

.mdi-book-education::before {
  content: "\\f16c9";
}

.mdi-book-education-outline::before {
  content: "\\f16ca";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-lock-open-outline::before {
  content: "\\f168e";
}

.mdi-book-lock-outline::before {
  content: "\\f168f";
}

.mdi-book-marker::before {
  content: "\\f1690";
}

.mdi-book-marker-outline::before {
  content: "\\f1691";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-minus-outline::before {
  content: "\\f1692";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-music-outline::before {
  content: "\\f1693";
}

.mdi-book-off::before {
  content: "\\f1694";
}

.mdi-book-off-outline::before {
  content: "\\f1695";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-blank-variant::before {
  content: "\\f00be";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\f15d6";
}

.mdi-book-open-variant::before {
  content: "\\f14f7";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-plus-outline::before {
  content: "\\f1696";
}

.mdi-book-refresh::before {
  content: "\\f1697";
}

.mdi-book-refresh-outline::before {
  content: "\\f1698";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-remove-outline::before {
  content: "\\f1699";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-settings::before {
  content: "\\f169a";
}

.mdi-book-settings-outline::before {
  content: "\\f169b";
}

.mdi-book-sync::before {
  content: "\\f169c";
}

.mdi-book-sync-outline::before {
  content: "\\f16c8";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-off::before {
  content: "\\f1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\f1659";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-briefcase-variant::before {
  content: "\\f1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\f165a";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\f165b";
}

.mdi-briefcase-variant-outline::before {
  content: "\\f1495";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-bucket::before {
  content: "\\f1415";
}

.mdi-bucket-outline::before {
  content: "\\f1416";
}

.mdi-buddhism::before {
  content: "\\f094b";
}

.mdi-buffer::before {
  content: "\\f0619";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-butterfly::before {
  content: "\\f1589";
}

.mdi-butterfly-outline::before {
  content: "\\f158a";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calculator-variant-outline::before {
  content: "\\f15a6";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-cursor::before {
  content: "\\f157b";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-end::before {
  content: "\\f166c";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-lock::before {
  content: "\\f1641";
}

.mdi-calendar-lock-outline::before {
  content: "\\f1642";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-start::before {
  content: "\\f166d";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-flip::before {
  content: "\\f15d9";
}

.mdi-camera-flip-outline::before {
  content: "\\f15da";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-cannabis-off::before {
  content: "\\f166e";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-cog::before {
  content: "\\f13cc";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-electric-outline::before {
  content: "\\f15b5";
}

.mdi-car-emergency::before {
  content: "\\f160f";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-lifted-pickup::before {
  content: "\\f152d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-outline::before {
  content: "\\f14ed";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-settings::before {
  content: "\\f13cd";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-carabiner::before {
  content: "\\f14c0";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-minus::before {
  content: "\\f1600";
}

.mdi-card-minus-outline::before {
  content: "\\f1601";
}

.mdi-card-off::before {
  content: "\\f1602";
}

.mdi-card-off-outline::before {
  content: "\\f1603";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-remove::before {
  content: "\\f1604";
}

.mdi-card-remove-outline::before {
  content: "\\f1605";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-check::before {
  content: "\\f15ea";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-cart-variant::before {
  content: "\\f15eb";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-check::before {
  content: "\\f14ee";
}

.mdi-cash-lock::before {
  content: "\\f14ea";
}

.mdi-cash-lock-open::before {
  content: "\\f14eb";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cash-usd::before {
  content: "\\f1176";
}

.mdi-cash-usd-outline::before {
  content: "\\f0117";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-android::before {
  content: "\\f011d";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-erase::before {
  content: "\\f094d";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-iphone::before {
  content: "\\f0120";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-celtic-cross::before {
  content: "\\f0cf5";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-box::before {
  content: "\\f154d";
}

.mdi-chart-box-outline::before {
  content: "\\f154e";
}

.mdi-chart-box-plus-outline::before {
  content: "\\f154f";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\f15b6";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-minus::before {
  content: "\\f1410";
}

.mdi-chat-minus-outline::before {
  content: "\\f1413";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-plus::before {
  content: "\\f140f";
}

.mdi-chat-plus-outline::before {
  content: "\\f1412";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-remove::before {
  content: "\\f1411";
}

.mdi-chat-remove-outline::before {
  content: "\\f1414";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-box-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-check-box-outline::before {
  content: "\\f0c52";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-cheese-off::before {
  content: "\\f13ee";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chili-off::before {
  content: "\\f1467";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-christianity::before {
  content: "\\f0953";
}

.mdi-christianity-outline::before {
  content: "\\f0cf6";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-cigar-off::before {
  content: "\\f141b";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-box::before {
  content: "\\f15dc";
}

.mdi-circle-box-outline::before {
  content: "\\f15dd";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-edit::before {
  content: "\\f14e5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\f14e6";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-minus::before {
  content: "\\f1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\f1619";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-off::before {
  content: "\\f161a";
}

.mdi-clipboard-off-outline::before {
  content: "\\f161b";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-remove::before {
  content: "\\f161c";
}

.mdi-clipboard-remove-outline::before {
  content: "\\f161d";
}

.mdi-clipboard-search::before {
  content: "\\f161e";
}

.mdi-clipboard-search-outline::before {
  content: "\\f161f";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-off::before {
  content: "\\f1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\f1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clipboard-text-search::before {
  content: "\\f1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\f1623";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-clock-time-eight::before {
  content: "\\f1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\f1452";
}

.mdi-clock-time-eleven::before {
  content: "\\f1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\f1455";
}

.mdi-clock-time-five::before {
  content: "\\f1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\f144f";
}

.mdi-clock-time-four::before {
  content: "\\f1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\f144e";
}

.mdi-clock-time-nine::before {
  content: "\\f1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\f1453";
}

.mdi-clock-time-one::before {
  content: "\\f143f";
}

.mdi-clock-time-one-outline::before {
  content: "\\f144b";
}

.mdi-clock-time-seven::before {
  content: "\\f1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\f1451";
}

.mdi-clock-time-six::before {
  content: "\\f1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\f1450";
}

.mdi-clock-time-ten::before {
  content: "\\f1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\f1454";
}

.mdi-clock-time-three::before {
  content: "\\f1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\f144d";
}

.mdi-clock-time-twelve::before {
  content: "\\f144a";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\f1456";
}

.mdi-clock-time-two::before {
  content: "\\f1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\f144c";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-off::before {
  content: "\\f13ce";
}

.mdi-cog-off-outline::before {
  content: "\\f13cf";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-refresh::before {
  content: "\\f145e";
}

.mdi-cog-refresh-outline::before {
  content: "\\f145f";
}

.mdi-cog-sync::before {
  content: "\\f1460";
}

.mdi-cog-sync-outline::before {
  content: "\\f1461";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-bookmark::before {
  content: "\\f15ae";
}

.mdi-comment-bookmark-outline::before {
  content: "\\f15af";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-flash::before {
  content: "\\f15b0";
}

.mdi-comment-flash-outline::before {
  content: "\\f15b1";
}

.mdi-comment-minus::before {
  content: "\\f15df";
}

.mdi-comment-minus-outline::before {
  content: "\\f15e0";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-off::before {
  content: "\\f15e1";
}

.mdi-comment-off-outline::before {
  content: "\\f15e2";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compare-horizontal::before {
  content: "\\f1492";
}

.mdi-compare-vertical::before {
  content: "\\f1493";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-concourse-ci::before {
  content: "\\f10a0";
}

.mdi-connection::before {
  content: "\\f1616";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-cog::before {
  content: "\\f145b";
}

.mdi-content-save-cog-outline::before {
  content: "\\f145c";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-off::before {
  content: "\\f1643";
}

.mdi-content-save-off-outline::before {
  content: "\\f1644";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-cookie-alert::before {
  content: "\\f16d0";
}

.mdi-cookie-alert-outline::before {
  content: "\\f16d1";
}

.mdi-cookie-check::before {
  content: "\\f16d2";
}

.mdi-cookie-check-outline::before {
  content: "\\f16d3";
}

.mdi-cookie-cog::before {
  content: "\\f16d4";
}

.mdi-cookie-cog-outline::before {
  content: "\\f16d5";
}

.mdi-cookie-minus::before {
  content: "\\f16da";
}

.mdi-cookie-minus-outline::before {
  content: "\\f16db";
}

.mdi-cookie-outline::before {
  content: "\\f16de";
}

.mdi-cookie-plus::before {
  content: "\\f16d6";
}

.mdi-cookie-plus-outline::before {
  content: "\\f16d7";
}

.mdi-cookie-remove::before {
  content: "\\f16d8";
}

.mdi-cookie-remove-outline::before {
  content: "\\f16d9";
}

.mdi-cookie-settings::before {
  content: "\\f16dc";
}

.mdi-cookie-settings-outline::before {
  content: "\\f16dd";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-corn-off::before {
  content: "\\f13ef";
}

.mdi-cosine-wave::before {
  content: "\\f1479";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-check::before {
  content: "\\f13d0";
}

.mdi-credit-card-check-outline::before {
  content: "\\f13d1";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refresh::before {
  content: "\\f1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\f1646";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-search::before {
  content: "\\f1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\f1648";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-sync::before {
  content: "\\f1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\f164a";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-off::before {
  content: "\\f141c";
}

.mdi-cube-off-outline::before {
  content: "\\f141d";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-mnt::before {
  content: "\\f1512";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-circle::before {
  content: "\\f116b";
}

.mdi-currency-usd-circle-outline::before {
  content: "\\f0178";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f1480";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-dance-ballroom::before {
  content: "\\f15fb";
}

.mdi-dance-pole::before {
  content: "\\f1578";
}

.mdi-data-matrix::before {
  content: "\\f153c";
}

.mdi-data-matrix-edit::before {
  content: "\\f153d";
}

.mdi-data-matrix-minus::before {
  content: "\\f153e";
}

.mdi-data-matrix-plus::before {
  content: "\\f153f";
}

.mdi-data-matrix-remove::before {
  content: "\\f1540";
}

.mdi-data-matrix-scan::before {
  content: "\\f1541";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-alert::before {
  content: "\\f163a";
}

.mdi-database-alert-outline::before {
  content: "\\f1624";
}

.mdi-database-arrow-down::before {
  content: "\\f163b";
}

.mdi-database-arrow-down-outline::before {
  content: "\\f1625";
}

.mdi-database-arrow-left::before {
  content: "\\f163c";
}

.mdi-database-arrow-left-outline::before {
  content: "\\f1626";
}

.mdi-database-arrow-right::before {
  content: "\\f163d";
}

.mdi-database-arrow-right-outline::before {
  content: "\\f1627";
}

.mdi-database-arrow-up::before {
  content: "\\f163e";
}

.mdi-database-arrow-up-outline::before {
  content: "\\f1628";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-check-outline::before {
  content: "\\f1629";
}

.mdi-database-clock::before {
  content: "\\f163f";
}

.mdi-database-clock-outline::before {
  content: "\\f162a";
}

.mdi-database-cog::before {
  content: "\\f164b";
}

.mdi-database-cog-outline::before {
  content: "\\f164c";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-edit-outline::before {
  content: "\\f162b";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-export-outline::before {
  content: "\\f162c";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-import-outline::before {
  content: "\\f162d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-lock-outline::before {
  content: "\\f162e";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-marker-outline::before {
  content: "\\f162f";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-minus-outline::before {
  content: "\\f1630";
}

.mdi-database-off::before {
  content: "\\f1640";
}

.mdi-database-off-outline::before {
  content: "\\f1631";
}

.mdi-database-outline::before {
  content: "\\f1632";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-plus-outline::before {
  content: "\\f1633";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-refresh-outline::before {
  content: "\\f1634";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-remove-outline::before {
  content: "\\f1635";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-search-outline::before {
  content: "\\f1636";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-settings-outline::before {
  content: "\\f1637";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-database-sync-outline::before {
  content: "\\f1638";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-clock::before {
  content: "\\f1556";
}

.mdi-delete-clock-outline::before {
  content: "\\f1557";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-do-not-disturb::before {
  content: "\\f0698";
}

.mdi-do-not-disturb-off::before {
  content: "\\f0699";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-top::before {
  content: "\\f1513";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-dome-light::before {
  content: "\\f141e";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-grid::before {
  content: "\\f15fc";
}

.mdi-dots-hexagon::before {
  content: "\\f15ff";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-square::before {
  content: "\\f15fd";
}

.mdi-dots-triangle::before {
  content: "\\f15fe";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-douban::before {
  content: "\\f069a";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-box::before {
  content: "\\f1462";
}

.mdi-download-box-outline::before {
  content: "\\f1463";
}

.mdi-download-circle::before {
  content: "\\f1464";
}

.mdi-download-circle-outline::before {
  content: "\\f1465";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-minus::before {
  content: "\\f1407";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-box-plus::before {
  content: "\\f1406";
}

.mdi-earth-box-remove::before {
  content: "\\f1408";
}

.mdi-earth-minus::before {
  content: "\\f1404";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-earth-plus::before {
  content: "\\f1403";
}

.mdi-earth-remove::before {
  content: "\\f1405";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-egg-off::before {
  content: "\\f13f0";
}

.mdi-egg-off-outline::before {
  content: "\\f13f1";
}

.mdi-egg-outline::before {
  content: "\\f13f2";
}

.mdi-eiffel-tower::before {
  content: "\\f156b";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-off::before {
  content: "\\f13e3";
}

.mdi-email-off-outline::before {
  content: "\\f13e4";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-remove::before {
  content: "\\f1661";
}

.mdi-email-remove-outline::before {
  content: "\\f1662";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-sick::before {
  content: "\\f157c";
}

.mdi-emoticon-sick-outline::before {
  content: "\\f157d";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-plug-ccs1::before {
  content: "\\f1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\f151a";
}

.mdi-ev-plug-chademo::before {
  content: "\\f151b";
}

.mdi-ev-plug-tesla::before {
  content: "\\f151c";
}

.mdi-ev-plug-type1::before {
  content: "\\f151d";
}

.mdi-ev-plug-type2::before {
  content: "\\f151e";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-remove::before {
  content: "\\f15e3";
}

.mdi-eye-remove-outline::before {
  content: "\\f15e4";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-minus::before {
  content: "\\f13dd";
}

.mdi-eyedropper-off::before {
  content: "\\f13df";
}

.mdi-eyedropper-plus::before {
  content: "\\f13dc";
}

.mdi-eyedropper-remove::before {
  content: "\\f13de";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face::before {
  content: "\\f0643";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-mask::before {
  content: "\\f1586";
}

.mdi-face-mask-outline::before {
  content: "\\f1587";
}

.mdi-face-outline::before {
  content: "\\f0b96";
}

.mdi-face-profile::before {
  content: "\\f0644";
}

.mdi-face-profile-woman::before {
  content: "\\f1076";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-shimmer::before {
  content: "\\f15cc";
}

.mdi-face-shimmer-outline::before {
  content: "\\f15cd";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-face-woman-shimmer::before {
  content: "\\f15ce";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\f15cf";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-gaming::before {
  content: "\\f07dd";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-family-tree::before {
  content: "\\f160e";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-alert::before {
  content: "\\f146c";
}

.mdi-fan-chevron-down::before {
  content: "\\f146d";
}

.mdi-fan-chevron-up::before {
  content: "\\f146e";
}

.mdi-fan-minus::before {
  content: "\\f1470";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fan-plus::before {
  content: "\\f146f";
}

.mdi-fan-remove::before {
  content: "\\f1471";
}

.mdi-fan-speed-1::before {
  content: "\\f1472";
}

.mdi-fan-speed-2::before {
  content: "\\f1473";
}

.mdi-fan-speed-3::before {
  content: "\\f1474";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-60::before {
  content: "\\f160b";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-fencing::before {
  content: "\\f14c1";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-multiple::before {
  content: "\\f1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\f1518";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf::before {
  content: "\\f0225";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-pdf-box-outline::before {
  content: "\\f0fb3";
}

.mdi-file-pdf-outline::before {
  content: "\\f0e2d";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-tree-outline::before {
  content: "\\f13d2";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-off::before {
  content: "\\f14ef";
}

.mdi-filter-off-outline::before {
  content: "\\f14f0";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-alert::before {
  content: "\\f15d7";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fish-off::before {
  content: "\\f13f3";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-circle::before {
  content: "\\f0820";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-off::before {
  content: "\\f13f4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\f13f5";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-off::before {
  content: "\\f13f6";
}

.mdi-flask-off-outline::before {
  content: "\\f13f7";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-variant::before {
  content: "\\f1041";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\f147e";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\f147f";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-multiple::before {
  content: "\\f13d3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\f13d4";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-drumstick::before {
  content: "\\f141f";
}

.mdi-food-drumstick-off::before {
  content: "\\f1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\f1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\f1420";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-halal::before {
  content: "\\f1572";
}

.mdi-food-kosher::before {
  content: "\\f1573";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-steak::before {
  content: "\\f146a";
}

.mdi-food-steak-off::before {
  content: "\\f146b";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-food-variant-off::before {
  content: "\\f13e5";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-form-dropdown::before {
  content: "\\f1400";
}

.mdi-form-select::before {
  content: "\\f1401";
}

.mdi-form-textarea::before {
  content: "\\f1095";
}

.mdi-form-textbox::before {
  content: "\\f060e";
}

.mdi-form-textbox-lock::before {
  content: "\\f135d";
}

.mdi-form-textbox-password::before {
  content: "\\f07f5";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-variant-outline::before {
  content: "\\f150f";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-industrial::before {
  content: "\\f15ee";
}

.mdi-fridge-industrial-alert::before {
  content: "\\f15ef";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\f15f0";
}

.mdi-fridge-industrial-off::before {
  content: "\\f15f1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\f15f2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\f15f3";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fridge-variant::before {
  content: "\\f15f4";
}

.mdi-fridge-variant-alert::before {
  content: "\\f15f5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\f15f6";
}

.mdi-fridge-variant-off::before {
  content: "\\f15f7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\f15f8";
}

.mdi-fridge-variant-outline::before {
  content: "\\f15f9";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\f13f8";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\f13f9";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-alert::before {
  content: "\\f142d";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-fuse-off::before {
  content: "\\f142c";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-off::before {
  content: "\\f1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\f140a";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-ghost-off-outline::before {
  content: "\\f165c";
}

.mdi-ghost-outline::before {
  content: "\\f165d";
}

.mdi-gif::before {
  content: "\\f0d78";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\f15e6";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-off::before {
  content: "\\f15e7";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\f15e8";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-photos::before {
  content: "\\f06dd";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grass::before {
  content: "\\f1510";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand::before {
  content: "\\f0a4f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-heart-outline::before {
  content: "\\f157e";
}

.mdi-hand-left::before {
  content: "\\f0e46";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-right::before {
  content: "\\f0e47";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-wash::before {
  content: "\\f157f";
}

.mdi-hand-wash-outline::before {
  content: "\\f1580";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-handshake-outline::before {
  content: "\\f15a1";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-cog::before {
  content: "\\f1663";
}

.mdi-heart-cog-outline::before {
  content: "\\f1664";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-minus::before {
  content: "\\f142f";
}

.mdi-heart-minus-outline::before {
  content: "\\f1432";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-off-outline::before {
  content: "\\f1434";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-plus::before {
  content: "\\f142e";
}

.mdi-heart-plus-outline::before {
  content: "\\f1431";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-heart-remove::before {
  content: "\\f1430";
}

.mdi-heart-remove-outline::before {
  content: "\\f1433";
}

.mdi-heart-settings::before {
  content: "\\f1665";
}

.mdi-heart-settings-outline::before {
  content: "\\f1666";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-hinduism::before {
  content: "\\f0973";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-alert-outline::before {
  content: "\\f15d0";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-currency-usd::before {
  content: "\\f08af";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-minus-outline::before {
  content: "\\f13d5";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-plus-outline::before {
  content: "\\f13d6";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-remove-outline::before {
  content: "\\f13d7";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horse::before {
  content: "\\f15bf";
}

.mdi-horse-human::before {
  content: "\\f15c0";
}

.mdi-horse-variant::before {
  content: "\\f15c1";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hours-24::before {
  content: "\\f1478";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-cane::before {
  content: "\\f1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\f159b";
}

.mdi-human-capacity-increase::before {
  content: "\\f159c";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-edit::before {
  content: "\\f14e8";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-dance::before {
  content: "\\f15c9";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f064a";
}

.mdi-human-greeting-proximity::before {
  content: "\\f159d";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-queue::before {
  content: "\\f1571";
}

.mdi-human-scooter::before {
  content: "\\f11e9";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hvac-off::before {
  content: "\\f159e";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-iframe::before {
  content: "\\f0c8b";
}

.mdi-iframe-array::before {
  content: "\\f10f5";
}

.mdi-iframe-array-outline::before {
  content: "\\f10f6";
}

.mdi-iframe-braces::before {
  content: "\\f10f7";
}

.mdi-iframe-braces-outline::before {
  content: "\\f10f8";
}

.mdi-iframe-outline::before {
  content: "\\f0c8c";
}

.mdi-iframe-parentheses::before {
  content: "\\f10f9";
}

.mdi-iframe-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-iframe-variable::before {
  content: "\\f10fb";
}

.mdi-iframe-variable-outline::before {
  content: "\\f10fc";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-minus::before {
  content: "\\f1419";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-remove::before {
  content: "\\f1418";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-image-text::before {
  content: "\\f160d";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-inbox-remove::before {
  content: "\\f159f";
}

.mdi-inbox-remove-outline::before {
  content: "\\f15a0";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-circle::before {
  content: "\\f1421";
}

.mdi-incognito-circle-off::before {
  content: "\\f1422";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-islam::before {
  content: "\\f0979";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-judaism::before {
  content: "\\f097a";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-kangaroo::before {
  content: "\\f1558";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-chain::before {
  content: "\\f1574";
}

.mdi-key-chain-variant::before {
  content: "\\f1575";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladder::before {
  content: "\\f15a2";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lamps::before {
  content: "\\f1576";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-rust::before {
  content: "\\f1617";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-chromebook::before {
  content: "\\f0323";
}

.mdi-laptop-mac::before {
  content: "\\f0324";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laptop-windows::before {
  content: "\\f0325";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-laser-pointer::before {
  content: "\\f1484";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-lightning-bolt::before {
  content: "\\f140b";
}

.mdi-lightning-bolt-outline::before {
  content: "\\f140c";
}

.mdi-lingerie::before {
  content: "\\f1476";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-list-status::before {
  content: "\\f15ab";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-alert-outline::before {
  content: "\\f15d1";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-check-outline::before {
  content: "\\f16a8";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-minus::before {
  content: "\\f16a9";
}

.mdi-lock-minus-outline::before {
  content: "\\f16aa";
}

.mdi-lock-off::before {
  content: "\\f1671";
}

.mdi-lock-off-outline::before {
  content: "\\f1672";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-alert-outline::before {
  content: "\\f15d2";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-check-outline::before {
  content: "\\f16ab";
}

.mdi-lock-open-minus::before {
  content: "\\f16ac";
}

.mdi-lock-open-minus-outline::before {
  content: "\\f16ad";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-plus::before {
  content: "\\f16ae";
}

.mdi-lock-open-plus-outline::before {
  content: "\\f16af";
}

.mdi-lock-open-remove::before {
  content: "\\f16b0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\f16b1";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-plus-outline::before {
  content: "\\f16b2";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-remove::before {
  content: "\\f16b3";
}

.mdi-lock-remove-outline::before {
  content: "\\f16b4";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-lotion::before {
  content: "\\f1582";
}

.mdi-lotion-outline::before {
  content: "\\f1583";
}

.mdi-lotion-plus::before {
  content: "\\f1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\f1585";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-manjaro::before {
  content: "\\f160a";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-star::before {
  content: "\\f1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\f1609";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-bookmark::before {
  content: "\\f15ac";
}

.mdi-message-bookmark-outline::before {
  content: "\\f15ad";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-flash::before {
  content: "\\f15a9";
}

.mdi-message-flash-outline::before {
  content: "\\f15aa";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-off::before {
  content: "\\f164d";
}

.mdi-message-off-outline::before {
  content: "\\f164e";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-edge-legacy::before {
  content: "\\f1250";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microsoft-yammer::before {
  content: "\\f0789";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-microwave-off::before {
  content: "\\f1423";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-off::before {
  content: "\\f1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\f145a";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-minus-thick::before {
  content: "\\f1639";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-clean::before {
  content: "\\f1104";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-share::before {
  content: "\\f1483";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-moped-electric::before {
  content: "\\f15b7";
}

.mdi-moped-electric-outline::before {
  content: "\\f15b8";
}

.mdi-moped-outline::before {
  content: "\\f15b9";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion::before {
  content: "\\f15b2";
}

.mdi-motion-outline::before {
  content: "\\f15b3";
}

.mdi-motion-pause::before {
  content: "\\f1590";
}

.mdi-motion-pause-outline::before {
  content: "\\f1592";
}

.mdi-motion-play::before {
  content: "\\f158f";
}

.mdi-motion-play-outline::before {
  content: "\\f1591";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motion-sensor-off::before {
  content: "\\f1435";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-motorbike-electric::before {
  content: "\\f15ba";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-move-down::before {
  content: "\\f1550";
}

.mdi-mouse-move-up::before {
  content: "\\f1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\f1552";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-mower::before {
  content: "\\f166f";
}

.mdi-mower-bag::before {
  content: "\\f1670";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-off::before {
  content: "\\f13fa";
}

.mdi-mushroom-off-outline::before {
  content: "\\f13fb";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-mustache::before {
  content: "\\f15de";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-navigation-outline::before {
  content: "\\f1607";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-minus::before {
  content: "\\f164f";
}

.mdi-note-minus-outline::before {
  content: "\\f1650";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-remove::before {
  content: "\\f1651";
}

.mdi-note-remove-outline::before {
  content: "\\f1652";
}

.mdi-note-search::before {
  content: "\\f1653";
}

.mdi-note-search-outline::before {
  content: "\\f1654";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-check::before {
  content: "\\f14f5";
}

.mdi-notebook-check-outline::before {
  content: "\\f14f6";
}

.mdi-notebook-edit::before {
  content: "\\f14e7";
}

.mdi-notebook-edit-outline::before {
  content: "\\f14e9";
}

.mdi-notebook-minus::before {
  content: "\\f1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\f1611";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notebook-plus::before {
  content: "\\f1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\f1613";
}

.mdi-notebook-remove::before {
  content: "\\f1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\f1615";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-numeric-positive-1::before {
  content: "\\f15cb";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-office-building-marker::before {
  content: "\\f1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\f1521";
}

.mdi-office-building-outline::before {
  content: "\\f151f";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-orbit-variant::before {
  content: "\\f15db";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-pail::before {
  content: "\\f1417";
}

.mdi-pail-minus::before {
  content: "\\f1437";
}

.mdi-pail-minus-outline::before {
  content: "\\f143c";
}

.mdi-pail-off::before {
  content: "\\f1439";
}

.mdi-pail-off-outline::before {
  content: "\\f143e";
}

.mdi-pail-outline::before {
  content: "\\f143a";
}

.mdi-pail-plus::before {
  content: "\\f1436";
}

.mdi-pail-plus-outline::before {
  content: "\\f143b";
}

.mdi-pail-remove::before {
  content: "\\f1438";
}

.mdi-pail-remove-outline::before {
  content: "\\f143d";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f03de";
}

.mdi-panorama-vertical::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-paw-off-outline::before {
  content: "\\f1676";
}

.mdi-paw-outline::before {
  content: "\\f1675";
}

.mdi-pdf-box::before {
  content: "\\f0e56";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-pentagram::before {
  content: "\\f1667";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-pharmacy::before {
  content: "\\f03f1";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-dial::before {
  content: "\\f1559";
}

.mdi-phone-dial-outline::before {
  content: "\\f155a";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-remove::before {
  content: "\\f152f";
}

.mdi-phone-remove-outline::before {
  content: "\\f1530";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-pig-variant-outline::before {
  content: "\\f1678";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\f1679";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pine-tree-fire::before {
  content: "\\f141a";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pitchfork::before {
  content: "\\f1553";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\f13e6";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-minus-variant::before {
  content: "\\f14c9";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-one::before {
  content: "\\f041b";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-poll-box::before {
  content: "\\f0420";
}

.mdi-poll-box-outline::before {
  content: "\\f127b";
}

.mdi-polo::before {
  content: "\\f14c3";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-plug-off-outline::before {
  content: "\\f1424";
}

.mdi-power-plug-outline::before {
  content: "\\f1425";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-it::before {
  content: "\\f14ff";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-pretzel::before {
  content: "\\f1562";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-eye::before {
  content: "\\f1458";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-search::before {
  content: "\\f1457";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-question::before {
  content: "\\f1522";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pump::before {
  content: "\\f1402";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-check::before {
  content: "\\f1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\f1427";
}

.mdi-puzzle-edit::before {
  content: "\\f14d3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\f14d9";
}

.mdi-puzzle-heart::before {
  content: "\\f14d4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\f14da";
}

.mdi-puzzle-minus::before {
  content: "\\f14d1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\f14d7";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-puzzle-plus::before {
  content: "\\f14d0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\f14d6";
}

.mdi-puzzle-remove::before {
  content: "\\f14d2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\f14d8";
}

.mdi-puzzle-star::before {
  content: "\\f14d5";
}

.mdi-puzzle-star-outline::before {
  content: "\\f14db";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radiology-box::before {
  content: "\\f14c5";
}

.mdi-radiology-box-outline::before {
  content: "\\f14c6";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-rake::before {
  content: "\\f1544";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\f15d8";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-reiterate::before {
  content: "\\f1588";
}

.mdi-relation-many-to-many::before {
  content: "\\f1496";
}

.mdi-relation-many-to-one::before {
  content: "\\f1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\f1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\f1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\f149a";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\f149b";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\f149c";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\f149d";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\f149e";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\f149f";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\f14a0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\f14a1";
}

.mdi-relation-one-to-many::before {
  content: "\\f14a2";
}

.mdi-relation-one-to-one::before {
  content: "\\f14a3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\f14a4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\f14a5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\f14a6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\f14a7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\f14a8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\f14a9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\f14aa";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\f14ab";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\f14ac";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\f14ad";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\f14ae";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\f14af";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\f14b0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\f14b1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\f14b2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\f14b3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\f14b4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\f14b5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\f14b6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\f14b7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\f14b8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\f14b9";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-reproduction::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-60::before {
  content: "\\f160c";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\f14dc";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-rhombus-split-outline::before {
  content: "\\f14dd";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-rickshaw::before {
  content: "\\f15bb";
}

.mdi-rickshaw-electric::before {
  content: "\\f15bc";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-angry::before {
  content: "\\f169d";
}

.mdi-robot-angry-outline::before {
  content: "\\f169e";
}

.mdi-robot-confused::before {
  content: "\\f169f";
}

.mdi-robot-confused-outline::before {
  content: "\\f16a0";
}

.mdi-robot-dead::before {
  content: "\\f16a1";
}

.mdi-robot-dead-outline::before {
  content: "\\f16a2";
}

.mdi-robot-excited::before {
  content: "\\f16a3";
}

.mdi-robot-excited-outline::before {
  content: "\\f16a4";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-love::before {
  content: "\\f16a5";
}

.mdi-robot-love-outline::before {
  content: "\\f16a6";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-off::before {
  content: "\\f16a7";
}

.mdi-robot-off-outline::before {
  content: "\\f167b";
}

.mdi-robot-outline::before {
  content: "\\f167a";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-launch::before {
  content: "\\f14de";
}

.mdi-rocket-launch-outline::before {
  content: "\\f14df";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-off::before {
  content: "\\f15a3";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rug::before {
  content: "\\f1475";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-sawtooth-wave::before {
  content: "\\f147a";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scan-helper::before {
  content: "\\f13d8";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f15bd";
}

.mdi-scooter-electric::before {
  content: "\\f15be";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-off::before {
  content: "\\f13fd";
}

.mdi-seed-off-outline::before {
  content: "\\f13fe";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-seesaw::before {
  content: "\\f15a4";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple::before {
  content: "\\f1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-merge::before {
  content: "\\f14e0";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-split::before {
  content: "\\f14e1";
}

.mdi-set-square::before {
  content: "\\f145d";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\f14fa";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-share-variant-outline::before {
  content: "\\f1514";
}

.mdi-shark-fin::before {
  content: "\\f1673";
}

.mdi-shark-fin-outline::before {
  content: "\\f1674";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-account-variant::before {
  content: "\\f15a7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\f15a8";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-bug::before {
  content: "\\f13da";
}

.mdi-shield-bug-outline::before {
  content: "\\f13db";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shoe-ballet::before {
  content: "\\f15ca";
}

.mdi-shoe-cleat::before {
  content: "\\f15c7";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shoe-sneaker::before {
  content: "\\f15c8";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shore::before {
  content: "\\f14f9";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-pole::before {
  content: "\\f14f8";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-alert-outline::before {
  content: "\\f15d3";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-sim-off-outline::before {
  content: "\\f15d4";
}

.mdi-sim-outline::before {
  content: "\\f15d5";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sine-wave::before {
  content: "\\f095b";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skateboard::before {
  content: "\\f14c2";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skull-scan::before {
  content: "\\f14c7";
}

.mdi-skull-scan-outline::before {
  content: "\\f14c8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slide::before {
  content: "\\f15a5";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-smoking-pipe::before {
  content: "\\f140d";
}

.mdi-smoking-pipe-off::before {
  content: "\\f1428";
}

.mdi-snail::before {
  content: "\\f1677";
}

.mdi-snake::before {
  content: "\\f150e";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-off::before {
  content: "\\f14e3";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\f1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\f157a";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-sofa-outline::before {
  content: "\\f156d";
}

.mdi-sofa-single::before {
  content: "\\f156e";
}

.mdi-sofa-single-outline::before {
  content: "\\f156f";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\f1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\f1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\f1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\f154a";
}

.mdi-sort-clock-descending::before {
  content: "\\f154b";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\f154c";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-branch-check::before {
  content: "\\f14cf";
}

.mdi-source-branch-minus::before {
  content: "\\f14cb";
}

.mdi-source-branch-plus::before {
  content: "\\f14ca";
}

.mdi-source-branch-refresh::before {
  content: "\\f14cd";
}

.mdi-source-branch-remove::before {
  content: "\\f14cc";
}

.mdi-source-branch-sync::before {
  content: "\\f14ce";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-soy-sauce-off::before {
  content: "\\f13fc";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-sparkles::before {
  content: "\\f1545";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spirit-level::before {
  content: "\\f14f1";
}

.mdi-spoon-sugar::before {
  content: "\\f1429";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-circle::before {
  content: "\\f1500";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-rounded::before {
  content: "\\f14fb";
}

.mdi-square-rounded-outline::before {
  content: "\\f14fc";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-square-wave::before {
  content: "\\f147b";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-check::before {
  content: "\\f1566";
}

.mdi-star-check-outline::before {
  content: "\\f156a";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-cog::before {
  content: "\\f1668";
}

.mdi-star-cog-outline::before {
  content: "\\f1669";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-minus::before {
  content: "\\f1564";
}

.mdi-star-minus-outline::before {
  content: "\\f1568";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-off-outline::before {
  content: "\\f155b";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-plus::before {
  content: "\\f1563";
}

.mdi-star-plus-outline::before {
  content: "\\f1567";
}

.mdi-star-remove::before {
  content: "\\f1565";
}

.mdi-star-remove-outline::before {
  content: "\\f1569";
}

.mdi-star-settings::before {
  content: "\\f166a";
}

.mdi-star-settings-outline::before {
  content: "\\f166b";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-minus::before {
  content: "\\f165e";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-store-plus::before {
  content: "\\f165f";
}

.mdi-store-remove::before {
  content: "\\f1660";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-submarine::before {
  content: "\\f156c";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\f1336";
}

.mdi-symbol::before {
  content: "\\f1501";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-account::before {
  content: "\\f13b9";
}

.mdi-table-alert::before {
  content: "\\f13ba";
}

.mdi-table-arrow-down::before {
  content: "\\f13bb";
}

.mdi-table-arrow-left::before {
  content: "\\f13bc";
}

.mdi-table-arrow-right::before {
  content: "\\f13bd";
}

.mdi-table-arrow-up::before {
  content: "\\f13be";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-cancel::before {
  content: "\\f13bf";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-check::before {
  content: "\\f13c0";
}

.mdi-table-clock::before {
  content: "\\f13c1";
}

.mdi-table-cog::before {
  content: "\\f13c2";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-eye-off::before {
  content: "\\f13c3";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-heart::before {
  content: "\\f13c4";
}

.mdi-table-key::before {
  content: "\\f13c5";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-lock::before {
  content: "\\f13c6";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-minus::before {
  content: "\\f13c7";
}

.mdi-table-multiple::before {
  content: "\\f13c8";
}

.mdi-table-network::before {
  content: "\\f13c9";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-off::before {
  content: "\\f13ca";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-split-cell::before {
  content: "\\f142a";
}

.mdi-table-star::before {
  content: "\\f13cb";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-tablet-ipad::before {
  content: "\\f04f8";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tailwind::before {
  content: "\\f13ff";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-drive::before {
  content: "\\f16df";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teach::before {
  content: "\\f0890";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-telegram::before {
  content: "\\f0501";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-clean::before {
  content: "\\f1110";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-account::before {
  content: "\\f1570";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-search::before {
  content: "\\f13b8";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-subject::before {
  content: "\\f09aa";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-off::before {
  content: "\\f1531";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\f142b";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-check::before {
  content: "\\f1532";
}

.mdi-timeline-check-outline::before {
  content: "\\f1533";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-minus::before {
  content: "\\f1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\f1535";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-remove::before {
  content: "\\f1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\f1537";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-check::before {
  content: "\\f155c";
}

.mdi-tooltip-check-outline::before {
  content: "\\f155d";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-minus::before {
  content: "\\f155e";
}

.mdi-tooltip-minus-outline::before {
  content: "\\f155f";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-remove::before {
  content: "\\f1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\f1561";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-torch::before {
  content: "\\f1606";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-tractor-variant::before {
  content: "\\f14c4";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-horizontal::before {
  content: "\\f1546";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-skip::before {
  content: "\\f1515";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triangle-wave::before {
  content: "\\f147c";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-variant::before {
  content: "\\f1542";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-tune-vertical-variant::before {
  content: "\\f1543";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-twitter-retweet::before {
  content: "\\f0547";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\f13e2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\f13e1";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unicorn::before {
  content: "\\f15c2";
}

.mdi-unicorn-variant::before {
  content: "\\f15c3";
}

.mdi-unicycle::before {
  content: "\\f15e5";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-untappd::before {
  content: "\\f0551";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanish-quarter::before {
  content: "\\f1554";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-off::before {
  content: "\\f13d9";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-high-definition::before {
  content: "\\f152e";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-array-outline::before {
  content: "\\f1485";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-carousel-outline::before {
  content: "\\f1486";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-column-outline::before {
  content: "\\f1487";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-comfy-outline::before {
  content: "\\f1488";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\f1489";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-day-outline::before {
  content: "\\f148a";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-list-outline::before {
  content: "\\f148b";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-module-outline::before {
  content: "\\f148c";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-parallel-outline::before {
  content: "\\f148d";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-quilt-outline::before {
  content: "\\f148e";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-sequential-outline::before {
  content: "\\f148f";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-stream-outline::before {
  content: "\\f1490";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-view-week-outline::before {
  content: "\\f1491";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-virus::before {
  content: "\\f13b6";
}

.mdi-virus-outline::before {
  content: "\\f13b7";
}

.mdi-vk::before {
  content: "\\f0579";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voice-off::before {
  content: "\\f0ed4";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-alert::before {
  content: "\\f1502";
}

.mdi-water-alert-outline::before {
  content: "\\f1503";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-check::before {
  content: "\\f1504";
}

.mdi-water-check-outline::before {
  content: "\\f1505";
}

.mdi-water-minus::before {
  content: "\\f1506";
}

.mdi-water-minus-outline::before {
  content: "\\f1507";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-off-outline::before {
  content: "\\f1508";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-percent-alert::before {
  content: "\\f1509";
}

.mdi-water-plus::before {
  content: "\\f150a";
}

.mdi-water-plus-outline::before {
  content: "\\f150b";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-remove::before {
  content: "\\f150c";
}

.mdi-water-remove-outline::before {
  content: "\\f150d";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-watering-can::before {
  content: "\\f1481";
}

.mdi-watering-can-outline::before {
  content: "\\f1482";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waveform::before {
  content: "\\f147d";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunny-off::before {
  content: "\\f14e4";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheel-barrow::before {
  content: "\\f14f2";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-alert::before {
  content: "\\f16b5";
}

.mdi-wifi-arrow-down::before {
  content: "\\f16b6";
}

.mdi-wifi-arrow-left::before {
  content: "\\f16b7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\f16b8";
}

.mdi-wifi-arrow-right::before {
  content: "\\f16b9";
}

.mdi-wifi-arrow-up::before {
  content: "\\f16ba";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\f16bb";
}

.mdi-wifi-cancel::before {
  content: "\\f16bc";
}

.mdi-wifi-check::before {
  content: "\\f16bd";
}

.mdi-wifi-cog::before {
  content: "\\f16be";
}

.mdi-wifi-lock::before {
  content: "\\f16bf";
}

.mdi-wifi-lock-open::before {
  content: "\\f16c0";
}

.mdi-wifi-marker::before {
  content: "\\f16c1";
}

.mdi-wifi-minus::before {
  content: "\\f16c2";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-plus::before {
  content: "\\f16c3";
}

.mdi-wifi-refresh::before {
  content: "\\f16c4";
}

.mdi-wifi-remove::before {
  content: "\\f16c5";
}

.mdi-wifi-settings::before {
  content: "\\f16c6";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\f16cb";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\f16cc";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\f16cd";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\f16ce";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\f16cf";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wifi-sync::before {
  content: "\\f16c7";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-windsock::before {
  content: "\\f15fa";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wizard-hat::before {
  content: "\\f1477";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xamarin-outline::before {
  content: "\\f0846";
}

.mdi-xing::before {
  content: "\\f05be";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-y-combinator::before {
  content: "\\f0624";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-yurt::before {
  content: "\\f1516";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@font-face {
  font-family: "boxicons";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
}
.bx {
  font-family: "boxicons" !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none;
}

.bx-ul > li {
  position: relative;
}

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(359deg);
  }
}
@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  90% {
    transform: scale(1.5);
    opacity: 0;
  }
}
@keyframes flashing {
  0% {
    opacity: 1;
  }
  45% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
}
@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(20px);
    opacity: 0;
  }
}
@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);
  }
  40%, 60%, 80% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.bx-spin {
  animation: spin 2s linear infinite;
}

.bx-spin-hover:hover {
  animation: spin 2s linear infinite;
}

.bx-tada {
  animation: tada 1.5s ease infinite;
}

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite;
}

.bx-flashing {
  animation: flashing 1.5s infinite linear;
}

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear;
}

.bx-burst {
  animation: burst 1.5s infinite linear;
}

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}

.bx-fade-up {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-down {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-left {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-right {
  animation: fade-right 1.5s infinite linear;
}

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear;
}

.bx-xs {
  font-size: 1rem !important;
}

.bx-sm {
  font-size: 1.55rem !important;
}

.bx-md {
  font-size: 2.25rem !important;
}

.bx-fw {
  font-size: 1.2857142857em;
  line-height: 0.8em;
  width: 1.2857142857em;
  height: 0.8em;
  margin-top: -0.2em !important;
  vertical-align: middle;
}

.bx-lg {
  font-size: 3rem !important;
}

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important;
}

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important;
}

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
}

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
}

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.bx-border {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25em;
}

.bx-border-circle {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.bxl-adobe:before {
  content: "\\e900";
}

.bxl-algolia:before {
  content: "\\e901";
}

.bxl-audible:before {
  content: "\\e902";
}

.bxl-figma:before {
  content: "\\e903";
}

.bxl-redbubble:before {
  content: "\\e904";
}

.bxl-etsy:before {
  content: "\\e905";
}

.bxl-gitlab:before {
  content: "\\e906";
}

.bxl-patreon:before {
  content: "\\e907";
}

.bxl-facebook-circle:before {
  content: "\\e908";
}

.bxl-imdb:before {
  content: "\\e909";
}

.bxl-jquery:before {
  content: "\\e90a";
}

.bxl-pinterest-alt:before {
  content: "\\e90b";
}

.bxl-500px:before {
  content: "\\e90c";
}

.bxl-airbnb:before {
  content: "\\e90d";
}

.bxl-amazon:before {
  content: "\\e90e";
}

.bxl-android:before {
  content: "\\e90f";
}

.bxl-angular:before {
  content: "\\e910";
}

.bxl-apple:before {
  content: "\\e911";
}

.bxl-baidu:before {
  content: "\\e912";
}

.bxl-behance:before {
  content: "\\e913";
}

.bxl-bing:before {
  content: "\\e914";
}

.bxl-bitcoin:before {
  content: "\\e915";
}

.bxl-blogger:before {
  content: "\\e916";
}

.bxl-bootstrap:before {
  content: "\\e917";
}

.bxl-chrome:before {
  content: "\\e918";
}

.bxl-codepen:before {
  content: "\\e919";
}

.bxl-creative-commons:before {
  content: "\\e91a";
}

.bxl-css3:before {
  content: "\\e91b";
}

.bxl-dailymotion:before {
  content: "\\e91c";
}

.bxl-deviantart:before {
  content: "\\e91d";
}

.bxl-digg:before {
  content: "\\e91e";
}

.bxl-digitalocean:before {
  content: "\\e91f";
}

.bxl-discord:before {
  content: "\\e920";
}

.bxl-discourse:before {
  content: "\\e921";
}

.bxl-dribbble:before {
  content: "\\e922";
}

.bxl-dropbox:before {
  content: "\\e923";
}

.bxl-drupal:before {
  content: "\\e924";
}

.bxl-ebay:before {
  content: "\\e925";
}

.bxl-edge:before {
  content: "\\e926";
}

.bxl-facebook:before {
  content: "\\e927";
}

.bxl-facebook-square:before {
  content: "\\e928";
}

.bxl-firefox:before {
  content: "\\e929";
}

.bxl-flickr:before {
  content: "\\e92a";
}

.bxl-flickr-square:before {
  content: "\\e92b";
}

.bxl-foursquare:before {
  content: "\\e92c";
}

.bxl-git:before {
  content: "\\e92d";
}

.bxl-github:before {
  content: "\\e92e";
}

.bxl-google:before {
  content: "\\e92f";
}

.bxl-google-plus:before {
  content: "\\e930";
}

.bxl-google-plus-circle:before {
  content: "\\e931";
}

.bxl-html5:before {
  content: "\\e932";
}

.bxl-instagram:before {
  content: "\\e933";
}

.bxl-instagram-alt:before {
  content: "\\e934";
}

.bxl-internet-explorer:before {
  content: "\\e935";
}

.bxl-invision:before {
  content: "\\e936";
}

.bxl-javascript:before {
  content: "\\e937";
}

.bxl-joomla:before {
  content: "\\e938";
}

.bxl-jsfiddle:before {
  content: "\\e939";
}

.bxl-kickstarter:before {
  content: "\\e93a";
}

.bxl-less:before {
  content: "\\e93b";
}

.bxl-linkedin:before {
  content: "\\e93c";
}

.bxl-linkedin-square:before {
  content: "\\e93d";
}

.bxl-magento:before {
  content: "\\e93e";
}

.bxl-mailchimp:before {
  content: "\\e93f";
}

.bxl-mastercard:before {
  content: "\\e940";
}

.bxl-medium:before {
  content: "\\e941";
}

.bxl-medium-old:before {
  content: "\\e942";
}

.bxl-medium-square:before {
  content: "\\e943";
}

.bxl-messenger:before {
  content: "\\e944";
}

.bxl-microsoft:before {
  content: "\\e945";
}

.bxl-nodejs:before {
  content: "\\e946";
}

.bxl-opera:before {
  content: "\\e947";
}

.bxl-paypal:before {
  content: "\\e948";
}

.bxl-periscope:before {
  content: "\\e949";
}

.bxl-pinterest:before {
  content: "\\e94a";
}

.bxl-play-store:before {
  content: "\\e94b";
}

.bxl-pocket:before {
  content: "\\e94c";
}

.bxl-product-hunt:before {
  content: "\\e94d";
}

.bxl-quora:before {
  content: "\\e94e";
}

.bxl-react:before {
  content: "\\e94f";
}

.bxl-reddit:before {
  content: "\\e950";
}

.bxl-redux:before {
  content: "\\e951";
}

.bxl-sass:before {
  content: "\\e952";
}

.bxl-shopify:before {
  content: "\\e953";
}

.bxl-skype:before {
  content: "\\e954";
}

.bxl-slack:before {
  content: "\\e955";
}

.bxl-slack-old:before {
  content: "\\e956";
}

.bxl-snapchat:before {
  content: "\\e957";
}

.bxl-soundcloud:before {
  content: "\\e958";
}

.bxl-spotify:before {
  content: "\\e959";
}

.bxl-squarespace:before {
  content: "\\e95a";
}

.bxl-stack-overflow:before {
  content: "\\e95b";
}

.bxl-stripe:before {
  content: "\\e95c";
}

.bxl-telegram:before {
  content: "\\e95d";
}

.bxl-trello:before {
  content: "\\e95e";
}

.bxl-tumblr:before {
  content: "\\e95f";
}

.bxl-twitch:before {
  content: "\\e960";
}

.bxl-twitter:before {
  content: "\\e961";
}

.bxl-unsplash:before {
  content: "\\e962";
}

.bxl-vimeo:before {
  content: "\\e963";
}

.bxl-visa:before {
  content: "\\e964";
}

.bxl-vk:before {
  content: "\\e965";
}

.bxl-vuejs:before {
  content: "\\e966";
}

.bxl-whatsapp:before {
  content: "\\e967";
}

.bxl-whatsapp-square:before {
  content: "\\e968";
}

.bxl-wikipedia:before {
  content: "\\e969";
}

.bxl-windows:before {
  content: "\\e96a";
}

.bxl-wix:before {
  content: "\\e96b";
}

.bxl-wordpress:before {
  content: "\\e96c";
}

.bxl-yahoo:before {
  content: "\\e96d";
}

.bxl-yelp:before {
  content: "\\e96e";
}

.bxl-youtube:before {
  content: "\\e96f";
}

.bx-accessibility:before {
  content: "\\e970";
}

.bx-add-to-queue:before {
  content: "\\e971";
}

.bx-adjust:before {
  content: "\\e972";
}

.bx-alarm:before {
  content: "\\e973";
}

.bx-alarm-add:before {
  content: "\\e974";
}

.bx-alarm-off:before {
  content: "\\e975";
}

.bx-album:before {
  content: "\\e976";
}

.bx-align-justify:before {
  content: "\\e977";
}

.bx-align-left:before {
  content: "\\e978";
}

.bx-align-middle:before {
  content: "\\e979";
}

.bx-align-right:before {
  content: "\\e97a";
}

.bx-analyse:before {
  content: "\\e97b";
}

.bx-anchor:before {
  content: "\\e97c";
}

.bx-angry:before {
  content: "\\e97d";
}

.bx-aperture:before {
  content: "\\e97e";
}

.bx-archive:before {
  content: "\\e97f";
}

.bx-archive-in:before {
  content: "\\e980";
}

.bx-archive-out:before {
  content: "\\e981";
}

.bx-area:before {
  content: "\\e982";
}

.bx-arrow-back:before {
  content: "\\e983";
}

.bx-at:before {
  content: "\\e984";
}

.bx-award:before {
  content: "\\e985";
}

.bx-badge:before {
  content: "\\e986";
}

.bx-badge-check:before {
  content: "\\e987";
}

.bx-ball:before {
  content: "\\e988";
}

.bx-band-aid:before {
  content: "\\e989";
}

.bx-bar-chart:before {
  content: "\\e98a";
}

.bx-bar-chart-alt:before {
  content: "\\e98b";
}

.bx-bar-chart-alt-2:before {
  content: "\\e98c";
}

.bx-bar-chart-square:before {
  content: "\\e98d";
}

.bx-barcode:before {
  content: "\\e98e";
}

.bx-basket:before {
  content: "\\e98f";
}

.bx-basketball:before {
  content: "\\e990";
}

.bx-bath:before {
  content: "\\e991";
}

.bx-battery:before {
  content: "\\e992";
}

.bx-bed:before {
  content: "\\e993";
}

.bx-bell:before {
  content: "\\e994";
}

.bx-bell-minus:before {
  content: "\\e995";
}

.bx-bell-off:before {
  content: "\\e996";
}

.bx-bell-plus:before {
  content: "\\e997";
}

.bx-bitcoin:before {
  content: "\\e998";
}

.bx-block:before {
  content: "\\e999";
}

.bx-bluetooth:before {
  content: "\\e99a";
}

.bx-body:before {
  content: "\\e99b";
}

.bx-bold:before {
  content: "\\e99c";
}

.bx-bolt-circle:before {
  content: "\\e99d";
}

.bx-book:before {
  content: "\\e99e";
}

.bx-book-bookmark:before {
  content: "\\e99f";
}

.bx-book-content:before {
  content: "\\e9a0";
}

.bx-bookmark:before {
  content: "\\e9a1";
}

.bx-bookmark-minus:before {
  content: "\\e9a2";
}

.bx-bookmark-plus:before {
  content: "\\e9a3";
}

.bx-bookmarks:before {
  content: "\\e9a4";
}

.bx-book-open:before {
  content: "\\e9a5";
}

.bx-border-all:before {
  content: "\\e9a6";
}

.bx-border-bottom:before {
  content: "\\e9a7";
}

.bx-border-left:before {
  content: "\\e9a8";
}

.bx-border-radius:before {
  content: "\\e9a9";
}

.bx-border-right:before {
  content: "\\e9aa";
}

.bx-border-top:before {
  content: "\\e9ab";
}

.bx-bot:before {
  content: "\\e9ac";
}

.bx-bowling-ball:before {
  content: "\\e9ad";
}

.bx-box:before {
  content: "\\e9ae";
}

.bx-briefcase:before {
  content: "\\e9af";
}

.bx-briefcase-alt:before {
  content: "\\e9b0";
}

.bx-briefcase-alt-2:before {
  content: "\\e9b1";
}

.bx-brightness:before {
  content: "\\e9b2";
}

.bx-brightness-half:before {
  content: "\\e9b3";
}

.bx-broadcast:before {
  content: "\\e9b4";
}

.bx-brush:before {
  content: "\\e9b5";
}

.bx-brush-alt:before {
  content: "\\e9b6";
}

.bx-bug:before {
  content: "\\e9b7";
}

.bx-bug-alt:before {
  content: "\\e9b8";
}

.bx-building:before {
  content: "\\e9b9";
}

.bx-building-house:before {
  content: "\\e9ba";
}

.bx-buildings:before {
  content: "\\e9bb";
}

.bx-bulb:before {
  content: "\\e9bc";
}

.bx-bullseye:before {
  content: "\\e9bd";
}

.bx-buoy:before {
  content: "\\e9be";
}

.bx-bus:before {
  content: "\\e9bf";
}

.bx-cake:before {
  content: "\\e9c0";
}

.bx-calculator:before {
  content: "\\e9c1";
}

.bx-calendar:before {
  content: "\\e9c2";
}

.bx-calendar-alt:before {
  content: "\\e9c3";
}

.bx-calendar-check:before {
  content: "\\e9c4";
}

.bx-calendar-event:before {
  content: "\\e9c5";
}

.bx-calendar-minus:before {
  content: "\\e9c6";
}

.bx-calendar-plus:before {
  content: "\\e9c7";
}

.bx-calendar-x:before {
  content: "\\e9c8";
}

.bx-camera:before {
  content: "\\e9c9";
}

.bx-camera-off:before {
  content: "\\e9ca";
}

.bx-captions:before {
  content: "\\e9cb";
}

.bx-car:before {
  content: "\\e9cc";
}

.bx-card:before {
  content: "\\e9cd";
}

.bx-caret-down:before {
  content: "\\e9ce";
}

.bx-caret-left:before {
  content: "\\e9cf";
}

.bx-caret-right:before {
  content: "\\e9d0";
}

.bx-caret-up:before {
  content: "\\e9d1";
}

.bx-carousel:before {
  content: "\\e9d2";
}

.bx-cart:before {
  content: "\\e9d3";
}

.bx-cart-alt:before {
  content: "\\e9d4";
}

.bx-cast:before {
  content: "\\e9d5";
}

.bx-certification:before {
  content: "\\e9d6";
}

.bx-chalkboard:before {
  content: "\\e9d7";
}

.bx-chart:before {
  content: "\\e9d8";
}

.bx-chat:before {
  content: "\\e9d9";
}

.bx-check:before {
  content: "\\e9da";
}

.bx-checkbox:before {
  content: "\\e9db";
}

.bx-checkbox-checked:before {
  content: "\\e9dc";
}

.bx-checkbox-square:before {
  content: "\\e9dd";
}

.bx-check-circle:before {
  content: "\\e9de";
}

.bx-check-double:before {
  content: "\\e9df";
}

.bx-check-shield:before {
  content: "\\e9e0";
}

.bx-check-square:before {
  content: "\\e9e1";
}

.bx-chevron-down:before {
  content: "\\e9e2";
}

.bx-chevron-left:before {
  content: "\\e9e3";
}

.bx-chevron-right:before {
  content: "\\e9e4";
}

.bx-chevrons-down:before {
  content: "\\e9e5";
}

.bx-chevrons-left:before {
  content: "\\e9e6";
}

.bx-chevrons-right:before {
  content: "\\e9e7";
}

.bx-chevrons-up:before {
  content: "\\e9e8";
}

.bx-chevron-up:before {
  content: "\\e9e9";
}

.bx-chip:before {
  content: "\\e9ea";
}

.bx-circle:before {
  content: "\\e9eb";
}

.bx-clinic:before {
  content: "\\e9ec";
}

.bx-clipboard:before {
  content: "\\e9ed";
}

.bx-closet:before {
  content: "\\e9ee";
}

.bx-cloud:before {
  content: "\\e9ef";
}

.bx-cloud-download:before {
  content: "\\e9f0";
}

.bx-cloud-drizzle:before {
  content: "\\e9f1";
}

.bx-cloud-lightning:before {
  content: "\\e9f2";
}

.bx-cloud-light-rain:before {
  content: "\\e9f3";
}

.bx-cloud-rain:before {
  content: "\\e9f4";
}

.bx-cloud-snow:before {
  content: "\\e9f5";
}

.bx-cloud-upload:before {
  content: "\\e9f6";
}

.bx-code:before {
  content: "\\e9f7";
}

.bx-code-alt:before {
  content: "\\e9f8";
}

.bx-code-block:before {
  content: "\\e9f9";
}

.bx-code-curly:before {
  content: "\\e9fa";
}

.bx-coffee:before {
  content: "\\e9fb";
}

.bx-cog:before {
  content: "\\e9fc";
}

.bx-collapse:before {
  content: "\\e9fd";
}

.bx-collection:before {
  content: "\\e9fe";
}

.bx-columns:before {
  content: "\\e9ff";
}

.bx-command:before {
  content: "\\ea00";
}

.bx-comment:before {
  content: "\\ea01";
}

.bx-comment-dots:before {
  content: "\\ea02";
}

.bx-compass:before {
  content: "\\ea03";
}

.bx-confused:before {
  content: "\\ea04";
}

.bx-conversation:before {
  content: "\\ea05";
}

.bx-cool:before {
  content: "\\ea06";
}

.bx-copy:before {
  content: "\\ea07";
}

.bx-copy-alt:before {
  content: "\\ea08";
}

.bx-copyright:before {
  content: "\\ea09";
}

.bx-credit-card:before {
  content: "\\ea0a";
}

.bx-credit-card-alt:before {
  content: "\\ea0b";
}

.bx-crop:before {
  content: "\\ea0c";
}

.bx-crosshair:before {
  content: "\\ea0d";
}

.bx-crown:before {
  content: "\\ea0e";
}

.bx-cube:before {
  content: "\\ea0f";
}

.bx-cube-alt:before {
  content: "\\ea10";
}

.bx-cuboid:before {
  content: "\\ea11";
}

.bx-customize:before {
  content: "\\ea12";
}

.bx-cut:before {
  content: "\\ea13";
}

.bx-cycling:before {
  content: "\\ea14";
}

.bx-cylinder:before {
  content: "\\ea15";
}

.bx-data:before {
  content: "\\ea16";
}

.bx-desktop:before {
  content: "\\ea17";
}

.bx-detail:before {
  content: "\\ea18";
}

.bx-devices:before {
  content: "\\ea19";
}

.bx-dialpad:before {
  content: "\\ea1a";
}

.bx-dialpad-alt:before {
  content: "\\ea1b";
}

.bx-diamond:before {
  content: "\\ea1c";
}

.bx-directions:before {
  content: "\\ea1d";
}

.bx-disc:before {
  content: "\\ea1e";
}

.bx-dish:before {
  content: "\\ea1f";
}

.bx-dislike:before {
  content: "\\ea20";
}

.bx-dizzy:before {
  content: "\\ea21";
}

.bx-dna:before {
  content: "\\ea22";
}

.bx-dock-bottom:before {
  content: "\\ea23";
}

.bx-dock-left:before {
  content: "\\ea24";
}

.bx-dock-right:before {
  content: "\\ea25";
}

.bx-dock-top:before {
  content: "\\ea26";
}

.bx-dollar:before {
  content: "\\ea27";
}

.bx-dollar-circle:before {
  content: "\\ea28";
}

.bx-dots-horizontal:before {
  content: "\\ea29";
}

.bx-dots-horizontal-rounded:before {
  content: "\\ea2a";
}

.bx-dots-vertical:before {
  content: "\\ea2b";
}

.bx-dots-vertical-rounded:before {
  content: "\\ea2c";
}

.bx-doughnut-chart:before {
  content: "\\ea2d";
}

.bx-down-arrow:before {
  content: "\\ea2e";
}

.bx-down-arrow-alt:before {
  content: "\\ea2f";
}

.bx-down-arrow-circle:before {
  content: "\\ea30";
}

.bx-download:before {
  content: "\\ea31";
}

.bx-downvote:before {
  content: "\\ea32";
}

.bx-droplet:before {
  content: "\\ea33";
}

.bx-dumbbell:before {
  content: "\\ea34";
}

.bx-duplicate:before {
  content: "\\ea35";
}

.bx-edit:before {
  content: "\\ea36";
}

.bx-edit-alt:before {
  content: "\\ea37";
}

.bx-envelope:before {
  content: "\\ea38";
}

.bx-equalizer:before {
  content: "\\ea39";
}

.bx-error:before {
  content: "\\ea3a";
}

.bx-error-alt:before {
  content: "\\ea3b";
}

.bx-error-circle:before {
  content: "\\ea3c";
}

.bx-euro:before {
  content: "\\ea3d";
}

.bx-exit:before {
  content: "\\ea3e";
}

.bx-exit-fullscreen:before {
  content: "\\ea3f";
}

.bx-expand:before {
  content: "\\ea40";
}

.bx-export:before {
  content: "\\ea41";
}

.bx-extension:before {
  content: "\\ea42";
}

.bx-face:before {
  content: "\\ea43";
}

.bx-fast-forward:before {
  content: "\\ea44";
}

.bx-fast-forward-circle:before {
  content: "\\ea45";
}

.bx-female:before {
  content: "\\ea46";
}

.bx-female-sign:before {
  content: "\\ea47";
}

.bx-file:before {
  content: "\\ea48";
}

.bx-file-blank:before {
  content: "\\ea49";
}

.bx-file-find:before {
  content: "\\ea4a";
}

.bx-film:before {
  content: "\\ea4b";
}

.bx-filter:before {
  content: "\\ea4c";
}

.bx-filter-alt:before {
  content: "\\ea4d";
}

.bx-fingerprint:before {
  content: "\\ea4e";
}

.bx-first-aid:before {
  content: "\\ea4f";
}

.bx-first-page:before {
  content: "\\ea50";
}

.bx-flag:before {
  content: "\\ea51";
}

.bx-folder:before {
  content: "\\ea52";
}

.bx-folder-minus:before {
  content: "\\ea53";
}

.bx-folder-open:before {
  content: "\\ea54";
}

.bx-folder-plus:before {
  content: "\\ea55";
}

.bx-font:before {
  content: "\\ea56";
}

.bx-font-color:before {
  content: "\\ea57";
}

.bx-font-family:before {
  content: "\\ea58";
}

.bx-font-size:before {
  content: "\\ea59";
}

.bx-food-menu:before {
  content: "\\ea5a";
}

.bx-food-tag:before {
  content: "\\ea5b";
}

.bx-football:before {
  content: "\\ea5c";
}

.bx-fridge:before {
  content: "\\ea5d";
}

.bx-fullscreen:before {
  content: "\\ea5e";
}

.bx-gas-pump:before {
  content: "\\ea5f";
}

.bx-ghost:before {
  content: "\\ea60";
}

.bx-gift:before {
  content: "\\ea61";
}

.bx-git-branch:before {
  content: "\\ea62";
}

.bx-git-commit:before {
  content: "\\ea63";
}

.bx-git-compare:before {
  content: "\\ea64";
}

.bx-git-merge:before {
  content: "\\ea65";
}

.bx-git-pull-request:before {
  content: "\\ea66";
}

.bx-git-repo-forked:before {
  content: "\\ea67";
}

.bx-globe:before {
  content: "\\ea68";
}

.bx-globe-alt:before {
  content: "\\ea69";
}

.bx-grid:before {
  content: "\\ea6a";
}

.bx-grid-alt:before {
  content: "\\ea6b";
}

.bx-grid-horizontal:before {
  content: "\\ea6c";
}

.bx-grid-small:before {
  content: "\\ea6d";
}

.bx-grid-vertical:before {
  content: "\\ea6e";
}

.bx-group:before {
  content: "\\ea6f";
}

.bx-handicap:before {
  content: "\\ea70";
}

.bx-happy:before {
  content: "\\ea71";
}

.bx-happy-alt:before {
  content: "\\ea72";
}

.bx-happy-beaming:before {
  content: "\\ea73";
}

.bx-happy-heart-eyes:before {
  content: "\\ea74";
}

.bx-hash:before {
  content: "\\ea75";
}

.bx-hdd:before {
  content: "\\ea76";
}

.bx-heading:before {
  content: "\\ea77";
}

.bx-headphone:before {
  content: "\\ea78";
}

.bx-health:before {
  content: "\\ea79";
}

.bx-heart:before {
  content: "\\ea7a";
}

.bx-help-circle:before {
  content: "\\ea7b";
}

.bx-hide:before {
  content: "\\ea7c";
}

.bx-highlight:before {
  content: "\\ea7d";
}

.bx-history:before {
  content: "\\ea7e";
}

.bx-hive:before {
  content: "\\ea7f";
}

.bx-home:before {
  content: "\\ea80";
}

.bx-home-alt:before {
  content: "\\ea81";
}

.bx-home-circle:before {
  content: "\\ea82";
}

.bx-horizontal-center:before {
  content: "\\ea83";
}

.bx-hotel:before {
  content: "\\ea84";
}

.bx-hourglass:before {
  content: "\\ea85";
}

.bx-id-card:before {
  content: "\\ea86";
}

.bx-image:before {
  content: "\\ea87";
}

.bx-image-add:before {
  content: "\\ea88";
}

.bx-image-alt:before {
  content: "\\ea89";
}

.bx-images:before {
  content: "\\ea8a";
}

.bx-import:before {
  content: "\\ea8b";
}

.bx-infinite:before {
  content: "\\ea8c";
}

.bx-info-circle:before {
  content: "\\ea8d";
}

.bx-italic:before {
  content: "\\ea8e";
}

.bx-joystick:before {
  content: "\\ea8f";
}

.bx-joystick-alt:before {
  content: "\\ea90";
}

.bx-joystick-button:before {
  content: "\\ea91";
}

.bx-key:before {
  content: "\\ea92";
}

.bx-label:before {
  content: "\\ea93";
}

.bx-landscape:before {
  content: "\\ea94";
}

.bx-laptop:before {
  content: "\\ea95";
}

.bx-last-page:before {
  content: "\\ea96";
}

.bx-laugh:before {
  content: "\\ea97";
}

.bx-layer:before {
  content: "\\ea98";
}

.bx-layout:before {
  content: "\\ea99";
}

.bx-left-arrow:before {
  content: "\\ea9a";
}

.bx-left-arrow-alt:before {
  content: "\\ea9b";
}

.bx-left-arrow-circle:before {
  content: "\\ea9c";
}

.bx-left-down-arrow-circle:before {
  content: "\\ea9d";
}

.bx-left-indent:before {
  content: "\\ea9e";
}

.bx-left-top-arrow-circle:before {
  content: "\\ea9f";
}

.bx-like:before {
  content: "\\eaa0";
}

.bx-line-chart:before {
  content: "\\eaa1";
}

.bx-link:before {
  content: "\\eaa2";
}

.bx-link-alt:before {
  content: "\\eaa3";
}

.bx-link-external:before {
  content: "\\eaa4";
}

.bx-lira:before {
  content: "\\eaa5";
}

.bx-list-check:before {
  content: "\\eaa6";
}

.bx-list-minus:before {
  content: "\\eaa7";
}

.bx-list-ol:before {
  content: "\\eaa8";
}

.bx-list-plus:before {
  content: "\\eaa9";
}

.bx-list-ul:before {
  content: "\\eaaa";
}

.bx-loader:before {
  content: "\\eaab";
}

.bx-loader-alt:before {
  content: "\\eaac";
}

.bx-loader-circle:before {
  content: "\\eaad";
}

.bx-lock:before {
  content: "\\eaae";
}

.bx-lock-alt:before {
  content: "\\eaaf";
}

.bx-lock-open:before {
  content: "\\eab0";
}

.bx-lock-open-alt:before {
  content: "\\eab1";
}

.bx-log-in:before {
  content: "\\eab2";
}

.bx-log-in-circle:before {
  content: "\\eab3";
}

.bx-log-out:before {
  content: "\\eab4";
}

.bx-log-out-circle:before {
  content: "\\eab5";
}

.bx-magnet:before {
  content: "\\eab6";
}

.bx-mail-send:before {
  content: "\\eab7";
}

.bx-male:before {
  content: "\\eab8";
}

.bx-male-sign:before {
  content: "\\eab9";
}

.bx-map:before {
  content: "\\eaba";
}

.bx-map-alt:before {
  content: "\\eabb";
}

.bx-map-pin:before {
  content: "\\eabc";
}

.bx-meh:before {
  content: "\\eabd";
}

.bx-meh-alt:before {
  content: "\\eabe";
}

.bx-meh-blank:before {
  content: "\\eabf";
}

.bx-memory-card:before {
  content: "\\eac0";
}

.bx-menu:before {
  content: "\\eac1";
}

.bx-menu-alt-left:before {
  content: "\\eac2";
}

.bx-menu-alt-right:before {
  content: "\\eac3";
}

.bx-message:before {
  content: "\\eac4";
}

.bx-message-alt:before {
  content: "\\eac5";
}

.bx-message-alt-dots:before {
  content: "\\eac6";
}

.bx-message-dots:before {
  content: "\\eac7";
}

.bx-message-rounded:before {
  content: "\\eac8";
}

.bx-message-rounded-dots:before {
  content: "\\eac9";
}

.bx-message-square:before {
  content: "\\eaca";
}

.bx-message-square-dots:before {
  content: "\\eacb";
}

.bx-microphone:before {
  content: "\\eacc";
}

.bx-microphone-off:before {
  content: "\\eacd";
}

.bx-minus:before {
  content: "\\eace";
}

.bx-minus-circle:before {
  content: "\\eacf";
}

.bx-mobile:before {
  content: "\\ead0";
}

.bx-mobile-alt:before {
  content: "\\ead1";
}

.bx-mobile-landscape:before {
  content: "\\ead2";
}

.bx-mobile-vibration:before {
  content: "\\ead3";
}

.bx-money:before {
  content: "\\ead4";
}

.bx-moon:before {
  content: "\\ead5";
}

.bx-mouse:before {
  content: "\\ead6";
}

.bx-mouse-alt:before {
  content: "\\ead7";
}

.bx-move:before {
  content: "\\ead8";
}

.bx-move-horizontal:before {
  content: "\\ead9";
}

.bx-move-vertical:before {
  content: "\\eada";
}

.bx-movie:before {
  content: "\\eadb";
}

.bx-music:before {
  content: "\\eadc";
}

.bx-navigation:before {
  content: "\\eadd";
}

.bx-news:before {
  content: "\\eade";
}

.bx-no-entry:before {
  content: "\\eadf";
}

.bx-note:before {
  content: "\\eae0";
}

.bx-notepad:before {
  content: "\\eae1";
}

.bx-notification:before {
  content: "\\eae2";
}

.bx-notification-off:before {
  content: "\\eae3";
}

.bx-package:before {
  content: "\\eae4";
}

.bx-paint:before {
  content: "\\eae5";
}

.bx-paint-roll:before {
  content: "\\eae6";
}

.bx-palette:before {
  content: "\\eae7";
}

.bx-paperclip:before {
  content: "\\eae8";
}

.bx-paper-plane:before {
  content: "\\eae9";
}

.bx-paragraph:before {
  content: "\\eaea";
}

.bx-paste:before {
  content: "\\eaeb";
}

.bx-pause:before {
  content: "\\eaec";
}

.bx-pause-circle:before {
  content: "\\eaed";
}

.bx-pen:before {
  content: "\\eaee";
}

.bx-pencil:before {
  content: "\\eaef";
}

.bx-phone:before {
  content: "\\eaf0";
}

.bx-phone-call:before {
  content: "\\eaf1";
}

.bx-phone-incoming:before {
  content: "\\eaf2";
}

.bx-phone-outgoing:before {
  content: "\\eaf3";
}

.bx-photo-album:before {
  content: "\\eaf4";
}

.bx-pie-chart:before {
  content: "\\eaf5";
}

.bx-pie-chart-alt:before {
  content: "\\eaf6";
}

.bx-pie-chart-alt-2:before {
  content: "\\eaf7";
}

.bx-pin:before {
  content: "\\eaf8";
}

.bx-planet:before {
  content: "\\eaf9";
}

.bx-play:before {
  content: "\\eafa";
}

.bx-play-circle:before {
  content: "\\eafb";
}

.bx-plug:before {
  content: "\\eafc";
}

.bx-plus:before {
  content: "\\eafd";
}

.bx-plus-circle:before {
  content: "\\eafe";
}

.bx-plus-medical:before {
  content: "\\eaff";
}

.bx-poll:before {
  content: "\\eb00";
}

.bx-polygon:before {
  content: "\\eb01";
}

.bx-pound:before {
  content: "\\eb02";
}

.bx-power-off:before {
  content: "\\eb03";
}

.bx-printer:before {
  content: "\\eb04";
}

.bx-pulse:before {
  content: "\\eb05";
}

.bx-purchase-tag:before {
  content: "\\eb06";
}

.bx-purchase-tag-alt:before {
  content: "\\eb07";
}

.bx-pyramid:before {
  content: "\\eb08";
}

.bx-question-mark:before {
  content: "\\eb09";
}

.bx-radar:before {
  content: "\\eb0a";
}

.bx-radio:before {
  content: "\\eb0b";
}

.bx-radio-circle:before {
  content: "\\eb0c";
}

.bx-radio-circle-marked:before {
  content: "\\eb0d";
}

.bx-receipt:before {
  content: "\\eb0e";
}

.bx-rectangle:before {
  content: "\\eb0f";
}

.bx-redo:before {
  content: "\\eb10";
}

.bx-rename:before {
  content: "\\eb11";
}

.bx-repeat:before {
  content: "\\eb12";
}

.bx-reply:before {
  content: "\\eb13";
}

.bx-reply-all:before {
  content: "\\eb14";
}

.bx-repost:before {
  content: "\\eb15";
}

.bx-reset:before {
  content: "\\eb16";
}

.bx-restaurant:before {
  content: "\\eb17";
}

.bx-revision:before {
  content: "\\eb18";
}

.bx-rewind:before {
  content: "\\eb19";
}

.bx-rewind-circle:before {
  content: "\\eb1a";
}

.bx-right-arrow:before {
  content: "\\eb1b";
}

.bx-right-arrow-alt:before {
  content: "\\eb1c";
}

.bx-right-arrow-circle:before {
  content: "\\eb1d";
}

.bx-right-down-arrow-circle:before {
  content: "\\eb1e";
}

.bx-right-indent:before {
  content: "\\eb1f";
}

.bx-right-top-arrow-circle:before {
  content: "\\eb20";
}

.bx-rocket:before {
  content: "\\eb21";
}

.bx-rotate-left:before {
  content: "\\eb22";
}

.bx-rotate-right:before {
  content: "\\eb23";
}

.bx-rss:before {
  content: "\\eb24";
}

.bx-ruble:before {
  content: "\\eb25";
}

.bx-ruler:before {
  content: "\\eb26";
}

.bx-run:before {
  content: "\\eb27";
}

.bx-rupee:before {
  content: "\\eb28";
}

.bx-sad:before {
  content: "\\eb29";
}

.bx-save:before {
  content: "\\eb2a";
}

.bx-screenshot:before {
  content: "\\eb2b";
}

.bx-search:before {
  content: "\\eb2c";
}

.bx-search-alt:before {
  content: "\\eb2d";
}

.bx-search-alt-2:before {
  content: "\\eb2e";
}

.bx-selection:before {
  content: "\\eb2f";
}

.bx-select-multiple:before {
  content: "\\eb30";
}

.bx-send:before {
  content: "\\eb31";
}

.bx-server:before {
  content: "\\eb32";
}

.bx-shape-circle:before {
  content: "\\eb33";
}

.bx-shape-square:before {
  content: "\\eb34";
}

.bx-shape-triangle:before {
  content: "\\eb35";
}

.bx-share:before {
  content: "\\eb36";
}

.bx-share-alt:before {
  content: "\\eb37";
}

.bx-shekel:before {
  content: "\\eb38";
}

.bx-shield:before {
  content: "\\eb39";
}

.bx-shield-alt:before {
  content: "\\eb3a";
}

.bx-shield-alt-2:before {
  content: "\\eb3b";
}

.bx-shield-quarter:before {
  content: "\\eb3c";
}

.bx-shocked:before {
  content: "\\eb3d";
}

.bx-shopping-bag:before {
  content: "\\eb3e";
}

.bx-show:before {
  content: "\\eb3f";
}

.bx-show-alt:before {
  content: "\\eb40";
}

.bx-shuffle:before {
  content: "\\eb41";
}

.bx-sidebar:before {
  content: "\\eb42";
}

.bx-sitemap:before {
  content: "\\eb43";
}

.bx-skip-next:before {
  content: "\\eb44";
}

.bx-skip-next-circle:before {
  content: "\\eb45";
}

.bx-skip-previous:before {
  content: "\\eb46";
}

.bx-skip-previous-circle:before {
  content: "\\eb47";
}

.bx-sleepy:before {
  content: "\\eb48";
}

.bx-slider:before {
  content: "\\eb49";
}

.bx-slider-alt:before {
  content: "\\eb4a";
}

.bx-slideshow:before {
  content: "\\eb4b";
}

.bx-smile:before {
  content: "\\eb4c";
}

.bx-sort:before {
  content: "\\eb4d";
}

.bx-sort-a-z:before {
  content: "\\eb4e";
}

.bx-sort-down:before {
  content: "\\eb4f";
}

.bx-sort-up:before {
  content: "\\eb50";
}

.bx-sort-z-a:before {
  content: "\\eb51";
}

.bx-spa:before {
  content: "\\eb52";
}

.bx-space-bar:before {
  content: "\\eb53";
}

.bx-spreadsheet:before {
  content: "\\eb54";
}

.bx-square:before {
  content: "\\eb55";
}

.bx-square-rounded:before {
  content: "\\eb56";
}

.bx-star:before {
  content: "\\eb57";
}

.bx-station:before {
  content: "\\eb58";
}

.bx-stats:before {
  content: "\\eb59";
}

.bx-sticker:before {
  content: "\\eb5a";
}

.bx-stop:before {
  content: "\\eb5b";
}

.bx-stop-circle:before {
  content: "\\eb5c";
}

.bx-stopwatch:before {
  content: "\\eb5d";
}

.bx-store:before {
  content: "\\eb5e";
}

.bx-store-alt:before {
  content: "\\eb5f";
}

.bx-street-view:before {
  content: "\\eb60";
}

.bx-strikethrough:before {
  content: "\\eb61";
}

.bx-subdirectory-left:before {
  content: "\\eb62";
}

.bx-subdirectory-right:before {
  content: "\\eb63";
}

.bx-sun:before {
  content: "\\eb64";
}

.bx-support:before {
  content: "\\eb65";
}

.bx-swim:before {
  content: "\\eb66";
}

.bx-sync:before {
  content: "\\eb67";
}

.bx-tab:before {
  content: "\\eb68";
}

.bx-table:before {
  content: "\\eb69";
}

.bx-tag:before {
  content: "\\eb6a";
}

.bx-target-lock:before {
  content: "\\eb6b";
}

.bx-task:before {
  content: "\\eb6c";
}

.bx-taxi:before {
  content: "\\eb6d";
}

.bx-tennis-ball:before {
  content: "\\eb6e";
}

.bx-terminal:before {
  content: "\\eb6f";
}

.bx-test-tube:before {
  content: "\\eb70";
}

.bx-text:before {
  content: "\\eb71";
}

.bx-time:before {
  content: "\\eb72";
}

.bx-time-five:before {
  content: "\\eb73";
}

.bx-timer:before {
  content: "\\eb74";
}

.bx-tired:before {
  content: "\\eb75";
}

.bx-toggle-left:before {
  content: "\\eb76";
}

.bx-toggle-right:before {
  content: "\\eb77";
}

.bx-tone:before {
  content: "\\eb78";
}

.bx-train:before {
  content: "\\eb79";
}

.bx-transfer:before {
  content: "\\eb7a";
}

.bx-transfer-alt:before {
  content: "\\eb7b";
}

.bx-trash:before {
  content: "\\eb7c";
}

.bx-trash-alt:before {
  content: "\\eb7d";
}

.bx-trending-down:before {
  content: "\\eb7e";
}

.bx-trending-up:before {
  content: "\\eb7f";
}

.bx-trophy:before {
  content: "\\eb80";
}

.bx-tv:before {
  content: "\\eb81";
}

.bx-underline:before {
  content: "\\eb82";
}

.bx-undo:before {
  content: "\\eb83";
}

.bx-unlink:before {
  content: "\\eb84";
}

.bx-up-arrow:before {
  content: "\\eb85";
}

.bx-up-arrow-alt:before {
  content: "\\eb86";
}

.bx-up-arrow-circle:before {
  content: "\\eb87";
}

.bx-upload:before {
  content: "\\eb88";
}

.bx-upside-down:before {
  content: "\\eb89";
}

.bx-upvote:before {
  content: "\\eb8a";
}

.bx-usb:before {
  content: "\\eb8b";
}

.bx-user:before {
  content: "\\eb8c";
}

.bx-user-check:before {
  content: "\\eb8d";
}

.bx-user-circle:before {
  content: "\\eb8e";
}

.bx-user-minus:before {
  content: "\\eb8f";
}

.bx-user-pin:before {
  content: "\\eb90";
}

.bx-user-plus:before {
  content: "\\eb91";
}

.bx-user-voice:before {
  content: "\\eb92";
}

.bx-user-x:before {
  content: "\\eb93";
}

.bx-vertical-center:before {
  content: "\\eb94";
}

.bx-video:before {
  content: "\\eb95";
}

.bx-video-off:before {
  content: "\\eb96";
}

.bx-video-plus:before {
  content: "\\eb97";
}

.bx-video-recording:before {
  content: "\\eb98";
}

.bx-voicemail:before {
  content: "\\eb99";
}

.bx-volume:before {
  content: "\\eb9a";
}

.bx-volume-full:before {
  content: "\\eb9b";
}

.bx-volume-low:before {
  content: "\\eb9c";
}

.bx-volume-mute:before {
  content: "\\eb9d";
}

.bx-walk:before {
  content: "\\eb9e";
}

.bx-wallet:before {
  content: "\\eb9f";
}

.bx-wallet-alt:before {
  content: "\\eba0";
}

.bx-water:before {
  content: "\\eba1";
}

.bx-wifi:before {
  content: "\\eba2";
}

.bx-wifi-off:before {
  content: "\\eba3";
}

.bx-wind:before {
  content: "\\eba4";
}

.bx-window:before {
  content: "\\eba5";
}

.bx-window-close:before {
  content: "\\eba6";
}

.bx-window-open:before {
  content: "\\eba7";
}

.bx-windows:before {
  content: "\\eba8";
}

.bx-wink-smile:before {
  content: "\\eba9";
}

.bx-wink-tongue:before {
  content: "\\ebaa";
}

.bx-won:before {
  content: "\\ebab";
}

.bx-world:before {
  content: "\\ebac";
}

.bx-wrench:before {
  content: "\\ebad";
}

.bx-x:before {
  content: "\\ebae";
}

.bx-x-circle:before {
  content: "\\ebaf";
}

.bx-yen:before {
  content: "\\ebb0";
}

.bx-zoom-in:before {
  content: "\\ebb1";
}

.bx-zoom-out:before {
  content: "\\ebb2";
}

.bxs-add-to-queue:before {
  content: "\\ebb3";
}

.bxs-adjust:before {
  content: "\\ebb4";
}

.bxs-adjust-alt:before {
  content: "\\ebb5";
}

.bxs-alarm:before {
  content: "\\ebb6";
}

.bxs-alarm-add:before {
  content: "\\ebb7";
}

.bxs-alarm-off:before {
  content: "\\ebb8";
}

.bxs-album:before {
  content: "\\ebb9";
}

.bxs-ambulance:before {
  content: "\\ebba";
}

.bxs-analyse:before {
  content: "\\ebbb";
}

.bxs-angry:before {
  content: "\\ebbc";
}

.bxs-archive:before {
  content: "\\ebbd";
}

.bxs-archive-in:before {
  content: "\\ebbe";
}

.bxs-archive-out:before {
  content: "\\ebbf";
}

.bxs-area:before {
  content: "\\ebc0";
}

.bxs-award:before {
  content: "\\ebc1";
}

.bxs-baby-carriage:before {
  content: "\\ebc2";
}

.bxs-badge:before {
  content: "\\ebc3";
}

.bxs-badge-check:before {
  content: "\\ebc4";
}

.bxs-ball:before {
  content: "\\ebc5";
}

.bxs-band-aid:before {
  content: "\\ebc6";
}

.bxs-bank:before {
  content: "\\ebc7";
}

.bxs-bar-chart-alt-2:before {
  content: "\\ebc8";
}

.bxs-bar-chart-square:before {
  content: "\\ebc9";
}

.bxs-barcode:before {
  content: "\\ebca";
}

.bxs-basket:before {
  content: "\\ebcb";
}

.bxs-bath:before {
  content: "\\ebcc";
}

.bxs-battery:before {
  content: "\\ebcd";
}

.bxs-battery-charging:before {
  content: "\\ebce";
}

.bxs-battery-full:before {
  content: "\\ebcf";
}

.bxs-battery-low:before {
  content: "\\ebd0";
}

.bxs-bed:before {
  content: "\\ebd1";
}

.bxs-bell:before {
  content: "\\ebd2";
}

.bxs-bell-minus:before {
  content: "\\ebd3";
}

.bxs-bell-off:before {
  content: "\\ebd4";
}

.bxs-bell-plus:before {
  content: "\\ebd5";
}

.bxs-bell-ring:before {
  content: "\\ebd6";
}

.bxs-bolt:before {
  content: "\\ebd7";
}

.bxs-bolt-circle:before {
  content: "\\ebd8";
}

.bxs-book:before {
  content: "\\ebd9";
}

.bxs-book-bookmark:before {
  content: "\\ebda";
}

.bxs-book-content:before {
  content: "\\ebdb";
}

.bxs-bookmark:before {
  content: "\\ebdc";
}

.bxs-bookmark-minus:before {
  content: "\\ebdd";
}

.bxs-bookmark-plus:before {
  content: "\\ebde";
}

.bxs-bookmarks:before {
  content: "\\ebdf";
}

.bxs-bookmark-star:before {
  content: "\\ebe0";
}

.bxs-book-open:before {
  content: "\\ebe1";
}

.bxs-bot:before {
  content: "\\ebe2";
}

.bxs-bowling-ball:before {
  content: "\\ebe3";
}

.bxs-box:before {
  content: "\\ebe4";
}

.bxs-briefcase:before {
  content: "\\ebe5";
}

.bxs-briefcase-alt:before {
  content: "\\ebe6";
}

.bxs-briefcase-alt-2:before {
  content: "\\ebe7";
}

.bxs-brightness:before {
  content: "\\ebe8";
}

.bxs-brightness-half:before {
  content: "\\ebe9";
}

.bxs-brush:before {
  content: "\\ebea";
}

.bxs-brush-alt:before {
  content: "\\ebeb";
}

.bxs-bug:before {
  content: "\\ebec";
}

.bxs-bug-alt:before {
  content: "\\ebed";
}

.bxs-building:before {
  content: "\\ebee";
}

.bxs-building-house:before {
  content: "\\ebef";
}

.bxs-buildings:before {
  content: "\\ebf0";
}

.bxs-bulb:before {
  content: "\\ebf1";
}

.bxs-buoy:before {
  content: "\\ebf2";
}

.bxs-bus:before {
  content: "\\ebf3";
}

.bxs-business:before {
  content: "\\ebf4";
}

.bxs-cake:before {
  content: "\\ebf5";
}

.bxs-calculator:before {
  content: "\\ebf6";
}

.bxs-calendar:before {
  content: "\\ebf7";
}

.bxs-calendar-alt:before {
  content: "\\ebf8";
}

.bxs-calendar-check:before {
  content: "\\ebf9";
}

.bxs-calendar-event:before {
  content: "\\ebfa";
}

.bxs-calendar-minus:before {
  content: "\\ebfb";
}

.bxs-calendar-plus:before {
  content: "\\ebfc";
}

.bxs-calendar-x:before {
  content: "\\ebfd";
}

.bxs-camera:before {
  content: "\\ebfe";
}

.bxs-camera-off:before {
  content: "\\ebff";
}

.bxs-camera-plus:before {
  content: "\\ec00";
}

.bxs-capsule:before {
  content: "\\ec01";
}

.bxs-captions:before {
  content: "\\ec02";
}

.bxs-car:before {
  content: "\\ec03";
}

.bxs-card:before {
  content: "\\ec04";
}

.bxs-caret-down-circle:before {
  content: "\\ec05";
}

.bxs-caret-left-circle:before {
  content: "\\ec06";
}

.bxs-caret-right-circle:before {
  content: "\\ec07";
}

.bxs-caret-up-circle:before {
  content: "\\ec08";
}

.bxs-carousel:before {
  content: "\\ec09";
}

.bxs-cart:before {
  content: "\\ec0a";
}

.bxs-cart-alt:before {
  content: "\\ec0b";
}

.bxs-certification:before {
  content: "\\ec0c";
}

.bxs-chalkboard:before {
  content: "\\ec0d";
}

.bxs-chart:before {
  content: "\\ec0e";
}

.bxs-chat:before {
  content: "\\ec0f";
}

.bxs-checkbox:before {
  content: "\\ec10";
}

.bxs-checkbox-checked:before {
  content: "\\ec11";
}

.bxs-check-circle:before {
  content: "\\ec12";
}

.bxs-check-shield:before {
  content: "\\ec13";
}

.bxs-check-square:before {
  content: "\\ec14";
}

.bxs-chip:before {
  content: "\\ec15";
}

.bxs-circle:before {
  content: "\\ec16";
}

.bxs-city:before {
  content: "\\ec17";
}

.bxs-clinic:before {
  content: "\\ec18";
}

.bxs-cloud:before {
  content: "\\ec19";
}

.bxs-cloud-download:before {
  content: "\\ec1a";
}

.bxs-cloud-lightning:before {
  content: "\\ec1b";
}

.bxs-cloud-rain:before {
  content: "\\ec1c";
}

.bxs-cloud-upload:before {
  content: "\\ec1d";
}

.bxs-coffee:before {
  content: "\\ec1e";
}

.bxs-coffee-alt:before {
  content: "\\ec1f";
}

.bxs-cog:before {
  content: "\\ec20";
}

.bxs-collection:before {
  content: "\\ec21";
}

.bxs-color-fill:before {
  content: "\\ec22";
}

.bxs-comment:before {
  content: "\\ec23";
}

.bxs-comment-add:before {
  content: "\\ec24";
}

.bxs-comment-detail:before {
  content: "\\ec25";
}

.bxs-comment-dots:before {
  content: "\\ec26";
}

.bxs-comment-error:before {
  content: "\\ec27";
}

.bxs-compass:before {
  content: "\\ec28";
}

.bxs-component:before {
  content: "\\ec29";
}

.bxs-confused:before {
  content: "\\ec2a";
}

.bxs-contact:before {
  content: "\\ec2b";
}

.bxs-conversation:before {
  content: "\\ec2c";
}

.bxs-cool:before {
  content: "\\ec2d";
}

.bxs-copy:before {
  content: "\\ec2e";
}

.bxs-copy-alt:before {
  content: "\\ec2f";
}

.bxs-coupon:before {
  content: "\\ec30";
}

.bxs-credit-card:before {
  content: "\\ec31";
}

.bxs-credit-card-alt:before {
  content: "\\ec32";
}

.bxs-crown:before {
  content: "\\ec33";
}

.bxs-cube:before {
  content: "\\ec34";
}

.bxs-cube-alt:before {
  content: "\\ec35";
}

.bxs-cuboid:before {
  content: "\\ec36";
}

.bxs-customize:before {
  content: "\\ec37";
}

.bxs-cylinder:before {
  content: "\\ec38";
}

.bxs-dashboard:before {
  content: "\\ec39";
}

.bxs-data:before {
  content: "\\ec3a";
}

.bxs-detail:before {
  content: "\\ec3b";
}

.bxs-devices:before {
  content: "\\ec3c";
}

.bxs-direction-left:before {
  content: "\\ec3d";
}

.bxs-direction-right:before {
  content: "\\ec3e";
}

.bxs-directions:before {
  content: "\\ec3f";
}

.bxs-disc:before {
  content: "\\ec40";
}

.bxs-discount:before {
  content: "\\ec41";
}

.bxs-dish:before {
  content: "\\ec42";
}

.bxs-dislike:before {
  content: "\\ec43";
}

.bxs-dizzy:before {
  content: "\\ec44";
}

.bxs-dock-bottom:before {
  content: "\\ec45";
}

.bxs-dock-left:before {
  content: "\\ec46";
}

.bxs-dock-right:before {
  content: "\\ec47";
}

.bxs-dock-top:before {
  content: "\\ec48";
}

.bxs-dollar-circle:before {
  content: "\\ec49";
}

.bxs-doughnut-chart:before {
  content: "\\ec4a";
}

.bxs-down-arrow:before {
  content: "\\ec4b";
}

.bxs-down-arrow-circle:before {
  content: "\\ec4c";
}

.bxs-down-arrow-square:before {
  content: "\\ec4d";
}

.bxs-download:before {
  content: "\\ec4e";
}

.bxs-downvote:before {
  content: "\\ec4f";
}

.bxs-drink:before {
  content: "\\ec50";
}

.bxs-droplet:before {
  content: "\\ec51";
}

.bxs-droplet-half:before {
  content: "\\ec52";
}

.bxs-duplicate:before {
  content: "\\ec53";
}

.bxs-edit:before {
  content: "\\ec54";
}

.bxs-edit-alt:before {
  content: "\\ec55";
}

.bxs-eject:before {
  content: "\\ec56";
}

.bxs-envelope:before {
  content: "\\ec57";
}

.bxs-eraser:before {
  content: "\\ec58";
}

.bxs-error:before {
  content: "\\ec59";
}

.bxs-error-alt:before {
  content: "\\ec5a";
}

.bxs-error-circle:before {
  content: "\\ec5b";
}

.bxs-exit:before {
  content: "\\ec5c";
}

.bxs-extension:before {
  content: "\\ec5d";
}

.bxs-eyedropper:before {
  content: "\\ec5e";
}

.bxs-face:before {
  content: "\\ec5f";
}

.bxs-factory:before {
  content: "\\ec60";
}

.bxs-fast-forward-circle:before {
  content: "\\ec61";
}

.bxs-file:before {
  content: "\\ec62";
}

.bxs-file-blank:before {
  content: "\\ec63";
}

.bxs-file-css:before {
  content: "\\ec64";
}

.bxs-file-doc:before {
  content: "\\ec65";
}

.bxs-file-find:before {
  content: "\\ec66";
}

.bxs-file-gif:before {
  content: "\\ec67";
}

.bxs-file-html:before {
  content: "\\ec68";
}

.bxs-file-image:before {
  content: "\\ec69";
}

.bxs-file-jpg:before {
  content: "\\ec6a";
}

.bxs-file-js:before {
  content: "\\ec6b";
}

.bxs-file-json:before {
  content: "\\ec6c";
}

.bxs-file-md:before {
  content: "\\ec6d";
}

.bxs-file-pdf:before {
  content: "\\ec6e";
}

.bxs-file-plus:before {
  content: "\\ec6f";
}

.bxs-file-png:before {
  content: "\\ec70";
}

.bxs-file-txt:before {
  content: "\\ec71";
}

.bxs-film:before {
  content: "\\ec72";
}

.bxs-filter-alt:before {
  content: "\\ec73";
}

.bxs-first-aid:before {
  content: "\\ec74";
}

.bxs-flag:before {
  content: "\\ec75";
}

.bxs-flag-alt:before {
  content: "\\ec76";
}

.bxs-flame:before {
  content: "\\ec77";
}

.bxs-flask:before {
  content: "\\ec78";
}

.bxs-folder:before {
  content: "\\ec79";
}

.bxs-folder-minus:before {
  content: "\\ec7a";
}

.bxs-folder-open:before {
  content: "\\ec7b";
}

.bxs-folder-plus:before {
  content: "\\ec7c";
}

.bxs-food-menu:before {
  content: "\\ec7d";
}

.bxs-fridge:before {
  content: "\\ec7e";
}

.bxs-gas-pump:before {
  content: "\\ec7f";
}

.bxs-ghost:before {
  content: "\\ec80";
}

.bxs-gift:before {
  content: "\\ec81";
}

.bxs-graduation:before {
  content: "\\ec82";
}

.bxs-grid:before {
  content: "\\ec83";
}

.bxs-grid-alt:before {
  content: "\\ec84";
}

.bxs-group:before {
  content: "\\ec85";
}

.bxs-hand-down:before {
  content: "\\ec86";
}

.bxs-hand-left:before {
  content: "\\ec87";
}

.bxs-hand-right:before {
  content: "\\ec88";
}

.bxs-hand-up:before {
  content: "\\ec89";
}

.bxs-happy:before {
  content: "\\ec8a";
}

.bxs-happy-alt:before {
  content: "\\ec8b";
}

.bxs-happy-beaming:before {
  content: "\\ec8c";
}

.bxs-happy-heart-eyes:before {
  content: "\\ec8d";
}

.bxs-hdd:before {
  content: "\\ec8e";
}

.bxs-heart:before {
  content: "\\ec8f";
}

.bxs-help-circle:before {
  content: "\\ec90";
}

.bxs-hide:before {
  content: "\\ec91";
}

.bxs-home:before {
  content: "\\ec92";
}

.bxs-home-circle:before {
  content: "\\ec93";
}

.bxs-hot:before {
  content: "\\ec94";
}

.bxs-hotel:before {
  content: "\\ec95";
}

.bxs-hourglass:before {
  content: "\\ec96";
}

.bxs-hourglass-bottom:before {
  content: "\\ec97";
}

.bxs-hourglass-top:before {
  content: "\\ec98";
}

.bxs-id-card:before {
  content: "\\ec99";
}

.bxs-image:before {
  content: "\\ec9a";
}

.bxs-image-add:before {
  content: "\\ec9b";
}

.bxs-image-alt:before {
  content: "\\ec9c";
}

.bxs-inbox:before {
  content: "\\ec9d";
}

.bxs-info-circle:before {
  content: "\\ec9e";
}

.bxs-institution:before {
  content: "\\ec9f";
}

.bxs-joystick:before {
  content: "\\eca0";
}

.bxs-joystick-alt:before {
  content: "\\eca1";
}

.bxs-joystick-button:before {
  content: "\\eca2";
}

.bxs-key:before {
  content: "\\eca3";
}

.bxs-keyboard:before {
  content: "\\eca4";
}

.bxs-label:before {
  content: "\\eca5";
}

.bxs-landmark:before {
  content: "\\eca6";
}

.bxs-landscape:before {
  content: "\\eca7";
}

.bxs-laugh:before {
  content: "\\eca8";
}

.bxs-layer:before {
  content: "\\eca9";
}

.bxs-layout:before {
  content: "\\ecaa";
}

.bxs-left-arrow:before {
  content: "\\ecab";
}

.bxs-left-arrow-circle:before {
  content: "\\ecac";
}

.bxs-left-arrow-square:before {
  content: "\\ecad";
}

.bxs-left-down-arrow-circle:before {
  content: "\\ecae";
}

.bxs-left-top-arrow-circle:before {
  content: "\\ecaf";
}

.bxs-like:before {
  content: "\\ecb0";
}

.bxs-lock:before {
  content: "\\ecb1";
}

.bxs-lock-alt:before {
  content: "\\ecb2";
}

.bxs-lock-open:before {
  content: "\\ecb3";
}

.bxs-lock-open-alt:before {
  content: "\\ecb4";
}

.bxs-log-in:before {
  content: "\\ecb5";
}

.bxs-log-in-circle:before {
  content: "\\ecb6";
}

.bxs-log-out:before {
  content: "\\ecb7";
}

.bxs-log-out-circle:before {
  content: "\\ecb8";
}

.bxs-magic-wand:before {
  content: "\\ecb9";
}

.bxs-magnet:before {
  content: "\\ecba";
}

.bxs-map:before {
  content: "\\ecbb";
}

.bxs-map-alt:before {
  content: "\\ecbc";
}

.bxs-map-pin:before {
  content: "\\ecbd";
}

.bxs-megaphone:before {
  content: "\\ecbe";
}

.bxs-meh:before {
  content: "\\ecbf";
}

.bxs-meh-alt:before {
  content: "\\ecc0";
}

.bxs-meh-blank:before {
  content: "\\ecc1";
}

.bxs-memory-card:before {
  content: "\\ecc2";
}

.bxs-message:before {
  content: "\\ecc3";
}

.bxs-message-alt:before {
  content: "\\ecc4";
}

.bxs-message-alt-dots:before {
  content: "\\ecc5";
}

.bxs-message-dots:before {
  content: "\\ecc6";
}

.bxs-message-rounded:before {
  content: "\\ecc7";
}

.bxs-message-rounded-dots:before {
  content: "\\ecc8";
}

.bxs-message-square:before {
  content: "\\ecc9";
}

.bxs-message-square-dots:before {
  content: "\\ecca";
}

.bxs-microphone:before {
  content: "\\eccb";
}

.bxs-microphone-alt:before {
  content: "\\eccc";
}

.bxs-microphone-off:before {
  content: "\\eccd";
}

.bxs-minus-circle:before {
  content: "\\ecce";
}

.bxs-minus-square:before {
  content: "\\eccf";
}

.bxs-mobile:before {
  content: "\\ecd0";
}

.bxs-mobile-vibration:before {
  content: "\\ecd1";
}

.bxs-moon:before {
  content: "\\ecd2";
}

.bxs-mouse:before {
  content: "\\ecd3";
}

.bxs-mouse-alt:before {
  content: "\\ecd4";
}

.bxs-movie:before {
  content: "\\ecd5";
}

.bxs-music:before {
  content: "\\ecd6";
}

.bxs-navigation:before {
  content: "\\ecd7";
}

.bxs-news:before {
  content: "\\ecd8";
}

.bxs-no-entry:before {
  content: "\\ecd9";
}

.bxs-note:before {
  content: "\\ecda";
}

.bxs-notepad:before {
  content: "\\ecdb";
}

.bxs-notification:before {
  content: "\\ecdc";
}

.bxs-notification-off:before {
  content: "\\ecdd";
}

.bxs-offer:before {
  content: "\\ecde";
}

.bxs-package:before {
  content: "\\ecdf";
}

.bxs-paint:before {
  content: "\\ece0";
}

.bxs-paint-roll:before {
  content: "\\ece1";
}

.bxs-palette:before {
  content: "\\ece2";
}

.bxs-paper-plane:before {
  content: "\\ece3";
}

.bxs-parking:before {
  content: "\\ece4";
}

.bxs-paste:before {
  content: "\\ece5";
}

.bxs-pen:before {
  content: "\\ece6";
}

.bxs-pencil:before {
  content: "\\ece7";
}

.bxs-phone:before {
  content: "\\ece8";
}

.bxs-phone-call:before {
  content: "\\ece9";
}

.bxs-phone-incoming:before {
  content: "\\ecea";
}

.bxs-phone-outgoing:before {
  content: "\\eceb";
}

.bxs-photo-album:before {
  content: "\\ecec";
}

.bxs-pie-chart:before {
  content: "\\eced";
}

.bxs-pie-chart-alt:before {
  content: "\\ecee";
}

.bxs-pie-chart-alt-2:before {
  content: "\\ecef";
}

.bxs-pin:before {
  content: "\\ecf0";
}

.bxs-plane:before {
  content: "\\ecf1";
}

.bxs-plane-alt:before {
  content: "\\ecf2";
}

.bxs-plane-land:before {
  content: "\\ecf3";
}

.bxs-planet:before {
  content: "\\ecf4";
}

.bxs-plane-take-off:before {
  content: "\\ecf5";
}

.bxs-playlist:before {
  content: "\\ecf6";
}

.bxs-plug:before {
  content: "\\ecf7";
}

.bxs-plus-circle:before {
  content: "\\ecf8";
}

.bxs-plus-square:before {
  content: "\\ecf9";
}

.bxs-polygon:before {
  content: "\\ecfa";
}

.bxs-printer:before {
  content: "\\ecfb";
}

.bxs-purchase-tag:before {
  content: "\\ecfc";
}

.bxs-purchase-tag-alt:before {
  content: "\\ecfd";
}

.bxs-pyramid:before {
  content: "\\ecfe";
}

.bxs-quote-alt-left:before {
  content: "\\ecff";
}

.bxs-quote-alt-right:before {
  content: "\\ed00";
}

.bxs-quote-left:before {
  content: "\\ed01";
}

.bxs-quote-right:before {
  content: "\\ed02";
}

.bxs-quote-single-left:before {
  content: "\\ed03";
}

.bxs-quote-single-right:before {
  content: "\\ed04";
}

.bxs-radio:before {
  content: "\\ed05";
}

.bxs-receipt:before {
  content: "\\ed06";
}

.bxs-rectangle:before {
  content: "\\ed07";
}

.bxs-rename:before {
  content: "\\ed08";
}

.bxs-report:before {
  content: "\\ed09";
}

.bxs-rewind-circle:before {
  content: "\\ed0a";
}

.bxs-right-arrow:before {
  content: "\\ed0b";
}

.bxs-right-arrow-circle:before {
  content: "\\ed0c";
}

.bxs-right-arrow-square:before {
  content: "\\ed0d";
}

.bxs-right-down-arrow-circle:before {
  content: "\\ed0e";
}

.bxs-right-top-arrow-circle:before {
  content: "\\ed0f";
}

.bxs-rocket:before {
  content: "\\ed10";
}

.bxs-ruler:before {
  content: "\\ed11";
}

.bxs-sad:before {
  content: "\\ed12";
}

.bxs-save:before {
  content: "\\ed13";
}

.bxs-school:before {
  content: "\\ed14";
}

.bxs-search:before {
  content: "\\ed15";
}

.bxs-search-alt-2:before {
  content: "\\ed16";
}

.bxs-select-multiple:before {
  content: "\\ed17";
}

.bxs-send:before {
  content: "\\ed18";
}

.bxs-server:before {
  content: "\\ed19";
}

.bxs-share:before {
  content: "\\ed1a";
}

.bxs-share-alt:before {
  content: "\\ed1b";
}

.bxs-shield:before {
  content: "\\ed1c";
}

.bxs-shield-alt-2:before {
  content: "\\ed1d";
}

.bxs-ship:before {
  content: "\\ed1e";
}

.bxs-shocked:before {
  content: "\\ed1f";
}

.bxs-shopping-bag:before {
  content: "\\ed20";
}

.bxs-shopping-bag-alt:before {
  content: "\\ed21";
}

.bxs-show:before {
  content: "\\ed22";
}

.bxs-skip-next-circle:before {
  content: "\\ed23";
}

.bxs-skip-previous-circle:before {
  content: "\\ed24";
}

.bxs-skull:before {
  content: "\\ed25";
}

.bxs-sleepy:before {
  content: "\\ed26";
}

.bxs-slideshow:before {
  content: "\\ed27";
}

.bxs-smile:before {
  content: "\\ed28";
}

.bxs-sort-alt:before {
  content: "\\ed29";
}

.bxs-spa:before {
  content: "\\ed2a";
}

.bxs-spreadsheet:before {
  content: "\\ed2b";
}

.bxs-square:before {
  content: "\\ed2c";
}

.bxs-square-rounded:before {
  content: "\\ed2d";
}

.bxs-star:before {
  content: "\\ed2e";
}

.bxs-star-half:before {
  content: "\\ed2f";
}

.bxs-stopwatch:before {
  content: "\\ed30";
}

.bxs-store:before {
  content: "\\ed31";
}

.bxs-store-alt:before {
  content: "\\ed32";
}

.bxs-sun:before {
  content: "\\ed33";
}

.bxs-tag:before {
  content: "\\ed34";
}

.bxs-tag-x:before {
  content: "\\ed35";
}

.bxs-taxi:before {
  content: "\\ed36";
}

.bxs-tennis-ball:before {
  content: "\\ed37";
}

.bxs-terminal:before {
  content: "\\ed38";
}

.bxs-time:before {
  content: "\\ed39";
}

.bxs-time-five:before {
  content: "\\ed3a";
}

.bxs-timer:before {
  content: "\\ed3b";
}

.bxs-tired:before {
  content: "\\ed3c";
}

.bxs-toggle-left:before {
  content: "\\ed3d";
}

.bxs-toggle-right:before {
  content: "\\ed3e";
}

.bxs-tone:before {
  content: "\\ed3f";
}

.bxs-torch:before {
  content: "\\ed40";
}

.bxs-to-top:before {
  content: "\\ed41";
}

.bxs-traffic:before {
  content: "\\ed42";
}

.bxs-traffic-barrier:before {
  content: "\\ed43";
}

.bxs-train:before {
  content: "\\ed44";
}

.bxs-trash:before {
  content: "\\ed45";
}

.bxs-trash-alt:before {
  content: "\\ed46";
}

.bxs-tree:before {
  content: "\\ed47";
}

.bxs-trophy:before {
  content: "\\ed48";
}

.bxs-truck:before {
  content: "\\ed49";
}

.bxs-t-shirt:before {
  content: "\\ed4a";
}

.bxs-up-arrow:before {
  content: "\\ed4b";
}

.bxs-up-arrow-circle:before {
  content: "\\ed4c";
}

.bxs-up-arrow-square:before {
  content: "\\ed4d";
}

.bxs-upside-down:before {
  content: "\\ed4e";
}

.bxs-upvote:before {
  content: "\\ed4f";
}

.bxs-user:before {
  content: "\\ed50";
}

.bxs-user-badge:before {
  content: "\\ed51";
}

.bxs-user-check:before {
  content: "\\ed52";
}

.bxs-user-circle:before {
  content: "\\ed53";
}

.bxs-user-detail:before {
  content: "\\ed54";
}

.bxs-user-minus:before {
  content: "\\ed55";
}

.bxs-user-pin:before {
  content: "\\ed56";
}

.bxs-user-plus:before {
  content: "\\ed57";
}

.bxs-user-rectangle:before {
  content: "\\ed58";
}

.bxs-user-voice:before {
  content: "\\ed59";
}

.bxs-user-x:before {
  content: "\\ed5a";
}

.bxs-vial:before {
  content: "\\ed5b";
}

.bxs-video:before {
  content: "\\ed5c";
}

.bxs-video-off:before {
  content: "\\ed5d";
}

.bxs-video-plus:before {
  content: "\\ed5e";
}

.bxs-video-recording:before {
  content: "\\ed5f";
}

.bxs-videos:before {
  content: "\\ed60";
}

.bxs-volume:before {
  content: "\\ed61";
}

.bxs-volume-full:before {
  content: "\\ed62";
}

.bxs-volume-low:before {
  content: "\\ed63";
}

.bxs-volume-mute:before {
  content: "\\ed64";
}

.bxs-wallet:before {
  content: "\\ed65";
}

.bxs-wallet-alt:before {
  content: "\\ed66";
}

.bxs-watch:before {
  content: "\\ed67";
}

.bxs-watch-alt:before {
  content: "\\ed68";
}

.bxs-widget:before {
  content: "\\ed69";
}

.bxs-wine:before {
  content: "\\ed6a";
}

.bxs-wink-smile:before {
  content: "\\ed6b";
}

.bxs-wink-tongue:before {
  content: "\\ed6c";
}

.bxs-wrench:before {
  content: "\\ed6d";
}

.bxs-x-circle:before {
  content: "\\ed6e";
}

.bxs-x-square:before {
  content: "\\ed6f";
}

.bxs-yin-yang:before {
  content: "\\ed70";
}

.bxs-zap:before {
  content: "\\ed71";
}

.bxs-zoom-in:before {
  content: "\\ed72";
}

.bxs-zoom-out:before {
  content: "\\ed73";
}

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
.fa,
.fas,
.far,
.fal,
.fad,
.fab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-ad:before {
  content: "\\f641";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-card:before {
  content: "\\f2bb";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adobe:before {
  content: "\\f778";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-air-freshener:before {
  content: "\\f5d0";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-allergies:before {
  content: "\\f461";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angry:before {
  content: "\\f556";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-ankh:before {
  content: "\\f644";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-alt:before {
  content: "\\f5d1";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-archway:before {
  content: "\\f557";
}

.fa-arrow-alt-circle-down:before {
  content: "\\f358";
}

.fa-arrow-alt-circle-left:before {
  content: "\\f359";
}

.fa-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-arrows-alt-h:before {
  content: "\\f337";
}

.fa-arrows-alt-v:before {
  content: "\\f338";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-atlas:before {
  content: "\\f558";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-atom:before {
  content: "\\f5d2";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-award:before {
  content: "\\f559";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-baby:before {
  content: "\\f77c";
}

.fa-baby-carriage:before {
  content: "\\f77d";
}

.fa-backspace:before {
  content: "\\f55a";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-bacon:before {
  content: "\\f7e5";
}

.fa-bahai:before {
  content: "\\f666";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-balance-scale-left:before {
  content: "\\f515";
}

.fa-balance-scale-right:before {
  content: "\\f516";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-band-aid:before {
  content: "\\f462";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-bars:before {
  content: "\\f0c9";
}

.fa-baseball-ball:before {
  content: "\\f433";
}

.fa-basketball-ball:before {
  content: "\\f434";
}

.fa-bath:before {
  content: "\\f2cd";
}

.fa-battery-empty:before {
  content: "\\f244";
}

.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-bed:before {
  content: "\\f236";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bezier-curve:before {
  content: "\\f55b";
}

.fa-bible:before {
  content: "\\f647";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-biking:before {
  content: "\\f84a";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-biohazard:before {
  content: "\\f780";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blender:before {
  content: "\\f517";
}

.fa-blender-phone:before {
  content: "\\f6b6";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-blog:before {
  content: "\\f781";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-bolt:before {
  content: "\\f0e7";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-bone:before {
  content: "\\f5d7";
}

.fa-bong:before {
  content: "\\f55c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-book-dead:before {
  content: "\\f6b7";
}

.fa-book-medical:before {
  content: "\\f7e6";
}

.fa-book-open:before {
  content: "\\f518";
}

.fa-book-reader:before {
  content: "\\f5da";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-border-all:before {
  content: "\\f84c";
}

.fa-border-none:before {
  content: "\\f850";
}

.fa-border-style:before {
  content: "\\f853";
}

.fa-bowling-ball:before {
  content: "\\f436";
}

.fa-box:before {
  content: "\\f466";
}

.fa-box-open:before {
  content: "\\f49e";
}

.fa-box-tissue:before {
  content: "拏";
}

.fa-boxes:before {
  content: "\\f468";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-brain:before {
  content: "\\f5dc";
}

.fa-bread-slice:before {
  content: "\\f7ec";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-briefcase-medical:before {
  content: "\\f469";
}

.fa-broadcast-tower:before {
  content: "\\f519";
}

.fa-broom:before {
  content: "\\f51a";
}

.fa-brush:before {
  content: "\\f55d";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-burn:before {
  content: "\\f46a";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-bus-alt:before {
  content: "\\f55e";
}

.fa-business-time:before {
  content: "\\f64a";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-calendar:before {
  content: "\\f133";
}

.fa-calendar-alt:before {
  content: "\\f073";
}

.fa-calendar-check:before {
  content: "\\f274";
}

.fa-calendar-day:before {
  content: "\\f783";
}

.fa-calendar-minus:before {
  content: "\\f272";
}

.fa-calendar-plus:before {
  content: "\\f271";
}

.fa-calendar-times:before {
  content: "\\f273";
}

.fa-calendar-week:before {
  content: "\\f784";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-campground:before {
  content: "\\f6bb";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-candy-cane:before {
  content: "\\f786";
}

.fa-cannabis:before {
  content: "\\f55f";
}

.fa-capsules:before {
  content: "\\f46b";
}

.fa-car:before {
  content: "\\f1b9";
}

.fa-car-alt:before {
  content: "\\f5de";
}

.fa-car-battery:before {
  content: "\\f5df";
}

.fa-car-crash:before {
  content: "\\f5e1";
}

.fa-car-side:before {
  content: "\\f5e4";
}

.fa-caravan:before {
  content: "\\f8ff";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-caret-square-down:before {
  content: "\\f150";
}

.fa-caret-square-left:before {
  content: "\\f191";
}

.fa-caret-square-right:before {
  content: "\\f152";
}

.fa-caret-square-up:before {
  content: "\\f151";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-carrot:before {
  content: "\\f787";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cash-register:before {
  content: "\\f788";
}

.fa-cat:before {
  content: "\\f6be";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-chair:before {
  content: "\\f6c0";
}

.fa-chalkboard:before {
  content: "\\f51b";
}

.fa-chalkboard-teacher:before {
  content: "\\f51c";
}

.fa-charging-station:before {
  content: "\\f5e7";
}

.fa-chart-area:before {
  content: "\\f1fe";
}

.fa-chart-bar:before {
  content: "\\f080";
}

.fa-chart-line:before {
  content: "\\f201";
}

.fa-chart-pie:before {
  content: "\\f200";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-check-double:before {
  content: "\\f560";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-cheese:before {
  content: "\\f7ef";
}

.fa-chess:before {
  content: "\\f439";
}

.fa-chess-bishop:before {
  content: "\\f43a";
}

.fa-chess-board:before {
  content: "\\f43c";
}

.fa-chess-king:before {
  content: "\\f43f";
}

.fa-chess-knight:before {
  content: "\\f441";
}

.fa-chess-pawn:before {
  content: "\\f443";
}

.fa-chess-queen:before {
  content: "\\f445";
}

.fa-chess-rook:before {
  content: "\\f447";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-church:before {
  content: "\\f51d";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-circle-notch:before {
  content: "\\f1ce";
}

.fa-city:before {
  content: "\\f64f";
}

.fa-clinic-medical:before {
  content: "\\f7f2";
}

.fa-clipboard:before {
  content: "\\f328";
}

.fa-clipboard-check:before {
  content: "\\f46c";
}

.fa-clipboard-list:before {
  content: "\\f46d";
}

.fa-clock:before {
  content: "\\f017";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-closed-captioning:before {
  content: "\\f20a";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-cloud-download-alt:before {
  content: "\\f381";
}

.fa-cloud-meatball:before {
  content: "\\f73b";
}

.fa-cloud-moon:before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain:before {
  content: "\\f73c";
}

.fa-cloud-rain:before {
  content: "\\f73d";
}

.fa-cloud-showers-heavy:before {
  content: "\\f740";
}

.fa-cloud-sun:before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain:before {
  content: "\\f743";
}

.fa-cloud-upload-alt:before {
  content: "\\f382";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cocktail:before {
  content: "\\f561";
}

.fa-code:before {
  content: "\\f121";
}

.fa-code-branch:before {
  content: "\\f126";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cog:before {
  content: "\\f013";
}

.fa-cogs:before {
  content: "\\f085";
}

.fa-coins:before {
  content: "\\f51e";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-comment-alt:before {
  content: "\\f27a";
}

.fa-comment-dollar:before {
  content: "\\f651";
}

.fa-comment-dots:before {
  content: "\\f4ad";
}

.fa-comment-medical:before {
  content: "\\f7f5";
}

.fa-comment-slash:before {
  content: "\\f4b3";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-comments-dollar:before {
  content: "\\f653";
}

.fa-compact-disc:before {
  content: "\\f51f";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-compress-alt:before {
  content: "\\f422";
}

.fa-compress-arrows-alt:before {
  content: "\\f78c";
}

.fa-concierge-bell:before {
  content: "\\f562";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cookie:before {
  content: "\\f563";
}

.fa-cookie-bite:before {
  content: "\\f564";
}

.fa-copy:before {
  content: "\\f0c5";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-couch:before {
  content: "\\f4b8";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-crop-alt:before {
  content: "\\f565";
}

.fa-cross:before {
  content: "\\f654";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-crow:before {
  content: "\\f520";
}

.fa-crown:before {
  content: "\\f521";
}

.fa-crutch:before {
  content: "\\f7f7";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-cut:before {
  content: "\\f0c4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dailymotion:before {
  content: "勒";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-deaf:before {
  content: "\\f2a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-democrat:before {
  content: "\\f747";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dharmachakra:before {
  content: "\\f655";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diagnoses:before {
  content: "\\f470";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-dice:before {
  content: "\\f522";
}

.fa-dice-d20:before {
  content: "\\f6cf";
}

.fa-dice-d6:before {
  content: "\\f6d1";
}

.fa-dice-five:before {
  content: "\\f523";
}

.fa-dice-four:before {
  content: "\\f524";
}

.fa-dice-one:before {
  content: "\\f525";
}

.fa-dice-six:before {
  content: "\\f526";
}

.fa-dice-three:before {
  content: "\\f527";
}

.fa-dice-two:before {
  content: "\\f528";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-digital-tachograph:before {
  content: "\\f566";
}

.fa-directions:before {
  content: "\\f5eb";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-disease:before {
  content: "\\f7fa";
}

.fa-divide:before {
  content: "\\f529";
}

.fa-dizzy:before {
  content: "\\f567";
}

.fa-dna:before {
  content: "\\f471";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-dog:before {
  content: "\\f6d3";
}

.fa-dollar-sign:before {
  content: "\\f155";
}

.fa-dolly:before {
  content: "\\f472";
}

.fa-dolly-flatbed:before {
  content: "\\f474";
}

.fa-donate:before {
  content: "\\f4b9";
}

.fa-door-closed:before {
  content: "\\f52a";
}

.fa-door-open:before {
  content: "\\f52b";
}

.fa-dot-circle:before {
  content: "\\f192";
}

.fa-dove:before {
  content: "\\f4ba";
}

.fa-download:before {
  content: "\\f019";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-drafting-compass:before {
  content: "\\f568";
}

.fa-dragon:before {
  content: "\\f6d5";
}

.fa-draw-polygon:before {
  content: "\\f5ee";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drum:before {
  content: "\\f569";
}

.fa-drum-steelpan:before {
  content: "\\f56a";
}

.fa-drumstick-bite:before {
  content: "\\f6d7";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dumbbell:before {
  content: "\\f44b";
}

.fa-dumpster:before {
  content: "\\f793";
}

.fa-dumpster-fire:before {
  content: "\\f794";
}

.fa-dungeon:before {
  content: "\\f6d9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edit:before {
  content: "\\f044";
}

.fa-egg:before {
  content: "\\f7fb";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-text:before {
  content: "\\f658";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-equals:before {
  content: "\\f52c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-ethernet:before {
  content: "\\f796";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-euro-sign:before {
  content: "\\f153";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-exchange-alt:before {
  content: "\\f362";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-expand-alt:before {
  content: "\\f424";
}

.fa-expand-arrows-alt:before {
  content: "\\f31e";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-external-link-alt:before {
  content: "\\f35d";
}

.fa-external-link-square-alt:before {
  content: "\\f360";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-dropper:before {
  content: "\\f1fb";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fan:before {
  content: "\\f863";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-faucet:before {
  content: "串";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-feather:before {
  content: "\\f52d";
}

.fa-feather-alt:before {
  content: "\\f56b";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-female:before {
  content: "\\f182";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-alt:before {
  content: "\\f15c";
}

.fa-file-archive:before {
  content: "\\f1c6";
}

.fa-file-audio:before {
  content: "\\f1c7";
}

.fa-file-code:before {
  content: "\\f1c9";
}

.fa-file-contract:before {
  content: "\\f56c";
}

.fa-file-csv:before {
  content: "\\f6dd";
}

.fa-file-download:before {
  content: "\\f56d";
}

.fa-file-excel:before {
  content: "\\f1c3";
}

.fa-file-export:before {
  content: "\\f56e";
}

.fa-file-image:before {
  content: "\\f1c5";
}

.fa-file-import:before {
  content: "\\f56f";
}

.fa-file-invoice:before {
  content: "\\f570";
}

.fa-file-invoice-dollar:before {
  content: "\\f571";
}

.fa-file-medical:before {
  content: "\\f477";
}

.fa-file-medical-alt:before {
  content: "\\f478";
}

.fa-file-pdf:before {
  content: "\\f1c1";
}

.fa-file-powerpoint:before {
  content: "\\f1c4";
}

.fa-file-prescription:before {
  content: "\\f572";
}

.fa-file-signature:before {
  content: "\\f573";
}

.fa-file-upload:before {
  content: "\\f574";
}

.fa-file-video:before {
  content: "\\f1c8";
}

.fa-file-word:before {
  content: "\\f1c2";
}

.fa-fill:before {
  content: "\\f575";
}

.fa-fill-drip:before {
  content: "\\f576";
}

.fa-film:before {
  content: "\\f008";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-fingerprint:before {
  content: "\\f577";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-fire-alt:before {
  content: "\\f7e4";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-firefox-browser:before {
  content: "龜";
}

.fa-first-aid:before {
  content: "\\f479";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-fish:before {
  content: "\\f578";
}

.fa-fist-raised:before {
  content: "\\f6de";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-flag-usa:before {
  content: "\\f74d";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-flushed:before {
  content: "\\f579";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-minus:before {
  content: "\\f65d";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-folder-plus:before {
  content: "\\f65e";
}

.fa-font:before {
  content: "\\f031";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-font-awesome-flag:before {
  content: "\\f425";
}

.fa-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-football-ball:before {
  content: "\\f44e";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-frog:before {
  content: "\\f52e";
}

.fa-frown:before {
  content: "\\f119";
}

.fa-frown-open:before {
  content: "\\f57a";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-funnel-dollar:before {
  content: "\\f662";
}

.fa-futbol:before {
  content: "\\f1e3";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-gas-pump:before {
  content: "\\f52f";
}

.fa-gavel:before {
  content: "\\f0e3";
}

.fa-gem:before {
  content: "\\f3a5";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-ghost:before {
  content: "\\f6e2";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-gifts:before {
  content: "\\f79c";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glass-cheers:before {
  content: "\\f79f";
}

.fa-glass-martini:before {
  content: "\\f000";
}

.fa-glass-martini-alt:before {
  content: "\\f57b";
}

.fa-glass-whiskey:before {
  content: "\\f7a0";
}

.fa-glasses:before {
  content: "\\f530";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-globe-africa:before {
  content: "\\f57c";
}

.fa-globe-americas:before {
  content: "\\f57d";
}

.fa-globe-asia:before {
  content: "\\f57e";
}

.fa-globe-europe:before {
  content: "\\f7a2";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golf-ball:before {
  content: "\\f450";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gopuram:before {
  content: "\\f664";
}

.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-greater-than:before {
  content: "\\f531";
}

.fa-greater-than-equal:before {
  content: "\\f532";
}

.fa-grimace:before {
  content: "\\f57f";
}

.fa-grin:before {
  content: "\\f580";
}

.fa-grin-alt:before {
  content: "\\f581";
}

.fa-grin-beam:before {
  content: "\\f582";
}

.fa-grin-beam-sweat:before {
  content: "\\f583";
}

.fa-grin-hearts:before {
  content: "\\f584";
}

.fa-grin-squint:before {
  content: "\\f585";
}

.fa-grin-squint-tears:before {
  content: "\\f586";
}

.fa-grin-stars:before {
  content: "\\f587";
}

.fa-grin-tears:before {
  content: "\\f588";
}

.fa-grin-tongue:before {
  content: "\\f589";
}

.fa-grin-tongue-squint:before {
  content: "\\f58a";
}

.fa-grin-tongue-wink:before {
  content: "\\f58b";
}

.fa-grin-wink:before {
  content: "\\f58c";
}

.fa-grip-horizontal:before {
  content: "\\f58d";
}

.fa-grip-lines:before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical:before {
  content: "\\f7a5";
}

.fa-grip-vertical:before {
  content: "\\f58e";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guitar:before {
  content: "\\f7a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hamburger:before {
  content: "\\f805";
}

.fa-hammer:before {
  content: "\\f6e3";
}

.fa-hamsa:before {
  content: "\\f665";
}

.fa-hand-holding:before {
  content: "\\f4bd";
}

.fa-hand-holding-heart:before {
  content: "\\f4be";
}

.fa-hand-holding-medical:before {
  content: "樂";
}

.fa-hand-holding-usd:before {
  content: "\\f4c0";
}

.fa-hand-holding-water:before {
  content: "\\f4c1";
}

.fa-hand-lizard:before {
  content: "\\f258";
}

.fa-hand-middle-finger:before {
  content: "\\f806";
}

.fa-hand-paper:before {
  content: "\\f256";
}

.fa-hand-peace:before {
  content: "\\f25b";
}

.fa-hand-point-down:before {
  content: "\\f0a7";
}

.fa-hand-point-left:before {
  content: "\\f0a5";
}

.fa-hand-point-right:before {
  content: "\\f0a4";
}

.fa-hand-point-up:before {
  content: "\\f0a6";
}

.fa-hand-pointer:before {
  content: "\\f25a";
}

.fa-hand-rock:before {
  content: "\\f255";
}

.fa-hand-scissors:before {
  content: "\\f257";
}

.fa-hand-sparkles:before {
  content: "諾";
}

.fa-hand-spock:before {
  content: "\\f259";
}

.fa-hands:before {
  content: "\\f4c2";
}

.fa-hands-helping:before {
  content: "\\f4c4";
}

.fa-hands-wash:before {
  content: "丹";
}

.fa-handshake:before {
  content: "\\f2b5";
}

.fa-handshake-alt-slash:before {
  content: "寧";
}

.fa-handshake-slash:before {
  content: "怒";
}

.fa-hanukiah:before {
  content: "\\f6e6";
}

.fa-hard-hat:before {
  content: "\\f807";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-hat-cowboy:before {
  content: "\\f8c0";
}

.fa-hat-cowboy-side:before {
  content: "\\f8c1";
}

.fa-hat-wizard:before {
  content: "\\f6e8";
}

.fa-hdd:before {
  content: "\\f0a0";
}

.fa-head-side-cough:before {
  content: "率";
}

.fa-head-side-cough-slash:before {
  content: "異";
}

.fa-head-side-mask:before {
  content: "北";
}

.fa-head-side-virus:before {
  content: "磻";
}

.fa-heading:before {
  content: "\\f1dc";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-headphones-alt:before {
  content: "\\f58f";
}

.fa-headset:before {
  content: "\\f590";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-heart-broken:before {
  content: "\\f7a9";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-helicopter:before {
  content: "\\f533";
}

.fa-highlighter:before {
  content: "\\f591";
}

.fa-hiking:before {
  content: "\\f6ec";
}

.fa-hippo:before {
  content: "\\f6ed";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-hockey-puck:before {
  content: "\\f453";
}

.fa-holly-berry:before {
  content: "\\f7aa";
}

.fa-home:before {
  content: "\\f015";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-horse:before {
  content: "\\f6f0";
}

.fa-horse-head:before {
  content: "\\f7ab";
}

.fa-hospital:before {
  content: "\\f0f8";
}

.fa-hospital-alt:before {
  content: "\\f47d";
}

.fa-hospital-symbol:before {
  content: "\\f47e";
}

.fa-hospital-user:before {
  content: "\\f80d";
}

.fa-hot-tub:before {
  content: "\\f593";
}

.fa-hotdog:before {
  content: "\\f80f";
}

.fa-hotel:before {
  content: "\\f594";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-house-damage:before {
  content: "\\f6f1";
}

.fa-house-user:before {
  content: "便";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-hryvnia:before {
  content: "\\f6f2";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-ice-cream:before {
  content: "\\f810";
}

.fa-icicles:before {
  content: "\\f7ad";
}

.fa-icons:before {
  content: "\\f86d";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-id-card:before {
  content: "\\f2c2";
}

.fa-id-card-alt:before {
  content: "\\f47f";
}

.fa-ideal:before {
  content: "邏";
}

.fa-igloo:before {
  content: "\\f7ae";
}

.fa-image:before {
  content: "\\f03e";
}

.fa-images:before {
  content: "\\f302";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-infinity:before {
  content: "\\f534";
}

.fa-info:before {
  content: "\\f129";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-instagram-square:before {
  content: "凌";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi:before {
  content: "\\f669";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joint:before {
  content: "\\f595";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-journal-whills:before {
  content: "\\f66a";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaaba:before {
  content: "\\f66b";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-key:before {
  content: "\\f084";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keyboard:before {
  content: "\\f11c";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-khanda:before {
  content: "\\f66d";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-kiss:before {
  content: "\\f596";
}

.fa-kiss-beam:before {
  content: "\\f597";
}

.fa-kiss-wink-heart:before {
  content: "\\f598";
}

.fa-kiwi-bird:before {
  content: "\\f535";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-landmark:before {
  content: "\\f66f";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-laptop-code:before {
  content: "\\f5fc";
}

.fa-laptop-house:before {
  content: "復";
}

.fa-laptop-medical:before {
  content: "\\f812";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-laugh:before {
  content: "\\f599";
}

.fa-laugh-beam:before {
  content: "\\f59a";
}

.fa-laugh-squint:before {
  content: "\\f59b";
}

.fa-laugh-wink:before {
  content: "\\f59c";
}

.fa-layer-group:before {
  content: "\\f5fd";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-lemon:before {
  content: "\\f094";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-less-than:before {
  content: "\\f536";
}

.fa-less-than-equal:before {
  content: "\\f537";
}

.fa-level-down-alt:before {
  content: "\\f3be";
}

.fa-level-up-alt:before {
  content: "\\f3bf";
}

.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-lightbulb:before {
  content: "\\f0eb";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-link:before {
  content: "\\f0c1";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lira-sign:before {
  content: "\\f195";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-lock-open:before {
  content: "\\f3c1";
}

.fa-long-arrow-alt-down:before {
  content: "\\f309";
}

.fa-long-arrow-alt-left:before {
  content: "\\f30a";
}

.fa-long-arrow-alt-right:before {
  content: "\\f30b";
}

.fa-long-arrow-alt-up:before {
  content: "\\f30c";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-luggage-cart:before {
  content: "\\f59d";
}

.fa-lungs:before {
  content: "\\f604";
}

.fa-lungs-virus:before {
  content: "不";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-mail-bulk:before {
  content: "\\f674";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-male:before {
  content: "\\f183";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-map:before {
  content: "\\f279";
}

.fa-map-marked:before {
  content: "\\f59f";
}

.fa-map-marked-alt:before {
  content: "\\f5a0";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-map-marker-alt:before {
  content: "\\f3c5";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-marker:before {
  content: "\\f5a1";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mask:before {
  content: "\\f6fa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-medal:before {
  content: "\\f5a2";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f3c7";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-meh:before {
  content: "\\f11a";
}

.fa-meh-blank:before {
  content: "\\f5a4";
}

.fa-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.fa-memory:before {
  content: "\\f538";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-menorah:before {
  content: "\\f676";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-meteor:before {
  content: "\\f753";
}

.fa-microblog:before {
  content: "駱";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-alt:before {
  content: "\\f3c9";
}

.fa-microphone-alt-slash:before {
  content: "\\f539";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-microscope:before {
  content: "\\f610";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-mitten:before {
  content: "\\f7b5";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mixer:before {
  content: "稜";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-mobile:before {
  content: "\\f10b";
}

.fa-mobile-alt:before {
  content: "\\f3cd";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-money-bill:before {
  content: "\\f0d6";
}

.fa-money-bill-alt:before {
  content: "\\f3d1";
}

.fa-money-bill-wave:before {
  content: "\\f53a";
}

.fa-money-bill-wave-alt:before {
  content: "\\f53b";
}

.fa-money-check:before {
  content: "\\f53c";
}

.fa-money-check-alt:before {
  content: "\\f53d";
}

.fa-monument:before {
  content: "\\f5a6";
}

.fa-moon:before {
  content: "\\f186";
}

.fa-mortar-pestle:before {
  content: "\\f5a7";
}

.fa-mosque:before {
  content: "\\f678";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-mountain:before {
  content: "\\f6fc";
}

.fa-mouse:before {
  content: "\\f8cc";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-mug-hot:before {
  content: "\\f7b6";
}

.fa-music:before {
  content: "\\f001";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-network-wired:before {
  content: "\\f6ff";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-newspaper:before {
  content: "\\f1ea";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-not-equal:before {
  content: "\\f53e";
}

.fa-notes-medical:before {
  content: "\\f481";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-oil-can:before {
  content: "\\f613";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-om:before {
  content: "\\f679";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-otter:before {
  content: "\\f700";
}

.fa-outdent:before {
  content: "\\f03b";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-pager:before {
  content: "\\f815";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-paint-roller:before {
  content: "\\f5aa";
}

.fa-palette:before {
  content: "\\f53f";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-pallet:before {
  content: "\\f482";
}

.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-parachute-box:before {
  content: "\\f4cd";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-parking:before {
  content: "\\f540";
}

.fa-passport:before {
  content: "\\f5ab";
}

.fa-pastafarianism:before {
  content: "\\f67b";
}

.fa-paste:before {
  content: "\\f0ea";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-peace:before {
  content: "\\f67c";
}

.fa-pen:before {
  content: "\\f304";
}

.fa-pen-alt:before {
  content: "\\f305";
}

.fa-pen-fancy:before {
  content: "\\f5ac";
}

.fa-pen-nib:before {
  content: "\\f5ad";
}

.fa-pen-square:before {
  content: "\\f14b";
}

.fa-pencil-alt:before {
  content: "\\f303";
}

.fa-pencil-ruler:before {
  content: "\\f5ae";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-people-arrows:before {
  content: "泌";
}

.fa-people-carry:before {
  content: "\\f4ce";
}

.fa-pepper-hot:before {
  content: "\\f816";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-percentage:before {
  content: "\\f541";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-person-booth:before {
  content: "\\f756";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-phone-alt:before {
  content: "\\f879";
}

.fa-phone-slash:before {
  content: "\\f3dd";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-phone-square-alt:before {
  content: "\\f87b";
}

.fa-phone-volume:before {
  content: "\\f2a0";
}

.fa-photo-video:before {
  content: "\\f87c";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-square:before {
  content: "爛";
}

.fa-piggy-bank:before {
  content: "\\f4d3";
}

.fa-pills:before {
  content: "\\f484";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-pizza-slice:before {
  content: "\\f818";
}

.fa-place-of-worship:before {
  content: "\\f67f";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-plane-arrival:before {
  content: "\\f5af";
}

.fa-plane-departure:before {
  content: "\\f5b0";
}

.fa-plane-slash:before {
  content: "數";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-poll:before {
  content: "\\f681";
}

.fa-poll-h:before {
  content: "\\f682";
}

.fa-poo:before {
  content: "\\f2fe";
}

.fa-poo-storm:before {
  content: "\\f75a";
}

.fa-poop:before {
  content: "\\f619";
}

.fa-portrait:before {
  content: "\\f3e0";
}

.fa-pound-sign:before {
  content: "\\f154";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-pray:before {
  content: "\\f683";
}

.fa-praying-hands:before {
  content: "\\f684";
}

.fa-prescription:before {
  content: "\\f5b1";
}

.fa-prescription-bottle:before {
  content: "\\f485";
}

.fa-prescription-bottle-alt:before {
  content: "\\f486";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-procedures:before {
  content: "\\f487";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-project-diagram:before {
  content: "\\f542";
}

.fa-pump-medical:before {
  content: "索";
}

.fa-pump-soap:before {
  content: "參";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-question:before {
  content: "\\f128";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-quidditch:before {
  content: "\\f458";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-quran:before {
  content: "\\f687";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-radiation:before {
  content: "\\f7b9";
}

.fa-radiation-alt:before {
  content: "\\f7ba";
}

.fa-rainbow:before {
  content: "\\f75b";
}

.fa-random:before {
  content: "\\f074";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-receipt:before {
  content: "\\f543";
}

.fa-record-vinyl:before {
  content: "\\f8d9";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-redo:before {
  content: "\\f01e";
}

.fa-redo-alt:before {
  content: "\\f2f9";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-remove-format:before {
  content: "\\f87d";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-reply:before {
  content: "\\f3e5";
}

.fa-reply-all:before {
  content: "\\f122";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-republican:before {
  content: "\\f75e";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-restroom:before {
  content: "\\f7bd";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-ribbon:before {
  content: "\\f4d6";
}

.fa-ring:before {
  content: "\\f70b";
}

.fa-road:before {
  content: "\\f018";
}

.fa-robot:before {
  content: "\\f544";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-route:before {
  content: "\\f4d7";
}

.fa-rss:before {
  content: "\\f09e";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-ruble-sign:before {
  content: "\\f158";
}

.fa-ruler:before {
  content: "\\f545";
}

.fa-ruler-combined:before {
  content: "\\f546";
}

.fa-ruler-horizontal:before {
  content: "\\f547";
}

.fa-ruler-vertical:before {
  content: "\\f548";
}

.fa-running:before {
  content: "\\f70c";
}

.fa-rupee-sign:before {
  content: "\\f156";
}

.fa-sad-cry:before {
  content: "\\f5b3";
}

.fa-sad-tear:before {
  content: "\\f5b4";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-satellite:before {
  content: "\\f7bf";
}

.fa-satellite-dish:before {
  content: "\\f7c0";
}

.fa-save:before {
  content: "\\f0c7";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-school:before {
  content: "\\f549";
}

.fa-screwdriver:before {
  content: "\\f54a";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-scroll:before {
  content: "\\f70e";
}

.fa-sd-card:before {
  content: "\\f7c2";
}

.fa-search:before {
  content: "\\f002";
}

.fa-search-dollar:before {
  content: "\\f688";
}

.fa-search-location:before {
  content: "\\f689";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-seedling:before {
  content: "\\f4d8";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-server:before {
  content: "\\f233";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shapes:before {
  content: "\\f61f";
}

.fa-share:before {
  content: "\\f064";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-shekel-sign:before {
  content: "\\f20b";
}

.fa-shield-alt:before {
  content: "\\f3ed";
}

.fa-shield-virus:before {
  content: "塞";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-shipping-fast:before {
  content: "\\f48b";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shoe-prints:before {
  content: "\\f54b";
}

.fa-shopify:before {
  content: "綾";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-shuttle-van:before {
  content: "\\f5b6";
}

.fa-sign:before {
  content: "\\f4d9";
}

.fa-sign-in-alt:before {
  content: "\\f2f6";
}

.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-sign-out-alt:before {
  content: "\\f2f5";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-signature:before {
  content: "\\f5b7";
}

.fa-sim-card:before {
  content: "\\f7c4";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-skating:before {
  content: "\\f7c5";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skiing:before {
  content: "\\f7c9";
}

.fa-skiing-nordic:before {
  content: "\\f7ca";
}

.fa-skull:before {
  content: "\\f54c";
}

.fa-skull-crossbones:before {
  content: "\\f714";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f3ef";
}

.fa-slash:before {
  content: "\\f715";
}

.fa-sleigh:before {
  content: "\\f7cc";
}

.fa-sliders-h:before {
  content: "\\f1de";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-smile:before {
  content: "\\f118";
}

.fa-smile-beam:before {
  content: "\\f5b8";
}

.fa-smile-wink:before {
  content: "\\f4da";
}

.fa-smog:before {
  content: "\\f75f";
}

.fa-smoking:before {
  content: "\\f48d";
}

.fa-smoking-ban:before {
  content: "\\f54d";
}

.fa-sms:before {
  content: "\\f7cd";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-snowboarding:before {
  content: "\\f7ce";
}

.fa-snowflake:before {
  content: "\\f2dc";
}

.fa-snowman:before {
  content: "\\f7d0";
}

.fa-snowplow:before {
  content: "\\f7d2";
}

.fa-soap:before {
  content: "葉";
}

.fa-socks:before {
  content: "\\f696";
}

.fa-solar-panel:before {
  content: "\\f5ba";
}

.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-alpha-down:before {
  content: "\\f15d";
}

.fa-sort-alpha-down-alt:before {
  content: "\\f881";
}

.fa-sort-alpha-up:before {
  content: "\\f15e";
}

.fa-sort-alpha-up-alt:before {
  content: "\\f882";
}

.fa-sort-amount-down:before {
  content: "\\f160";
}

.fa-sort-amount-down-alt:before {
  content: "\\f884";
}

.fa-sort-amount-up:before {
  content: "\\f161";
}

.fa-sort-amount-up-alt:before {
  content: "\\f885";
}

.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-numeric-down:before {
  content: "\\f162";
}

.fa-sort-numeric-down-alt:before {
  content: "\\f886";
}

.fa-sort-numeric-up:before {
  content: "\\f163";
}

.fa-sort-numeric-up-alt:before {
  content: "\\f887";
}

.fa-sort-up:before {
  content: "\\f0de";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-spa:before {
  content: "\\f5bb";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-spell-check:before {
  content: "\\f891";
}

.fa-spider:before {
  content: "\\f717";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-splotch:before {
  content: "\\f5bc";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-spray-can:before {
  content: "\\f5bd";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-square-full:before {
  content: "\\f45c";
}

.fa-square-root-alt:before {
  content: "\\f698";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-stamp:before {
  content: "\\f5bf";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-and-crescent:before {
  content: "\\f699";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-star-half-alt:before {
  content: "\\f5c0";
}

.fa-star-of-david:before {
  content: "\\f69a";
}

.fa-star-of-life:before {
  content: "\\f621";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stopwatch:before {
  content: "\\f2f2";
}

.fa-stopwatch-20:before {
  content: "說";
}

.fa-store:before {
  content: "\\f54e";
}

.fa-store-alt:before {
  content: "\\f54f";
}

.fa-store-alt-slash:before {
  content: "殺";
}

.fa-store-slash:before {
  content: "辰";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stream:before {
  content: "\\f550";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-stroopwafel:before {
  content: "\\f551";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-suitcase-rolling:before {
  content: "\\f5c1";
}

.fa-sun:before {
  content: "\\f185";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-surprise:before {
  content: "\\f5c2";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swatchbook:before {
  content: "\\f5c3";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-swimmer:before {
  content: "\\f5c4";
}

.fa-swimming-pool:before {
  content: "\\f5c5";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-synagogue:before {
  content: "\\f69b";
}

.fa-sync:before {
  content: "\\f021";
}

.fa-sync-alt:before {
  content: "\\f2f1";
}

.fa-syringe:before {
  content: "\\f48e";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-table-tennis:before {
  content: "\\f45d";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-tablet-alt:before {
  content: "\\f3fa";
}

.fa-tablets:before {
  content: "\\f490";
}

.fa-tachometer-alt:before {
  content: "\\f3fd";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-tape:before {
  content: "\\f4db";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-taxi:before {
  content: "\\f1ba";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-teeth:before {
  content: "\\f62e";
}

.fa-teeth-open:before {
  content: "\\f62f";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f3fe";
}

.fa-temperature-high:before {
  content: "\\f769";
}

.fa-temperature-low:before {
  content: "\\f76b";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-tenge:before {
  content: "\\f7d7";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-theater-masks:before {
  content: "\\f630";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-thermometer:before {
  content: "\\f491";
}

.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbtack:before {
  content: "\\f08d";
}

.fa-ticket-alt:before {
  content: "\\f3ff";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-tint-slash:before {
  content: "\\f5c7";
}

.fa-tired:before {
  content: "\\f5c8";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-toilet:before {
  content: "\\f7d8";
}

.fa-toilet-paper:before {
  content: "\\f71e";
}

.fa-toilet-paper-slash:before {
  content: "沈";
}

.fa-toolbox:before {
  content: "\\f552";
}

.fa-tools:before {
  content: "\\f7d9";
}

.fa-tooth:before {
  content: "\\f5c9";
}

.fa-torah:before {
  content: "\\f6a0";
}

.fa-torii-gate:before {
  content: "\\f6a1";
}

.fa-tractor:before {
  content: "\\f722";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-traffic-light:before {
  content: "\\f637";
}

.fa-trailer:before {
  content: "論";
}

.fa-train:before {
  content: "\\f238";
}

.fa-tram:before {
  content: "\\f7da";
}

.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-trash-alt:before {
  content: "\\f2ed";
}

.fa-trash-restore:before {
  content: "\\f829";
}

.fa-trash-restore-alt:before {
  content: "\\f82a";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-truck-loading:before {
  content: "\\f4de";
}

.fa-truck-monster:before {
  content: "\\f63b";
}

.fa-truck-moving:before {
  content: "\\f4df";
}

.fa-truck-pickup:before {
  content: "\\f63c";
}

.fa-tshirt:before {
  content: "\\f553";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-tv:before {
  content: "\\f26c";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-umbrella-beach:before {
  content: "\\f5ca";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-undo:before {
  content: "\\f0e2";
}

.fa-undo-alt:before {
  content: "\\f2ea";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-unity:before {
  content: "雷";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-university:before {
  content: "\\f19c";
}

.fa-unlink:before {
  content: "\\f127";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-user:before {
  content: "\\f007";
}

.fa-user-alt:before {
  content: "\\f406";
}

.fa-user-alt-slash:before {
  content: "\\f4fa";
}

.fa-user-astronaut:before {
  content: "\\f4fb";
}

.fa-user-check:before {
  content: "\\f4fc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-clock:before {
  content: "\\f4fd";
}

.fa-user-cog:before {
  content: "\\f4fe";
}

.fa-user-edit:before {
  content: "\\f4ff";
}

.fa-user-friends:before {
  content: "\\f500";
}

.fa-user-graduate:before {
  content: "\\f501";
}

.fa-user-injured:before {
  content: "\\f728";
}

.fa-user-lock:before {
  content: "\\f502";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-user-minus:before {
  content: "\\f503";
}

.fa-user-ninja:before {
  content: "\\f504";
}

.fa-user-nurse:before {
  content: "\\f82f";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-user-shield:before {
  content: "\\f505";
}

.fa-user-slash:before {
  content: "\\f506";
}

.fa-user-tag:before {
  content: "\\f507";
}

.fa-user-tie:before {
  content: "\\f508";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-users:before {
  content: "\\f0c0";
}

.fa-users-cog:before {
  content: "\\f509";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-utensil-spoon:before {
  content: "\\f2e5";
}

.fa-utensils:before {
  content: "\\f2e7";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-vector-square:before {
  content: "\\f5cb";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-vial:before {
  content: "\\f492";
}

.fa-vials:before {
  content: "\\f493";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-video:before {
  content: "\\f03d";
}

.fa-video-slash:before {
  content: "\\f4e2";
}

.fa-vihara:before {
  content: "\\f6a7";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-virus:before {
  content: "若";
}

.fa-virus-slash:before {
  content: "掠";
}

.fa-viruses:before {
  content: "略";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-voicemail:before {
  content: "\\f897";
}

.fa-volleyball-ball:before {
  content: "\\f45f";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-mute:before {
  content: "\\f6a9";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-vote-yea:before {
  content: "\\f772";
}

.fa-vr-cardboard:before {
  content: "\\f729";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-walking:before {
  content: "\\f554";
}

.fa-wallet:before {
  content: "\\f555";
}

.fa-warehouse:before {
  content: "\\f494";
}

.fa-water:before {
  content: "\\f773";
}

.fa-wave-square:before {
  content: "\\f83e";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weight:before {
  content: "\\f496";
}

.fa-weight-hanging:before {
  content: "\\f5cd";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wind:before {
  content: "\\f72e";
}

.fa-window-close:before {
  content: "\\f410";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wine-bottle:before {
  content: "\\f72f";
}

.fa-wine-glass:before {
  content: "\\f4e3";
}

.fa-wine-glass-alt:before {
  content: "\\f5ce";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-won-sign:before {
  content: "\\f159";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-x-ray:before {
  content: "\\f497";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yen-sign:before {
  content: "\\f157";
}

.fa-yin-yang:before {
  content: "\\f6ad";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Font Awesome 5 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
}
.fab {
  font-family: "Font Awesome 5 Brands";
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg");
}
.far {
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
}
.fa,
.fas {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

@font-face {
  font-family: "dripicons-v2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[data-icon]:before {
  font-family: "dripicons-v2" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^=dripicons-]:before,
[class*=" dripicons-"]:before {
  font-family: "dripicons-v2" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dripicons-alarm:before {
  content: "a";
}

.dripicons-align-center:before {
  content: "b";
}

.dripicons-align-justify:before {
  content: "c";
}

.dripicons-align-left:before {
  content: "d";
}

.dripicons-align-right:before {
  content: "e";
}

.dripicons-anchor:before {
  content: "f";
}

.dripicons-archive:before {
  content: "g";
}

.dripicons-arrow-down:before {
  content: "h";
}

.dripicons-arrow-left:before {
  content: "i";
}

.dripicons-arrow-right:before {
  content: "j";
}

.dripicons-arrow-thin-down:before {
  content: "k";
}

.dripicons-arrow-thin-left:before {
  content: "l";
}

.dripicons-arrow-thin-right:before {
  content: "m";
}

.dripicons-arrow-thin-up:before {
  content: "n";
}

.dripicons-arrow-up:before {
  content: "o";
}

.dripicons-article:before {
  content: "p";
}

.dripicons-backspace:before {
  content: "q";
}

.dripicons-basket:before {
  content: "r";
}

.dripicons-basketball:before {
  content: "s";
}

.dripicons-battery-empty:before {
  content: "t";
}

.dripicons-battery-full:before {
  content: "u";
}

.dripicons-battery-low:before {
  content: "v";
}

.dripicons-battery-medium:before {
  content: "w";
}

.dripicons-bell:before {
  content: "x";
}

.dripicons-blog:before {
  content: "y";
}

.dripicons-bluetooth:before {
  content: "z";
}

.dripicons-bold:before {
  content: "A";
}

.dripicons-bookmark:before {
  content: "B";
}

.dripicons-bookmarks:before {
  content: "C";
}

.dripicons-box:before {
  content: "D";
}

.dripicons-briefcase:before {
  content: "E";
}

.dripicons-brightness-low:before {
  content: "F";
}

.dripicons-brightness-max:before {
  content: "G";
}

.dripicons-brightness-medium:before {
  content: "H";
}

.dripicons-broadcast:before {
  content: "I";
}

.dripicons-browser:before {
  content: "J";
}

.dripicons-browser-upload:before {
  content: "K";
}

.dripicons-brush:before {
  content: "L";
}

.dripicons-calendar:before {
  content: "M";
}

.dripicons-camcorder:before {
  content: "N";
}

.dripicons-camera:before {
  content: "O";
}

.dripicons-card:before {
  content: "P";
}

.dripicons-cart:before {
  content: "Q";
}

.dripicons-checklist:before {
  content: "R";
}

.dripicons-checkmark:before {
  content: "S";
}

.dripicons-chevron-down:before {
  content: "T";
}

.dripicons-chevron-left:before {
  content: "U";
}

.dripicons-chevron-right:before {
  content: "V";
}

.dripicons-chevron-up:before {
  content: "W";
}

.dripicons-clipboard:before {
  content: "X";
}

.dripicons-clock:before {
  content: "Y";
}

.dripicons-clockwise:before {
  content: "Z";
}

.dripicons-cloud:before {
  content: "0";
}

.dripicons-cloud-download:before {
  content: "1";
}

.dripicons-cloud-upload:before {
  content: "2";
}

.dripicons-code:before {
  content: "3";
}

.dripicons-contract:before {
  content: "4";
}

.dripicons-contract-2:before {
  content: "5";
}

.dripicons-conversation:before {
  content: "6";
}

.dripicons-copy:before {
  content: "7";
}

.dripicons-crop:before {
  content: "8";
}

.dripicons-cross:before {
  content: "9";
}

.dripicons-crosshair:before {
  content: "!";
}

.dripicons-cutlery:before {
  content: '"';
}

.dripicons-device-desktop:before {
  content: "#";
}

.dripicons-device-mobile:before {
  content: "\$";
}

.dripicons-device-tablet:before {
  content: "%";
}

.dripicons-direction:before {
  content: "&";
}

.dripicons-disc:before {
  content: "'";
}

.dripicons-document:before {
  content: "(";
}

.dripicons-document-delete:before {
  content: ")";
}

.dripicons-document-edit:before {
  content: "*";
}

.dripicons-document-new:before {
  content: "+";
}

.dripicons-document-remove:before {
  content: ",";
}

.dripicons-dot:before {
  content: "-";
}

.dripicons-dots-2:before {
  content: ".";
}

.dripicons-dots-3:before {
  content: "/";
}

.dripicons-download:before {
  content: ":";
}

.dripicons-duplicate:before {
  content: ";";
}

.dripicons-enter:before {
  content: "<";
}

.dripicons-exit:before {
  content: "=";
}

.dripicons-expand:before {
  content: ">";
}

.dripicons-expand-2:before {
  content: "?";
}

.dripicons-experiment:before {
  content: "@";
}

.dripicons-export:before {
  content: "[";
}

.dripicons-feed:before {
  content: "]";
}

.dripicons-flag:before {
  content: "^";
}

.dripicons-flashlight:before {
  content: "_";
}

.dripicons-folder:before {
  content: "\`";
}

.dripicons-folder-open:before {
  content: "{";
}

.dripicons-forward:before {
  content: "|";
}

.dripicons-gaming:before {
  content: "}";
}

.dripicons-gear:before {
  content: "~";
}

.dripicons-graduation:before {
  content: "\\\\";
}

.dripicons-graph-bar:before {
  content: "\\e000";
}

.dripicons-graph-line:before {
  content: "\\e001";
}

.dripicons-graph-pie:before {
  content: "\\e002";
}

.dripicons-headset:before {
  content: "\\e003";
}

.dripicons-heart:before {
  content: "\\e004";
}

.dripicons-help:before {
  content: "\\e005";
}

.dripicons-home:before {
  content: "\\e006";
}

.dripicons-hourglass:before {
  content: "\\e007";
}

.dripicons-inbox:before {
  content: "\\e008";
}

.dripicons-information:before {
  content: "\\e009";
}

.dripicons-italic:before {
  content: "\\e00a";
}

.dripicons-jewel:before {
  content: "\\e00b";
}

.dripicons-lifting:before {
  content: "\\e00c";
}

.dripicons-lightbulb:before {
  content: "\\e00d";
}

.dripicons-link:before {
  content: "\\e00e";
}

.dripicons-link-broken:before {
  content: "\\e00f";
}

.dripicons-list:before {
  content: "\\e010";
}

.dripicons-loading:before {
  content: "\\e011";
}

.dripicons-location:before {
  content: "\\e012";
}

.dripicons-lock:before {
  content: "\\e013";
}

.dripicons-lock-open:before {
  content: "\\e014";
}

.dripicons-mail:before {
  content: "\\e015";
}

.dripicons-map:before {
  content: "\\e016";
}

.dripicons-media-loop:before {
  content: "\\e017";
}

.dripicons-media-next:before {
  content: "\\e018";
}

.dripicons-media-pause:before {
  content: "\\e019";
}

.dripicons-media-play:before {
  content: "\\e01a";
}

.dripicons-media-previous:before {
  content: "\\e01b";
}

.dripicons-media-record:before {
  content: "\\e01c";
}

.dripicons-media-shuffle:before {
  content: "\\e01d";
}

.dripicons-media-stop:before {
  content: "\\e01e";
}

.dripicons-medical:before {
  content: "\\e01f";
}

.dripicons-menu:before {
  content: "\\e020";
}

.dripicons-message:before {
  content: "\\e021";
}

.dripicons-meter:before {
  content: "\\e022";
}

.dripicons-microphone:before {
  content: "\\e023";
}

.dripicons-minus:before {
  content: "\\e024";
}

.dripicons-monitor:before {
  content: "\\e025";
}

.dripicons-move:before {
  content: "\\e026";
}

.dripicons-music:before {
  content: "\\e027";
}

.dripicons-network-1:before {
  content: "\\e028";
}

.dripicons-network-2:before {
  content: "\\e029";
}

.dripicons-network-3:before {
  content: "\\e02a";
}

.dripicons-network-4:before {
  content: "\\e02b";
}

.dripicons-network-5:before {
  content: "\\e02c";
}

.dripicons-pamphlet:before {
  content: "\\e02d";
}

.dripicons-paperclip:before {
  content: "\\e02e";
}

.dripicons-pencil:before {
  content: "\\e02f";
}

.dripicons-phone:before {
  content: "\\e030";
}

.dripicons-photo:before {
  content: "\\e031";
}

.dripicons-photo-group:before {
  content: "\\e032";
}

.dripicons-pill:before {
  content: "\\e033";
}

.dripicons-pin:before {
  content: "\\e034";
}

.dripicons-plus:before {
  content: "\\e035";
}

.dripicons-power:before {
  content: "\\e036";
}

.dripicons-preview:before {
  content: "\\e037";
}

.dripicons-print:before {
  content: "\\e038";
}

.dripicons-pulse:before {
  content: "\\e039";
}

.dripicons-question:before {
  content: "\\e03a";
}

.dripicons-reply:before {
  content: "\\e03b";
}

.dripicons-reply-all:before {
  content: "\\e03c";
}

.dripicons-return:before {
  content: "\\e03d";
}

.dripicons-retweet:before {
  content: "\\e03e";
}

.dripicons-rocket:before {
  content: "\\e03f";
}

.dripicons-scale:before {
  content: "\\e040";
}

.dripicons-search:before {
  content: "\\e041";
}

.dripicons-shopping-bag:before {
  content: "\\e042";
}

.dripicons-skip:before {
  content: "\\e043";
}

.dripicons-stack:before {
  content: "\\e044";
}

.dripicons-star:before {
  content: "\\e045";
}

.dripicons-stopwatch:before {
  content: "\\e046";
}

.dripicons-store:before {
  content: "\\e047";
}

.dripicons-suitcase:before {
  content: "\\e048";
}

.dripicons-swap:before {
  content: "\\e049";
}

.dripicons-tag:before {
  content: "\\e04a";
}

.dripicons-tag-delete:before {
  content: "\\e04b";
}

.dripicons-tags:before {
  content: "\\e04c";
}

.dripicons-thumbs-down:before {
  content: "\\e04d";
}

.dripicons-thumbs-up:before {
  content: "\\e04e";
}

.dripicons-ticket:before {
  content: "\\e04f";
}

.dripicons-time-reverse:before {
  content: "\\e050";
}

.dripicons-to-do:before {
  content: "\\e051";
}

.dripicons-toggles:before {
  content: "\\e052";
}

.dripicons-trash:before {
  content: "\\e053";
}

.dripicons-trophy:before {
  content: "\\e054";
}

.dripicons-upload:before {
  content: "\\e055";
}

.dripicons-user:before {
  content: "\\e056";
}

.dripicons-user-group:before {
  content: "\\e057";
}

.dripicons-user-id:before {
  content: "\\e058";
}

.dripicons-vibrate:before {
  content: "\\e059";
}

.dripicons-view-apps:before {
  content: "\\e05a";
}

.dripicons-view-list:before {
  content: "\\e05b";
}

.dripicons-view-list-large:before {
  content: "\\e05c";
}

.dripicons-view-thumb:before {
  content: "\\e05d";
}

.dripicons-volume-full:before {
  content: "\\e05e";
}

.dripicons-volume-low:before {
  content: "\\e05f";
}

.dripicons-volume-medium:before {
  content: "\\e060";
}

.dripicons-volume-off:before {
  content: "\\e061";
}

.dripicons-wallet:before {
  content: "\\e062";
}

.dripicons-warning:before {
  content: "\\e063";
}

.dripicons-web:before {
  content: "\\e064";
}

.dripicons-weight:before {
  content: "\\e065";
}

.dripicons-wifi:before {
  content: "\\e066";
}

.dripicons-wrong:before {
  content: "\\e067";
}

.dripicons-zoom-in:before {
  content: "\\e068";
}

.dripicons-zoom-out:before {
  content: "\\e069";
}

/*
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap  v5.3.5 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #556ee6;
  --bs-indigo: #564ab1;
  --bs-purple: #6f42c1;
  --bs-pink: #e83e8c;
  --bs-red: #f46a6a;
  --bs-orange: #f1734f;
  --bs-yellow: #f1b44c;
  --bs-green: #34c38f;
  --bs-teal: #050505;
  --bs-cyan: #50a5f1;
  --bs-white: #fff;
  --bs-gray: #74788d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #eff2f7;
  --bs-gray-300: #f6f6f6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #74788d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #556ee6;
  --bs-secondary: #74788d;
  --bs-success: #34c38f;
  --bs-info: #50a5f1;
  --bs-warning: #f1b44c;
  --bs-danger: #f46a6a;
  --bs-pink: #e83e8c;
  --bs-light: #eff2f7;
  --bs-dark: #343a40;
  --bs-primary-rgb: 85, 110, 230;
  --bs-secondary-rgb: 116, 120, 141;
  --bs-success-rgb: 52, 195, 143;
  --bs-info-rgb: 80, 165, 241;
  --bs-warning-rgb: 241, 180, 76;
  --bs-danger-rgb: 244, 106, 106;
  --bs-pink-rgb: 232, 62, 140;
  --bs-light-rgb: 239, 242, 247;
  --bs-dark-rgb: 52, 58, 64;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Poppins", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.8125rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #495057;
  --bs-body-color-rgb: 73, 80, 87;
  --bs-body-bg: #f8f8fb;
  --bs-body-bg-rgb: 248, 248, 251;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #556ee6;
  --bs-link-color-rgb: 85, 110, 230;
  --bs-link-decoration: none;
  --bs-link-hover-color: #4458b8;
  --bs-link-hover-color-rgb: 68, 88, 184;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #e83e8c;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #eff2f7;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.4rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.2;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.328125rem + 0.9375vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.03125rem;
  }
}

h2, .h2 {
  font-size: calc(1.2875rem + 0.45vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.625rem;
  }
}

h3, .h3 {
  font-size: calc(1.2671875rem + 0.20625vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.421875rem;
  }
}

h4, .h4 {
  font-size: 1.21875rem;
}

h5, .h5 {
  font-size: 1.015625rem;
}

h6, .h6 {
  font-size: 0.8125rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 80%;
}

mark, .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: underline;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 87.5%;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 600;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #74788d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.015625rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.725rem + 5.7vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 6rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.675rem + 5.1vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 5.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4.5rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 80%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.015625rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 80%;
  color: #74788d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f8f8fb;
  border: 1px solid #f6f6f6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 80%;
  color: #74788d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 12px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #495057;
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: #eff2f7;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #495057;
  --bs-table-striped-bg: #f8f9fa;
  --bs-table-active-color: #495057;
  --bs-table-active-bg: #f8f9fa;
  --bs-table-hover-color: #495057;
  --bs-table-hover-bg: #f8f9fa;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid #eff2f7;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.3rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #dde2fa;
  --bs-table-border-color: rgb(198.9, 203.4, 225);
  --bs-table-striped-bg: rgb(209.95, 214.7, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(198.9, 203.4, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(204.425, 209.05, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(227.2, 228, 232.2);
  --bs-table-border-color: rgb(204.48, 205.2, 208.98);
  --bs-table-striped-bg: rgb(215.84, 216.6, 220.59);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(204.48, 205.2, 208.98);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(210.16, 210.9, 214.785);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(214.4, 243, 232.6);
  --bs-table-border-color: rgb(192.96, 218.7, 209.34);
  --bs-table-striped-bg: rgb(203.68, 230.85, 220.97);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(192.96, 218.7, 209.34);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(198.32, 224.775, 215.155);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(220, 237, 252.2);
  --bs-table-border-color: rgb(198, 213.3, 226.98);
  --bs-table-striped-bg: rgb(209, 225.15, 239.59);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(198, 213.3, 226.98);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(203.5, 219.225, 233.285);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(252.2, 240, 219.2);
  --bs-table-border-color: rgb(226.98, 216, 197.28);
  --bs-table-striped-bg: rgb(239.59, 228, 208.24);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(226.98, 216, 197.28);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(233.285, 222, 202.76);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(252.8, 225.2, 225.2);
  --bs-table-border-color: rgb(227.52, 202.68, 202.68);
  --bs-table-striped-bg: rgb(240.16, 213.94, 213.94);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(227.52, 202.68, 202.68);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(233.84, 208.31, 208.31);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #eff2f7;
  --bs-table-border-color: rgb(215.1, 217.8, 222.3);
  --bs-table-striped-bg: rgb(227.05, 229.9, 234.65);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(215.1, 217.8, 222.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(221.075, 223.85, 228.475);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: rgb(72.3, 77.7, 83.1);
  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.47rem + 1px);
  padding-bottom: calc(0.47rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.015625rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7109375rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 80%;
  color: #74788d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(185.4, 190.8, 196.2);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: #74788d;
  opacity: 1;
}
.form-control:disabled {
  background-color: #eff2f7;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.47rem 0.75rem;
  margin: -0.47rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: #495057;
  background-color: #eff2f7;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(227.05, 229.9, 234.65);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.47rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.015625rem;
  border-radius: 0.4rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.94rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.94rem + 2px);
  padding: 0.47rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  display: block;
  width: 100%;
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(185.4, 190.8, 196.2);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  color: #74788d;
  background-color: #eff2f7;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7109375rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.015625rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.form-check {
  display: block;
  min-height: 1.21875rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(185.4, 190.8, 196.2);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25);
}
.form-check-input:checked {
  background-color: #556ee6;
  border-color: #556ee6;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #556ee6;
  border-color: #556ee6;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f8fb, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f8fb, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #556ee6;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(204, 211.5, 247.5);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #f6f6f6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #556ee6;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(204, 211.5, 247.5);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #f6f6f6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  min-height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  border-radius: 0.25rem;
}
.form-floating > textarea:disabled ~ label::after {
  background-color: #eff2f7;
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #eff2f7;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.015625rem;
  border-radius: 0.4rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.5rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * 1px);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #34c38f;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7109375rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(52, 195, 143, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #34c38f;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #34c38f;
  box-shadow: 0 0 0 0.15rem rgba(52, 195, 143, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #34c38f;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  padding-right: calc(0.75em + 3.205rem);
  background-position: right 0.75rem center, center right 2.5rem;
  background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #34c38f;
  box-shadow: 0 0 0 0.15rem rgba(52, 195, 143, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.94rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #34c38f;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #34c38f;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.15rem rgba(52, 195, 143, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #34c38f;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f46a6a;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7109375rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(244, 106, 106, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f46a6a;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f46a6a;
  box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f46a6a;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  padding-right: calc(0.75em + 3.205rem);
  background-position: right 0.75rem center, center right 2.5rem;
  background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #f46a6a;
  box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.94rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f46a6a;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #f46a6a;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f46a6a;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.47rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.25rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  text-decoration: none;
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #556ee6;
  --bs-btn-border-color: #556ee6;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(72.25, 93.5, 195.5);
  --bs-btn-hover-border-color: #4458b8;
  --bs-btn-focus-shadow-rgb: 111, 132, 234;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4458b8;
  --bs-btn-active-border-color: rgb(63.75, 82.5, 172.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #556ee6;
  --bs-btn-disabled-border-color: #556ee6;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(98.6, 102, 119.85);
  --bs-btn-hover-border-color: rgb(92.8, 96, 112.8);
  --bs-btn-focus-shadow-rgb: 137, 140, 158;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.8, 96, 112.8);
  --bs-btn-active-border-color: rgb(87, 90, 105.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #74788d;
  --bs-btn-disabled-border-color: #74788d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #34c38f;
  --bs-btn-border-color: #34c38f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(44.2, 165.75, 121.55);
  --bs-btn-hover-border-color: rgb(41.6, 156, 114.4);
  --bs-btn-focus-shadow-rgb: 82, 204, 160;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(41.6, 156, 114.4);
  --bs-btn-active-border-color: rgb(39, 146.25, 107.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #34c38f;
  --bs-btn-disabled-border-color: #34c38f;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(68, 140.25, 204.85);
  --bs-btn-hover-border-color: rgb(64, 132, 192.8);
  --bs-btn-focus-shadow-rgb: 106, 179, 243;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(64, 132, 192.8);
  --bs-btn-active-border-color: rgb(60, 123.75, 180.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #50a5f1;
  --bs-btn-disabled-border-color: #50a5f1;
}

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f1b44c;
  --bs-btn-border-color: #f1b44c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(204.85, 153, 64.6);
  --bs-btn-hover-border-color: rgb(192.8, 144, 60.8);
  --bs-btn-focus-shadow-rgb: 243, 191, 103;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(192.8, 144, 60.8);
  --bs-btn-active-border-color: rgb(180.75, 135, 57);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f1b44c;
  --bs-btn-disabled-border-color: #f1b44c;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f46a6a;
  --bs-btn-border-color: #f46a6a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(207.4, 90.1, 90.1);
  --bs-btn-hover-border-color: rgb(195.2, 84.8, 84.8);
  --bs-btn-focus-shadow-rgb: 246, 128, 128;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(195.2, 84.8, 84.8);
  --bs-btn-active-border-color: rgb(183, 79.5, 79.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f46a6a;
  --bs-btn-disabled-border-color: #f46a6a;
}

.btn-pink {
  --bs-btn-color: #fff;
  --bs-btn-bg: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(197.2, 52.7, 119);
  --bs-btn-hover-border-color: rgb(185.6, 49.6, 112);
  --bs-btn-focus-shadow-rgb: 235, 91, 157;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(185.6, 49.6, 112);
  --bs-btn-active-border-color: rgb(174, 46.5, 105);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #e83e8c;
  --bs-btn-disabled-border-color: #e83e8c;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eff2f7;
  --bs-btn-border-color: #eff2f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(203.15, 205.7, 209.95);
  --bs-btn-hover-border-color: rgb(191.2, 193.6, 197.6);
  --bs-btn-focus-shadow-rgb: 203, 206, 210;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(191.2, 193.6, 197.6);
  --bs-btn-active-border-color: rgb(179.25, 181.5, 185.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eff2f7;
  --bs-btn-disabled-border-color: #eff2f7;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(82.45, 87.55, 92.65);
  --bs-btn-hover-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.6, 97.4, 102.2);
  --bs-btn-active-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}

.btn-outline-primary {
  --bs-btn-color: #556ee6;
  --bs-btn-border-color: #556ee6;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #556ee6;
  --bs-btn-hover-border-color: #556ee6;
  --bs-btn-focus-shadow-rgb: 85, 110, 230;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #556ee6;
  --bs-btn-active-border-color: #556ee6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #556ee6;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #556ee6;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #74788d;
  --bs-btn-hover-border-color: #74788d;
  --bs-btn-focus-shadow-rgb: 116, 120, 141;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #74788d;
  --bs-btn-active-border-color: #74788d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #74788d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #34c38f;
  --bs-btn-border-color: #34c38f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #34c38f;
  --bs-btn-hover-border-color: #34c38f;
  --bs-btn-focus-shadow-rgb: 52, 195, 143;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #34c38f;
  --bs-btn-active-border-color: #34c38f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #34c38f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #34c38f;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #50a5f1;
  --bs-btn-hover-border-color: #50a5f1;
  --bs-btn-focus-shadow-rgb: 80, 165, 241;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #50a5f1;
  --bs-btn-active-border-color: #50a5f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50a5f1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50a5f1;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #f1b44c;
  --bs-btn-border-color: #f1b44c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f1b44c;
  --bs-btn-hover-border-color: #f1b44c;
  --bs-btn-focus-shadow-rgb: 241, 180, 76;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f1b44c;
  --bs-btn-active-border-color: #f1b44c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f1b44c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f1b44c;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #f46a6a;
  --bs-btn-border-color: #f46a6a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f46a6a;
  --bs-btn-hover-border-color: #f46a6a;
  --bs-btn-focus-shadow-rgb: 244, 106, 106;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f46a6a;
  --bs-btn-active-border-color: #f46a6a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f46a6a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f46a6a;
  --bs-gradient: none;
}

.btn-outline-pink {
  --bs-btn-color: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #e83e8c;
  --bs-btn-hover-border-color: #e83e8c;
  --bs-btn-focus-shadow-rgb: 232, 62, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #e83e8c;
  --bs-btn-active-border-color: #e83e8c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e83e8c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e83e8c;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #eff2f7;
  --bs-btn-border-color: #eff2f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eff2f7;
  --bs-btn-hover-border-color: #eff2f7;
  --bs-btn-focus-shadow-rgb: 239, 242, 247;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eff2f7;
  --bs-btn-active-border-color: #eff2f7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eff2f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eff2f7;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #556ee6;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #4458b8;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #4458b8;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.015625rem;
  --bs-btn-border-radius: 0.4rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.7109375rem;
  --bs-btn-border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.8125rem;
  --bs-dropdown-color: #495057;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: calc(0.25rem - 0);
  --bs-dropdown-divider-bg: #eff2f7;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  --bs-dropdown-link-color: #212529;
  --bs-dropdown-link-hover-color: rgb(29.7, 33.3, 36.9);
  --bs-dropdown-link-hover-bg: #f8f9fa;
  --bs-dropdown-link-active-color: #343a40;
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #74788d;
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #74788d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7109375rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #f6f6f6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #f6f6f6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #eff2f7;
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #343a40;
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.25rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * 1px);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * 1px);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
  text-decoration: none;
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #ced4da;
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: #eff2f7 #eff2f7 #ced4da;
  --bs-nav-tabs-link-active-color: #495057;
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: #ced4da #ced4da var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #556ee6;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 600;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.34765625rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.015625rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.015625rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.25rem;
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
  text-decoration: none;
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: #f6f6f6;
  --bs-card-border-radius: 0.25rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(0.25rem - 0);
  --bs-card-cap-padding-y: 0.625rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: rgba(0, 0, 0, 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #495057;
  --bs-accordion-bg: transparent;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: rgba(0, 0, 0, 0.125);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.25rem;
  --bs-accordion-inner-border-radius: calc(0.25rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: #495057;
  --bs-accordion-btn-bg: transparent;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --bs-accordion-btn-icon-width: 16px;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: rgb(76.5, 99, 207);
  --bs-accordion-active-bg: rgb(238, 240.5, 252.5);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.8125rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 1rem;
  --bs-breadcrumb-padding-y: 0.75rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #74788d;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: #74788d;
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #ced4da;
  --bs-pagination-border-radius: 0.25rem;
  --bs-pagination-hover-color: #4458b8;
  --bs-pagination-hover-bg: #eff2f7;
  --bs-pagination-hover-border-color: #ced4da;
  --bs-pagination-focus-color: #4458b8;
  --bs-pagination-focus-bg: #eff2f7;
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #556ee6;
  --bs-pagination-active-border-color: #556ee6;
  --bs-pagination-disabled-color: #ced4da;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #ced4da;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  text-decoration: none;
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.015625rem;
  --bs-pagination-border-radius: 0.4rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.7109375rem;
  --bs-pagination-border-radius: 0.2rem;
}

.badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 75%;
  --bs-badge-font-weight: 500;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-pink {
  --bs-alert-color: var(--bs-pink-text-emphasis);
  --bs-alert-bg: var(--bs-pink-bg-subtle);
  --bs-alert-border-color: var(--bs-pink-border-subtle);
  --bs-alert-link-color: var(--bs-pink-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 0.625rem;
  --bs-progress-font-size: 0.609375rem;
  --bs-progress-bg: #f6f6f6;
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #556ee6;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: #eff2f7;
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1.25rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: #495057;
  --bs-list-group-action-hover-color: #495057;
  --bs-list-group-action-hover-bg: #f8f9fa;
  --bs-list-group-action-active-color: #495057;
  --bs-list-group-action-active-bg: #eff2f7;
  --bs-list-group-disabled-color: #74788d;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #556ee6;
  --bs-list-group-active-border-color: #556ee6;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-pink {
  --bs-list-group-color: var(--bs-pink-text-emphasis);
  --bs-list-group-bg: var(--bs-pink-bg-subtle);
  --bs-list-group-border-color: var(--bs-pink-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);
  --bs-list-group-active-color: var(--bs-pink-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.25rem;
  --bs-toast-spacing: 12px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: rgba(0, 0, 0, 0.1);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  --bs-toast-header-color: #74788d;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: #fff;
  --bs-modal-border-color: #f6f6f6;
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.4rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.4rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: #eff2f7;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #eff2f7;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.7rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.7109375rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.25rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.7109375rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: #f6f6f6;
  --bs-popover-border-radius: 0.4rem;
  --bs-popover-inner-border-radius: calc(0.4rem - 1px);
  --bs-popover-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: rgb(244.8, 244.8, 244.8);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: #495057;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: #f6f6f6;
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-pink {
  color: #fff !important;
  background-color: RGBA(var(--bs-pink-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(68, 88, 184, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(68, 88, 184, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(93, 96, 113, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(93, 96, 113, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(42, 156, 114, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 156, 114, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(64, 132, 193, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(64, 132, 193, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(193, 144, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(193, 144, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(195, 85, 85, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(195, 85, 85, var(--bs-link-underline-opacity, 1)) !important;
}

.link-pink {
  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-pink:hover, .link-pink:focus {
  color: RGBA(186, 50, 112, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(186, 50, 112, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(242, 245, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(242, 245, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.2;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-pink {
  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-pink {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.328125rem + 0.9375vw) !important;
}

.fs-2 {
  font-size: calc(1.2875rem + 0.45vw) !important;
}

.fs-3 {
  font-size: calc(1.2671875rem + 0.20625vw) !important;
}

.fs-4 {
  font-size: 1.21875rem !important;
}

.fs-5 {
  font-size: 1.015625rem !important;
}

.fs-6 {
  font-size: 0.8125rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-pink {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-pink {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-pink {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.03125rem !important;
  }
  .fs-2 {
    font-size: 1.625rem !important;
  }
  .fs-3 {
    font-size: 1.421875rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/* =============
   General
============= */
html {
  position: relative;
  min-height: 100%;
}

.h1, .h2, .h3, .h4, .h5, .h6,
h1, h2, h3, h4, h5, h6 {
  color: #495057;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid #f6f6f6;
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #f6f6f6;
  text-align: right;
}

@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}

.row > * {
  position: relative;
}

.bg-primary.bg-soft {
  background-color: rgba(85, 110, 230, 0.25) !important;
}

.bg-secondary.bg-soft {
  background-color: rgba(116, 120, 141, 0.25) !important;
}

.bg-success.bg-soft {
  background-color: rgba(52, 195, 143, 0.25) !important;
}

.bg-info.bg-soft {
  background-color: rgba(80, 165, 241, 0.25) !important;
}

.bg-warning.bg-soft {
  background-color: rgba(241, 180, 76, 0.25) !important;
}

.bg-danger.bg-soft {
  background-color: rgba(244, 106, 106, 0.25) !important;
}

.bg-pink.bg-soft {
  background-color: rgba(232, 62, 140, 0.25) !important;
}

.bg-light.bg-soft {
  background-color: rgba(239, 242, 247, 0.25) !important;
}

.bg-dark.bg-soft {
  background-color: rgba(52, 58, 64, 0.25) !important;
}

.badge[href]:hover, .badge[href]:focus {
  color: #fff;
}

.badge.bg-primary[href]:hover, .badge.bg-primary[href]:focus {
  background-color: rgb(67.2153846154, 94.8307692308, 227.3846153846) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
}
.badge-soft-primary[href]:hover, .badge-soft-primary[href]:focus {
  color: #556ee6;
  text-decoration: none;
  background-color: rgba(85, 110, 230, 0.4);
}

.badge.bg-secondary[href]:hover, .badge.bg-secondary[href]:focus {
  background-color: rgb(106.6102766798, 110.3509881423, 129.9897233202) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18);
}
.badge-soft-secondary[href]:hover, .badge-soft-secondary[href]:focus {
  color: #74788d;
  text-decoration: none;
  background-color: rgba(116, 120, 141, 0.4);
}

.badge.bg-success[href]:hover, .badge.bg-success[href]:focus {
  background-color: rgb(47.7052631579, 178.8947368421, 131.1894736842) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
}
.badge-soft-success[href]:hover, .badge-soft-success[href]:focus {
  color: #34c38f;
  text-decoration: none;
  background-color: rgba(52, 195, 143, 0.4);
}

.badge.bg-info[href]:hover, .badge.bg-info[href]:focus {
  background-color: rgb(61.1111111111, 155.2857142857, 239.4888888889) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}
.badge-soft-info[href]:hover, .badge-soft-info[href]:focus {
  color: #50a5f1;
  text-decoration: none;
  background-color: rgba(80, 165, 241, 0.4);
}

.badge.bg-warning[href]:hover, .badge.bg-warning[href]:focus {
  background-color: rgb(239.5202072539, 172.0725388601, 57.0797927461) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18);
}
.badge-soft-warning[href]:hover, .badge-soft-warning[href]:focus {
  color: #f1b44c;
  text-decoration: none;
  background-color: rgba(241, 180, 76, 0.4);
}

.badge.bg-danger[href]:hover, .badge.bg-danger[href]:focus {
  background-color: rgb(242.5975, 87.0025, 87.0025) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18);
}
.badge-soft-danger[href]:hover, .badge-soft-danger[href]:focus {
  color: #f46a6a;
  text-decoration: none;
  background-color: rgba(244, 106, 106, 0.4);
}

.badge.bg-pink[href]:hover, .badge.bg-pink[href]:focus {
  background-color: rgb(229.8277777778, 43.7722222222, 129.1388888889) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.18);
}
.badge-soft-pink[href]:hover, .badge-soft-pink[href]:focus {
  color: #e83e8c;
  text-decoration: none;
  background-color: rgba(232, 62, 140, 0.4);
}

.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  background-color: rgb(225.4, 230.95, 240.2) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-light {
  color: #eff2f7;
  background-color: rgba(239, 242, 247, 0.18);
}
.badge-soft-light[href]:hover, .badge-soft-light[href]:focus {
  color: #eff2f7;
  text-decoration: none;
  background-color: rgba(239, 242, 247, 0.4);
}

.badge.bg-dark[href]:hover, .badge.bg-dark[href]:focus {
  background-color: rgb(42.8551724138, 47.8, 52.7448275862) !important;
}

.badge.bg-light {
  color: #495057;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #495057;
}

.badge-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18);
}
.badge-soft-dark[href]:hover, .badge-soft-dark[href]:focus {
  color: #343a40;
  text-decoration: none;
  background-color: rgba(52, 58, 64, 0.4);
}

.rounded-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
}

.badge.bg-dark {
  color: #eff2f7;
}

button, a {
  outline: none !important;
}

.btn-rounded {
  border-radius: 30px;
}

.btn-dark, .btn-secondary {
  color: #eff2f7 !important;
}

.btn-outline-light {
  color: #212529;
}

.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle, .btn-outline-dark:hover, .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle, .btn-dark:hover {
  color: #eff2f7;
}

.btn-group-example .btn {
  position: relative;
}
.btn-group-example .btn:first-child::before {
  display: none;
}
.btn-group-example .btn:before {
  content: "OR";
  position: absolute;
  font-size: 10px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  background-color: #74788d;
  color: #eff2f7;
  border: 1px solid #fff;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.btn-label {
  position: relative;
  padding-left: 44px;
}
.btn-label .label-icon {
  position: absolute;
  width: 32px;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-label.btn-light .label-icon {
  background-color: rgba(52, 58, 64, 0.1);
  border-right: 1px solid rgba(52, 58, 64, 0.2);
}

.breadcrumb-item > a {
  color: #495057;
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
}

.card {
  margin-bottom: 24px;
  box-shadow: none;
  border: 0;
  background: #fff !important;
}

.card-drop {
  color: #495057;
}

.card-title {
  font-size: 15px;
  margin: 0 0 7px 0;
  font-weight: 600;
}

.card-title-desc {
  color: #74788d;
  margin-bottom: 24px;
}

.dropdown-menu {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.show {
  top: 100% !important;
}

.dropdown-menu-end[style] {
  left: auto !important;
  right: 0 !important;
}

.dropdown-menu[data-popper-placement^=right], .dropdown-menu[data-popper-placement^=top], .dropdown-menu[data-popper-placement^=left] {
  top: auto !important;
  animation: none !important;
}

.tooltip[x-placement^=top], .show[x-placement^=top]:not(.tooltip) {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(10px);
  }
}
@media (min-width: 600px) {
  .dropdown-menu-lg {
    width: 320px;
  }
  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-divider {
  border-top-color: #eff2f7;
}

.dropdown-mega {
  position: static !important;
}

.dropdown-megamenu[style] {
  padding: 20px;
  left: 20px !important;
  right: 20px !important;
}

.dropdown-mega-menu-xl {
  width: 40rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

.icon-tab .nav-link {
  border: 1px solid #e9e9e9;
  color: #495057;
}

.icon-tab .active.nav-link {
  background: #556ee6;
  color: #fff;
}

.icon-tab li:first-child .nav-link {
  border-top-left-radius: 21px !important;
  border-bottom-left-radius: 21px !important;
}

.icon-tab li:last-child .nav-link {
  border-top-right-radius: 21px !important;
  border-bottom-right-radius: 21px !important;
}

.icon-tab .nav-link i, .vertical-icon .nav-link i {
  padding-right: 3px;
  font-size: 14px;
}

.vertical-icon .active.nav-link {
  border: 1px solid #556ee6;
  border-radius: 21px;
  background: #556ee6;
  color: #fff;
}

.vertical-icon .nav-link {
  color: #495057;
}

.nav-tabs > li > a, .nav-pills > li > a {
  color: #495057;
  font-weight: 500;
}

.nav-pills > a {
  color: #495057;
  font-weight: 500;
}

.nav-tabs-custom {
  border-bottom: 2px solid #f6f6f6;
}
.nav-tabs-custom .nav-item {
  position: relative;
  color: #343a40;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #556ee6;
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -1px;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: #556ee6;
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.table th {
  font-weight: 600;
}
.table .table-light {
  color: #495057;
  border-color: #eff2f7;
  background-color: #f8f9fa;
}

.table-bordered {
  border: 1px solid #eff2f7;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #eff2f7;
}

.table-dark > :not(:last-child) > :last-child > * {
  border-bottom-color: rgb(67.225, 72.775, 78.325);
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  width: 32px;
  height: 32px;
  padding: 0;
  text-align: center;
  line-height: 32px;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.custom-progess {
  position: relative;
}
.custom-progess .progress-icon {
  position: absolute;
  top: -12px;
}
.custom-progess .progress-icon .avatar-title {
  background: #fff;
}

.animated-progess {
  position: relative;
}
.animated-progess .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}
/*
File: Main Css File
*/
#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 250px;
  z-index: 1002;
  background-color: #ffffff;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
@media (max-width: 991.98px) {
  #page-topbar {
    left: 0;
  }
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 calc(24px / 2) 0 0;
}
.navbar-header .dropdown.show.header-item {
  background-color: #f8f9fa;
}
.navbar-header .dropdown .dropdown-menu {
  margin-top: 0;
}

.navbar-brand-box {
  padding: 0 1.5rem;
  text-align: center;
}

.logo {
  line-height: 70px;
}
.logo .logo-sm {
  display: none;
}

.logo-light {
  display: none;
}

/* Search */
.app-search {
  padding: calc(32px / 2) 0;
}
.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 20px;
  background-color: #f3f3f9;
  box-shadow: none;
  border-radius: 30px;
}
.app-search span {
  position: absolute;
  z-index: 10;
  font-size: 16px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: #74788d;
}

.megamenu-list li {
  position: relative;
  padding: 5px 0px;
}
.megamenu-list li a {
  color: #495057;
}

@media (max-width: 992px) {
  .navbar-brand-box {
    width: auto;
  }
  .logo span.logo-lg {
    display: none;
  }
  .logo span.logo-sm {
    display: inline-block;
  }
}
.page-content {
  padding: 15px 12px 60px 12px;
  background: #fff;
}

.header-item {
  height: 70px;
  box-shadow: none !important;
  color: #555b6d;
  border: 0;
  border-radius: 0px;
  position: relative;
}
.header-item:hover {
  color: #555b6d;
}

.header-profile-user {
  height: 36px;
  width: 36px;
  background-color: #f6f6f6;
  padding: 3px;
}

.noti-icon i {
  font-size: 22px;
  color: #555b6d;
}
.noti-icon .badge {
  position: absolute;
  top: 12px;
  right: 4px;
}

.notification-item .media {
  padding: 0.75rem 1rem;
}
.notification-item .media:hover {
  background-color: #f6f6f6;
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: #74788d;
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  border-color: #eff2f7;
}

.fullscreen-enable [data-toggle=fullscreen] .bx-fullscreen::before {
  content: "\\ea3f";
}

body[data-topbar=dark] #page-topbar {
  background-color: #2a3042;
}
body[data-topbar=dark] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.05);
}
body[data-topbar=dark] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}
body[data-topbar=dark] .header-item {
  color: #e9ecef;
}
body[data-topbar=dark] .header-item:hover {
  color: #e9ecef;
}
body[data-topbar=dark] .header-profile-user {
  background-color: rgba(255, 255, 255, 0.25);
}
body[data-topbar=dark] .noti-icon i {
  color: #e9ecef;
}
body[data-topbar=dark] .logo-dark {
  display: none;
}
body[data-topbar=dark] .logo-light {
  display: block;
}
body[data-topbar=dark] .app-search .form-control {
  background-color: rgba(243, 243, 249, 0.07);
  color: #fff;
}
body[data-topbar=dark] .app-search span,
body[data-topbar=dark] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

body[data-sidebar=dark] .navbar-brand-box {
  background: #2a3042;
}
body[data-sidebar=dark] .logo-dark {
  display: none;
}
body[data-sidebar=dark] .logo-light {
  display: block;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }
  .navbar-header .dropdown .dropdown-menu {
    left: 10px !important;
    right: 10px !important;
  }
}
@media (max-width: 380px) {
  .navbar-brand-box {
    display: none;
  }
}
body[data-layout=horizontal] .navbar-brand-box {
  width: auto;
}
body[data-layout=horizontal] .page-content {
  margin-top: 70px;
  padding: calc(55px + 24px) calc(24px / 2) 60px calc(24px / 2);
}

@media (max-width: 992px) {
  body[data-layout=horizontal] .page-content {
    margin-top: 15px;
  }
}
.page-title-box {
  padding-bottom: 24px;
  background: #fff;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4, .page-title-box .h4 {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px !important;
}

.footer {
  bottom: 0;
  padding: 20px calc(24px / 2);
  position: absolute;
  right: 0;
  color: #ffffff;
  left: 250px;
  height: 60px;
  background-color: #111233;
}
@media (max-width: 991.98px) {
  .footer {
    left: 0;
  }
}

.vertical-collpsed .footer {
  left: 70px;
}
@media (max-width: 991.98px) {
  .vertical-collpsed .footer {
    left: 0;
  }
}

body[data-layout=horizontal] .footer {
  left: 0 !important;
}

.right-bar {
  background-color: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 280px;
  z-index: 9999;
  float: right !important;
  right: -290px;
  top: 0;
  bottom: 0;
}
.right-bar .right-bar-toggle {
  background-color: rgb(68.0034482759, 75.85, 83.6965517241);
  height: 24px;
  width: 24px;
  line-height: 24px;
  display: block;
  color: #eff2f7;
  text-align: center;
  border-radius: 50%;
}
.right-bar .right-bar-toggle:hover {
  background-color: rgb(74.8620689655, 83.5, 92.1379310345);
}

.rightbar-overlay {
  background-color: rgba(52, 58, 64, 0.55);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all 0.2s ease-out;
}

.right-bar-enabled .right-bar {
  right: 0;
}
.right-bar-enabled .rightbar-overlay {
  display: block;
}

@media (max-width: 767.98px) {
  .right-bar {
    overflow: auto;
  }
  .right-bar .slimscroll-menu {
    height: auto !important;
  }
}
.react-drawer-drawer {
  background-color: #fff !important;
}

.metismenu {
  margin: 0;
}
.metismenu li {
  display: block;
  width: 100%;
}
.metismenu .mm-collapse {
  display: none;
}
.metismenu .mm-collapse:not(.mm-show) {
  display: none;
}
.metismenu .mm-collapse.mm-show {
  display: block;
}
.metismenu .mm-collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-timing-function: ease;
  transition-duration: 0.35s;
  transition-property: height, visibility;
}

.vertical-menu {
  width: 250px;
  z-index: 1001;
  background: #ffffff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  padding-top: 70px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
@media (max-width: 991.98px) {
  .vertical-menu {
    top: 70px;
    padding-top: 0px;
  }
}
.vertical-menu .navbar-brand-box {
  position: fixed;
  top: 0px;
  z-index: 99;
}
@media (max-width: 991.98px) {
  .vertical-menu .navbar-brand-box {
    display: none;
  }
}

.main-content {
  margin-left: 250px;
  overflow: hidden;
}
.main-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

#sidebar-menu {
  padding: 10px 0 30px 0;
}
#sidebar-menu .mm-active > .has-arrow:after {
  transform: rotate(-180deg);
}
#sidebar-menu .has-arrow:after {
  content: "\\f0140";
  font-family: "Material Design Icons";
  display: block;
  float: right;
  transition: transform 0.2s;
  font-size: 1rem;
}
#sidebar-menu ul li a {
  display: block;
  padding: 0.625rem 1.5rem;
  color: #545a6d;
  position: relative;
  font-size: 13px;
  transition: all 0.4s;
}
#sidebar-menu ul li a i {
  display: inline-block;
  min-width: 1.75rem;
  padding-bottom: 0.125em;
  font-size: 1.25rem;
  line-height: 1.40625rem;
  vertical-align: middle;
  color: #7f8387;
  transition: all 0.4s;
}
#sidebar-menu ul li a:hover {
  color: #383c40;
}
#sidebar-menu ul li a:hover i {
  color: #383c40;
}
#sidebar-menu ul li .badge {
  margin-top: 4px;
}
#sidebar-menu ul li ul.sub-menu {
  padding: 0;
}
#sidebar-menu ul li ul.sub-menu li a {
  padding: 0.4rem 1.5rem 0.4rem 3.5rem;
  font-size: 13px;
  color: #545a6d;
}
#sidebar-menu ul li ul.sub-menu li a:hover {
  color: #383c40;
}
#sidebar-menu ul li ul.sub-menu li ul.sub-menu {
  padding: 0;
}
#sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding: 0.4rem 1.5rem 0.4rem 4.5rem;
  font-size: 13px;
}

.menu-title {
  padding: 12px 20px !important;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: #7f8387;
  font-weight: 600;
}

.mm-active {
  color: #556ee6 !important;
}
.mm-active > a {
  color: #556ee6 !important;
}
.mm-active > a i {
  color: #556ee6 !important;
}
.mm-active .active {
  color: #556ee6 !important;
}
.mm-active .active i {
  color: #556ee6 !important;
}
.mm-active > i {
  color: #556ee6 !important;
}

@media (max-width: 992px) {
  .vertical-menu {
    display: none;
  }
  .main-content {
    margin-left: 0 !important;
  }
  body.sidebar-enable .vertical-menu {
    display: block;
  }
}
.vertical-collpsed .main-content {
  margin-left: 70px;
}
.vertical-collpsed .navbar-brand-box {
  width: 70px !important;
}
.vertical-collpsed #page-topbar {
  left: 70px;
}
@media (max-width: 991.98px) {
  .vertical-collpsed #page-topbar {
    left: 0;
  }
}
.vertical-collpsed .logo span.logo-lg {
  display: none;
}
.vertical-collpsed .logo span.logo-sm {
  display: block;
}
.vertical-collpsed .vertical-menu {
  position: absolute;
  width: 70px !important;
  z-index: 5;
}
.vertical-collpsed .vertical-menu .simplebar-mask,
.vertical-collpsed .vertical-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
.vertical-collpsed .vertical-menu .simplebar-scrollbar {
  display: none !important;
}
.vertical-collpsed .vertical-menu .simplebar-offset {
  bottom: 0 !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .menu-title,
.vertical-collpsed .vertical-menu #sidebar-menu .badge,
.vertical-collpsed .vertical-menu #sidebar-menu .collapse.in {
  display: none !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .nav.collapse {
  height: inherit !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .has-arrow:after {
  display: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li {
  position: relative;
  white-space: nowrap;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a {
  padding: 15px 20px;
  min-height: 55px;
  transition: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:active, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:focus {
  color: #383c40;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
  font-size: 1.45rem;
  margin-left: 4px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a span {
  display: none;
  padding-left: 25px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  position: relative;
  width: calc(190px + 70px);
  color: #556ee6;
  background-color: rgb(244.8, 244.8, 244.8);
  transition: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #556ee6;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a span {
  display: inline;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul {
  display: block;
  left: 70px;
  position: absolute;
  width: 190px;
  height: auto !important;
  box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul ul {
  box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
  color: #545a6d;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: #383c40;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
  padding: 5px 0;
  z-index: 9999;
  display: none;
  background-color: #ffffff;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li:hover > ul {
  display: block;
  left: 190px;
  height: auto !important;
  margin-top: -36px;
  position: absolute;
  width: 190px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li > a span.pull-right {
  position: absolute;
  right: 20px;
  top: 12px;
  transform: rotate(270deg);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li.active a {
  color: #f8f9fa;
}

body[data-sidebar=dark] .vertical-menu {
  background: #2a3042;
}
body[data-sidebar=dark] #sidebar-menu ul li a {
  color: #a6b0cf;
}
body[data-sidebar=dark] #sidebar-menu ul li a i {
  color: #6a7187;
}
body[data-sidebar=dark] #sidebar-menu ul li a:hover {
  color: #ffffff;
}
body[data-sidebar=dark] #sidebar-menu ul li a:hover i {
  color: #ffffff;
}
body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  color: #79829c;
}
body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed {
  min-height: 1760px;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu .navbar-brand-box {
  background: #2a3042;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background: rgb(45.9666666667, 52.5333333333, 72.2333333333);
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
  color: #79829c;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: #ffffff;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
  background-color: #2a3042;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active {
  color: #ffffff !important;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active > a {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active > a i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active > i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active .active {
  color: #ffffff !important;
}
body[data-sidebar=dark] .mm-active .active i {
  color: #ffffff !important;
}
body[data-sidebar=dark] .menu-title {
  color: #6a7187;
}

body[data-layout=horizontal] .main-content {
  margin-left: 0 !important;
}

body[data-sidebar-size=small] .navbar-brand-box {
  width: 160px;
}
body[data-sidebar-size=small] .vertical-menu {
  width: 160px;
  text-align: center;
}
body[data-sidebar-size=small] .vertical-menu .has-arrow:after,
body[data-sidebar-size=small] .vertical-menu .badge {
  display: none !important;
}
body[data-sidebar-size=small] .main-content {
  margin-left: 160px;
}
body[data-sidebar-size=small] .footer {
  left: 160px;
}
@media (max-width: 991.98px) {
  body[data-sidebar-size=small] .footer {
    left: 0;
  }
}
body[data-sidebar-size=small] #page-topbar {
  left: 160px;
}
@media (max-width: 991.98px) {
  body[data-sidebar-size=small] #page-topbar {
    left: 0;
  }
  body[data-sidebar-size=small] #page-topbar .navbar-header .navbar-brand-box {
    width: auto;
  }
}
body[data-sidebar-size=small] #sidebar-menu ul li a i {
  display: block;
}
body[data-sidebar-size=small] #sidebar-menu ul li ul.sub-menu li a {
  padding-left: 1.5rem;
}
body[data-sidebar-size=small] #sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding-left: 1.5rem;
}
body[data-sidebar-size=small].vertical-collpsed .main-content {
  margin-left: 70px;
}
body[data-sidebar-size=small].vertical-collpsed .vertical-menu #sidebar-menu {
  text-align: left;
}
body[data-sidebar-size=small].vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
  display: inline-block;
}
body[data-sidebar-size=small].vertical-collpsed .footer {
  left: 70px;
}

body[data-sidebar=colored] .navbar-brand-box .logo-dark,
body[data-sidebar=winter] .navbar-brand-box .logo-dark,
body[data-sidebar=ladylip] .navbar-brand-box .logo-dark,
body[data-sidebar=plumplate] .navbar-brand-box .logo-dark,
body[data-sidebar=strongbliss] .navbar-brand-box .logo-dark,
body[data-sidebar=greatwhale] .navbar-brand-box .logo-dark {
  display: none;
}
body[data-sidebar=colored] .navbar-brand-box .logo-light,
body[data-sidebar=winter] .navbar-brand-box .logo-light,
body[data-sidebar=ladylip] .navbar-brand-box .logo-light,
body[data-sidebar=plumplate] .navbar-brand-box .logo-light,
body[data-sidebar=strongbliss] .navbar-brand-box .logo-light,
body[data-sidebar=greatwhale] .navbar-brand-box .logo-light {
  display: block;
}
body[data-sidebar=colored] .mm-active,
body[data-sidebar=winter] .mm-active,
body[data-sidebar=ladylip] .mm-active,
body[data-sidebar=plumplate] .mm-active,
body[data-sidebar=strongbliss] .mm-active,
body[data-sidebar=greatwhale] .mm-active {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > a,
body[data-sidebar=winter] .mm-active > a,
body[data-sidebar=ladylip] .mm-active > a,
body[data-sidebar=plumplate] .mm-active > a,
body[data-sidebar=strongbliss] .mm-active > a,
body[data-sidebar=greatwhale] .mm-active > a {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > a i,
body[data-sidebar=winter] .mm-active > a i,
body[data-sidebar=ladylip] .mm-active > a i,
body[data-sidebar=plumplate] .mm-active > a i,
body[data-sidebar=strongbliss] .mm-active > a i,
body[data-sidebar=greatwhale] .mm-active > a i {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > i,
body[data-sidebar=colored] .mm-active .active,
body[data-sidebar=winter] .mm-active > i,
body[data-sidebar=winter] .mm-active .active,
body[data-sidebar=ladylip] .mm-active > i,
body[data-sidebar=ladylip] .mm-active .active,
body[data-sidebar=plumplate] .mm-active > i,
body[data-sidebar=plumplate] .mm-active .active,
body[data-sidebar=strongbliss] .mm-active > i,
body[data-sidebar=strongbliss] .mm-active .active,
body[data-sidebar=greatwhale] .mm-active > i,
body[data-sidebar=greatwhale] .mm-active .active {
  color: #fff !important;
}
body[data-sidebar=colored] #sidebar-menu ul li.menu-title,
body[data-sidebar=winter] #sidebar-menu ul li.menu-title,
body[data-sidebar=ladylip] #sidebar-menu ul li.menu-title,
body[data-sidebar=plumplate] #sidebar-menu ul li.menu-title,
body[data-sidebar=strongbliss] #sidebar-menu ul li.menu-title,
body[data-sidebar=greatwhale] #sidebar-menu ul li.menu-title {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li a,
body[data-sidebar=winter] #sidebar-menu ul li a,
body[data-sidebar=ladylip] #sidebar-menu ul li a,
body[data-sidebar=plumplate] #sidebar-menu ul li a,
body[data-sidebar=strongbliss] #sidebar-menu ul li a,
body[data-sidebar=greatwhale] #sidebar-menu ul li a {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li a i,
body[data-sidebar=winter] #sidebar-menu ul li a i,
body[data-sidebar=ladylip] #sidebar-menu ul li a i,
body[data-sidebar=plumplate] #sidebar-menu ul li a i,
body[data-sidebar=strongbliss] #sidebar-menu ul li a i,
body[data-sidebar=greatwhale] #sidebar-menu ul li a i {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li a.waves-effect .waves-ripple,
body[data-sidebar=winter] #sidebar-menu ul li a.waves-effect .waves-ripple,
body[data-sidebar=ladylip] #sidebar-menu ul li a.waves-effect .waves-ripple,
body[data-sidebar=plumplate] #sidebar-menu ul li a.waves-effect .waves-ripple,
body[data-sidebar=strongbliss] #sidebar-menu ul li a.waves-effect .waves-ripple,
body[data-sidebar=greatwhale] #sidebar-menu ul li a.waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.1);
}
body[data-sidebar=colored] #sidebar-menu ul li a:hover,
body[data-sidebar=winter] #sidebar-menu ul li a:hover,
body[data-sidebar=ladylip] #sidebar-menu ul li a:hover,
body[data-sidebar=plumplate] #sidebar-menu ul li a:hover,
body[data-sidebar=strongbliss] #sidebar-menu ul li a:hover,
body[data-sidebar=greatwhale] #sidebar-menu ul li a:hover {
  color: #fff;
}
body[data-sidebar=colored] #sidebar-menu ul li a:hover i,
body[data-sidebar=winter] #sidebar-menu ul li a:hover i,
body[data-sidebar=ladylip] #sidebar-menu ul li a:hover i,
body[data-sidebar=plumplate] #sidebar-menu ul li a:hover i,
body[data-sidebar=strongbliss] #sidebar-menu ul li a:hover i,
body[data-sidebar=greatwhale] #sidebar-menu ul li a:hover i {
  color: #fff;
}
body[data-sidebar=colored] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar=winter] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar=ladylip] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar=plumplate] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar=strongbliss] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar=greatwhale] #sidebar-menu ul li ul.sub-menu li a {
  color: rgba(255, 255, 255, 0.5);
}
body[data-sidebar=colored] #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=winter] #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=ladylip] #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=plumplate] #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=strongbliss] #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=greatwhale] #sidebar-menu ul li ul.sub-menu li a:hover {
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active {
  color: #556ee6 !important;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover {
  color: #556ee6;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active {
  color: #556ee6 !important;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a {
  color: #556ee6 !important;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i {
  color: #556ee6 !important;
}

.bg-colored {
  background-color: #556ee6 !important;
}

body[data-sidebar=colored] .vertical-menu {
  background-color: #556ee6;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-color: #556ee6;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: rgb(93.8923076923, 117.5846153846, 231.3076923077);
}
body[data-sidebar=colored][data-sidebar-size=small] .menu-title {
  background: transparent;
}

.vertical-menu [data-simplebar] {
  z-index: 9;
}

body[data-sidebar=winter] .vertical-menu {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x;
}
body[data-sidebar=winter].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x;
}
body[data-sidebar=winter].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x;
}
body[data-sidebar=winter][data-sidebar-size=small] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
}

body[data-sidebar=ladylip] .vertical-menu {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x;
}
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x;
}
body[data-sidebar=ladylip].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x;
}
body[data-sidebar=ladylip][data-sidebar-size=small] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
}

body[data-sidebar=plumplate] .vertical-menu {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
  background-repeat: repeat-x;
}
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
  background-repeat: repeat-x;
}
body[data-sidebar=plumplate].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
  background-repeat: repeat-x;
}
body[data-sidebar=plumplate][data-sidebar-size=small] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
}

body[data-sidebar=strongbliss] .vertical-menu {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
  background-repeat: repeat-x;
}
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
  background-repeat: repeat-x;
}
body[data-sidebar=strongbliss].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
  background-repeat: repeat-x;
}
body[data-sidebar=strongbliss][data-sidebar-size=small] .menu-title {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
}

body[data-sidebar=greatwhale] .vertical-menu {
  background-image: linear-gradient(to right, rgb(30.5769230769, 61.1538461538, 207.9230769231), #50a5f1);
  background-repeat: repeat-x;
}
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, rgb(30.5769230769, 61.1538461538, 207.9230769231), #50a5f1);
  background-repeat: repeat-x;
}
body[data-sidebar=greatwhale].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, rgb(30.5769230769, 61.1538461538, 207.9230769231), #50a5f1);
  background-repeat: repeat-x;
}
body[data-sidebar=greatwhale][data-sidebar-size=small] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #50a5f1);
}

.themesideimage {
  height: 80px;
  width: 40px;
}

body[data-sidebar-image] .vertical-menu:before {
  opacity: 0.33;
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
body[data-sidebar-image] .vertical-menu:after {
  opacity: 0.77;
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
body[data-sidebar-image] .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07;
}

body[data-sidebar-image=img1] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

body[data-sidebar-image=img2] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}

body[data-sidebar-image=img3] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

body[data-sidebar-image=img4] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.verticalcontent {
  writing-mode: vertical-rl;
  text-orientation: upright;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #343a40 !important;
}

.wh-30 {
  width: 30px;
  height: 30px;
}

.gradient-colored {
  background-color: #556ee6;
}

.gradient-winter {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x;
}

.gradient-lady-lip {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x;
}

.gradient-plum-plate {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
}

.gradient-strong-bliss {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
}

.gradient-strong-great-whale {
  background-image: linear-gradient(to right, rgb(40.5384615385, 72.0769230769, 223.4615384615), #50a5f1);
}

.topnav {
  background: #fff;
  padding: 0 calc(24px / 2);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
}
.topnav .topnav-menu {
  margin: 0;
  padding: 0;
}
.topnav .navbar-nav .nav-link {
  font-size: 14px;
  position: relative;
  padding: 1rem 1.3rem;
  color: #545a6d;
}
.topnav .navbar-nav .nav-link i {
  font-size: 15px;
}
.topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {
  color: #556ee6;
  background-color: transparent;
}
.topnav .navbar-nav .dropdown-item {
  color: #545a6d;
}
.topnav .navbar-nav .dropdown-item.active, .topnav .navbar-nav .dropdown-item:hover {
  color: #556ee6;
}
.topnav .navbar-nav .nav-item .nav-link.active {
  color: #556ee6;
}
.topnav .navbar-nav .dropdown.active > a {
  color: #556ee6;
  background-color: transparent;
}

body[data-layout=horizontal] #page-topbar {
  left: 0;
}

@media (min-width: 1200px) {
  body[data-layout=horizontal] .container-fluid, body[data-layout=horizontal] .container-sm, body[data-layout=horizontal] .container-md, body[data-layout=horizontal] .container-lg, body[data-layout=horizontal] .container-xl, body[data-layout=horizontal] .container-xxl,
  body[data-layout=horizontal] .navbar-header {
    max-width: 85%;
  }
}
@media (min-width: 992px) {
  .topnav .navbar-nav .nav-item:first-of-type .nav-link {
    padding-left: 0;
  }
  .topnav .dropdown-item {
    padding: 0.5rem 1.5rem;
    min-width: 180px;
  }
  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {
    left: 0px;
    right: auto;
  }
  .topnav .dropdown .dropdown-menu {
    margin-top: 0;
    border-radius: 0 0 0.25rem 0.25rem;
  }
  .topnav .dropdown .dropdown-menu .arrow-down::after {
    right: 15px;
    transform: rotate(-135deg) translateY(-50%);
    position: absolute;
  }
  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
    position: absolute;
    top: 0 !important;
    left: 100%;
    display: none;
  }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .navbar-toggle {
    display: none;
  }
}
.arrow-down {
  display: inline-block;
}
.arrow-down:after {
  border-color: initial;
  border-style: solid;
  border-width: 0 0 1px 1px;
  content: "";
  height: 0.4em;
  display: inline-block;
  right: 5px;
  top: 50%;
  margin-left: 10px;
  transform: rotate(-45deg) translateY(-50%);
  transform-origin: top;
  transition: all 0.3s ease-out;
  width: 0.4em;
}

@media (max-width: 1199.98px) {
  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {
    right: 100%;
    left: auto;
  }
}
@media (max-width: 991.98px) {
  .navbar-brand-box .logo-dark {
    display: block;
  }
  .navbar-brand-box .logo-dark span.logo-sm {
    display: block;
  }
  .navbar-brand-box .logo-light {
    display: none;
  }
  .topnav {
    max-height: 360px;
    overflow-y: auto;
    padding: 0;
  }
  .topnav .navbar-nav .nav-link {
    padding: 0.75rem 1.1rem;
  }
  .topnav .dropdown .dropdown-menu {
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding-left: 15px;
  }
  .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl {
    width: auto;
  }
  .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl .row {
    margin: 0px;
  }
  .topnav .dropdown .dropdown-item {
    position: relative;
    background-color: transparent;
  }
  .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {
    color: #556ee6;
  }
  .topnav .arrow-down::after {
    right: 15px;
    position: absolute;
  }
}
@media (min-width: 992px) {
  body[data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-dark {
    display: block;
  }
  body[data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-light {
    display: none;
  }
  body[data-layout=horizontal][data-topbar=light] .topnav {
    background-color: #556ee6;
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.6);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link:focus, body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link:hover {
    color: rgba(255, 255, 255, 0.9);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav > .dropdown.active > a {
    color: rgba(255, 255, 255, 0.9) !important;
  }
}
body[data-layout=horizontal][data-topbar=colored] #page-topbar {
  background-color: #556ee6;
  box-shadow: none;
}
body[data-layout=horizontal][data-topbar=colored] .logo-dark {
  display: none;
}
body[data-layout=horizontal][data-topbar=colored] .logo-light {
  display: block;
}
body[data-layout=horizontal][data-topbar=colored] .app-search .form-control {
  background-color: rgba(243, 243, 249, 0.07);
  color: #fff;
}
body[data-layout=horizontal][data-topbar=colored] .app-search span,
body[data-layout=horizontal][data-topbar=colored] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
body[data-layout=horizontal][data-topbar=colored] .header-item {
  color: #e9ecef;
}
body[data-layout=horizontal][data-topbar=colored] .header-item:hover {
  color: #e9ecef;
}
body[data-layout=horizontal][data-topbar=colored] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.1);
}
body[data-layout=horizontal][data-topbar=colored] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}
body[data-layout=horizontal][data-topbar=colored] .noti-icon i {
  color: #e9ecef;
}
@media (min-width: 992px) {
  body[data-layout=horizontal][data-topbar=colored] .topnav {
    background-color: #556ee6;
  }
  body[data-layout=horizontal][data-topbar=colored] .topnav .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.6);
  }
  body[data-layout=horizontal][data-topbar=colored] .topnav .navbar-nav .nav-link:focus, body[data-layout=horizontal][data-topbar=colored] .topnav .navbar-nav .nav-link:hover {
    color: rgba(255, 255, 255, 0.9);
  }
  body[data-layout=horizontal][data-topbar=colored] .topnav .navbar-nav > .dropdown.active > a {
    color: rgba(255, 255, 255, 0.9) !important;
  }
}

body[data-layout-size=boxed] {
  background-color: #ebebf4;
}
body[data-layout-size=boxed] #layout-wrapper {
  background-color: #f8f8fb;
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
body[data-layout-size=boxed] #page-topbar {
  max-width: calc(1300px - 250px);
  margin: 0 auto;
}
body[data-layout-size=boxed].vertical-collpsed #page-topbar {
  max-width: calc(1300px - 70px);
  margin: 0 auto;
}
body[data-layout-size=boxed].vertical-collpsed .main-content {
  min-height: 1760px;
}
body[data-layout-size=boxed][data-sidebar-size=small] #page-topbar {
  max-width: calc(1300px - 160px);
  left: 160px;
}
@media (max-width: 991.98px) {
  body[data-layout-size=boxed][data-sidebar-size=small] #page-topbar {
    left: 0;
  }
}
body[data-layout-size=boxed] .footer {
  margin: 0 auto;
  max-width: calc(1300px - 250px);
}
body[data-layout-size=boxed].vertical-collpsed .footer {
  max-width: calc(1300px - 70px);
}

body[data-layout=horizontal][data-layout-size=boxed] #page-topbar,
body[data-layout=horizontal][data-layout-size=boxed] #layout-wrapper,
body[data-layout=horizontal][data-layout-size=boxed] .footer {
  max-width: 100%;
}
body[data-layout=horizontal][data-layout-size=boxed] .container-fluid, body[data-layout=horizontal][data-layout-size=boxed] .container-sm, body[data-layout=horizontal][data-layout-size=boxed] .container-md, body[data-layout=horizontal][data-layout-size=boxed] .container-lg, body[data-layout=horizontal][data-layout-size=boxed] .container-xl, body[data-layout=horizontal][data-layout-size=boxed] .container-xxl,
body[data-layout=horizontal][data-layout-size=boxed] .navbar-header {
  max-width: 1300px;
}

@media (min-width: 992px) {
  body[data-layout-scrollable=true] #page-topbar,
  body[data-layout-scrollable=true] .vertical-menu,
  body[data-layout-scrollable=true] .navbar-brand-box {
    position: absolute;
  }
}
@media (min-width: 992px) {
  body[data-layout-scrollable=true][data-layout=horizontal] #page-topbar,
  body[data-layout-scrollable=true][data-layout=horizontal] .topnav {
    position: absolute;
  }
  body[data-layout-scrollable=true][data-layout=horizontal] .navbar-brand-box {
    position: relative;
  }
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(85, 110, 230, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(52, 195, 143, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(80, 165, 241, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(241, 180, 76, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(244, 106, 106, 0.4);
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #556ee6;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap;
}
.avatar-group .avatar-group-item {
  margin-left: -12px;
  border: 2px solid #fff;
  border-radius: 50%;
  transition: all 0.2s;
}
.avatar-group .avatar-group-item:hover {
  position: relative;
  transform: translateY(-2px);
}

.custom-accordion .accordion-list {
  display: flex;
  border-radius: 7px;
  background-color: #f6f6f6;
  padding: 12px 20px;
  color: #495057;
  font-weight: 600;
  align-items: center;
  justify-content: space-between;
}
.custom-accordion .accordion-list.collapsed i.accor-plus-icon:before {
  content: "\\f0415";
}
.custom-accordion .accordion-list .accor-plus-icon {
  display: inline-block;
  font-size: 16px;
  height: 24px;
  width: 24px;
  line-height: 22px;
  background-color: #fff;
  text-align: center;
  border-radius: 50%;
}
.custom-accordion a.collapsed i.accor-down-icon:before {
  content: "\\f0140";
}
.custom-accordion .card-body {
  color: #74788d;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.fw-medium {
  font-weight: 500;
}

.font-weight-semibold {
  font-weight: 600;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s;
}
.social-list-item:hover {
  color: #74788d;
  background-color: #eff2f7;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.alert-dismissible .btn-close {
  font-size: 10px;
  padding: 1.05rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_49___}) center/1em auto no-repeat;
}

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 9999;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

.spinner-chase {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  position: relative;
  animation: spinner-chase 2.5s infinite linear both;
}

.chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: chase-dot 2s infinite ease-in-out both;
}
.chase-dot:before {
  content: "";
  display: block;
  width: 25%;
  height: 25%;
  background-color: #556ee6;
  border-radius: 100%;
  animation: chase-dot-before 2s infinite ease-in-out both;
}
.chase-dot:nth-child(1) {
  animation-delay: -1.1s;
}
.chase-dot:nth-child(1):before {
  animation-delay: -1.1s;
}
.chase-dot:nth-child(2) {
  animation-delay: -1s;
}
.chase-dot:nth-child(2):before {
  animation-delay: -1s;
}
.chase-dot:nth-child(3) {
  animation-delay: -0.9s;
}
.chase-dot:nth-child(3):before {
  animation-delay: -0.9s;
}
.chase-dot:nth-child(4) {
  animation-delay: -0.8s;
}
.chase-dot:nth-child(4):before {
  animation-delay: -0.8s;
}
.chase-dot:nth-child(5) {
  animation-delay: -0.7s;
}
.chase-dot:nth-child(5):before {
  animation-delay: -0.7s;
}
.chase-dot:nth-child(6) {
  animation-delay: -0.6s;
}
.chase-dot:nth-child(6):before {
  animation-delay: -0.6s;
}

@keyframes spinner-chase {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes chase-dot {
  80%, 100% {
    transform: rotate(360deg);
  }
}
@keyframes chase-dot-before {
  50% {
    transform: scale(0.4);
  }
  100%, 0% {
    transform: scale(1);
  }
}
[type=tel]::placeholder,
[type=url]::placeholder,
[type=email]::placeholder,
[type=number]::placeholder {
  text-align: left;
}

.form-check {
  position: relative;
  text-align: left;
}

.form-check-right {
  padding-left: 0;
  display: inline-block;
  padding-right: 1.5em;
}
.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.5em;
}
.form-check-right .form-check-label {
  display: block;
}

.form-checkbox-outline .form-check-input {
  border-width: 2px;
  background-color: #fff;
}
.form-checkbox-outline .form-check-input:active {
  filter: none;
}
.form-checkbox-outline .form-check-input:checked {
  background-color: #fff !important;
}
.form-checkbox-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-checkbox-outline .form-check-input:checked:after {
  position: absolute;
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: -4px !important;
  left: 1px; /*rtl: -4px */
  font-size: 16px;
  color: #343a40;
}

.form-radio-outline .form-check-input {
  background-color: #fff;
  position: relative;
}
.form-radio-outline .form-check-input:active {
  filter: none;
}
.form-radio-outline .form-check-input:checked {
  background-color: #fff !important;
}
.form-radio-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-radio-outline .form-check-input:checked:after {
  position: absolute;
  content: "";
  top: 3px !important;
  left: 3px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
}

.form-check-primary .form-check-input:checked {
  background-color: #556ee6;
  border-color: #556ee6;
}

.form-radio-primary .form-check-input:checked {
  border-color: #556ee6;
  background-color: #556ee6;
}
.form-radio-primary .form-check-input:checked:after {
  background-color: #556ee6;
}

.form-check-secondary .form-check-input:checked {
  background-color: #74788d;
  border-color: #74788d;
}

.form-radio-secondary .form-check-input:checked {
  border-color: #74788d;
  background-color: #74788d;
}
.form-radio-secondary .form-check-input:checked:after {
  background-color: #74788d;
}

.form-check-success .form-check-input:checked {
  background-color: #34c38f;
  border-color: #34c38f;
}

.form-radio-success .form-check-input:checked {
  border-color: #34c38f;
  background-color: #34c38f;
}
.form-radio-success .form-check-input:checked:after {
  background-color: #34c38f;
}

.form-check-info .form-check-input:checked {
  background-color: #50a5f1;
  border-color: #50a5f1;
}

.form-radio-info .form-check-input:checked {
  border-color: #50a5f1;
  background-color: #50a5f1;
}
.form-radio-info .form-check-input:checked:after {
  background-color: #50a5f1;
}

.form-check-warning .form-check-input:checked {
  background-color: #f1b44c;
  border-color: #f1b44c;
}

.form-radio-warning .form-check-input:checked {
  border-color: #f1b44c;
  background-color: #f1b44c;
}
.form-radio-warning .form-check-input:checked:after {
  background-color: #f1b44c;
}

.form-check-danger .form-check-input:checked {
  background-color: #f46a6a;
  border-color: #f46a6a;
}

.form-radio-danger .form-check-input:checked {
  border-color: #f46a6a;
  background-color: #f46a6a;
}
.form-radio-danger .form-check-input:checked:after {
  background-color: #f46a6a;
}

.form-check-pink .form-check-input:checked {
  background-color: #e83e8c;
  border-color: #e83e8c;
}

.form-radio-pink .form-check-input:checked {
  border-color: #e83e8c;
  background-color: #e83e8c;
}
.form-radio-pink .form-check-input:checked:after {
  background-color: #e83e8c;
}

.form-check-light .form-check-input:checked {
  background-color: #eff2f7;
  border-color: #eff2f7;
}

.form-radio-light .form-check-input:checked {
  border-color: #eff2f7;
  background-color: #eff2f7;
}
.form-radio-light .form-check-input:checked:after {
  background-color: #eff2f7;
}

.form-check-dark .form-check-input:checked {
  background-color: #343a40;
  border-color: #343a40;
}

.form-radio-dark .form-check-input:checked {
  border-color: #343a40;
  background-color: #343a40;
}
.form-radio-dark .form-check-input:checked:after {
  background-color: #343a40;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 24px;
  line-height: 24px;
}
.form-switch-md .form-check-input {
  width: 40px;
  height: 20px;
  left: -0.5rem;
  position: relative;
}
.form-switch-md .form-check-label {
  vertical-align: middle;
}

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px;
}
.form-switch-lg .form-check-input {
  width: 48px;
  height: 24px;
  left: -0.75rem;
  position: relative;
}

.input-group-text {
  margin-bottom: 0px;
}

.rdl-filter,
.rdl-control {
  background-color: #fff;
  border-color: #ced4da;
  color: #495057;
}

.react-dual-listbox button {
  color: #343a40;
  border-color: #eff2f7;
  background-color: #eff2f7;
}
.react-dual-listbox input:disabled,
.react-dual-listbox select:disabled {
  background-color: #eff2f7;
}

.rdl-move:hover:not(:disabled), .rdl-move:active:not(:disabled), .rdl-move:focus:not(:disabled) {
  background-color: rgb(232.2, 236.475, 243.6);
  border-color: #eff2f7;
}

.css-1uccc91-singleValue {
  color: #495057 !important;
}

.react-kanban-column {
  background-color: #eff2f7 !important;
}

.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative;
}
.mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
  content: "";
  position: absolute;
  width: 8px;
  height: 54px;
  background-color: rgba(255, 255, 255, 0.1);
  left: 16px;
  transform: rotate(32deg);
  top: -5px;
  transition: all 0.4s;
}
.mini-stats-wid .mini-stat-icon::after {
  left: -12px;
  width: 12px;
  transition: all 0.2s;
}
.mini-stats-wid:hover .mini-stat-icon::after {
  left: 60px;
}

.button-items {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-items .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.mfp-popup-form {
  max-width: 1140px;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

[dir=rtl] .modal-open {
  padding-left: 0px !important;
}

.icon-demo-content {
  text-align: center;
  color: #adb5bd;
}
.icon-demo-content i {
  display: block;
  font-size: 24px;
  margin-bottom: 16px;
  color: #74788d;
  transition: all 0.4s;
}
.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}
.icon-demo-content .col-lg-4:hover i {
  color: #556ee6;
  transform: scale(1.5);
}

.grid-structure .grid-container {
  background-color: #f8f9fa;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px;
}

.card-radio {
  background-color: #fff;
  border: 2px solid #f6f6f6;
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card-radio:hover {
  cursor: pointer;
}

.card-radio-label {
  display: block;
}

.card-radio-input {
  display: none;
}
.card-radio-input:checked + .card-radio {
  border-color: #556ee6 !important;
}

.navs-carousel .owl-nav {
  margin-top: 16px;
}
.navs-carousel .owl-nav button {
  width: 30px;
  height: 30px;
  line-height: 28px !important;
  font-size: 20px !important;
  border-radius: 50% !important;
  background-color: rgba(85, 110, 230, 0.25) !important;
  color: #556ee6 !important;
  margin: 4px 8px !important;
}

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .footer {
    display: none !important;
  }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    border: 0;
  }
}
[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 4px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

/* ==============
  Calendar
===================*/
.lnb-calendars-item {
  display: inline-block;
  margin-right: 7px;
}

input[type=checkbox].tui-full-calendar-checkbox-round + span {
  margin-right: 4px;
  margin-left: 0;
}

.tui-full-calendar-layout, .tui-full-calendar-timegrid-timezone {
  background-color: #fff !important;
}

.tui-full-calendar-dayname-container,
.tui-full-calendar-left,
.tui-full-calendar-splitter,
.tui-full-calendar-time-date,
.tui-full-calendar-weekday-grid-line,
.tui-full-calendar-timegrid-timezone,
.tui-full-calendar-timegrid-gridline {
  border-color: #f6f6f6 !important;
}

.tui-full-calendar-weekday-exceed-in-week {
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 28px;
  border-radius: 4px;
  background-color: #fff;
  color: #495057;
  border-color: #eff2f7;
}

.tui-full-calendar-timegrid-hour {
  color: #495057 !important;
}

.tui-full-calendar-weekday-schedule-title, .tui-full-calendar-time-schedule {
  font-weight: 600;
}

/* ==============
  Druafula
===================*/
.task-box {
  border: 1px solid #f6f6f6;
}

.gu-transit {
  border: 1px dashed #74788d !important;
  background-color: #eff2f7 !important;
}

#session-timeout-dialog .close {
  display: none;
}
#session-timeout-dialog .countdown-holder {
  color: #f46a6a;
  font-weight: 500;
}
#session-timeout-dialog .btn-default {
  background-color: #fff;
  color: #f46a6a;
  box-shadow: none;
}

.irs {
  font-family: var(--bs-font-sans-serif);
}

.irs--square .irs-bar, .irs--square .irs-to, .irs--square .irs-from, .irs--square .irs-single {
  background: #556ee6 !important;
  font-size: 11px;
}
.irs--square .irs-to:before, .irs--square .irs-from:before, .irs--square .irs-single:before {
  border-top-color: #556ee6;
}
.irs--square .irs-line {
  background: #f6f6f6;
  border-color: #f6f6f6;
}
.irs--square .irs-grid-text {
  font-size: 11px;
  color: #ced4da;
}
.irs--square .irs-min, .irs--square .irs-max {
  color: #ced4da;
  background: #f6f6f6;
  font-size: 11px;
}
.irs--square .irs-handle {
  border: 2px solid #556ee6;
  width: 12px;
  height: 12px;
  top: 26px;
  background-color: #fff !important;
}

.swal2-container .swal2-title {
  font-size: 20px;
  font-weight: 500;
}

.swal2-modal {
  font-size: 14px;
}

.swal2-icon.swal2-question {
  border-color: #50a5f1;
  color: #50a5f1;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #34c38f;
}
.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(52, 195, 143, 0.3);
}
.swal2-icon.swal2-warning {
  border-color: #f1b44c;
  color: #f1b44c;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-progress-steps .swal2-progress-step {
  background: #556ee6;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #556ee6;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(85, 110, 230, 0.3);
}
.swal2-progress-steps .swal2-progress-step-line {
  background: #556ee6;
}

.swal2-loader {
  border-color: #556ee6 transparent #556ee6 transparent;
}

.sweet-alert {
  color: #495057 !important;
}
.sweet-alert h2, .sweet-alert .h2 {
  color: rgba(0, 0, 0, 0.6) !important;
}

.symbol {
  border-color: #fff;
}

.rating-symbol-background, .rating-symbol-foreground {
  font-size: 24px;
}

.rating-symbol-foreground {
  top: 0px;
}

.rating-star > span {
  display: inline-block;
  vertical-align: middle;
}
.rating-star > span.badge {
  margin-left: 4px;
}

/* =============
   Notification
============= */
#toast-container > div {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  opacity: 1;
}
#toast-container > div:hover {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  opacity: 0.9;
}
#toast-container.toast-top-full-width > div, #toast-container.toast-bottom-full-width > div {
  min-width: 96%;
  margin: 4px auto;
}

.toast-primary {
  border: 2px solid #556ee6 !important;
  background-color: rgba(85, 110, 230, 0.8) !important;
}

.toast-secondary {
  border: 2px solid #74788d !important;
  background-color: rgba(116, 120, 141, 0.8) !important;
}

.toast-success {
  border: 2px solid #34c38f !important;
  background-color: rgba(52, 195, 143, 0.8) !important;
}

.toast-info {
  border: 2px solid #50a5f1 !important;
  background-color: rgba(80, 165, 241, 0.8) !important;
}

.toast-warning {
  border: 2px solid #f1b44c !important;
  background-color: rgba(241, 180, 76, 0.8) !important;
}

.toast-danger {
  border: 2px solid #f46a6a !important;
  background-color: rgba(244, 106, 106, 0.8) !important;
}

.toast-pink {
  border: 2px solid #e83e8c !important;
  background-color: rgba(232, 62, 140, 0.8) !important;
}

.toast-light {
  border: 2px solid #eff2f7 !important;
  background-color: rgba(239, 242, 247, 0.8) !important;
}

.toast-dark {
  border: 2px solid #343a40 !important;
  background-color: rgba(52, 58, 64, 0.8) !important;
}

.toast-error {
  background-color: rgba(244, 106, 106, 0.8);
  border: 2px solid #f46a6a;
}

.toastr-options {
  padding: 24px;
  background-color: rgb(245.8, 247.525, 250.4);
  margin-bottom: 0;
  border: 1px solid #eff2f7;
}

.error {
  color: #f46a6a;
}

.parsley-error {
  border-color: #f46a6a;
}

.parsley-errors-list {
  display: none;
  margin: 0;
  padding: 0;
}
.parsley-errors-list.filled {
  display: block;
}
.parsley-errors-list > li {
  font-size: 12px;
  list-style: none;
  color: #f46a6a;
  margin-top: 5px;
}

.select2-container .select2-selection--single {
  background-color: #fff;
  border: 1px solid #ced4da;
  height: 38px;
}
.select2-container .select2-selection--single:focus {
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 0.75rem;
  color: #495057;
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  right: 3px;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: #adb5bd transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}
.select2-container .select2-selection--single .select2-selection__placeholder {
  color: #495057;
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent #adb5bd transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: #fff;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  border: 1px solid #ced4da;
  background-color: #fff;
  color: #74788d;
  outline: none;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #556ee6;
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: #f8f9fa;
  color: #343a40;
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: #556ee6;
  color: #fff;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-container[dir=rtl] .select2-selection--single .select2-selection__rendered {
  padding-left: 0.75rem;
}

.select2-dropdown {
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #fff;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}

.select2-search input {
  border: 1px solid #f6f6f6;
}

.select2-container .select2-selection--multiple {
  min-height: 38px;
  background-color: #fff;
  border: 1px solid #ced4da !important;
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 2px 0.75rem;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: #495057;
}
.select2-container .select2-selection--multiple .select2-search__field::placeholder {
  color: #495057;
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #eff2f7;
  border: 1px solid #f6f6f6;
  border-radius: 1px;
  padding: 0 7px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #ced4da;
}
.select2-container--default .select2-results__group {
  font-weight: 600;
}

.select2-result-repository__avatar {
  float: left;
  width: 60px;
  margin-right: 10px;
}
.select2-result-repository__avatar img {
  width: 100%;
  height: auto;
  border-radius: 2px;
}

.select2-result-repository__statistics {
  margin-top: 7px;
}

.select2-result-repository__forks,
.select2-result-repository__stargazers,
.select2-result-repository__watchers {
  display: inline-block;
  font-size: 11px;
  margin-right: 1em;
  color: #adb5bd;
}
.select2-result-repository__forks .fa,
.select2-result-repository__stargazers .fa,
.select2-result-repository__watchers .fa {
  margin-right: 4px;
}
.select2-result-repository__forks .fa.fa-flash::before,
.select2-result-repository__stargazers .fa.fa-flash::before,
.select2-result-repository__watchers .fa.fa-flash::before {
  content: "\\f0e7";
  font-family: "Font Awesome 5 Free";
}

.select2-results__option--highlighted .select2-result-repository__forks,
.select2-results__option--highlighted .select2-result-repository__stargazers,
.select2-results__option--highlighted .select2-result-repository__watchers {
  color: rgba(255, 255, 255, 0.8);
}

.select2-result-repository__meta {
  overflow: hidden;
}

.img-flag {
  margin-right: 7px;
  height: 15px;
  width: 18px;
}

.select2-selection__control {
  background-color: #fff !important;
  border-color: #ced4da !important;
}

.select2-selection__indicator-separator {
  background-color: #ced4da !important;
}

.select2-selection__indicator svg {
  fill: #495057 !important;
}

.select2-selection__placeholder {
  color: #74788d !important;
}

.select2-selection__menu {
  background-color: #fff !important;
}

/* CSS Switch */
input[switch] {
  display: none;
}
input[switch] + label {
  font-size: 1em;
  line-height: 1;
  width: 56px;
  height: 24px;
  background-color: #ced4da;
  background-image: none;
  border-radius: 2rem;
  padding: 0.16667rem;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  position: relative;
  font-weight: 500;
  transition: all 0.1s ease-in-out;
}
input[switch] + label:before {
  color: #343a40;
  content: attr(data-off-label);
  display: block;
  font-family: inherit;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  position: absolute;
  right: 1px;
  margin: 3px;
  top: -2px;
  text-align: center;
  min-width: 1.66667rem;
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}
input[switch] + label:after {
  content: "";
  position: absolute;
  left: 3px;
  background-color: #eff2f7;
  box-shadow: none;
  border-radius: 2rem;
  height: 20px;
  width: 20px;
  top: 2px;
  transition: all 0.1s ease-in-out;
}
input[switch]:checked + label {
  background-color: #556ee6;
}

input[switch]:checked + label {
  background-color: #556ee6;
}
input[switch]:checked + label:before {
  color: #fff;
  content: attr(data-on-label);
  right: auto;
  left: 3px;
}
input[switch]:checked + label:after {
  left: 33px;
  background-color: #eff2f7;
}

input[switch=bool] + label {
  background-color: #f46a6a;
}

input[switch=bool] + label:before, input[switch=bool]:checked + label:before,
input[switch=default]:checked + label:before {
  color: #fff;
}

input[switch=bool]:checked + label {
  background-color: #34c38f;
}

input[switch=default]:checked + label {
  background-color: #a2a2a2;
}

input[switch=primary]:checked + label {
  background-color: #556ee6;
}

input[switch=success]:checked + label {
  background-color: #34c38f;
}

input[switch=info]:checked + label {
  background-color: #50a5f1;
}

input[switch=warning]:checked + label {
  background-color: #f1b44c;
}

input[switch=danger]:checked + label {
  background-color: #f46a6a;
}

input[switch=dark]:checked + label {
  background-color: #343a40;
}
input[switch=dark]:checked + label:before {
  color: #eff2f7;
}

.square-switch {
  margin-right: 7px;
}
.square-switch input[switch] + label, .square-switch input[switch] + label:after {
  border-radius: 4px;
}

.sp-container {
  background-color: #fff;
}
.sp-container button {
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem;
  font-weight: 400;
  color: #343a40;
}
.sp-container button.sp-palette-toggle {
  background-color: #eff2f7;
}
.sp-container button.sp-choose {
  background-color: #34c38f;
  margin-left: 5px;
  margin-right: 0;
}

.sp-palette-container {
  border-right: 1px solid #eff2f7;
}

.sp-input {
  background-color: #fff;
  border-color: #ced4da !important;
  color: #495057;
}
.sp-input:focus {
  outline: none;
}

[dir=rtl] .sp-alpha {
  direction: ltr;
}
[dir=rtl] .sp-original-input-container .sp-add-on {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
[dir=rtl] input.spectrum.with-add-on {
  border: 1px solid #ced4da;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

/* Timepicker */
.bootstrap-timepicker-widget table td a {
  color: #495057;
}
.bootstrap-timepicker-widget table td a:hover {
  background-color: transparent;
  border-color: transparent;
  border-radius: 4px;
  color: #556ee6;
  text-decoration: none;
}
.bootstrap-timepicker-widget table td input {
  width: 32px;
  height: 32px;
  border: 0;
  color: #495057;
  border: 1px solid #eff2f7;
  background-color: #fff;
}
.bootstrap-timepicker-widget.dropdown-menu:after {
  border-bottom-color: #eff2f7;
}
.bootstrap-timepicker-widget.timepicker-orient-bottom:after {
  border-top-color: #eff2f7;
}

.timepicker-orient-top {
  top: calc(1.5em + 0.94rem + 2px) !important;
}

.timepicker-orient-bottom {
  top: auto !important;
  bottom: calc(1.5em + 0.94rem + 2px) !important;
}

.bootstrap-timepicker-widget {
  left: 0 !important;
  right: auto !important;
}

.bootstrap-timepicker-widget.timepicker-orient-left:before {
  left: 6px;
  right: auto;
}
.bootstrap-timepicker-widget.timepicker-orient-left::after {
  left: 7px;
  right: auto;
}

[dir=rtl] .datepicker {
  right: 0 !important;
  left: auto;
}

.datepicker {
  border: 1px solid #eff2f7;
  padding: 8px;
  z-index: 999 !important;
}
.datepicker table tr th {
  font-weight: 500;
}
.datepicker table tr td.active, .datepicker table tr td.active:hover, .datepicker table tr td .active.disabled, .datepicker table tr td.active.disabled:hover, .datepicker table tr td.today, .datepicker table tr td.today:hover, .datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:hover, .datepicker table tr td.selected, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.disabled, .datepicker table tr td.selected.disabled:hover,
.datepicker table tr td span.active.active, .datepicker table tr td span.active:hover.active {
  background-color: #556ee6 !important;
  background-image: none;
  box-shadow: none;
  color: #fff !important;
}
.datepicker table tr td.day.focused, .datepicker table tr td.day:hover,
.datepicker table tr td span.focused,
.datepicker table tr td span:hover {
  background: #eff2f7;
}
.datepicker table tr td.new, .datepicker table tr td.old,
.datepicker table tr td span.new,
.datepicker table tr td span.old {
  color: #adb5bd;
  opacity: 0.6;
}
.datepicker table tr td.range, .datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:hover, .datepicker table tr td.range:hover {
  background-color: #f6f6f6;
}

.table-condensed > thead > tr > th, .table-condensed > tbody > tr > td {
  padding: 7px;
}

.bootstrap-datepicker-inline .datepicker-inline {
  width: auto !important;
  display: inline-block;
}

.datepicker-container {
  border: 1px solid #eff2f7;
  box-shadow: none;
  background-color: #fff;
}
.datepicker-container.datepicker-inline {
  width: 212px;
}

.datepicker-panel > ul > li {
  background-color: #fff;
  border-radius: 4px;
}
.datepicker-panel > ul > li.picked, .datepicker-panel > ul > li.picked:hover {
  background-color: rgba(85, 110, 230, 0.25);
  color: #556ee6;
}
.datepicker-panel > ul > li.highlighted, .datepicker-panel > ul > li.highlighted:hover, .datepicker-panel > ul > li:hover {
  background-color: #556ee6;
  color: #fff;
}
.datepicker-panel > ul > li.muted, .datepicker-panel > ul > li.muted:hover {
  color: #adb5bd;
  opacity: 0.6;
}
.datepicker-panel > ul[data-view=week] > li {
  font-weight: 500;
}
.datepicker-panel > ul[data-view=week] > li, .datepicker-panel > ul[data-view=week] > li:hover {
  background-color: #fff;
}

.bootstrap-touchspin.input-group > .input-group-prepend > .btn, .bootstrap-touchspin.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.bootstrap-touchspin.input-group > .input-group-append > .btn, .bootstrap-touchspin.input-group > .input-group-append > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.tox-tinymce {
  border: 1px solid #ced4da !important;
}

.tox .tox-statusbar {
  border-top: 1px solid #eff2f7 !important;
}
.tox .tox-menubar, .tox .tox-edit-area__iframe, .tox .tox-statusbar {
  background-color: #fff !important;
  background: none !important;
}
.tox .tox-mbtn {
  color: #495057 !important;
}
.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background-color: #eff2f7 !important;
}
.tox .tox-tbtn:hover {
  background-color: #eff2f7 !important;
}
.tox .tox-toolbar, .tox .tox-toolbar__overflow, .tox .tox-toolbar__primary {
  background: #eff2f7 !important;
}
.tox .tox-toolbar__primary {
  border-top-color: #eff2f7 !important;
}
.tox .tox-tbtn {
  color: #495057 !important;
}
.tox .tox-tbtn svg {
  fill: #495057 !important;
}
.tox .tox-edit-area__iframe {
  background-color: #fff !important;
}
.tox .tox-statusbar a, .tox .tox-statusbar__path-item, .tox .tox-statusbar__wordcount {
  color: #495057 !important;
}
.tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
  border-right: 1px solid rgb(222, 228.1875, 238.5) !important;
}

.editable-input .form-control {
  display: inline-block;
}

.editable-buttons {
  margin-left: 7px;
}
.editable-buttons .editable-cancel {
  margin-left: 7px;
}

/* Dropzone */
.dropzone {
  min-height: 230px;
  border: 2px dashed #ced4da;
  background: #fff;
  border-radius: 6px;
}
.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
}
.dropzone .dz-message:focus {
  outline: none;
}

.form-wizard-wrapper label {
  font-size: 14px;
  text-align: right;
}

.wizard .steps > ul {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
@media (max-width: 1199.98px) {
  .wizard .steps > ul {
    flex-direction: column;
  }
}
.wizard .steps > ul > a, .wizard .steps > ul > li {
  flex-basis: 0;
  flex-grow: 1;
}
.wizard .steps > ul > li {
  width: 100%;
}
.wizard .steps > ul > li a {
  display: block;
  padding: 0.5rem 1rem;
  color: #495057;
  font-weight: 500;
  background-color: rgba(85, 110, 230, 0.1);
}
.wizard .steps > ul .current-info {
  position: absolute;
  left: -999em;
}
.wizard .steps .number {
  display: inline-block;
  width: 38px;
  height: 38px;
  line-height: 34px;
  border: 2px solid #556ee6;
  color: #556ee6;
  text-align: center;
  border-radius: 50%;
  margin-right: 0.5rem;
}
.wizard .steps .current a, .wizard .steps .current a:active, .wizard .steps .current a:hover {
  background-color: rgba(85, 110, 230, 0.2);
  color: #495057;
}
.wizard .steps .current a .number, .wizard .steps .current a:active .number, .wizard .steps .current a:hover .number {
  background-color: #556ee6;
  color: #fff;
}
.wizard > .content {
  background-color: transparent;
  padding: 14px;
  margin-top: 0;
  border-radius: 0;
  min-height: 150px;
}
.wizard > .content > .title {
  position: absolute;
  left: -999em;
}
.wizard > .content > .body {
  width: 100%;
  height: 100%;
  padding: 14px 0 0;
  position: static;
}
.wizard > .actions {
  position: relative;
  display: block;
  text-align: right;
  width: 100%;
}
.wizard > .actions > ul {
  display: block;
  text-align: right;
  padding-left: 0;
}
.wizard > .actions > ul > li {
  display: inline-block;
  margin: 0 0.5em;
}
.wizard > .actions a, .wizard > .actions a:active, .wizard > .actions a:hover {
  background-color: #556ee6;
  border-radius: 4px;
  padding: 8px 15px;
  color: #fff;
}
.wizard > .actions .disabled a, .wizard > .actions .disabled a:active, .wizard > .actions .disabled a:hover {
  opacity: 0.65;
  background-color: #556ee6;
  color: #fff;
  cursor: not-allowed;
}
.wizard.vertical-wizard {
  display: flex;
  flex-wrap: wrap;
}
.wizard.vertical-wizard .steps > ul {
  flex-direction: column;
}
.wizard.vertical-wizard .steps > ul > li {
  width: 100% !important;
}
.wizard.vertical-wizard .steps, .wizard.vertical-wizard .content, .wizard.vertical-wizard .actions {
  width: 100%;
}
@media (min-width: 1200px) {
  .wizard.vertical-wizard .steps {
    width: 25%;
  }
}
.wizard.vertical-wizard .content {
  padding: 24px;
}
@media (min-width: 1200px) {
  .wizard.vertical-wizard .content {
    width: 75%;
    padding: 12px 24px;
  }
}
.wizard.vertical-wizard .content > .body {
  padding: 0;
}

/* 
Datatable
*/
div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}
@media (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_filter {
    text-align: center;
  }
}
div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  margin-right: 0;
}

.table.dataTable.dtr-inline.collapsed > tbody > tr > td, table.dataTable.dtr-inline.collapsed > tbody > tr > td {
  position: relative;
}
.table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control {
  padding-left: 30px;
}
.table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before {
  top: 50%;
  left: 5px;
  height: 14px;
  width: 14px;
  margin-top: -9px;
  display: block;
  position: absolute;
  color: #fff;
  border: 2px solid #fff;
  border-radius: 14px;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  line-height: 14px;
  content: "+";
  background-color: #556ee6;
}

.table-rep-plugin .btn-toolbar {
  display: block;
}
.table-rep-plugin .table-responsive {
  border: none !important;
}
.table-rep-plugin .btn-group .btn-default {
  background-color: #74788d;
  color: #eff2f7;
  border: 1px solid #74788d;
}
.table-rep-plugin .btn-group .btn-default.btn-primary {
  background-color: #556ee6;
  border-color: #556ee6;
  color: #fff;
  box-shadow: 0 0 0 2px rgba(85, 110, 230, 0.5);
}
.table-rep-plugin .btn-group.pull-right {
  float: right;
}
.table-rep-plugin .btn-group.pull-right .dropdown-menu {
  right: 0;
  transform: none !important;
  top: 100% !important;
}
.table-rep-plugin tbody th {
  font-size: 14px;
  font-weight: normal;
}
.table-rep-plugin .checkbox-row {
  padding-left: 40px;
  color: #495057 !important;
}
.table-rep-plugin .checkbox-row:hover {
  background-color: rgb(245.8, 247.525, 250.4) !important;
}
.table-rep-plugin .checkbox-row label {
  display: inline-block;
  padding-left: 5px;
  position: relative;
}
.table-rep-plugin .checkbox-row label::before {
  -o-transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #f6f6f6;
  content: "";
  display: inline-block;
  height: 17px;
  left: 0;
  margin-left: -20px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 17px;
  outline: none !important;
}
.table-rep-plugin .checkbox-row label::after {
  color: #eff2f7;
  display: inline-block;
  font-size: 11px;
  height: 16px;
  left: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 1px;
  position: absolute;
  top: -1px;
  width: 16px;
}
.table-rep-plugin .checkbox-row input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
  outline: none;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:disabled + label::before {
  background-color: #f8f9fa;
  cursor: not-allowed;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::before {
  background-color: #556ee6;
  border-color: #556ee6;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::after {
  color: #fff;
}
.table-rep-plugin .fixed-solution .sticky-table-header {
  top: 70px !important;
  background-color: #556ee6;
}
.table-rep-plugin .fixed-solution .sticky-table-header table {
  color: #fff;
}
.table-rep-plugin table.focus-on tbody tr.focused th,
.table-rep-plugin table.focus-on tbody tr.focused td,
.table-rep-plugin .sticky-table-header {
  background: #556ee6;
  border-color: #556ee6;
  color: #fff;
}
.table-rep-plugin table.focus-on tbody tr.focused th table,
.table-rep-plugin table.focus-on tbody tr.focused td table,
.table-rep-plugin .sticky-table-header table {
  color: #fff;
}

@media (min-width: 992px) {
  body[data-layout=horizontal] .fixed-solution .sticky-table-header {
    top: 120px !important;
  }
}

a.btn.btn-primary {
  display: flex !important;
  align-items: center !important;
}

.table-edits input, .table-edits select {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  background-color: #fff;
  color: #495057;
  border-radius: 0.25rem;
}
.table-edits input:focus, .table-edits select:focus {
  outline: none;
  border-color: rgb(185.4, 190.8, 196.2);
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: #adb5bd;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-legend-series {
  font-weight: 500;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: #f8f9fa;
}

.apexcharts-legend-text {
  color: #74788d !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-size: 13px !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: #adb5bd;
}

.e-charts {
  height: 350px;
}

/* Flot chart */
.flot-charts-height {
  height: 320px;
}

.flotTip {
  padding: 8px 12px;
  background-color: rgba(52, 58, 64, 0.9);
  z-index: 100;
  color: #f8f9fa;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border-radius: 4px;
}

.legendLabel {
  color: #adb5bd;
}

.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #343a40 !important;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  padding: 5px 10px !important;
  border-radius: 3px;
  border-color: #212529 !important;
}

.jqsfield {
  color: #eff2f7 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-weight: 500 !important;
}

.gmaps, .gmaps-panaroma {
  height: 300px !important;
  background: #f8f9fa;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #556ee6;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #556ee6;
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #556ee6;
}

.jvectormap-label {
  border: none;
  background: #343a40;
  color: #f8f9fa;
  font-family: var(--bs-font-sans-serif);
  font-size: 0.8125rem;
  padding: 5px 8px;
}

.leaflet-map {
  height: 300px;
}
.leaflet-map.leaflet-container {
  z-index: 99;
}

.home-btn {
  position: absolute;
  top: 15px;
  right: 25px;
}

.auth-logo .auth-logo-dark {
  display: block;
}
.auth-logo .auth-logo-light {
  display: none;
}

.auth-body-bg {
  background-color: #fff;
}

.auth-pass-inputgroup input[type=input] + .btn .mdi-eye-outline:before {
  content: "\\f06d1";
}

.auth-full-bg {
  background-color: rgba(85, 110, 230, 0.25);
  display: flex;
}
@media (min-width: 1200px) {
  .auth-full-bg {
    height: 100vh;
  }
}
.auth-full-bg::before {
  content: "";
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}
.auth-full-bg .bg-overlay {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.auth-full-page-content {
  display: flex;
}
@media (min-width: 1200px) {
  .auth-full-page-content {
    min-height: 100vh;
  }
}

.auth-review-carousel.owl-theme .owl-dots .owl-dot span {
  background-color: rgba(85, 110, 230, 0.25);
}
.auth-review-carousel.owl-theme .owl-dots .owl-dot.active span, .auth-review-carousel.owl-theme .owl-dots .owl-dot:hover span {
  background-color: #556ee6;
}

.search-box .form-control {
  border-radius: 30px;
  padding-left: 40px;
}
.search-box .search-icon {
  font-size: 16px;
  position: absolute;
  left: 13px;
  top: 0;
  line-height: 38px;
}

.product-list li a {
  display: block;
  padding: 4px 0px;
  color: #495057;
}

.product-view-nav.nav-pills .nav-item {
  margin-left: 4px;
}
.product-view-nav.nav-pills .nav-link {
  width: 36px;
  height: 36px;
  font-size: 16px;
  padding: 0;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
}

.product-ribbon {
  position: absolute;
  right: 0px;
  top: 0px;
}

.product-detai-imgs .nav .nav-link {
  margin: 7px 0px;
}
.product-detai-imgs .nav .nav-link.active {
  background-color: #f6f6f6;
}

.product-color a {
  display: inline-block;
  text-align: center;
  color: #495057;
}
.product-color a .product-color-item {
  margin: 7px;
}
.product-color a.active, .product-color a:hover {
  color: #556ee6;
}
.product-color a.active .product-color-item, .product-color a:hover .product-color-item {
  border-color: #556ee6 !important;
}

.visa-card .visa-logo {
  line-height: 0.5;
}
.visa-card .visa-pattern {
  position: absolute;
  font-size: 385px;
  color: rgba(255, 255, 255, 0.05);
  line-height: 0.4;
  right: 0px;
  bottom: 0px;
}

.checkout-tabs .nav-pills .nav-link {
  margin-bottom: 24px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
.checkout-tabs .nav-pills .nav-link.active {
  background-color: #556ee6;
}
.checkout-tabs .nav-pills .nav-link .check-nav-icon {
  font-size: 36px;
}

/* ==============
  Email
===================*/
.email-leftbar {
  width: 236px;
  float: left;
  padding: 20px;
  border-radius: 5px;
}

.email-rightbar {
  margin-left: 260px;
}

.chat-user-box p.user-title {
  color: #343a40;
  font-weight: 500;
}
.chat-user-box p {
  font-size: 12px;
}

@media (max-width: 767px) {
  .email-leftbar {
    float: none;
    width: 100%;
  }
  .email-rightbar {
    margin: 0;
  }
}
.mail-list a {
  display: block;
  color: #74788d !important;
  line-height: 24px;
  padding: 8px 5px;
}
.mail-list a.active {
  color: #f46a6a !important;
  font-weight: 500;
}

.mail-list .nav-tabs-custom .nav-item .nav-link::after {
  content: none;
}

.message-list {
  display: block;
  padding-left: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
}
.message-list li a {
  color: #74788d;
}
.message-list li:hover {
  background: #f6f6f6;
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 320px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}
.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 110px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 170px;
  padding-left: 80px;
}
.message-list li.active, .message-list li.active:hover {
  box-shadow: inset 3px 0 0 #556ee6;
}
.message-list li.unread {
  background-color: #f6f6f6;
  font-weight: 500;
  color: rgb(40.5689655172, 45.25, 49.9310344828);
}
.message-list li.unread a {
  color: rgb(40.5689655172, 45.25, 49.9310344828);
  font-weight: 500;
}
.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  box-shadow: inset 0 0 0 1px #ced4da;
  border-radius: 1px;
}
.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}
.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}
.message-list .checkbox-wrapper-mail label {
  position: absolute;
  height: 20px;
  width: 20px;
  left: 0;
  cursor: pointer;
  opacity: 0;
  margin-bottom: 0;
  transition-duration: 0.05s;
  top: 0;
}
.message-list .checkbox-wrapper-mail label:before {
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: 0;
  height: 20px;
  color: rgb(40.5689655172, 45.25, 49.9310344828);
  width: 20px;
  position: absolute;
  margin-top: -16px;
  left: 4px;
  font-size: 13px;
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px;
  }
}
@media (min-width: 1200px) {
  .filemanager-sidebar {
    min-width: 230px;
    max-width: 230px;
  }
}
@media (min-width: 1366px) {
  .filemanager-sidebar {
    min-width: 280px;
    max-width: 280px;
  }
}

.categories-list {
  padding: 4px 0;
}
.categories-list li a {
  display: block;
  padding: 8px 12px;
  color: #495057;
  font-weight: 500;
}
.categories-list li.active a {
  color: #556ee6;
}
.categories-list li ul {
  padding-left: 16px;
}
.categories-list li ul li a {
  padding: 4px 12px;
  color: #74788d;
  font-size: 13px;
  font-weight: 400;
}

@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 260px;
  }
}
@media (min-width: 1200px) {
  .chat-leftsidebar {
    min-width: 380px;
  }
}
.chat-leftsidebar .chat-leftsidebar-nav .nav {
  background-color: #fff;
}
.chat-leftsidebar .chat-leftsidebar-nav .tab-content {
  min-height: 488px;
}

.chat-noti-dropdown.active:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #f46a6a;
  border-radius: 50%;
  right: 0;
}
.chat-noti-dropdown .btn {
  padding: 6px;
  box-shadow: none;
  font-size: 20px;
}

.chat-search-box .form-control {
  border: 0;
}

.chat-list {
  margin: 0;
}
.chat-list li.active a {
  background-color: #fff;
  border-color: transparent;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
.chat-list li a {
  display: block;
  padding: 14px 16px;
  color: #74788d;
  transition: all 0.4s;
  border-top: 1px solid #eff2f7;
  border-radius: 4px;
}
.chat-list li a:hover {
  background-color: #fff;
  border-color: transparent;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}

.user-chat-nav .dropdown .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 16px;
  background-color: #eff2f7;
  border-radius: 50%;
}
.user-chat-nav .dropdown .dropdown-menu {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border: 1px solid #eff2f7;
}

.chat-conversation li {
  clear: both;
}
.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
}
.chat-conversation .chat-day-title .title {
  background-color: #fff;
  position: relative;
  z-index: 1;
  padding: 6px 24px;
}
.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: #eff2f7;
  top: 10px;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-block;
  position: relative;
}
.chat-conversation .conversation-list .ctext-wrap {
  padding: 12px 24px;
  background-color: rgba(85, 110, 230, 0.1);
  border-radius: 8px 8px 8px 0px;
  overflow: hidden;
}
.chat-conversation .conversation-list .ctext-wrap .conversation-name {
  font-weight: 600;
  color: #556ee6;
  margin-bottom: 4px;
}
.chat-conversation .conversation-list .dropdown {
  float: right;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #74788d;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}
.chat-conversation .conversation-list .dropdown .dropdown-menu {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border: 1px solid #eff2f7;
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
}
.chat-conversation .right .conversation-list {
  float: right;
}
.chat-conversation .right .conversation-list .ctext-wrap {
  background-color: #eff2f7;
  text-align: right;
  border-radius: 8px 8px 0px 8px;
}
.chat-conversation .right .conversation-list .dropdown {
  float: left;
}
.chat-conversation .right .conversation-list.last-chat .conversation-list:before {
  right: 0;
  left: auto;
}
.chat-conversation .last-chat .conversation-list:before {
  content: "\\f0009";
  font-family: "Material Design Icons";
  position: absolute;
  color: #556ee6;
  right: 0;
  bottom: 0;
  font-size: 16px;
}
@media (max-width: 575.98px) {
  .chat-conversation .last-chat .conversation-list:before {
    display: none;
  }
}

.chat-input-section {
  border-top: 1px solid #eff2f7;
}

.chat-input {
  border-radius: 30px;
  background-color: #eff2f7 !important;
  border-color: #eff2f7 !important;
  padding-right: 120px;
}

.chat-input-links {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.chat-input-links li a {
  font-size: 16px;
  line-height: 36px;
  padding: 0px 4px;
  display: inline-block;
}

@media (max-width: 575.98px) {
  .chat-send {
    min-width: auto;
  }
}

.project-list-table {
  border-collapse: separate;
  border-spacing: 0 12px;
}
.project-list-table tr {
  background-color: #fff;
}

.contact-links a {
  color: #495057;
}

.profile-user-wid {
  margin-top: -26px;
}

.payouts-table-success {
  background-color: #e4fce9 !important;
}

.payouts-table-danger {
  background-color: #fdeeee !important;
}

.height-fit-content {
  height: fit-content !important;
}

.width-fit-content {
  width: fit-content !important;
}

@media (min-width: 576px) {
  .currency-value {
    position: relative;
  }
  .currency-value:after {
    content: "\\f04e1";
    font-family: "Material Design Icons";
    font-size: 24px;
    position: absolute;
    width: 45px;
    height: 45px;
    line-height: 45px;
    border-radius: 50%;
    text-align: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: #556ee6;
    color: #fff;
    z-index: 9;
    right: -34px;
  }
}
.crypto-buy-sell-nav-content {
  border: 2px solid #f6f6f6;
  border-top: 0;
}

.kyc-doc-verification .dropzone {
  min-height: 180px;
}
.kyc-doc-verification .dropzone .dz-message {
  margin: 24px 0px;
}

/******************
    Ico Landing
*******************/
.section {
  position: relative;
  padding-top: 80px;
  padding-bottom: 80px;
}
.section.bg-white {
  background-color: #fff !important;
}

.small-title {
  color: #74788d;
  margin-bottom: 8px;
}

.navigation {
  padding: 0 16px;
  width: 100%;
  z-index: 999;
  margin-bottom: 0px;
  transition: all 0.5s ease-in-out;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
@media (max-width: 991.98px) {
  .navigation {
    background-color: #fff;
  }
}
.navigation .navbar-logo {
  line-height: 70px;
  transition: all 0.4s;
}
.navigation .navbar-logo .logo-dark {
  display: none;
}
@media (max-width: 991.98px) {
  .navigation .navbar-logo .logo-dark {
    display: block;
  }
}
.navigation .navbar-logo .logo-light {
  display: block;
}
@media (max-width: 991.98px) {
  .navigation .navbar-logo .logo-light {
    display: none;
  }
}
.navigation .navbar-nav .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.6);
  line-height: 58px;
  padding: 6px 16px;
  font-weight: 500;
  transition: all 0.4s;
}
@media (max-width: 991.98px) {
  .navigation .navbar-nav .nav-item .nav-link {
    color: #555b6d;
  }
}
.navigation .navbar-nav .nav-item .nav-link:hover, .navigation .navbar-nav .nav-item .nav-link.active {
  color: rgba(255, 255, 255, 0.9);
}
@media (max-width: 991.98px) {
  .navigation .navbar-nav .nav-item .nav-link:hover, .navigation .navbar-nav .nav-item .nav-link.active {
    color: #556ee6;
  }
}
@media (max-width: 991.98px) {
  .navigation .navbar-nav .nav-item .nav-link {
    line-height: 28px !important;
  }
}
.navigation.nav-sticky {
  background-color: #fff;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
}
.navigation.nav-sticky .navbar-logo {
  line-height: 60px;
}
.navigation.nav-sticky .navbar-logo .logo-dark {
  display: block;
}
.navigation.nav-sticky .navbar-logo .logo-light {
  display: none;
}
.navigation.nav-sticky .navbar-nav .nav-item .nav-link {
  line-height: 48px;
  color: #555b6d;
}
.navigation.nav-sticky .navbar-nav .nav-item .nav-link:hover, .navigation.nav-sticky .navbar-nav .nav-item .nav-link.active {
  color: #556ee6;
}

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #000;
}

.hero-section {
  padding-top: 220px;
  padding-bottom: 190px;
}
.hero-section.bg-ico-hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  background-size: cover;
  background-position: top;
}
@media (max-width: 575.98px) {
  .hero-section {
    padding-top: 140px;
    padding-bottom: 80px;
  }
}
.hero-section .hero-title {
  font-size: 42px;
}
@media (max-width: 575.98px) {
  .hero-section .hero-title {
    font-size: 26px;
  }
}
.hero-section .ico-countdown {
  font-size: 22px;
  margin-right: -12px;
  margin-left: -12px;
}
@media (max-width: 575.98px) {
  .hero-section .ico-countdown {
    display: block;
  }
}
.hero-section .ico-countdown .coming-box {
  margin-right: 12px;
  margin-left: 12px;
  border: 1px solid #eff2f7;
  border-radius: 4px;
  padding: 8px;
  background-color: #fff;
}
@media (max-width: 575.98px) {
  .hero-section .ico-countdown .coming-box {
    display: inline-block;
    width: 40%;
    margin-bottom: 24px;
  }
}
.hero-section .ico-countdown .coming-box span {
  background-color: #eff2f7;
  font-size: 12px;
  padding: 4px;
  margin-top: 8px;
}
.hero-section .softcap-progress {
  overflow: visible;
}
.hero-section .softcap-progress .progress-bar {
  overflow: visible;
}
.hero-section .softcap-progress .progress-label {
  position: relative;
  text-align: right;
  color: #495057;
  bottom: 20px;
  font-size: 12px;
  font-weight: 500;
}

.currency-price {
  position: relative;
  bottom: 40px;
}

.client-images img {
  max-height: 34px;
  width: auto !important;
  margin: 12px auto;
  opacity: 0.7;
  transition: all 0.4s;
}

.features-number {
  opacity: 0.1;
}

.team-box .team-social-links a {
  color: #495057;
  font-size: 14px;
}

.blog-box .blog-badge {
  position: absolute;
  top: 12px;
  right: 12px;
}

.landing-footer {
  padding: 80px 0 40px;
  background-color: #2a3042;
  color: rgba(255, 255, 255, 0.5);
}
.landing-footer .footer-list-title {
  color: rgba(255, 255, 255, 0.9);
}
.landing-footer .footer-list-menu li a {
  display: block;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 14px;
  transition: all 0.4s;
}
.landing-footer .footer-list-menu li a:hover {
  color: rgba(255, 255, 255, 0.8);
}
.landing-footer .blog-post .post {
  display: block;
  color: rgba(255, 255, 255, 0.5);
  padding: 16px 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.landing-footer .blog-post .post .post-title {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}
.landing-footer .blog-post .post:first-of-type {
  padding-top: 0;
}
.landing-footer .blog-post .post:last-of-type {
  padding-bottom: 0;
  border-bottom: 0;
}
.landing-footer .footer-border {
  border-color: rgba(255, 255, 255, 0.1);
}

.counter-number {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  display: flex;
}
.counter-number span {
  font-size: 16px;
  font-weight: 400;
  display: block;
  padding-top: 5px;
}

.coming-box {
  width: 25%;
}

/************** Horizontal timeline **************/
.hori-timeline .events .event-list {
  text-align: center;
  display: block;
}
.hori-timeline .events .event-list .event-down-icon {
  position: relative;
}
.hori-timeline .events .event-list .event-down-icon::before {
  content: "";
  position: absolute;
  width: 100%;
  top: 16px;
  left: 0;
  right: 0;
  border-bottom: 3px dashed #f6f6f6;
}
.hori-timeline .events .event-list .event-down-icon .down-arrow-icon {
  position: relative;
  background-color: #fff;
  padding: 4px;
}
.hori-timeline .events .event-list:hover .down-arrow-icon {
  animation: fade-down 1.5s infinite linear;
}
.hori-timeline .events .event-list.active .down-arrow-icon {
  animation: fade-down 1.5s infinite linear;
}
.hori-timeline .events .event-list.active .down-arrow-icon:before {
  content: "\\ec4c";
}

/************** vertical timeline **************/
.verti-timeline {
  border-left: 3px dashed #f6f6f6;
  margin: 0 10px;
}
.verti-timeline .event-list {
  position: relative;
  padding: 0px 0px 40px 30px;
}
.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0px;
  z-index: 9;
  font-size: 16px;
}
.verti-timeline .event-list .event-content {
  position: relative;
  border: 2px solid #eff2f7;
  border-radius: 7px;
}
.verti-timeline .event-list.active .event-timeline-dot {
  color: #556ee6;
}
.verti-timeline .event-list:last-child {
  padding-bottom: 0px;
}

.plan-box .plan-btn {
  position: relative;
}
.plan-box .plan-btn::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: #f6f6f6;
  left: 0px;
  right: 0px;
  top: 12px;
}

.blog-play-icon {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  margin: 0px auto;
}

.information-wrap span + span {
  border-top: 1px solid #eff2f7;
  padding-top: 8px;
  margin-top: 8px;
}

.information-wrap span h6, .information-wrap span .h6 {
  margin: 0;
  font-weight: bold;
}

.fundings-form h4, .fundings-form .h4 {
  font-size: 18px;
  margin-bottom: 20px;
}

.information-wrap {
  padding: 14px 10px;
  border-radius: 5px;
  border: 1px solid #eff2f7;
}

.status-box {
  margin-top: 30px;
  margin-bottom: 20px;
}

.status-box .form-control {
  display: flex;
}

.status-box .form-control .form-check {
  margin-right: 15px;
}

.coment-box {
  margin-bottom: 20px;
}

.inner-repeater ul {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ced4da;
  margin: 0;
}

.inner-repeater ul li {
  color: #333;
  margin: 4px 3px;
  list-style: none;
  border-radius: 5px;
  background: #f2f2f2;
  padding: 0 8px 0px 10px;
  border: 1px solid #e3e1e1;
}

.moderator-table {
  width: 100%;
  table-layout: fixed;
}

.overflow-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.datepicker-container-error {
  border: 1px solid #f46a6a;
}

.end_start_date_required {
  color: #f46a6a;
  font-size: 10px;
}

.more-text {
  font-size: 11px;
  opacity: 0.9;
}

li.placeHolder {
  background: transparent !important;
  padding: 0;
  border: 0 !important;
}

.react-bootstrap-table-page-btns-ul {
  margin: 0;
}

.pagination-rounded {
  flex-direction: row-reverse;
  justify-content: space-between !important;
  align-items: center !important;
}

.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 24px;
  margin: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider.round {
  border-radius: 34px;
}

input:checked + .slider {
  background-color: #556ee6;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

.slider.round:before {
  border-radius: 50%;
}

.switch input:checked + .slider:before {
  transform: translateX(21px);
}

.multi-input .ReactTags__tagInput input {
  display: inline-block;
  border: 1px solid #ced4da;
  padding: 7px 15px;
  border-radius: 100px;
  width: 100%;
}

.multi-input .ReactTags__selected {
  display: flex;
  flex-wrap: wrap;
}

.multi-input .ReactTags__selected .ReactTags__tagInput {
  display: block;
  width: 100%;
  order: 1;
}

.multi-input .ReactTags__selected .tag-wrapper {
  order: 2;
  background: #556ee6;
  color: #fff;
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 100px;
  margin-right: 5px;
  margin-top: 5px;
}

.multi-input .ReactTags__selected .tag-wrapper button {
  background: transparent;
  border: none;
  color: #fff;
  padding: 0;
  margin-left: 10px;
}

.question-table-wrp {
  position: relative;
  padding-bottom: 30px;
}

.faq-heading {
  background: #f7f7fa;
  padding: 10px;
  margin-bottom: 10px;
}

.faq-heading p {
  margin: 0;
}

.faq-heading p span h6, .faq-heading p span .h6 {
  margin: 0;
}

.question-table-wrp h3, .question-table-wrp .h3 {
  color: #495057;
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
  display: block;
}

.faq-list {
  padding-bottom: 10px;
  border-bottom: 1px solid #eff2f7;
  margin-bottom: 30px;
}

.faq-desc {
  position: relative;
  padding-bottom: 20px;
}

.faq-desc-itme {
  position: relative;
  width: 100%;
  padding-left: 25px;
}

.faq-quetion,
.faq-answer {
  position: relative;
  padding-bottom: 10px;
  display: block;
}

.faq-quetion label,
.faq-answer label {
  color: #000;
  font-weight: 900;
  font-size: 13px;
  margin: 0;
  display: block;
  position: absolute;
  top: 1px;
  left: -21px;
}

.faq-quetion h6, .faq-quetion .h6 {
  margin: 0;
  font-size: 14px;
  color: #000;
  line-height: 20px;
}

.faq-answer p {
  margin: 0;
  font-size: 13px;
  color: #495057;
  line-height: 18px;
}

.event-images img {
  height: 150px !important;
  width: 200px !important;
}
@media (min-width: 576px) {
  .event-images img {
    height: 240px !important;
    width: 320px !important;
  }
}
@media (min-width: 768px) {
  .event-images img {
    height: 120px !important;
    width: 160px !important;
  }
}
@media (min-width: 992px) {
  .event-images img {
    height: 180px !important;
    width: 240px !important;
  }
}
@media (min-width: 1200px) {
  .event-images img {
    height: 240px !important;
    width: 320px !important;
  }
}

body * {
  outline: none;
}

#sidebar-menu ul li a i {
  min-width: 2rem;
}

.leaflet-pane {
  z-index: 1;
}

svg > rect:first-child {
  fill-opacity: 0 !important;
}

.dataTables_filter,
.dataTables_paginate {
  float: right;
}

.rdw-editor-main {
  border: 1px solid #f6f6f6;
  height: 239px;
  padding-left: 15px;
}

.dz-message {
  text-align: center;
  padding: 30px;
}

.react-kanban-column {
  height: 100%;
  min-height: 28px;
  display: inline-block;
  padding: 15px;
  border-radius: 2px;
  background-color: rgb(238, 238, 238);
  margin: 5px;
  vertical-align: top;
}

.fcYNFc,
.sc-AxmLO.gmtmqV {
  background-color: #fff !important;
  margin: 0 20px 0 0 !important;
}

.task-box {
  border: 1px solid #eff2f7;
}

.react-datepicker-wrapper {
  width: 100% !important;
}

.ReactModal__Overlay {
  z-index: 1001 !important;
}

.external-event:hover {
  cursor: pointer;
}

a:hover {
  cursor: pointer;
}

.rating-container {
  background-color: transparent !important;
}

.input-group-append {
  z-index: 0;
}

.input-color {
  color: #495057 !important;
}

.sketch-picker {
  position: absolute;
  z-index: 1;
}

.rangeslider__fill {
  background-color: #556ee6 !important;
}

.dropdown-menu-end {
  left: auto !important;
  right: 0 !important;
}

.flatpickr-months .flatpickr-month {
  background: #556ee6 !important;
}

.flatpickr-weekdays {
  background: #556ee6 !important;
}

span.flatpickr-weekday {
  background: #556ee6 !important;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  background: #556ee6 !important;
}

span.flatpickr-weekday {
  color: #fff !important;
}

.flatpickr-day.selected {
  background: #556ee6 !important;
}

.bs-select select {
  width: auto !important;
}

.file-manager .table td {
  padding: 0.35rem;
}

.slider_css .slide {
  background: none !important;
}
.slider_css .carousel-status,
.slider_css .control-next,
.slider_css .control-prev {
  display: none !important;
}

.carousel .control-dots {
  margin: -5px 0px;
}
.carousel .dot {
  background: #556ee6 !important;
  width: 9px !important;
  height: 9px !important;
}

.verification input:focus {
  border: none;
  outline: none !important;
}

@media (max-width: 768px) {
  .verification input {
    width: 40px !important;
  }
}
@media (max-width: 320px) {
  .verification input {
    width: 30px !important;
    height: 30px !important;
    font-size: 15px !important;
  }
}
.verification-2 input:focus {
  border: none;
  outline: none !important;
}

@media (max-width: 768px) {
  .verification-2 input {
    width: 40px !important;
    font-size: 14px;
  }
}
@media (max-width: 320px) {
  .verification-2 input {
    width: 30px !important;
    height: 35px !important;
    font-size: 15px !important;
  }
}
.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center;
  }
  .fc-toolbar .fc-left,
  .fc-toolbar .fc-right,
  .fc-toolbar .fc-center {
    float: none;
    display: block;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc-today-button {
    display: none;
  }
}
.ps__rail-y {
  z-index: 999999 !important;
}

.close {
  background: transparent;
  border: 0;
  font-size: 10px;
  padding: 1.35rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_49___}) center/1em auto no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2;
}
.close span {
  display: none;
}

.card-columns .card {
  margin-bottom: 24px;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

/* drawer */
.react-drawer-drawer {
  z-index: 9999;
  background: #fff;
}

.drawer-main-menu {
  padding-top: 8px;
  padding-bottom: 8px;
}

.drawer-menu a i {
  min-width: 2rem;
  display: inline-block;
  min-width: 1.75rem;
  padding-bottom: 0.125em;
  font-size: 1.25rem;
  line-height: 1.40625rem;
  vertical-align: middle;
  color: #7f8387;
  transition: all 0.4s;
}

.drawer-menu a {
  display: block;
  padding: 0.625rem 1.5rem;
  color: #545a6d;
  position: relative;
  font-size: 13px;
  transition: all 0.4s;
}

.drawer-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.ReactModal__Overlay {
  z-index: 5000 !important;
}

.rangeslider__handle:focus {
  outline: none;
}

.react-bootstrap-table-page-btns-ul {
  float: right !important;
}

.search-label {
  float: right;
}

.react-drawer-overlay {
  z-index: 9999;
}

.react-bs-table-sizePerPage-dropdown .dropdown-menu .dropdown-item a {
  display: block;
}

.rightbar-title .right-bar-toggle {
  background-color: #444c54 !important;
  height: 24px !important;
  width: 24px !important;
  line-height: 24px !important;
  display: block !important;
  color: #eff2f7 !important;
  text-align: center !important;
  border-radius: 50% !important;
}

.css-sourceMap-modules-importLoaders-1-localIdentName-animate__animated___2O131 {
  animation-duration: 0.6s !important;
}

.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {
  background: rgba(0, 0, 0, 0.15) !important;
}

/*  tui charts**/
.tui-chart .tui-chart-chartExportMenu-area {
  z-index: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_fontawesome-all.scss","webpack://./src/assets/scss/custom/plugins/icons/_dripicons.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_backgrounds.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_table.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_vertical.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/structure/_layouts.scss","webpack://./src/assets/scss/custom/components/_waves.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_accordion.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_preloader.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_widgets.scss","webpack://./src/assets/scss/custom/components/_demos.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/custom/plugins/_calendar.scss","webpack://./src/assets/scss/custom/plugins/_dragula.scss","webpack://./src/assets/scss/custom/plugins/_session-timeout.scss","webpack://./src/assets/scss/custom/plugins/_range-slider.scss","webpack://./src/assets/scss/custom/plugins/_sweatalert2.scss","webpack://./src/assets/scss/custom/plugins/_rating.scss","webpack://./src/assets/scss/custom/plugins/_toastr.scss","webpack://./src/assets/scss/custom/plugins/_parsley.scss","webpack://./src/assets/scss/custom/plugins/_select2.scss","webpack://./src/assets/scss/custom/plugins/_switch.scss","webpack://./src/assets/scss/custom/plugins/_colorpicker.scss","webpack://./src/assets/scss/custom/plugins/_timepicker.scss","webpack://./src/assets/scss/custom/plugins/_datepicker.scss","webpack://./src/assets/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/assets/scss/custom/plugins/_form-editors.scss","webpack://./src/assets/scss/custom/plugins/_form-upload.scss","webpack://./src/assets/scss/custom/plugins/_form-wizard.scss","webpack://./src/assets/scss/custom/plugins/_datatable.scss","webpack://./src/assets/scss/custom/plugins/_responsive-table.scss","webpack://./src/assets/scss/custom/plugins/_table-editable.scss","webpack://./src/assets/scss/custom/plugins/_apexcharts.scss","webpack://./src/assets/scss/custom/plugins/_echarts.scss","webpack://./src/assets/scss/custom/plugins/_flot.scss","webpack://./src/assets/scss/custom/plugins/_sparkline-chart.scss","webpack://./src/assets/scss/custom/plugins/_google-map.scss","webpack://./src/assets/scss/custom/plugins/_vector-maps.scss","webpack://./src/assets/scss/custom/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/custom/pages/_authentication.scss","webpack://./src/assets/scss/custom/pages/_ecommerce.scss","webpack://./src/assets/scss/custom/pages/_email.scss","webpack://./src/assets/scss/custom/pages/_file-manager.scss","webpack://./src/assets/scss/custom/pages/_chat.scss","webpack://./src/assets/scss/custom/pages/_projects.scss","webpack://./src/assets/scss/custom/pages/_users.scss","webpack://./src/assets/scss/custom/pages/_crypto.scss","webpack://./src/assets/scss/custom/pages/_coming-soon.scss","webpack://./src/assets/scss/custom/pages/_timeline.scss","webpack://./src/assets/scss/custom/pages/_extras-pages.scss","webpack://./src/assets/scss/custom/pages/_applied-funding.scss","webpack://./src/assets/scss/custom/pages/_createPitch.scss","webpack://./src/assets/scss/custom/pages/_investors.scss","webpack://./src/assets/scss/custom/pages/_founder-list.scss","webpack://./src/assets/scss/custom/pages/_identifiedUsers.scss","webpack://./src/assets/scss/custom/pages/_event-report.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AFMF;AEHA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,iBAAA;AFKF;;AEFA;EACE,gBAAA;EACA,kBAAA;AFKF;;AEFA;EACE,eAAA;AFKF;;AEFA;EACE,eAAA;AFKF;;AEFA;EACE,eAAA;AFKF;;AEFA;EACE,eAAA;AFKF;;AEFA;EACE,0BAAA;AFKF;;AEFA;EACE,0BAAA;AFKF;;AEFA;EACE,YAAA;AFKF;;AEFA;EACE,+BAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,wBAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,wBAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,yBAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,yBAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,yBAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,yBAAA;AFKF;;AEFA;EACE;;;;;;;;;;;;;;;SAAA;AFoBF;;AEFA;EAGE,yBAAA;AFKF;;AEFA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFKF;;AEFA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFKF;;AEFA;EAEE,sCAAA;AFKF;AESA;EACE;IAEE,uBAAA;EFIF;EEFA;IAEE,yBAAA;EFIF;AACF;;AG9ouBA;EAEI,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,4SAAA;AH+ouBJ;AGzouBA;EAEI,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EAEA,qBAAA;EAEA,oBAAA;EAEA,WAAA;EACA,mCAAA;EACA,kCAAA;AHuouBJ;;AGrouBA;EAEI,gBAAA;EACA,eAAA;EAEA,gBAAA;AHsouBJ;;AGpouBA;EAEI,kBAAA;AHsouBJ;;AGpouBA;EAEI,kBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,UAAA;EAEA,UAAA;EAEA,kBAAA;AHmouBJ;AGpnuBA;EAEI;IAGY,oBAAA;EH+nuBd;EG7nuBE;IAGY,yBAAA;EH8nuBd;AACF;AG3muBA;EAEI;IAGY,mBAAA;IAER,UAAA;EHsnuBN;EGpnuBE;IAGY,qBAAA;IAER,UAAA;EHonuBN;AACF;AGnmuBA;EAEI;IAEI,UAAA;EH8muBN;EG5muBE;IAEI,UAAA;EH6muBN;EG3muBE;IAEI,UAAA;EH4muBN;AACF;AGzluBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHomuBN;EGlmuBE;IAGY,4BAAA;IAER,UAAA;EHkmuBN;AACF;AG/kuBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH0luBN;EGxluBE;IAGY,2BAAA;IAER,UAAA;EHwluBN;AACF;AGrkuBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHgluBN;EG9kuBE;IAGY,4BAAA;IAER,UAAA;EH8kuBN;AACF;AG3juBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHskuBN;EGpkuBE;IAGY,2BAAA;IAER,UAAA;EHokuBN;AACF;AG3huBA;EAEI;IAGY,2BAAA;EHijuBd;EG9iuBE;IAIY,8DAAA;EH8iuBd;EG3iuBE;IAMY,oDAAA;EHyiuBd;EGtiuBE;IAKY,oCAAA;EHqiuBd;EGliuBE;IAGY,2BAAA;EHmiuBd;AACF;AGjiuBA;EAGY,kCAAA;AHkiuBZ;;AGhiuBA;EAGY,kCAAA;AHkiuBZ;;AG/huBA;EAGY,kCAAA;AHiiuBZ;;AG/huBA;EAGY,kCAAA;AHiiuBZ;;AG9huBA;EAGY,wCAAA;AHgiuBZ;;AG9huBA;EAGY,wCAAA;AHgiuBZ;;AG7huBA;EAGY,qCAAA;AH+huBZ;;AG7huBA;EAGY,qCAAA;AH+huBZ;;AG7huBA;EAGY,uCAAA;AH+huBZ;;AG7huBA;EAGY,uCAAA;AH+huBZ;;AG7huBA;EAGY,yCAAA;AH+huBZ;;AG7huBA;EAGY,yCAAA;AH+huBZ;;AG7huBA;EAGY,yCAAA;AH+huBZ;;AG7huBA;EAGY,yCAAA;AH+huBZ;;AG7huBA;EAGY,0CAAA;AH+huBZ;;AG7huBA;EAGY,0CAAA;AH+huBZ;;AG7huBA;EAEI,0BAAA;AH+huBJ;;AG7huBA;EAEI,6BAAA;AH+huBJ;;AG7huBA;EAEI,6BAAA;AH+huBJ;;AG7huBA;EAEI,yBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,aAAA;EACA,6BAAA;EAEA,sBAAA;AH6huBJ;;AG1huBA;EAEI,0BAAA;AH4huBJ;;AG1huBA;EAEI,WAAA;EAEA,8BAAA;AH2huBJ;;AGxhuBA;EAEI,YAAA;EAEA,6BAAA;AHyhuBJ;;AGvhuBA;EAEI,wBAAA;EAEA,sEAAA;AHwhuBJ;;AGthuBA;EAEI,yBAAA;EAEA,sEAAA;AHuhuBJ;;AGrhuBA;EAEI,yBAAA;EAEA,sEAAA;AHshuBJ;;AGphuBA;EAEI,qBAAA;EAEA,gFAAA;AHqhuBJ;;AGnhuBA;EAEI,qBAAA;EAEA,gFAAA;AHohuBJ;;AGlhuBA;EAEI,eAAA;EAEA,uCAAA;EACA,qBAAA;AHmhuBJ;;AGjhuBA;EAEI,eAAA;EAEA,uCAAA;EACA,kBAAA;AHkhuBJ;;AG/guBA;EACE,gBAAA;AHkhuBF;;AGhhuBA;EACE,gBAAA;AHmhuBF;;AGjhuBA;EACE,gBAAA;AHohuBF;;AGlhuBA;EACE,gBAAA;AHqhuBF;;AGnhuBA;EACE,gBAAA;AHshuBF;;AGphuBA;EACE,gBAAA;AHuhuBF;;AGrhuBA;EACE,gBAAA;AHwhuBF;;AGthuBA;EACE,gBAAA;AHyhuBF;;AGvhuBA;EACE,gBAAA;AH0huBF;;AGxhuBA;EACE,gBAAA;AH2huBF;;AGzhuBA;EACE,gBAAA;AH4huBF;;AG1huBA;EACE,gBAAA;AH6huBF;;AG3huBA;EACE,gBAAA;AH8huBF;;AG5huBA;EACE,gBAAA;AH+huBF;;AG7huBA;EACE,gBAAA;AHgiuBF;;AG9huBA;EACE,gBAAA;AHiiuBF;;AG/huBA;EACE,gBAAA;AHkiuBF;;AGhiuBA;EACE,gBAAA;AHmiuBF;;AGjiuBA;EACE,gBAAA;AHoiuBF;;AGliuBA;EACE,gBAAA;AHqiuBF;;AGniuBA;EACE,gBAAA;AHsiuBF;;AGpiuBA;EACE,gBAAA;AHuiuBF;;AGriuBA;EACE,gBAAA;AHwiuBF;;AGtiuBA;EACE,gBAAA;AHyiuBF;;AGviuBA;EACE,gBAAA;AH0iuBF;;AGxiuBA;EACE,gBAAA;AH2iuBF;;AGziuBA;EACE,gBAAA;AH4iuBF;;AG1iuBA;EACE,gBAAA;AH6iuBF;;AG3iuBA;EACE,gBAAA;AH8iuBF;;AG5iuBA;EACE,gBAAA;AH+iuBF;;AG7iuBA;EACE,gBAAA;AHgjuBF;;AG9iuBA;EACE,gBAAA;AHijuBF;;AG/iuBA;EACE,gBAAA;AHkjuBF;;AGhjuBA;EACE,gBAAA;AHmjuBF;;AGjjuBA;EACE,gBAAA;AHojuBF;;AGljuBA;EACE,gBAAA;AHqjuBF;;AGnjuBA;EACE,gBAAA;AHsjuBF;;AGpjuBA;EACE,gBAAA;AHujuBF;;AGrjuBA;EACE,gBAAA;AHwjuBF;;AGtjuBA;EACE,gBAAA;AHyjuBF;;AGvjuBA;EACE,gBAAA;AH0juBF;;AGxjuBA;EACE,gBAAA;AH2juBF;;AGzjuBA;EACE,gBAAA;AH4juBF;;AG1juBA;EACE,gBAAA;AH6juBF;;AG3juBA;EACE,gBAAA;AH8juBF;;AG5juBA;EACE,gBAAA;AH+juBF;;AG7juBA;EACE,gBAAA;AHgkuBF;;AG9juBA;EACE,gBAAA;AHikuBF;;AG/juBA;EACE,gBAAA;AHkkuBF;;AGhkuBA;EACE,gBAAA;AHmkuBF;;AGjkuBA;EACE,gBAAA;AHokuBF;;AGlkuBA;EACE,gBAAA;AHqkuBF;;AGnkuBA;EACE,gBAAA;AHskuBF;;AGpkuBA;EACE,gBAAA;AHukuBF;;AGrkuBA;EACE,gBAAA;AHwkuBF;;AGtkuBA;EACE,gBAAA;AHykuBF;;AGvkuBA;EACE,gBAAA;AH0kuBF;;AGxkuBA;EACE,gBAAA;AH2kuBF;;AGzkuBA;EACE,gBAAA;AH4kuBF;;AG1kuBA;EACE,gBAAA;AH6kuBF;;AG3kuBA;EACE,gBAAA;AH8kuBF;;AG5kuBA;EACE,gBAAA;AH+kuBF;;AG7kuBA;EACE,gBAAA;AHgluBF;;AG9kuBA;EACE,gBAAA;AHiluBF;;AG/kuBA;EACE,gBAAA;AHkluBF;;AGhluBA;EACE,gBAAA;AHmluBF;;AGjluBA;EACE,gBAAA;AHoluBF;;AGlluBA;EACE,gBAAA;AHqluBF;;AGnluBA;EACE,gBAAA;AHsluBF;;AGpluBA;EACE,gBAAA;AHuluBF;;AGrluBA;EACE,gBAAA;AHwluBF;;AGtluBA;EACE,gBAAA;AHyluBF;;AGvluBA;EACE,gBAAA;AH0luBF;;AGxluBA;EACE,gBAAA;AH2luBF;;AGzluBA;EACE,gBAAA;AH4luBF;;AG1luBA;EACE,gBAAA;AH6luBF;;AG3luBA;EACE,gBAAA;AH8luBF;;AG5luBA;EACE,gBAAA;AH+luBF;;AG7luBA;EACE,gBAAA;AHgmuBF;;AG9luBA;EACE,gBAAA;AHimuBF;;AG/luBA;EACE,gBAAA;AHkmuBF;;AGhmuBA;EACE,gBAAA;AHmmuBF;;AGjmuBA;EACE,gBAAA;AHomuBF;;AGlmuBA;EACE,gBAAA;AHqmuBF;;AGnmuBA;EACE,gBAAA;AHsmuBF;;AGpmuBA;EACE,gBAAA;AHumuBF;;AGrmuBA;EACE,gBAAA;AHwmuBF;;AGtmuBA;EACE,gBAAA;AHymuBF;;AGvmuBA;EACE,gBAAA;AH0muBF;;AGxmuBA;EACE,gBAAA;AH2muBF;;AGzmuBA;EACE,gBAAA;AH4muBF;;AG1muBA;EACE,gBAAA;AH6muBF;;AG3muBA;EACE,gBAAA;AH8muBF;;AG5muBA;EACE,gBAAA;AH+muBF;;AG7muBA;EACE,gBAAA;AHgnuBF;;AG9muBA;EACE,gBAAA;AHinuBF;;AG/muBA;EACE,gBAAA;AHknuBF;;AGhnuBA;EACE,gBAAA;AHmnuBF;;AGjnuBA;EACE,gBAAA;AHonuBF;;AGlnuBA;EACE,gBAAA;AHqnuBF;;AGnnuBA;EACE,gBAAA;AHsnuBF;;AGpnuBA;EACE,gBAAA;AHunuBF;;AGrnuBA;EACE,gBAAA;AHwnuBF;;AGtnuBA;EACE,gBAAA;AHynuBF;;AGvnuBA;EACE,gBAAA;AH0nuBF;;AGxnuBA;EACE,gBAAA;AH2nuBF;;AGznuBA;EACE,gBAAA;AH4nuBF;;AG1nuBA;EACE,gBAAA;AH6nuBF;;AG3nuBA;EACE,gBAAA;AH8nuBF;;AG5nuBA;EACE,gBAAA;AH+nuBF;;AG7nuBA;EACE,gBAAA;AHgouBF;;AG9nuBA;EACE,gBAAA;AHiouBF;;AG/nuBA;EACE,gBAAA;AHkouBF;;AGhouBA;EACE,gBAAA;AHmouBF;;AGjouBA;EACE,gBAAA;AHoouBF;;AGlouBA;EACE,gBAAA;AHqouBF;;AGnouBA;EACE,gBAAA;AHsouBF;;AGpouBA;EACE,gBAAA;AHuouBF;;AGrouBA;EACE,gBAAA;AHwouBF;;AGtouBA;EACE,gBAAA;AHyouBF;;AGvouBA;EACE,gBAAA;AH0ouBF;;AGxouBA;EACE,gBAAA;AH2ouBF;;AGzouBA;EACE,gBAAA;AH4ouBF;;AG1ouBA;EACE,gBAAA;AH6ouBF;;AG3ouBA;EACE,gBAAA;AH8ouBF;;AG5ouBA;EACE,gBAAA;AH+ouBF;;AG7ouBA;EACE,gBAAA;AHgpuBF;;AG9ouBA;EACE,gBAAA;AHipuBF;;AG/ouBA;EACE,gBAAA;AHkpuBF;;AGhpuBA;EACE,gBAAA;AHmpuBF;;AGjpuBA;EACE,gBAAA;AHopuBF;;AGlpuBA;EACE,gBAAA;AHqpuBF;;AGnpuBA;EACE,gBAAA;AHspuBF;;AGppuBA;EACE,gBAAA;AHupuBF;;AGrpuBA;EACE,gBAAA;AHwpuBF;;AGtpuBA;EACE,gBAAA;AHypuBF;;AGvpuBA;EACE,gBAAA;AH0puBF;;AGxpuBA;EACE,gBAAA;AH2puBF;;AGzpuBA;EACE,gBAAA;AH4puBF;;AG1puBA;EACE,gBAAA;AH6puBF;;AG3puBA;EACE,gBAAA;AH8puBF;;AG5puBA;EACE,gBAAA;AH+puBF;;AG7puBA;EACE,gBAAA;AHgquBF;;AG9puBA;EACE,gBAAA;AHiquBF;;AG/puBA;EACE,gBAAA;AHkquBF;;AGhquBA;EACE,gBAAA;AHmquBF;;AGjquBA;EACE,gBAAA;AHoquBF;;AGlquBA;EACE,gBAAA;AHqquBF;;AGnquBA;EACE,gBAAA;AHsquBF;;AGpquBA;EACE,gBAAA;AHuquBF;;AGrquBA;EACE,gBAAA;AHwquBF;;AGtquBA;EACE,gBAAA;AHyquBF;;AGvquBA;EACE,gBAAA;AH0quBF;;AGxquBA;EACE,gBAAA;AH2quBF;;AGzquBA;EACE,gBAAA;AH4quBF;;AG1quBA;EACE,gBAAA;AH6quBF;;AG3quBA;EACE,gBAAA;AH8quBF;;AG5quBA;EACE,gBAAA;AH+quBF;;AG7quBA;EACE,gBAAA;AHgruBF;;AG9quBA;EACE,gBAAA;AHiruBF;;AG/quBA;EACE,gBAAA;AHkruBF;;AGhruBA;EACE,gBAAA;AHmruBF;;AGjruBA;EACE,gBAAA;AHoruBF;;AGlruBA;EACE,gBAAA;AHqruBF;;AGnruBA;EACE,gBAAA;AHsruBF;;AGpruBA;EACE,gBAAA;AHuruBF;;AGrruBA;EACE,gBAAA;AHwruBF;;AGtruBA;EACE,gBAAA;AHyruBF;;AGvruBA;EACE,gBAAA;AH0ruBF;;AGxruBA;EACE,gBAAA;AH2ruBF;;AGzruBA;EACE,gBAAA;AH4ruBF;;AG1ruBA;EACE,gBAAA;AH6ruBF;;AG3ruBA;EACE,gBAAA;AH8ruBF;;AG5ruBA;EACE,gBAAA;AH+ruBF;;AG7ruBA;EACE,gBAAA;AHgsuBF;;AG9ruBA;EACE,gBAAA;AHisuBF;;AG/ruBA;EACE,gBAAA;AHksuBF;;AGhsuBA;EACE,gBAAA;AHmsuBF;;AGjsuBA;EACE,gBAAA;AHosuBF;;AGlsuBA;EACE,gBAAA;AHqsuBF;;AGnsuBA;EACE,gBAAA;AHssuBF;;AGpsuBA;EACE,gBAAA;AHusuBF;;AGrsuBA;EACE,gBAAA;AHwsuBF;;AGtsuBA;EACE,gBAAA;AHysuBF;;AGvsuBA;EACE,gBAAA;AH0suBF;;AGxsuBA;EACE,gBAAA;AH2suBF;;AGzsuBA;EACE,gBAAA;AH4suBF;;AG1suBA;EACE,gBAAA;AH6suBF;;AG3suBA;EACE,gBAAA;AH8suBF;;AG5suBA;EACE,gBAAA;AH+suBF;;AG7suBA;EACE,gBAAA;AHgtuBF;;AG9suBA;EACE,gBAAA;AHituBF;;AG/suBA;EACE,gBAAA;AHktuBF;;AGhtuBA;EACE,gBAAA;AHmtuBF;;AGjtuBA;EACE,gBAAA;AHotuBF;;AGltuBA;EACE,gBAAA;AHqtuBF;;AGntuBA;EACE,gBAAA;AHstuBF;;AGptuBA;EACE,gBAAA;AHutuBF;;AGrtuBA;EACE,gBAAA;AHwtuBF;;AGttuBA;EACE,gBAAA;AHytuBF;;AGvtuBA;EACE,gBAAA;AH0tuBF;;AGxtuBA;EACE,gBAAA;AH2tuBF;;AGztuBA;EACE,gBAAA;AH4tuBF;;AG1tuBA;EACE,gBAAA;AH6tuBF;;AG3tuBA;EACE,gBAAA;AH8tuBF;;AG5tuBA;EACE,gBAAA;AH+tuBF;;AG7tuBA;EACE,gBAAA;AHguuBF;;AG9tuBA;EACE,gBAAA;AHiuuBF;;AG/tuBA;EACE,gBAAA;AHkuuBF;;AGhuuBA;EACE,gBAAA;AHmuuBF;;AGjuuBA;EACE,gBAAA;AHouuBF;;AGluuBA;EACE,gBAAA;AHquuBF;;AGnuuBA;EACE,gBAAA;AHsuuBF;;AGpuuBA;EACE,gBAAA;AHuuuBF;;AGruuBA;EACE,gBAAA;AHwuuBF;;AGtuuBA;EACE,gBAAA;AHyuuBF;;AGvuuBA;EACE,gBAAA;AH0uuBF;;AGxuuBA;EACE,gBAAA;AH2uuBF;;AGzuuBA;EACE,gBAAA;AH4uuBF;;AG1uuBA;EACE,gBAAA;AH6uuBF;;AG3uuBA;EACE,gBAAA;AH8uuBF;;AG5uuBA;EACE,gBAAA;AH+uuBF;;AG7uuBA;EACE,gBAAA;AHgvuBF;;AG9uuBA;EACE,gBAAA;AHivuBF;;AG/uuBA;EACE,gBAAA;AHkvuBF;;AGhvuBA;EACE,gBAAA;AHmvuBF;;AGjvuBA;EACE,gBAAA;AHovuBF;;AGlvuBA;EACE,gBAAA;AHqvuBF;;AGnvuBA;EACE,gBAAA;AHsvuBF;;AGpvuBA;EACE,gBAAA;AHuvuBF;;AGrvuBA;EACE,gBAAA;AHwvuBF;;AGtvuBA;EACE,gBAAA;AHyvuBF;;AGvvuBA;EACE,gBAAA;AH0vuBF;;AGxvuBA;EACE,gBAAA;AH2vuBF;;AGzvuBA;EACE,gBAAA;AH4vuBF;;AG1vuBA;EACE,gBAAA;AH6vuBF;;AG3vuBA;EACE,gBAAA;AH8vuBF;;AG5vuBA;EACE,gBAAA;AH+vuBF;;AG7vuBA;EACE,gBAAA;AHgwuBF;;AG9vuBA;EACE,gBAAA;AHiwuBF;;AG/vuBA;EACE,gBAAA;AHkwuBF;;AGhwuBA;EACE,gBAAA;AHmwuBF;;AGjwuBA;EACE,gBAAA;AHowuBF;;AGlwuBA;EACE,gBAAA;AHqwuBF;;AGnwuBA;EACE,gBAAA;AHswuBF;;AGpwuBA;EACE,gBAAA;AHuwuBF;;AGrwuBA;EACE,gBAAA;AHwwuBF;;AGtwuBA;EACE,gBAAA;AHywuBF;;AGvwuBA;EACE,gBAAA;AH0wuBF;;AGxwuBA;EACE,gBAAA;AH2wuBF;;AGzwuBA;EACE,gBAAA;AH4wuBF;;AG1wuBA;EACE,gBAAA;AH6wuBF;;AG3wuBA;EACE,gBAAA;AH8wuBF;;AG5wuBA;EACE,gBAAA;AH+wuBF;;AG7wuBA;EACE,gBAAA;AHgxuBF;;AG9wuBA;EACE,gBAAA;AHixuBF;;AG/wuBA;EACE,gBAAA;AHkxuBF;;AGhxuBA;EACE,gBAAA;AHmxuBF;;AGjxuBA;EACE,gBAAA;AHoxuBF;;AGlxuBA;EACE,gBAAA;AHqxuBF;;AGnxuBA;EACE,gBAAA;AHsxuBF;;AGpxuBA;EACE,gBAAA;AHuxuBF;;AGrxuBA;EACE,gBAAA;AHwxuBF;;AGtxuBA;EACE,gBAAA;AHyxuBF;;AGvxuBA;EACE,gBAAA;AH0xuBF;;AGxxuBA;EACE,gBAAA;AH2xuBF;;AGzxuBA;EACE,gBAAA;AH4xuBF;;AG1xuBA;EACE,gBAAA;AH6xuBF;;AG3xuBA;EACE,gBAAA;AH8xuBF;;AG5xuBA;EACE,gBAAA;AH+xuBF;;AG7xuBA;EACE,gBAAA;AHgyuBF;;AG9xuBA;EACE,gBAAA;AHiyuBF;;AG/xuBA;EACE,gBAAA;AHkyuBF;;AGhyuBA;EACE,gBAAA;AHmyuBF;;AGjyuBA;EACE,gBAAA;AHoyuBF;;AGlyuBA;EACE,gBAAA;AHqyuBF;;AGnyuBA;EACE,gBAAA;AHsyuBF;;AGpyuBA;EACE,gBAAA;AHuyuBF;;AGryuBA;EACE,gBAAA;AHwyuBF;;AGtyuBA;EACE,gBAAA;AHyyuBF;;AGvyuBA;EACE,gBAAA;AH0yuBF;;AGxyuBA;EACE,gBAAA;AH2yuBF;;AGzyuBA;EACE,gBAAA;AH4yuBF;;AG1yuBA;EACE,gBAAA;AH6yuBF;;AG3yuBA;EACE,gBAAA;AH8yuBF;;AG5yuBA;EACE,gBAAA;AH+yuBF;;AG7yuBA;EACE,gBAAA;AHgzuBF;;AG9yuBA;EACE,gBAAA;AHizuBF;;AG/yuBA;EACE,gBAAA;AHkzuBF;;AGhzuBA;EACE,gBAAA;AHmzuBF;;AGjzuBA;EACE,gBAAA;AHozuBF;;AGlzuBA;EACE,gBAAA;AHqzuBF;;AGnzuBA;EACE,gBAAA;AHszuBF;;AGpzuBA;EACE,gBAAA;AHuzuBF;;AGrzuBA;EACE,gBAAA;AHwzuBF;;AGtzuBA;EACE,gBAAA;AHyzuBF;;AGvzuBA;EACE,gBAAA;AH0zuBF;;AGxzuBA;EACE,gBAAA;AH2zuBF;;AGzzuBA;EACE,gBAAA;AH4zuBF;;AG1zuBA;EACE,gBAAA;AH6zuBF;;AG3zuBA;EACE,gBAAA;AH8zuBF;;AG5zuBA;EACE,gBAAA;AH+zuBF;;AG7zuBA;EACE,gBAAA;AHg0uBF;;AG9zuBA;EACE,gBAAA;AHi0uBF;;AG/zuBA;EACE,gBAAA;AHk0uBF;;AGh0uBA;EACE,gBAAA;AHm0uBF;;AGj0uBA;EACE,gBAAA;AHo0uBF;;AGl0uBA;EACE,gBAAA;AHq0uBF;;AGn0uBA;EACE,gBAAA;AHs0uBF;;AGp0uBA;EACE,gBAAA;AHu0uBF;;AGr0uBA;EACE,gBAAA;AHw0uBF;;AGt0uBA;EACE,gBAAA;AHy0uBF;;AGv0uBA;EACE,gBAAA;AH00uBF;;AGx0uBA;EACE,gBAAA;AH20uBF;;AGz0uBA;EACE,gBAAA;AH40uBF;;AG10uBA;EACE,gBAAA;AH60uBF;;AG30uBA;EACE,gBAAA;AH80uBF;;AG50uBA;EACE,gBAAA;AH+0uBF;;AG70uBA;EACE,gBAAA;AHg1uBF;;AG90uBA;EACE,gBAAA;AHi1uBF;;AG/0uBA;EACE,gBAAA;AHk1uBF;;AGh1uBA;EACE,gBAAA;AHm1uBF;;AGj1uBA;EACE,gBAAA;AHo1uBF;;AGl1uBA;EACE,gBAAA;AHq1uBF;;AGn1uBA;EACE,gBAAA;AHs1uBF;;AGp1uBA;EACE,gBAAA;AHu1uBF;;AGr1uBA;EACE,gBAAA;AHw1uBF;;AGt1uBA;EACE,gBAAA;AHy1uBF;;AGv1uBA;EACE,gBAAA;AH01uBF;;AGx1uBA;EACE,gBAAA;AH21uBF;;AGz1uBA;EACE,gBAAA;AH41uBF;;AG11uBA;EACE,gBAAA;AH61uBF;;AG31uBA;EACE,gBAAA;AH81uBF;;AG51uBA;EACE,gBAAA;AH+1uBF;;AG71uBA;EACE,gBAAA;AHg2uBF;;AG91uBA;EACE,gBAAA;AHi2uBF;;AG/1uBA;EACE,gBAAA;AHk2uBF;;AGh2uBA;EACE,gBAAA;AHm2uBF;;AGj2uBA;EACE,gBAAA;AHo2uBF;;AGl2uBA;EACE,gBAAA;AHq2uBF;;AGn2uBA;EACE,gBAAA;AHs2uBF;;AGp2uBA;EACE,gBAAA;AHu2uBF;;AGr2uBA;EACE,gBAAA;AHw2uBF;;AGt2uBA;EACE,gBAAA;AHy2uBF;;AGv2uBA;EACE,gBAAA;AH02uBF;;AGx2uBA;EACE,gBAAA;AH22uBF;;AGz2uBA;EACE,gBAAA;AH42uBF;;AG12uBA;EACE,gBAAA;AH62uBF;;AG32uBA;EACE,gBAAA;AH82uBF;;AG52uBA;EACE,gBAAA;AH+2uBF;;AG72uBA;EACE,gBAAA;AHg3uBF;;AG92uBA;EACE,gBAAA;AHi3uBF;;AG/2uBA;EACE,gBAAA;AHk3uBF;;AGh3uBA;EACE,gBAAA;AHm3uBF;;AGj3uBA;EACE,gBAAA;AHo3uBF;;AGl3uBA;EACE,gBAAA;AHq3uBF;;AGn3uBA;EACE,gBAAA;AHs3uBF;;AGp3uBA;EACE,gBAAA;AHu3uBF;;AGr3uBA;EACE,gBAAA;AHw3uBF;;AGt3uBA;EACE,gBAAA;AHy3uBF;;AGv3uBA;EACE,gBAAA;AH03uBF;;AGx3uBA;EACE,gBAAA;AH23uBF;;AGz3uBA;EACE,gBAAA;AH43uBF;;AG13uBA;EACE,gBAAA;AH63uBF;;AG33uBA;EACE,gBAAA;AH83uBF;;AG53uBA;EACE,gBAAA;AH+3uBF;;AG73uBA;EACE,gBAAA;AHg4uBF;;AG93uBA;EACE,gBAAA;AHi4uBF;;AG/3uBA;EACE,gBAAA;AHk4uBF;;AGh4uBA;EACE,gBAAA;AHm4uBF;;AGj4uBA;EACE,gBAAA;AHo4uBF;;AGl4uBA;EACE,gBAAA;AHq4uBF;;AGn4uBA;EACE,gBAAA;AHs4uBF;;AGp4uBA;EACE,gBAAA;AHu4uBF;;AGr4uBA;EACE,gBAAA;AHw4uBF;;AGt4uBA;EACE,gBAAA;AHy4uBF;;AGv4uBA;EACE,gBAAA;AH04uBF;;AGx4uBA;EACE,gBAAA;AH24uBF;;AGz4uBA;EACE,gBAAA;AH44uBF;;AG14uBA;EACE,gBAAA;AH64uBF;;AG34uBA;EACE,gBAAA;AH84uBF;;AG54uBA;EACE,gBAAA;AH+4uBF;;AG74uBA;EACE,gBAAA;AHg5uBF;;AG94uBA;EACE,gBAAA;AHi5uBF;;AG/4uBA;EACE,gBAAA;AHk5uBF;;AGh5uBA;EACE,gBAAA;AHm5uBF;;AGj5uBA;EACE,gBAAA;AHo5uBF;;AGl5uBA;EACE,gBAAA;AHq5uBF;;AGn5uBA;EACE,gBAAA;AHs5uBF;;AGp5uBA;EACE,gBAAA;AHu5uBF;;AGr5uBA;EACE,gBAAA;AHw5uBF;;AGt5uBA;EACE,gBAAA;AHy5uBF;;AGv5uBA;EACE,gBAAA;AH05uBF;;AGx5uBA;EACE,gBAAA;AH25uBF;;AGz5uBA;EACE,gBAAA;AH45uBF;;AG15uBA;EACE,gBAAA;AH65uBF;;AG35uBA;EACE,gBAAA;AH85uBF;;AG55uBA;EACE,gBAAA;AH+5uBF;;AG75uBA;EACE,gBAAA;AHg6uBF;;AG95uBA;EACE,gBAAA;AHi6uBF;;AG/5uBA;EACE,gBAAA;AHk6uBF;;AGh6uBA;EACE,gBAAA;AHm6uBF;;AGj6uBA;EACE,gBAAA;AHo6uBF;;AGl6uBA;EACE,gBAAA;AHq6uBF;;AGn6uBA;EACE,gBAAA;AHs6uBF;;AGp6uBA;EACE,gBAAA;AHu6uBF;;AGr6uBA;EACE,gBAAA;AHw6uBF;;AGt6uBA;EACE,gBAAA;AHy6uBF;;AGv6uBA;EACE,gBAAA;AH06uBF;;AGx6uBA;EACE,gBAAA;AH26uBF;;AGz6uBA;EACE,gBAAA;AH46uBF;;AG16uBA;EACE,gBAAA;AH66uBF;;AG36uBA;EACE,gBAAA;AH86uBF;;AG56uBA;EACE,gBAAA;AH+6uBF;;AG76uBA;EACE,gBAAA;AHg7uBF;;AG96uBA;EACE,gBAAA;AHi7uBF;;AG/6uBA;EACE,gBAAA;AHk7uBF;;AGh7uBA;EACE,gBAAA;AHm7uBF;;AGj7uBA;EACE,gBAAA;AHo7uBF;;AGl7uBA;EACE,gBAAA;AHq7uBF;;AGn7uBA;EACE,gBAAA;AHs7uBF;;AGp7uBA;EACE,gBAAA;AHu7uBF;;AGr7uBA;EACE,gBAAA;AHw7uBF;;AGt7uBA;EACE,gBAAA;AHy7uBF;;AGv7uBA;EACE,gBAAA;AH07uBF;;AGx7uBA;EACE,gBAAA;AH27uBF;;AGz7uBA;EACE,gBAAA;AH47uBF;;AG17uBA;EACE,gBAAA;AH67uBF;;AG37uBA;EACE,gBAAA;AH87uBF;;AG57uBA;EACE,gBAAA;AH+7uBF;;AG77uBA;EACE,gBAAA;AHg8uBF;;AG97uBA;EACE,gBAAA;AHi8uBF;;AG/7uBA;EACE,gBAAA;AHk8uBF;;AGh8uBA;EACE,gBAAA;AHm8uBF;;AGj8uBA;EACE,gBAAA;AHo8uBF;;AGl8uBA;EACE,gBAAA;AHq8uBF;;AGn8uBA;EACE,gBAAA;AHs8uBF;;AGp8uBA;EACE,gBAAA;AHu8uBF;;AGr8uBA;EACE,gBAAA;AHw8uBF;;AGt8uBA;EACE,gBAAA;AHy8uBF;;AGv8uBA;EACE,gBAAA;AH08uBF;;AGx8uBA;EACE,gBAAA;AH28uBF;;AGz8uBA;EACE,gBAAA;AH48uBF;;AG18uBA;EACE,gBAAA;AH68uBF;;AG38uBA;EACE,gBAAA;AH88uBF;;AG58uBA;EACE,gBAAA;AH+8uBF;;AG78uBA;EACE,gBAAA;AHg9uBF;;AG98uBA;EACE,gBAAA;AHi9uBF;;AG/8uBA;EACE,gBAAA;AHk9uBF;;AGh9uBA;EACE,gBAAA;AHm9uBF;;AGj9uBA;EACE,gBAAA;AHo9uBF;;AGl9uBA;EACE,gBAAA;AHq9uBF;;AGn9uBA;EACE,gBAAA;AHs9uBF;;AGp9uBA;EACE,gBAAA;AHu9uBF;;AGr9uBA;EACE,gBAAA;AHw9uBF;;AGt9uBA;EACE,gBAAA;AHy9uBF;;AGv9uBA;EACE,gBAAA;AH09uBF;;AGx9uBA;EACE,gBAAA;AH29uBF;;AGz9uBA;EACE,gBAAA;AH49uBF;;AG19uBA;EACE,gBAAA;AH69uBF;;AG39uBA;EACE,gBAAA;AH89uBF;;AG59uBA;EACE,gBAAA;AH+9uBF;;AG79uBA;EACE,gBAAA;AHg+uBF;;AG99uBA;EACE,gBAAA;AHi+uBF;;AG/9uBA;EACE,gBAAA;AHk+uBF;;AGh+uBA;EACE,gBAAA;AHm+uBF;;AGj+uBA;EACE,gBAAA;AHo+uBF;;AGl+uBA;EACE,gBAAA;AHq+uBF;;AGn+uBA;EACE,gBAAA;AHs+uBF;;AGp+uBA;EACE,gBAAA;AHu+uBF;;AGr+uBA;EACE,gBAAA;AHw+uBF;;AGt+uBA;EACE,gBAAA;AHy+uBF;;AGv+uBA;EACE,gBAAA;AH0+uBF;;AGx+uBA;EACE,gBAAA;AH2+uBF;;AGz+uBA;EACE,gBAAA;AH4+uBF;;AG1+uBA;EACE,gBAAA;AH6+uBF;;AG3+uBA;EACE,gBAAA;AH8+uBF;;AG5+uBA;EACE,gBAAA;AH++uBF;;AG7+uBA;EACE,gBAAA;AHg/uBF;;AG9+uBA;EACE,gBAAA;AHi/uBF;;AG/+uBA;EACE,gBAAA;AHk/uBF;;AGh/uBA;EACE,gBAAA;AHm/uBF;;AGj/uBA;EACE,gBAAA;AHo/uBF;;AGl/uBA;EACE,gBAAA;AHq/uBF;;AGn/uBA;EACE,gBAAA;AHs/uBF;;AGp/uBA;EACE,gBAAA;AHu/uBF;;AGr/uBA;EACE,gBAAA;AHw/uBF;;AGt/uBA;EACE,gBAAA;AHy/uBF;;AGv/uBA;EACE,gBAAA;AH0/uBF;;AGx/uBA;EACE,gBAAA;AH2/uBF;;AGz/uBA;EACE,gBAAA;AH4/uBF;;AG1/uBA;EACE,gBAAA;AH6/uBF;;AG3/uBA;EACE,gBAAA;AH8/uBF;;AG5/uBA;EACE,gBAAA;AH+/uBF;;AG7/uBA;EACE,gBAAA;AHggvBF;;AG9/uBA;EACE,gBAAA;AHigvBF;;AG//uBA;EACE,gBAAA;AHkgvBF;;AGhgvBA;EACE,gBAAA;AHmgvBF;;AGjgvBA;EACE,gBAAA;AHogvBF;;AGlgvBA;EACE,gBAAA;AHqgvBF;;AGngvBA;EACE,gBAAA;AHsgvBF;;AGpgvBA;EACE,gBAAA;AHugvBF;;AGrgvBA;EACE,gBAAA;AHwgvBF;;AGtgvBA;EACE,gBAAA;AHygvBF;;AGvgvBA;EACE,gBAAA;AH0gvBF;;AGxgvBA;EACE,gBAAA;AH2gvBF;;AGzgvBA;EACE,gBAAA;AH4gvBF;;AG1gvBA;EACE,gBAAA;AH6gvBF;;AG3gvBA;EACE,gBAAA;AH8gvBF;;AG5gvBA;EACE,gBAAA;AH+gvBF;;AG7gvBA;EACE,gBAAA;AHghvBF;;AG9gvBA;EACE,gBAAA;AHihvBF;;AG/gvBA;EACE,gBAAA;AHkhvBF;;AGhhvBA;EACE,gBAAA;AHmhvBF;;AGjhvBA;EACE,gBAAA;AHohvBF;;AGlhvBA;EACE,gBAAA;AHqhvBF;;AGnhvBA;EACE,gBAAA;AHshvBF;;AGphvBA;EACE,gBAAA;AHuhvBF;;AGrhvBA;EACE,gBAAA;AHwhvBF;;AGthvBA;EACE,gBAAA;AHyhvBF;;AGvhvBA;EACE,gBAAA;AH0hvBF;;AGxhvBA;EACE,gBAAA;AH2hvBF;;AGzhvBA;EACE,gBAAA;AH4hvBF;;AG1hvBA;EACE,gBAAA;AH6hvBF;;AG3hvBA;EACE,gBAAA;AH8hvBF;;AG5hvBA;EACE,gBAAA;AH+hvBF;;AG7hvBA;EACE,gBAAA;AHgivBF;;AG9hvBA;EACE,gBAAA;AHiivBF;;AG/hvBA;EACE,gBAAA;AHkivBF;;AGhivBA;EACE,gBAAA;AHmivBF;;AGjivBA;EACE,gBAAA;AHoivBF;;AGlivBA;EACE,gBAAA;AHqivBF;;AGnivBA;EACE,gBAAA;AHsivBF;;AGpivBA;EACE,gBAAA;AHuivBF;;AGrivBA;EACE,gBAAA;AHwivBF;;AGtivBA;EACE,gBAAA;AHyivBF;;AGvivBA;EACE,gBAAA;AH0ivBF;;AGxivBA;EACE,gBAAA;AH2ivBF;;AGzivBA;EACE,gBAAA;AH4ivBF;;AG1ivBA;EACE,gBAAA;AH6ivBF;;AG3ivBA;EACE,gBAAA;AH8ivBF;;AG5ivBA;EACE,gBAAA;AH+ivBF;;AG7ivBA;EACE,gBAAA;AHgjvBF;;AG9ivBA;EACE,gBAAA;AHijvBF;;AG/ivBA;EACE,gBAAA;AHkjvBF;;AGhjvBA;EACE,gBAAA;AHmjvBF;;AGjjvBA;EACE,gBAAA;AHojvBF;;AGljvBA;EACE,gBAAA;AHqjvBF;;AGnjvBA;EACE,gBAAA;AHsjvBF;;AGpjvBA;EACE,gBAAA;AHujvBF;;AGrjvBA;EACE,gBAAA;AHwjvBF;;AGtjvBA;EACE,gBAAA;AHyjvBF;;AGvjvBA;EACE,gBAAA;AH0jvBF;;AGxjvBA;EACE,gBAAA;AH2jvBF;;AGzjvBA;EACE,gBAAA;AH4jvBF;;AG1jvBA;EACE,gBAAA;AH6jvBF;;AG3jvBA;EACE,gBAAA;AH8jvBF;;AG5jvBA;EACE,gBAAA;AH+jvBF;;AG7jvBA;EACE,gBAAA;AHgkvBF;;AG9jvBA;EACE,gBAAA;AHikvBF;;AG/jvBA;EACE,gBAAA;AHkkvBF;;AGhkvBA;EACE,gBAAA;AHmkvBF;;AGjkvBA;EACE,gBAAA;AHokvBF;;AGlkvBA;EACE,gBAAA;AHqkvBF;;AGnkvBA;EACE,gBAAA;AHskvBF;;AGpkvBA;EACE,gBAAA;AHukvBF;;AGrkvBA;EACE,gBAAA;AHwkvBF;;AGtkvBA;EACE,gBAAA;AHykvBF;;AGvkvBA;EACE,gBAAA;AH0kvBF;;AGxkvBA;EACE,gBAAA;AH2kvBF;;AGzkvBA;EACE,gBAAA;AH4kvBF;;AG1kvBA;EACE,gBAAA;AH6kvBF;;AG3kvBA;EACE,gBAAA;AH8kvBF;;AG5kvBA;EACE,gBAAA;AH+kvBF;;AG7kvBA;EACE,gBAAA;AHglvBF;;AG9kvBA;EACE,gBAAA;AHilvBF;;AG/kvBA;EACE,gBAAA;AHklvBF;;AGhlvBA;EACE,gBAAA;AHmlvBF;;AGjlvBA;EACE,gBAAA;AHolvBF;;AGllvBA;EACE,gBAAA;AHqlvBF;;AGnlvBA;EACE,gBAAA;AHslvBF;;AGplvBA;EACE,gBAAA;AHulvBF;;AGrlvBA;EACE,gBAAA;AHwlvBF;;AGtlvBA;EACE,gBAAA;AHylvBF;;AGvlvBA;EACE,gBAAA;AH0lvBF;;AGxlvBA;EACE,gBAAA;AH2lvBF;;AGzlvBA;EACE,gBAAA;AH4lvBF;;AG1lvBA;EACE,gBAAA;AH6lvBF;;AG3lvBA;EACE,gBAAA;AH8lvBF;;AG5lvBA;EACE,gBAAA;AH+lvBF;;AG7lvBA;EACE,gBAAA;AHgmvBF;;AG9lvBA;EACE,gBAAA;AHimvBF;;AG/lvBA;EACE,gBAAA;AHkmvBF;;AGhmvBA;EACE,gBAAA;AHmmvBF;;AGjmvBA;EACE,gBAAA;AHomvBF;;AGlmvBA;EACE,gBAAA;AHqmvBF;;AGnmvBA;EACE,gBAAA;AHsmvBF;;AGpmvBA;EACE,gBAAA;AHumvBF;;AGrmvBA;EACE,gBAAA;AHwmvBF;;AGtmvBA;EACE,gBAAA;AHymvBF;;AGvmvBA;EACE,gBAAA;AH0mvBF;;AGxmvBA;EACE,gBAAA;AH2mvBF;;AGzmvBA;EACE,gBAAA;AH4mvBF;;AG1mvBA;EACE,gBAAA;AH6mvBF;;AG3mvBA;EACE,gBAAA;AH8mvBF;;AG5mvBA;EACE,gBAAA;AH+mvBF;;AG7mvBA;EACE,gBAAA;AHgnvBF;;AG9mvBA;EACE,gBAAA;AHinvBF;;AG/mvBA;EACE,gBAAA;AHknvBF;;AGhnvBA;EACE,gBAAA;AHmnvBF;;AGjnvBA;EACE,gBAAA;AHonvBF;;AGlnvBA;EACE,gBAAA;AHqnvBF;;AGnnvBA;EACE,gBAAA;AHsnvBF;;AGpnvBA;EACE,gBAAA;AHunvBF;;AGrnvBA;EACE,gBAAA;AHwnvBF;;AGtnvBA;EACE,gBAAA;AHynvBF;;AGvnvBA;EACE,gBAAA;AH0nvBF;;AGxnvBA;EACE,gBAAA;AH2nvBF;;AGznvBA;EACE,gBAAA;AH4nvBF;;AG1nvBA;EACE,gBAAA;AH6nvBF;;AG3nvBA;EACE,gBAAA;AH8nvBF;;AG5nvBA;EACE,gBAAA;AH+nvBF;;AG7nvBA;EACE,gBAAA;AHgovBF;;AG9nvBA;EACE,gBAAA;AHiovBF;;AG/nvBA;EACE,gBAAA;AHkovBF;;AGhovBA;EACE,gBAAA;AHmovBF;;AGjovBA;EACE,gBAAA;AHoovBF;;AGlovBA;EACE,gBAAA;AHqovBF;;AGnovBA;EACE,gBAAA;AHsovBF;;AGpovBA;EACE,gBAAA;AHuovBF;;AGrovBA;EACE,gBAAA;AHwovBF;;AGtovBA;EACE,gBAAA;AHyovBF;;AGvovBA;EACE,gBAAA;AH0ovBF;;AGxovBA;EACE,gBAAA;AH2ovBF;;AGzovBA;EACE,gBAAA;AH4ovBF;;AG1ovBA;EACE,gBAAA;AH6ovBF;;AG3ovBA;EACE,gBAAA;AH8ovBF;;AG5ovBA;EACE,gBAAA;AH+ovBF;;AG7ovBA;EACE,gBAAA;AHgpvBF;;AG9ovBA;EACE,gBAAA;AHipvBF;;AG/ovBA;EACE,gBAAA;AHkpvBF;;AGhpvBA;EACE,gBAAA;AHmpvBF;;AGjpvBA;EACE,gBAAA;AHopvBF;;AGlpvBA;EACE,gBAAA;AHqpvBF;;AGnpvBA;EACE,gBAAA;AHspvBF;;AGppvBA;EACE,gBAAA;AHupvBF;;AGrpvBA;EACE,gBAAA;AHwpvBF;;AGtpvBA;EACE,gBAAA;AHypvBF;;AGvpvBA;EACE,gBAAA;AH0pvBF;;AGxpvBA;EACE,gBAAA;AH2pvBF;;AGzpvBA;EACE,gBAAA;AH4pvBF;;AG1pvBA;EACE,gBAAA;AH6pvBF;;AG3pvBA;EACE,gBAAA;AH8pvBF;;AG5pvBA;EACE,gBAAA;AH+pvBF;;AG7pvBA;EACE,gBAAA;AHgqvBF;;AG9pvBA;EACE,gBAAA;AHiqvBF;;AG/pvBA;EACE,gBAAA;AHkqvBF;;AGhqvBA;EACE,gBAAA;AHmqvBF;;AGjqvBA;EACE,gBAAA;AHoqvBF;;AGlqvBA;EACE,gBAAA;AHqqvBF;;AGnqvBA;EACE,gBAAA;AHsqvBF;;AGpqvBA;EACE,gBAAA;AHuqvBF;;AGrqvBA;EACE,gBAAA;AHwqvBF;;AGtqvBA;EACE,gBAAA;AHyqvBF;;AGvqvBA;EACE,gBAAA;AH0qvBF;;AGxqvBA;EACE,gBAAA;AH2qvBF;;AGzqvBA;EACE,gBAAA;AH4qvBF;;AG1qvBA;EACE,gBAAA;AH6qvBF;;AG3qvBA;EACE,gBAAA;AH8qvBF;;AG5qvBA;EACE,gBAAA;AH+qvBF;;AG7qvBA;EACE,gBAAA;AHgrvBF;;AG9qvBA;EACE,gBAAA;AHirvBF;;AG/qvBA;EACE,gBAAA;AHkrvBF;;AGhrvBA;EACE,gBAAA;AHmrvBF;;AGjrvBA;EACE,gBAAA;AHorvBF;;AGlrvBA;EACE,gBAAA;AHqrvBF;;AGnrvBA;EACE,gBAAA;AHsrvBF;;AGprvBA;EACE,gBAAA;AHurvBF;;AGrrvBA;EACE,gBAAA;AHwrvBF;;AGtrvBA;EACE,gBAAA;AHyrvBF;;AGvrvBA;EACE,gBAAA;AH0rvBF;;AGxrvBA;EACE,gBAAA;AH2rvBF;;AGzrvBA;EACE,gBAAA;AH4rvBF;;AG1rvBA;EACE,gBAAA;AH6rvBF;;AG3rvBA;EACE,gBAAA;AH8rvBF;;AG5rvBA;EACE,gBAAA;AH+rvBF;;AG7rvBA;EACE,gBAAA;AHgsvBF;;AG9rvBA;EACE,gBAAA;AHisvBF;;AG/rvBA;EACE,gBAAA;AHksvBF;;AGhsvBA;EACE,gBAAA;AHmsvBF;;AGjsvBA;EACE,gBAAA;AHosvBF;;AGlsvBA;EACE,gBAAA;AHqsvBF;;AGnsvBA;EACE,gBAAA;AHssvBF;;AGpsvBA;EACE,gBAAA;AHusvBF;;AGrsvBA;EACE,gBAAA;AHwsvBF;;AGtsvBA;EACE,gBAAA;AHysvBF;;AGvsvBA;EACE,gBAAA;AH0svBF;;AGxsvBA;EACE,gBAAA;AH2svBF;;AGzsvBA;EACE,gBAAA;AH4svBF;;AG1svBA;EACE,gBAAA;AH6svBF;;AG3svBA;EACE,gBAAA;AH8svBF;;AG5svBA;EACE,gBAAA;AH+svBF;;AG7svBA;EACE,gBAAA;AHgtvBF;;AG9svBA;EACE,gBAAA;AHitvBF;;AG/svBA;EACE,gBAAA;AHktvBF;;AGhtvBA;EACE,gBAAA;AHmtvBF;;AGjtvBA;EACE,gBAAA;AHotvBF;;AGltvBA;EACE,gBAAA;AHqtvBF;;AGntvBA;EACE,gBAAA;AHstvBF;;AGptvBA;EACE,gBAAA;AHutvBF;;AGrtvBA;EACE,gBAAA;AHwtvBF;;AGttvBA;EACE,gBAAA;AHytvBF;;AGvtvBA;EACE,gBAAA;AH0tvBF;;AGxtvBA;EACE,gBAAA;AH2tvBF;;AGztvBA;EACE,gBAAA;AH4tvBF;;AG1tvBA;EACE,gBAAA;AH6tvBF;;AG3tvBA;EACE,gBAAA;AH8tvBF;;AG5tvBA;EACE,gBAAA;AH+tvBF;;AG7tvBA;EACE,gBAAA;AHguvBF;;AG9tvBA;EACE,gBAAA;AHiuvBF;;AG/tvBA;EACE,gBAAA;AHkuvBF;;AGhuvBA;EACE,gBAAA;AHmuvBF;;AGjuvBA;EACE,gBAAA;AHouvBF;;AGluvBA;EACE,gBAAA;AHquvBF;;AGnuvBA;EACE,gBAAA;AHsuvBF;;AGpuvBA;EACE,gBAAA;AHuuvBF;;AGruvBA;EACE,gBAAA;AHwuvBF;;AGtuvBA;EACE,gBAAA;AHyuvBF;;AGvuvBA;EACE,gBAAA;AH0uvBF;;AGxuvBA;EACE,gBAAA;AH2uvBF;;AGzuvBA;EACE,gBAAA;AH4uvBF;;AG1uvBA;EACE,gBAAA;AH6uvBF;;AG3uvBA;EACE,gBAAA;AH8uvBF;;AG5uvBA;EACE,gBAAA;AH+uvBF;;AG7uvBA;EACE,gBAAA;AHgvvBF;;AG9uvBA;EACE,gBAAA;AHivvBF;;AG/uvBA;EACE,gBAAA;AHkvvBF;;AGhvvBA;EACE,gBAAA;AHmvvBF;;AGjvvBA;EACE,gBAAA;AHovvBF;;AGlvvBA;EACE,gBAAA;AHqvvBF;;AGnvvBA;EACE,gBAAA;AHsvvBF;;AGpvvBA;EACE,gBAAA;AHuvvBF;;AGrvvBA;EACE,gBAAA;AHwvvBF;;AGtvvBA;EACE,gBAAA;AHyvvBF;;AGvvvBA;EACE,gBAAA;AH0vvBF;;AGxvvBA;EACE,gBAAA;AH2vvBF;;AGzvvBA;EACE,gBAAA;AH4vvBF;;AG1vvBA;EACE,gBAAA;AH6vvBF;;AG3vvBA;EACE,gBAAA;AH8vvBF;;AG5vvBA;EACE,gBAAA;AH+vvBF;;AG7vvBA;EACE,gBAAA;AHgwvBF;;AG9vvBA;EACE,gBAAA;AHiwvBF;;AG/vvBA;EACE,gBAAA;AHkwvBF;;AGhwvBA;EACE,gBAAA;AHmwvBF;;AGjwvBA;EACE,gBAAA;AHowvBF;;AGlwvBA;EACE,gBAAA;AHqwvBF;;AGnwvBA;EACE,gBAAA;AHswvBF;;AGpwvBA;EACE,gBAAA;AHuwvBF;;AGrwvBA;EACE,gBAAA;AHwwvBF;;AGtwvBA;EACE,gBAAA;AHywvBF;;AGvwvBA;EACE,gBAAA;AH0wvBF;;AGxwvBA;EACE,gBAAA;AH2wvBF;;AGzwvBA;EACE,gBAAA;AH4wvBF;;AG1wvBA;EACE,gBAAA;AH6wvBF;;AG3wvBA;EACE,gBAAA;AH8wvBF;;AG5wvBA;EACE,gBAAA;AH+wvBF;;AG7wvBA;EACE,gBAAA;AHgxvBF;;AG9wvBA;EACE,gBAAA;AHixvBF;;AG/wvBA;EACE,gBAAA;AHkxvBF;;AGhxvBA;EACE,gBAAA;AHmxvBF;;AGjxvBA;EACE,gBAAA;AHoxvBF;;AGlxvBA;EACE,gBAAA;AHqxvBF;;AGnxvBA;EACE,gBAAA;AHsxvBF;;AGpxvBA;EACE,gBAAA;AHuxvBF;;AGrxvBA;EACE,gBAAA;AHwxvBF;;AGtxvBA;EACE,gBAAA;AHyxvBF;;AGvxvBA;EACE,gBAAA;AH0xvBF;;AGxxvBA;EACE,gBAAA;AH2xvBF;;AGzxvBA;EACE,gBAAA;AH4xvBF;;AG1xvBA;EACE,gBAAA;AH6xvBF;;AG3xvBA;EACE,gBAAA;AH8xvBF;;AG5xvBA;EACE,gBAAA;AH+xvBF;;AG7xvBA;EACE,gBAAA;AHgyvBF;;AG9xvBA;EACE,gBAAA;AHiyvBF;;AG/xvBA;EACE,gBAAA;AHkyvBF;;AGhyvBA;EACE,gBAAA;AHmyvBF;;AGjyvBA;EACE,gBAAA;AHoyvBF;;AGlyvBA;EACE,gBAAA;AHqyvBF;;AGnyvBA;EACE,gBAAA;AHsyvBF;;AGpyvBA;EACE,gBAAA;AHuyvBF;;AGryvBA;EACE,gBAAA;AHwyvBF;;AGtyvBA;EACE,gBAAA;AHyyvBF;;AGvyvBA;EACE,gBAAA;AH0yvBF;;AGxyvBA;EACE,gBAAA;AH2yvBF;;AGzyvBA;EACE,gBAAA;AH4yvBF;;AG1yvBA;EACE,gBAAA;AH6yvBF;;AG3yvBA;EACE,gBAAA;AH8yvBF;;AG5yvBA;EACE,gBAAA;AH+yvBF;;AG7yvBA;EACE,gBAAA;AHgzvBF;;AG9yvBA;EACE,gBAAA;AHizvBF;;AG/yvBA;EACE,gBAAA;AHkzvBF;;AGhzvBA;EACE,gBAAA;AHmzvBF;;AGjzvBA;EACE,gBAAA;AHozvBF;;AGlzvBA;EACE,gBAAA;AHqzvBF;;AGnzvBA;EACE,gBAAA;AHszvBF;;AGpzvBA;EACE,gBAAA;AHuzvBF;;AGrzvBA;EACE,gBAAA;AHwzvBF;;AGtzvBA;EACE,gBAAA;AHyzvBF;;AGvzvBA;EACE,gBAAA;AH0zvBF;;AGxzvBA;EACE,gBAAA;AH2zvBF;;AGzzvBA;EACE,gBAAA;AH4zvBF;;AG1zvBA;EACE,gBAAA;AH6zvBF;;AG3zvBA;EACE,gBAAA;AH8zvBF;;AG5zvBA;EACE,gBAAA;AH+zvBF;;AG7zvBA;EACE,gBAAA;AHg0vBF;;AG9zvBA;EACE,gBAAA;AHi0vBF;;AG/zvBA;EACE,gBAAA;AHk0vBF;;AGh0vBA;EACE,gBAAA;AHm0vBF;;AGj0vBA;EACE,gBAAA;AHo0vBF;;AGl0vBA;EACE,gBAAA;AHq0vBF;;AGn0vBA;EACE,gBAAA;AHs0vBF;;AGp0vBA;EACE,gBAAA;AHu0vBF;;AGr0vBA;EACE,gBAAA;AHw0vBF;;AGt0vBA;EACE,gBAAA;AHy0vBF;;AGv0vBA;EACE,gBAAA;AH00vBF;;AGx0vBA;EACE,gBAAA;AH20vBF;;AGz0vBA;EACE,gBAAA;AH40vBF;;AG10vBA;EACE,gBAAA;AH60vBF;;AG30vBA;EACE,gBAAA;AH80vBF;;AG50vBA;EACE,gBAAA;AH+0vBF;;AG70vBA;EACE,gBAAA;AHg1vBF;;AG90vBA;EACE,gBAAA;AHi1vBF;;AG/0vBA;EACE,gBAAA;AHk1vBF;;AGh1vBA;EACE,gBAAA;AHm1vBF;;AGj1vBA;EACE,gBAAA;AHo1vBF;;AGl1vBA;EACE,gBAAA;AHq1vBF;;AGn1vBA;EACE,gBAAA;AHs1vBF;;AGp1vBA;EACE,gBAAA;AHu1vBF;;AGr1vBA;EACE,gBAAA;AHw1vBF;;AGt1vBA;EACE,gBAAA;AHy1vBF;;AGv1vBA;EACE,gBAAA;AH01vBF;;AGx1vBA;EACE,gBAAA;AH21vBF;;AGz1vBA;EACE,gBAAA;AH41vBF;;AG11vBA;EACE,gBAAA;AH61vBF;;AG31vBA;EACE,gBAAA;AH81vBF;;AG51vBA;EACE,gBAAA;AH+1vBF;;AG71vBA;EACE,gBAAA;AHg2vBF;;AG91vBA;EACE,gBAAA;AHi2vBF;;AG/1vBA;EACE,gBAAA;AHk2vBF;;AGh2vBA;EACE,gBAAA;AHm2vBF;;AGj2vBA;EACE,gBAAA;AHo2vBF;;AGl2vBA;EACE,gBAAA;AHq2vBF;;AGn2vBA;EACE,gBAAA;AHs2vBF;;AGp2vBA;EACE,gBAAA;AHu2vBF;;AGr2vBA;EACE,gBAAA;AHw2vBF;;AGt2vBA;EACE,gBAAA;AHy2vBF;;AGv2vBA;EACE,gBAAA;AH02vBF;;AGx2vBA;EACE,gBAAA;AH22vBF;;AGz2vBA;EACE,gBAAA;AH42vBF;;AG12vBA;EACE,gBAAA;AH62vBF;;AG32vBA;EACE,gBAAA;AH82vBF;;AG52vBA;EACE,gBAAA;AH+2vBF;;AG72vBA;EACE,gBAAA;AHg3vBF;;AG92vBA;EACE,gBAAA;AHi3vBF;;AG/2vBA;EACE,gBAAA;AHk3vBF;;AGh3vBA;EACE,gBAAA;AHm3vBF;;AGj3vBA;EACE,gBAAA;AHo3vBF;;AGl3vBA;EACE,gBAAA;AHq3vBF;;AGn3vBA;EACE,gBAAA;AHs3vBF;;AGp3vBA;EACE,gBAAA;AHu3vBF;;AGr3vBA;EACE,gBAAA;AHw3vBF;;AGt3vBA;EACE,gBAAA;AHy3vBF;;AGv3vBA;EACE,gBAAA;AH03vBF;;AGx3vBA;EACE,gBAAA;AH23vBF;;AGz3vBA;EACE,gBAAA;AH43vBF;;AG13vBA;EACE,gBAAA;AH63vBF;;AG33vBA;EACE,gBAAA;AH83vBF;;AG53vBA;EACE,gBAAA;AH+3vBF;;AG73vBA;EACE,gBAAA;AHg4vBF;;AG93vBA;EACE,gBAAA;AHi4vBF;;AG/3vBA;EACE,gBAAA;AHk4vBF;;AGh4vBA;EACE,gBAAA;AHm4vBF;;AGj4vBA;EACE,gBAAA;AHo4vBF;;AGl4vBA;EACE,gBAAA;AHq4vBF;;AGn4vBA;EACE,gBAAA;AHs4vBF;;AGp4vBA;EACE,gBAAA;AHu4vBF;;AGr4vBA;EACE,gBAAA;AHw4vBF;;AGt4vBA;EACE,gBAAA;AHy4vBF;;AGv4vBA;EACE,gBAAA;AH04vBF;;AGx4vBA;EACE,gBAAA;AH24vBF;;AGz4vBA;EACE,gBAAA;AH44vBF;;AG14vBA;EACE,gBAAA;AH64vBF;;AG34vBA;EACE,gBAAA;AH84vBF;;AG54vBA;EACE,gBAAA;AH+4vBF;;AG74vBA;EACE,gBAAA;AHg5vBF;;AG94vBA;EACE,gBAAA;AHi5vBF;;AG/4vBA;EACE,gBAAA;AHk5vBF;;AGh5vBA;EACE,gBAAA;AHm5vBF;;AGj5vBA;EACE,gBAAA;AHo5vBF;;AGl5vBA;EACE,gBAAA;AHq5vBF;;AGn5vBA;EACE,gBAAA;AHs5vBF;;AGp5vBA;EACE,gBAAA;AHu5vBF;;AGr5vBA;EACE,gBAAA;AHw5vBF;;AGt5vBA;EACE,gBAAA;AHy5vBF;;AGv5vBA;EACE,gBAAA;AH05vBF;;AGx5vBA;EACE,gBAAA;AH25vBF;;AGz5vBA;EACE,gBAAA;AH45vBF;;AG15vBA;EACE,gBAAA;AH65vBF;;AG35vBA;EACE,gBAAA;AH85vBF;;AG55vBA;EACE,gBAAA;AH+5vBF;;AG75vBA;EACE,gBAAA;AHg6vBF;;AG95vBA;EACE,gBAAA;AHi6vBF;;AG/5vBA;EACE,gBAAA;AHk6vBF;;AGh6vBA;EACE,gBAAA;AHm6vBF;;AGj6vBA;EACE,gBAAA;AHo6vBF;;AGl6vBA;EACE,gBAAA;AHq6vBF;;AGn6vBA;EACE,gBAAA;AHs6vBF;;AGp6vBA;EACE,gBAAA;AHu6vBF;;AGr6vBA;EACE,gBAAA;AHw6vBF;;AGt6vBA;EACE,gBAAA;AHy6vBF;;AGv6vBA;EACE,gBAAA;AH06vBF;;AGx6vBA;EACE,gBAAA;AH26vBF;;AGz6vBA;EACE,gBAAA;AH46vBF;;AG16vBA;EACE,gBAAA;AH66vBF;;AG36vBA;EACE,gBAAA;AH86vBF;;AG56vBA;EACE,gBAAA;AH+6vBF;;AG76vBA;EACE,gBAAA;AHg7vBF;;AG96vBA;EACE,gBAAA;AHi7vBF;;AG/6vBA;EACE,gBAAA;AHk7vBF;;AGh7vBA;EACE,gBAAA;AHm7vBF;;AGj7vBA;EACE,gBAAA;AHo7vBF;;AGl7vBA;EACE,gBAAA;AHq7vBF;;AGn7vBA;EACE,gBAAA;AHs7vBF;;AGp7vBA;EACE,gBAAA;AHu7vBF;;AGr7vBA;EACE,gBAAA;AHw7vBF;;AGt7vBA;EACE,gBAAA;AHy7vBF;;AGv7vBA;EACE,gBAAA;AH07vBF;;AGx7vBA;EACE,gBAAA;AH27vBF;;AGz7vBA;EACE,gBAAA;AH47vBF;;AG17vBA;EACE,gBAAA;AH67vBF;;AG37vBA;EACE,gBAAA;AH87vBF;;AG57vBA;EACE,gBAAA;AH+7vBF;;AG77vBA;EACE,gBAAA;AHg8vBF;;AG97vBA;EACE,gBAAA;AHi8vBF;;AG/7vBA;EACE,gBAAA;AHk8vBF;;AGh8vBA;EACE,gBAAA;AHm8vBF;;AGj8vBA;EACE,gBAAA;AHo8vBF;;AGl8vBA;EACE,gBAAA;AHq8vBF;;AGn8vBA;EACE,gBAAA;AHs8vBF;;AGp8vBA;EACE,gBAAA;AHu8vBF;;AGr8vBA;EACE,gBAAA;AHw8vBF;;AGt8vBA;EACE,gBAAA;AHy8vBF;;AGv8vBA;EACE,gBAAA;AH08vBF;;AGx8vBA;EACE,gBAAA;AH28vBF;;AGz8vBA;EACE,gBAAA;AH48vBF;;AG18vBA;EACE,gBAAA;AH68vBF;;AG38vBA;EACE,gBAAA;AH88vBF;;AG58vBA;EACE,gBAAA;AH+8vBF;;AG78vBA;EACE,gBAAA;AHg9vBF;;AG98vBA;EACE,gBAAA;AHi9vBF;;AG/8vBA;EACE,gBAAA;AHk9vBF;;AGh9vBA;EACE,gBAAA;AHm9vBF;;AGj9vBA;EACE,gBAAA;AHo9vBF;;AGl9vBA;EACE,gBAAA;AHq9vBF;;AGn9vBA;EACE,gBAAA;AHs9vBF;;AGp9vBA;EACE,gBAAA;AHu9vBF;;AGr9vBA;EACE,gBAAA;AHw9vBF;;AGt9vBA;EACE,gBAAA;AHy9vBF;;AGv9vBA;EACE,gBAAA;AH09vBF;;AGx9vBA;EACE,gBAAA;AH29vBF;;AGz9vBA;EACE,gBAAA;AH49vBF;;AG19vBA;EACE,gBAAA;AH69vBF;;AG39vBA;EACE,gBAAA;AH89vBF;;AG59vBA;EACE,gBAAA;AH+9vBF;;AG79vBA;EACE,gBAAA;AHg+vBF;;AG99vBA;EACE,gBAAA;AHi+vBF;;AG/9vBA;EACE,gBAAA;AHk+vBF;;AGh+vBA;EACE,gBAAA;AHm+vBF;;AGj+vBA;EACE,gBAAA;AHo+vBF;;AGl+vBA;EACE,gBAAA;AHq+vBF;;AGn+vBA;EACE,gBAAA;AHs+vBF;;AGp+vBA;EACE,gBAAA;AHu+vBF;;AGr+vBA;EACE,gBAAA;AHw+vBF;;AGt+vBA;EACE,gBAAA;AHy+vBF;;AGv+vBA;EACE,gBAAA;AH0+vBF;;AGx+vBA;EACE,gBAAA;AH2+vBF;;AGz+vBA;EACE,gBAAA;AH4+vBF;;AG1+vBA;EACE,gBAAA;AH6+vBF;;AG3+vBA;EACE,gBAAA;AH8+vBF;;AG5+vBA;EACE,gBAAA;AH++vBF;;AG7+vBA;EACE,gBAAA;AHg/vBF;;AG9+vBA;EACE,gBAAA;AHi/vBF;;AG/+vBA;EACE,gBAAA;AHk/vBF;;AGh/vBA;EACE,gBAAA;AHm/vBF;;AGj/vBA;EACE,gBAAA;AHo/vBF;;AGl/vBA;EACE,gBAAA;AHq/vBF;;AGn/vBA;EACE,gBAAA;AHs/vBF;;AGp/vBA;EACE,gBAAA;AHu/vBF;;AGr/vBA;EACE,gBAAA;AHw/vBF;;AGt/vBA;EACE,gBAAA;AHy/vBF;;AGv/vBA;EACE,gBAAA;AH0/vBF;;AGx/vBA;EACE,gBAAA;AH2/vBF;;AGz/vBA;EACE,gBAAA;AH4/vBF;;AG1/vBA;EACE,gBAAA;AH6/vBF;;AG3/vBA;EACE,gBAAA;AH8/vBF;;AG5/vBA;EACE,gBAAA;AH+/vBF;;AG7/vBA;EACE,gBAAA;AHggwBF;;AG9/vBA;EACE,gBAAA;AHigwBF;;AG//vBA;EACE,gBAAA;AHkgwBF;;AGhgwBA;EACE,gBAAA;AHmgwBF;;AGjgwBA;EACE,gBAAA;AHogwBF;;AGlgwBA;EACE,gBAAA;AHqgwBF;;AGngwBA;EACE,gBAAA;AHsgwBF;;AGpgwBA;EACE,gBAAA;AHugwBF;;AGrgwBA;EACE,gBAAA;AHwgwBF;;AGtgwBA;EACE,gBAAA;AHygwBF;;AGvgwBA;EACE,gBAAA;AH0gwBF;;AGxgwBA;EACE,gBAAA;AH2gwBF;;AGzgwBA;EACE,gBAAA;AH4gwBF;;AG1gwBA;EACE,gBAAA;AH6gwBF;;AG3gwBA;EACE,gBAAA;AH8gwBF;;AG5gwBA;EACE,gBAAA;AH+gwBF;;AG7gwBA;EACE,gBAAA;AHghwBF;;AG9gwBA;EACE,gBAAA;AHihwBF;;AG/gwBA;EACE,gBAAA;AHkhwBF;;AGhhwBA;EACE,gBAAA;AHmhwBF;;AGjhwBA;EACE,gBAAA;AHohwBF;;AGlhwBA;EACE,gBAAA;AHqhwBF;;AGnhwBA;EACE,gBAAA;AHshwBF;;AGphwBA;EACE,gBAAA;AHuhwBF;;AGrhwBA;EACE,gBAAA;AHwhwBF;;AGthwBA;EACE,gBAAA;AHyhwBF;;AGvhwBA;EACE,gBAAA;AH0hwBF;;AGxhwBA;EACE,gBAAA;AH2hwBF;;AGzhwBA;EACE,gBAAA;AH4hwBF;;AG1hwBA;EACE,gBAAA;AH6hwBF;;AG3hwBA;EACE,gBAAA;AH8hwBF;;AG5hwBA;EACE,gBAAA;AH+hwBF;;AG7hwBA;EACE,gBAAA;AHgiwBF;;AG9hwBA;EACE,gBAAA;AHiiwBF;;AG/hwBA;EACE,gBAAA;AHkiwBF;;AGhiwBA;EACE,gBAAA;AHmiwBF;;AGjiwBA;EACE,gBAAA;AHoiwBF;;AGliwBA;EACE,gBAAA;AHqiwBF;;AGniwBA;EACE,gBAAA;AHsiwBF;;AGpiwBA;EACE,gBAAA;AHuiwBF;;AGriwBA;EACE,gBAAA;AHwiwBF;;AGtiwBA;EACE,gBAAA;AHyiwBF;;AGviwBA;EACE,gBAAA;AH0iwBF;;AGxiwBA;EACE,gBAAA;AH2iwBF;;AGziwBA;EACE,gBAAA;AH4iwBF;;AG1iwBA;EACE,gBAAA;AH6iwBF;;AG3iwBA;EACE,gBAAA;AH8iwBF;;AG5iwBA;EACE,gBAAA;AH+iwBF;;AG7iwBA;EACE,gBAAA;AHgjwBF;;AG9iwBA;EACE,gBAAA;AHijwBF;;AG/iwBA;EACE,gBAAA;AHkjwBF;;AGhjwBA;EACE,gBAAA;AHmjwBF;;AGjjwBA;EACE,gBAAA;AHojwBF;;AGljwBA;EACE,gBAAA;AHqjwBF;;AGnjwBA;EACE,gBAAA;AHsjwBF;;AGpjwBA;EACE,gBAAA;AHujwBF;;AGrjwBA;EACE,gBAAA;AHwjwBF;;AGtjwBA;EACE,gBAAA;AHyjwBF;;AGvjwBA;EACE,gBAAA;AH0jwBF;;AGxjwBA;EACE,gBAAA;AH2jwBF;;AGzjwBA;EACE,gBAAA;AH4jwBF;;AG1jwBA;EACE,gBAAA;AH6jwBF;;AG3jwBA;EACE,gBAAA;AH8jwBF;;AG5jwBA;EACE,gBAAA;AH+jwBF;;AG7jwBA;EACE,gBAAA;AHgkwBF;;AG9jwBA;EACE,gBAAA;AHikwBF;;AG/jwBA;EACE,gBAAA;AHkkwBF;;AGhkwBA;EACE,gBAAA;AHmkwBF;;AGjkwBA;EACE,gBAAA;AHokwBF;;AGlkwBA;EACE,gBAAA;AHqkwBF;;AGnkwBA;EACE,gBAAA;AHskwBF;;AGpkwBA;EACE,gBAAA;AHukwBF;;AGrkwBA;EACE,gBAAA;AHwkwBF;;AGtkwBA;EACE,gBAAA;AHykwBF;;AGvkwBA;EACE,gBAAA;AH0kwBF;;AGxkwBA;EACE,gBAAA;AH2kwBF;;AGzkwBA;EACE,gBAAA;AH4kwBF;;AG1kwBA;EACE,gBAAA;AH6kwBF;;AG3kwBA;EACE,gBAAA;AH8kwBF;;AG5kwBA;EACE,gBAAA;AH+kwBF;;AG7kwBA;EACE,gBAAA;AHglwBF;;AG9kwBA;EACE,gBAAA;AHilwBF;;AG/kwBA;EACE,gBAAA;AHklwBF;;AGhlwBA;EACE,gBAAA;AHmlwBF;;AGjlwBA;EACE,gBAAA;AHolwBF;;AGllwBA;EACE,gBAAA;AHqlwBF;;AGnlwBA;EACE,gBAAA;AHslwBF;;AGplwBA;EACE,gBAAA;AHulwBF;;AGrlwBA;EACE,gBAAA;AHwlwBF;;AGtlwBA;EACE,gBAAA;AHylwBF;;AGvlwBA;EACE,gBAAA;AH0lwBF;;AGxlwBA;EACE,gBAAA;AH2lwBF;;AGzlwBA;EACE,gBAAA;AH4lwBF;;AG1lwBA;EACE,gBAAA;AH6lwBF;;AG3lwBA;EACE,gBAAA;AH8lwBF;;AG5lwBA;EACE,gBAAA;AH+lwBF;;AG7lwBA;EACE,gBAAA;AHgmwBF;;AG9lwBA;EACE,gBAAA;AHimwBF;;AG/lwBA;EACE,gBAAA;AHkmwBF;;AGhmwBA;EACE,gBAAA;AHmmwBF;;AGjmwBA;EACE,gBAAA;AHomwBF;;AGlmwBA;EACE,gBAAA;AHqmwBF;;AGnmwBA;EACE,gBAAA;AHsmwBF;;AGpmwBA;EACE,gBAAA;AHumwBF;;AGrmwBA;EACE,gBAAA;AHwmwBF;;AGtmwBA;EACE,gBAAA;AHymwBF;;AGvmwBA;EACE,gBAAA;AH0mwBF;;AGxmwBA;EACE,gBAAA;AH2mwBF;;AGzmwBA;EACE,gBAAA;AH4mwBF;;AG1mwBA;EACE,gBAAA;AH6mwBF;;AG3mwBA;EACE,gBAAA;AH8mwBF;;AG5mwBA;EACE,gBAAA;AH+mwBF;;AG7mwBA;EACE,gBAAA;AHgnwBF;;AG9mwBA;EACE,gBAAA;AHinwBF;;AG/mwBA;EACE,gBAAA;AHknwBF;;AGhnwBA;EACE,gBAAA;AHmnwBF;;AGjnwBA;EACE,gBAAA;AHonwBF;;AGlnwBA;EACE,gBAAA;AHqnwBF;;AGnnwBA;EACE,gBAAA;AHsnwBF;;AGpnwBA;EACE,gBAAA;AHunwBF;;AGrnwBA;EACE,gBAAA;AHwnwBF;;AGtnwBA;EACE,gBAAA;AHynwBF;;AGvnwBA;EACE,gBAAA;AH0nwBF;;AGxnwBA;EACE,gBAAA;AH2nwBF;;AGznwBA;EACE,gBAAA;AH4nwBF;;AG1nwBA;EACE,gBAAA;AH6nwBF;;AG3nwBA;EACE,gBAAA;AH8nwBF;;AG5nwBA;EACE,gBAAA;AH+nwBF;;AG7nwBA;EACE,gBAAA;AHgowBF;;AG9nwBA;EACE,gBAAA;AHiowBF;;AG/nwBA;EACE,gBAAA;AHkowBF;;AGhowBA;EACE,gBAAA;AHmowBF;;AGjowBA;EACE,gBAAA;AHoowBF;;AGlowBA;EACE,gBAAA;AHqowBF;;AI3+3BA;;;EAAA;AAIA;;;;;;EAME,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AJ8+3BF;;AI5+3BA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AJ++3BF;;AI7+3BA;EACE,iBAAA;AJg/3BF;;AI9+3BA;EACE,kBAAA;AJi/3BF;;AI/+3BA;EACE,cAAA;AJk/3BF;;AIh/3BA;EACE,cAAA;AJm/3BF;;AIj/3BA;EACE,cAAA;AJo/3BF;;AIl/3BA;EACE,cAAA;AJq/3BF;;AIn/3BA;EACE,cAAA;AJs/3BF;;AIp/3BA;EACE,cAAA;AJu/3BF;;AIr/3BA;EACE,cAAA;AJw/3BF;;AIt/3BA;EACE,cAAA;AJy/3BF;;AIv/3BA;EACE,cAAA;AJ0/3BF;;AIx/3BA;EACE,eAAA;AJ2/3BF;;AIz/3BA;EACE,kBAAA;EACA,aAAA;AJ4/3BF;;AI1/3BA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AJ6/3BF;;AI5/3BE;EACE,kBAAA;AJ+/3BJ;;AI7/3BA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AJgg4BF;;AI9/3BA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;AJig4BF;;AI//3BA;EACE,WAAA;AJkg4BF;;AIhg4BA;EACE,YAAA;AJmg4BF;;AIjg4BA;;;;;EAKE,mBAAA;AJog4BF;;AIlg4BA;;;;;EAKE,kBAAA;AJqg4BF;;AIng4BA;EAEU,qCAAA;AJsg4BV;;AIpg4BA;EAEU,uCAAA;AJug4BV;AI7/3BA;EACE;IAEU,uBAAA;EJ0g4BV;EIzg4BA;IAEU,yBAAA;EJ2g4BV;AACF;AI1g4BA;EACE,sEAAA;EAEQ,wBAAA;AJ4g4BV;;AI1g4BA;EACE,sEAAA;EAEQ,yBAAA;AJ6g4BV;;AI3g4BA;EACE,sEAAA;EAEQ,yBAAA;AJ8g4BV;;AI5g4BA;EACE,gFAAA;EAEQ,uBAAA;AJ+g4BV;;AI7g4BA;EACE,gFAAA;EAEQ,uBAAA;AJgh4BV;;AI9g4BA;EACE,gFAAA;EAEQ,wBAAA;AJih4BV;;AI/g4BA;;;;;;EAOU,YAAA;AJkh4BV;;AIhh4BA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AJmh4BF;;AIjh4BA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AJoh4BF;;AIlh4BA;EACE,oBAAA;AJqh4BF;;AInh4BA;EACE,cAAA;AJsh4BF;;AIph4BA;EACE,WAAA;AJuh4BF;;AIrh4BA;gEAAA;AAEA;EACE,gBAAA;AJwh4BF;;AIth4BA;EACE,gBAAA;AJyh4BF;;AIvh4BA;EACE,gBAAA;AJ0h4BF;;AIxh4BA;EACE,gBAAA;AJ2h4BF;;AIzh4BA;EACE,gBAAA;AJ4h4BF;;AI1h4BA;EACE,gBAAA;AJ6h4BF;;AI3h4BA;EACE,gBAAA;AJ8h4BF;;AI5h4BA;EACE,gBAAA;AJ+h4BF;;AI7h4BA;EACE,gBAAA;AJgi4BF;;AI9h4BA;EACE,gBAAA;AJii4BF;;AI/h4BA;EACE,gBAAA;AJki4BF;;AIhi4BA;EACE,gBAAA;AJmi4BF;;AIji4BA;EACE,gBAAA;AJoi4BF;;AIli4BA;EACE,gBAAA;AJqi4BF;;AIni4BA;EACE,gBAAA;AJsi4BF;;AIpi4BA;EACE,gBAAA;AJui4BF;;AIri4BA;EACE,gBAAA;AJwi4BF;;AIti4BA;EACE,gBAAA;AJyi4BF;;AIvi4BA;EACE,gBAAA;AJ0i4BF;;AIxi4BA;EACE,gBAAA;AJ2i4BF;;AIzi4BA;EACE,gBAAA;AJ4i4BF;;AI1i4BA;EACE,gBAAA;AJ6i4BF;;AI3i4BA;EACE,gBAAA;AJ8i4BF;;AI5i4BA;EACE,gBAAA;AJ+i4BF;;AI7i4BA;EACE,gBAAA;AJgj4BF;;AI9i4BA;EACE,gBAAA;AJij4BF;;AI/i4BA;EACE,gBAAA;AJkj4BF;;AIhj4BA;EACE,gBAAA;AJmj4BF;;AIjj4BA;EACE,gBAAA;AJoj4BF;;AIlj4BA;EACE,gBAAA;AJqj4BF;;AInj4BA;EACE,gBAAA;AJsj4BF;;AIpj4BA;EACE,gBAAA;AJuj4BF;;AIrj4BA;EACE,gBAAA;AJwj4BF;;AItj4BA;EACE,gBAAA;AJyj4BF;;AIvj4BA;EACE,gBAAA;AJ0j4BF;;AIxj4BA;EACE,gBAAA;AJ2j4BF;;AIzj4BA;EACE,gBAAA;AJ4j4BF;;AI1j4BA;EACE,gBAAA;AJ6j4BF;;AI3j4BA;EACE,gBAAA;AJ8j4BF;;AI5j4BA;EACE,gBAAA;AJ+j4BF;;AI7j4BA;EACE,gBAAA;AJgk4BF;;AI9j4BA;EACE,gBAAA;AJik4BF;;AI/j4BA;EACE,gBAAA;AJkk4BF;;AIhk4BA;EACE,gBAAA;AJmk4BF;;AIjk4BA;EACE,gBAAA;AJok4BF;;AIlk4BA;EACE,gBAAA;AJqk4BF;;AInk4BA;EACE,gBAAA;AJsk4BF;;AIpk4BA;EACE,gBAAA;AJuk4BF;;AIrk4BA;EACE,gBAAA;AJwk4BF;;AItk4BA;EACE,gBAAA;AJyk4BF;;AIvk4BA;EACE,gBAAA;AJ0k4BF;;AIxk4BA;EACE,gBAAA;AJ2k4BF;;AIzk4BA;EACE,gBAAA;AJ4k4BF;;AI1k4BA;EACE,gBAAA;AJ6k4BF;;AI3k4BA;EACE,gBAAA;AJ8k4BF;;AI5k4BA;EACE,gBAAA;AJ+k4BF;;AI7k4BA;EACE,gBAAA;AJgl4BF;;AI9k4BA;EACE,gBAAA;AJil4BF;;AI/k4BA;EACE,gBAAA;AJkl4BF;;AIhl4BA;EACE,gBAAA;AJml4BF;;AIjl4BA;EACE,gBAAA;AJol4BF;;AIll4BA;EACE,gBAAA;AJql4BF;;AInl4BA;EACE,gBAAA;AJsl4BF;;AIpl4BA;EACE,gBAAA;AJul4BF;;AIrl4BA;EACE,gBAAA;AJwl4BF;;AItl4BA;EACE,gBAAA;AJyl4BF;;AIvl4BA;EACE,gBAAA;AJ0l4BF;;AIxl4BA;EACE,gBAAA;AJ2l4BF;;AIzl4BA;EACE,gBAAA;AJ4l4BF;;AI1l4BA;EACE,gBAAA;AJ6l4BF;;AI3l4BA;EACE,gBAAA;AJ8l4BF;;AI5l4BA;EACE,gBAAA;AJ+l4BF;;AI7l4BA;EACE,gBAAA;AJgm4BF;;AI9l4BA;EACE,gBAAA;AJim4BF;;AI/l4BA;EACE,gBAAA;AJkm4BF;;AIhm4BA;EACE,gBAAA;AJmm4BF;;AIjm4BA;EACE,gBAAA;AJom4BF;;AIlm4BA;EACE,gBAAA;AJqm4BF;;AInm4BA;EACE,gBAAA;AJsm4BF;;AIpm4BA;EACE,gBAAA;AJum4BF;;AIrm4BA;EACE,gBAAA;AJwm4BF;;AItm4BA;EACE,gBAAA;AJym4BF;;AIvm4BA;EACE,gBAAA;AJ0m4BF;;AIxm4BA;EACE,gBAAA;AJ2m4BF;;AIzm4BA;EACE,gBAAA;AJ4m4BF;;AI1m4BA;EACE,gBAAA;AJ6m4BF;;AI3m4BA;EACE,gBAAA;AJ8m4BF;;AI5m4BA;EACE,gBAAA;AJ+m4BF;;AI7m4BA;EACE,gBAAA;AJgn4BF;;AI9m4BA;EACE,gBAAA;AJin4BF;;AI/m4BA;EACE,gBAAA;AJkn4BF;;AIhn4BA;EACE,gBAAA;AJmn4BF;;AIjn4BA;EACE,gBAAA;AJon4BF;;AIln4BA;EACE,gBAAA;AJqn4BF;;AInn4BA;EACE,gBAAA;AJsn4BF;;AIpn4BA;EACE,gBAAA;AJun4BF;;AIrn4BA;EACE,gBAAA;AJwn4BF;;AItn4BA;EACE,gBAAA;AJyn4BF;;AIvn4BA;EACE,gBAAA;AJ0n4BF;;AIxn4BA;EACE,gBAAA;AJ2n4BF;;AIzn4BA;EACE,gBAAA;AJ4n4BF;;AI1n4BA;EACE,gBAAA;AJ6n4BF;;AI3n4BA;EACE,gBAAA;AJ8n4BF;;AI5n4BA;EACE,gBAAA;AJ+n4BF;;AI7n4BA;EACE,gBAAA;AJgo4BF;;AI9n4BA;EACE,gBAAA;AJio4BF;;AI/n4BA;EACE,gBAAA;AJko4BF;;AIho4BA;EACE,gBAAA;AJmo4BF;;AIjo4BA;EACE,gBAAA;AJoo4BF;;AIlo4BA;EACE,gBAAA;AJqo4BF;;AIno4BA;EACE,gBAAA;AJso4BF;;AIpo4BA;EACE,gBAAA;AJuo4BF;;AIro4BA;EACE,gBAAA;AJwo4BF;;AIto4BA;EACE,gBAAA;AJyo4BF;;AIvo4BA;EACE,gBAAA;AJ0o4BF;;AIxo4BA;EACE,gBAAA;AJ2o4BF;;AIzo4BA;EACE,gBAAA;AJ4o4BF;;AI1o4BA;EACE,gBAAA;AJ6o4BF;;AI3o4BA;EACE,gBAAA;AJ8o4BF;;AI5o4BA;EACE,gBAAA;AJ+o4BF;;AI7o4BA;EACE,gBAAA;AJgp4BF;;AI9o4BA;EACE,gBAAA;AJip4BF;;AI/o4BA;EACE,gBAAA;AJkp4BF;;AIhp4BA;EACE,gBAAA;AJmp4BF;;AIjp4BA;EACE,gBAAA;AJop4BF;;AIlp4BA;EACE,gBAAA;AJqp4BF;;AInp4BA;EACE,gBAAA;AJsp4BF;;AIpp4BA;EACE,gBAAA;AJup4BF;;AIrp4BA;EACE,gBAAA;AJwp4BF;;AItp4BA;EACE,gBAAA;AJyp4BF;;AIvp4BA;EACE,gBAAA;AJ0p4BF;;AIxp4BA;EACE,gBAAA;AJ2p4BF;;AIzp4BA;EACE,gBAAA;AJ4p4BF;;AI1p4BA;EACE,gBAAA;AJ6p4BF;;AI3p4BA;EACE,gBAAA;AJ8p4BF;;AI5p4BA;EACE,gBAAA;AJ+p4BF;;AI7p4BA;EACE,gBAAA;AJgq4BF;;AI9p4BA;EACE,gBAAA;AJiq4BF;;AI/p4BA;EACE,gBAAA;AJkq4BF;;AIhq4BA;EACE,gBAAA;AJmq4BF;;AIjq4BA;EACE,gBAAA;AJoq4BF;;AIlq4BA;EACE,gBAAA;AJqq4BF;;AInq4BA;EACE,gBAAA;AJsq4BF;;AIpq4BA;EACE,gBAAA;AJuq4BF;;AIrq4BA;EACE,gBAAA;AJwq4BF;;AItq4BA;EACE,gBAAA;AJyq4BF;;AIvq4BA;EACE,gBAAA;AJ0q4BF;;AIxq4BA;EACE,YAAA;AJ2q4BF;;AIzq4BA;EACE,gBAAA;AJ4q4BF;;AI1q4BA;EACE,gBAAA;AJ6q4BF;;AI3q4BA;EACE,gBAAA;AJ8q4BF;;AI5q4BA;EACE,gBAAA;AJ+q4BF;;AI7q4BA;EACE,gBAAA;AJgr4BF;;AI9q4BA;EACE,gBAAA;AJir4BF;;AI/q4BA;EACE,gBAAA;AJkr4BF;;AIhr4BA;EACE,gBAAA;AJmr4BF;;AIjr4BA;EACE,gBAAA;AJor4BF;;AIlr4BA;EACE,gBAAA;AJqr4BF;;AInr4BA;EACE,gBAAA;AJsr4BF;;AIpr4BA;EACE,gBAAA;AJur4BF;;AIrr4BA;EACE,gBAAA;AJwr4BF;;AItr4BA;EACE,gBAAA;AJyr4BF;;AIvr4BA;EACE,gBAAA;AJ0r4BF;;AIxr4BA;EACE,gBAAA;AJ2r4BF;;AIzr4BA;EACE,gBAAA;AJ4r4BF;;AI1r4BA;EACE,gBAAA;AJ6r4BF;;AI3r4BA;EACE,gBAAA;AJ8r4BF;;AI5r4BA;EACE,gBAAA;AJ+r4BF;;AI7r4BA;EACE,gBAAA;AJgs4BF;;AI9r4BA;EACE,gBAAA;AJis4BF;;AI/r4BA;EACE,gBAAA;AJks4BF;;AIhs4BA;EACE,gBAAA;AJms4BF;;AIjs4BA;EACE,gBAAA;AJos4BF;;AIls4BA;EACE,gBAAA;AJqs4BF;;AIns4BA;EACE,gBAAA;AJss4BF;;AIps4BA;EACE,gBAAA;AJus4BF;;AIrs4BA;EACE,gBAAA;AJws4BF;;AIts4BA;EACE,gBAAA;AJys4BF;;AIvs4BA;EACE,gBAAA;AJ0s4BF;;AIxs4BA;EACE,gBAAA;AJ2s4BF;;AIzs4BA;EACE,gBAAA;AJ4s4BF;;AI1s4BA;EACE,gBAAA;AJ6s4BF;;AI3s4BA;EACE,gBAAA;AJ8s4BF;;AI5s4BA;EACE,gBAAA;AJ+s4BF;;AI7s4BA;EACE,gBAAA;AJgt4BF;;AI9s4BA;EACE,gBAAA;AJit4BF;;AI/s4BA;EACE,gBAAA;AJkt4BF;;AIht4BA;EACE,gBAAA;AJmt4BF;;AIjt4BA;EACE,gBAAA;AJot4BF;;AIlt4BA;EACE,gBAAA;AJqt4BF;;AInt4BA;EACE,gBAAA;AJst4BF;;AIpt4BA;EACE,gBAAA;AJut4BF;;AIrt4BA;EACE,gBAAA;AJwt4BF;;AItt4BA;EACE,gBAAA;AJyt4BF;;AIvt4BA;EACE,gBAAA;AJ0t4BF;;AIxt4BA;EACE,gBAAA;AJ2t4BF;;AIzt4BA;EACE,gBAAA;AJ4t4BF;;AI1t4BA;EACE,gBAAA;AJ6t4BF;;AI3t4BA;EACE,gBAAA;AJ8t4BF;;AI5t4BA;EACE,gBAAA;AJ+t4BF;;AI7t4BA;EACE,gBAAA;AJgu4BF;;AI9t4BA;EACE,gBAAA;AJiu4BF;;AI/t4BA;EACE,gBAAA;AJku4BF;;AIhu4BA;EACE,gBAAA;AJmu4BF;;AIju4BA;EACE,gBAAA;AJou4BF;;AIlu4BA;EACE,gBAAA;AJqu4BF;;AInu4BA;EACE,gBAAA;AJsu4BF;;AIpu4BA;EACE,gBAAA;AJuu4BF;;AIru4BA;EACE,gBAAA;AJwu4BF;;AItu4BA;EACE,gBAAA;AJyu4BF;;AIvu4BA;EACE,gBAAA;AJ0u4BF;;AIxu4BA;EACE,gBAAA;AJ2u4BF;;AIzu4BA;EACE,gBAAA;AJ4u4BF;;AI1u4BA;EACE,gBAAA;AJ6u4BF;;AI3u4BA;EACE,gBAAA;AJ8u4BF;;AI5u4BA;EACE,gBAAA;AJ+u4BF;;AI7u4BA;EACE,gBAAA;AJgv4BF;;AI9u4BA;EACE,gBAAA;AJiv4BF;;AI/u4BA;EACE,gBAAA;AJkv4BF;;AIhv4BA;EACE,gBAAA;AJmv4BF;;AIjv4BA;EACE,gBAAA;AJov4BF;;AIlv4BA;EACE,gBAAA;AJqv4BF;;AInv4BA;EACE,gBAAA;AJsv4BF;;AIpv4BA;EACE,gBAAA;AJuv4BF;;AIrv4BA;EACE,gBAAA;AJwv4BF;;AItv4BA;EACE,gBAAA;AJyv4BF;;AIvv4BA;EACE,gBAAA;AJ0v4BF;;AIxv4BA;EACE,gBAAA;AJ2v4BF;;AIzv4BA;EACE,gBAAA;AJ4v4BF;;AI1v4BA;EACE,gBAAA;AJ6v4BF;;AI3v4BA;EACE,gBAAA;AJ8v4BF;;AI5v4BA;EACE,gBAAA;AJ+v4BF;;AI7v4BA;EACE,gBAAA;AJgw4BF;;AI9v4BA;EACE,gBAAA;AJiw4BF;;AI/v4BA;EACE,gBAAA;AJkw4BF;;AIhw4BA;EACE,gBAAA;AJmw4BF;;AIjw4BA;EACE,gBAAA;AJow4BF;;AIlw4BA;EACE,gBAAA;AJqw4BF;;AInw4BA;EACE,gBAAA;AJsw4BF;;AIpw4BA;EACE,gBAAA;AJuw4BF;;AIrw4BA;EACE,gBAAA;AJww4BF;;AItw4BA;EACE,gBAAA;AJyw4BF;;AIvw4BA;EACE,gBAAA;AJ0w4BF;;AIxw4BA;EACE,gBAAA;AJ2w4BF;;AIzw4BA;EACE,gBAAA;AJ4w4BF;;AI1w4BA;EACE,gBAAA;AJ6w4BF;;AI3w4BA;EACE,gBAAA;AJ8w4BF;;AI5w4BA;EACE,gBAAA;AJ+w4BF;;AI7w4BA;EACE,gBAAA;AJgx4BF;;AI9w4BA;EACE,gBAAA;AJix4BF;;AI/w4BA;EACE,gBAAA;AJkx4BF;;AIhx4BA;EACE,gBAAA;AJmx4BF;;AIjx4BA;EACE,gBAAA;AJox4BF;;AIlx4BA;EACE,gBAAA;AJqx4BF;;AInx4BA;EACE,gBAAA;AJsx4BF;;AIpx4BA;EACE,gBAAA;AJux4BF;;AIrx4BA;EACE,gBAAA;AJwx4BF;;AItx4BA;EACE,gBAAA;AJyx4BF;;AIvx4BA;EACE,gBAAA;AJ0x4BF;;AIxx4BA;EACE,gBAAA;AJ2x4BF;;AIzx4BA;EACE,gBAAA;AJ4x4BF;;AI1x4BA;EACE,gBAAA;AJ6x4BF;;AI3x4BA;EACE,gBAAA;AJ8x4BF;;AI5x4BA;EACE,gBAAA;AJ+x4BF;;AI7x4BA;EACE,gBAAA;AJgy4BF;;AI9x4BA;EACE,gBAAA;AJiy4BF;;AI/x4BA;EACE,gBAAA;AJky4BF;;AIhy4BA;EACE,gBAAA;AJmy4BF;;AIjy4BA;EACE,gBAAA;AJoy4BF;;AIly4BA;EACE,gBAAA;AJqy4BF;;AIny4BA;EACE,gBAAA;AJsy4BF;;AIpy4BA;EACE,gBAAA;AJuy4BF;;AIry4BA;EACE,gBAAA;AJwy4BF;;AIty4BA;EACE,gBAAA;AJyy4BF;;AIvy4BA;EACE,gBAAA;AJ0y4BF;;AIxy4BA;EACE,gBAAA;AJ2y4BF;;AIzy4BA;EACE,gBAAA;AJ4y4BF;;AI1y4BA;EACE,gBAAA;AJ6y4BF;;AI3y4BA;EACE,gBAAA;AJ8y4BF;;AI5y4BA;EACE,gBAAA;AJ+y4BF;;AI7y4BA;EACE,gBAAA;AJgz4BF;;AI9y4BA;EACE,gBAAA;AJiz4BF;;AI/y4BA;EACE,gBAAA;AJkz4BF;;AIhz4BA;EACE,gBAAA;AJmz4BF;;AIjz4BA;EACE,gBAAA;AJoz4BF;;AIlz4BA;EACE,gBAAA;AJqz4BF;;AInz4BA;EACE,gBAAA;AJsz4BF;;AIpz4BA;EACE,gBAAA;AJuz4BF;;AIrz4BA;EACE,gBAAA;AJwz4BF;;AItz4BA;EACE,gBAAA;AJyz4BF;;AIvz4BA;EACE,gBAAA;AJ0z4BF;;AIxz4BA;EACE,gBAAA;AJ2z4BF;;AIzz4BA;EACE,gBAAA;AJ4z4BF;;AI1z4BA;EACE,gBAAA;AJ6z4BF;;AI3z4BA;EACE,gBAAA;AJ8z4BF;;AI5z4BA;EACE,gBAAA;AJ+z4BF;;AI7z4BA;EACE,gBAAA;AJg04BF;;AI9z4BA;EACE,gBAAA;AJi04BF;;AI/z4BA;EACE,gBAAA;AJk04BF;;AIh04BA;EACE,gBAAA;AJm04BF;;AIj04BA;EACE,gBAAA;AJo04BF;;AIl04BA;EACE,gBAAA;AJq04BF;;AIn04BA;EACE,gBAAA;AJs04BF;;AIp04BA;EACE,gBAAA;AJu04BF;;AIr04BA;EACE,gBAAA;AJw04BF;;AIt04BA;EACE,gBAAA;AJy04BF;;AIv04BA;EACE,gBAAA;AJ004BF;;AIx04BA;EACE,gBAAA;AJ204BF;;AIz04BA;EACE,gBAAA;AJ404BF;;AI104BA;EACE,gBAAA;AJ604BF;;AI304BA;EACE,gBAAA;AJ804BF;;AI504BA;EACE,gBAAA;AJ+04BF;;AI704BA;EACE,gBAAA;AJg14BF;;AI904BA;EACE,gBAAA;AJi14BF;;AI/04BA;EACE,gBAAA;AJk14BF;;AIh14BA;EACE,gBAAA;AJm14BF;;AIj14BA;EACE,gBAAA;AJo14BF;;AIl14BA;EACE,gBAAA;AJq14BF;;AIn14BA;EACE,gBAAA;AJs14BF;;AIp14BA;EACE,gBAAA;AJu14BF;;AIr14BA;EACE,gBAAA;AJw14BF;;AIt14BA;EACE,gBAAA;AJy14BF;;AIv14BA;EACE,gBAAA;AJ014BF;;AIx14BA;EACE,gBAAA;AJ214BF;;AIz14BA;EACE,gBAAA;AJ414BF;;AI114BA;EACE,gBAAA;AJ614BF;;AI314BA;EACE,gBAAA;AJ814BF;;AI514BA;EACE,gBAAA;AJ+14BF;;AI714BA;EACE,gBAAA;AJg24BF;;AI914BA;EACE,gBAAA;AJi24BF;;AI/14BA;EACE,gBAAA;AJk24BF;;AIh24BA;EACE,gBAAA;AJm24BF;;AIj24BA;EACE,gBAAA;AJo24BF;;AIl24BA;EACE,gBAAA;AJq24BF;;AIn24BA;EACE,gBAAA;AJs24BF;;AIp24BA;EACE,gBAAA;AJu24BF;;AIr24BA;EACE,gBAAA;AJw24BF;;AIt24BA;EACE,gBAAA;AJy24BF;;AIv24BA;EACE,gBAAA;AJ024BF;;AIx24BA;EACE,YAAA;AJ224BF;;AIz24BA;EACE,gBAAA;AJ424BF;;AI124BA;EACE,gBAAA;AJ624BF;;AI324BA;EACE,gBAAA;AJ824BF;;AI524BA;EACE,gBAAA;AJ+24BF;;AI724BA;EACE,gBAAA;AJg34BF;;AI924BA;EACE,gBAAA;AJi34BF;;AI/24BA;EACE,gBAAA;AJk34BF;;AIh34BA;EACE,gBAAA;AJm34BF;;AIj34BA;EACE,gBAAA;AJo34BF;;AIl34BA;EACE,gBAAA;AJq34BF;;AIn34BA;EACE,gBAAA;AJs34BF;;AIp34BA;EACE,gBAAA;AJu34BF;;AIr34BA;EACE,gBAAA;AJw34BF;;AIt34BA;EACE,gBAAA;AJy34BF;;AIv34BA;EACE,gBAAA;AJ034BF;;AIx34BA;EACE,gBAAA;AJ234BF;;AIz34BA;EACE,gBAAA;AJ434BF;;AI134BA;EACE,gBAAA;AJ634BF;;AI334BA;EACE,gBAAA;AJ834BF;;AI534BA;EACE,gBAAA;AJ+34BF;;AI734BA;EACE,gBAAA;AJg44BF;;AI934BA;EACE,gBAAA;AJi44BF;;AI/34BA;EACE,gBAAA;AJk44BF;;AIh44BA;EACE,gBAAA;AJm44BF;;AIj44BA;EACE,gBAAA;AJo44BF;;AIl44BA;EACE,gBAAA;AJq44BF;;AIn44BA;EACE,gBAAA;AJs44BF;;AIp44BA;EACE,gBAAA;AJu44BF;;AIr44BA;EACE,gBAAA;AJw44BF;;AIt44BA;EACE,gBAAA;AJy44BF;;AIv44BA;EACE,gBAAA;AJ044BF;;AIx44BA;EACE,gBAAA;AJ244BF;;AIz44BA;EACE,gBAAA;AJ444BF;;AI144BA;EACE,gBAAA;AJ644BF;;AI344BA;EACE,gBAAA;AJ844BF;;AI544BA;EACE,gBAAA;AJ+44BF;;AI744BA;EACE,gBAAA;AJg54BF;;AI944BA;EACE,gBAAA;AJi54BF;;AI/44BA;EACE,gBAAA;AJk54BF;;AIh54BA;EACE,gBAAA;AJm54BF;;AIj54BA;EACE,gBAAA;AJo54BF;;AIl54BA;EACE,gBAAA;AJq54BF;;AIn54BA;EACE,gBAAA;AJs54BF;;AIp54BA;EACE,gBAAA;AJu54BF;;AIr54BA;EACE,gBAAA;AJw54BF;;AIt54BA;EACE,gBAAA;AJy54BF;;AIv54BA;EACE,gBAAA;AJ054BF;;AIx54BA;EACE,gBAAA;AJ254BF;;AIz54BA;EACE,gBAAA;AJ454BF;;AI154BA;EACE,gBAAA;AJ654BF;;AI354BA;EACE,gBAAA;AJ854BF;;AI554BA;EACE,gBAAA;AJ+54BF;;AI754BA;EACE,gBAAA;AJg64BF;;AI954BA;EACE,gBAAA;AJi64BF;;AI/54BA;EACE,gBAAA;AJk64BF;;AIh64BA;EACE,gBAAA;AJm64BF;;AIj64BA;EACE,gBAAA;AJo64BF;;AIl64BA;EACE,gBAAA;AJq64BF;;AIn64BA;EACE,gBAAA;AJs64BF;;AIp64BA;EACE,gBAAA;AJu64BF;;AIr64BA;EACE,gBAAA;AJw64BF;;AIt64BA;EACE,gBAAA;AJy64BF;;AIv64BA;EACE,gBAAA;AJ064BF;;AIx64BA;EACE,gBAAA;AJ264BF;;AIz64BA;EACE,gBAAA;AJ464BF;;AI164BA;EACE,gBAAA;AJ664BF;;AI364BA;EACE,gBAAA;AJ864BF;;AI564BA;EACE,gBAAA;AJ+64BF;;AI764BA;EACE,gBAAA;AJg74BF;;AI964BA;EACE,gBAAA;AJi74BF;;AI/64BA;EACE,gBAAA;AJk74BF;;AIh74BA;EACE,gBAAA;AJm74BF;;AIj74BA;EACE,gBAAA;AJo74BF;;AIl74BA;EACE,gBAAA;AJq74BF;;AIn74BA;EACE,gBAAA;AJs74BF;;AIp74BA;EACE,gBAAA;AJu74BF;;AIr74BA;EACE,gBAAA;AJw74BF;;AIt74BA;EACE,gBAAA;AJy74BF;;AIv74BA;EACE,gBAAA;AJ074BF;;AIx74BA;EACE,gBAAA;AJ274BF;;AIz74BA;EACE,gBAAA;AJ474BF;;AI174BA;EACE,gBAAA;AJ674BF;;AI374BA;EACE,gBAAA;AJ874BF;;AI574BA;EACE,gBAAA;AJ+74BF;;AI774BA;EACE,gBAAA;AJg84BF;;AI974BA;EACE,gBAAA;AJi84BF;;AI/74BA;EACE,gBAAA;AJk84BF;;AIh84BA;EACE,gBAAA;AJm84BF;;AIj84BA;EACE,gBAAA;AJo84BF;;AIl84BA;EACE,gBAAA;AJq84BF;;AIn84BA;EACE,gBAAA;AJs84BF;;AIp84BA;EACE,gBAAA;AJu84BF;;AIr84BA;EACE,gBAAA;AJw84BF;;AIt84BA;EACE,gBAAA;AJy84BF;;AIv84BA;EACE,gBAAA;AJ084BF;;AIx84BA;EACE,gBAAA;AJ284BF;;AIz84BA;EACE,gBAAA;AJ484BF;;AI184BA;EACE,gBAAA;AJ684BF;;AI384BA;EACE,gBAAA;AJ884BF;;AI584BA;EACE,gBAAA;AJ+84BF;;AI784BA;EACE,gBAAA;AJg94BF;;AI984BA;EACE,gBAAA;AJi94BF;;AI/84BA;EACE,gBAAA;AJk94BF;;AIh94BA;EACE,gBAAA;AJm94BF;;AIj94BA;EACE,gBAAA;AJo94BF;;AIl94BA;EACE,gBAAA;AJq94BF;;AIn94BA;EACE,gBAAA;AJs94BF;;AIp94BA;EACE,YAAA;AJu94BF;;AIr94BA;EACE,gBAAA;AJw94BF;;AIt94BA;EACE,gBAAA;AJy94BF;;AIv94BA;EACE,gBAAA;AJ094BF;;AIx94BA;EACE,gBAAA;AJ294BF;;AIz94BA;EACE,gBAAA;AJ494BF;;AI194BA;EACE,gBAAA;AJ694BF;;AI394BA;EACE,gBAAA;AJ894BF;;AI594BA;EACE,gBAAA;AJ+94BF;;AI794BA;EACE,gBAAA;AJg+4BF;;AI994BA;EACE,gBAAA;AJi+4BF;;AI/94BA;EACE,gBAAA;AJk+4BF;;AIh+4BA;EACE,gBAAA;AJm+4BF;;AIj+4BA;EACE,gBAAA;AJo+4BF;;AIl+4BA;EACE,gBAAA;AJq+4BF;;AIn+4BA;EACE,gBAAA;AJs+4BF;;AIp+4BA;EACE,gBAAA;AJu+4BF;;AIr+4BA;EACE,gBAAA;AJw+4BF;;AIt+4BA;EACE,gBAAA;AJy+4BF;;AIv+4BA;EACE,gBAAA;AJ0+4BF;;AIx+4BA;EACE,gBAAA;AJ2+4BF;;AIz+4BA;EACE,gBAAA;AJ4+4BF;;AI1+4BA;EACE,gBAAA;AJ6+4BF;;AI3+4BA;EACE,gBAAA;AJ8+4BF;;AI5+4BA;EACE,gBAAA;AJ++4BF;;AI7+4BA;EACE,gBAAA;AJg/4BF;;AI9+4BA;EACE,gBAAA;AJi/4BF;;AI/+4BA;EACE,gBAAA;AJk/4BF;;AIh/4BA;EACE,gBAAA;AJm/4BF;;AIj/4BA;EACE,gBAAA;AJo/4BF;;AIl/4BA;EACE,gBAAA;AJq/4BF;;AIn/4BA;EACE,gBAAA;AJs/4BF;;AIp/4BA;EACE,gBAAA;AJu/4BF;;AIr/4BA;EACE,gBAAA;AJw/4BF;;AIt/4BA;EACE,gBAAA;AJy/4BF;;AIv/4BA;EACE,gBAAA;AJ0/4BF;;AIx/4BA;EACE,gBAAA;AJ2/4BF;;AIz/4BA;EACE,gBAAA;AJ4/4BF;;AI1/4BA;EACE,gBAAA;AJ6/4BF;;AI3/4BA;EACE,gBAAA;AJ8/4BF;;AI5/4BA;EACE,gBAAA;AJ+/4BF;;AI7/4BA;EACE,YAAA;AJgg5BF;;AI9/4BA;EACE,gBAAA;AJig5BF;;AI//4BA;EACE,gBAAA;AJkg5BF;;AIhg5BA;EACE,gBAAA;AJmg5BF;;AIjg5BA;EACE,gBAAA;AJog5BF;;AIlg5BA;EACE,gBAAA;AJqg5BF;;AIng5BA;EACE,gBAAA;AJsg5BF;;AIpg5BA;EACE,gBAAA;AJug5BF;;AIrg5BA;EACE,gBAAA;AJwg5BF;;AItg5BA;EACE,gBAAA;AJyg5BF;;AIvg5BA;EACE,gBAAA;AJ0g5BF;;AIxg5BA;EACE,gBAAA;AJ2g5BF;;AIzg5BA;EACE,gBAAA;AJ4g5BF;;AI1g5BA;EACE,gBAAA;AJ6g5BF;;AI3g5BA;EACE,gBAAA;AJ8g5BF;;AI5g5BA;EACE,gBAAA;AJ+g5BF;;AI7g5BA;EACE,gBAAA;AJgh5BF;;AI9g5BA;EACE,gBAAA;AJih5BF;;AI/g5BA;EACE,gBAAA;AJkh5BF;;AIhh5BA;EACE,gBAAA;AJmh5BF;;AIjh5BA;EACE,gBAAA;AJoh5BF;;AIlh5BA;EACE,gBAAA;AJqh5BF;;AInh5BA;EACE,gBAAA;AJsh5BF;;AIph5BA;EACE,gBAAA;AJuh5BF;;AIrh5BA;EACE,gBAAA;AJwh5BF;;AIth5BA;EACE,gBAAA;AJyh5BF;;AIvh5BA;EACE,gBAAA;AJ0h5BF;;AIxh5BA;EACE,gBAAA;AJ2h5BF;;AIzh5BA;EACE,gBAAA;AJ4h5BF;;AI1h5BA;EACE,gBAAA;AJ6h5BF;;AI3h5BA;EACE,gBAAA;AJ8h5BF;;AI5h5BA;EACE,gBAAA;AJ+h5BF;;AI7h5BA;EACE,gBAAA;AJgi5BF;;AI9h5BA;EACE,gBAAA;AJii5BF;;AI/h5BA;EACE,gBAAA;AJki5BF;;AIhi5BA;EACE,gBAAA;AJmi5BF;;AIji5BA;EACE,gBAAA;AJoi5BF;;AIli5BA;EACE,gBAAA;AJqi5BF;;AIni5BA;EACE,gBAAA;AJsi5BF;;AIpi5BA;EACE,gBAAA;AJui5BF;;AIri5BA;EACE,gBAAA;AJwi5BF;;AIti5BA;EACE,gBAAA;AJyi5BF;;AIvi5BA;EACE,gBAAA;AJ0i5BF;;AIxi5BA;EACE,gBAAA;AJ2i5BF;;AIzi5BA;EACE,gBAAA;AJ4i5BF;;AI1i5BA;EACE,gBAAA;AJ6i5BF;;AI3i5BA;EACE,gBAAA;AJ8i5BF;;AI5i5BA;EACE,gBAAA;AJ+i5BF;;AI7i5BA;EACE,gBAAA;AJgj5BF;;AI9i5BA;EACE,gBAAA;AJij5BF;;AI/i5BA;EACE,gBAAA;AJkj5BF;;AIhj5BA;EACE,gBAAA;AJmj5BF;;AIjj5BA;EACE,gBAAA;AJoj5BF;;AIlj5BA;EACE,gBAAA;AJqj5BF;;AInj5BA;EACE,gBAAA;AJsj5BF;;AIpj5BA;EACE,gBAAA;AJuj5BF;;AIrj5BA;EACE,gBAAA;AJwj5BF;;AItj5BA;EACE,gBAAA;AJyj5BF;;AIvj5BA;EACE,gBAAA;AJ0j5BF;;AIxj5BA;EACE,gBAAA;AJ2j5BF;;AIzj5BA;EACE,gBAAA;AJ4j5BF;;AI1j5BA;EACE,gBAAA;AJ6j5BF;;AI3j5BA;EACE,gBAAA;AJ8j5BF;;AI5j5BA;EACE,gBAAA;AJ+j5BF;;AI7j5BA;EACE,gBAAA;AJgk5BF;;AI9j5BA;EACE,gBAAA;AJik5BF;;AI/j5BA;EACE,gBAAA;AJkk5BF;;AIhk5BA;EACE,gBAAA;AJmk5BF;;AIjk5BA;EACE,gBAAA;AJok5BF;;AIlk5BA;EACE,gBAAA;AJqk5BF;;AInk5BA;EACE,gBAAA;AJsk5BF;;AIpk5BA;EACE,gBAAA;AJuk5BF;;AIrk5BA;EACE,gBAAA;AJwk5BF;;AItk5BA;EACE,gBAAA;AJyk5BF;;AIvk5BA;EACE,gBAAA;AJ0k5BF;;AIxk5BA;EACE,gBAAA;AJ2k5BF;;AIzk5BA;EACE,gBAAA;AJ4k5BF;;AI1k5BA;EACE,gBAAA;AJ6k5BF;;AI3k5BA;EACE,gBAAA;AJ8k5BF;;AI5k5BA;EACE,gBAAA;AJ+k5BF;;AI7k5BA;EACE,gBAAA;AJgl5BF;;AI9k5BA;EACE,gBAAA;AJil5BF;;AI/k5BA;EACE,gBAAA;AJkl5BF;;AIhl5BA;EACE,gBAAA;AJml5BF;;AIjl5BA;EACE,gBAAA;AJol5BF;;AIll5BA;EACE,gBAAA;AJql5BF;;AInl5BA;EACE,gBAAA;AJsl5BF;;AIpl5BA;EACE,gBAAA;AJul5BF;;AIrl5BA;EACE,gBAAA;AJwl5BF;;AItl5BA;EACE,gBAAA;AJyl5BF;;AIvl5BA;EACE,gBAAA;AJ0l5BF;;AIxl5BA;EACE,gBAAA;AJ2l5BF;;AIzl5BA;EACE,gBAAA;AJ4l5BF;;AI1l5BA;EACE,gBAAA;AJ6l5BF;;AI3l5BA;EACE,gBAAA;AJ8l5BF;;AI5l5BA;EACE,gBAAA;AJ+l5BF;;AI7l5BA;EACE,gBAAA;AJgm5BF;;AI9l5BA;EACE,gBAAA;AJim5BF;;AI/l5BA;EACE,gBAAA;AJkm5BF;;AIhm5BA;EACE,gBAAA;AJmm5BF;;AIjm5BA;EACE,gBAAA;AJom5BF;;AIlm5BA;EACE,gBAAA;AJqm5BF;;AInm5BA;EACE,gBAAA;AJsm5BF;;AIpm5BA;EACE,gBAAA;AJum5BF;;AIrm5BA;EACE,gBAAA;AJwm5BF;;AItm5BA;EACE,gBAAA;AJym5BF;;AIvm5BA;EACE,gBAAA;AJ0m5BF;;AIxm5BA;EACE,gBAAA;AJ2m5BF;;AIzm5BA;EACE,gBAAA;AJ4m5BF;;AI1m5BA;EACE,gBAAA;AJ6m5BF;;AI3m5BA;EACE,gBAAA;AJ8m5BF;;AI5m5BA;EACE,gBAAA;AJ+m5BF;;AI7m5BA;EACE,gBAAA;AJgn5BF;;AI9m5BA;EACE,gBAAA;AJin5BF;;AI/m5BA;EACE,gBAAA;AJkn5BF;;AIhn5BA;EACE,gBAAA;AJmn5BF;;AIjn5BA;EACE,gBAAA;AJon5BF;;AIln5BA;EACE,gBAAA;AJqn5BF;;AInn5BA;EACE,gBAAA;AJsn5BF;;AIpn5BA;EACE,gBAAA;AJun5BF;;AIrn5BA;EACE,gBAAA;AJwn5BF;;AItn5BA;EACE,gBAAA;AJyn5BF;;AIvn5BA;EACE,YAAA;AJ0n5BF;;AIxn5BA;EACE,gBAAA;AJ2n5BF;;AIzn5BA;EACE,gBAAA;AJ4n5BF;;AI1n5BA;EACE,gBAAA;AJ6n5BF;;AI3n5BA;EACE,gBAAA;AJ8n5BF;;AI5n5BA;EACE,gBAAA;AJ+n5BF;;AI7n5BA;EACE,gBAAA;AJgo5BF;;AI9n5BA;EACE,gBAAA;AJio5BF;;AI/n5BA;EACE,gBAAA;AJko5BF;;AIho5BA;EACE,gBAAA;AJmo5BF;;AIjo5BA;EACE,gBAAA;AJoo5BF;;AIlo5BA;EACE,gBAAA;AJqo5BF;;AIno5BA;EACE,gBAAA;AJso5BF;;AIpo5BA;EACE,gBAAA;AJuo5BF;;AIro5BA;EACE,YAAA;AJwo5BF;;AIto5BA;EACE,gBAAA;AJyo5BF;;AIvo5BA;EACE,gBAAA;AJ0o5BF;;AIxo5BA;EACE,gBAAA;AJ2o5BF;;AIzo5BA;EACE,YAAA;AJ4o5BF;;AI1o5BA;EACE,gBAAA;AJ6o5BF;;AI3o5BA;EACE,YAAA;AJ8o5BF;;AI5o5BA;EACE,YAAA;AJ+o5BF;;AI7o5BA;EACE,gBAAA;AJgp5BF;;AI9o5BA;EACE,gBAAA;AJip5BF;;AI/o5BA;EACE,gBAAA;AJkp5BF;;AIhp5BA;EACE,gBAAA;AJmp5BF;;AIjp5BA;EACE,gBAAA;AJop5BF;;AIlp5BA;EACE,gBAAA;AJqp5BF;;AInp5BA;EACE,gBAAA;AJsp5BF;;AIpp5BA;EACE,YAAA;AJup5BF;;AIrp5BA;EACE,YAAA;AJwp5BF;;AItp5BA;EACE,YAAA;AJyp5BF;;AIvp5BA;EACE,YAAA;AJ0p5BF;;AIxp5BA;EACE,gBAAA;AJ2p5BF;;AIzp5BA;EACE,gBAAA;AJ4p5BF;;AI1p5BA;EACE,gBAAA;AJ6p5BF;;AI3p5BA;EACE,gBAAA;AJ8p5BF;;AI5p5BA;EACE,gBAAA;AJ+p5BF;;AI7p5BA;EACE,gBAAA;AJgq5BF;;AI9p5BA;EACE,gBAAA;AJiq5BF;;AI/p5BA;EACE,gBAAA;AJkq5BF;;AIhq5BA;EACE,gBAAA;AJmq5BF;;AIjq5BA;EACE,gBAAA;AJoq5BF;;AIlq5BA;EACE,gBAAA;AJqq5BF;;AInq5BA;EACE,gBAAA;AJsq5BF;;AIpq5BA;EACE,gBAAA;AJuq5BF;;AIrq5BA;EACE,gBAAA;AJwq5BF;;AItq5BA;EACE,gBAAA;AJyq5BF;;AIvq5BA;EACE,gBAAA;AJ0q5BF;;AIxq5BA;EACE,gBAAA;AJ2q5BF;;AIzq5BA;EACE,gBAAA;AJ4q5BF;;AI1q5BA;EACE,gBAAA;AJ6q5BF;;AI3q5BA;EACE,gBAAA;AJ8q5BF;;AI5q5BA;EACE,gBAAA;AJ+q5BF;;AI7q5BA;EACE,gBAAA;AJgr5BF;;AI9q5BA;EACE,gBAAA;AJir5BF;;AI/q5BA;EACE,gBAAA;AJkr5BF;;AIhr5BA;EACE,gBAAA;AJmr5BF;;AIjr5BA;EACE,gBAAA;AJor5BF;;AIlr5BA;EACE,gBAAA;AJqr5BF;;AInr5BA;EACE,gBAAA;AJsr5BF;;AIpr5BA;EACE,gBAAA;AJur5BF;;AIrr5BA;EACE,gBAAA;AJwr5BF;;AItr5BA;EACE,gBAAA;AJyr5BF;;AIvr5BA;EACE,gBAAA;AJ0r5BF;;AIxr5BA;EACE,gBAAA;AJ2r5BF;;AIzr5BA;EACE,gBAAA;AJ4r5BF;;AI1r5BA;EACE,YAAA;AJ6r5BF;;AI3r5BA;EACE,gBAAA;AJ8r5BF;;AI5r5BA;EACE,gBAAA;AJ+r5BF;;AI7r5BA;EACE,gBAAA;AJgs5BF;;AI9r5BA;EACE,gBAAA;AJis5BF;;AI/r5BA;EACE,gBAAA;AJks5BF;;AIhs5BA;EACE,gBAAA;AJms5BF;;AIjs5BA;EACE,gBAAA;AJos5BF;;AIls5BA;EACE,gBAAA;AJqs5BF;;AIns5BA;EACE,gBAAA;AJss5BF;;AIps5BA;EACE,gBAAA;AJus5BF;;AIrs5BA;EACE,gBAAA;AJws5BF;;AIts5BA;EACE,YAAA;AJys5BF;;AIvs5BA;EACE,gBAAA;AJ0s5BF;;AIxs5BA;EACE,gBAAA;AJ2s5BF;;AIzs5BA;EACE,gBAAA;AJ4s5BF;;AI1s5BA;EACE,gBAAA;AJ6s5BF;;AI3s5BA;EACE,gBAAA;AJ8s5BF;;AI5s5BA;EACE,gBAAA;AJ+s5BF;;AI7s5BA;EACE,gBAAA;AJgt5BF;;AI9s5BA;EACE,gBAAA;AJit5BF;;AI/s5BA;EACE,gBAAA;AJkt5BF;;AIht5BA;EACE,gBAAA;AJmt5BF;;AIjt5BA;EACE,gBAAA;AJot5BF;;AIlt5BA;EACE,YAAA;AJqt5BF;;AInt5BA;EACE,gBAAA;AJst5BF;;AIpt5BA;EACE,gBAAA;AJut5BF;;AIrt5BA;EACE,gBAAA;AJwt5BF;;AItt5BA;EACE,gBAAA;AJyt5BF;;AIvt5BA;EACE,gBAAA;AJ0t5BF;;AIxt5BA;EACE,gBAAA;AJ2t5BF;;AIzt5BA;EACE,gBAAA;AJ4t5BF;;AI1t5BA;EACE,gBAAA;AJ6t5BF;;AI3t5BA;EACE,gBAAA;AJ8t5BF;;AI5t5BA;EACE,gBAAA;AJ+t5BF;;AI7t5BA;EACE,gBAAA;AJgu5BF;;AI9t5BA;EACE,gBAAA;AJiu5BF;;AI/t5BA;EACE,gBAAA;AJku5BF;;AIhu5BA;EACE,gBAAA;AJmu5BF;;AIju5BA;EACE,gBAAA;AJou5BF;;AIlu5BA;EACE,gBAAA;AJqu5BF;;AInu5BA;EACE,gBAAA;AJsu5BF;;AIpu5BA;EACE,gBAAA;AJuu5BF;;AIru5BA;EACE,gBAAA;AJwu5BF;;AItu5BA;EACE,gBAAA;AJyu5BF;;AIvu5BA;EACE,gBAAA;AJ0u5BF;;AIxu5BA;EACE,gBAAA;AJ2u5BF;;AIzu5BA;EACE,gBAAA;AJ4u5BF;;AI1u5BA;EACE,gBAAA;AJ6u5BF;;AI3u5BA;EACE,gBAAA;AJ8u5BF;;AI5u5BA;EACE,gBAAA;AJ+u5BF;;AI7u5BA;EACE,gBAAA;AJgv5BF;;AI9u5BA;EACE,gBAAA;AJiv5BF;;AI/u5BA;EACE,gBAAA;AJkv5BF;;AIhv5BA;EACE,gBAAA;AJmv5BF;;AIjv5BA;EACE,gBAAA;AJov5BF;;AIlv5BA;EACE,gBAAA;AJqv5BF;;AInv5BA;EACE,gBAAA;AJsv5BF;;AIpv5BA;EACE,gBAAA;AJuv5BF;;AIrv5BA;EACE,gBAAA;AJwv5BF;;AItv5BA;EACE,gBAAA;AJyv5BF;;AIvv5BA;EACE,gBAAA;AJ0v5BF;;AIxv5BA;EACE,gBAAA;AJ2v5BF;;AIzv5BA;EACE,YAAA;AJ4v5BF;;AI1v5BA;EACE,gBAAA;AJ6v5BF;;AI3v5BA;EACE,gBAAA;AJ8v5BF;;AI5v5BA;EACE,gBAAA;AJ+v5BF;;AI7v5BA;EACE,gBAAA;AJgw5BF;;AI9v5BA;EACE,gBAAA;AJiw5BF;;AI/v5BA;EACE,gBAAA;AJkw5BF;;AIhw5BA;EACE,gBAAA;AJmw5BF;;AIjw5BA;EACE,gBAAA;AJow5BF;;AIlw5BA;EACE,gBAAA;AJqw5BF;;AInw5BA;EACE,gBAAA;AJsw5BF;;AIpw5BA;EACE,gBAAA;AJuw5BF;;AIrw5BA;EACE,gBAAA;AJww5BF;;AItw5BA;EACE,gBAAA;AJyw5BF;;AIvw5BA;EACE,gBAAA;AJ0w5BF;;AIxw5BA;EACE,gBAAA;AJ2w5BF;;AIzw5BA;EACE,gBAAA;AJ4w5BF;;AI1w5BA;EACE,gBAAA;AJ6w5BF;;AI3w5BA;EACE,gBAAA;AJ8w5BF;;AI5w5BA;EACE,gBAAA;AJ+w5BF;;AI7w5BA;EACE,gBAAA;AJgx5BF;;AI9w5BA;EACE,gBAAA;AJix5BF;;AI/w5BA;EACE,gBAAA;AJkx5BF;;AIhx5BA;EACE,gBAAA;AJmx5BF;;AIjx5BA;EACE,gBAAA;AJox5BF;;AIlx5BA;EACE,gBAAA;AJqx5BF;;AInx5BA;EACE,gBAAA;AJsx5BF;;AIpx5BA;EACE,gBAAA;AJux5BF;;AIrx5BA;EACE,gBAAA;AJwx5BF;;AItx5BA;EACE,gBAAA;AJyx5BF;;AIvx5BA;EACE,gBAAA;AJ0x5BF;;AIxx5BA;EACE,gBAAA;AJ2x5BF;;AIzx5BA;EACE,gBAAA;AJ4x5BF;;AI1x5BA;EACE,gBAAA;AJ6x5BF;;AI3x5BA;EACE,gBAAA;AJ8x5BF;;AI5x5BA;EACE,gBAAA;AJ+x5BF;;AI7x5BA;EACE,gBAAA;AJgy5BF;;AI9x5BA;EACE,gBAAA;AJiy5BF;;AI/x5BA;EACE,gBAAA;AJky5BF;;AIhy5BA;EACE,gBAAA;AJmy5BF;;AIjy5BA;EACE,gBAAA;AJoy5BF;;AIly5BA;EACE,YAAA;AJqy5BF;;AIny5BA;EACE,gBAAA;AJsy5BF;;AIpy5BA;EACE,gBAAA;AJuy5BF;;AIry5BA;EACE,gBAAA;AJwy5BF;;AIty5BA;EACE,gBAAA;AJyy5BF;;AIvy5BA;EACE,gBAAA;AJ0y5BF;;AIxy5BA;EACE,gBAAA;AJ2y5BF;;AIzy5BA;EACE,gBAAA;AJ4y5BF;;AI1y5BA;EACE,gBAAA;AJ6y5BF;;AI3y5BA;EACE,gBAAA;AJ8y5BF;;AI5y5BA;EACE,gBAAA;AJ+y5BF;;AI7y5BA;EACE,gBAAA;AJgz5BF;;AI9y5BA;EACE,gBAAA;AJiz5BF;;AI/y5BA;EACE,gBAAA;AJkz5BF;;AIhz5BA;EACE,gBAAA;AJmz5BF;;AIjz5BA;EACE,gBAAA;AJoz5BF;;AIlz5BA;EACE,gBAAA;AJqz5BF;;AInz5BA;EACE,gBAAA;AJsz5BF;;AIpz5BA;EACE,gBAAA;AJuz5BF;;AIrz5BA;EACE,gBAAA;AJwz5BF;;AItz5BA;EACE,gBAAA;AJyz5BF;;AIvz5BA;EACE,gBAAA;AJ0z5BF;;AIxz5BA;EACE,gBAAA;AJ2z5BF;;AIzz5BA;EACE,gBAAA;AJ4z5BF;;AI1z5BA;EACE,gBAAA;AJ6z5BF;;AI3z5BA;EACE,gBAAA;AJ8z5BF;;AI5z5BA;EACE,gBAAA;AJ+z5BF;;AI7z5BA;EACE,gBAAA;AJg05BF;;AI9z5BA;EACE,gBAAA;AJi05BF;;AI/z5BA;EACE,gBAAA;AJk05BF;;AIh05BA;EACE,gBAAA;AJm05BF;;AIj05BA;EACE,gBAAA;AJo05BF;;AIl05BA;EACE,gBAAA;AJq05BF;;AIn05BA;EACE,gBAAA;AJs05BF;;AIp05BA;EACE,gBAAA;AJu05BF;;AIr05BA;EACE,gBAAA;AJw05BF;;AIt05BA;EACE,gBAAA;AJy05BF;;AIv05BA;EACE,gBAAA;AJ005BF;;AIx05BA;EACE,gBAAA;AJ205BF;;AIz05BA;EACE,gBAAA;AJ405BF;;AI105BA;EACE,gBAAA;AJ605BF;;AI305BA;EACE,gBAAA;AJ805BF;;AI505BA;EACE,gBAAA;AJ+05BF;;AI705BA;EACE,YAAA;AJg15BF;;AI905BA;EACE,gBAAA;AJi15BF;;AI/05BA;EACE,gBAAA;AJk15BF;;AIh15BA;EACE,gBAAA;AJm15BF;;AIj15BA;EACE,gBAAA;AJo15BF;;AIl15BA;EACE,gBAAA;AJq15BF;;AIn15BA;EACE,gBAAA;AJs15BF;;AIp15BA;EACE,gBAAA;AJu15BF;;AIr15BA;EACE,gBAAA;AJw15BF;;AIt15BA;EACE,gBAAA;AJy15BF;;AIv15BA;EACE,gBAAA;AJ015BF;;AIx15BA;EACE,gBAAA;AJ215BF;;AIz15BA;EACE,gBAAA;AJ415BF;;AI115BA;EACE,gBAAA;AJ615BF;;AI315BA;EACE,YAAA;AJ815BF;;AI515BA;EACE,gBAAA;AJ+15BF;;AI715BA;EACE,gBAAA;AJg25BF;;AI915BA;EACE,gBAAA;AJi25BF;;AI/15BA;EACE,gBAAA;AJk25BF;;AIh25BA;EACE,gBAAA;AJm25BF;;AIj25BA;EACE,gBAAA;AJo25BF;;AIl25BA;EACE,gBAAA;AJq25BF;;AIn25BA;EACE,gBAAA;AJs25BF;;AIp25BA;EACE,gBAAA;AJu25BF;;AIr25BA;EACE,gBAAA;AJw25BF;;AIt25BA;EACE,gBAAA;AJy25BF;;AIv25BA;EACE,gBAAA;AJ025BF;;AIx25BA;EACE,gBAAA;AJ225BF;;AIz25BA;EACE,gBAAA;AJ425BF;;AI125BA;EACE,gBAAA;AJ625BF;;AI325BA;EACE,gBAAA;AJ825BF;;AI525BA;EACE,gBAAA;AJ+25BF;;AI725BA;EACE,gBAAA;AJg35BF;;AI925BA;EACE,gBAAA;AJi35BF;;AI/25BA;EACE,gBAAA;AJk35BF;;AIh35BA;EACE,gBAAA;AJm35BF;;AIj35BA;EACE,gBAAA;AJo35BF;;AIl35BA;EACE,gBAAA;AJq35BF;;AIn35BA;EACE,gBAAA;AJs35BF;;AIp35BA;EACE,gBAAA;AJu35BF;;AIr35BA;EACE,gBAAA;AJw35BF;;AIt35BA;EACE,gBAAA;AJy35BF;;AIv35BA;EACE,gBAAA;AJ035BF;;AIx35BA;EACE,gBAAA;AJ235BF;;AIz35BA;EACE,gBAAA;AJ435BF;;AI135BA;EACE,gBAAA;AJ635BF;;AI335BA;EACE,gBAAA;AJ835BF;;AI535BA;EACE,gBAAA;AJ+35BF;;AI735BA;EACE,gBAAA;AJg45BF;;AI935BA;EACE,gBAAA;AJi45BF;;AI/35BA;EACE,gBAAA;AJk45BF;;AIh45BA;EACE,gBAAA;AJm45BF;;AIj45BA;EACE,gBAAA;AJo45BF;;AIl45BA;EACE,gBAAA;AJq45BF;;AIn45BA;EACE,gBAAA;AJs45BF;;AIp45BA;EACE,gBAAA;AJu45BF;;AIr45BA;EACE,gBAAA;AJw45BF;;AIt45BA;EACE,gBAAA;AJy45BF;;AIv45BA;EACE,gBAAA;AJ045BF;;AIx45BA;EACE,gBAAA;AJ245BF;;AIz45BA;EACE,gBAAA;AJ445BF;;AI145BA;EACE,gBAAA;AJ645BF;;AI345BA;EACE,gBAAA;AJ845BF;;AI545BA;EACE,gBAAA;AJ+45BF;;AI745BA;EACE,gBAAA;AJg55BF;;AI945BA;EACE,gBAAA;AJi55BF;;AI/45BA;EACE,gBAAA;AJk55BF;;AIh55BA;EACE,gBAAA;AJm55BF;;AIj55BA;EACE,gBAAA;AJo55BF;;AIl55BA;EACE,gBAAA;AJq55BF;;AIn55BA;EACE,gBAAA;AJs55BF;;AIp55BA;EACE,gBAAA;AJu55BF;;AIr55BA;EACE,gBAAA;AJw55BF;;AIt55BA;EACE,gBAAA;AJy55BF;;AIv55BA;EACE,gBAAA;AJ055BF;;AIx55BA;EACE,gBAAA;AJ255BF;;AIz55BA;EACE,gBAAA;AJ455BF;;AI155BA;EACE,gBAAA;AJ655BF;;AI355BA;EACE,gBAAA;AJ855BF;;AI555BA;EACE,gBAAA;AJ+55BF;;AI755BA;EACE,gBAAA;AJg65BF;;AI955BA;EACE,gBAAA;AJi65BF;;AI/55BA;EACE,gBAAA;AJk65BF;;AIh65BA;EACE,gBAAA;AJm65BF;;AIj65BA;EACE,gBAAA;AJo65BF;;AIl65BA;EACE,gBAAA;AJq65BF;;AIn65BA;EACE,gBAAA;AJs65BF;;AIp65BA;EACE,gBAAA;AJu65BF;;AIr65BA;EACE,gBAAA;AJw65BF;;AIt65BA;EACE,gBAAA;AJy65BF;;AIv65BA;EACE,gBAAA;AJ065BF;;AIx65BA;EACE,gBAAA;AJ265BF;;AIz65BA;EACE,gBAAA;AJ465BF;;AI165BA;EACE,gBAAA;AJ665BF;;AI365BA;EACE,YAAA;AJ865BF;;AI565BA;EACE,gBAAA;AJ+65BF;;AI765BA;EACE,gBAAA;AJg75BF;;AI965BA;EACE,gBAAA;AJi75BF;;AI/65BA;EACE,gBAAA;AJk75BF;;AIh75BA;EACE,gBAAA;AJm75BF;;AIj75BA;EACE,gBAAA;AJo75BF;;AIl75BA;EACE,gBAAA;AJq75BF;;AIn75BA;EACE,gBAAA;AJs75BF;;AIp75BA;EACE,gBAAA;AJu75BF;;AIr75BA;EACE,gBAAA;AJw75BF;;AIt75BA;EACE,gBAAA;AJy75BF;;AIv75BA;EACE,gBAAA;AJ075BF;;AIx75BA;EACE,gBAAA;AJ275BF;;AIz75BA;EACE,gBAAA;AJ475BF;;AI175BA;EACE,gBAAA;AJ675BF;;AI375BA;EACE,gBAAA;AJ875BF;;AI575BA;EACE,gBAAA;AJ+75BF;;AI775BA;EACE,gBAAA;AJg85BF;;AI975BA;EACE,gBAAA;AJi85BF;;AI/75BA;EACE,gBAAA;AJk85BF;;AIh85BA;EACE,gBAAA;AJm85BF;;AIj85BA;EACE,YAAA;AJo85BF;;AIl85BA;EACE,gBAAA;AJq85BF;;AIn85BA;EACE,gBAAA;AJs85BF;;AIp85BA;EACE,gBAAA;AJu85BF;;AIr85BA;EACE,gBAAA;AJw85BF;;AIt85BA;EACE,gBAAA;AJy85BF;;AIv85BA;EACE,gBAAA;AJ085BF;;AIx85BA;EACE,gBAAA;AJ285BF;;AIz85BA;EACE,gBAAA;AJ485BF;;AI185BA;EACE,gBAAA;AJ685BF;;AI385BA;EACE,gBAAA;AJ885BF;;AI585BA;EACE,YAAA;AJ+85BF;;AI785BA;EACE,gBAAA;AJg95BF;;AI985BA;EACE,gBAAA;AJi95BF;;AI/85BA;EACE,gBAAA;AJk95BF;;AIh95BA;EACE,gBAAA;AJm95BF;;AIj95BA;EACE,gBAAA;AJo95BF;;AIl95BA;EACE,gBAAA;AJq95BF;;AIn95BA;EACE,gBAAA;AJs95BF;;AIp95BA;EACE,gBAAA;AJu95BF;;AIr95BA;EACE,gBAAA;AJw95BF;;AIt95BA;EACE,gBAAA;AJy95BF;;AIv95BA;EACE,gBAAA;AJ095BF;;AIx95BA;EACE,gBAAA;AJ295BF;;AIz95BA;EACE,gBAAA;AJ495BF;;AI195BA;EACE,gBAAA;AJ695BF;;AI395BA;EACE,gBAAA;AJ895BF;;AI595BA;EACE,gBAAA;AJ+95BF;;AI795BA;EACE,gBAAA;AJg+5BF;;AI995BA;EACE,gBAAA;AJi+5BF;;AI/95BA;EACE,gBAAA;AJk+5BF;;AIh+5BA;EACE,gBAAA;AJm+5BF;;AIj+5BA;EACE,gBAAA;AJo+5BF;;AIl+5BA;EACE,gBAAA;AJq+5BF;;AIn+5BA;EACE,gBAAA;AJs+5BF;;AIp+5BA;EACE,gBAAA;AJu+5BF;;AIr+5BA;EACE,gBAAA;AJw+5BF;;AIt+5BA;EACE,YAAA;AJy+5BF;;AIv+5BA;EACE,YAAA;AJ0+5BF;;AIx+5BA;EACE,gBAAA;AJ2+5BF;;AIz+5BA;EACE,gBAAA;AJ4+5BF;;AI1+5BA;EACE,gBAAA;AJ6+5BF;;AI3+5BA;EACE,gBAAA;AJ8+5BF;;AI5+5BA;EACE,gBAAA;AJ++5BF;;AI7+5BA;EACE,gBAAA;AJg/5BF;;AI9+5BA;EACE,gBAAA;AJi/5BF;;AI/+5BA;EACE,gBAAA;AJk/5BF;;AIh/5BA;EACE,gBAAA;AJm/5BF;;AIj/5BA;EACE,gBAAA;AJo/5BF;;AIl/5BA;EACE,gBAAA;AJq/5BF;;AIn/5BA;EACE,gBAAA;AJs/5BF;;AIp/5BA;EACE,gBAAA;AJu/5BF;;AIr/5BA;EACE,gBAAA;AJw/5BF;;AIt/5BA;EACE,gBAAA;AJy/5BF;;AIv/5BA;EACE,gBAAA;AJ0/5BF;;AIx/5BA;EACE,gBAAA;AJ2/5BF;;AIz/5BA;EACE,gBAAA;AJ4/5BF;;AI1/5BA;EACE,gBAAA;AJ6/5BF;;AI3/5BA;EACE,gBAAA;AJ8/5BF;;AI5/5BA;EACE,gBAAA;AJ+/5BF;;AI7/5BA;EACE,gBAAA;AJgg6BF;;AI9/5BA;EACE,gBAAA;AJig6BF;;AI//5BA;EACE,gBAAA;AJkg6BF;;AIhg6BA;EACE,gBAAA;AJmg6BF;;AIjg6BA;EACE,gBAAA;AJog6BF;;AIlg6BA;EACE,gBAAA;AJqg6BF;;AIng6BA;EACE,gBAAA;AJsg6BF;;AIpg6BA;EACE,gBAAA;AJug6BF;;AIrg6BA;EACE,gBAAA;AJwg6BF;;AItg6BA;EACE,gBAAA;AJyg6BF;;AIvg6BA;EACE,gBAAA;AJ0g6BF;;AIxg6BA;EACE,gBAAA;AJ2g6BF;;AIzg6BA;EACE,gBAAA;AJ4g6BF;;AI1g6BA;EACE,gBAAA;AJ6g6BF;;AI3g6BA;EACE,gBAAA;AJ8g6BF;;AI5g6BA;EACE,gBAAA;AJ+g6BF;;AI7g6BA;EACE,gBAAA;AJgh6BF;;AI9g6BA;EACE,gBAAA;AJih6BF;;AI/g6BA;EACE,gBAAA;AJkh6BF;;AIhh6BA;EACE,gBAAA;AJmh6BF;;AIjh6BA;EACE,gBAAA;AJoh6BF;;AIlh6BA;EACE,gBAAA;AJqh6BF;;AInh6BA;EACE,gBAAA;AJsh6BF;;AIph6BA;EACE,gBAAA;AJuh6BF;;AIrh6BA;EACE,gBAAA;AJwh6BF;;AIth6BA;EACE,gBAAA;AJyh6BF;;AIvh6BA;EACE,gBAAA;AJ0h6BF;;AIxh6BA;EACE,gBAAA;AJ2h6BF;;AIzh6BA;EACE,gBAAA;AJ4h6BF;;AI1h6BA;EACE,gBAAA;AJ6h6BF;;AI3h6BA;EACE,gBAAA;AJ8h6BF;;AI5h6BA;EACE,gBAAA;AJ+h6BF;;AI7h6BA;EACE,gBAAA;AJgi6BF;;AI9h6BA;EACE,gBAAA;AJii6BF;;AI/h6BA;EACE,gBAAA;AJki6BF;;AIhi6BA;EACE,gBAAA;AJmi6BF;;AIji6BA;EACE,gBAAA;AJoi6BF;;AIli6BA;EACE,gBAAA;AJqi6BF;;AIni6BA;EACE,gBAAA;AJsi6BF;;AIpi6BA;EACE,gBAAA;AJui6BF;;AIri6BA;EACE,gBAAA;AJwi6BF;;AIti6BA;EACE,gBAAA;AJyi6BF;;AIvi6BA;EACE,gBAAA;AJ0i6BF;;AIxi6BA;EACE,gBAAA;AJ2i6BF;;AIzi6BA;EACE,gBAAA;AJ4i6BF;;AI1i6BA;EACE,gBAAA;AJ6i6BF;;AI3i6BA;EACE,gBAAA;AJ8i6BF;;AI5i6BA;EACE,gBAAA;AJ+i6BF;;AI7i6BA;EACE,gBAAA;AJgj6BF;;AI9i6BA;EACE,gBAAA;AJij6BF;;AI/i6BA;EACE,gBAAA;AJkj6BF;;AIhj6BA;EACE,gBAAA;AJmj6BF;;AIjj6BA;EACE,gBAAA;AJoj6BF;;AIlj6BA;EACE,gBAAA;AJqj6BF;;AInj6BA;EACE,gBAAA;AJsj6BF;;AIpj6BA;EACE,gBAAA;AJuj6BF;;AIrj6BA;EACE,gBAAA;AJwj6BF;;AItj6BA;EACE,gBAAA;AJyj6BF;;AIvj6BA;EACE,gBAAA;AJ0j6BF;;AIxj6BA;EACE,gBAAA;AJ2j6BF;;AIzj6BA;EACE,gBAAA;AJ4j6BF;;AI1j6BA;EACE,gBAAA;AJ6j6BF;;AI3j6BA;EACE,gBAAA;AJ8j6BF;;AI5j6BA;EACE,gBAAA;AJ+j6BF;;AI7j6BA;EACE,gBAAA;AJgk6BF;;AI9j6BA;EACE,gBAAA;AJik6BF;;AI/j6BA;EACE,gBAAA;AJkk6BF;;AIhk6BA;EACE,gBAAA;AJmk6BF;;AIjk6BA;EACE,gBAAA;AJok6BF;;AIlk6BA;EACE,gBAAA;AJqk6BF;;AInk6BA;EACE,gBAAA;AJsk6BF;;AIpk6BA;EACE,gBAAA;AJuk6BF;;AIrk6BA;EACE,gBAAA;AJwk6BF;;AItk6BA;EACE,gBAAA;AJyk6BF;;AIvk6BA;EACE,YAAA;AJ0k6BF;;AIxk6BA;EACE,gBAAA;AJ2k6BF;;AIzk6BA;EACE,gBAAA;AJ4k6BF;;AI1k6BA;EACE,gBAAA;AJ6k6BF;;AI3k6BA;EACE,gBAAA;AJ8k6BF;;AI5k6BA;EACE,YAAA;AJ+k6BF;;AI7k6BA;EACE,gBAAA;AJgl6BF;;AI9k6BA;EACE,gBAAA;AJil6BF;;AI/k6BA;EACE,gBAAA;AJkl6BF;;AIhl6BA;EACE,gBAAA;AJml6BF;;AIjl6BA;EACE,gBAAA;AJol6BF;;AIll6BA;EACE,gBAAA;AJql6BF;;AInl6BA;EACE,gBAAA;AJsl6BF;;AIpl6BA;EACE,gBAAA;AJul6BF;;AIrl6BA;EACE,gBAAA;AJwl6BF;;AItl6BA;EACE,gBAAA;AJyl6BF;;AIvl6BA;EACE,gBAAA;AJ0l6BF;;AIxl6BA;EACE,gBAAA;AJ2l6BF;;AIzl6BA;EACE,gBAAA;AJ4l6BF;;AI1l6BA;EACE,gBAAA;AJ6l6BF;;AI3l6BA;EACE,gBAAA;AJ8l6BF;;AI5l6BA;EACE,gBAAA;AJ+l6BF;;AI7l6BA;EACE,gBAAA;AJgm6BF;;AI9l6BA;EACE,gBAAA;AJim6BF;;AI/l6BA;EACE,gBAAA;AJkm6BF;;AIhm6BA;EACE,gBAAA;AJmm6BF;;AIjm6BA;EACE,gBAAA;AJom6BF;;AIlm6BA;EACE,gBAAA;AJqm6BF;;AInm6BA;EACE,gBAAA;AJsm6BF;;AIpm6BA;EACE,gBAAA;AJum6BF;;AIrm6BA;EACE,gBAAA;AJwm6BF;;AItm6BA;EACE,gBAAA;AJym6BF;;AIvm6BA;EACE,gBAAA;AJ0m6BF;;AIxm6BA;EACE,gBAAA;AJ2m6BF;;AIzm6BA;EACE,gBAAA;AJ4m6BF;;AI1m6BA;EACE,gBAAA;AJ6m6BF;;AI3m6BA;EACE,gBAAA;AJ8m6BF;;AI5m6BA;EACE,gBAAA;AJ+m6BF;;AI7m6BA;EACE,gBAAA;AJgn6BF;;AI9m6BA;EACE,gBAAA;AJin6BF;;AI/m6BA;EACE,gBAAA;AJkn6BF;;AIhn6BA;EACE,gBAAA;AJmn6BF;;AIjn6BA;EACE,gBAAA;AJon6BF;;AIln6BA;EACE,gBAAA;AJqn6BF;;AInn6BA;EACE,gBAAA;AJsn6BF;;AIpn6BA;EACE,gBAAA;AJun6BF;;AIrn6BA;EACE,gBAAA;AJwn6BF;;AItn6BA;EACE,gBAAA;AJyn6BF;;AIvn6BA;EACE,gBAAA;AJ0n6BF;;AIxn6BA;EACE,gBAAA;AJ2n6BF;;AIzn6BA;EACE,gBAAA;AJ4n6BF;;AI1n6BA;EACE,YAAA;AJ6n6BF;;AI3n6BA;EACE,gBAAA;AJ8n6BF;;AI5n6BA;EACE,gBAAA;AJ+n6BF;;AI7n6BA;EACE,gBAAA;AJgo6BF;;AI9n6BA;EACE,gBAAA;AJio6BF;;AI/n6BA;EACE,gBAAA;AJko6BF;;AIho6BA;EACE,gBAAA;AJmo6BF;;AIjo6BA;EACE,gBAAA;AJoo6BF;;AIlo6BA;EACE,gBAAA;AJqo6BF;;AIno6BA;EACE,gBAAA;AJso6BF;;AIpo6BA;EACE,gBAAA;AJuo6BF;;AIro6BA;EACE,gBAAA;AJwo6BF;;AIto6BA;EACE,gBAAA;AJyo6BF;;AIvo6BA;EACE,gBAAA;AJ0o6BF;;AIxo6BA;EACE,gBAAA;AJ2o6BF;;AIzo6BA;EACE,gBAAA;AJ4o6BF;;AI1o6BA;EACE,gBAAA;AJ6o6BF;;AI3o6BA;EACE,gBAAA;AJ8o6BF;;AI5o6BA;EACE,gBAAA;AJ+o6BF;;AI7o6BA;EACE,gBAAA;AJgp6BF;;AI9o6BA;EACE,gBAAA;AJip6BF;;AI/o6BA;EACE,gBAAA;AJkp6BF;;AIhp6BA;EACE,gBAAA;AJmp6BF;;AIjp6BA;EACE,gBAAA;AJop6BF;;AIlp6BA;EACE,gBAAA;AJqp6BF;;AInp6BA;EACE,gBAAA;AJsp6BF;;AIpp6BA;EACE,gBAAA;AJup6BF;;AIrp6BA;EACE,gBAAA;AJwp6BF;;AItp6BA;EACE,gBAAA;AJyp6BF;;AIvp6BA;EACE,gBAAA;AJ0p6BF;;AIxp6BA;EACE,gBAAA;AJ2p6BF;;AIzp6BA;EACE,gBAAA;AJ4p6BF;;AI1p6BA;EACE,gBAAA;AJ6p6BF;;AI3p6BA;EACE,gBAAA;AJ8p6BF;;AI5p6BA;EACE,gBAAA;AJ+p6BF;;AI7p6BA;EACE,gBAAA;AJgq6BF;;AI9p6BA;EACE,gBAAA;AJiq6BF;;AI/p6BA;EACE,gBAAA;AJkq6BF;;AIhq6BA;EACE,gBAAA;AJmq6BF;;AIjq6BA;EACE,gBAAA;AJoq6BF;;AIlq6BA;EACE,gBAAA;AJqq6BF;;AInq6BA;EACE,gBAAA;AJsq6BF;;AIpq6BA;EACE,gBAAA;AJuq6BF;;AIrq6BA;EACE,gBAAA;AJwq6BF;;AItq6BA;EACE,gBAAA;AJyq6BF;;AIvq6BA;EACE,gBAAA;AJ0q6BF;;AIxq6BA;EACE,gBAAA;AJ2q6BF;;AIzq6BA;EACE,gBAAA;AJ4q6BF;;AI1q6BA;EACE,gBAAA;AJ6q6BF;;AI3q6BA;EACE,gBAAA;AJ8q6BF;;AI5q6BA;EACE,gBAAA;AJ+q6BF;;AI7q6BA;EACE,gBAAA;AJgr6BF;;AI9q6BA;EACE,gBAAA;AJir6BF;;AI/q6BA;EACE,gBAAA;AJkr6BF;;AIhr6BA;EACE,gBAAA;AJmr6BF;;AIjr6BA;EACE,gBAAA;AJor6BF;;AIlr6BA;EACE,YAAA;AJqr6BF;;AInr6BA;EACE,gBAAA;AJsr6BF;;AIpr6BA;EACE,gBAAA;AJur6BF;;AIrr6BA;EACE,YAAA;AJwr6BF;;AItr6BA;EACE,YAAA;AJyr6BF;;AIvr6BA;EACE,gBAAA;AJ0r6BF;;AIxr6BA;EACE,gBAAA;AJ2r6BF;;AIzr6BA;EACE,gBAAA;AJ4r6BF;;AI1r6BA;EACE,gBAAA;AJ6r6BF;;AI3r6BA;EACE,gBAAA;AJ8r6BF;;AI5r6BA;EACE,gBAAA;AJ+r6BF;;AI7r6BA;EACE,gBAAA;AJgs6BF;;AI9r6BA;EACE,gBAAA;AJis6BF;;AI/r6BA;EACE,gBAAA;AJks6BF;;AIhs6BA;EACE,gBAAA;AJms6BF;;AIjs6BA;EACE,gBAAA;AJos6BF;;AIls6BA;EACE,gBAAA;AJqs6BF;;AIns6BA;EACE,gBAAA;AJss6BF;;AIps6BA;EACE,gBAAA;AJus6BF;;AIrs6BA;EACE,gBAAA;AJws6BF;;AIts6BA;EACE,gBAAA;AJys6BF;;AIvs6BA;EACE,gBAAA;AJ0s6BF;;AIxs6BA;EACE,gBAAA;AJ2s6BF;;AIzs6BA;EACE,gBAAA;AJ4s6BF;;AI1s6BA;EACE,gBAAA;AJ6s6BF;;AI3s6BA;EACE,gBAAA;AJ8s6BF;;AI5s6BA;EACE,gBAAA;AJ+s6BF;;AI7s6BA;EACE,gBAAA;AJgt6BF;;AI9s6BA;EACE,gBAAA;AJit6BF;;AI/s6BA;EACE,gBAAA;AJkt6BF;;AIht6BA;EACE,gBAAA;AJmt6BF;;AIjt6BA;EACE,gBAAA;AJot6BF;;AIlt6BA;EACE,gBAAA;AJqt6BF;;AInt6BA;EACE,gBAAA;AJst6BF;;AIpt6BA;EACE,gBAAA;AJut6BF;;AIrt6BA;EACE,gBAAA;AJwt6BF;;AItt6BA;EACE,gBAAA;AJyt6BF;;AIvt6BA;EACE,gBAAA;AJ0t6BF;;AIxt6BA;EACE,gBAAA;AJ2t6BF;;AIzt6BA;EACE,gBAAA;AJ4t6BF;;AI1t6BA;EACE,gBAAA;AJ6t6BF;;AI3t6BA;EACE,gBAAA;AJ8t6BF;;AI5t6BA;EACE,gBAAA;AJ+t6BF;;AI7t6BA;EACE,gBAAA;AJgu6BF;;AI9t6BA;EACE,gBAAA;AJiu6BF;;AI/t6BA;EACE,gBAAA;AJku6BF;;AIhu6BA;EACE,gBAAA;AJmu6BF;;AIju6BA;EACE,gBAAA;AJou6BF;;AIlu6BA;EACE,gBAAA;AJqu6BF;;AInu6BA;EACE,gBAAA;AJsu6BF;;AIpu6BA;EACE,gBAAA;AJuu6BF;;AIru6BA;EACE,gBAAA;AJwu6BF;;AItu6BA;EACE,gBAAA;AJyu6BF;;AIvu6BA;EACE,gBAAA;AJ0u6BF;;AIxu6BA;EACE,gBAAA;AJ2u6BF;;AIzu6BA;EACE,gBAAA;AJ4u6BF;;AI1u6BA;EACE,gBAAA;AJ6u6BF;;AI3u6BA;EACE,gBAAA;AJ8u6BF;;AI5u6BA;EACE,gBAAA;AJ+u6BF;;AI7u6BA;EACE,gBAAA;AJgv6BF;;AI9u6BA;EACE,gBAAA;AJiv6BF;;AI/u6BA;EACE,gBAAA;AJkv6BF;;AIhv6BA;EACE,gBAAA;AJmv6BF;;AIjv6BA;EACE,gBAAA;AJov6BF;;AIlv6BA;EACE,gBAAA;AJqv6BF;;AInv6BA;EACE,gBAAA;AJsv6BF;;AIpv6BA;EACE,gBAAA;AJuv6BF;;AIrv6BA;EACE,gBAAA;AJwv6BF;;AItv6BA;EACE,gBAAA;AJyv6BF;;AIvv6BA;EACE,gBAAA;AJ0v6BF;;AIxv6BA;EACE,gBAAA;AJ2v6BF;;AIzv6BA;EACE,gBAAA;AJ4v6BF;;AI1v6BA;EACE,gBAAA;AJ6v6BF;;AI3v6BA;EACE,gBAAA;AJ8v6BF;;AI5v6BA;EACE,gBAAA;AJ+v6BF;;AI7v6BA;EACE,gBAAA;AJgw6BF;;AI9v6BA;EACE,gBAAA;AJiw6BF;;AI/v6BA;EACE,gBAAA;AJkw6BF;;AIhw6BA;EACE,gBAAA;AJmw6BF;;AIjw6BA;EACE,gBAAA;AJow6BF;;AIlw6BA;EACE,gBAAA;AJqw6BF;;AInw6BA;EACE,gBAAA;AJsw6BF;;AIpw6BA;EACE,gBAAA;AJuw6BF;;AIrw6BA;EACE,gBAAA;AJww6BF;;AItw6BA;EACE,YAAA;AJyw6BF;;AIvw6BA;EACE,gBAAA;AJ0w6BF;;AIxw6BA;EACE,gBAAA;AJ2w6BF;;AIzw6BA;EACE,gBAAA;AJ4w6BF;;AI1w6BA;EACE,gBAAA;AJ6w6BF;;AI3w6BA;EACE,gBAAA;AJ8w6BF;;AI5w6BA;EACE,gBAAA;AJ+w6BF;;AI7w6BA;EACE,gBAAA;AJgx6BF;;AI9w6BA;EACE,gBAAA;AJix6BF;;AI/w6BA;EACE,gBAAA;AJkx6BF;;AIhx6BA;EACE,YAAA;AJmx6BF;;AIjx6BA;EACE,gBAAA;AJox6BF;;AIlx6BA;EACE,gBAAA;AJqx6BF;;AInx6BA;EACE,gBAAA;AJsx6BF;;AIpx6BA;EACE,gBAAA;AJux6BF;;AIrx6BA;EACE,gBAAA;AJwx6BF;;AItx6BA;EACE,gBAAA;AJyx6BF;;AIvx6BA;EACE,gBAAA;AJ0x6BF;;AIxx6BA;EACE,gBAAA;AJ2x6BF;;AIzx6BA;EACE,gBAAA;AJ4x6BF;;AI1x6BA;EACE,gBAAA;AJ6x6BF;;AI3x6BA;EACE,gBAAA;AJ8x6BF;;AI5x6BA;EACE,gBAAA;AJ+x6BF;;AI7x6BA;EACE,gBAAA;AJgy6BF;;AI9x6BA;EACE,gBAAA;AJiy6BF;;AI/x6BA;EACE,gBAAA;AJky6BF;;AIhy6BA;EACE,gBAAA;AJmy6BF;;AIjy6BA;EACE,gBAAA;AJoy6BF;;AIly6BA;EACE,gBAAA;AJqy6BF;;AIny6BA;EACE,gBAAA;AJsy6BF;;AIpy6BA;EACE,gBAAA;AJuy6BF;;AIry6BA;EACE,gBAAA;AJwy6BF;;AIty6BA;EACE,gBAAA;AJyy6BF;;AIvy6BA;EACE,gBAAA;AJ0y6BF;;AIxy6BA;EACE,gBAAA;AJ2y6BF;;AIzy6BA;EACE,gBAAA;AJ4y6BF;;AI1y6BA;EACE,gBAAA;AJ6y6BF;;AI3y6BA;EACE,gBAAA;AJ8y6BF;;AI5y6BA;EACE,gBAAA;AJ+y6BF;;AI7y6BA;EACE,gBAAA;AJgz6BF;;AI9y6BA;EACE,gBAAA;AJiz6BF;;AI/y6BA;EACE,gBAAA;AJkz6BF;;AIhz6BA;EACE,gBAAA;AJmz6BF;;AIjz6BA;EACE,gBAAA;AJoz6BF;;AIlz6BA;EACE,gBAAA;AJqz6BF;;AInz6BA;EACE,gBAAA;AJsz6BF;;AIpz6BA;EACE,gBAAA;AJuz6BF;;AIrz6BA;EACE,YAAA;AJwz6BF;;AItz6BA;EACE,gBAAA;AJyz6BF;;AIvz6BA;EACE,gBAAA;AJ0z6BF;;AIxz6BA;EACE,gBAAA;AJ2z6BF;;AIzz6BA;EACE,gBAAA;AJ4z6BF;;AI1z6BA;EACE,gBAAA;AJ6z6BF;;AI3z6BA;EACE,gBAAA;AJ8z6BF;;AI5z6BA;EACE,gBAAA;AJ+z6BF;;AI7z6BA;EACE,gBAAA;AJg06BF;;AI9z6BA;EACE,gBAAA;AJi06BF;;AI/z6BA;EACE,gBAAA;AJk06BF;;AIh06BA;EACE,gBAAA;AJm06BF;;AIj06BA;EACE,gBAAA;AJo06BF;;AIl06BA;EACE,gBAAA;AJq06BF;;AIn06BA;EACE,gBAAA;AJs06BF;;AIp06BA;EACE,gBAAA;AJu06BF;;AIr06BA;EACE,gBAAA;AJw06BF;;AIt06BA;EACE,gBAAA;AJy06BF;;AIv06BA;EACE,gBAAA;AJ006BF;;AIx06BA;EACE,gBAAA;AJ206BF;;AIz06BA;EACE,gBAAA;AJ406BF;;AI106BA;EACE,gBAAA;AJ606BF;;AI306BA;EACE,gBAAA;AJ806BF;;AI506BA;EACE,gBAAA;AJ+06BF;;AI706BA;EACE,gBAAA;AJg16BF;;AI906BA;EACE,gBAAA;AJi16BF;;AI/06BA;EACE,gBAAA;AJk16BF;;AIh16BA;EACE,gBAAA;AJm16BF;;AIj16BA;EACE,gBAAA;AJo16BF;;AIl16BA;EACE,gBAAA;AJq16BF;;AIn16BA;EACE,gBAAA;AJs16BF;;AIp16BA;EACE,gBAAA;AJu16BF;;AIr16BA;EACE,gBAAA;AJw16BF;;AIt16BA;EACE,gBAAA;AJy16BF;;AIv16BA;EACE,gBAAA;AJ016BF;;AIx16BA;EACE,gBAAA;AJ216BF;;AIz16BA;EACE,gBAAA;AJ416BF;;AI116BA;EACE,gBAAA;AJ616BF;;AI316BA;EACE,gBAAA;AJ816BF;;AI516BA;EACE,gBAAA;AJ+16BF;;AI716BA;EACE,gBAAA;AJg26BF;;AI916BA;EACE,gBAAA;AJi26BF;;AI/16BA;EACE,gBAAA;AJk26BF;;AIh26BA;EACE,gBAAA;AJm26BF;;AIj26BA;EACE,gBAAA;AJo26BF;;AIl26BA;EACE,gBAAA;AJq26BF;;AIn26BA;EACE,gBAAA;AJs26BF;;AIp26BA;EACE,gBAAA;AJu26BF;;AIr26BA;EACE,gBAAA;AJw26BF;;AIt26BA;EACE,gBAAA;AJy26BF;;AIv26BA;EACE,gBAAA;AJ026BF;;AIx26BA;EACE,gBAAA;AJ226BF;;AIz26BA;EACE,gBAAA;AJ426BF;;AI126BA;EACE,gBAAA;AJ626BF;;AI326BA;EACE,gBAAA;AJ826BF;;AI526BA;EACE,gBAAA;AJ+26BF;;AI726BA;EACE,gBAAA;AJg36BF;;AI926BA;EACE,gBAAA;AJi36BF;;AI/26BA;EACE,YAAA;AJk36BF;;AIh36BA;EACE,YAAA;AJm36BF;;AIj36BA;EACE,YAAA;AJo36BF;;AIl36BA;EACE,gBAAA;AJq36BF;;AIn36BA;EACE,gBAAA;AJs36BF;;AIp36BA;EACE,gBAAA;AJu36BF;;AIr36BA;EACE,gBAAA;AJw36BF;;AIt36BA;EACE,gBAAA;AJy36BF;;AIv36BA;EACE,gBAAA;AJ036BF;;AIx36BA;EACE,gBAAA;AJ236BF;;AIz36BA;EACE,gBAAA;AJ436BF;;AI136BA;EACE,gBAAA;AJ636BF;;AI336BA;EACE,gBAAA;AJ836BF;;AI536BA;EACE,gBAAA;AJ+36BF;;AI736BA;EACE,gBAAA;AJg46BF;;AI936BA;EACE,gBAAA;AJi46BF;;AI/36BA;EACE,gBAAA;AJk46BF;;AIh46BA;EACE,gBAAA;AJm46BF;;AIj46BA;EACE,gBAAA;AJo46BF;;AIl46BA;EACE,gBAAA;AJq46BF;;AIn46BA;EACE,gBAAA;AJs46BF;;AIp46BA;EACE,gBAAA;AJu46BF;;AIr46BA;EACE,gBAAA;AJw46BF;;AIt46BA;EACE,gBAAA;AJy46BF;;AIv46BA;EACE,gBAAA;AJ046BF;;AIx46BA;EACE,gBAAA;AJ246BF;;AIz46BA;EACE,gBAAA;AJ446BF;;AI146BA;EACE,gBAAA;AJ646BF;;AI346BA;EACE,gBAAA;AJ846BF;;AI546BA;EACE,gBAAA;AJ+46BF;;AI746BA;EACE,gBAAA;AJg56BF;;AI946BA;EACE,gBAAA;AJi56BF;;AI/46BA;EACE,gBAAA;AJk56BF;;AIh56BA;EACE,gBAAA;AJm56BF;;AIj56BA;EACE,gBAAA;AJo56BF;;AIl56BA;EACE,gBAAA;AJq56BF;;AIn56BA;EACE,gBAAA;AJs56BF;;AIp56BA;EACE,gBAAA;AJu56BF;;AIr56BA;EACE,gBAAA;AJw56BF;;AIt56BA;EACE,gBAAA;AJy56BF;;AIv56BA;EACE,gBAAA;AJ056BF;;AIx56BA;EACE,gBAAA;AJ256BF;;AIz56BA;EACE,gBAAA;AJ456BF;;AI156BA;EACE,gBAAA;AJ656BF;;AI356BA;EACE,gBAAA;AJ856BF;;AI556BA;EACE,gBAAA;AJ+56BF;;AI756BA;EACE,gBAAA;AJg66BF;;AI956BA;EACE,gBAAA;AJi66BF;;AI/56BA;EACE,gBAAA;AJk66BF;;AIh66BA;EACE,gBAAA;AJm66BF;;AIj66BA;EACE,gBAAA;AJo66BF;;AIl66BA;EACE,gBAAA;AJq66BF;;AIn66BA;EACE,gBAAA;AJs66BF;;AIp66BA;EACE,gBAAA;AJu66BF;;AIr66BA;EACE,gBAAA;AJw66BF;;AIt66BA;EACE,gBAAA;AJy66BF;;AIv66BA;EACE,gBAAA;AJ066BF;;AIx66BA;EACE,gBAAA;AJ266BF;;AIz66BA;EACE,gBAAA;AJ466BF;;AI166BA;EACE,gBAAA;AJ666BF;;AI366BA;EACE,gBAAA;AJ866BF;;AI566BA;EACE,gBAAA;AJ+66BF;;AI766BA;EACE,gBAAA;AJg76BF;;AI966BA;EACE,gBAAA;AJi76BF;;AI/66BA;EACE,gBAAA;AJk76BF;;AIh76BA;EACE,gBAAA;AJm76BF;;AIj76BA;EACE,gBAAA;AJo76BF;;AIl76BA;EACE,gBAAA;AJq76BF;;AIn76BA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AJs76BF;;AIp76BA;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AJu76BF;;AIt76BA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AJy76BF;AIv76BA;EACE,oCAAA;EACA,gBAAA;AJy76BF;;AIx76BA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AJ276BF;AIz76BA;EACE,kCAAA;EACA,gBAAA;AJ276BF;;AI176BA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AJ676BF;AI376BA;;EAEE,kCAAA;EACA,gBAAA;AJ676BF;;AKt4jCA;EACE,2BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;ALs4jCF;AKl4jCA;EACE,sCAAA;EACA,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;ALo4jCF;;AKj4jCA;;EAEE,sCAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;ALo4jCF;;AKj4jCA;EACE,YAAA;ALo4jCF;;AKl4jCA;EACE,YAAA;ALq4jCF;;AKn4jCA;EACE,YAAA;ALs4jCF;;AKp4jCA;EACE,YAAA;ALu4jCF;;AKr4jCA;EACE,YAAA;ALw4jCF;;AKt4jCA;EACE,YAAA;ALy4jCF;;AKv4jCA;EACE,YAAA;AL04jCF;;AKx4jCA;EACE,YAAA;AL24jCF;;AKz4jCA;EACE,YAAA;AL44jCF;;AK14jCA;EACE,YAAA;AL64jCF;;AK34jCA;EACE,YAAA;AL84jCF;;AK54jCA;EACE,YAAA;AL+4jCF;;AK74jCA;EACE,YAAA;ALg5jCF;;AK94jCA;EACE,YAAA;ALi5jCF;;AK/4jCA;EACE,YAAA;ALk5jCF;;AKh5jCA;EACE,YAAA;ALm5jCF;;AKj5jCA;EACE,YAAA;ALo5jCF;;AKl5jCA;EACE,YAAA;ALq5jCF;;AKn5jCA;EACE,YAAA;ALs5jCF;;AKp5jCA;EACE,YAAA;ALu5jCF;;AKr5jCA;EACE,YAAA;ALw5jCF;;AKt5jCA;EACE,YAAA;ALy5jCF;;AKv5jCA;EACE,YAAA;AL05jCF;;AKx5jCA;EACE,YAAA;AL25jCF;;AKz5jCA;EACE,YAAA;AL45jCF;;AK15jCA;EACE,YAAA;AL65jCF;;AK35jCA;EACE,YAAA;AL85jCF;;AK55jCA;EACE,YAAA;AL+5jCF;;AK75jCA;EACE,YAAA;ALg6jCF;;AK95jCA;EACE,YAAA;ALi6jCF;;AK/5jCA;EACE,YAAA;ALk6jCF;;AKh6jCA;EACE,YAAA;ALm6jCF;;AKj6jCA;EACE,YAAA;ALo6jCF;;AKl6jCA;EACE,YAAA;ALq6jCF;;AKn6jCA;EACE,YAAA;ALs6jCF;;AKp6jCA;EACE,YAAA;ALu6jCF;;AKr6jCA;EACE,YAAA;ALw6jCF;;AKt6jCA;EACE,YAAA;ALy6jCF;;AKv6jCA;EACE,YAAA;AL06jCF;;AKx6jCA;EACE,YAAA;AL26jCF;;AKz6jCA;EACE,YAAA;AL46jCF;;AK16jCA;EACE,YAAA;AL66jCF;;AK36jCA;EACE,YAAA;AL86jCF;;AK56jCA;EACE,YAAA;AL+6jCF;;AK76jCA;EACE,YAAA;ALg7jCF;;AK96jCA;EACE,YAAA;ALi7jCF;;AK/6jCA;EACE,YAAA;ALk7jCF;;AKh7jCA;EACE,YAAA;ALm7jCF;;AKj7jCA;EACE,YAAA;ALo7jCF;;AKl7jCA;EACE,YAAA;ALq7jCF;;AKn7jCA;EACE,YAAA;ALs7jCF;;AKp7jCA;EACE,YAAA;ALu7jCF;;AKr7jCA;EACE,YAAA;ALw7jCF;;AKt7jCA;EACE,YAAA;ALy7jCF;;AKv7jCA;EACE,YAAA;AL07jCF;;AKx7jCA;EACE,YAAA;AL27jCF;;AKz7jCA;EACE,YAAA;AL47jCF;;AK17jCA;EACE,YAAA;AL67jCF;;AK37jCA;EACE,YAAA;AL87jCF;;AK57jCA;EACE,YAAA;AL+7jCF;;AK77jCA;EACE,YAAA;ALg8jCF;;AK97jCA;EACE,YAAA;ALi8jCF;;AK/7jCA;EACE,YAAA;ALk8jCF;;AKh8jCA;EACE,YAAA;ALm8jCF;;AKj8jCA;EACE,YAAA;ALo8jCF;;AKl8jCA;EACE,YAAA;ALq8jCF;;AKn8jCA;EACE,YAAA;ALs8jCF;;AKp8jCA;EACE,YAAA;ALu8jCF;;AKr8jCA;EACE,YAAA;ALw8jCF;;AKt8jCA;EACE,YAAA;ALy8jCF;;AKv8jCA;EACE,YAAA;AL08jCF;;AKx8jCA;EACE,YAAA;AL28jCF;;AKz8jCA;EACE,YAAA;AL48jCF;;AK18jCA;EACE,YAAA;AL68jCF;;AK38jCA;EACE,YAAA;AL88jCF;;AK58jCA;EACE,YAAA;AL+8jCF;;AK78jCA;EACE,YAAA;ALg9jCF;;AK98jCA;EACE,YAAA;ALi9jCF;;AK/8jCA;EACE,YAAA;ALk9jCF;;AKh9jCA;EACE,YAAA;ALm9jCF;;AKj9jCA;EACE,YAAA;ALo9jCF;;AKl9jCA;EACE,YAAA;ALq9jCF;;AKn9jCA;EACE,YAAA;ALs9jCF;;AKp9jCA;EACE,YAAA;ALu9jCF;;AKr9jCA;EACE,YAAA;ALw9jCF;;AKt9jCA;EACE,YAAA;ALy9jCF;;AKv9jCA;EACE,YAAA;AL09jCF;;AKx9jCA;EACE,YAAA;AL29jCF;;AKz9jCA;EACE,YAAA;AL49jCF;;AK19jCA;EACE,YAAA;AL69jCF;;AK39jCA;EACE,YAAA;AL89jCF;;AK59jCA;EACE,YAAA;AL+9jCF;;AK79jCA;EACE,YAAA;ALg+jCF;;AK99jCA;EACE,aAAA;ALi+jCF;;AK/9jCA;EACE,gBAAA;ALk+jCF;;AKh+jCA;EACE,gBAAA;ALm+jCF;;AKj+jCA;EACE,gBAAA;ALo+jCF;;AKl+jCA;EACE,gBAAA;ALq+jCF;;AKn+jCA;EACE,gBAAA;ALs+jCF;;AKp+jCA;EACE,gBAAA;ALu+jCF;;AKr+jCA;EACE,gBAAA;ALw+jCF;;AKt+jCA;EACE,gBAAA;ALy+jCF;;AKv+jCA;EACE,gBAAA;AL0+jCF;;AKx+jCA;EACE,gBAAA;AL2+jCF;;AKz+jCA;EACE,gBAAA;AL4+jCF;;AK1+jCA;EACE,gBAAA;AL6+jCF;;AK3+jCA;EACE,gBAAA;AL8+jCF;;AK5+jCA;EACE,gBAAA;AL++jCF;;AK7+jCA;EACE,gBAAA;ALg/jCF;;AK9+jCA;EACE,gBAAA;ALi/jCF;;AK/+jCA;EACE,gBAAA;ALk/jCF;;AKh/jCA;EACE,gBAAA;ALm/jCF;;AKj/jCA;EACE,gBAAA;ALo/jCF;;AKl/jCA;EACE,gBAAA;ALq/jCF;;AKn/jCA;EACE,gBAAA;ALs/jCF;;AKp/jCA;EACE,gBAAA;ALu/jCF;;AKr/jCA;EACE,gBAAA;ALw/jCF;;AKt/jCA;EACE,gBAAA;ALy/jCF;;AKv/jCA;EACE,gBAAA;AL0/jCF;;AKx/jCA;EACE,gBAAA;AL2/jCF;;AKz/jCA;EACE,gBAAA;AL4/jCF;;AK1/jCA;EACE,gBAAA;AL6/jCF;;AK3/jCA;EACE,gBAAA;AL8/jCF;;AK5/jCA;EACE,gBAAA;AL+/jCF;;AK7/jCA;EACE,gBAAA;ALggkCF;;AK9/jCA;EACE,gBAAA;ALigkCF;;AK//jCA;EACE,gBAAA;ALkgkCF;;AKhgkCA;EACE,gBAAA;ALmgkCF;;AKjgkCA;EACE,gBAAA;ALogkCF;;AKlgkCA;EACE,gBAAA;ALqgkCF;;AKngkCA;EACE,gBAAA;ALsgkCF;;AKpgkCA;EACE,gBAAA;ALugkCF;;AKrgkCA;EACE,gBAAA;ALwgkCF;;AKtgkCA;EACE,gBAAA;ALygkCF;;AKvgkCA;EACE,gBAAA;AL0gkCF;;AKxgkCA;EACE,gBAAA;AL2gkCF;;AKzgkCA;EACE,gBAAA;AL4gkCF;;AK1gkCA;EACE,gBAAA;AL6gkCF;;AK3gkCA;EACE,gBAAA;AL8gkCF;;AK5gkCA;EACE,gBAAA;AL+gkCF;;AK7gkCA;EACE,gBAAA;ALghkCF;;AK9gkCA;EACE,gBAAA;ALihkCF;;AK/gkCA;EACE,gBAAA;ALkhkCF;;AKhhkCA;EACE,gBAAA;ALmhkCF;;AKjhkCA;EACE,gBAAA;ALohkCF;;AKlhkCA;EACE,gBAAA;ALqhkCF;;AKnhkCA;EACE,gBAAA;ALshkCF;;AKphkCA;EACE,gBAAA;ALuhkCF;;AKrhkCA;EACE,gBAAA;ALwhkCF;;AKthkCA;EACE,gBAAA;ALyhkCF;;AKvhkCA;EACE,gBAAA;AL0hkCF;;AKxhkCA;EACE,gBAAA;AL2hkCF;;AKzhkCA;EACE,gBAAA;AL4hkCF;;AK1hkCA;EACE,gBAAA;AL6hkCF;;AK3hkCA;EACE,gBAAA;AL8hkCF;;AK5hkCA;EACE,gBAAA;AL+hkCF;;AK7hkCA;EACE,gBAAA;ALgikCF;;AK9hkCA;EACE,gBAAA;ALiikCF;;AK/hkCA;EACE,gBAAA;ALkikCF;;AKhikCA;EACE,gBAAA;ALmikCF;;AKjikCA;EACE,gBAAA;ALoikCF;;AKlikCA;EACE,gBAAA;ALqikCF;;AKnikCA;EACE,gBAAA;ALsikCF;;AKpikCA;EACE,gBAAA;ALuikCF;;AKrikCA;EACE,gBAAA;ALwikCF;;AKtikCA;EACE,gBAAA;ALyikCF;;AKvikCA;EACE,gBAAA;AL0ikCF;;AKxikCA;EACE,gBAAA;AL2ikCF;;AKzikCA;EACE,gBAAA;AL4ikCF;;AK1ikCA;EACE,gBAAA;AL6ikCF;;AK3ikCA;EACE,gBAAA;AL8ikCF;;AK5ikCA;EACE,gBAAA;AL+ikCF;;AK7ikCA;EACE,gBAAA;ALgjkCF;;AK9ikCA;EACE,gBAAA;ALijkCF;;AK/ikCA;EACE,gBAAA;ALkjkCF;;AKhjkCA;EACE,gBAAA;ALmjkCF;;AKjjkCA;EACE,gBAAA;ALojkCF;;AKljkCA;EACE,gBAAA;ALqjkCF;;AKnjkCA;EACE,gBAAA;ALsjkCF;;AKpjkCA;EACE,gBAAA;ALujkCF;;AKrjkCA;EACE,gBAAA;ALwjkCF;;AKtjkCA;EACE,gBAAA;ALyjkCF;;AKvjkCA;EACE,gBAAA;AL0jkCF;;AKxjkCA;EACE,gBAAA;AL2jkCF;;AKzjkCA;EACE,gBAAA;AL4jkCF;;AK1jkCA;EACE,gBAAA;AL6jkCF;;AK3jkCA;EACE,gBAAA;AL8jkCF;;AK5jkCA;EACE,gBAAA;AL+jkCF;;AK7jkCA;EACE,gBAAA;ALgkkCF;;AK9jkCA;EACE,gBAAA;ALikkCF;;AK/jkCA;EACE,gBAAA;ALkkkCF;;AKhkkCA;EACE,gBAAA;ALmkkCF;;AKjkkCA;EACE,gBAAA;ALokkCF;;AKlkkCA;EACE,gBAAA;ALqkkCF;;AKnkkCA;EACE,gBAAA;ALskkCF;;AKpkkCA;EACE,gBAAA;ALukkCF;;AKrkkCA;EACE,gBAAA;ALwkkCF;;AKtkkCA;EACE,gBAAA;ALykkCF;;AKvkkCA;EACE,gBAAA;AL0kkCF;;AKxkkCA;EACE,gBAAA;AL2kkCF;;AMzslCA;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,2CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,8BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,0BAAA;EAEA,8BAAA;EACA,sCAAA;EAGE,qCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,wDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AR6slCF;;AU7zlCI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AR6slCJ;;AWr3lCA;;;EAGE,sBAAA;AXw3lCF;;AWz2lCI;EANJ;IAOM,uBAAA;EX62lCJ;AACF;;AWh2lCA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AXm2lCF;;AW11lCA;EACE,cAAA;EACA,cCspBS;EDrpBT,SAAA;EACA,wCAAA;EACA,YCqpBW;AZwskCb;;AWn1lCA;EACE,aAAA;EACA,qBCgmBuB;ED7lBvB,gBCgmBqB;ED/lBrB,gBCgmBqB;ED/lBrB,8BAAA;AXo1lCF;;AWj1lCA;EFuMQ,uCAAA;AT8olCR;AS1ylCI;EE3CJ;IF8MQ,qBAAA;ET2olCN;AACF;;AWr1lCA;EFkMQ,mCAAA;ATuplCR;ASnzlCI;EEtCJ;IFyMQ,mBAAA;EToplCN;AACF;;AWz1lCA;EF6LQ,yCAAA;ATgqlCR;AS5zlCI;EEjCJ;IFoMQ,sBAAA;ET6plCN;AACF;;AW71lCA;EFoLM,qBALI;ATkrlCV;;AW51lCA;EF+KM,sBALI;ATsrlCV;;AW31lCA;EF0KM,oBALI;AT0rlCV;;AWp1lCA;EACE,aAAA;EACA,mBCiZwB;AZs8kC1B;;AW70lCA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AXg1lCF;;AW10lCA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AX60lCF;;AWv0lCA;;EAEE,kBAAA;AX00lCF;;AWv0lCA;;;EAGE,aAAA;EACA,mBAAA;AX00lCF;;AWv0lCA;;;;EAIE,gBAAA;AX00lCF;;AWv0lCA;EACE,gBCseiB;AZo2kCnB;;AWr0lCA;EACE,qBAAA;EACA,cAAA;AXw0lCF;;AWl0lCA;EACE,gBAAA;AXq0lCF;;AW7zlCA;;EAEE,mBC+cmB;AZi3kCrB;;AWxzlCA;EF6EM,cALI;ATovlCV;;AWrzlCA;EACE,cCygBa;EDxgBb,gCAAA;EACA,wCAAA;AXwzlCF;;AW/ylCA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AXkzlCF;;AW/ylCA;EAAM,eAAA;AXmzlCN;;AWlzlCA;EAAM,WAAA;AXszlCN;;AWjzlCA;EACE,gEAAA;EACA,qBCkRgB;AZkilClB;AWlzlCE;EACE,mDAAA;EACA,0BCiRoB;AZmilCxB;;AW1ylCE;EAEE,cAAA;EACA,qBAAA;AX4ylCJ;;AWrylCA;;;;EAIE,qCC2XiB;EH7Wb,cALI;ATgylCV;;AWjylCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,gBALI;EEKR,cCpMS;AZw+lCX;AWjylCE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AXmylCJ;;AW/xlCA;EFVM,gBALI;EEiBR,2BAAA;EACA,qBAAA;AXkylCF;AW/xlCE;EACE,cAAA;AXiylCJ;;AW7xlCA;EACE,sBAAA;EFtBI,gBALI;EE6BR,WCrOM;EDsON,yBC7NS;ECxEP,qBAAA;AbskmCJ;AW9xlCE;EACE,UAAA;EF7BE,cALI;EEoCN,gBC0Ve;AZs8kCnB;;AWvxlCA;EACE,gBAAA;AX0xlCF;;AWpxlCA;;EAEE,sBAAA;AXuxlCF;;AW/wlCA;EACE,oBAAA;EACA,yBAAA;AXkxlCF;;AW/wlCA;EACE,oBCqZqB;EDpZrB,uBCoZqB;EDnZrB,cCxQS;EDyQT,gBAAA;AXkxlCF;;AW3wlCA;EAEE,mBAAA;EACA,gCAAA;AX6wlCF;;AW1wlCA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AX6wlCF;;AWrwlCA;EACE,qBAAA;AXwwlCF;;AWlwlCA;EAEE,gBAAA;AXowlCF;;AW5vlCA;EACE,UAAA;AX+vlCF;;AW1vlCA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AX6vlCF;;AWzvlCA;;EAEE,oBAAA;AX4vlCF;;AWvvlCA;EACE,eAAA;AX0vlCF;;AWvvlCA;EAGE,iBAAA;AXwvlCF;AWrvlCE;EACE,UAAA;AXuvlCJ;;AWhvlCA;EACE,wBAAA;AXmvlCF;;AW3ulCA;;;;EAIE,0BAAA;AX8ulCF;AW3ulCI;;;;EACE,eAAA;AXgvlCN;;AWzulCA;EACE,UAAA;EACA,kBAAA;AX4ulCF;;AWvulCA;EACE,gBAAA;AX0ulCF;;AWhulCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AXmulCF;;AW3tlCA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC2OqB;EDzOrB,oBAAA;EFnNM,iCAAA;ATi7lCR;AS7kmCI;EEyWJ;IFtMQ,iBAAA;ET86lCN;AACF;AWhulCE;EACE,WAAA;AXkulCJ;;AW3tlCA;;;;;;;EAOE,UAAA;AX8tlCF;;AW3tlCA;EACE,YAAA;AX8tlCF;;AWrtlCA;EACE,6BAAA;EACA,oBAAA;AXwtlCF;;AWhtlCA;;;;;;;CAAA;AAWA;EACE,wBAAA;AXgtlCF;;AW3slCA;EACE,UAAA;AX8slCF;;AWvslCA;EACE,aAAA;EACA,0BAAA;AX0slCF;;AWrslCA;EACE,qBAAA;AXwslCF;;AWnslCA;EACE,SAAA;AXsslCF;;AW/rlCA;EACE,kBAAA;EACA,eAAA;AXkslCF;;AW1rlCA;EACE,wBAAA;AX6rlCF;;AWrrlCA;EACE,wBAAA;AXwrlCF;;Ac7vmCA;ELmQM,sBALI;EK5PR,gBF8qBiB;AZkllCnB;;Ac3vmCE;EAGE,gBFgqBkB;EE/pBlB,gBFipBmB;EHrZf,iCAAA;ATigmCR;AS7pmCI;EKpGF;ILuQM,eAAA;ET8/lCN;AACF;;ActwmCE;EAGE,gBFgqBkB;EE/pBlB,gBFipBmB;EHrZf,iCAAA;AT4gmCR;ASxqmCI;EKpGF;ILuQM,iBAAA;ETygmCN;AACF;;AcjxmCE;EAGE,gBFgqBkB;EE/pBlB,gBFipBmB;EHrZf,iCAAA;ATuhmCR;ASnrmCI;EKpGF;ILuQM,iBAAA;ETohmCN;AACF;;Ac5xmCE;EAGE,gBFgqBkB;EE/pBlB,gBFipBmB;EHrZf,iCAAA;ATkimCR;AS9rmCI;EKpGF;ILuQM,iBAAA;ET+hmCN;AACF;;AcvymCE;EAGE,gBFgqBkB;EE/pBlB,gBFipBmB;EHrZf,iCAAA;AT6imCR;ASzsmCI;EKpGF;ILuQM,eAAA;ET0imCN;AACF;;AclzmCE;EAGE,gBFgqBkB;EE/pBlB,gBFipBmB;EHrZf,iCAAA;ATwjmCR;ASptmCI;EKpGF;ILuQM,iBAAA;ETqjmCN;AACF;;AcrymCA;ECvDE,eAAA;EACA,gBAAA;Afg2mCF;;AcrymCA;EC5DE,eAAA;EACA,gBAAA;Afq2mCF;;AcvymCA;EACE,qBAAA;Ad0ymCF;AcxymCE;EACE,oBFkqBkB;AZwolCtB;;AchymCA;EL8MM,cALI;EKvMR,yBAAA;AdmymCF;;Ac/xmCA;EACE,mBFuWO;EHhKH,sBALI;ATimmCV;AchymCE;EACE,gBAAA;AdkymCJ;;Ac9xmCA;EACE,iBAAA;EACA,mBF6VO;EHhKH,cALI;EKtLR,cFZS;AZ6ymCX;Ac/xmCE;EACE,aAAA;AdiymCJ;;AgBj4mCA;ECIE,eAAA;EAGA,YAAA;AjB+3mCF;;AgBh4mCA;EACE,gBJqjDkB;EIpjDlB,yBJ8cQ;EI7cR,yBAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AjBw4mCF;;AgB13mCA;EAEE,qBAAA;AhB43mCF;;AgBz3mCA;EACE,qBAAA;EACA,cAAA;AhB43mCF;;AgBz3mCA;EPyPM,cALI;EOlPR,cJgDS;AZ40mCX;;AkB95mCE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AnB26mCF;;AoBr3mCI;EF5CE;IACE,gBNyhBe;EZ44lCrB;AACF;AoB33mCI;EF5CE;IACE,gBNyhBe;EZi5lCrB;AACF;AoBh4mCI;EF5CE;IACE,gBNyhBe;EZs5lCrB;AACF;AoBr4mCI;EF5CE;IACE,iBNyhBe;EZ25lCrB;AACF;AoB14mCI;EF5CE;IACE,iBNyhBe;EZg6lCrB;AACF;AqB18mCA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;ArBg9mCJ;;AqB38mCE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AtBo9mCF;AqBl9mCI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AtB88mCF;;AsB/5mCM;EACE,SAAA;AtBk6mCR;;AsB/5mCM;EApCJ,cAAA;EACA,WAAA;AtBu8mCF;;AsBz7mCE;EACE,cAAA;EACA,WAAA;AtB47mCJ;;AsB97mCE;EACE,cAAA;EACA,UAAA;AtBi8mCJ;;AsBn8mCE;EACE,cAAA;EACA,mBAAA;AtBs8mCJ;;AsBx8mCE;EACE,cAAA;EACA,UAAA;AtB28mCJ;;AsB78mCE;EACE,cAAA;EACA,UAAA;AtBg9mCJ;;AsBl9mCE;EACE,cAAA;EACA,mBAAA;AtBq9mCJ;;AsBt7mCM;EAhDJ,cAAA;EACA,WAAA;AtB0+mCF;;AsBr7mCU;EAhEN,cAAA;EACA,kBAAA;AtBy/mCJ;;AsB17mCU;EAhEN,cAAA;EACA,mBAAA;AtB8/mCJ;;AsB/7mCU;EAhEN,cAAA;EACA,UAAA;AtBmgnCJ;;AsBp8mCU;EAhEN,cAAA;EACA,mBAAA;AtBwgnCJ;;AsBz8mCU;EAhEN,cAAA;EACA,mBAAA;AtB6gnCJ;;AsB98mCU;EAhEN,cAAA;EACA,UAAA;AtBkhnCJ;;AsBn9mCU;EAhEN,cAAA;EACA,mBAAA;AtBuhnCJ;;AsBx9mCU;EAhEN,cAAA;EACA,mBAAA;AtB4hnCJ;;AsB79mCU;EAhEN,cAAA;EACA,UAAA;AtBiinCJ;;AsBl+mCU;EAhEN,cAAA;EACA,mBAAA;AtBsinCJ;;AsBv+mCU;EAhEN,cAAA;EACA,mBAAA;AtB2inCJ;;AsB5+mCU;EAhEN,cAAA;EACA,WAAA;AtBgjnCJ;;AsBz+mCY;EAxDV,wBAAA;AtBqinCF;;AsB7+mCY;EAxDV,yBAAA;AtByinCF;;AsBj/mCY;EAxDV,gBAAA;AtB6inCF;;AsBr/mCY;EAxDV,yBAAA;AtBijnCF;;AsBz/mCY;EAxDV,yBAAA;AtBqjnCF;;AsB7/mCY;EAxDV,gBAAA;AtByjnCF;;AsBjgnCY;EAxDV,yBAAA;AtB6jnCF;;AsBrgnCY;EAxDV,yBAAA;AtBiknCF;;AsBzgnCY;EAxDV,gBAAA;AtBqknCF;;AsB7gnCY;EAxDV,yBAAA;AtByknCF;;AsBjhnCY;EAxDV,yBAAA;AtB6knCF;;AsB1gnCQ;;EAEE,gBAAA;AtB6gnCV;;AsB1gnCQ;;EAEE,gBAAA;AtB6gnCV;;AsBphnCQ;;EAEE,sBAAA;AtBuhnCV;;AsBphnCQ;;EAEE,sBAAA;AtBuhnCV;;AsB9hnCQ;;EAEE,qBAAA;AtBiinCV;;AsB9hnCQ;;EAEE,qBAAA;AtBiinCV;;AsBxinCQ;;EAEE,mBAAA;AtB2inCV;;AsBxinCQ;;EAEE,mBAAA;AtB2inCV;;AsBljnCQ;;EAEE,qBAAA;AtBqjnCV;;AsBljnCQ;;EAEE,qBAAA;AtBqjnCV;;AsB5jnCQ;;EAEE,mBAAA;AtB+jnCV;;AsB5jnCQ;;EAEE,mBAAA;AtB+jnCV;;AoBznnCI;EEUE;IACE,SAAA;EtBmnnCN;EsBhnnCI;IApCJ,cAAA;IACA,WAAA;EtBupnCA;EsBzonCA;IACE,cAAA;IACA,WAAA;EtB2onCF;EsB7onCA;IACE,cAAA;IACA,UAAA;EtB+onCF;EsBjpnCA;IACE,cAAA;IACA,mBAAA;EtBmpnCF;EsBrpnCA;IACE,cAAA;IACA,UAAA;EtBupnCF;EsBzpnCA;IACE,cAAA;IACA,UAAA;EtB2pnCF;EsB7pnCA;IACE,cAAA;IACA,mBAAA;EtB+pnCF;EsBhonCI;IAhDJ,cAAA;IACA,WAAA;EtBmrnCA;EsB9nnCQ;IAhEN,cAAA;IACA,kBAAA;EtBisnCF;EsBlonCQ;IAhEN,cAAA;IACA,mBAAA;EtBqsnCF;EsBtonCQ;IAhEN,cAAA;IACA,UAAA;EtBysnCF;EsB1onCQ;IAhEN,cAAA;IACA,mBAAA;EtB6snCF;EsB9onCQ;IAhEN,cAAA;IACA,mBAAA;EtBitnCF;EsBlpnCQ;IAhEN,cAAA;IACA,UAAA;EtBqtnCF;EsBtpnCQ;IAhEN,cAAA;IACA,mBAAA;EtBytnCF;EsB1pnCQ;IAhEN,cAAA;IACA,mBAAA;EtB6tnCF;EsB9pnCQ;IAhEN,cAAA;IACA,UAAA;EtBiunCF;EsBlqnCQ;IAhEN,cAAA;IACA,mBAAA;EtBqunCF;EsBtqnCQ;IAhEN,cAAA;IACA,mBAAA;EtByunCF;EsB1qnCQ;IAhEN,cAAA;IACA,WAAA;EtB6unCF;EsBtqnCU;IAxDV,cAAA;EtBiunCA;EsBzqnCU;IAxDV,wBAAA;EtBounCA;EsB5qnCU;IAxDV,yBAAA;EtBuunCA;EsB/qnCU;IAxDV,gBAAA;EtB0unCA;EsBlrnCU;IAxDV,yBAAA;EtB6unCA;EsBrrnCU;IAxDV,yBAAA;EtBgvnCA;EsBxrnCU;IAxDV,gBAAA;EtBmvnCA;EsB3rnCU;IAxDV,yBAAA;EtBsvnCA;EsB9rnCU;IAxDV,yBAAA;EtByvnCA;EsBjsnCU;IAxDV,gBAAA;EtB4vnCA;EsBpsnCU;IAxDV,yBAAA;EtB+vnCA;EsBvsnCU;IAxDV,yBAAA;EtBkwnCA;EsB/rnCM;;IAEE,gBAAA;EtBisnCR;EsB9rnCM;;IAEE,gBAAA;EtBgsnCR;EsBvsnCM;;IAEE,sBAAA;EtBysnCR;EsBtsnCM;;IAEE,sBAAA;EtBwsnCR;EsB/snCM;;IAEE,qBAAA;EtBitnCR;EsB9snCM;;IAEE,qBAAA;EtBgtnCR;EsBvtnCM;;IAEE,mBAAA;EtBytnCR;EsBttnCM;;IAEE,mBAAA;EtBwtnCR;EsB/tnCM;;IAEE,qBAAA;EtBiunCR;EsB9tnCM;;IAEE,qBAAA;EtBgunCR;EsBvunCM;;IAEE,mBAAA;EtByunCR;EsBtunCM;;IAEE,mBAAA;EtBwunCR;AACF;AoBnynCI;EEUE;IACE,SAAA;EtB4xnCN;EsBzxnCI;IApCJ,cAAA;IACA,WAAA;EtBg0nCA;EsBlznCA;IACE,cAAA;IACA,WAAA;EtBoznCF;EsBtznCA;IACE,cAAA;IACA,UAAA;EtBwznCF;EsB1znCA;IACE,cAAA;IACA,mBAAA;EtB4znCF;EsB9znCA;IACE,cAAA;IACA,UAAA;EtBg0nCF;EsBl0nCA;IACE,cAAA;IACA,UAAA;EtBo0nCF;EsBt0nCA;IACE,cAAA;IACA,mBAAA;EtBw0nCF;EsBzynCI;IAhDJ,cAAA;IACA,WAAA;EtB41nCA;EsBvynCQ;IAhEN,cAAA;IACA,kBAAA;EtB02nCF;EsB3ynCQ;IAhEN,cAAA;IACA,mBAAA;EtB82nCF;EsB/ynCQ;IAhEN,cAAA;IACA,UAAA;EtBk3nCF;EsBnznCQ;IAhEN,cAAA;IACA,mBAAA;EtBs3nCF;EsBvznCQ;IAhEN,cAAA;IACA,mBAAA;EtB03nCF;EsB3znCQ;IAhEN,cAAA;IACA,UAAA;EtB83nCF;EsB/znCQ;IAhEN,cAAA;IACA,mBAAA;EtBk4nCF;EsBn0nCQ;IAhEN,cAAA;IACA,mBAAA;EtBs4nCF;EsBv0nCQ;IAhEN,cAAA;IACA,UAAA;EtB04nCF;EsB30nCQ;IAhEN,cAAA;IACA,mBAAA;EtB84nCF;EsB/0nCQ;IAhEN,cAAA;IACA,mBAAA;EtBk5nCF;EsBn1nCQ;IAhEN,cAAA;IACA,WAAA;EtBs5nCF;EsB/0nCU;IAxDV,cAAA;EtB04nCA;EsBl1nCU;IAxDV,wBAAA;EtB64nCA;EsBr1nCU;IAxDV,yBAAA;EtBg5nCA;EsBx1nCU;IAxDV,gBAAA;EtBm5nCA;EsB31nCU;IAxDV,yBAAA;EtBs5nCA;EsB91nCU;IAxDV,yBAAA;EtBy5nCA;EsBj2nCU;IAxDV,gBAAA;EtB45nCA;EsBp2nCU;IAxDV,yBAAA;EtB+5nCA;EsBv2nCU;IAxDV,yBAAA;EtBk6nCA;EsB12nCU;IAxDV,gBAAA;EtBq6nCA;EsB72nCU;IAxDV,yBAAA;EtBw6nCA;EsBh3nCU;IAxDV,yBAAA;EtB26nCA;EsBx2nCM;;IAEE,gBAAA;EtB02nCR;EsBv2nCM;;IAEE,gBAAA;EtBy2nCR;EsBh3nCM;;IAEE,sBAAA;EtBk3nCR;EsB/2nCM;;IAEE,sBAAA;EtBi3nCR;EsBx3nCM;;IAEE,qBAAA;EtB03nCR;EsBv3nCM;;IAEE,qBAAA;EtBy3nCR;EsBh4nCM;;IAEE,mBAAA;EtBk4nCR;EsB/3nCM;;IAEE,mBAAA;EtBi4nCR;EsBx4nCM;;IAEE,qBAAA;EtB04nCR;EsBv4nCM;;IAEE,qBAAA;EtBy4nCR;EsBh5nCM;;IAEE,mBAAA;EtBk5nCR;EsB/4nCM;;IAEE,mBAAA;EtBi5nCR;AACF;AoB58nCI;EEUE;IACE,SAAA;EtBq8nCN;EsBl8nCI;IApCJ,cAAA;IACA,WAAA;EtBy+nCA;EsB39nCA;IACE,cAAA;IACA,WAAA;EtB69nCF;EsB/9nCA;IACE,cAAA;IACA,UAAA;EtBi+nCF;EsBn+nCA;IACE,cAAA;IACA,mBAAA;EtBq+nCF;EsBv+nCA;IACE,cAAA;IACA,UAAA;EtBy+nCF;EsB3+nCA;IACE,cAAA;IACA,UAAA;EtB6+nCF;EsB/+nCA;IACE,cAAA;IACA,mBAAA;EtBi/nCF;EsBl9nCI;IAhDJ,cAAA;IACA,WAAA;EtBqgoCA;EsBh9nCQ;IAhEN,cAAA;IACA,kBAAA;EtBmhoCF;EsBp9nCQ;IAhEN,cAAA;IACA,mBAAA;EtBuhoCF;EsBx9nCQ;IAhEN,cAAA;IACA,UAAA;EtB2hoCF;EsB59nCQ;IAhEN,cAAA;IACA,mBAAA;EtB+hoCF;EsBh+nCQ;IAhEN,cAAA;IACA,mBAAA;EtBmioCF;EsBp+nCQ;IAhEN,cAAA;IACA,UAAA;EtBuioCF;EsBx+nCQ;IAhEN,cAAA;IACA,mBAAA;EtB2ioCF;EsB5+nCQ;IAhEN,cAAA;IACA,mBAAA;EtB+ioCF;EsBh/nCQ;IAhEN,cAAA;IACA,UAAA;EtBmjoCF;EsBp/nCQ;IAhEN,cAAA;IACA,mBAAA;EtBujoCF;EsBx/nCQ;IAhEN,cAAA;IACA,mBAAA;EtB2joCF;EsB5/nCQ;IAhEN,cAAA;IACA,WAAA;EtB+joCF;EsBx/nCU;IAxDV,cAAA;EtBmjoCA;EsB3/nCU;IAxDV,wBAAA;EtBsjoCA;EsB9/nCU;IAxDV,yBAAA;EtByjoCA;EsBjgoCU;IAxDV,gBAAA;EtB4joCA;EsBpgoCU;IAxDV,yBAAA;EtB+joCA;EsBvgoCU;IAxDV,yBAAA;EtBkkoCA;EsB1goCU;IAxDV,gBAAA;EtBqkoCA;EsB7goCU;IAxDV,yBAAA;EtBwkoCA;EsBhhoCU;IAxDV,yBAAA;EtB2koCA;EsBnhoCU;IAxDV,gBAAA;EtB8koCA;EsBthoCU;IAxDV,yBAAA;EtBiloCA;EsBzhoCU;IAxDV,yBAAA;EtBoloCA;EsBjhoCM;;IAEE,gBAAA;EtBmhoCR;EsBhhoCM;;IAEE,gBAAA;EtBkhoCR;EsBzhoCM;;IAEE,sBAAA;EtB2hoCR;EsBxhoCM;;IAEE,sBAAA;EtB0hoCR;EsBjioCM;;IAEE,qBAAA;EtBmioCR;EsBhioCM;;IAEE,qBAAA;EtBkioCR;EsBzioCM;;IAEE,mBAAA;EtB2ioCR;EsBxioCM;;IAEE,mBAAA;EtB0ioCR;EsBjjoCM;;IAEE,qBAAA;EtBmjoCR;EsBhjoCM;;IAEE,qBAAA;EtBkjoCR;EsBzjoCM;;IAEE,mBAAA;EtB2joCR;EsBxjoCM;;IAEE,mBAAA;EtB0joCR;AACF;AoBrnoCI;EEUE;IACE,SAAA;EtB8moCN;EsB3moCI;IApCJ,cAAA;IACA,WAAA;EtBkpoCA;EsBpooCA;IACE,cAAA;IACA,WAAA;EtBsooCF;EsBxooCA;IACE,cAAA;IACA,UAAA;EtB0ooCF;EsB5ooCA;IACE,cAAA;IACA,mBAAA;EtB8ooCF;EsBhpoCA;IACE,cAAA;IACA,UAAA;EtBkpoCF;EsBppoCA;IACE,cAAA;IACA,UAAA;EtBspoCF;EsBxpoCA;IACE,cAAA;IACA,mBAAA;EtB0poCF;EsB3noCI;IAhDJ,cAAA;IACA,WAAA;EtB8qoCA;EsBznoCQ;IAhEN,cAAA;IACA,kBAAA;EtB4roCF;EsB7noCQ;IAhEN,cAAA;IACA,mBAAA;EtBgsoCF;EsBjooCQ;IAhEN,cAAA;IACA,UAAA;EtBosoCF;EsBrooCQ;IAhEN,cAAA;IACA,mBAAA;EtBwsoCF;EsBzooCQ;IAhEN,cAAA;IACA,mBAAA;EtB4soCF;EsB7ooCQ;IAhEN,cAAA;IACA,UAAA;EtBgtoCF;EsBjpoCQ;IAhEN,cAAA;IACA,mBAAA;EtBotoCF;EsBrpoCQ;IAhEN,cAAA;IACA,mBAAA;EtBwtoCF;EsBzpoCQ;IAhEN,cAAA;IACA,UAAA;EtB4toCF;EsB7poCQ;IAhEN,cAAA;IACA,mBAAA;EtBguoCF;EsBjqoCQ;IAhEN,cAAA;IACA,mBAAA;EtBouoCF;EsBrqoCQ;IAhEN,cAAA;IACA,WAAA;EtBwuoCF;EsBjqoCU;IAxDV,cAAA;EtB4toCA;EsBpqoCU;IAxDV,wBAAA;EtB+toCA;EsBvqoCU;IAxDV,yBAAA;EtBkuoCA;EsB1qoCU;IAxDV,gBAAA;EtBquoCA;EsB7qoCU;IAxDV,yBAAA;EtBwuoCA;EsBhroCU;IAxDV,yBAAA;EtB2uoCA;EsBnroCU;IAxDV,gBAAA;EtB8uoCA;EsBtroCU;IAxDV,yBAAA;EtBivoCA;EsBzroCU;IAxDV,yBAAA;EtBovoCA;EsB5roCU;IAxDV,gBAAA;EtBuvoCA;EsB/roCU;IAxDV,yBAAA;EtB0voCA;EsBlsoCU;IAxDV,yBAAA;EtB6voCA;EsB1roCM;;IAEE,gBAAA;EtB4roCR;EsBzroCM;;IAEE,gBAAA;EtB2roCR;EsBlsoCM;;IAEE,sBAAA;EtBosoCR;EsBjsoCM;;IAEE,sBAAA;EtBmsoCR;EsB1soCM;;IAEE,qBAAA;EtB4soCR;EsBzsoCM;;IAEE,qBAAA;EtB2soCR;EsBltoCM;;IAEE,mBAAA;EtBotoCR;EsBjtoCM;;IAEE,mBAAA;EtBmtoCR;EsB1toCM;;IAEE,qBAAA;EtB4toCR;EsBztoCM;;IAEE,qBAAA;EtB2toCR;EsBluoCM;;IAEE,mBAAA;EtBouoCR;EsBjuoCM;;IAEE,mBAAA;EtBmuoCR;AACF;AoB9xoCI;EEUE;IACE,SAAA;EtBuxoCN;EsBpxoCI;IApCJ,cAAA;IACA,WAAA;EtB2zoCA;EsB7yoCA;IACE,cAAA;IACA,WAAA;EtB+yoCF;EsBjzoCA;IACE,cAAA;IACA,UAAA;EtBmzoCF;EsBrzoCA;IACE,cAAA;IACA,mBAAA;EtBuzoCF;EsBzzoCA;IACE,cAAA;IACA,UAAA;EtB2zoCF;EsB7zoCA;IACE,cAAA;IACA,UAAA;EtB+zoCF;EsBj0oCA;IACE,cAAA;IACA,mBAAA;EtBm0oCF;EsBpyoCI;IAhDJ,cAAA;IACA,WAAA;EtBu1oCA;EsBlyoCQ;IAhEN,cAAA;IACA,kBAAA;EtBq2oCF;EsBtyoCQ;IAhEN,cAAA;IACA,mBAAA;EtBy2oCF;EsB1yoCQ;IAhEN,cAAA;IACA,UAAA;EtB62oCF;EsB9yoCQ;IAhEN,cAAA;IACA,mBAAA;EtBi3oCF;EsBlzoCQ;IAhEN,cAAA;IACA,mBAAA;EtBq3oCF;EsBtzoCQ;IAhEN,cAAA;IACA,UAAA;EtBy3oCF;EsB1zoCQ;IAhEN,cAAA;IACA,mBAAA;EtB63oCF;EsB9zoCQ;IAhEN,cAAA;IACA,mBAAA;EtBi4oCF;EsBl0oCQ;IAhEN,cAAA;IACA,UAAA;EtBq4oCF;EsBt0oCQ;IAhEN,cAAA;IACA,mBAAA;EtBy4oCF;EsB10oCQ;IAhEN,cAAA;IACA,mBAAA;EtB64oCF;EsB90oCQ;IAhEN,cAAA;IACA,WAAA;EtBi5oCF;EsB10oCU;IAxDV,cAAA;EtBq4oCA;EsB70oCU;IAxDV,wBAAA;EtBw4oCA;EsBh1oCU;IAxDV,yBAAA;EtB24oCA;EsBn1oCU;IAxDV,gBAAA;EtB84oCA;EsBt1oCU;IAxDV,yBAAA;EtBi5oCA;EsBz1oCU;IAxDV,yBAAA;EtBo5oCA;EsB51oCU;IAxDV,gBAAA;EtBu5oCA;EsB/1oCU;IAxDV,yBAAA;EtB05oCA;EsBl2oCU;IAxDV,yBAAA;EtB65oCA;EsBr2oCU;IAxDV,gBAAA;EtBg6oCA;EsBx2oCU;IAxDV,yBAAA;EtBm6oCA;EsB32oCU;IAxDV,yBAAA;EtBs6oCA;EsBn2oCM;;IAEE,gBAAA;EtBq2oCR;EsBl2oCM;;IAEE,gBAAA;EtBo2oCR;EsB32oCM;;IAEE,sBAAA;EtB62oCR;EsB12oCM;;IAEE,sBAAA;EtB42oCR;EsBn3oCM;;IAEE,qBAAA;EtBq3oCR;EsBl3oCM;;IAEE,qBAAA;EtBo3oCR;EsB33oCM;;IAEE,mBAAA;EtB63oCR;EsB13oCM;;IAEE,mBAAA;EtB43oCR;EsBn4oCM;;IAEE,qBAAA;EtBq4oCR;EsBl4oCM;;IAEE,qBAAA;EtBo4oCR;EsB34oCM;;IAEE,mBAAA;EtB64oCR;EsB14oCM;;IAEE,mBAAA;EtB44oCR;AACF;AuBlgpCA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXwaO;EWvaP,mBXguB0B;EW/tB1B,0CAAA;AvBigpCF;AuB1/oCE;EACE,wBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,wBXqiBW;EWpiBX,2GAAA;AvB2/oCJ;AuBx/oCE;EACE,uBAAA;AvB0/oCJ;AuBv/oCE;EACE,sBAAA;AvBy/oCJ;;AuBr/oCA;EACE,uCAAA;AvBw/oCF;;AuBj/oCA;EACE,iBAAA;AvBo/oCF;;AuB1+oCE;EACE,sBAAA;AvB6+oCJ;;AuB99oCE;EACE,mBAAA;AvBi+oCJ;AuB99oCI;EACE,mBAAA;AvBg+oCN;;AuBz9oCE;EACE,sBAAA;AvB49oCJ;AuBz9oCE;EACE,mBAAA;AvB29oCJ;;AuBj9oCE;EACE,oDAAA;EACA,8CAAA;AvBo9oCJ;;AuB98oCE;EACE,oDAAA;EACA,8CAAA;AvBi9oCJ;;AuBz8oCA;EACE,oDAAA;EACA,8CAAA;AvB48oCF;;AuBp8oCE;EACE,mDAAA;EACA,6CAAA;AvBu8oCJ;;AwBnlpCE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB+kpCJ;;AwBjmpCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB6lpCJ;;AwB/mpCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB2mpCJ;;AwB7npCE;EAOE,sBAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,8BAAA;EACA,6CAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBynpCJ;;AwB3opCE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBuopCJ;;AwBzppCE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBqppCJ;;AwBvqpCE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,iDAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBmqpCJ;;AwBrrpCE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBirpCJ;;AuBhipCI;EACE,gBAAA;EACA,iCAAA;AvBmipCN;;AoB9npCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvByipCJ;AACF;AoBropCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvB+ipCJ;AACF;AoB3opCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBqjpCJ;AACF;AoBjppCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvB2jpCJ;AACF;AoBvppCI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBikpCJ;AACF;AyBrupCA;EACE,qBb63ByB;AZ02nC3B;;AyB9tpCA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBbuoBiB;AZwloCnB;;AyB3tpCA;EACE,+BAAA;EACA,kCAAA;EhBoQI,sBALI;ATg+oCV;;AyB3tpCA;EACE,gCAAA;EACA,mCAAA;EhB8PI,uBALI;ATs+oCV;;A0B5vpCA;EACE,mBdq3BqB;EH3lBjB,cALI;EiBjRR,cd+ES;AZ8qpCX;;A2BlwpCA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;ElBwRI,oBALI;EkBhRR,gBf6oBmB;Ee5oBnB,gBfipBiB;EehpBjB,cf6ES;Ee5ET,gBAAA;EACA,sBfoEM;EenEN,4BAAA;EACA,yBAAA;EdGE,sBAAA;EeHE,wEDMJ;A3BgwpCF;A4BlwpCM;EDhBN;ICiBQ,gBAAA;E5BqwpCN;AACF;A2BnwpCE;EACE,gBAAA;A3BqwpCJ;A2BnwpCI;EACE,eAAA;A3BqwpCN;A2BhwpCE;EACE,cfuDO;EetDP,sBf+CI;Ee9CJ,sCfm4BuB;Eel4BvB,UAAA;EAKE,gBfg4BmB;AZ83nCzB;A2B1vpCE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;A3B8upCJ;A2BzupCE;EACE,cAAA;EACA,UAAA;A3B2upCJ;A2BvupCE;EACE,cfaO;EeXP,UAAA;A3BwupCJ;A2BhupCE;EAEE,yBfHO;EeMP,UAAA;A3B+tpCJ;A2B3tpCE;EACE,wBAAA;EACA,yBAAA;EACA,0Bf0sBkB;EezsBlB,cfTO;EiBrFT,yBjBgFS;EegBP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfkeW;EejeX,gBAAA;ECzFE,qID0FF;A3B6tpCJ;A4BnzpCM;ED0EJ;ICzEM,gBAAA;E5BszpCN;AACF;A2B/tpCE;EACE,4Cfo+BwB;AZ6vnC5B;;A2BxtpCA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBfgiBiB;Ee/hBjB,cfpCS;EeqCT,6BAAA;EACA,yBAAA;EACA,mBAAA;A3B2tpCF;A2BztpCE;EACE,UAAA;A3B2tpCJ;A2BxtpCE;EAEE,gBAAA;EACA,eAAA;A3BytpCJ;;A2B9spCA;EACE,sCfuyBgB;EetyBhB,uBAAA;ElByII,uBALI;EIvQN,qBAAA;Abs1pCJ;A2B/spCE;EACE,uBAAA;EACA,wBAAA;EACA,yBf6pBqB;AZojoCzB;;A2B7spCA;EACE,oCf8xBgB;Ee7xBhB,oBAAA;ElB4HI,sBALI;EIvQN,qBAAA;Abk2pCJ;A2B9spCE;EACE,oBAAA;EACA,qBAAA;EACA,uBfopBqB;AZ4joCzB;;A2BxspCE;EACE,uCfqwBW;AZs8nCf;A2BxspCE;EACE,sCfqwBc;AZq8nClB;A2BvspCE;EACE,oCfqwBc;AZo8nClB;;A2BpspCA;EACE,WfqwBiB;EepwBjB,mCfsvBa;EervBb,gBfumBoB;AZgmoCtB;A2BrspCE;EACE,eAAA;A3BuspCJ;A2BpspCE;EACE,oBAAA;EdvLA,sBAAA;Ab83pCJ;A2BnspCE;EACE,oBAAA;Ed5LA,sBAAA;Abk4pCJ;A2BlspCE;EAAoB,kCfyuBJ;AZ49nClB;A2BpspCE;EAAoB,gCf4uBJ;AZ29nClB;;A8Bt5pCA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,wCAAA;ErBqRI,oBALI;EqB7QR,gBlB0oBmB;EkBzoBnB,gBlB8oBiB;EkB7oBjB,clB0ES;EkBzET,gBAAA;EACA,sBlBiEM;EkBhEN,mFAAA;EACA,4BAAA;EACA,yClBigCwB;EkBhgCxB,0BlBigCoB;EkBhgCpB,yBAAA;EjBHE,sBAAA;EeHE,wEESJ;A9Bs5pCF;A4B35pCM;EEfN;IFgBQ,gBAAA;E5B85pCN;AACF;A8Bz5pCE;EACE,sClB24BuB;EkB14BvB,UAAA;EAKE,kDlBygCyB;AZ84nC/B;A8Bn5pCE;EAEE,sBlBmwBkB;EkBlwBlB,sBAAA;A9Bo5pCJ;A8Bj5pCE;EACE,clB2CO;EkB1CP,yBlBsCO;AZ62pCX;A8B94pCE;EACE,kBAAA;EACA,0BAAA;A9Bg5pCJ;;A8B54pCA;EACE,oBlB+vBuB;EkB9vBvB,uBlB8vBuB;EkB7vBvB,oBlB8vBuB;EH3hBnB,uBALI;EIvQN,yCAAA;Ab07pCJ;;A8B54pCA;EACE,mBlB2vBuB;EkB1vBvB,sBlB0vBuB;EkBzvBvB,kBlB0vBuB;EH/hBnB,sBALI;EIvQN,yCAAA;Abk8pCJ;;A8B14pCI;EACE,iEAAA;A9B64pCN;;A+Br9pCA;EACE,cAAA;EACA,sBnBq8BsB;EmBp8BtB,mBnBq8ByB;EmBp8BzB,uBnBq8ByB;AZmhoC3B;A+Bt9pCE;EACE,WAAA;EACA,mBAAA;A/Bw9pCJ;;A+Bp9pCA;EACE,oBnB27ByB;EmB17BzB,eAAA;EACA,iBAAA;A/Bu9pCF;A+Br9pCE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A/Bu9pCJ;;A+Bn9pCA;EACE,qCAAA;EAEA,cAAA;EACA,UnB06BuB;EmBz6BvB,WnBy6BuB;EmBx6BvB,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCnB66BwB;EmB56BxB,yBAAA;EH3BI,mJG4BJ;A/Bq9pCF;A4B7+pCM;EGQN;IHPQ,gBAAA;E5Bg/pCN;AACF;A+Bx9pCE;ElB3BE,qBAAA;Abs/pCJ;A+Bv9pCE;EAEE,kBnBq6B6B;AZmjoCjC;A+Br9pCE;EACE,uBnB45B6B;AZ2joCjC;A+Bp9pCE;EACE,sCnB22BuB;EmB12BvB,UAAA;EACA,kDnByvByB;AZ6toC7B;A+Bn9pCE;EACE,yBnB8CG;EmB7CH,qBnB6CG;AZw6pCP;A+Bn9pCI;EAII,kEAAA;A/Bk9pCR;A+B98pCI;EAII,kEAAA;A/B68pCR;A+Bx8pCE;EACE,yBnByBG;EmBxBH,qBnBwBG;EmBnBD,kEAAA;A/Bs8pCN;A+Bl8pCE;EACE,oBAAA;EACA,YAAA;EACA,YnBo4BgC;AZgkoCpC;A+B77pCI;EACE,eAAA;EACA,YnB23B8B;AZokoCpC;;A+Bj7pCA;EACE,mBnBs3B0B;AZ8joC5B;A+Bl7pCE;EACE,6DAAA;EAEA,UnBg3BgB;EmB/2BhB,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A/Bm7pCJ;A4BriqCM;EG0GJ;IHzGM,gBAAA;E5BwiqCN;AACF;A+Bt7pCI;EACE,6DAAA;A/Bw7pCN;A+Br7pCI;EACE,iCnB+2B4B;EmB12B1B,6DAAA;A/Bm7pCR;A+B96pCE;EACE,oBnB01BwB;EmBz1BxB,eAAA;A/Bg7pCJ;A+B96pCI;EACE,oBAAA;EACA,cAAA;A/Bg7pCN;;A+B36pCA;EACE,qBAAA;EACA,kBnBw0B6B;AZsmoC/B;;A+B36pCA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/B86pCF;A+B16pCI;EACE,oBAAA;EACA,YAAA;EACA,anB6qBiB;AZ+voCvB;;A+Br6pCI;EACE,6DAAA;A/Bw6pCN;;AgC3lqCA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AhC8lqCF;AgC5lqCE;EACE,UAAA;AhC8lqCJ;AgC1lqCI;EAA0B,mCpBqjCM;AZwioCpC;AgC5lqCI;EAA0B,mCpBojCM;AZ2ioCpC;AgC5lqCE;EACE,SAAA;AhC8lqCJ;AgC3lqCE;EACE,WpBsiCqB;EoBriCrB,YpBqiCqB;EoBpiCrB,oBAAA;EACA,gBAAA;EH1BF,yBjB4GK;EoBhFH,SpBoiCsB;ECjjCtB,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;AhC4lqCJ;A4B3mqCM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;E5B8mqCN;AACF;AgC/lqCI;EHjCF,wCjBqkC2B;AZ8joC7B;AgC7lqCE;EACE,WpB+gCqB;EoB9gCrB,cpB+gCsB;EoB9gCtB,kBAAA;EACA,epB8gCsB;EoB7gCtB,yBpBsCO;EoBrCP,yBAAA;EnB7BA,mBAAA;Ab6nqCJ;AgC3lqCE;EACE,WpB2gCqB;EoB1gCrB,YpB0gCqB;EoBzgCrB,gBAAA;EHpDF,yBjB4GK;EoBtDH,SpB0gCsB;ECjjCtB,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;AhC4lqCJ;A4BroqCM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;E5BwoqCN;AACF;AgC/lqCI;EH3DF,wCjBqkC2B;AZwloC7B;AgC7lqCE;EACE,WpBq/BqB;EoBp/BrB,cpBq/BsB;EoBp/BtB,kBAAA;EACA,epBo/BsB;EoBn/BtB,yBpBYO;EoBXP,yBAAA;EnBvDA,mBAAA;AbupqCJ;AgC3lqCE;EACE,oBAAA;AhC6lqCJ;AgC3lqCI;EACE,yBpBIK;AZylqCX;AgC1lqCI;EACE,yBAAA;AhC4lqCN;;AiCnrqCA;EACE,kBAAA;AjCsrqCF;AiCprqCE;;;EAGE,0BrBglCmB;EqB/kCnB,8BrB+kCmB;EqB9kCnB,iBrB+kCwB;AZumoC5B;AiCnrqCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELVE,gEKWF;AjCqrqCJ;A4B5rqCM;EKTJ;ILUM,gBAAA;E5B+rqCN;AACF;AiCvrqCE;;EAEE,qBAAA;AjCyrqCJ;AiCvrqCI;;EACE,kBAAA;AjC0rqCN;AiCvrqCI;;;EAEE,qBrBkjC0B;EqBjjC1B,wBrBkjC0B;AZwooChC;AiCvrqCI;;EACE,qBrB6iC0B;EqB5iC1B,wBrB6iC0B;AZ6ooChC;AiCtrqCE;EACE,qBrBuiC4B;EqBtiC5B,wBrBuiC4B;EqBtiC5B,qBrBsvBkB;AZk8oCtB;AiCjrqCI;;;;EACE,8DrBgiC0B;AZspoChC;AiCjrqCI;EACE,8DrB0hC0B;AZypoChC;AiC9qqCI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,aCw+BkC;EDv+BlC,WAAA;EACA,sBrBIE;EC/DJ,sBAAA;Ab6uqCJ;AiC9qqCE;EACE,yBrBCO;AZ+qqCX;AiC5qqCI;EACE,mBAAA;AjC8qqCN;AiC1qqCE;;EAEE,cChFO;AlC4vqCX;;AmCtwqCA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AnCywqCF;AmCvwqCE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AnCywqCJ;AmCrwqCE;;;EAGE,UAAA;AnCuwqCJ;AmCjwqCE;EACE,kBAAA;EACA,UAAA;AnCmwqCJ;AmCjwqCI;EACE,UAAA;AnCmwqCN;;AmCxvqCA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;E1B8OI,oBALI;E0BvOR,gBvBomBmB;EuBnmBnB,gBvBwmBiB;EuBvmBjB,cvBoCS;EuBnCT,kBAAA;EACA,mBAAA;EACA,yBvB4BS;EuB3BT,yBAAA;EtBtCE,sBAAA;AbkyqCJ;;AmClvqCA;;;;EAIE,oBAAA;E1BwNI,sBALI;EIvQN,qBAAA;Ab2yqCJ;;AmClvqCA;;;;EAIE,uBAAA;E1B+MI,uBALI;EIvQN,qBAAA;AbozqCJ;;AmClvqCA;;EAEE,qBAAA;AnCqvqCF;;AmCxuqCI;;;;EtBjEA,0BAAA;EACA,6BAAA;AbgzqCJ;AmCvuqCI;;;;EtB1EA,0BAAA;EACA,6BAAA;AbuzqCJ;AmCjuqCE;EACE,2BAAA;EtB1EA,yBAAA;EACA,4BAAA;Ab8yqCJ;AmCjuqCE;;EtB9EE,yBAAA;EACA,4BAAA;AbmzqCJ;;AoC30qCE;EACE,aAAA;EACA,WAAA;EACA,mBxB61BmB;EH3lBjB,cALI;E2B1PN,cxBklCqB;AZ2voCzB;;AoC10qCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E3BqPE,uBALI;E2B9ON,gBxBgnBe;EwB/mBf,WAxBc;EAyBd,yCAxBiB;EvBHjB,sBAAA;Aby2qCJ;;AoCz0qCI;;;;EAEE,cAAA;ApC80qCN;;AoC73qCI;EAqDE,qBxBujCmB;EwBpjCjB,oCxBm3Ba;EwBl3Bb,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ApC00qCR;AoCv0qCM;EACE,qBxB4iCiB;EwBviCf,kDApDW;ApCy3qCrB;;AoC14qCI;EA+EI,oCxB41Ba;EwB31Bb,gFAAA;ApC+zqCR;;AoC/4qCI;EAuFE,qBxBqhCmB;AZuyoCzB;AoCzzqCQ;EAEE,kEAAA;EACA,sCxBu7B8B;EwBt7B9B,8DAAA;EACA,yEAAA;ApC0zqCV;AoCtzqCM;EACE,qBxBwgCiB;EwBngCf,kDAxFW;ApC44qCrB;;AoC75qCI;EAkHI,yCAAA;ApC+yqCR;;AoCj6qCI;EAyHE,qBxBm/BmB;AZyzoCzB;AoC1yqCM;EACE,yBxBg/BiB;AZ4zoCzB;AoCzyqCM;EACE,kDA/Ga;ApC05qCrB;AoCxyqCM;EACE,cxBw+BiB;AZk0oCzB;;AoCryqCI;EACE,kBAAA;ApCwyqCN;;AoCl7qCI;;;;;EAoJM,UAAA;ApCsyqCV;;AoCt6qCE;EACE,aAAA;EACA,WAAA;EACA,mBxB61BmB;EH3lBjB,cALI;E2B1PN,cxBklCqB;AZs1oCzB;;AoCr6qCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E3BqPE,uBALI;E2B9ON,gBxBgnBe;EwB/mBf,WAxBc;EAyBd,0CAxBiB;EvBHjB,sBAAA;Abo8qCJ;;AoCp6qCI;;;;EAEE,cAAA;ApCy6qCN;;AoCx9qCI;EAqDE,qBxBujCmB;EwBpjCjB,oCxBm3Ba;EwBl3Bb,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ApCq6qCR;AoCl6qCM;EACE,qBxB4iCiB;EwBviCf,mDApDW;ApCo9qCrB;;AoCr+qCI;EA+EI,oCxB41Ba;EwB31Bb,gFAAA;ApC05qCR;;AoC1+qCI;EAuFE,qBxBqhCmB;AZk4oCzB;AoCp5qCQ;EAEE,kEAAA;EACA,sCxBu7B8B;EwBt7B9B,8DAAA;EACA,yEAAA;ApCq5qCV;AoCj5qCM;EACE,qBxBwgCiB;EwBngCf,mDAxFW;ApCu+qCrB;;AoCx/qCI;EAkHI,yCAAA;ApC04qCR;;AoC5/qCI;EAyHE,qBxBm/BmB;AZo5oCzB;AoCr4qCM;EACE,yBxBg/BiB;AZu5oCzB;AoCp4qCM;EACE,mDA/Ga;ApCq/qCrB;AoCn4qCM;EACE,cxBw+BiB;AZ65oCzB;;AoCh4qCI;EACE,kBAAA;ApCm4qCN;;AoC7grCI;;;;;EAsJM,UAAA;ApC+3qCV;;AqCvhrCA;EAEE,2BAAA;EACA,2BAAA;EACA,sBAAA;E5BuRI,6BALI;E4BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EgBfF,kCQkCqB;ETtBjB,qISwBJ;ArCohrCF;A4BxirCM;EShBN;ITiBQ,gBAAA;E5B2irCN;AACF;AqCvhrCE;EACE,gCAAA;EACA,qBAAA;EACA,wCAAA;EACA,8CAAA;ArCyhrCJ;AqCthrCE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;ArCuhrCJ;AqCphrCE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;ArCkhrCN;AqC9grCE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;ArC4grCN;AqCxgrCE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;ArCogrCJ;AqCjgrCI;EAKI,0CAAA;ArC+/qCR;AqC1/qCE;EAKI,0CAAA;ArCw/qCN;AqCp/qCE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;ArCm/qCJ;;AqCv+qCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC0lrCF;;AqCx/qCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC2mrCF;;AqCzgrCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC4nrCF;;AqC1hrCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,gDAAA;EACA,wCAAA;EACA,2BAAA;EACA,uCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC6orCF;;AqC3irCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,wCAAA;EACA,2BAAA;EACA,yCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC8prCF;;AqC5jrCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC+qrCF;;AqC7krCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCgsrCF;;AqC9lrCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,wDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCitrCF;;AqC/mrCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCkurCF;;AqCtmrCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC0trCF;;AqCvnrCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC2urCF;;AqCxorCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC4vrCF;;AqCzprCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC6wrCF;;AqC1qrCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC8xrCF;;AqC3rrCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC+yrCF;;AqC5srCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCg0rCF;;AqC7trCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCi1rCF;;AqC9urCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCk2rCF;;AqCnvrCA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBzBgVgB;AZq6qClB;AqChvrCE;EAEE,0BzB4UoB;AZq6qCxB;AqC9urCE;EACE,0BAAA;ArCgvrCJ;AqC7urCE;EACE,gCAAA;ArC+urCJ;;AqCpurCA;ECjJE,0BAAA;EACA,wBAAA;E7B8NI,+BALI;E6BvNR,8BAAA;AtCy3rCF;;AqCvurCA;ECrJE,2BAAA;EACA,0BAAA;E7B8NI,gCALI;E6BvNR,8BAAA;AtCg4rCF;;AuCn8rCA;EXgBM,gCWfJ;AvCs8rCF;A4Bn7rCM;EWpBN;IXqBQ,gBAAA;E5Bs7rCN;AACF;AuCz8rCE;EACE,UAAA;AvC28rCJ;;AuCr8rCE;EACE,aAAA;AvCw8rCJ;;AuCp8rCA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;AvCu8rCF;A4Br8rCM;EWLN;IXMQ,gBAAA;E5Bw8rCN;AACF;AuC18rCE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;AvC48rCJ;A4B/8rCM;EWAJ;IXCM,gBAAA;E5Bk9rCN;AACF;;AwCv+rCA;;;;;;EAME,kBAAA;AxC0+rCF;;AwCv+rCA;EACE,mBAAA;AxC0+rCF;;AwCn+rCA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E/BuQI,kCALI;E+BhQR,4BAAA;EACA,sBAAA;EACA,+CAAA;EACA,oCAAA;EACA,6BAAA;EACA,oDAAA;EACA,iCAAA;EACA,sCAAA;EACA,iEAAA;EACA,iCAAA;EACA,qDAAA;EACA,oCAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;Ab6gsCJ;AwCh+rCE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AxCk+rCJ;;AwC18rCI;EACE,oBAAA;AxC68rCN;AwC38rCM;EACE,WAAA;EACA,OAAA;AxC68rCR;;AwCz8rCI;EACE,kBAAA;AxC48rCN;AwC18rCM;EACE,QAAA;EACA,UAAA;AxC48rCR;;AoBt/rCI;EoB4BA;IACE,oBAAA;ExC89rCJ;EwC59rCI;IACE,WAAA;IACA,OAAA;ExC89rCN;EwC19rCE;IACE,kBAAA;ExC49rCJ;EwC19rCI;IACE,QAAA;IACA,UAAA;ExC49rCN;AACF;AoBvgsCI;EoB4BA;IACE,oBAAA;ExC8+rCJ;EwC5+rCI;IACE,WAAA;IACA,OAAA;ExC8+rCN;EwC1+rCE;IACE,kBAAA;ExC4+rCJ;EwC1+rCI;IACE,QAAA;IACA,UAAA;ExC4+rCN;AACF;AoBvhsCI;EoB4BA;IACE,oBAAA;ExC8/rCJ;EwC5/rCI;IACE,WAAA;IACA,OAAA;ExC8/rCN;EwC1/rCE;IACE,kBAAA;ExC4/rCJ;EwC1/rCI;IACE,QAAA;IACA,UAAA;ExC4/rCN;AACF;AoBvisCI;EoB4BA;IACE,oBAAA;ExC8gsCJ;EwC5gsCI;IACE,WAAA;IACA,OAAA;ExC8gsCN;EwC1gsCE;IACE,kBAAA;ExC4gsCJ;EwC1gsCI;IACE,QAAA;IACA,UAAA;ExC4gsCN;AACF;AoBvjsCI;EoB4BA;IACE,oBAAA;ExC8hsCJ;EwC5hsCI;IACE,WAAA;IACA,OAAA;ExC8hsCN;EwC1hsCE;IACE,kBAAA;ExC4hsCJ;EwC1hsCI;IACE,QAAA;IACA,UAAA;ExC4hsCN;AACF;AwCnhsCE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AxCqhsCJ;AwC5gsCE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AxC8gsCJ;AwCzgsCI;EACE,iBAAA;AxC2gsCN;;AwCrgsCE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AxCwgsCJ;AwCngsCI;EACE,iBAAA;AxCqgsCN;;AwC9/rCA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AxCigsCF;;AwC3/rCA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5BoemB;E4BnenB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;AboqsCJ;AwC3/rCE;EAEE,0CAAA;EACA,qBAAA;EX3LF,kDW4LuB;AxC4/rCzB;AwCz/rCE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;AxC0/rCzB;AwCv/rCE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AxCw/rCJ;;AwCl/rCA;EACE,cAAA;AxCq/rCF;;AwCj/rCA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,uBALI;E+B5DR,sCAAA;EACA,mBAAA;AxCo/rCF;;AwCh/rCA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AxCm/rCF;;AwC/+rCA;EAEE,4BAAA;EACA,yBAAA;EACA,+CAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sDAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AxCi/rCF;;AyCvusCA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AzC0usCF;AyCxusCE;;EACE,kBAAA;EACA,cAAA;AzC2usCJ;AyCtusCE;;;;;;;;;;;;EAME,UAAA;AzC8usCJ;;AyCzusCA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AzC4usCF;AyC1usCE;EACE,WAAA;AzC4usCJ;;AyCxusCA;E5BhBI,sBAAA;Ab4vsCJ;AyCxusCE;;EAEE,2BAAA;AzC0usCJ;AyCtusCE;;;E5BVE,0BAAA;EACA,6BAAA;AbqvsCJ;AyClusCE;;;E5BNE,yBAAA;EACA,4BAAA;Ab6usCJ;;AyCrtsCA;EACE,wBAAA;EACA,uBAAA;AzCwtsCF;AyCttsCE;EAGE,cAAA;AzCstsCJ;AyCntsCE;EACE,eAAA;AzCqtsCJ;;AyCjtsCA;EACE,uBAAA;EACA,sBAAA;AzCotsCF;;AyCjtsCA;EACE,sBAAA;EACA,qBAAA;AzCotsCF;;AyChssCA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AzCmssCF;AyCjssCE;;EAEE,WAAA;AzCmssCJ;AyChssCE;;EAEE,0BAAA;AzCkssCJ;AyC9rsCE;;E5B1FE,6BAAA;EACA,4BAAA;Ab4xsCJ;AyC1rsCE;;;E5BjHE,yBAAA;EACA,0BAAA;AbgzsCJ;;A0Cx0sCA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A1Cu0sCF;;A0Cp0sCA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;A1Cs0sCF;A4Bl1sCM;EcGN;IdFQ,gBAAA;E5Bq1sCN;AACF;A0Cz0sCE;EAEE,qCAAA;EACA,qBAAA;A1C00sCJ;A0Cv0sCE;EACE,UAAA;EACA,kDRkhBoB;AlCuzrCxB;A0Cr0sCE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;A1Cs0sCJ;;A0C9zsCA;EAEE,+BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8DAAA;EACA,wCAAA;EACA,+CAAA;EACA,yEAAA;EAGA,oFAAA;A1C8zsCF;A0C5zsCE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;Ab42sCJ;A0C7zsCI;EAGE,kBAAA;EACA,wDAAA;A1C6zsCN;A0CzzsCE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;A1C2zsCJ;A0CxzsCE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;Ab23sCJ;;A0ChzsCA;EAEE,qCAAA;EACA,sCAAA;EACA,sCAAA;A1CkzsCF;A0C/ysCE;E7B5FE,gDAAA;Ab84sCJ;A0C9ysCE;;EAEE,4CAAA;EbjHF,oDakHuB;A1CgzsCzB;;A0CvysCA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;A1CuysCF;A0CrysCE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;A1CuysCJ;A0CrysCI;EAEE,iCAAA;A1CsysCN;A0ClysCE;;EAEE,gB9BmgBe;E8BlgBf,gDAAA;EACA,iCAAA;A1CoysCJ;;A0C1xsCE;;EAEE,cAAA;EACA,kBAAA;A1C6xsCJ;;A0CxxsCE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;A1C2xsCJ;;A0CrxsCE;;EACE,WAAA;A1CyxsCJ;;A0C/wsCE;EACE,aAAA;A1CkxsCJ;A0ChxsCE;EACE,cAAA;A1CkxsCJ;;A2C/8sCA;EAEE,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,kCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EACA,qEAAA;EACA,oDAAA;EACA,0CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;A3C+8sCF;A2Cz8sCE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A3Ci9sCJ;A2C77sCA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EAEA,mBAAA;A3C87sCF;A2C57sCE;EAEE,yCAAA;EACA,qBAAA;A3C67sCJ;;A2Cp7sCA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A3Cm7sCF;A2Ch7sCI;EAEE,oCAAA;A3Ci7sCN;A2C76sCE;EACE,gBAAA;A3C+6sCJ;;A2Ct6sCA;EACE,mB/B0hCmB;E+BzhCnB,sB/ByhCmB;E+BxhCnB,6BAAA;A3Cy6sCF;A2Cv6sCE;;;EAGE,oCAAA;A3Cy6sCJ;;A2C55sCA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;A3C65sCF;;A2Cz5sCA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;A3C45sCF;A4BritCM;EeiIN;IfhIQ,gBAAA;E5BwitCN;AACF;A2C/5sCE;EACE,qBAAA;A3Ci6sCJ;A2C95sCE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;A3Cg6sCJ;;A2C15sCA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;A3C65sCF;;A2C15sCA;EACE,yCAAA;EACA,gBAAA;A3C65sCF;;AoBvhtCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3Co5sCN;E2Cl5sCM;IACE,mBAAA;E3Co5sCR;E2Cl5sCQ;IACE,kBAAA;E3Co5sCV;E2Cj5sCQ;IACE,kDAAA;IACA,iDAAA;E3Cm5sCV;E2C/4sCM;IACE,iBAAA;E3Ci5sCR;E2C94sCM;IACE,wBAAA;IACA,gBAAA;E3Cg5sCR;E2C74sCM;IACE,aAAA;E3C+4sCR;E2C54sCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3C44sCR;E2Cz4sCQ;IACE,aAAA;E3C24sCV;E2Cx4sCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3C04sCV;AACF;AoBvktCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3Cm8sCN;E2Cj8sCM;IACE,mBAAA;E3Cm8sCR;E2Cj8sCQ;IACE,kBAAA;E3Cm8sCV;E2Ch8sCQ;IACE,kDAAA;IACA,iDAAA;E3Ck8sCV;E2C97sCM;IACE,iBAAA;E3Cg8sCR;E2C77sCM;IACE,wBAAA;IACA,gBAAA;E3C+7sCR;E2C57sCM;IACE,aAAA;E3C87sCR;E2C37sCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3C27sCR;E2Cx7sCQ;IACE,aAAA;E3C07sCV;E2Cv7sCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Cy7sCV;AACF;AoBtntCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3Ck/sCN;E2Ch/sCM;IACE,mBAAA;E3Ck/sCR;E2Ch/sCQ;IACE,kBAAA;E3Ck/sCV;E2C/+sCQ;IACE,kDAAA;IACA,iDAAA;E3Ci/sCV;E2C7+sCM;IACE,iBAAA;E3C++sCR;E2C5+sCM;IACE,wBAAA;IACA,gBAAA;E3C8+sCR;E2C3+sCM;IACE,aAAA;E3C6+sCR;E2C1+sCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3C0+sCR;E2Cv+sCQ;IACE,aAAA;E3Cy+sCV;E2Ct+sCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Cw+sCV;AACF;AoBrqtCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CiitCN;E2C/htCM;IACE,mBAAA;E3CiitCR;E2C/htCQ;IACE,kBAAA;E3CiitCV;E2C9htCQ;IACE,kDAAA;IACA,iDAAA;E3CgitCV;E2C5htCM;IACE,iBAAA;E3C8htCR;E2C3htCM;IACE,wBAAA;IACA,gBAAA;E3C6htCR;E2C1htCM;IACE,aAAA;E3C4htCR;E2CzhtCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CyhtCR;E2CthtCQ;IACE,aAAA;E3CwhtCV;E2CrhtCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CuhtCV;AACF;AoBpttCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CgltCN;E2C9ktCM;IACE,mBAAA;E3CgltCR;E2C9ktCQ;IACE,kBAAA;E3CgltCV;E2C7ktCQ;IACE,kDAAA;IACA,iDAAA;E3C+ktCV;E2C3ktCM;IACE,iBAAA;E3C6ktCR;E2C1ktCM;IACE,wBAAA;IACA,gBAAA;E3C4ktCR;E2CzktCM;IACE,aAAA;E3C2ktCR;E2CxktCM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CwktCR;E2CrktCQ;IACE,aAAA;E3CuktCV;E2CpktCQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CsktCV;AACF;A2C7ntCI;EAEI,iBAAA;EACA,2BAAA;A3C8ntCR;A2C5ntCQ;EACE,mBAAA;A3C8ntCV;A2C5ntCU;EACE,kBAAA;A3C8ntCZ;A2C3ntCU;EACE,kDAAA;EACA,iDAAA;A3C6ntCZ;A2CzntCQ;EACE,iBAAA;A3C2ntCV;A2CxntCQ;EACE,wBAAA;EACA,gBAAA;A3C0ntCV;A2CvntCQ;EACE,aAAA;A3CyntCV;A2CtntCQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;A3CsntCV;A2CnntCU;EACE,aAAA;A3CqntCZ;A2ClntCU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;A3ContCZ;;A2CnmtCA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;A3CqmtCF;;A2C/ltCI;EACE,qEAAA;A3CkmtCN;;A4C33tCA;EAEE,2BAAA;EACA,2BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EACA,gDAAA;EACA,iCAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;Ab64tCJ;A4Cx3tCE;EACE,eAAA;EACA,cAAA;A5C03tCJ;A4Cv3tCE;EACE,mBAAA;EACA,sBAAA;A5Cy3tCJ;A4Cv3tCI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;Abg5tCJ;A4Cv3tCI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;Abu4tCJ;A4Cp3tCE;;EAEE,aAAA;A5Cs3tCJ;;A4Cl3tCA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A5Cm3tCF;;A4Ch3tCA;EACE,4CAAA;EACA,iCAAA;A5Cm3tCF;;A4Ch3tCA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;A5Cm3tCF;;A4Ch3tCA;EACE,gBAAA;A5Cm3tCF;;A4C/2tCE;EACE,qBAAA;A5Ck3tCJ;A4C/2tCE;EACE,oCAAA;A5Ci3tCJ;;A4Cz2tCA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A5C42tCF;A4C12tCE;E/B7FE,wFAAA;Ab08tCJ;;A4Cx2tCA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A5C22tCF;A4Cz2tCE;E/BxGE,wFAAA;Abo9tCJ;;A4Cl2tCA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A5Cq2tCF;A4Cn2tCE;EACE,mCAAA;EACA,sCAAA;A5Cq2tCJ;;A4Cj2tCA;EACE,uDAAA;EACA,sDAAA;A5Co2tCF;;A4Ch2tCA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;Ab8+tCJ;;A4Ch2tCA;;;EAGE,WAAA;A5Cm2tCF;;A4Ch2tCA;;E/B3II,0DAAA;EACA,2DAAA;Abg/tCJ;;A4Cj2tCA;;E/BlII,8DAAA;EACA,6DAAA;Abw+tCJ;;A4C11tCE;EACE,0CAAA;A5C61tCJ;AoBx9tCI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;E5C61tCF;E4C11tCE;IACE,SAAA;IACA,gBAAA;E5C41tCJ;E4C11tCI;IACE,cAAA;IACA,cAAA;E5C41tCN;E4Cv1tCM;I/B1KJ,0BAAA;IACA,6BAAA;EboguCF;E4Cx1tCQ;;IAGE,0BAAA;E5Cy1tCV;E4Cv1tCQ;;IAGE,6BAAA;E5Cw1tCV;E4Cp1tCM;I/B3KJ,yBAAA;IACA,4BAAA;EbkguCF;E4Cr1tCQ;;IAGE,yBAAA;E5Cs1tCV;E4Cp1tCQ;;IAGE,4BAAA;E5Cq1tCV;AACF;;A6CzjuCA;EAEE,6BAAA;EACA,8BAAA;EACA,8KAAA;EACA,iDAAA;EACA,gCAAA;EACA,qCAAA;EACA,uDAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,kCAAA;EACA,iEAAA;EACA,mCAAA;EACA,iDAAA;EACA,8DAAA;EACA,wEAAA;EACA,yCAAA;EACA,sCAAA;EACA,mCAAA;EACA,+CAAA;EACA,gDAAA;A7C2juCF;;A6CvjuCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,oBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;A7C0juCF;A4BjluCM;EiBUN;IjBTQ,gBAAA;E5BoluCN;AACF;A6C7juCE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A7C+juCJ;A6C7juCI;EACE,qDAAA;EACA,iDAAA;A7C+juCN;A6C1juCE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;A7C4juCJ;A4B1muCM;EiBqCJ;IjBpCM,gBAAA;E5B6muCN;AACF;A6C9juCE;EACE,UAAA;A7CgkuCJ;A6C7juCE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;A7C+juCJ;;A6C3juCA;EACE,gBAAA;A7C8juCF;;A6C3juCA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A7C8juCF;A6C5juCE;EhC7DE,yDAAA;EACA,0DAAA;Ab4nuCJ;A6C7juCI;EhChEA,+DAAA;EACA,gEAAA;AbgouCJ;A6C5juCE;EACE,aAAA;A7C8juCJ;A6C1juCE;EhC5DE,6DAAA;EACA,4DAAA;AbynuCJ;A6C1juCM;EhChEF,mEAAA;EACA,kEAAA;Ab6nuCJ;A6CzjuCI;EhCrEA,6DAAA;EACA,4DAAA;AbiouCJ;;A6CvjuCA;EACE,8EAAA;A7C0juCF;;A6CjjuCE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AbmquCJ;A6CljuCI;EAAgB,aAAA;A7CqjuCpB;A6CpjuCI;EAAe,gBAAA;A7CujuCnB;A6CpjuCI;;;EhCrHA,gBAAA;Ab8quCJ;;A6C9iuCI;EACE,iEAAA;EACA,wEAAA;A7CijuCN;;A8CtsuCA;EAEE,+BAAA;EACA,kCAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AbssuCJ;;A8ChsuCE;EACE,iDAAA;A9CmsuCJ;A8CjsuCI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A9CmsuCN;A8C/ruCE;EACE,6CAAA;A9CisuCJ;;A+CtuuCA;EAEE,kCAAA;EACA,iCAAA;EtC4RI,+BALI;EsCrRR,8BAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,sCAAA;EACA,oCAAA;EACA,iCAAA;EACA,2CAAA;EACA,oCAAA;EACA,iCAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;Af2vuCF;;A+CpuuCA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A/CsuuCF;A4BvvuCM;EmBQN;InBPQ,gBAAA;E5B0vuCN;AACF;A+CzuuCE;EACE,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,+CAAA;EACA,qDAAA;A/C2uuCJ;A+CxuuCE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCuB;EmC1uCvB,iDAAA;A/C0uuCJ;A+CvuuCE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A/CwuuCJ;A+CruuCE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A/CsuuCJ;;A+CjuuCE;EACE,iBnC8sCsB;AZshsC1B;A+CntuCI;ElCxEA,iDAAA;Ab8xuCJ;;A+C3suCA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,sCALI;EuCnRR,qCAAA;AhDizuCF;;A+C9suCA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,uCALI;EuCnRR,qCAAA;AhDwzuCF;;AiD1zuCA;EAEE,2BAAA;EACA,4BAAA;ExCuRI,yBALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;Ab+zuCJ;AiDtzuCE;EACE,aAAA;AjDwzuCJ;;AiDnzuCA;EACE,kBAAA;EACA,SAAA;AjDszuCF;;AkDt1uCA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;Ab01uCJ;;AkDl1uCA;EAEE,cAAA;AlDo1uCF;;AkDh1uCA;EACE,gBtCsnBiB;EsCrnBjB,iCAAA;AlDm1uCF;;AkD30uCA;EACE,sBtCs+C4B;AZw2rC9B;AkD30uCE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;AlD60uCJ;;AkDr0uCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDw0uCJ;;AkD50uCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AlD+0uCJ;;AkDn1uCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDs1uCJ;;AkD11uCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlD61uCJ;;AkDj2uCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDo2uCJ;;AkDx2uCE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AlD22uCJ;;AkD/2uCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDk3uCJ;;AkDt3uCE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AlDy3uCJ;;AkD73uCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDg4uCJ;;AmD57uCE;EACE;IAAK,gDAAA;EnDg8uCP;AACF;AmD57uCA;;EAGE,8BAAA;E1CkRI,oCALI;E0C3QR,yBAAA;EACA,oCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;Abo8uCJ;;AmDv7uCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;AnD07uCF;A4B/8uCM;EuBYN;IvBXQ,gBAAA;E5Bk9uCN;AACF;;AmD57uCA;EtBAE,qMAAA;EsBEA,oEAAA;AnD+7uCF;;AmD57uCA;EACE,iBAAA;AnD+7uCF;;AmD57uCA;EACE,WAAA;AnD+7uCF;;AmD37uCE;EACE,kDAAA;AnD87uCJ;AmD37uCM;EAJJ;IAKM,eAAA;EnD87uCN;AACF;;AoD1/uCA;EAEE,2CAAA;EACA,wBAAA;EACA,qCAAA;EACA,iCAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AbogvCJ;;AoDr/uCA;EACE,qBAAA;EACA,sBAAA;ApDw/uCF;AoDt/uCE;EAEE,oCAAA;EACA,0BAAA;ApDu/uCJ;;AoD/+uCA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;ApDi/uCF;AoD/+uCE;EvC9BE,+BAAA;EACA,gCAAA;AbghvCJ;AoD/+uCE;EvCpBE,mCAAA;EACA,kCAAA;AbsgvCJ;AoD/+uCE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;ApDg/uCJ;AoD5+uCE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;ApD8+uCJ;AoD1+uCE;EACE,mBAAA;ApD4+uCJ;AoD1+uCI;EACE,wDAAA;EACA,mDAAA;ApD4+uCN;;AoDl+uCA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;ApDq+uCF;AoDj+uCI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;ApDk+uCN;AoD/9uCI;EACE,+CAAA;EACA,uDAAA;ApDi+uCN;;AoDp9uCI;EACE,mBAAA;ApDu9uCN;AoDp9uCQ;EvCzDJ,6DAAA;EAZA,0BAAA;Ab6hvCJ;AoDn9uCQ;EvC1EJ,2DAAA;EAYA,4BAAA;AbqhvCJ;AoDl9uCQ;EACE,aAAA;ApDo9uCV;AoDj9uCQ;EACE,mDAAA;EACA,oBAAA;ApDm9uCV;AoDj9uCU;EACE,yDAAA;EACA,oDAAA;ApDm9uCZ;;AoB3ivCI;EgCgEA;IACE,mBAAA;EpD++uCJ;EoD5+uCM;IvCzDJ,6DAAA;IAZA,0BAAA;EbqjvCF;EoD3+uCM;IvC1EJ,2DAAA;IAYA,4BAAA;Eb6ivCF;EoD1+uCM;IACE,aAAA;EpD4+uCR;EoDz+uCM;IACE,mDAAA;IACA,oBAAA;EpD2+uCR;EoDz+uCQ;IACE,yDAAA;IACA,oDAAA;EpD2+uCV;AACF;AoBpkvCI;EgCgEA;IACE,mBAAA;EpDugvCJ;EoDpgvCM;IvCzDJ,6DAAA;IAZA,0BAAA;Eb6kvCF;EoDngvCM;IvC1EJ,2DAAA;IAYA,4BAAA;EbqkvCF;EoDlgvCM;IACE,aAAA;EpDogvCR;EoDjgvCM;IACE,mDAAA;IACA,oBAAA;EpDmgvCR;EoDjgvCQ;IACE,yDAAA;IACA,oDAAA;EpDmgvCV;AACF;AoB5lvCI;EgCgEA;IACE,mBAAA;EpD+hvCJ;EoD5hvCM;IvCzDJ,6DAAA;IAZA,0BAAA;EbqmvCF;EoD3hvCM;IvC1EJ,2DAAA;IAYA,4BAAA;Eb6lvCF;EoD1hvCM;IACE,aAAA;EpD4hvCR;EoDzhvCM;IACE,mDAAA;IACA,oBAAA;EpD2hvCR;EoDzhvCQ;IACE,yDAAA;IACA,oDAAA;EpD2hvCV;AACF;AoBpnvCI;EgCgEA;IACE,mBAAA;EpDujvCJ;EoDpjvCM;IvCzDJ,6DAAA;IAZA,0BAAA;Eb6nvCF;EoDnjvCM;IvC1EJ,2DAAA;IAYA,4BAAA;EbqnvCF;EoDljvCM;IACE,aAAA;EpDojvCR;EoDjjvCM;IACE,mDAAA;IACA,oBAAA;EpDmjvCR;EoDjjvCQ;IACE,yDAAA;IACA,oDAAA;EpDmjvCV;AACF;AoB5ovCI;EgCgEA;IACE,mBAAA;EpD+kvCJ;EoD5kvCM;IvCzDJ,6DAAA;IAZA,0BAAA;EbqpvCF;EoD3kvCM;IvC1EJ,2DAAA;IAYA,4BAAA;Eb6ovCF;EoD1kvCM;IACE,aAAA;EpD4kvCR;EoDzkvCM;IACE,mDAAA;IACA,oBAAA;EpD2kvCR;EoDzkvCQ;IACE,yDAAA;IACA,oDAAA;EpD2kvCV;AACF;AoD9jvCA;EvClJI,gBAAA;AbmtvCJ;AoD9jvCE;EACE,mDAAA;ApDgkvCJ;AoD9jvCI;EACE,sBAAA;ApDgkvCN;;AoDnjvCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDsjvCJ;;AoDhkvCE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;ApDmkvCJ;;AoD7kvCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDglvCJ;;AoD1lvCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApD6lvCJ;;AoDvmvCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApD0mvCJ;;AoDpnvCE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ApDunvCJ;;AoDjovCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApDoovCJ;;AoD9ovCE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ApDipvCJ;;AoD3pvCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApD8pvCJ;;AqD51vCA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCwoDgB;EyCvoDhB,WzCuoDgB;EyCtoDhB,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,sBAAA;EwCMF,oCAAA;ArD41vCF;AqDz1vCE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;ArD21vCJ;AqDx1vCE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;ArD01vCJ;AqDv1vCE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;ArDw1vCJ;;AqDh1vCA;EAHE,iEAAA;ArDu1vCF;;AqDh1vCA;;EAEE,uBAAA;ArDm1vCF;;AU93vCI;E2CkCF,iEAAA;ArDg2vCF;;AsDj5vCA;EAEE,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2CAAA;EACA,iCAAA;EACA,8DAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;Ab05vCJ;AsD/4vCE;EACE,UAAA;AtDi5vCJ;AsD94vCE;EACE,aAAA;AtDg5vCJ;;AsD54vCA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AtD84vCF;AsD54vCE;EACE,sCAAA;AtD84vCJ;;AsD14vCA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;Ab86vCJ;AsD54vCE;EACE,oDAAA;EACA,sCAAA;AtD84vCJ;;AsD14vCA;EACE,kCAAA;EACA,qBAAA;AtD64vCF;;AuD38vCA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AvDy8vCF;;AuDl8vCA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AvDo8vCF;AuDj8vCE;EACE,8B3C+7CmB;EgB5+CjB,mC2B8CF;AvDm8vCJ;A4B7+vCM;E2BwCJ;I3BvCM,gBAAA;E5Bg/vCN;AACF;AuDt8vCE;EACE,e3C47CmB;AZ4gtCvB;AuDp8vCE;EACE,sB3Cy7CoB;AZ6gtCxB;;AuDl8vCA;EACE,+CAAA;AvDq8vCF;AuDn8vCE;EACE,gBAAA;EACA,gBAAA;AvDq8vCJ;AuDl8vCE;EACE,gBAAA;AvDo8vCJ;;AuDh8vCA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AvDm8vCF;;AuD/7vCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AvD+7vCF;;AuD37vCA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AvDi8vC9D;AwD7iwCE;EAAS,UAAA;AxDgjwCX;AwD/iwCE;EAAS,mCD2GiF;AvDu8vC5F;;AuDl8vCA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;Ab2iwCJ;AuDp8vCE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AvDq8vCJ;;AuDh8vCA;EACE,gBAAA;EACA,8CAAA;AvDm8vCF;;AuD97vCA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AvD+7vCF;;AuD37vCA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;Ab4jwCJ;AuD17vCE;EACE,8CAAA;AvD47vCJ;;AoB3iwCI;EmCqHF;IACE,0BAAA;IACA,8DAAA;EvD07vCF;EuDt7vCA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EvDw7vCF;EuDr7vCA;IACE,uBAAA;EvDu7vCF;AACF;AoB1jwCI;EmCuIF;;IAEE,uBAAA;EvDs7vCF;AACF;AoBhkwCI;EmC8IF;IACE,wBAAA;EvDq7vCF;AACF;AuD56vCI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AvD86vCN;AuD56vCM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;Ab4nwCJ;AuD36vCM;;E1CjNF,gBAAA;AbgowCJ;AuD16vCM;EACE,gBAAA;AvD46vCR;;AoB1kwCI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDk8vCJ;EuDh8vCI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EbgpwCF;EuD/7vCI;;I1CjNF,gBAAA;EbopwCF;EuD97vCI;IACE,gBAAA;EvDg8vCN;AACF;AoB/lwCI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDs9vCJ;EuDp9vCI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EboqwCF;EuDn9vCI;;I1CjNF,gBAAA;EbwqwCF;EuDl9vCI;IACE,gBAAA;EvDo9vCN;AACF;AoBnnwCI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD0+vCJ;EuDx+vCI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EbwrwCF;EuDv+vCI;;I1CjNF,gBAAA;Eb4rwCF;EuDt+vCI;IACE,gBAAA;EvDw+vCN;AACF;AoBvowCI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD8/vCJ;EuD5/vCI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;Eb4swCF;EuD3/vCI;;I1CjNF,gBAAA;EbgtwCF;EuD1/vCI;IACE,gBAAA;EvD4/vCN;AACF;AoB3pwCI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDkhwCJ;EuDhhwCI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EbguwCF;EuD/gwCI;;I1CjNF,gBAAA;EbouwCF;EuD9gwCI;IACE,gBAAA;EvDghwCN;AACF;AyD1vwCA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EhDwRI,oCALI;EgDjRR,wBAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C0oBiB;E8CxoBjB,kBAAA;EACA,gB9CmpBmB;E8ClpBnB,gB9CupBiB;E8CtpBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AzDkwwCF;AyDhwwCE;EAAS,kCAAA;AzDmwwCX;AyDjwwCE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzDmwwCJ;AyDjwwCI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AzDmwwCN;;AyD9vwCA;EACE,iDAAA;AzDiwwCF;AyD/vwCE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AzDiwwCJ;;AyD7vwCA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AzDgwwCF;AyD9vwCE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AzDgwwCJ;;AyD5vwCA,mBAAA;AAEA;EACE,8CAAA;AzD8vwCF;AyD5vwCE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AzD8vwCJ;;AyD1vwCA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AzD6vwCF;AyD3vwCE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AzD6vwCJ;;AyDzvwCA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;Ab60wCJ;;A2Dh2wCA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,oCALI;EkDrRR,qBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kCAAA;EACA,oDAAA;EACA,4DAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,gDAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C0oBiB;E8CxoBjB,kBAAA;EACA,gB9CmpBmB;E8ClpBnB,gB9CupBiB;E8CtpBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;Ab23wCJ;A2Dv2wCE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A3Dy2wCJ;A2Dv2wCI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;A3Dw2wCN;;A2Dl2wCE;EACE,oFAAA;A3Dq2wCJ;A2Dn2wCI;EAEE,wFAAA;A3Do2wCN;A2Dj2wCI;EACE,SAAA;EACA,gDAAA;A3Dm2wCN;A2Dh2wCI;EACE,sCAAA;EACA,sCAAA;A3Dk2wCN;;A2D71wCA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;A3D+1wCJ;A2D71wCI;EAEE,kIAAA;A3D81wCN;A2D31wCI;EACE,OAAA;EACA,kDAAA;A3D61wCN;A2D11wCI;EACE,oCAAA;EACA,wCAAA;A3D41wCN;;A2Dv1wCA,mBAAA;AAGE;EACE,iFAAA;A3Dw1wCJ;A2Dt1wCI;EAEE,wFAAA;A3Du1wCN;A2Dp1wCI;EACE,MAAA;EACA,mDAAA;A3Ds1wCN;A2Dn1wCI;EACE,mCAAA;EACA,yCAAA;A3Dq1wCN;A2Dh1wCE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;A3Dk1wCJ;;A2D90wCA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;A3Dg1wCJ;A2D90wCI;EAEE,kIAAA;A3D+0wCN;A2D50wCI;EACE,QAAA;EACA,iDAAA;A3D80wCN;A2D30wCI;EACE,qCAAA;EACA,uCAAA;A3D60wCN;;A2Dx0wCA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;Abu9wCJ;A2DzzwCE;EACE,aAAA;A3D2zwCJ;;A2DvzwCA;EACE,0EAAA;EACA,mCAAA;A3D0zwCF;;A4D/+wCA;EACE,kBAAA;A5Dk/wCF;;A4D/+wCA;EACE,mBAAA;A5Dk/wCF;;A4D/+wCA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A5Dk/wCF;A6DxgxCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7D0gxCJ;;A4Dn/wCA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;A5Ds/wCF;A4BrgxCM;EgCQN;IhCPQ,gBAAA;E5BwgxCN;AACF;;A4Dx/wCA;;;EAGE,cAAA;A5D2/wCF;;A4Dx/wCA;;EAEE,2BAAA;A5D2/wCF;;A4Dx/wCA;;EAEE,4BAAA;A5D2/wCF;;A4Dl/wCE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A5Dq/wCJ;A4Dl/wCE;;;EAGE,UAAA;EACA,UAAA;A5Do/wCJ;A4Dj/wCE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;A5Dm/wCJ;A4B5ixCM;EgCqDJ;;IhCpDM,gBAAA;E5BgjxCN;AACF;;A4Dh/wCA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDwgDuB;EgDvgDvB,UAAA;EACA,WhDhBM;EgDiBN,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhDkgDyB;EgBzlDrB,8BgCwFJ;A5Dk/wCF;A4BtkxCM;EgCkEN;;IhCjEQ,gBAAA;E5B0kxCN;AACF;A4Dr/wCE;;;EAEE,WhD3BI;EgD4BJ,qBAAA;EACA,UAAA;EACA,YhD0/C6B;AZ8/tCjC;;A4Dr/wCA;EACE,OAAA;A5Dw/wCF;;A4Dr/wCA;EACE,QAAA;A5Dw/wCF;;A4Dn/wCA;;EAEE,qBAAA;EACA,WhD2/C4B;EgD1/C5B,YhD0/C4B;EgDz/C5B,4BAAA;EACA,wBAAA;EACA,0BAAA;A5Ds/wCF;;A4Dn/wCA;EACE,2TAAA;A5Ds/wCF;;A4Dp/wCA;EACE,0TAAA;A5Du/wCF;;A4D/+wCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhD28CuB;EgD18CvB,mBAAA;EACA,gBhDy8CuB;AZwiuCzB;A4D/+wCE;EACE,uBAAA;EACA,cAAA;EACA,WhDy8CuB;EgDx8CvB,WhDy8CwB;EgDx8CxB,UAAA;EACA,iBhDy8CwB;EgDx8CxB,gBhDw8CwB;EgDv8CxB,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhDg8CyB;EgBjmDvB,6BgCkKF;A5Dg/wCJ;A4B9oxCM;EgC6IJ;IhC5IM,gBAAA;E5BipxCN;AACF;A4Dl/wCE;EACE,UhD67CgC;AZujuCpC;;A4D3+wCA;EACE,kBAAA;EACA,UAAA;EACA,ehDu7CwB;EgDt7CxB,SAAA;EACA,oBhDo7C2B;EgDn7C3B,uBhDm7C2B;EgDl7C3B,uCAAA;EACA,kBAAA;A5D8+wCF;;A4Dn+wCA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;A5D4+wCF;;A4Dr+wCA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;A5Dw+wCF;;AUnrxCI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;A5Dy/wCF;;A8DpsxCA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A9DssxCF;;A8DlsxCA;EACE;IAAK,0CAAA;E9DssxCL;AACF;A8DnsxCA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A9DksxCF;;A8D/rxCA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A9DisxCF;;A8DxrxCA;EACE;IACE,mBAAA;E9D2rxCF;E8DzrxCA;IACE,UAAA;IACA,eAAA;E9D2rxCF;AACF;A8DvrxCA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A9DsrxCF;;A8DnrxCA;EACE,wBAAA;EACA,yBAAA;A9DsrxCF;;A8DlrxCE;EACE;;IAEE,kCAAA;E9DqrxCJ;AACF;A+DrwxCA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,uBAAA;EACA,gCAAA;EACA,oCAAA;EACA,kEAAA;EACA,qDAAA;EACA,qCAAA;A/DswxCF;;AoBzsxCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/DuvxCJ;AACF;A4BlxxCM;EmCYJ;InCXM,gBAAA;E5BqxxCN;AACF;AoB/txCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D8vxCN;E+D3vxCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D6vxCN;E+D1vxCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D4vxCN;E+DzvxCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D2vxCN;E+DxvxCI;IAEE,eAAA;E/DyvxCN;E+DtvxCI;IAGE,mBAAA;E/DsvxCN;AACF;AoBnxxCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/DqvxCN;E+DnvxCM;IACE,aAAA;E/DqvxCR;E+DlvxCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/DmvxCR;AACF;;AoBvxxCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/Dq0xCJ;AACF;A4Bh2xCM;EmCYJ;InCXM,gBAAA;E5Bm2xCN;AACF;AoB7yxCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D40xCN;E+Dz0xCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D20xCN;E+Dx0xCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D00xCN;E+Dv0xCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Dy0xCN;E+Dt0xCI;IAEE,eAAA;E/Du0xCN;E+Dp0xCI;IAGE,mBAAA;E/Do0xCN;AACF;AoBj2xCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dm0xCN;E+Dj0xCM;IACE,aAAA;E/Dm0xCR;E+Dh0xCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Di0xCR;AACF;;AoBr2xCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/Dm5xCJ;AACF;A4B96xCM;EmCYJ;InCXM,gBAAA;E5Bi7xCN;AACF;AoB33xCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D05xCN;E+Dv5xCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Dy5xCN;E+Dt5xCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Dw5xCN;E+Dr5xCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Du5xCN;E+Dp5xCI;IAEE,eAAA;E/Dq5xCN;E+Dl5xCI;IAGE,mBAAA;E/Dk5xCN;AACF;AoB/6xCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Di5xCN;E+D/4xCM;IACE,aAAA;E/Di5xCR;E+D94xCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D+4xCR;AACF;;AoBn7xCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/Di+xCJ;AACF;A4B5/xCM;EmCYJ;InCXM,gBAAA;E5B+/xCN;AACF;AoBz8xCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Dw+xCN;E+Dr+xCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Du+xCN;E+Dp+xCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Ds+xCN;E+Dn+xCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Dq+xCN;E+Dl+xCI;IAEE,eAAA;E/Dm+xCN;E+Dh+xCI;IAGE,mBAAA;E/Dg+xCN;AACF;AoB7/xCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D+9xCN;E+D79xCM;IACE,aAAA;E/D+9xCR;E+D59xCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D69xCR;AACF;;AoBjgyCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E/D+iyCJ;AACF;A4B1kyCM;EmCYJ;InCXM,gBAAA;E5B6kyCN;AACF;AoBvhyCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/DsjyCN;E+DnjyCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DqjyCN;E+DljyCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DojyCN;E+DjjyCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DmjyCN;E+DhjyCI;IAEE,eAAA;E/DijyCN;E+D9iyCI;IAGE,mBAAA;E/D8iyCN;AACF;AoB3kyCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D6iyCN;E+D3iyCM;IACE,aAAA;E/D6iyCR;E+D1iyCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D2iyCR;AACF;;A+D3nyCE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A/D4nyCN;A4BtpyCM;EmCYJ;InCXM,gBAAA;E5BypyCN;AACF;A+D/nyCM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A/DioyCR;A+D9nyCM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A/DgoyCR;A+D7nyCM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A/D+nyCR;A+D5nyCM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A/D8nyCR;A+D3nyCM;EAEE,eAAA;A/D4nyCR;A+DznyCM;EAGE,mBAAA;A/DynyCR;;A+D9lyCA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CkoC0B;E4CjoC1B,YAAA;EACA,aAAA;EACA,sB5CoFM;AZkoyCR;AwDntyCE;EAAS,UAAA;AxDstyCX;AwDrtyCE;EAAS,Y5Ck+Cc;AZsvvCzB;;A+D1myCA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A/D6myCF;A+D3myCE;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;A/D4myCJ;;A+DxmyCA;EACE,gBAAA;EACA,kDAAA;A/D2myCF;;A+DxmyCA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A/D2myCF;;AgE5vyCA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDizCwB;AZ88vC1B;AgE7vyCE;EACE,qBAAA;EACA,WAAA;AhE+vyCJ;;AgE1vyCA;EACE,iBAAA;AhE6vyCF;;AgE1vyCA;EACE,iBAAA;AhE6vyCF;;AgE1vyCA;EACE,iBAAA;AhE6vyCF;;AgExvyCE;EACE,mDAAA;AhE2vyCJ;;AgEvvyCA;EACE;IACE,YpDoxCsB;EZs+vCxB;AACF;AgEvvyCA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AhEyvyCF;;AgEtvyCA;EACE;IACE,uBAAA;EhEyvyCF;AACF;A6DxyyCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7D0yyCJ;;AiE7yyCE;EACE,sBAAA;EACA,iFAAA;AjEgzyCJ;;AiElzyCE;EACE,sBAAA;EACA,mFAAA;AjEqzyCJ;;AiEvzyCE;EACE,sBAAA;EACA,iFAAA;AjE0zyCJ;;AiE5zyCE;EACE,sBAAA;EACA,8EAAA;AjE+zyCJ;;AiEj0yCE;EACE,sBAAA;EACA,iFAAA;AjEo0yCJ;;AiEt0yCE;EACE,sBAAA;EACA,gFAAA;AjEy0yCJ;;AiE30yCE;EACE,sBAAA;EACA,8EAAA;AjE80yCJ;;AiEh1yCE;EACE,sBAAA;EACA,+EAAA;AjEm1yCJ;;AiEr1yCE;EACE,sBAAA;EACA,8EAAA;AjEw1yCJ;;AkE11yCE;EACE,wEAAA;EACA,kGAAA;AlE61yCJ;AkE11yCM;EAGE,8DAAA;EACA,wFAAA;AlE01yCR;;AkEn2yCE;EACE,0EAAA;EACA,oGAAA;AlEs2yCJ;AkEn2yCM;EAGE,8DAAA;EACA,wFAAA;AlEm2yCR;;AkE52yCE;EACE,wEAAA;EACA,kGAAA;AlE+2yCJ;AkE52yCM;EAGE,+DAAA;EACA,yFAAA;AlE42yCR;;AkEr3yCE;EACE,qEAAA;EACA,+FAAA;AlEw3yCJ;AkEr3yCM;EAGE,+DAAA;EACA,yFAAA;AlEq3yCR;;AkE93yCE;EACE,wEAAA;EACA,kGAAA;AlEi4yCJ;AkE93yCM;EAGE,+DAAA;EACA,yFAAA;AlE83yCR;;AkEv4yCE;EACE,uEAAA;EACA,iGAAA;AlE04yCJ;AkEv4yCM;EAGE,8DAAA;EACA,wFAAA;AlEu4yCR;;AkEh5yCE;EACE,qEAAA;EACA,+FAAA;AlEm5yCJ;AkEh5yCM;EAGE,+DAAA;EACA,yFAAA;AlEg5yCR;;AkEz5yCE;EACE,sEAAA;EACA,gGAAA;AlE45yCJ;AkEz5yCM;EAGE,gEAAA;EACA,0FAAA;AlEy5yCR;;AkEl6yCE;EACE,qEAAA;EACA,+FAAA;AlEq6yCJ;AkEl6yCM;EAGE,6DAAA;EACA,uFAAA;AlEk6yCR;;AkE35yCA;EACE,+EAAA;EACA,yGAAA;AlE85yCF;AkE35yCI;EAEE,kFAAA;EACA,4GAAA;AlE45yCN;;AmEt7yCA;EACE,UAAA;EAEA,kJAAA;AnEw7yCF;;AoE37yCA;EACE,oBAAA;EACA,alC6c4B;EkC5c5B,mBAAA;EACA,kFAAA;EACA,6BlC2c4B;EkC1c5B,2BAAA;ApE87yCF;AoE57yCE;EACE,cAAA;EACA,UlCuc0B;EkCtc1B,WlCsc0B;EkCrc1B,kBAAA;ExCIE,sCwCHF;ApE87yCJ;A4Bv7yCM;EwCZJ;IxCaM,gBAAA;E5B07yCN;AACF;;AoE57yCI;EACE,mEAAA;ApE+7yCN;;AqEl9yCA;EACE,kBAAA;EACA,WAAA;ArEq9yCF;AqEn9yCE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;ArEq9yCJ;AqEl9yCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ArEo9yCJ;;AqE/8yCE;EACE,uBAAA;ArEk9yCJ;;AqEn9yCE;EACE,sBAAA;ArEs9yCJ;;AqEv9yCE;EACE,yBAAA;ArE09yCJ;;AqE39yCE;EACE,iCAAA;ArE89yCJ;;AsEn/yCA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1D+nCa;AZu3wCf;;AsEn/yCA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1DunCa;AZ+3wCf;;AsE9+yCI;EACE,gBAAA;EACA,MAAA;EACA,a1D2mCU;AZs4wChB;;AsE9+yCI;EACE,gBAAA;EACA,SAAA;EACA,a1DqmCU;AZ44wChB;;AoBl9yCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2mCU;EZm5wCd;EsE3/yCE;IACE,gBAAA;IACA,SAAA;IACA,a1DqmCU;EZw5wCd;AACF;AoB/9yCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2mCU;EZ+5wCd;EsEvgzCE;IACE,gBAAA;IACA,SAAA;IACA,a1DqmCU;EZo6wCd;AACF;AoB3+yCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2mCU;EZ26wCd;EsEnhzCE;IACE,gBAAA;IACA,SAAA;IACA,a1DqmCU;EZg7wCd;AACF;AoBv/yCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2mCU;EZu7wCd;EsE/hzCE;IACE,gBAAA;IACA,SAAA;IACA,a1DqmCU;EZ47wCd;AACF;AoBngzCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D2mCU;EZm8wCd;EsE3izCE;IACE,gBAAA;IACA,SAAA;IACA,a1DqmCU;EZw8wCd;AACF;AuE7kzCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AvE+kzCF;;AuE5kzCA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AvE+kzCF;;AwEvlzCA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AzEwlzCF;AyErlzCE;;EACE,6BAAA;AzEwlzCJ;;A0EtmzCE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DkgBqB;E8DjgBrB,WAAA;A1EymzCJ;;A2EjnzCA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A5EqnzCF;;A6E3nzCA;EACE,qBAAA;EACA,mBAAA;EACA,6B3CisB4B;E2ChsB5B,eAAA;EACA,8BAAA;EACA,YjEutBW;AZu6xCb;;A8ElkzCQ;EAOI,mCAAA;A9E+jzCZ;;A8EtkzCQ;EAOI,8BAAA;A9EmkzCZ;;A8E1kzCQ;EAOI,iCAAA;A9EukzCZ;;A8E9kzCQ;EAOI,iCAAA;A9E2kzCZ;;A8EllzCQ;EAOI,sCAAA;A9E+kzCZ;;A8EtlzCQ;EAOI,mCAAA;A9EmlzCZ;;A8E1lzCQ;EAOI,sBAAA;A9EulzCZ;;A8E9lzCQ;EAOI,uBAAA;A9E2lzCZ;;A8ElmzCQ;EAOI,sBAAA;A9E+lzCZ;;A8EtmzCQ;EAOI,8BAAA;A9EmmzCZ;;A8E1mzCQ;EAOI,4BAAA;A9EumzCZ;;A8E9mzCQ;EAOI,2BAAA;A9E2mzCZ;;A8ElnzCQ;EAOI,iCAAA;A9E+mzCZ;;A8EtnzCQ;EAOI,2BAAA;A9EmnzCZ;;A8E1nzCQ;EAOI,qBAAA;A9EunzCZ;;A8E9nzCQ;EAOI,wBAAA;A9E2nzCZ;;A8ElozCQ;EAOI,uBAAA;A9E+nzCZ;;A8EtozCQ;EAOI,wBAAA;A9EmozCZ;;A8E1ozCQ;EAOI,qBAAA;A9EuozCZ;;A8E9ozCQ;EAOI,yBAAA;A9E2ozCZ;;A8ElpzCQ;EAOI,2BAAA;A9E+ozCZ;;A8EtpzCQ;EAOI,4BAAA;A9EmpzCZ;;A8E1pzCQ;EAOI,2BAAA;A9EupzCZ;;A8E9pzCQ;EAOI,2BAAA;A9E2pzCZ;;A8ElqzCQ;EAOI,6BAAA;A9E+pzCZ;;A8EtqzCQ;EAOI,8BAAA;A9EmqzCZ;;A8E1qzCQ;EAOI,6BAAA;A9EuqzCZ;;A8E9qzCQ;EAOI,2BAAA;A9E2qzCZ;;A8ElrzCQ;EAOI,6BAAA;A9E+qzCZ;;A8EtrzCQ;EAOI,8BAAA;A9EmrzCZ;;A8E1rzCQ;EAOI,6BAAA;A9EurzCZ;;A8E9rzCQ;EAOI,0BAAA;A9E2rzCZ;;A8ElszCQ;EAOI,gCAAA;A9E+rzCZ;;A8EtszCQ;EAOI,yBAAA;A9EmszCZ;;A8E1szCQ;EAOI,wBAAA;A9EuszCZ;;A8E9szCQ;EAOI,+BAAA;A9E2szCZ;;A8EltzCQ;EAOI,yBAAA;A9E+szCZ;;A8EttzCQ;EAOI,6BAAA;A9EmtzCZ;;A8E1tzCQ;EAOI,8BAAA;A9EutzCZ;;A8E9tzCQ;EAOI,wBAAA;A9E2tzCZ;;A8EluzCQ;EAOI,+BAAA;A9E+tzCZ;;A8EtuzCQ;EAOI,wBAAA;A9EmuzCZ;;A8E1uzCQ;EAOI,2CAAA;A9EuuzCZ;;A8E9uzCQ;EAOI,8CAAA;A9E2uzCZ;;A8ElvzCQ;EAOI,8CAAA;A9E+uzCZ;;A8EtvzCQ;EAOI,2BAAA;A9EmvzCZ;;A8EpwzCQ;EACE,gFAAA;A9EuwzCV;;A8ExwzCQ;EACE,kFAAA;A9E2wzCV;;A8E5wzCQ;EACE,gFAAA;A9E+wzCV;;A8EhxzCQ;EACE,6EAAA;A9EmxzCV;;A8EpxzCQ;EACE,gFAAA;A9EuxzCV;;A8ExxzCQ;EACE,+EAAA;A9E2xzCV;;A8E5xzCQ;EACE,6EAAA;A9E+xzCV;;A8EhyzCQ;EACE,8EAAA;A9EmyzCV;;A8EpyzCQ;EACE,6EAAA;A9EuyzCV;;A8E9xzCQ;EAOI,2BAAA;A9E2xzCZ;;A8ElyzCQ;EAOI,6BAAA;A9E+xzCZ;;A8EtyzCQ;EAOI,6BAAA;A9EmyzCZ;;A8E1yzCQ;EAOI,0BAAA;A9EuyzCZ;;A8E9yzCQ;EAOI,2BAAA;A9E2yzCZ;;A8ElzzCQ;EAOI,iBAAA;A9E+yzCZ;;A8EtzzCQ;EAOI,mBAAA;A9EmzzCZ;;A8E1zzCQ;EAOI,oBAAA;A9EuzzCZ;;A8E9zzCQ;EAOI,oBAAA;A9E2zzCZ;;A8El0zCQ;EAOI,sBAAA;A9E+zzCZ;;A8Et0zCQ;EAOI,uBAAA;A9Em0zCZ;;A8E10zCQ;EAOI,kBAAA;A9Eu0zCZ;;A8E90zCQ;EAOI,oBAAA;A9E20zCZ;;A8El1zCQ;EAOI,qBAAA;A9E+0zCZ;;A8Et1zCQ;EAOI,mBAAA;A9Em1zCZ;;A8E11zCQ;EAOI,qBAAA;A9Eu1zCZ;;A8E91zCQ;EAOI,sBAAA;A9E21zCZ;;A8El2zCQ;EAOI,2CAAA;A9E+1zCZ;;A8Et2zCQ;EAOI,sCAAA;A9Em2zCZ;;A8E12zCQ;EAOI,sCAAA;A9Eu2zCZ;;A8E92zCQ;EAOI,uFAAA;A9E22zCZ;;A8El3zCQ;EAOI,oBAAA;A9E+2zCZ;;A8Et3zCQ;EAOI,2FAAA;A9Em3zCZ;;A8E13zCQ;EAOI,wBAAA;A9Eu3zCZ;;A8E93zCQ;EAOI,6FAAA;A9E23zCZ;;A8El4zCQ;EAOI,0BAAA;A9E+3zCZ;;A8Et4zCQ;EAOI,8FAAA;A9Em4zCZ;;A8E14zCQ;EAOI,2BAAA;A9Eu4zCZ;;A8E94zCQ;EAOI,4FAAA;A9E24zCZ;;A8El5zCQ;EAOI,yBAAA;A9E+4zCZ;;A8Et5zCQ;EAIQ,sBAAA;EAGJ,8EAAA;A9Eo5zCZ;;A8E35zCQ;EAIQ,sBAAA;EAGJ,gFAAA;A9Ey5zCZ;;A8Eh6zCQ;EAIQ,sBAAA;EAGJ,8EAAA;A9E85zCZ;;A8Er6zCQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Em6zCZ;;A8E16zCQ;EAIQ,sBAAA;EAGJ,8EAAA;A9Ew6zCZ;;A8E/6zCQ;EAIQ,sBAAA;EAGJ,6EAAA;A9E66zCZ;;A8Ep7zCQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Ek7zCZ;;A8Ez7zCQ;EAIQ,sBAAA;EAGJ,4EAAA;A9Eu7zCZ;;A8E97zCQ;EAIQ,sBAAA;EAGJ,2EAAA;A9E47zCZ;;A8En8zCQ;EAIQ,sBAAA;EAGJ,4EAAA;A9Ei8zCZ;;A8Ex8zCQ;EAIQ,sBAAA;EAGJ,4EAAA;A9Es8zCZ;;A8E78zCQ;EAOI,wDAAA;A9E08zCZ;;A8Ej9zCQ;EAOI,0DAAA;A9E88zCZ;;A8Er9zCQ;EAOI,wDAAA;A9Ek9zCZ;;A8Ez9zCQ;EAOI,qDAAA;A9Es9zCZ;;A8E79zCQ;EAOI,wDAAA;A9E09zCZ;;A8Ej+zCQ;EAOI,uDAAA;A9E89zCZ;;A8Er+zCQ;EAOI,sDAAA;A9Ek+zCZ;;A8Ez+zCQ;EAOI,qDAAA;A9Es+zCZ;;A8E7+zCQ;EAOI,0BAAA;A9E0+zCZ;;A8Ej/zCQ;EAOI,4BAAA;A9E8+zCZ;;A8Er/zCQ;EAOI,4BAAA;A9Ek/zCZ;;A8Ez/zCQ;EAOI,4BAAA;A9Es/zCZ;;A8E7/zCQ;EAOI,4BAAA;A9E0/zCZ;;A8Ejg0CQ;EAOI,4BAAA;A9E8/zCZ;;A8E/g0CQ;EACE,wBAAA;A9Ekh0CV;;A8Enh0CQ;EACE,yBAAA;A9Esh0CV;;A8Evh0CQ;EACE,wBAAA;A9E0h0CV;;A8E3h0CQ;EACE,yBAAA;A9E8h0CV;;A8E/h0CQ;EACE,sBAAA;A9Eki0CV;;A8Ezh0CQ;EAOI,qBAAA;A9Esh0CZ;;A8E7h0CQ;EAOI,qBAAA;A9E0h0CZ;;A8Eji0CQ;EAOI,qBAAA;A9E8h0CZ;;A8Eri0CQ;EAOI,sBAAA;A9Eki0CZ;;A8Ezi0CQ;EAOI,sBAAA;A9Esi0CZ;;A8E7i0CQ;EAOI,0BAAA;A9E0i0CZ;;A8Ejj0CQ;EAOI,uBAAA;A9E8i0CZ;;A8Erj0CQ;EAOI,2BAAA;A9Ekj0CZ;;A8Ezj0CQ;EAOI,sBAAA;A9Esj0CZ;;A8E7j0CQ;EAOI,sBAAA;A9E0j0CZ;;A8Ejk0CQ;EAOI,sBAAA;A9E8j0CZ;;A8Erk0CQ;EAOI,uBAAA;A9Ekk0CZ;;A8Ezk0CQ;EAOI,uBAAA;A9Esk0CZ;;A8E7k0CQ;EAOI,2BAAA;A9E0k0CZ;;A8Ejl0CQ;EAOI,wBAAA;A9E8k0CZ;;A8Erl0CQ;EAOI,4BAAA;A9Ekl0CZ;;A8Ezl0CQ;EAOI,yBAAA;A9Esl0CZ;;A8E7l0CQ;EAOI,8BAAA;A9E0l0CZ;;A8Ejm0CQ;EAOI,iCAAA;A9E8l0CZ;;A8Erm0CQ;EAOI,sCAAA;A9Ekm0CZ;;A8Ezm0CQ;EAOI,yCAAA;A9Esm0CZ;;A8E7m0CQ;EAOI,uBAAA;A9E0m0CZ;;A8Ejn0CQ;EAOI,uBAAA;A9E8m0CZ;;A8Ern0CQ;EAOI,yBAAA;A9Ekn0CZ;;A8Ezn0CQ;EAOI,yBAAA;A9Esn0CZ;;A8E7n0CQ;EAOI,0BAAA;A9E0n0CZ;;A8Ejo0CQ;EAOI,4BAAA;A9E8n0CZ;;A8Ero0CQ;EAOI,kCAAA;A9Eko0CZ;;A8Ezo0CQ;EAOI,sCAAA;A9Eso0CZ;;A8E7o0CQ;EAOI,oCAAA;A9E0o0CZ;;A8Ejp0CQ;EAOI,kCAAA;A9E8o0CZ;;A8Erp0CQ;EAOI,yCAAA;A9Ekp0CZ;;A8Ezp0CQ;EAOI,wCAAA;A9Esp0CZ;;A8E7p0CQ;EAOI,wCAAA;A9E0p0CZ;;A8Ejq0CQ;EAOI,kCAAA;A9E8p0CZ;;A8Erq0CQ;EAOI,gCAAA;A9Ekq0CZ;;A8Ezq0CQ;EAOI,8BAAA;A9Esq0CZ;;A8E7q0CQ;EAOI,gCAAA;A9E0q0CZ;;A8Ejr0CQ;EAOI,+BAAA;A9E8q0CZ;;A8Err0CQ;EAOI,oCAAA;A9Ekr0CZ;;A8Ezr0CQ;EAOI,kCAAA;A9Esr0CZ;;A8E7r0CQ;EAOI,gCAAA;A9E0r0CZ;;A8Ejs0CQ;EAOI,uCAAA;A9E8r0CZ;;A8Ers0CQ;EAOI,sCAAA;A9Eks0CZ;;A8Ezs0CQ;EAOI,iCAAA;A9Ess0CZ;;A8E7s0CQ;EAOI,2BAAA;A9E0s0CZ;;A8Ejt0CQ;EAOI,iCAAA;A9E8s0CZ;;A8Ert0CQ;EAOI,+BAAA;A9Ekt0CZ;;A8Ezt0CQ;EAOI,6BAAA;A9Est0CZ;;A8E7t0CQ;EAOI,+BAAA;A9E0t0CZ;;A8Eju0CQ;EAOI,8BAAA;A9E8t0CZ;;A8Eru0CQ;EAOI,oBAAA;A9Eku0CZ;;A8Ezu0CQ;EAOI,mBAAA;A9Esu0CZ;;A8E7u0CQ;EAOI,mBAAA;A9E0u0CZ;;A8Ejv0CQ;EAOI,mBAAA;A9E8u0CZ;;A8Erv0CQ;EAOI,mBAAA;A9Ekv0CZ;;A8Ezv0CQ;EAOI,mBAAA;A9Esv0CZ;;A8E7v0CQ;EAOI,mBAAA;A9E0v0CZ;;A8Ejw0CQ;EAOI,mBAAA;A9E8v0CZ;;A8Erw0CQ;EAOI,oBAAA;A9Ekw0CZ;;A8Ezw0CQ;EAOI,0BAAA;A9Esw0CZ;;A8E7w0CQ;EAOI,yBAAA;A9E0w0CZ;;A8Ejx0CQ;EAOI,uBAAA;A9E8w0CZ;;A8Erx0CQ;EAOI,yBAAA;A9Ekx0CZ;;A8Ezx0CQ;EAOI,uBAAA;A9Esx0CZ;;A8E7x0CQ;EAOI,uBAAA;A9E0x0CZ;;A8Ejy0CQ;EAOI,0BAAA;EAAA,yBAAA;A9E+x0CZ;;A8Ety0CQ;EAOI,gCAAA;EAAA,+BAAA;A9Eoy0CZ;;A8E3y0CQ;EAOI,+BAAA;EAAA,8BAAA;A9Eyy0CZ;;A8Ehz0CQ;EAOI,6BAAA;EAAA,4BAAA;A9E8y0CZ;;A8Erz0CQ;EAOI,+BAAA;EAAA,8BAAA;A9Emz0CZ;;A8E1z0CQ;EAOI,6BAAA;EAAA,4BAAA;A9Ewz0CZ;;A8E/z0CQ;EAOI,6BAAA;EAAA,4BAAA;A9E6z0CZ;;A8Ep00CQ;EAOI,wBAAA;EAAA,2BAAA;A9Ek00CZ;;A8Ez00CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eu00CZ;;A8E900CQ;EAOI,6BAAA;EAAA,gCAAA;A9E400CZ;;A8En10CQ;EAOI,2BAAA;EAAA,8BAAA;A9Ei10CZ;;A8Ex10CQ;EAOI,6BAAA;EAAA,gCAAA;A9Es10CZ;;A8E710CQ;EAOI,2BAAA;EAAA,8BAAA;A9E210CZ;;A8El20CQ;EAOI,2BAAA;EAAA,8BAAA;A9Eg20CZ;;A8Ev20CQ;EAOI,wBAAA;A9Eo20CZ;;A8E320CQ;EAOI,8BAAA;A9Ew20CZ;;A8E/20CQ;EAOI,6BAAA;A9E420CZ;;A8En30CQ;EAOI,2BAAA;A9Eg30CZ;;A8Ev30CQ;EAOI,6BAAA;A9Eo30CZ;;A8E330CQ;EAOI,2BAAA;A9Ew30CZ;;A8E/30CQ;EAOI,2BAAA;A9E430CZ;;A8En40CQ;EAOI,0BAAA;A9Eg40CZ;;A8Ev40CQ;EAOI,gCAAA;A9Eo40CZ;;A8E340CQ;EAOI,+BAAA;A9Ew40CZ;;A8E/40CQ;EAOI,6BAAA;A9E440CZ;;A8En50CQ;EAOI,+BAAA;A9Eg50CZ;;A8Ev50CQ;EAOI,6BAAA;A9Eo50CZ;;A8E350CQ;EAOI,6BAAA;A9Ew50CZ;;A8E/50CQ;EAOI,2BAAA;A9E450CZ;;A8En60CQ;EAOI,iCAAA;A9Eg60CZ;;A8Ev60CQ;EAOI,gCAAA;A9Eo60CZ;;A8E360CQ;EAOI,8BAAA;A9Ew60CZ;;A8E/60CQ;EAOI,gCAAA;A9E460CZ;;A8En70CQ;EAOI,8BAAA;A9Eg70CZ;;A8Ev70CQ;EAOI,8BAAA;A9Eo70CZ;;A8E370CQ;EAOI,yBAAA;A9Ew70CZ;;A8E/70CQ;EAOI,+BAAA;A9E470CZ;;A8En80CQ;EAOI,8BAAA;A9Eg80CZ;;A8Ev80CQ;EAOI,4BAAA;A9Eo80CZ;;A8E380CQ;EAOI,8BAAA;A9Ew80CZ;;A8E/80CQ;EAOI,4BAAA;A9E480CZ;;A8En90CQ;EAOI,4BAAA;A9Eg90CZ;;A8Ev90CQ;EAOI,2BAAA;A9Eo90CZ;;A8E390CQ;EAOI,0BAAA;A9Ew90CZ;;A8E/90CQ;EAOI,wBAAA;A9E490CZ;;A8En+0CQ;EAOI,0BAAA;A9Eg+0CZ;;A8Ev+0CQ;EAOI,wBAAA;A9Eo+0CZ;;A8E3+0CQ;EAOI,iCAAA;EAAA,gCAAA;A9Ey+0CZ;;A8Eh/0CQ;EAOI,gCAAA;EAAA,+BAAA;A9E8+0CZ;;A8Er/0CQ;EAOI,8BAAA;EAAA,6BAAA;A9Em/0CZ;;A8E1/0CQ;EAOI,gCAAA;EAAA,+BAAA;A9Ew/0CZ;;A8E//0CQ;EAOI,8BAAA;EAAA,6BAAA;A9E6/0CZ;;A8Epg1CQ;EAOI,+BAAA;EAAA,kCAAA;A9Ekg1CZ;;A8Ezg1CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eug1CZ;;A8E9g1CQ;EAOI,4BAAA;EAAA,+BAAA;A9E4g1CZ;;A8Enh1CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eih1CZ;;A8Exh1CQ;EAOI,4BAAA;EAAA,+BAAA;A9Esh1CZ;;A8E7h1CQ;EAOI,+BAAA;A9E0h1CZ;;A8Eji1CQ;EAOI,8BAAA;A9E8h1CZ;;A8Eri1CQ;EAOI,4BAAA;A9Eki1CZ;;A8Ezi1CQ;EAOI,8BAAA;A9Esi1CZ;;A8E7i1CQ;EAOI,4BAAA;A9E0i1CZ;;A8Ejj1CQ;EAOI,iCAAA;A9E8i1CZ;;A8Erj1CQ;EAOI,gCAAA;A9Ekj1CZ;;A8Ezj1CQ;EAOI,8BAAA;A9Esj1CZ;;A8E7j1CQ;EAOI,gCAAA;A9E0j1CZ;;A8Ejk1CQ;EAOI,8BAAA;A9E8j1CZ;;A8Erk1CQ;EAOI,kCAAA;A9Ekk1CZ;;A8Ezk1CQ;EAOI,iCAAA;A9Esk1CZ;;A8E7k1CQ;EAOI,+BAAA;A9E0k1CZ;;A8Ejl1CQ;EAOI,iCAAA;A9E8k1CZ;;A8Erl1CQ;EAOI,+BAAA;A9Ekl1CZ;;A8Ezl1CQ;EAOI,gCAAA;A9Esl1CZ;;A8E7l1CQ;EAOI,+BAAA;A9E0l1CZ;;A8Ejm1CQ;EAOI,6BAAA;A9E8l1CZ;;A8Erm1CQ;EAOI,+BAAA;A9Ekm1CZ;;A8Ezm1CQ;EAOI,6BAAA;A9Esm1CZ;;A8E7m1CQ;EAOI,qBAAA;A9E0m1CZ;;A8Ejn1CQ;EAOI,2BAAA;A9E8m1CZ;;A8Ern1CQ;EAOI,0BAAA;A9Ekn1CZ;;A8Ezn1CQ;EAOI,wBAAA;A9Esn1CZ;;A8E7n1CQ;EAOI,0BAAA;A9E0n1CZ;;A8Ejo1CQ;EAOI,wBAAA;A9E8n1CZ;;A8Ero1CQ;EAOI,2BAAA;EAAA,0BAAA;A9Emo1CZ;;A8E1o1CQ;EAOI,iCAAA;EAAA,gCAAA;A9Ewo1CZ;;A8E/o1CQ;EAOI,gCAAA;EAAA,+BAAA;A9E6o1CZ;;A8Epp1CQ;EAOI,8BAAA;EAAA,6BAAA;A9Ekp1CZ;;A8Ezp1CQ;EAOI,gCAAA;EAAA,+BAAA;A9Eup1CZ;;A8E9p1CQ;EAOI,8BAAA;EAAA,6BAAA;A9E4p1CZ;;A8Enq1CQ;EAOI,yBAAA;EAAA,4BAAA;A9Eiq1CZ;;A8Exq1CQ;EAOI,+BAAA;EAAA,kCAAA;A9Esq1CZ;;A8E7q1CQ;EAOI,8BAAA;EAAA,iCAAA;A9E2q1CZ;;A8Elr1CQ;EAOI,4BAAA;EAAA,+BAAA;A9Egr1CZ;;A8Evr1CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eqr1CZ;;A8E5r1CQ;EAOI,4BAAA;EAAA,+BAAA;A9E0r1CZ;;A8Ejs1CQ;EAOI,yBAAA;A9E8r1CZ;;A8Ers1CQ;EAOI,+BAAA;A9Eks1CZ;;A8Ezs1CQ;EAOI,8BAAA;A9Ess1CZ;;A8E7s1CQ;EAOI,4BAAA;A9E0s1CZ;;A8Ejt1CQ;EAOI,8BAAA;A9E8s1CZ;;A8Ert1CQ;EAOI,4BAAA;A9Ekt1CZ;;A8Ezt1CQ;EAOI,2BAAA;A9Est1CZ;;A8E7t1CQ;EAOI,iCAAA;A9E0t1CZ;;A8Eju1CQ;EAOI,gCAAA;A9E8t1CZ;;A8Eru1CQ;EAOI,8BAAA;A9Eku1CZ;;A8Ezu1CQ;EAOI,gCAAA;A9Esu1CZ;;A8E7u1CQ;EAOI,8BAAA;A9E0u1CZ;;A8Ejv1CQ;EAOI,4BAAA;A9E8u1CZ;;A8Erv1CQ;EAOI,kCAAA;A9Ekv1CZ;;A8Ezv1CQ;EAOI,iCAAA;A9Esv1CZ;;A8E7v1CQ;EAOI,+BAAA;A9E0v1CZ;;A8Ejw1CQ;EAOI,iCAAA;A9E8v1CZ;;A8Erw1CQ;EAOI,+BAAA;A9Ekw1CZ;;A8Ezw1CQ;EAOI,0BAAA;A9Esw1CZ;;A8E7w1CQ;EAOI,gCAAA;A9E0w1CZ;;A8Ejx1CQ;EAOI,+BAAA;A9E8w1CZ;;A8Erx1CQ;EAOI,6BAAA;A9Ekx1CZ;;A8Ezx1CQ;EAOI,+BAAA;A9Esx1CZ;;A8E7x1CQ;EAOI,6BAAA;A9E0x1CZ;;A8Ejy1CQ;EAOI,iBAAA;A9E8x1CZ;;A8Ery1CQ;EAOI,uBAAA;A9Eky1CZ;;A8Ezy1CQ;EAOI,sBAAA;A9Esy1CZ;;A8E7y1CQ;EAOI,oBAAA;A9E0y1CZ;;A8Ejz1CQ;EAOI,sBAAA;A9E8y1CZ;;A8Erz1CQ;EAOI,oBAAA;A9Ekz1CZ;;A8Ezz1CQ;EAOI,qBAAA;A9Esz1CZ;;A8E7z1CQ;EAOI,2BAAA;A9E0z1CZ;;A8Ej01CQ;EAOI,0BAAA;A9E8z1CZ;;A8Er01CQ;EAOI,wBAAA;A9Ek01CZ;;A8Ez01CQ;EAOI,0BAAA;A9Es01CZ;;A8E701CQ;EAOI,wBAAA;A9E001CZ;;A8Ej11CQ;EAOI,wBAAA;A9E801CZ;;A8Er11CQ;EAOI,8BAAA;A9Ek11CZ;;A8Ez11CQ;EAOI,6BAAA;A9Es11CZ;;A8E711CQ;EAOI,2BAAA;A9E011CZ;;A8Ej21CQ;EAOI,6BAAA;A9E811CZ;;A8Er21CQ;EAOI,2BAAA;A9Ek21CZ;;A8Ez21CQ;EAOI,gDAAA;A9Es21CZ;;A8E721CQ;EAOI,kDAAA;A9E021CZ;;A8Ej31CQ;EAOI,8CAAA;A9E821CZ;;A8Er31CQ;EAOI,oDAAA;A9Ek31CZ;;A8Ez31CQ;EAOI,gCAAA;A9Es31CZ;;A8E731CQ;EAOI,iCAAA;A9E031CZ;;A8Ej41CQ;EAOI,+BAAA;A9E831CZ;;A8Er41CQ;EAOI,6BAAA;A9Ek41CZ;;A8Ez41CQ;EAOI,6BAAA;A9Es41CZ;;A8E741CQ;EAOI,+BAAA;A9E041CZ;;A8Ej51CQ;EAOI,2BAAA;A9E841CZ;;A8Er51CQ;EAOI,2BAAA;A9Ek51CZ;;A8Ez51CQ;EAOI,2BAAA;A9Es51CZ;;A8E751CQ;EAOI,2BAAA;A9E051CZ;;A8Ej61CQ;EAOI,2BAAA;A9E851CZ;;A8Er61CQ;EAOI,8BAAA;A9Ek61CZ;;A8Ez61CQ;EAOI,yBAAA;A9Es61CZ;;A8E761CQ;EAOI,4BAAA;A9E061CZ;;A8Ej71CQ;EAOI,2BAAA;A9E861CZ;;A8Er71CQ;EAOI,yBAAA;A9Ek71CZ;;A8Ez71CQ;EAOI,2BAAA;A9Es71CZ;;A8E771CQ;EAOI,4BAAA;A9E071CZ;;A8Ej81CQ;EAOI,6BAAA;A9E871CZ;;A8Er81CQ;EAOI,gCAAA;A9Ek81CZ;;A8Ez81CQ;EAOI,qCAAA;A9Es81CZ;;A8E781CQ;EAOI,wCAAA;A9E081CZ;;A8Ej91CQ;EAOI,oCAAA;A9E881CZ;;A8Er91CQ;EAOI,oCAAA;A9Ek91CZ;;A8Ez91CQ;EAOI,qCAAA;A9Es91CZ;;A8E791CQ;EAOI,8BAAA;A9E091CZ;;A8Ej+1CQ;EAOI,8BAAA;A9E891CZ;;A8En/1CQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A9Eo+1CZ;;A8Ej91CQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A9E0+1CZ;;A8Ej/1CQ;EAIQ,oBAAA;EAGJ,uEAAA;A9E++1CZ;;A8Et/1CQ;EAIQ,oBAAA;EAGJ,qEAAA;A9Eo/1CZ;;A8E3/1CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9Ey/1CZ;;A8Ehg2CQ;EAIQ,oBAAA;EAGJ,qEAAA;A9E8/1CZ;;A8Erg2CQ;EAIQ,oBAAA;EAGJ,oEAAA;A9Emg2CZ;;A8E1g2CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9Ewg2CZ;;A8E/g2CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9E6g2CZ;;A8Eph2CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9Ekh2CZ;;A8Ezh2CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9Euh2CZ;;A8E9h2CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9E4h2CZ;;A8Eni2CQ;EAIQ,oBAAA;EAGJ,wEAAA;A9Eii2CZ;;A8Exi2CQ;EAIQ,oBAAA;EAGJ,2CAAA;A9Esi2CZ;;A8E7i2CQ;EAIQ,oBAAA;EAGJ,oCAAA;A9E2i2CZ;;A8Elj2CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Egj2CZ;;A8Evj2CQ;EAIQ,oBAAA;EAGJ,2CAAA;A9Eqj2CZ;;A8E5j2CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9E0j2CZ;;A8Ejk2CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9E+j2CZ;;A8Etk2CQ;EAIQ,oBAAA;EAGJ,yBAAA;A9Eok2CZ;;A8Erl2CQ;EACE,uBAAA;A9Ewl2CV;;A8Ezl2CQ;EACE,sBAAA;A9E4l2CV;;A8E7l2CQ;EACE,uBAAA;A9Egm2CV;;A8Ejm2CQ;EACE,oBAAA;A9Eom2CV;;A8E3l2CQ;EAOI,iDAAA;A9Ewl2CZ;;A8E/l2CQ;EAOI,mDAAA;A9E4l2CZ;;A8Enm2CQ;EAOI,iDAAA;A9Egm2CZ;;A8Evm2CQ;EAOI,8CAAA;A9Eom2CZ;;A8E3m2CQ;EAOI,iDAAA;A9Ewm2CZ;;A8E/m2CQ;EAOI,gDAAA;A9E4m2CZ;;A8Enn2CQ;EAOI,+CAAA;A9Egn2CZ;;A8Evn2CQ;EAOI,8CAAA;A9Eon2CZ;;A8Ero2CQ;EACE,sBAAA;A9Ewo2CV;;A8Epo2CU;EACE,sBAAA;A9Euo2CZ;;A8E7o2CQ;EACE,uBAAA;A9Egp2CV;;A8E5o2CU;EACE,uBAAA;A9E+o2CZ;;A8Erp2CQ;EACE,sBAAA;A9Ewp2CV;;A8Epp2CU;EACE,sBAAA;A9Eup2CZ;;A8E7p2CQ;EACE,uBAAA;A9Egq2CV;;A8E5p2CU;EACE,uBAAA;A9E+p2CZ;;A8Erq2CQ;EACE,oBAAA;A9Ewq2CV;;A8Epq2CU;EACE,oBAAA;A9Euq2CZ;;A8Enq2CQ;EAOI,yCAAA;A9Egq2CZ;;A8E3p2CU;EAOI,yCAAA;A9Ewp2Cd;;A8E3q2CQ;EAOI,wCAAA;A9Ewq2CZ;;A8Enq2CU;EAOI,wCAAA;A9Egq2Cd;;A8Enr2CQ;EAOI,yCAAA;A9Egr2CZ;;A8E3q2CU;EAOI,yCAAA;A9Ewq2Cd;;A8E3r2CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9Eyr2CZ;;A8Ehs2CQ;EAIQ,8BAAA;EAGJ,iGAAA;A9E8r2CZ;;A8Ers2CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9Ems2CZ;;A8E1s2CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Ews2CZ;;A8E/s2CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9E6s2CZ;;A8Ept2CQ;EAIQ,8BAAA;EAGJ,8FAAA;A9Ekt2CZ;;A8Ezt2CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Eut2CZ;;A8E9t2CQ;EAIQ,8BAAA;EAGJ,6FAAA;A9E4t2CZ;;A8Enu2CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Eiu2CZ;;A8Exu2CQ;EAIQ,8BAAA;EAGJ,qGAAA;A9Esu2CZ;;A8Evv2CQ;EACE,8BAAA;A9E0v2CV;;A8Etv2CU;EACE,8BAAA;A9Eyv2CZ;;A8E/v2CQ;EACE,gCAAA;A9Ekw2CV;;A8E9v2CU;EACE,gCAAA;A9Eiw2CZ;;A8Evw2CQ;EACE,iCAAA;A9E0w2CV;;A8Etw2CU;EACE,iCAAA;A9Eyw2CZ;;A8E/w2CQ;EACE,gCAAA;A9Ekx2CV;;A8E9w2CU;EACE,gCAAA;A9Eix2CZ;;A8Evx2CQ;EACE,iCAAA;A9E0x2CV;;A8Etx2CU;EACE,iCAAA;A9Eyx2CZ;;A8E/x2CQ;EACE,8BAAA;A9Eky2CV;;A8E9x2CU;EACE,8BAAA;A9Eiy2CZ;;A8E7x2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9E2x2CZ;;A8Ely2CQ;EAIQ,kBAAA;EAGJ,gFAAA;A9Egy2CZ;;A8Evy2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Eqy2CZ;;A8E5y2CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9E0y2CZ;;A8Ejz2CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9E+y2CZ;;A8Etz2CQ;EAIQ,kBAAA;EAGJ,6EAAA;A9Eoz2CZ;;A8E3z2CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9Eyz2CZ;;A8Eh02CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E8z2CZ;;A8Er02CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9Em02CZ;;A8E102CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9Ew02CZ;;A8E/02CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E602CZ;;A8Ep12CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Ek12CZ;;A8Ez12CQ;EAIQ,kBAAA;EAGJ,wCAAA;A9Eu12CZ;;A8E912CQ;EAIQ,kBAAA;EAGJ,mFAAA;A9E412CZ;;A8En22CQ;EAIQ,kBAAA;EAGJ,kFAAA;A9Ei22CZ;;A8El32CQ;EACE,oBAAA;A9Eq32CV;;A8Et32CQ;EACE,qBAAA;A9Ey32CV;;A8E132CQ;EACE,oBAAA;A9E632CV;;A8E932CQ;EACE,qBAAA;A9Ei42CV;;A8El42CQ;EACE,kBAAA;A9Eq42CV;;A8E532CQ;EAOI,wDAAA;A9Ey32CZ;;A8Eh42CQ;EAOI,0DAAA;A9E632CZ;;A8Ep42CQ;EAOI,wDAAA;A9Ei42CZ;;A8Ex42CQ;EAOI,qDAAA;A9Eq42CZ;;A8E542CQ;EAOI,wDAAA;A9Ey42CZ;;A8Eh52CQ;EAOI,uDAAA;A9E642CZ;;A8Ep52CQ;EAOI,sDAAA;A9Ei52CZ;;A8Ex52CQ;EAOI,qDAAA;A9Eq52CZ;;A8E552CQ;EAOI,+CAAA;A9Ey52CZ;;A8Eh62CQ;EAOI,mCAAA;UAAA,2BAAA;A9E652CZ;;A8Ep62CQ;EAOI,oCAAA;UAAA,4BAAA;A9Ei62CZ;;A8Ex62CQ;EAOI,oCAAA;UAAA,4BAAA;A9Eq62CZ;;A8E562CQ;EAOI,+BAAA;A9Ey62CZ;;A8Eh72CQ;EAOI,+BAAA;A9E662CZ;;A8Ep72CQ;EAOI,iDAAA;A9Ei72CZ;;A8Ex72CQ;EAOI,2BAAA;A9Eq72CZ;;A8E572CQ;EAOI,oDAAA;A9Ey72CZ;;A8Eh82CQ;EAOI,iDAAA;A9E672CZ;;A8Ep82CQ;EAOI,oDAAA;A9Ei82CZ;;A8Ex82CQ;EAOI,oDAAA;A9Eq82CZ;;A8E582CQ;EAOI,qDAAA;A9Ey82CZ;;A8Eh92CQ;EAOI,6BAAA;A9E682CZ;;A8Ep92CQ;EAOI,sDAAA;A9Ei92CZ;;A8Ex92CQ;EAOI,0DAAA;EAAA,2DAAA;A9Es92CZ;;A8E792CQ;EAOI,oCAAA;EAAA,qCAAA;A9E292CZ;;A8El+2CQ;EAOI,6DAAA;EAAA,8DAAA;A9Eg+2CZ;;A8Ev+2CQ;EAOI,0DAAA;EAAA,2DAAA;A9Eq+2CZ;;A8E5+2CQ;EAOI,6DAAA;EAAA,8DAAA;A9E0+2CZ;;A8Ej/2CQ;EAOI,6DAAA;EAAA,8DAAA;A9E++2CZ;;A8Et/2CQ;EAOI,8DAAA;EAAA,+DAAA;A9Eo/2CZ;;A8E3/2CQ;EAOI,sCAAA;EAAA,uCAAA;A9Ey/2CZ;;A8Ehg3CQ;EAOI,+DAAA;EAAA,gEAAA;A9E8/2CZ;;A8Erg3CQ;EAOI,2DAAA;EAAA,8DAAA;A9Emg3CZ;;A8E1g3CQ;EAOI,qCAAA;EAAA,wCAAA;A9Ewg3CZ;;A8E/g3CQ;EAOI,8DAAA;EAAA,iEAAA;A9E6g3CZ;;A8Eph3CQ;EAOI,2DAAA;EAAA,8DAAA;A9Ekh3CZ;;A8Ezh3CQ;EAOI,8DAAA;EAAA,iEAAA;A9Euh3CZ;;A8E9h3CQ;EAOI,8DAAA;EAAA,iEAAA;A9E4h3CZ;;A8Eni3CQ;EAOI,+DAAA;EAAA,kEAAA;A9Eii3CZ;;A8Exi3CQ;EAOI,uCAAA;EAAA,0CAAA;A9Esi3CZ;;A8E7i3CQ;EAOI,gEAAA;EAAA,mEAAA;A9E2i3CZ;;A8Elj3CQ;EAOI,8DAAA;EAAA,6DAAA;A9Egj3CZ;;A8Evj3CQ;EAOI,wCAAA;EAAA,uCAAA;A9Eqj3CZ;;A8E5j3CQ;EAOI,iEAAA;EAAA,gEAAA;A9E0j3CZ;;A8Ejk3CQ;EAOI,8DAAA;EAAA,6DAAA;A9E+j3CZ;;A8Etk3CQ;EAOI,iEAAA;EAAA,gEAAA;A9Eok3CZ;;A8E3k3CQ;EAOI,iEAAA;EAAA,gEAAA;A9Eyk3CZ;;A8Ehl3CQ;EAOI,kEAAA;EAAA,iEAAA;A9E8k3CZ;;A8Erl3CQ;EAOI,0CAAA;EAAA,yCAAA;A9Eml3CZ;;A8E1l3CQ;EAOI,mEAAA;EAAA,kEAAA;A9Ewl3CZ;;A8E/l3CQ;EAOI,6DAAA;EAAA,0DAAA;A9E6l3CZ;;A8Epm3CQ;EAOI,uCAAA;EAAA,oCAAA;A9Ekm3CZ;;A8Ezm3CQ;EAOI,gEAAA;EAAA,6DAAA;A9Eum3CZ;;A8E9m3CQ;EAOI,6DAAA;EAAA,0DAAA;A9E4m3CZ;;A8Enn3CQ;EAOI,gEAAA;EAAA,6DAAA;A9Ein3CZ;;A8Exn3CQ;EAOI,gEAAA;EAAA,6DAAA;A9Esn3CZ;;A8E7n3CQ;EAOI,iEAAA;EAAA,8DAAA;A9E2n3CZ;;A8Elo3CQ;EAOI,yCAAA;EAAA,sCAAA;A9Ego3CZ;;A8Evo3CQ;EAOI,kEAAA;EAAA,+DAAA;A9Eqo3CZ;;A8E5o3CQ;EAOI,8BAAA;A9Eyo3CZ;;A8Ehp3CQ;EAOI,6BAAA;A9E6o3CZ;;A8Epp3CQ;EAOI,sBAAA;A9Eip3CZ;;A8Exp3CQ;EAOI,qBAAA;A9Eqp3CZ;;A8E5p3CQ;EAOI,qBAAA;A9Eyp3CZ;;A8Ehq3CQ;EAOI,qBAAA;A9E6p3CZ;;A8Epq3CQ;EAOI,qBAAA;A9Eiq3CZ;;AoB3q3CI;E0DGI;IAOI,sBAAA;E9Esq3CV;E8E7q3CM;IAOI,uBAAA;E9Eyq3CV;E8Ehr3CM;IAOI,sBAAA;E9E4q3CV;E8Enr3CM;IAOI,8BAAA;E9E+q3CV;E8Etr3CM;IAOI,4BAAA;E9Ekr3CV;E8Ezr3CM;IAOI,2BAAA;E9Eqr3CV;E8E5r3CM;IAOI,iCAAA;E9Ewr3CV;E8E/r3CM;IAOI,2BAAA;E9E2r3CV;E8Els3CM;IAOI,0BAAA;E9E8r3CV;E8Ers3CM;IAOI,gCAAA;E9Eis3CV;E8Exs3CM;IAOI,yBAAA;E9Eos3CV;E8E3s3CM;IAOI,wBAAA;E9Eus3CV;E8E9s3CM;IAOI,+BAAA;E9E0s3CV;E8Ejt3CM;IAOI,yBAAA;E9E6s3CV;E8Ept3CM;IAOI,6BAAA;E9Egt3CV;E8Evt3CM;IAOI,8BAAA;E9Emt3CV;E8E1t3CM;IAOI,wBAAA;E9Est3CV;E8E7t3CM;IAOI,+BAAA;E9Eyt3CV;E8Ehu3CM;IAOI,wBAAA;E9E4t3CV;E8Enu3CM;IAOI,yBAAA;E9E+t3CV;E8Etu3CM;IAOI,8BAAA;E9Eku3CV;E8Ezu3CM;IAOI,iCAAA;E9Equ3CV;E8E5u3CM;IAOI,sCAAA;E9Ewu3CV;E8E/u3CM;IAOI,yCAAA;E9E2u3CV;E8Elv3CM;IAOI,uBAAA;E9E8u3CV;E8Erv3CM;IAOI,uBAAA;E9Eiv3CV;E8Exv3CM;IAOI,yBAAA;E9Eov3CV;E8E3v3CM;IAOI,yBAAA;E9Euv3CV;E8E9v3CM;IAOI,0BAAA;E9E0v3CV;E8Ejw3CM;IAOI,4BAAA;E9E6v3CV;E8Epw3CM;IAOI,kCAAA;E9Egw3CV;E8Evw3CM;IAOI,sCAAA;E9Emw3CV;E8E1w3CM;IAOI,oCAAA;E9Esw3CV;E8E7w3CM;IAOI,kCAAA;E9Eyw3CV;E8Ehx3CM;IAOI,yCAAA;E9E4w3CV;E8Enx3CM;IAOI,wCAAA;E9E+w3CV;E8Etx3CM;IAOI,wCAAA;E9Ekx3CV;E8Ezx3CM;IAOI,kCAAA;E9Eqx3CV;E8E5x3CM;IAOI,gCAAA;E9Ewx3CV;E8E/x3CM;IAOI,8BAAA;E9E2x3CV;E8Ely3CM;IAOI,gCAAA;E9E8x3CV;E8Ery3CM;IAOI,+BAAA;E9Eiy3CV;E8Exy3CM;IAOI,oCAAA;E9Eoy3CV;E8E3y3CM;IAOI,kCAAA;E9Euy3CV;E8E9y3CM;IAOI,gCAAA;E9E0y3CV;E8Ejz3CM;IAOI,uCAAA;E9E6y3CV;E8Epz3CM;IAOI,sCAAA;E9Egz3CV;E8Evz3CM;IAOI,iCAAA;E9Emz3CV;E8E1z3CM;IAOI,2BAAA;E9Esz3CV;E8E7z3CM;IAOI,iCAAA;E9Eyz3CV;E8Eh03CM;IAOI,+BAAA;E9E4z3CV;E8En03CM;IAOI,6BAAA;E9E+z3CV;E8Et03CM;IAOI,+BAAA;E9Ek03CV;E8Ez03CM;IAOI,8BAAA;E9Eq03CV;E8E503CM;IAOI,oBAAA;E9Ew03CV;E8E/03CM;IAOI,mBAAA;E9E203CV;E8El13CM;IAOI,mBAAA;E9E803CV;E8Er13CM;IAOI,mBAAA;E9Ei13CV;E8Ex13CM;IAOI,mBAAA;E9Eo13CV;E8E313CM;IAOI,mBAAA;E9Eu13CV;E8E913CM;IAOI,mBAAA;E9E013CV;E8Ej23CM;IAOI,mBAAA;E9E613CV;E8Ep23CM;IAOI,oBAAA;E9Eg23CV;E8Ev23CM;IAOI,0BAAA;E9Em23CV;E8E123CM;IAOI,yBAAA;E9Es23CV;E8E723CM;IAOI,uBAAA;E9Ey23CV;E8Eh33CM;IAOI,yBAAA;E9E423CV;E8En33CM;IAOI,uBAAA;E9E+23CV;E8Et33CM;IAOI,uBAAA;E9Ek33CV;E8Ez33CM;IAOI,0BAAA;IAAA,yBAAA;E9Es33CV;E8E733CM;IAOI,gCAAA;IAAA,+BAAA;E9E033CV;E8Ej43CM;IAOI,+BAAA;IAAA,8BAAA;E9E833CV;E8Er43CM;IAOI,6BAAA;IAAA,4BAAA;E9Ek43CV;E8Ez43CM;IAOI,+BAAA;IAAA,8BAAA;E9Es43CV;E8E743CM;IAOI,6BAAA;IAAA,4BAAA;E9E043CV;E8Ej53CM;IAOI,6BAAA;IAAA,4BAAA;E9E843CV;E8Er53CM;IAOI,wBAAA;IAAA,2BAAA;E9Ek53CV;E8Ez53CM;IAOI,8BAAA;IAAA,iCAAA;E9Es53CV;E8E753CM;IAOI,6BAAA;IAAA,gCAAA;E9E053CV;E8Ej63CM;IAOI,2BAAA;IAAA,8BAAA;E9E853CV;E8Er63CM;IAOI,6BAAA;IAAA,gCAAA;E9Ek63CV;E8Ez63CM;IAOI,2BAAA;IAAA,8BAAA;E9Es63CV;E8E763CM;IAOI,2BAAA;IAAA,8BAAA;E9E063CV;E8Ej73CM;IAOI,wBAAA;E9E663CV;E8Ep73CM;IAOI,8BAAA;E9Eg73CV;E8Ev73CM;IAOI,6BAAA;E9Em73CV;E8E173CM;IAOI,2BAAA;E9Es73CV;E8E773CM;IAOI,6BAAA;E9Ey73CV;E8Eh83CM;IAOI,2BAAA;E9E473CV;E8En83CM;IAOI,2BAAA;E9E+73CV;E8Et83CM;IAOI,0BAAA;E9Ek83CV;E8Ez83CM;IAOI,gCAAA;E9Eq83CV;E8E583CM;IAOI,+BAAA;E9Ew83CV;E8E/83CM;IAOI,6BAAA;E9E283CV;E8El93CM;IAOI,+BAAA;E9E883CV;E8Er93CM;IAOI,6BAAA;E9Ei93CV;E8Ex93CM;IAOI,6BAAA;E9Eo93CV;E8E393CM;IAOI,2BAAA;E9Eu93CV;E8E993CM;IAOI,iCAAA;E9E093CV;E8Ej+3CM;IAOI,gCAAA;E9E693CV;E8Ep+3CM;IAOI,8BAAA;E9Eg+3CV;E8Ev+3CM;IAOI,gCAAA;E9Em+3CV;E8E1+3CM;IAOI,8BAAA;E9Es+3CV;E8E7+3CM;IAOI,8BAAA;E9Ey+3CV;E8Eh/3CM;IAOI,yBAAA;E9E4+3CV;E8En/3CM;IAOI,+BAAA;E9E++3CV;E8Et/3CM;IAOI,8BAAA;E9Ek/3CV;E8Ez/3CM;IAOI,4BAAA;E9Eq/3CV;E8E5/3CM;IAOI,8BAAA;E9Ew/3CV;E8E//3CM;IAOI,4BAAA;E9E2/3CV;E8Elg4CM;IAOI,4BAAA;E9E8/3CV;E8Erg4CM;IAOI,2BAAA;E9Eig4CV;E8Exg4CM;IAOI,0BAAA;E9Eog4CV;E8E3g4CM;IAOI,wBAAA;E9Eug4CV;E8E9g4CM;IAOI,0BAAA;E9E0g4CV;E8Ejh4CM;IAOI,wBAAA;E9E6g4CV;E8Eph4CM;IAOI,iCAAA;IAAA,gCAAA;E9Eih4CV;E8Exh4CM;IAOI,gCAAA;IAAA,+BAAA;E9Eqh4CV;E8E5h4CM;IAOI,8BAAA;IAAA,6BAAA;E9Eyh4CV;E8Ehi4CM;IAOI,gCAAA;IAAA,+BAAA;E9E6h4CV;E8Epi4CM;IAOI,8BAAA;IAAA,6BAAA;E9Eii4CV;E8Exi4CM;IAOI,+BAAA;IAAA,kCAAA;E9Eqi4CV;E8E5i4CM;IAOI,8BAAA;IAAA,iCAAA;E9Eyi4CV;E8Ehj4CM;IAOI,4BAAA;IAAA,+BAAA;E9E6i4CV;E8Epj4CM;IAOI,8BAAA;IAAA,iCAAA;E9Eij4CV;E8Exj4CM;IAOI,4BAAA;IAAA,+BAAA;E9Eqj4CV;E8E5j4CM;IAOI,+BAAA;E9Ewj4CV;E8E/j4CM;IAOI,8BAAA;E9E2j4CV;E8Elk4CM;IAOI,4BAAA;E9E8j4CV;E8Erk4CM;IAOI,8BAAA;E9Eik4CV;E8Exk4CM;IAOI,4BAAA;E9Eok4CV;E8E3k4CM;IAOI,iCAAA;E9Euk4CV;E8E9k4CM;IAOI,gCAAA;E9E0k4CV;E8Ejl4CM;IAOI,8BAAA;E9E6k4CV;E8Epl4CM;IAOI,gCAAA;E9Egl4CV;E8Evl4CM;IAOI,8BAAA;E9Eml4CV;E8E1l4CM;IAOI,kCAAA;E9Esl4CV;E8E7l4CM;IAOI,iCAAA;E9Eyl4CV;E8Ehm4CM;IAOI,+BAAA;E9E4l4CV;E8Enm4CM;IAOI,iCAAA;E9E+l4CV;E8Etm4CM;IAOI,+BAAA;E9Ekm4CV;E8Ezm4CM;IAOI,gCAAA;E9Eqm4CV;E8E5m4CM;IAOI,+BAAA;E9Ewm4CV;E8E/m4CM;IAOI,6BAAA;E9E2m4CV;E8Eln4CM;IAOI,+BAAA;E9E8m4CV;E8Ern4CM;IAOI,6BAAA;E9Ein4CV;E8Exn4CM;IAOI,qBAAA;E9Eon4CV;E8E3n4CM;IAOI,2BAAA;E9Eun4CV;E8E9n4CM;IAOI,0BAAA;E9E0n4CV;E8Ejo4CM;IAOI,wBAAA;E9E6n4CV;E8Epo4CM;IAOI,0BAAA;E9Ego4CV;E8Evo4CM;IAOI,wBAAA;E9Emo4CV;E8E1o4CM;IAOI,2BAAA;IAAA,0BAAA;E9Euo4CV;E8E9o4CM;IAOI,iCAAA;IAAA,gCAAA;E9E2o4CV;E8Elp4CM;IAOI,gCAAA;IAAA,+BAAA;E9E+o4CV;E8Etp4CM;IAOI,8BAAA;IAAA,6BAAA;E9Emp4CV;E8E1p4CM;IAOI,gCAAA;IAAA,+BAAA;E9Eup4CV;E8E9p4CM;IAOI,8BAAA;IAAA,6BAAA;E9E2p4CV;E8Elq4CM;IAOI,yBAAA;IAAA,4BAAA;E9E+p4CV;E8Etq4CM;IAOI,+BAAA;IAAA,kCAAA;E9Emq4CV;E8E1q4CM;IAOI,8BAAA;IAAA,iCAAA;E9Euq4CV;E8E9q4CM;IAOI,4BAAA;IAAA,+BAAA;E9E2q4CV;E8Elr4CM;IAOI,8BAAA;IAAA,iCAAA;E9E+q4CV;E8Etr4CM;IAOI,4BAAA;IAAA,+BAAA;E9Emr4CV;E8E1r4CM;IAOI,yBAAA;E9Esr4CV;E8E7r4CM;IAOI,+BAAA;E9Eyr4CV;E8Ehs4CM;IAOI,8BAAA;E9E4r4CV;E8Ens4CM;IAOI,4BAAA;E9E+r4CV;E8Ets4CM;IAOI,8BAAA;E9Eks4CV;E8Ezs4CM;IAOI,4BAAA;E9Eqs4CV;E8E5s4CM;IAOI,2BAAA;E9Ews4CV;E8E/s4CM;IAOI,iCAAA;E9E2s4CV;E8Elt4CM;IAOI,gCAAA;E9E8s4CV;E8Ert4CM;IAOI,8BAAA;E9Eit4CV;E8Ext4CM;IAOI,gCAAA;E9Eot4CV;E8E3t4CM;IAOI,8BAAA;E9Eut4CV;E8E9t4CM;IAOI,4BAAA;E9E0t4CV;E8Eju4CM;IAOI,kCAAA;E9E6t4CV;E8Epu4CM;IAOI,iCAAA;E9Egu4CV;E8Evu4CM;IAOI,+BAAA;E9Emu4CV;E8E1u4CM;IAOI,iCAAA;E9Esu4CV;E8E7u4CM;IAOI,+BAAA;E9Eyu4CV;E8Ehv4CM;IAOI,0BAAA;E9E4u4CV;E8Env4CM;IAOI,gCAAA;E9E+u4CV;E8Etv4CM;IAOI,+BAAA;E9Ekv4CV;E8Ezv4CM;IAOI,6BAAA;E9Eqv4CV;E8E5v4CM;IAOI,+BAAA;E9Ewv4CV;E8E/v4CM;IAOI,6BAAA;E9E2v4CV;E8Elw4CM;IAOI,iBAAA;E9E8v4CV;E8Erw4CM;IAOI,uBAAA;E9Eiw4CV;E8Exw4CM;IAOI,sBAAA;E9Eow4CV;E8E3w4CM;IAOI,oBAAA;E9Euw4CV;E8E9w4CM;IAOI,sBAAA;E9E0w4CV;E8Ejx4CM;IAOI,oBAAA;E9E6w4CV;E8Epx4CM;IAOI,qBAAA;E9Egx4CV;E8Evx4CM;IAOI,2BAAA;E9Emx4CV;E8E1x4CM;IAOI,0BAAA;E9Esx4CV;E8E7x4CM;IAOI,wBAAA;E9Eyx4CV;E8Ehy4CM;IAOI,0BAAA;E9E4x4CV;E8Eny4CM;IAOI,wBAAA;E9E+x4CV;E8Ety4CM;IAOI,wBAAA;E9Eky4CV;E8Ezy4CM;IAOI,8BAAA;E9Eqy4CV;E8E5y4CM;IAOI,6BAAA;E9Ewy4CV;E8E/y4CM;IAOI,2BAAA;E9E2y4CV;E8Elz4CM;IAOI,6BAAA;E9E8y4CV;E8Erz4CM;IAOI,2BAAA;E9Eiz4CV;E8Exz4CM;IAOI,2BAAA;E9Eoz4CV;E8E3z4CM;IAOI,4BAAA;E9Euz4CV;E8E9z4CM;IAOI,6BAAA;E9E0z4CV;AACF;AoBr04CI;E0DGI;IAOI,sBAAA;E9E+z4CV;E8Et04CM;IAOI,uBAAA;E9Ek04CV;E8Ez04CM;IAOI,sBAAA;E9Eq04CV;E8E504CM;IAOI,8BAAA;E9Ew04CV;E8E/04CM;IAOI,4BAAA;E9E204CV;E8El14CM;IAOI,2BAAA;E9E804CV;E8Er14CM;IAOI,iCAAA;E9Ei14CV;E8Ex14CM;IAOI,2BAAA;E9Eo14CV;E8E314CM;IAOI,0BAAA;E9Eu14CV;E8E914CM;IAOI,gCAAA;E9E014CV;E8Ej24CM;IAOI,yBAAA;E9E614CV;E8Ep24CM;IAOI,wBAAA;E9Eg24CV;E8Ev24CM;IAOI,+BAAA;E9Em24CV;E8E124CM;IAOI,yBAAA;E9Es24CV;E8E724CM;IAOI,6BAAA;E9Ey24CV;E8Eh34CM;IAOI,8BAAA;E9E424CV;E8En34CM;IAOI,wBAAA;E9E+24CV;E8Et34CM;IAOI,+BAAA;E9Ek34CV;E8Ez34CM;IAOI,wBAAA;E9Eq34CV;E8E534CM;IAOI,yBAAA;E9Ew34CV;E8E/34CM;IAOI,8BAAA;E9E234CV;E8El44CM;IAOI,iCAAA;E9E834CV;E8Er44CM;IAOI,sCAAA;E9Ei44CV;E8Ex44CM;IAOI,yCAAA;E9Eo44CV;E8E344CM;IAOI,uBAAA;E9Eu44CV;E8E944CM;IAOI,uBAAA;E9E044CV;E8Ej54CM;IAOI,yBAAA;E9E644CV;E8Ep54CM;IAOI,yBAAA;E9Eg54CV;E8Ev54CM;IAOI,0BAAA;E9Em54CV;E8E154CM;IAOI,4BAAA;E9Es54CV;E8E754CM;IAOI,kCAAA;E9Ey54CV;E8Eh64CM;IAOI,sCAAA;E9E454CV;E8En64CM;IAOI,oCAAA;E9E+54CV;E8Et64CM;IAOI,kCAAA;E9Ek64CV;E8Ez64CM;IAOI,yCAAA;E9Eq64CV;E8E564CM;IAOI,wCAAA;E9Ew64CV;E8E/64CM;IAOI,wCAAA;E9E264CV;E8El74CM;IAOI,kCAAA;E9E864CV;E8Er74CM;IAOI,gCAAA;E9Ei74CV;E8Ex74CM;IAOI,8BAAA;E9Eo74CV;E8E374CM;IAOI,gCAAA;E9Eu74CV;E8E974CM;IAOI,+BAAA;E9E074CV;E8Ej84CM;IAOI,oCAAA;E9E674CV;E8Ep84CM;IAOI,kCAAA;E9Eg84CV;E8Ev84CM;IAOI,gCAAA;E9Em84CV;E8E184CM;IAOI,uCAAA;E9Es84CV;E8E784CM;IAOI,sCAAA;E9Ey84CV;E8Eh94CM;IAOI,iCAAA;E9E484CV;E8En94CM;IAOI,2BAAA;E9E+84CV;E8Et94CM;IAOI,iCAAA;E9Ek94CV;E8Ez94CM;IAOI,+BAAA;E9Eq94CV;E8E594CM;IAOI,6BAAA;E9Ew94CV;E8E/94CM;IAOI,+BAAA;E9E294CV;E8El+4CM;IAOI,8BAAA;E9E894CV;E8Er+4CM;IAOI,oBAAA;E9Ei+4CV;E8Ex+4CM;IAOI,mBAAA;E9Eo+4CV;E8E3+4CM;IAOI,mBAAA;E9Eu+4CV;E8E9+4CM;IAOI,mBAAA;E9E0+4CV;E8Ej/4CM;IAOI,mBAAA;E9E6+4CV;E8Ep/4CM;IAOI,mBAAA;E9Eg/4CV;E8Ev/4CM;IAOI,mBAAA;E9Em/4CV;E8E1/4CM;IAOI,mBAAA;E9Es/4CV;E8E7/4CM;IAOI,oBAAA;E9Ey/4CV;E8Ehg5CM;IAOI,0BAAA;E9E4/4CV;E8Eng5CM;IAOI,yBAAA;E9E+/4CV;E8Etg5CM;IAOI,uBAAA;E9Ekg5CV;E8Ezg5CM;IAOI,yBAAA;E9Eqg5CV;E8E5g5CM;IAOI,uBAAA;E9Ewg5CV;E8E/g5CM;IAOI,uBAAA;E9E2g5CV;E8Elh5CM;IAOI,0BAAA;IAAA,yBAAA;E9E+g5CV;E8Eth5CM;IAOI,gCAAA;IAAA,+BAAA;E9Emh5CV;E8E1h5CM;IAOI,+BAAA;IAAA,8BAAA;E9Euh5CV;E8E9h5CM;IAOI,6BAAA;IAAA,4BAAA;E9E2h5CV;E8Eli5CM;IAOI,+BAAA;IAAA,8BAAA;E9E+h5CV;E8Eti5CM;IAOI,6BAAA;IAAA,4BAAA;E9Emi5CV;E8E1i5CM;IAOI,6BAAA;IAAA,4BAAA;E9Eui5CV;E8E9i5CM;IAOI,wBAAA;IAAA,2BAAA;E9E2i5CV;E8Elj5CM;IAOI,8BAAA;IAAA,iCAAA;E9E+i5CV;E8Etj5CM;IAOI,6BAAA;IAAA,gCAAA;E9Emj5CV;E8E1j5CM;IAOI,2BAAA;IAAA,8BAAA;E9Euj5CV;E8E9j5CM;IAOI,6BAAA;IAAA,gCAAA;E9E2j5CV;E8Elk5CM;IAOI,2BAAA;IAAA,8BAAA;E9E+j5CV;E8Etk5CM;IAOI,2BAAA;IAAA,8BAAA;E9Emk5CV;E8E1k5CM;IAOI,wBAAA;E9Esk5CV;E8E7k5CM;IAOI,8BAAA;E9Eyk5CV;E8Ehl5CM;IAOI,6BAAA;E9E4k5CV;E8Enl5CM;IAOI,2BAAA;E9E+k5CV;E8Etl5CM;IAOI,6BAAA;E9Ekl5CV;E8Ezl5CM;IAOI,2BAAA;E9Eql5CV;E8E5l5CM;IAOI,2BAAA;E9Ewl5CV;E8E/l5CM;IAOI,0BAAA;E9E2l5CV;E8Elm5CM;IAOI,gCAAA;E9E8l5CV;E8Erm5CM;IAOI,+BAAA;E9Eim5CV;E8Exm5CM;IAOI,6BAAA;E9Eom5CV;E8E3m5CM;IAOI,+BAAA;E9Eum5CV;E8E9m5CM;IAOI,6BAAA;E9E0m5CV;E8Ejn5CM;IAOI,6BAAA;E9E6m5CV;E8Epn5CM;IAOI,2BAAA;E9Egn5CV;E8Evn5CM;IAOI,iCAAA;E9Emn5CV;E8E1n5CM;IAOI,gCAAA;E9Esn5CV;E8E7n5CM;IAOI,8BAAA;E9Eyn5CV;E8Eho5CM;IAOI,gCAAA;E9E4n5CV;E8Eno5CM;IAOI,8BAAA;E9E+n5CV;E8Eto5CM;IAOI,8BAAA;E9Eko5CV;E8Ezo5CM;IAOI,yBAAA;E9Eqo5CV;E8E5o5CM;IAOI,+BAAA;E9Ewo5CV;E8E/o5CM;IAOI,8BAAA;E9E2o5CV;E8Elp5CM;IAOI,4BAAA;E9E8o5CV;E8Erp5CM;IAOI,8BAAA;E9Eip5CV;E8Exp5CM;IAOI,4BAAA;E9Eop5CV;E8E3p5CM;IAOI,4BAAA;E9Eup5CV;E8E9p5CM;IAOI,2BAAA;E9E0p5CV;E8Ejq5CM;IAOI,0BAAA;E9E6p5CV;E8Epq5CM;IAOI,wBAAA;E9Egq5CV;E8Evq5CM;IAOI,0BAAA;E9Emq5CV;E8E1q5CM;IAOI,wBAAA;E9Esq5CV;E8E7q5CM;IAOI,iCAAA;IAAA,gCAAA;E9E0q5CV;E8Ejr5CM;IAOI,gCAAA;IAAA,+BAAA;E9E8q5CV;E8Err5CM;IAOI,8BAAA;IAAA,6BAAA;E9Ekr5CV;E8Ezr5CM;IAOI,gCAAA;IAAA,+BAAA;E9Esr5CV;E8E7r5CM;IAOI,8BAAA;IAAA,6BAAA;E9E0r5CV;E8Ejs5CM;IAOI,+BAAA;IAAA,kCAAA;E9E8r5CV;E8Ers5CM;IAOI,8BAAA;IAAA,iCAAA;E9Eks5CV;E8Ezs5CM;IAOI,4BAAA;IAAA,+BAAA;E9Ess5CV;E8E7s5CM;IAOI,8BAAA;IAAA,iCAAA;E9E0s5CV;E8Ejt5CM;IAOI,4BAAA;IAAA,+BAAA;E9E8s5CV;E8Ert5CM;IAOI,+BAAA;E9Eit5CV;E8Ext5CM;IAOI,8BAAA;E9Eot5CV;E8E3t5CM;IAOI,4BAAA;E9Eut5CV;E8E9t5CM;IAOI,8BAAA;E9E0t5CV;E8Eju5CM;IAOI,4BAAA;E9E6t5CV;E8Epu5CM;IAOI,iCAAA;E9Egu5CV;E8Evu5CM;IAOI,gCAAA;E9Emu5CV;E8E1u5CM;IAOI,8BAAA;E9Esu5CV;E8E7u5CM;IAOI,gCAAA;E9Eyu5CV;E8Ehv5CM;IAOI,8BAAA;E9E4u5CV;E8Env5CM;IAOI,kCAAA;E9E+u5CV;E8Etv5CM;IAOI,iCAAA;E9Ekv5CV;E8Ezv5CM;IAOI,+BAAA;E9Eqv5CV;E8E5v5CM;IAOI,iCAAA;E9Ewv5CV;E8E/v5CM;IAOI,+BAAA;E9E2v5CV;E8Elw5CM;IAOI,gCAAA;E9E8v5CV;E8Erw5CM;IAOI,+BAAA;E9Eiw5CV;E8Exw5CM;IAOI,6BAAA;E9Eow5CV;E8E3w5CM;IAOI,+BAAA;E9Euw5CV;E8E9w5CM;IAOI,6BAAA;E9E0w5CV;E8Ejx5CM;IAOI,qBAAA;E9E6w5CV;E8Epx5CM;IAOI,2BAAA;E9Egx5CV;E8Evx5CM;IAOI,0BAAA;E9Emx5CV;E8E1x5CM;IAOI,wBAAA;E9Esx5CV;E8E7x5CM;IAOI,0BAAA;E9Eyx5CV;E8Ehy5CM;IAOI,wBAAA;E9E4x5CV;E8Eny5CM;IAOI,2BAAA;IAAA,0BAAA;E9Egy5CV;E8Evy5CM;IAOI,iCAAA;IAAA,gCAAA;E9Eoy5CV;E8E3y5CM;IAOI,gCAAA;IAAA,+BAAA;E9Ewy5CV;E8E/y5CM;IAOI,8BAAA;IAAA,6BAAA;E9E4y5CV;E8Enz5CM;IAOI,gCAAA;IAAA,+BAAA;E9Egz5CV;E8Evz5CM;IAOI,8BAAA;IAAA,6BAAA;E9Eoz5CV;E8E3z5CM;IAOI,yBAAA;IAAA,4BAAA;E9Ewz5CV;E8E/z5CM;IAOI,+BAAA;IAAA,kCAAA;E9E4z5CV;E8En05CM;IAOI,8BAAA;IAAA,iCAAA;E9Eg05CV;E8Ev05CM;IAOI,4BAAA;IAAA,+BAAA;E9Eo05CV;E8E305CM;IAOI,8BAAA;IAAA,iCAAA;E9Ew05CV;E8E/05CM;IAOI,4BAAA;IAAA,+BAAA;E9E405CV;E8En15CM;IAOI,yBAAA;E9E+05CV;E8Et15CM;IAOI,+BAAA;E9Ek15CV;E8Ez15CM;IAOI,8BAAA;E9Eq15CV;E8E515CM;IAOI,4BAAA;E9Ew15CV;E8E/15CM;IAOI,8BAAA;E9E215CV;E8El25CM;IAOI,4BAAA;E9E815CV;E8Er25CM;IAOI,2BAAA;E9Ei25CV;E8Ex25CM;IAOI,iCAAA;E9Eo25CV;E8E325CM;IAOI,gCAAA;E9Eu25CV;E8E925CM;IAOI,8BAAA;E9E025CV;E8Ej35CM;IAOI,gCAAA;E9E625CV;E8Ep35CM;IAOI,8BAAA;E9Eg35CV;E8Ev35CM;IAOI,4BAAA;E9Em35CV;E8E135CM;IAOI,kCAAA;E9Es35CV;E8E735CM;IAOI,iCAAA;E9Ey35CV;E8Eh45CM;IAOI,+BAAA;E9E435CV;E8En45CM;IAOI,iCAAA;E9E+35CV;E8Et45CM;IAOI,+BAAA;E9Ek45CV;E8Ez45CM;IAOI,0BAAA;E9Eq45CV;E8E545CM;IAOI,gCAAA;E9Ew45CV;E8E/45CM;IAOI,+BAAA;E9E245CV;E8El55CM;IAOI,6BAAA;E9E845CV;E8Er55CM;IAOI,+BAAA;E9Ei55CV;E8Ex55CM;IAOI,6BAAA;E9Eo55CV;E8E355CM;IAOI,iBAAA;E9Eu55CV;E8E955CM;IAOI,uBAAA;E9E055CV;E8Ej65CM;IAOI,sBAAA;E9E655CV;E8Ep65CM;IAOI,oBAAA;E9Eg65CV;E8Ev65CM;IAOI,sBAAA;E9Em65CV;E8E165CM;IAOI,oBAAA;E9Es65CV;E8E765CM;IAOI,qBAAA;E9Ey65CV;E8Eh75CM;IAOI,2BAAA;E9E465CV;E8En75CM;IAOI,0BAAA;E9E+65CV;E8Et75CM;IAOI,wBAAA;E9Ek75CV;E8Ez75CM;IAOI,0BAAA;E9Eq75CV;E8E575CM;IAOI,wBAAA;E9Ew75CV;E8E/75CM;IAOI,wBAAA;E9E275CV;E8El85CM;IAOI,8BAAA;E9E875CV;E8Er85CM;IAOI,6BAAA;E9Ei85CV;E8Ex85CM;IAOI,2BAAA;E9Eo85CV;E8E385CM;IAOI,6BAAA;E9Eu85CV;E8E985CM;IAOI,2BAAA;E9E085CV;E8Ej95CM;IAOI,2BAAA;E9E685CV;E8Ep95CM;IAOI,4BAAA;E9Eg95CV;E8Ev95CM;IAOI,6BAAA;E9Em95CV;AACF;AoB995CI;E0DGI;IAOI,sBAAA;E9Ew95CV;E8E/95CM;IAOI,uBAAA;E9E295CV;E8El+5CM;IAOI,sBAAA;E9E895CV;E8Er+5CM;IAOI,8BAAA;E9Ei+5CV;E8Ex+5CM;IAOI,4BAAA;E9Eo+5CV;E8E3+5CM;IAOI,2BAAA;E9Eu+5CV;E8E9+5CM;IAOI,iCAAA;E9E0+5CV;E8Ej/5CM;IAOI,2BAAA;E9E6+5CV;E8Ep/5CM;IAOI,0BAAA;E9Eg/5CV;E8Ev/5CM;IAOI,gCAAA;E9Em/5CV;E8E1/5CM;IAOI,yBAAA;E9Es/5CV;E8E7/5CM;IAOI,wBAAA;E9Ey/5CV;E8Ehg6CM;IAOI,+BAAA;E9E4/5CV;E8Eng6CM;IAOI,yBAAA;E9E+/5CV;E8Etg6CM;IAOI,6BAAA;E9Ekg6CV;E8Ezg6CM;IAOI,8BAAA;E9Eqg6CV;E8E5g6CM;IAOI,wBAAA;E9Ewg6CV;E8E/g6CM;IAOI,+BAAA;E9E2g6CV;E8Elh6CM;IAOI,wBAAA;E9E8g6CV;E8Erh6CM;IAOI,yBAAA;E9Eih6CV;E8Exh6CM;IAOI,8BAAA;E9Eoh6CV;E8E3h6CM;IAOI,iCAAA;E9Euh6CV;E8E9h6CM;IAOI,sCAAA;E9E0h6CV;E8Eji6CM;IAOI,yCAAA;E9E6h6CV;E8Epi6CM;IAOI,uBAAA;E9Egi6CV;E8Evi6CM;IAOI,uBAAA;E9Emi6CV;E8E1i6CM;IAOI,yBAAA;E9Esi6CV;E8E7i6CM;IAOI,yBAAA;E9Eyi6CV;E8Ehj6CM;IAOI,0BAAA;E9E4i6CV;E8Enj6CM;IAOI,4BAAA;E9E+i6CV;E8Etj6CM;IAOI,kCAAA;E9Ekj6CV;E8Ezj6CM;IAOI,sCAAA;E9Eqj6CV;E8E5j6CM;IAOI,oCAAA;E9Ewj6CV;E8E/j6CM;IAOI,kCAAA;E9E2j6CV;E8Elk6CM;IAOI,yCAAA;E9E8j6CV;E8Erk6CM;IAOI,wCAAA;E9Eik6CV;E8Exk6CM;IAOI,wCAAA;E9Eok6CV;E8E3k6CM;IAOI,kCAAA;E9Euk6CV;E8E9k6CM;IAOI,gCAAA;E9E0k6CV;E8Ejl6CM;IAOI,8BAAA;E9E6k6CV;E8Epl6CM;IAOI,gCAAA;E9Egl6CV;E8Evl6CM;IAOI,+BAAA;E9Eml6CV;E8E1l6CM;IAOI,oCAAA;E9Esl6CV;E8E7l6CM;IAOI,kCAAA;E9Eyl6CV;E8Ehm6CM;IAOI,gCAAA;E9E4l6CV;E8Enm6CM;IAOI,uCAAA;E9E+l6CV;E8Etm6CM;IAOI,sCAAA;E9Ekm6CV;E8Ezm6CM;IAOI,iCAAA;E9Eqm6CV;E8E5m6CM;IAOI,2BAAA;E9Ewm6CV;E8E/m6CM;IAOI,iCAAA;E9E2m6CV;E8Eln6CM;IAOI,+BAAA;E9E8m6CV;E8Ern6CM;IAOI,6BAAA;E9Ein6CV;E8Exn6CM;IAOI,+BAAA;E9Eon6CV;E8E3n6CM;IAOI,8BAAA;E9Eun6CV;E8E9n6CM;IAOI,oBAAA;E9E0n6CV;E8Ejo6CM;IAOI,mBAAA;E9E6n6CV;E8Epo6CM;IAOI,mBAAA;E9Ego6CV;E8Evo6CM;IAOI,mBAAA;E9Emo6CV;E8E1o6CM;IAOI,mBAAA;E9Eso6CV;E8E7o6CM;IAOI,mBAAA;E9Eyo6CV;E8Ehp6CM;IAOI,mBAAA;E9E4o6CV;E8Enp6CM;IAOI,mBAAA;E9E+o6CV;E8Etp6CM;IAOI,oBAAA;E9Ekp6CV;E8Ezp6CM;IAOI,0BAAA;E9Eqp6CV;E8E5p6CM;IAOI,yBAAA;E9Ewp6CV;E8E/p6CM;IAOI,uBAAA;E9E2p6CV;E8Elq6CM;IAOI,yBAAA;E9E8p6CV;E8Erq6CM;IAOI,uBAAA;E9Eiq6CV;E8Exq6CM;IAOI,uBAAA;E9Eoq6CV;E8E3q6CM;IAOI,0BAAA;IAAA,yBAAA;E9Ewq6CV;E8E/q6CM;IAOI,gCAAA;IAAA,+BAAA;E9E4q6CV;E8Enr6CM;IAOI,+BAAA;IAAA,8BAAA;E9Egr6CV;E8Evr6CM;IAOI,6BAAA;IAAA,4BAAA;E9Eor6CV;E8E3r6CM;IAOI,+BAAA;IAAA,8BAAA;E9Ewr6CV;E8E/r6CM;IAOI,6BAAA;IAAA,4BAAA;E9E4r6CV;E8Ens6CM;IAOI,6BAAA;IAAA,4BAAA;E9Egs6CV;E8Evs6CM;IAOI,wBAAA;IAAA,2BAAA;E9Eos6CV;E8E3s6CM;IAOI,8BAAA;IAAA,iCAAA;E9Ews6CV;E8E/s6CM;IAOI,6BAAA;IAAA,gCAAA;E9E4s6CV;E8Ent6CM;IAOI,2BAAA;IAAA,8BAAA;E9Egt6CV;E8Evt6CM;IAOI,6BAAA;IAAA,gCAAA;E9Eot6CV;E8E3t6CM;IAOI,2BAAA;IAAA,8BAAA;E9Ewt6CV;E8E/t6CM;IAOI,2BAAA;IAAA,8BAAA;E9E4t6CV;E8Enu6CM;IAOI,wBAAA;E9E+t6CV;E8Etu6CM;IAOI,8BAAA;E9Eku6CV;E8Ezu6CM;IAOI,6BAAA;E9Equ6CV;E8E5u6CM;IAOI,2BAAA;E9Ewu6CV;E8E/u6CM;IAOI,6BAAA;E9E2u6CV;E8Elv6CM;IAOI,2BAAA;E9E8u6CV;E8Erv6CM;IAOI,2BAAA;E9Eiv6CV;E8Exv6CM;IAOI,0BAAA;E9Eov6CV;E8E3v6CM;IAOI,gCAAA;E9Euv6CV;E8E9v6CM;IAOI,+BAAA;E9E0v6CV;E8Ejw6CM;IAOI,6BAAA;E9E6v6CV;E8Epw6CM;IAOI,+BAAA;E9Egw6CV;E8Evw6CM;IAOI,6BAAA;E9Emw6CV;E8E1w6CM;IAOI,6BAAA;E9Esw6CV;E8E7w6CM;IAOI,2BAAA;E9Eyw6CV;E8Ehx6CM;IAOI,iCAAA;E9E4w6CV;E8Enx6CM;IAOI,gCAAA;E9E+w6CV;E8Etx6CM;IAOI,8BAAA;E9Ekx6CV;E8Ezx6CM;IAOI,gCAAA;E9Eqx6CV;E8E5x6CM;IAOI,8BAAA;E9Ewx6CV;E8E/x6CM;IAOI,8BAAA;E9E2x6CV;E8Ely6CM;IAOI,yBAAA;E9E8x6CV;E8Ery6CM;IAOI,+BAAA;E9Eiy6CV;E8Exy6CM;IAOI,8BAAA;E9Eoy6CV;E8E3y6CM;IAOI,4BAAA;E9Euy6CV;E8E9y6CM;IAOI,8BAAA;E9E0y6CV;E8Ejz6CM;IAOI,4BAAA;E9E6y6CV;E8Epz6CM;IAOI,4BAAA;E9Egz6CV;E8Evz6CM;IAOI,2BAAA;E9Emz6CV;E8E1z6CM;IAOI,0BAAA;E9Esz6CV;E8E7z6CM;IAOI,wBAAA;E9Eyz6CV;E8Eh06CM;IAOI,0BAAA;E9E4z6CV;E8En06CM;IAOI,wBAAA;E9E+z6CV;E8Et06CM;IAOI,iCAAA;IAAA,gCAAA;E9Em06CV;E8E106CM;IAOI,gCAAA;IAAA,+BAAA;E9Eu06CV;E8E906CM;IAOI,8BAAA;IAAA,6BAAA;E9E206CV;E8El16CM;IAOI,gCAAA;IAAA,+BAAA;E9E+06CV;E8Et16CM;IAOI,8BAAA;IAAA,6BAAA;E9Em16CV;E8E116CM;IAOI,+BAAA;IAAA,kCAAA;E9Eu16CV;E8E916CM;IAOI,8BAAA;IAAA,iCAAA;E9E216CV;E8El26CM;IAOI,4BAAA;IAAA,+BAAA;E9E+16CV;E8Et26CM;IAOI,8BAAA;IAAA,iCAAA;E9Em26CV;E8E126CM;IAOI,4BAAA;IAAA,+BAAA;E9Eu26CV;E8E926CM;IAOI,+BAAA;E9E026CV;E8Ej36CM;IAOI,8BAAA;E9E626CV;E8Ep36CM;IAOI,4BAAA;E9Eg36CV;E8Ev36CM;IAOI,8BAAA;E9Em36CV;E8E136CM;IAOI,4BAAA;E9Es36CV;E8E736CM;IAOI,iCAAA;E9Ey36CV;E8Eh46CM;IAOI,gCAAA;E9E436CV;E8En46CM;IAOI,8BAAA;E9E+36CV;E8Et46CM;IAOI,gCAAA;E9Ek46CV;E8Ez46CM;IAOI,8BAAA;E9Eq46CV;E8E546CM;IAOI,kCAAA;E9Ew46CV;E8E/46CM;IAOI,iCAAA;E9E246CV;E8El56CM;IAOI,+BAAA;E9E846CV;E8Er56CM;IAOI,iCAAA;E9Ei56CV;E8Ex56CM;IAOI,+BAAA;E9Eo56CV;E8E356CM;IAOI,gCAAA;E9Eu56CV;E8E956CM;IAOI,+BAAA;E9E056CV;E8Ej66CM;IAOI,6BAAA;E9E656CV;E8Ep66CM;IAOI,+BAAA;E9Eg66CV;E8Ev66CM;IAOI,6BAAA;E9Em66CV;E8E166CM;IAOI,qBAAA;E9Es66CV;E8E766CM;IAOI,2BAAA;E9Ey66CV;E8Eh76CM;IAOI,0BAAA;E9E466CV;E8En76CM;IAOI,wBAAA;E9E+66CV;E8Et76CM;IAOI,0BAAA;E9Ek76CV;E8Ez76CM;IAOI,wBAAA;E9Eq76CV;E8E576CM;IAOI,2BAAA;IAAA,0BAAA;E9Ey76CV;E8Eh86CM;IAOI,iCAAA;IAAA,gCAAA;E9E676CV;E8Ep86CM;IAOI,gCAAA;IAAA,+BAAA;E9Ei86CV;E8Ex86CM;IAOI,8BAAA;IAAA,6BAAA;E9Eq86CV;E8E586CM;IAOI,gCAAA;IAAA,+BAAA;E9Ey86CV;E8Eh96CM;IAOI,8BAAA;IAAA,6BAAA;E9E686CV;E8Ep96CM;IAOI,yBAAA;IAAA,4BAAA;E9Ei96CV;E8Ex96CM;IAOI,+BAAA;IAAA,kCAAA;E9Eq96CV;E8E596CM;IAOI,8BAAA;IAAA,iCAAA;E9Ey96CV;E8Eh+6CM;IAOI,4BAAA;IAAA,+BAAA;E9E696CV;E8Ep+6CM;IAOI,8BAAA;IAAA,iCAAA;E9Ei+6CV;E8Ex+6CM;IAOI,4BAAA;IAAA,+BAAA;E9Eq+6CV;E8E5+6CM;IAOI,yBAAA;E9Ew+6CV;E8E/+6CM;IAOI,+BAAA;E9E2+6CV;E8El/6CM;IAOI,8BAAA;E9E8+6CV;E8Er/6CM;IAOI,4BAAA;E9Ei/6CV;E8Ex/6CM;IAOI,8BAAA;E9Eo/6CV;E8E3/6CM;IAOI,4BAAA;E9Eu/6CV;E8E9/6CM;IAOI,2BAAA;E9E0/6CV;E8Ejg7CM;IAOI,iCAAA;E9E6/6CV;E8Epg7CM;IAOI,gCAAA;E9Egg7CV;E8Evg7CM;IAOI,8BAAA;E9Emg7CV;E8E1g7CM;IAOI,gCAAA;E9Esg7CV;E8E7g7CM;IAOI,8BAAA;E9Eyg7CV;E8Ehh7CM;IAOI,4BAAA;E9E4g7CV;E8Enh7CM;IAOI,kCAAA;E9E+g7CV;E8Eth7CM;IAOI,iCAAA;E9Ekh7CV;E8Ezh7CM;IAOI,+BAAA;E9Eqh7CV;E8E5h7CM;IAOI,iCAAA;E9Ewh7CV;E8E/h7CM;IAOI,+BAAA;E9E2h7CV;E8Eli7CM;IAOI,0BAAA;E9E8h7CV;E8Eri7CM;IAOI,gCAAA;E9Eii7CV;E8Exi7CM;IAOI,+BAAA;E9Eoi7CV;E8E3i7CM;IAOI,6BAAA;E9Eui7CV;E8E9i7CM;IAOI,+BAAA;E9E0i7CV;E8Ejj7CM;IAOI,6BAAA;E9E6i7CV;E8Epj7CM;IAOI,iBAAA;E9Egj7CV;E8Evj7CM;IAOI,uBAAA;E9Emj7CV;E8E1j7CM;IAOI,sBAAA;E9Esj7CV;E8E7j7CM;IAOI,oBAAA;E9Eyj7CV;E8Ehk7CM;IAOI,sBAAA;E9E4j7CV;E8Enk7CM;IAOI,oBAAA;E9E+j7CV;E8Etk7CM;IAOI,qBAAA;E9Ekk7CV;E8Ezk7CM;IAOI,2BAAA;E9Eqk7CV;E8E5k7CM;IAOI,0BAAA;E9Ewk7CV;E8E/k7CM;IAOI,wBAAA;E9E2k7CV;E8Ell7CM;IAOI,0BAAA;E9E8k7CV;E8Erl7CM;IAOI,wBAAA;E9Eil7CV;E8Exl7CM;IAOI,wBAAA;E9Eol7CV;E8E3l7CM;IAOI,8BAAA;E9Eul7CV;E8E9l7CM;IAOI,6BAAA;E9E0l7CV;E8Ejm7CM;IAOI,2BAAA;E9E6l7CV;E8Epm7CM;IAOI,6BAAA;E9Egm7CV;E8Evm7CM;IAOI,2BAAA;E9Emm7CV;E8E1m7CM;IAOI,2BAAA;E9Esm7CV;E8E7m7CM;IAOI,4BAAA;E9Eym7CV;E8Ehn7CM;IAOI,6BAAA;E9E4m7CV;AACF;AoBvn7CI;E0DGI;IAOI,sBAAA;E9Ein7CV;E8Exn7CM;IAOI,uBAAA;E9Eon7CV;E8E3n7CM;IAOI,sBAAA;E9Eun7CV;E8E9n7CM;IAOI,8BAAA;E9E0n7CV;E8Ejo7CM;IAOI,4BAAA;E9E6n7CV;E8Epo7CM;IAOI,2BAAA;E9Ego7CV;E8Evo7CM;IAOI,iCAAA;E9Emo7CV;E8E1o7CM;IAOI,2BAAA;E9Eso7CV;E8E7o7CM;IAOI,0BAAA;E9Eyo7CV;E8Ehp7CM;IAOI,gCAAA;E9E4o7CV;E8Enp7CM;IAOI,yBAAA;E9E+o7CV;E8Etp7CM;IAOI,wBAAA;E9Ekp7CV;E8Ezp7CM;IAOI,+BAAA;E9Eqp7CV;E8E5p7CM;IAOI,yBAAA;E9Ewp7CV;E8E/p7CM;IAOI,6BAAA;E9E2p7CV;E8Elq7CM;IAOI,8BAAA;E9E8p7CV;E8Erq7CM;IAOI,wBAAA;E9Eiq7CV;E8Exq7CM;IAOI,+BAAA;E9Eoq7CV;E8E3q7CM;IAOI,wBAAA;E9Euq7CV;E8E9q7CM;IAOI,yBAAA;E9E0q7CV;E8Ejr7CM;IAOI,8BAAA;E9E6q7CV;E8Epr7CM;IAOI,iCAAA;E9Egr7CV;E8Evr7CM;IAOI,sCAAA;E9Emr7CV;E8E1r7CM;IAOI,yCAAA;E9Esr7CV;E8E7r7CM;IAOI,uBAAA;E9Eyr7CV;E8Ehs7CM;IAOI,uBAAA;E9E4r7CV;E8Ens7CM;IAOI,yBAAA;E9E+r7CV;E8Ets7CM;IAOI,yBAAA;E9Eks7CV;E8Ezs7CM;IAOI,0BAAA;E9Eqs7CV;E8E5s7CM;IAOI,4BAAA;E9Ews7CV;E8E/s7CM;IAOI,kCAAA;E9E2s7CV;E8Elt7CM;IAOI,sCAAA;E9E8s7CV;E8Ert7CM;IAOI,oCAAA;E9Eit7CV;E8Ext7CM;IAOI,kCAAA;E9Eot7CV;E8E3t7CM;IAOI,yCAAA;E9Eut7CV;E8E9t7CM;IAOI,wCAAA;E9E0t7CV;E8Eju7CM;IAOI,wCAAA;E9E6t7CV;E8Epu7CM;IAOI,kCAAA;E9Egu7CV;E8Evu7CM;IAOI,gCAAA;E9Emu7CV;E8E1u7CM;IAOI,8BAAA;E9Esu7CV;E8E7u7CM;IAOI,gCAAA;E9Eyu7CV;E8Ehv7CM;IAOI,+BAAA;E9E4u7CV;E8Env7CM;IAOI,oCAAA;E9E+u7CV;E8Etv7CM;IAOI,kCAAA;E9Ekv7CV;E8Ezv7CM;IAOI,gCAAA;E9Eqv7CV;E8E5v7CM;IAOI,uCAAA;E9Ewv7CV;E8E/v7CM;IAOI,sCAAA;E9E2v7CV;E8Elw7CM;IAOI,iCAAA;E9E8v7CV;E8Erw7CM;IAOI,2BAAA;E9Eiw7CV;E8Exw7CM;IAOI,iCAAA;E9Eow7CV;E8E3w7CM;IAOI,+BAAA;E9Euw7CV;E8E9w7CM;IAOI,6BAAA;E9E0w7CV;E8Ejx7CM;IAOI,+BAAA;E9E6w7CV;E8Epx7CM;IAOI,8BAAA;E9Egx7CV;E8Evx7CM;IAOI,oBAAA;E9Emx7CV;E8E1x7CM;IAOI,mBAAA;E9Esx7CV;E8E7x7CM;IAOI,mBAAA;E9Eyx7CV;E8Ehy7CM;IAOI,mBAAA;E9E4x7CV;E8Eny7CM;IAOI,mBAAA;E9E+x7CV;E8Ety7CM;IAOI,mBAAA;E9Eky7CV;E8Ezy7CM;IAOI,mBAAA;E9Eqy7CV;E8E5y7CM;IAOI,mBAAA;E9Ewy7CV;E8E/y7CM;IAOI,oBAAA;E9E2y7CV;E8Elz7CM;IAOI,0BAAA;E9E8y7CV;E8Erz7CM;IAOI,yBAAA;E9Eiz7CV;E8Exz7CM;IAOI,uBAAA;E9Eoz7CV;E8E3z7CM;IAOI,yBAAA;E9Euz7CV;E8E9z7CM;IAOI,uBAAA;E9E0z7CV;E8Ej07CM;IAOI,uBAAA;E9E6z7CV;E8Ep07CM;IAOI,0BAAA;IAAA,yBAAA;E9Ei07CV;E8Ex07CM;IAOI,gCAAA;IAAA,+BAAA;E9Eq07CV;E8E507CM;IAOI,+BAAA;IAAA,8BAAA;E9Ey07CV;E8Eh17CM;IAOI,6BAAA;IAAA,4BAAA;E9E607CV;E8Ep17CM;IAOI,+BAAA;IAAA,8BAAA;E9Ei17CV;E8Ex17CM;IAOI,6BAAA;IAAA,4BAAA;E9Eq17CV;E8E517CM;IAOI,6BAAA;IAAA,4BAAA;E9Ey17CV;E8Eh27CM;IAOI,wBAAA;IAAA,2BAAA;E9E617CV;E8Ep27CM;IAOI,8BAAA;IAAA,iCAAA;E9Ei27CV;E8Ex27CM;IAOI,6BAAA;IAAA,gCAAA;E9Eq27CV;E8E527CM;IAOI,2BAAA;IAAA,8BAAA;E9Ey27CV;E8Eh37CM;IAOI,6BAAA;IAAA,gCAAA;E9E627CV;E8Ep37CM;IAOI,2BAAA;IAAA,8BAAA;E9Ei37CV;E8Ex37CM;IAOI,2BAAA;IAAA,8BAAA;E9Eq37CV;E8E537CM;IAOI,wBAAA;E9Ew37CV;E8E/37CM;IAOI,8BAAA;E9E237CV;E8El47CM;IAOI,6BAAA;E9E837CV;E8Er47CM;IAOI,2BAAA;E9Ei47CV;E8Ex47CM;IAOI,6BAAA;E9Eo47CV;E8E347CM;IAOI,2BAAA;E9Eu47CV;E8E947CM;IAOI,2BAAA;E9E047CV;E8Ej57CM;IAOI,0BAAA;E9E647CV;E8Ep57CM;IAOI,gCAAA;E9Eg57CV;E8Ev57CM;IAOI,+BAAA;E9Em57CV;E8E157CM;IAOI,6BAAA;E9Es57CV;E8E757CM;IAOI,+BAAA;E9Ey57CV;E8Eh67CM;IAOI,6BAAA;E9E457CV;E8En67CM;IAOI,6BAAA;E9E+57CV;E8Et67CM;IAOI,2BAAA;E9Ek67CV;E8Ez67CM;IAOI,iCAAA;E9Eq67CV;E8E567CM;IAOI,gCAAA;E9Ew67CV;E8E/67CM;IAOI,8BAAA;E9E267CV;E8El77CM;IAOI,gCAAA;E9E867CV;E8Er77CM;IAOI,8BAAA;E9Ei77CV;E8Ex77CM;IAOI,8BAAA;E9Eo77CV;E8E377CM;IAOI,yBAAA;E9Eu77CV;E8E977CM;IAOI,+BAAA;E9E077CV;E8Ej87CM;IAOI,8BAAA;E9E677CV;E8Ep87CM;IAOI,4BAAA;E9Eg87CV;E8Ev87CM;IAOI,8BAAA;E9Em87CV;E8E187CM;IAOI,4BAAA;E9Es87CV;E8E787CM;IAOI,4BAAA;E9Ey87CV;E8Eh97CM;IAOI,2BAAA;E9E487CV;E8En97CM;IAOI,0BAAA;E9E+87CV;E8Et97CM;IAOI,wBAAA;E9Ek97CV;E8Ez97CM;IAOI,0BAAA;E9Eq97CV;E8E597CM;IAOI,wBAAA;E9Ew97CV;E8E/97CM;IAOI,iCAAA;IAAA,gCAAA;E9E497CV;E8En+7CM;IAOI,gCAAA;IAAA,+BAAA;E9Eg+7CV;E8Ev+7CM;IAOI,8BAAA;IAAA,6BAAA;E9Eo+7CV;E8E3+7CM;IAOI,gCAAA;IAAA,+BAAA;E9Ew+7CV;E8E/+7CM;IAOI,8BAAA;IAAA,6BAAA;E9E4+7CV;E8En/7CM;IAOI,+BAAA;IAAA,kCAAA;E9Eg/7CV;E8Ev/7CM;IAOI,8BAAA;IAAA,iCAAA;E9Eo/7CV;E8E3/7CM;IAOI,4BAAA;IAAA,+BAAA;E9Ew/7CV;E8E//7CM;IAOI,8BAAA;IAAA,iCAAA;E9E4/7CV;E8Eng8CM;IAOI,4BAAA;IAAA,+BAAA;E9Egg8CV;E8Evg8CM;IAOI,+BAAA;E9Emg8CV;E8E1g8CM;IAOI,8BAAA;E9Esg8CV;E8E7g8CM;IAOI,4BAAA;E9Eyg8CV;E8Ehh8CM;IAOI,8BAAA;E9E4g8CV;E8Enh8CM;IAOI,4BAAA;E9E+g8CV;E8Eth8CM;IAOI,iCAAA;E9Ekh8CV;E8Ezh8CM;IAOI,gCAAA;E9Eqh8CV;E8E5h8CM;IAOI,8BAAA;E9Ewh8CV;E8E/h8CM;IAOI,gCAAA;E9E2h8CV;E8Eli8CM;IAOI,8BAAA;E9E8h8CV;E8Eri8CM;IAOI,kCAAA;E9Eii8CV;E8Exi8CM;IAOI,iCAAA;E9Eoi8CV;E8E3i8CM;IAOI,+BAAA;E9Eui8CV;E8E9i8CM;IAOI,iCAAA;E9E0i8CV;E8Ejj8CM;IAOI,+BAAA;E9E6i8CV;E8Epj8CM;IAOI,gCAAA;E9Egj8CV;E8Evj8CM;IAOI,+BAAA;E9Emj8CV;E8E1j8CM;IAOI,6BAAA;E9Esj8CV;E8E7j8CM;IAOI,+BAAA;E9Eyj8CV;E8Ehk8CM;IAOI,6BAAA;E9E4j8CV;E8Enk8CM;IAOI,qBAAA;E9E+j8CV;E8Etk8CM;IAOI,2BAAA;E9Ekk8CV;E8Ezk8CM;IAOI,0BAAA;E9Eqk8CV;E8E5k8CM;IAOI,wBAAA;E9Ewk8CV;E8E/k8CM;IAOI,0BAAA;E9E2k8CV;E8Ell8CM;IAOI,wBAAA;E9E8k8CV;E8Erl8CM;IAOI,2BAAA;IAAA,0BAAA;E9Ekl8CV;E8Ezl8CM;IAOI,iCAAA;IAAA,gCAAA;E9Esl8CV;E8E7l8CM;IAOI,gCAAA;IAAA,+BAAA;E9E0l8CV;E8Ejm8CM;IAOI,8BAAA;IAAA,6BAAA;E9E8l8CV;E8Erm8CM;IAOI,gCAAA;IAAA,+BAAA;E9Ekm8CV;E8Ezm8CM;IAOI,8BAAA;IAAA,6BAAA;E9Esm8CV;E8E7m8CM;IAOI,yBAAA;IAAA,4BAAA;E9E0m8CV;E8Ejn8CM;IAOI,+BAAA;IAAA,kCAAA;E9E8m8CV;E8Ern8CM;IAOI,8BAAA;IAAA,iCAAA;E9Ekn8CV;E8Ezn8CM;IAOI,4BAAA;IAAA,+BAAA;E9Esn8CV;E8E7n8CM;IAOI,8BAAA;IAAA,iCAAA;E9E0n8CV;E8Ejo8CM;IAOI,4BAAA;IAAA,+BAAA;E9E8n8CV;E8Ero8CM;IAOI,yBAAA;E9Eio8CV;E8Exo8CM;IAOI,+BAAA;E9Eoo8CV;E8E3o8CM;IAOI,8BAAA;E9Euo8CV;E8E9o8CM;IAOI,4BAAA;E9E0o8CV;E8Ejp8CM;IAOI,8BAAA;E9E6o8CV;E8Epp8CM;IAOI,4BAAA;E9Egp8CV;E8Evp8CM;IAOI,2BAAA;E9Emp8CV;E8E1p8CM;IAOI,iCAAA;E9Esp8CV;E8E7p8CM;IAOI,gCAAA;E9Eyp8CV;E8Ehq8CM;IAOI,8BAAA;E9E4p8CV;E8Enq8CM;IAOI,gCAAA;E9E+p8CV;E8Etq8CM;IAOI,8BAAA;E9Ekq8CV;E8Ezq8CM;IAOI,4BAAA;E9Eqq8CV;E8E5q8CM;IAOI,kCAAA;E9Ewq8CV;E8E/q8CM;IAOI,iCAAA;E9E2q8CV;E8Elr8CM;IAOI,+BAAA;E9E8q8CV;E8Err8CM;IAOI,iCAAA;E9Eir8CV;E8Exr8CM;IAOI,+BAAA;E9Eor8CV;E8E3r8CM;IAOI,0BAAA;E9Eur8CV;E8E9r8CM;IAOI,gCAAA;E9E0r8CV;E8Ejs8CM;IAOI,+BAAA;E9E6r8CV;E8Eps8CM;IAOI,6BAAA;E9Egs8CV;E8Evs8CM;IAOI,+BAAA;E9Ems8CV;E8E1s8CM;IAOI,6BAAA;E9Ess8CV;E8E7s8CM;IAOI,iBAAA;E9Eys8CV;E8Eht8CM;IAOI,uBAAA;E9E4s8CV;E8Ent8CM;IAOI,sBAAA;E9E+s8CV;E8Ett8CM;IAOI,oBAAA;E9Ekt8CV;E8Ezt8CM;IAOI,sBAAA;E9Eqt8CV;E8E5t8CM;IAOI,oBAAA;E9Ewt8CV;E8E/t8CM;IAOI,qBAAA;E9E2t8CV;E8Elu8CM;IAOI,2BAAA;E9E8t8CV;E8Eru8CM;IAOI,0BAAA;E9Eiu8CV;E8Exu8CM;IAOI,wBAAA;E9Eou8CV;E8E3u8CM;IAOI,0BAAA;E9Euu8CV;E8E9u8CM;IAOI,wBAAA;E9E0u8CV;E8Ejv8CM;IAOI,wBAAA;E9E6u8CV;E8Epv8CM;IAOI,8BAAA;E9Egv8CV;E8Evv8CM;IAOI,6BAAA;E9Emv8CV;E8E1v8CM;IAOI,2BAAA;E9Esv8CV;E8E7v8CM;IAOI,6BAAA;E9Eyv8CV;E8Ehw8CM;IAOI,2BAAA;E9E4v8CV;E8Enw8CM;IAOI,2BAAA;E9E+v8CV;E8Etw8CM;IAOI,4BAAA;E9Ekw8CV;E8Ezw8CM;IAOI,6BAAA;E9Eqw8CV;AACF;AoBhx8CI;E0DGI;IAOI,sBAAA;E9E0w8CV;E8Ejx8CM;IAOI,uBAAA;E9E6w8CV;E8Epx8CM;IAOI,sBAAA;E9Egx8CV;E8Evx8CM;IAOI,8BAAA;E9Emx8CV;E8E1x8CM;IAOI,4BAAA;E9Esx8CV;E8E7x8CM;IAOI,2BAAA;E9Eyx8CV;E8Ehy8CM;IAOI,iCAAA;E9E4x8CV;E8Eny8CM;IAOI,2BAAA;E9E+x8CV;E8Ety8CM;IAOI,0BAAA;E9Eky8CV;E8Ezy8CM;IAOI,gCAAA;E9Eqy8CV;E8E5y8CM;IAOI,yBAAA;E9Ewy8CV;E8E/y8CM;IAOI,wBAAA;E9E2y8CV;E8Elz8CM;IAOI,+BAAA;E9E8y8CV;E8Erz8CM;IAOI,yBAAA;E9Eiz8CV;E8Exz8CM;IAOI,6BAAA;E9Eoz8CV;E8E3z8CM;IAOI,8BAAA;E9Euz8CV;E8E9z8CM;IAOI,wBAAA;E9E0z8CV;E8Ej08CM;IAOI,+BAAA;E9E6z8CV;E8Ep08CM;IAOI,wBAAA;E9Eg08CV;E8Ev08CM;IAOI,yBAAA;E9Em08CV;E8E108CM;IAOI,8BAAA;E9Es08CV;E8E708CM;IAOI,iCAAA;E9Ey08CV;E8Eh18CM;IAOI,sCAAA;E9E408CV;E8En18CM;IAOI,yCAAA;E9E+08CV;E8Et18CM;IAOI,uBAAA;E9Ek18CV;E8Ez18CM;IAOI,uBAAA;E9Eq18CV;E8E518CM;IAOI,yBAAA;E9Ew18CV;E8E/18CM;IAOI,yBAAA;E9E218CV;E8El28CM;IAOI,0BAAA;E9E818CV;E8Er28CM;IAOI,4BAAA;E9Ei28CV;E8Ex28CM;IAOI,kCAAA;E9Eo28CV;E8E328CM;IAOI,sCAAA;E9Eu28CV;E8E928CM;IAOI,oCAAA;E9E028CV;E8Ej38CM;IAOI,kCAAA;E9E628CV;E8Ep38CM;IAOI,yCAAA;E9Eg38CV;E8Ev38CM;IAOI,wCAAA;E9Em38CV;E8E138CM;IAOI,wCAAA;E9Es38CV;E8E738CM;IAOI,kCAAA;E9Ey38CV;E8Eh48CM;IAOI,gCAAA;E9E438CV;E8En48CM;IAOI,8BAAA;E9E+38CV;E8Et48CM;IAOI,gCAAA;E9Ek48CV;E8Ez48CM;IAOI,+BAAA;E9Eq48CV;E8E548CM;IAOI,oCAAA;E9Ew48CV;E8E/48CM;IAOI,kCAAA;E9E248CV;E8El58CM;IAOI,gCAAA;E9E848CV;E8Er58CM;IAOI,uCAAA;E9Ei58CV;E8Ex58CM;IAOI,sCAAA;E9Eo58CV;E8E358CM;IAOI,iCAAA;E9Eu58CV;E8E958CM;IAOI,2BAAA;E9E058CV;E8Ej68CM;IAOI,iCAAA;E9E658CV;E8Ep68CM;IAOI,+BAAA;E9Eg68CV;E8Ev68CM;IAOI,6BAAA;E9Em68CV;E8E168CM;IAOI,+BAAA;E9Es68CV;E8E768CM;IAOI,8BAAA;E9Ey68CV;E8Eh78CM;IAOI,oBAAA;E9E468CV;E8En78CM;IAOI,mBAAA;E9E+68CV;E8Et78CM;IAOI,mBAAA;E9Ek78CV;E8Ez78CM;IAOI,mBAAA;E9Eq78CV;E8E578CM;IAOI,mBAAA;E9Ew78CV;E8E/78CM;IAOI,mBAAA;E9E278CV;E8El88CM;IAOI,mBAAA;E9E878CV;E8Er88CM;IAOI,mBAAA;E9Ei88CV;E8Ex88CM;IAOI,oBAAA;E9Eo88CV;E8E388CM;IAOI,0BAAA;E9Eu88CV;E8E988CM;IAOI,yBAAA;E9E088CV;E8Ej98CM;IAOI,uBAAA;E9E688CV;E8Ep98CM;IAOI,yBAAA;E9Eg98CV;E8Ev98CM;IAOI,uBAAA;E9Em98CV;E8E198CM;IAOI,uBAAA;E9Es98CV;E8E798CM;IAOI,0BAAA;IAAA,yBAAA;E9E098CV;E8Ej+8CM;IAOI,gCAAA;IAAA,+BAAA;E9E898CV;E8Er+8CM;IAOI,+BAAA;IAAA,8BAAA;E9Ek+8CV;E8Ez+8CM;IAOI,6BAAA;IAAA,4BAAA;E9Es+8CV;E8E7+8CM;IAOI,+BAAA;IAAA,8BAAA;E9E0+8CV;E8Ej/8CM;IAOI,6BAAA;IAAA,4BAAA;E9E8+8CV;E8Er/8CM;IAOI,6BAAA;IAAA,4BAAA;E9Ek/8CV;E8Ez/8CM;IAOI,wBAAA;IAAA,2BAAA;E9Es/8CV;E8E7/8CM;IAOI,8BAAA;IAAA,iCAAA;E9E0/8CV;E8Ejg9CM;IAOI,6BAAA;IAAA,gCAAA;E9E8/8CV;E8Erg9CM;IAOI,2BAAA;IAAA,8BAAA;E9Ekg9CV;E8Ezg9CM;IAOI,6BAAA;IAAA,gCAAA;E9Esg9CV;E8E7g9CM;IAOI,2BAAA;IAAA,8BAAA;E9E0g9CV;E8Ejh9CM;IAOI,2BAAA;IAAA,8BAAA;E9E8g9CV;E8Erh9CM;IAOI,wBAAA;E9Eih9CV;E8Exh9CM;IAOI,8BAAA;E9Eoh9CV;E8E3h9CM;IAOI,6BAAA;E9Euh9CV;E8E9h9CM;IAOI,2BAAA;E9E0h9CV;E8Eji9CM;IAOI,6BAAA;E9E6h9CV;E8Epi9CM;IAOI,2BAAA;E9Egi9CV;E8Evi9CM;IAOI,2BAAA;E9Emi9CV;E8E1i9CM;IAOI,0BAAA;E9Esi9CV;E8E7i9CM;IAOI,gCAAA;E9Eyi9CV;E8Ehj9CM;IAOI,+BAAA;E9E4i9CV;E8Enj9CM;IAOI,6BAAA;E9E+i9CV;E8Etj9CM;IAOI,+BAAA;E9Ekj9CV;E8Ezj9CM;IAOI,6BAAA;E9Eqj9CV;E8E5j9CM;IAOI,6BAAA;E9Ewj9CV;E8E/j9CM;IAOI,2BAAA;E9E2j9CV;E8Elk9CM;IAOI,iCAAA;E9E8j9CV;E8Erk9CM;IAOI,gCAAA;E9Eik9CV;E8Exk9CM;IAOI,8BAAA;E9Eok9CV;E8E3k9CM;IAOI,gCAAA;E9Euk9CV;E8E9k9CM;IAOI,8BAAA;E9E0k9CV;E8Ejl9CM;IAOI,8BAAA;E9E6k9CV;E8Epl9CM;IAOI,yBAAA;E9Egl9CV;E8Evl9CM;IAOI,+BAAA;E9Eml9CV;E8E1l9CM;IAOI,8BAAA;E9Esl9CV;E8E7l9CM;IAOI,4BAAA;E9Eyl9CV;E8Ehm9CM;IAOI,8BAAA;E9E4l9CV;E8Enm9CM;IAOI,4BAAA;E9E+l9CV;E8Etm9CM;IAOI,4BAAA;E9Ekm9CV;E8Ezm9CM;IAOI,2BAAA;E9Eqm9CV;E8E5m9CM;IAOI,0BAAA;E9Ewm9CV;E8E/m9CM;IAOI,wBAAA;E9E2m9CV;E8Eln9CM;IAOI,0BAAA;E9E8m9CV;E8Ern9CM;IAOI,wBAAA;E9Ein9CV;E8Exn9CM;IAOI,iCAAA;IAAA,gCAAA;E9Eqn9CV;E8E5n9CM;IAOI,gCAAA;IAAA,+BAAA;E9Eyn9CV;E8Eho9CM;IAOI,8BAAA;IAAA,6BAAA;E9E6n9CV;E8Epo9CM;IAOI,gCAAA;IAAA,+BAAA;E9Eio9CV;E8Exo9CM;IAOI,8BAAA;IAAA,6BAAA;E9Eqo9CV;E8E5o9CM;IAOI,+BAAA;IAAA,kCAAA;E9Eyo9CV;E8Ehp9CM;IAOI,8BAAA;IAAA,iCAAA;E9E6o9CV;E8Epp9CM;IAOI,4BAAA;IAAA,+BAAA;E9Eip9CV;E8Exp9CM;IAOI,8BAAA;IAAA,iCAAA;E9Eqp9CV;E8E5p9CM;IAOI,4BAAA;IAAA,+BAAA;E9Eyp9CV;E8Ehq9CM;IAOI,+BAAA;E9E4p9CV;E8Enq9CM;IAOI,8BAAA;E9E+p9CV;E8Etq9CM;IAOI,4BAAA;E9Ekq9CV;E8Ezq9CM;IAOI,8BAAA;E9Eqq9CV;E8E5q9CM;IAOI,4BAAA;E9Ewq9CV;E8E/q9CM;IAOI,iCAAA;E9E2q9CV;E8Elr9CM;IAOI,gCAAA;E9E8q9CV;E8Err9CM;IAOI,8BAAA;E9Eir9CV;E8Exr9CM;IAOI,gCAAA;E9Eor9CV;E8E3r9CM;IAOI,8BAAA;E9Eur9CV;E8E9r9CM;IAOI,kCAAA;E9E0r9CV;E8Ejs9CM;IAOI,iCAAA;E9E6r9CV;E8Eps9CM;IAOI,+BAAA;E9Egs9CV;E8Evs9CM;IAOI,iCAAA;E9Ems9CV;E8E1s9CM;IAOI,+BAAA;E9Ess9CV;E8E7s9CM;IAOI,gCAAA;E9Eys9CV;E8Eht9CM;IAOI,+BAAA;E9E4s9CV;E8Ent9CM;IAOI,6BAAA;E9E+s9CV;E8Ett9CM;IAOI,+BAAA;E9Ekt9CV;E8Ezt9CM;IAOI,6BAAA;E9Eqt9CV;E8E5t9CM;IAOI,qBAAA;E9Ewt9CV;E8E/t9CM;IAOI,2BAAA;E9E2t9CV;E8Elu9CM;IAOI,0BAAA;E9E8t9CV;E8Eru9CM;IAOI,wBAAA;E9Eiu9CV;E8Exu9CM;IAOI,0BAAA;E9Eou9CV;E8E3u9CM;IAOI,wBAAA;E9Euu9CV;E8E9u9CM;IAOI,2BAAA;IAAA,0BAAA;E9E2u9CV;E8Elv9CM;IAOI,iCAAA;IAAA,gCAAA;E9E+u9CV;E8Etv9CM;IAOI,gCAAA;IAAA,+BAAA;E9Emv9CV;E8E1v9CM;IAOI,8BAAA;IAAA,6BAAA;E9Euv9CV;E8E9v9CM;IAOI,gCAAA;IAAA,+BAAA;E9E2v9CV;E8Elw9CM;IAOI,8BAAA;IAAA,6BAAA;E9E+v9CV;E8Etw9CM;IAOI,yBAAA;IAAA,4BAAA;E9Emw9CV;E8E1w9CM;IAOI,+BAAA;IAAA,kCAAA;E9Euw9CV;E8E9w9CM;IAOI,8BAAA;IAAA,iCAAA;E9E2w9CV;E8Elx9CM;IAOI,4BAAA;IAAA,+BAAA;E9E+w9CV;E8Etx9CM;IAOI,8BAAA;IAAA,iCAAA;E9Emx9CV;E8E1x9CM;IAOI,4BAAA;IAAA,+BAAA;E9Eux9CV;E8E9x9CM;IAOI,yBAAA;E9E0x9CV;E8Ejy9CM;IAOI,+BAAA;E9E6x9CV;E8Epy9CM;IAOI,8BAAA;E9Egy9CV;E8Evy9CM;IAOI,4BAAA;E9Emy9CV;E8E1y9CM;IAOI,8BAAA;E9Esy9CV;E8E7y9CM;IAOI,4BAAA;E9Eyy9CV;E8Ehz9CM;IAOI,2BAAA;E9E4y9CV;E8Enz9CM;IAOI,iCAAA;E9E+y9CV;E8Etz9CM;IAOI,gCAAA;E9Ekz9CV;E8Ezz9CM;IAOI,8BAAA;E9Eqz9CV;E8E5z9CM;IAOI,gCAAA;E9Ewz9CV;E8E/z9CM;IAOI,8BAAA;E9E2z9CV;E8El09CM;IAOI,4BAAA;E9E8z9CV;E8Er09CM;IAOI,kCAAA;E9Ei09CV;E8Ex09CM;IAOI,iCAAA;E9Eo09CV;E8E309CM;IAOI,+BAAA;E9Eu09CV;E8E909CM;IAOI,iCAAA;E9E009CV;E8Ej19CM;IAOI,+BAAA;E9E609CV;E8Ep19CM;IAOI,0BAAA;E9Eg19CV;E8Ev19CM;IAOI,gCAAA;E9Em19CV;E8E119CM;IAOI,+BAAA;E9Es19CV;E8E719CM;IAOI,6BAAA;E9Ey19CV;E8Eh29CM;IAOI,+BAAA;E9E419CV;E8En29CM;IAOI,6BAAA;E9E+19CV;E8Et29CM;IAOI,iBAAA;E9Ek29CV;E8Ez29CM;IAOI,uBAAA;E9Eq29CV;E8E529CM;IAOI,sBAAA;E9Ew29CV;E8E/29CM;IAOI,oBAAA;E9E229CV;E8El39CM;IAOI,sBAAA;E9E829CV;E8Er39CM;IAOI,oBAAA;E9Ei39CV;E8Ex39CM;IAOI,qBAAA;E9Eo39CV;E8E339CM;IAOI,2BAAA;E9Eu39CV;E8E939CM;IAOI,0BAAA;E9E039CV;E8Ej49CM;IAOI,wBAAA;E9E639CV;E8Ep49CM;IAOI,0BAAA;E9Eg49CV;E8Ev49CM;IAOI,wBAAA;E9Em49CV;E8E149CM;IAOI,wBAAA;E9Es49CV;E8E749CM;IAOI,8BAAA;E9Ey49CV;E8Eh59CM;IAOI,6BAAA;E9E449CV;E8En59CM;IAOI,2BAAA;E9E+49CV;E8Et59CM;IAOI,6BAAA;E9Ek59CV;E8Ez59CM;IAOI,2BAAA;E9Eq59CV;E8E559CM;IAOI,2BAAA;E9Ew59CV;E8E/59CM;IAOI,4BAAA;E9E259CV;E8El69CM;IAOI,6BAAA;E9E859CV;AACF;A+Er99CA;ED+CQ;IAOI,gCAAA;E9Em69CV;E8E169CM;IAOI,8BAAA;E9Es69CV;E8E769CM;IAOI,iCAAA;E9Ey69CV;AACF;A+E789CA;ED4BQ;IAOI,0BAAA;E9E869CV;E8Er79CM;IAOI,gCAAA;E9Ei79CV;E8Ex79CM;IAOI,yBAAA;E9Eo79CV;E8E379CM;IAOI,wBAAA;E9Eu79CV;E8E979CM;IAOI,+BAAA;E9E079CV;E8Ej89CM;IAOI,yBAAA;E9E679CV;E8Ep89CM;IAOI,6BAAA;E9Eg89CV;E8Ev89CM;IAOI,8BAAA;E9Em89CV;E8E189CM;IAOI,wBAAA;E9Es89CV;E8E789CM;IAOI,+BAAA;E9Ey89CV;E8Eh99CM;IAOI,wBAAA;E9E489CV;AACF;AgFth+CA;;eAAA;AAIA;EACE,kBAAA;EACA,gBAAA;AhFuh+CF;;AgFph+CA;;EAEE,cpE8ES;AZy89CX;;AgFph+CA;EACE,gCAAA;AhFuh+CF;;AgFph+CA;EACE,gBAAA;EACA,qBpE82ByB;AZyq8C3B;;AgFlh+CA;EACE,kBAAA;EACA,8BAAA;AhFqh+CF;;AgFlh+CA;EACE,cAAA;EACA,+BAAA;EACA,iBAAA;AhFqh+CF;;AgF/g+CE;EADF;IAEM,iBAAA;EhFmh+CJ;AACF;;AgF7g+CE;EACI,kBAAA;AhFgh+CN;;AiFxj+CQ;EACI,qDAAA;AjF2j+CZ;;AiF5j+CQ;EACI,sDAAA;AjF+j+CZ;;AiFhk+CQ;EACI,qDAAA;AjFmk+CZ;;AiFpk+CQ;EACI,qDAAA;AjFuk+CZ;;AiFxk+CQ;EACI,qDAAA;AjF2k+CZ;;AiF5k+CQ;EACI,sDAAA;AjF+k+CZ;;AiFhl+CQ;EACI,qDAAA;AjFml+CZ;;AiFpl+CQ;EACI,sDAAA;AjFul+CZ;;AiFxl+CQ;EACI,mDAAA;AjF2l+CZ;;AkF7l+CI;EAEE,WtEyEE;AZsh+CR;;AkFvk+CM;EAEE,8EAAA;AlFyk+CR;;AkFlk+CE;EACE,ctE8CO;AZuh+CX;AkFlk+CM;EAEE,ctEyCG;AZ0h+CX;;AkF7j+CE;EAtCA,ctE0Ia;EsEzIb,0CAAA;AlFum+CF;AkFpm+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,yCAAA;AlFqm+CN;;AkF5l+CM;EAEE,gFAAA;AlF8l+CR;;AkFvl+CE;EACE,ctE8CO;AZ4i+CX;AkFvl+CM;EAEE,ctEyCG;AZ+i+CX;;AkFll+CE;EAtCA,ctE0Ia;EsEzIb,2CAAA;AlF4n+CF;AkFzn+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,0CAAA;AlF0n+CN;;AkFjn+CM;EAEE,+EAAA;AlFmn+CR;;AkF5m+CE;EACE,ctE8CO;AZik+CX;AkF5m+CM;EAEE,ctEyCG;AZok+CX;;AkFvm+CE;EAtCA,ctE0Ia;EsEzIb,0CAAA;AlFip+CF;AkF9o+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,yCAAA;AlF+o+CN;;AkFto+CM;EAEE,+EAAA;AlFwo+CR;;AkFjo+CE;EACE,ctE8CO;AZsl+CX;AkFjo+CM;EAEE,ctEyCG;AZyl+CX;;AkF5n+CE;EAtCA,ctE0Ia;EsEzIb,0CAAA;AlFsq+CF;AkFnq+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,yCAAA;AlFoq+CN;;AkF3p+CM;EAEE,+EAAA;AlF6p+CR;;AkFtp+CE;EACE,ctE8CO;AZ2m+CX;AkFtp+CM;EAEE,ctEyCG;AZ8m+CX;;AkFjp+CE;EAtCA,ctE0Ia;EsEzIb,0CAAA;AlF2r+CF;AkFxr+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,yCAAA;AlFyr+CN;;AkFhr+CM;EAEE,4DAAA;AlFkr+CR;;AkF3q+CE;EACE,ctE8CO;AZgo+CX;AkF3q+CM;EAEE,ctEyCG;AZmo+CX;;AkFtq+CE;EAtCA,ctE0Ia;EsEzIb,2CAAA;AlFgt+CF;AkF7s+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,0CAAA;AlF8s+CN;;AkFrs+CM;EAEE,+EAAA;AlFus+CR;;AkFhs+CE;EACE,ctE8CO;AZqp+CX;AkFhs+CM;EAEE,ctEyCG;AZwp+CX;;AkF3r+CE;EAtCA,ctE0Ia;EsEzIb,0CAAA;AlFqu+CF;AkFlu+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,yCAAA;AlFmu+CN;;AkF1t+CM;EAEE,sDAAA;AlF4t+CR;;AkFrt+CE;EACE,ctE8CO;AZ0q+CX;AkFrt+CM;EAEE,ctEyCG;AZ6q+CX;;AkFht+CE;EAtCA,ctE0Ia;EsEzIb,2CAAA;AlF0v+CF;AkFvv+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,0CAAA;AlFwv+CN;;AkF/u+CM;EAEE,oEAAA;AlFiv+CR;;AkF1u+CE;EACE,ctE8CO;AZ+r+CX;AkF1u+CM;EAEE,ctEyCG;AZks+CX;;AkFru+CE;EAtCA,ctE0Ia;EsEzIb,wCAAA;AlF+w+CF;AkF5w+CI;EAEE,ctEoIS;EsEnIT,qBAAA;EACA,uCAAA;AlF6w+CN;;AkFzu+CA;EACG,oBAAA;EACC,mBAAA;AlF4u+CJ;;AkFvu+CA;EACE,ctEgBS;AZ0t+CX;;AmF1y+CA;EACE,wBAAA;AnF6y+CF;;AmFxy+CA;EACE,mBAAA;AnF2y+CF;;AmFxy+CA;EACE,yBAAA;AnF2y+CF;;AmFxy+CA;EACE,cvEwES;AZmu+CX;;AmFvy+CE;EAIE,cvEyDO;AZ8u+CX;;AmFhy+CE;EACE,kBAAA;AnFmy+CJ;AmFhy+CM;EACE,aAAA;AnFky+CR;AmF9x+CI;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBvEqCK;EuEpCL,cvEgCK;EuE/BL,sBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AnFgy+CN;;AmFxx+CA;EACE,kBAAA;EACA,kBAAA;AnF2x+CF;AmF1x+CE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,0CAAA;EACA,gDAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnF4x+CJ;AmFzx+CI;EACE,uCAAA;EACA,6CAAA;AnF2x+CN;;AoFv2+CI;EACI,cxEgFG;AZ0x+CX;AoFv2+CQ;EACI,oCAAA;ApFy2+CZ;;AqFl3+CA;EACE,mBzEwjBkB;EyEtjBlB,gBAAA;EACA,SAAA;EACA,2BAAA;ArFo3+CF;;AqFj3+CA;EACE,czE4ES;AZwy+CX;;AqFj3+CA;EACE,eAAA;EACA,iBAAA;EACA,gBzE8CqB;AZs0+CvB;;AqFj3+CA;EACE,czEiES;EyEhET,mBAAA;ArFo3+CF;;AsFx4+CA;EACE,4C1E4lBc;E0E3lBd,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AtF24+CF;AsFz4+CE;EACE,oBAAA;AtF24+CJ;;AsFv4+CA;EACE,qBAAA;EACA,mBAAA;AtF04+CF;;AsFv4+CA;EACE,oBAAA;EACA,0BAAA;AtF04+CF;;AsFv4+CA;EACE,oBAAA;EAEA,0BAAA;AtF04+CF;;AsFt4+CA;EACE;IACI,wBAAA;EtFy4+CJ;EsFv4+CA;IACI,2BAAA;EtFy4+CJ;AACF;AsFt4+CA;EACE;IACE,YAAA;EtFw4+CF;EsFr4+CA;IACE,YAAA;EtFu4+CF;AACF;AsFp4+CA;EACE,yB1E6BS;AZy2+CX;;AsFj4+CA;EACE,2BAAA;AtFo4+CF;;AsFj4+CA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;AtFo4+CF;;AsF/3+CA;EACE,YAAA;AtFk4+CF;;AsF/3+CA;EACE,YAAA;AtFk4+CF;;AuF98+CA;EACE,yBAAA;EACA,cAAA;AvFi9+CF;;AuF/8+CA;EACE,mBAAA;EACA,WAAA;AvFk9+CF;;AuF/8+CA;EACE,uCAAA;EACA,0CAAA;AvFk9+CF;;AuFh9+CA;EACE,wCAAA;EACA,2CAAA;AvFm9+CF;;AuFj9+CA;EACE,kBAAA;EACA,eAAA;AvFo9+CF;;AuFl9+CA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AvFq9+CF;;AuFn9+CA;EACA,cAAA;AvFs9+CA;;AuF78+CM;EACI,c3EkDC;E2EjDD,gB3EwBE;AZw7+CZ;;AuF18+CE;EACI,c3E0CK;E2EzCL,gB3EgBM;AZ67+CZ;;AuFx8+CA;EACE,gCAAA;AvF28+CF;AuFz8+CE;EACE,kBAAA;EACA,c3EgCO;AZ26+CX;AuF18+CI;EACE,YAAA;AvF48+CN;AuF18+CM;EACE,WAAA;EACA,mB3EgDD;E2E/CC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;AvF48+CR;AuFz8+CM;EACE,c3EqCD;AZs6+CP;AuF18+CQ;EACE,mBAAA;AvF48+CV;;AuF/7+CM;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AvFk8+CV;AuFj8+CU;EACI,eAAA;AvFm8+Cd;;AwF7h/CE;EACI,gB5EkpBa;AZ849CnB;AwF7h/CE;EACE,c5E+EO;E4E9EP,qB5EyEO;E4ExEP,yBtDHO;AlCki/CX;;AwF3h/CA;EACE,yBAAA;AxF8h/CF;AwF5h/CE;;EAEE,yBAAA;AxF8h/CJ;;AwFzh/CA;EACE,gD5E6CwB;AZ+++C1B;;AwFxh/CE;EACE,mBAAA;AxF2h/CJ;;AyFrj/CI;EACI,8BAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AzFwj/CR;;A0Fjk/CA;EACE,WAAA;A1Fok/CF;;A0F/j/CA;EACE,WAAA;A1Fkk/CF;;A0F7j/CA;EACE,YAAA;A1Fgk/CF;;A0F5j/CA;EACE,YAAA;A1F+j/CF;;A0F5j/CA;EACE,kBAAA;A1F+j/CF;A0F9j/CE;EACI,kBAAA;EACA,UAAA;A1Fgk/CN;A0F/j/CM;EACE,gB9EkDA;AZ+g/CR;;A0F1j/CA;EACE,kBAAA;A1F6j/CF;A0F5j/CE;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;A1F8j/CJ;;A0F1j/CA;EACE;IACI,QAAA;E1F6j/CJ;AACF;A2Fhn/CA;;CAAA;ACIA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,WhFKc;EgFJd,aAAA;EACA,yBhFkBU;EgFjBV,mDhFqlBW;AZ4h+Cb;A4Fhn/CE;EARF;IASI,OAAA;E5Fmn/CF;AACF;;A4Fhn/CA;EACE,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YhFIc;EgFHd,6BAAA;A5Fmn/CF;A4F9m/CM;EACE,yBhFqDG;AZ2j/CX;A4F7m/CI;EACE,aAAA;A5F+m/CN;;A4F1m/CA;EACE,iBAAA;EACA,kBAAA;A5F6m/CF;;A4F1m/CA;EACE,iBAAA;A5F6m/CF;A4F3m/CE;EACE,aAAA;A5F6m/CJ;;A4Fzm/CA;EACE,aAAA;A5F4m/CF;;A4Fzm/CA,WAAA;AAEA;EACE,yBAAA;A5F2m/CF;A4Fzm/CE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBhF9Be;EgF+Bf,gBAAA;EACA,mBAAA;A5F2m/CJ;A4Fzm/CE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,chFWO;AZgm/CX;;A4Fpm/CE;EACE,kBAAA;EACA,gBAAA;A5Fum/CJ;A4Ftm/CI;EACE,chFCK;AZum/CX;;A4Fnm/CA;EACE;IACE,WAAA;E5Fsm/CF;E4Flm/CE;IACE,aAAA;E5Fom/CJ;E4Fjm/CE;IACE,qBAAA;E5Fmm/CJ;AACF;A4F/l/CA;EACE,4BAAA;EACA,gBAAA;A5Fim/CF;;A4Fxl/CA;EACE,YhF9Fc;EgF+Fd,2BAAA;EACA,chF9FkB;EgF+FlB,SAAA;EACA,kBAAA;EACA,kBAAA;A5F2l/CF;A4Fzl/CE;EACE,chFpGgB;AZ+r/CpB;;A4Fvl/CA;EACE,YAAA;EACA,WAAA;EACA,yBhFnDS;EgFoDT,YAAA;A5F0l/CF;;A4Ftl/CE;EACE,eAAA;EACA,chFlHgB;AZ2s/CpB;A4Ftl/CE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;A5Fwl/CJ;;A4Fnl/CE;EACE,qBAAA;A5Fsl/CJ;A4Fpl/CI;EACE,yBhFzEK;AZ+p/CX;;A4Fhl/CA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,chFpFS;AZuq/CX;A4Fjl/CE;EACE,YAAA;A5Fml/CJ;A4Fhl/CE;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5Fkl/CJ;A4F/k/CE;EACE,qBhFtGO;AZur/CX;;A4F1k/CI;EACE,gBAAA;A5F6k/CN;;A4Fvk/CE;EACE,yBhFzKa;AZmv/CjB;A4Ftk/CM;EACE,2CAAA;A5Fwk/CR;A4Fpk/CI;EACE,oCAAA;A5Fsk/CN;A4Flk/CE;EACE,chFvLqB;AZ2v/CzB;A4Flk/CI;EACE,chF1LmB;AZ8v/CzB;A4Fhk/CE;EACE,2CAAA;A5Fkk/CJ;A4F9j/CI;EACE,chFpMmB;AZow/CzB;A4F5j/CE;EACE,aAAA;A5F8j/CJ;A4F3j/CE;EACE,cAAA;A5F6j/CJ;A4Fzj/CI;EACE,2CAAA;EACA,WhFlKE;AZ6t/CR;A4Fzj/CI;;EAEE,+BAAA;A5F2j/CN;;A4Frj/CE;EACE,mBhF5Oc;AZoy/ClB;A4Frj/CE;EACE,aAAA;A5Fuj/CJ;A4Fpj/CE;EACE,cAAA;A5Fsj/CJ;;A4Flj/CA;EAEI;IACE,gBAAA;E5Foj/CJ;E4Flj/CI;IACE,qBAAA;IACA,sBAAA;E5Foj/CN;AACF;A4F/i/CA;EACE;IACE,aAAA;E5Fij/CF;AACF;A4F7i/CE;EACE,WAAA;A5F+i/CJ;A4F7i/CE;EACE,gBhFxQY;EgFyQZ,6DAAA;A5F+i/CJ;;A4F1i/CA;EAEI;IACE,gBAAA;E5F4i/CJ;AACF;A6Fr1/CA;EACE,oBjFwjBkB;EiFvjBlB,gBAAA;A7Fu1/CF;A6Fr1/CE;EACE,6BAAA;EACA,UAAA;A7Fu1/CJ;A6Fp1/CE;EACE,yBAAA;EACA,gBAAA;EACA,0BAAA;A7Fs1/CJ;;A8Fl2/CA;EACI,SAAA;EACA,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,clFgCW;EkF/BX,WAAA;EACA,YlF4BY;EkF3BZ,yBlF4BQ;AZy0/CZ;A8Fn2/CI;EAVJ;IAWQ,OAAA;E9Fs2/CN;AACF;;A8Fj2/CI;EACI,UlFRkB;AZ42/C1B;A8Fl2/CQ;EAHJ;IAIQ,OAAA;E9Fq2/CV;AACF;;A8Fh2/CI;EACI,kBAAA;A9Fm2/CR;;A+F/3/CA;EACE,sBnF6EM;EmF5EN,yEAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,YnFwCe;EmFvCf,aAAA;EACA,uBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;A/Fk4/CF;A+Fh4/CE;EACE,0DAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,cnF6DO;EmF5DP,kBAAA;EACA,kBAAA;A/Fk4/CJ;A+Fh4/CI;EACE,yDAAA;A/Fk4/CN;;A+F53/CA;EACE,wCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;A/F+3/CF;;A+F33/CE;EACE,QAAA;A/F83/CJ;A+F53/CE;EACE,cAAA;A/F83/CJ;;AoBr2/CI;E2EpBF;IACE,cAAA;E/F63/CF;E+F53/CE;IACE,uBAAA;E/F83/CJ;AACF;A+F13/CA;EACE,iCAAA;A/F43/CF;;AgGz7/CA;EACE,SAAA;AhG47/CF;AgG17/CE;EACE,cAAA;EACA,WAAA;AhG47/CJ;AgGz7/CE;EACE,aAAA;AhG27/CJ;AgGz7/CI;EACE,aAAA;AhG27/CN;AgGx7/CI;EACE,cAAA;AhG07/CN;AgGt7/CE;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,uCAAA;AhGw7/CJ;;AgGp7/CA;EACE,YpFtBc;EoFuBd,aAAA;EACA,mBpF9BW;EoF+BX,SAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,iBpFfc;EoFgBd,mDpFqjBW;AZk4+Cb;AgGt7/CE;EAVF;IAWI,SpFlBY;IoFmBZ,gBAAA;EhGy7/CF;AACF;AgGv7/CE;EACE,eAAA;EACA,QAAA;EACA,WAAA;AhGy7/CJ;AgGx7/CI;EAJF;IAKI,aAAA;EhG27/CJ;AACF;;AgGv7/CA;EACE,kBpF/Cc;EoFgDd,gBAAA;AhG07/CF;AgGx7/CE;EACE,yBAAA;EACA,gBpFtCY;AZg+/ChB;;AgGt7/CA;EACE,sBAAA;AhGy7/CF;AgGr7/CM;EACE,0BAAA;AhGu7/CR;AgGj7/CI;EACE,iBAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AhGm7/CN;AgG76/CM;EACE,cAAA;EACA,wBAAA;EACA,cpFxFkB;EoFyFlB,kBAAA;EACA,eAAA;EACA,oBAAA;AhG+6/CR;AgG76/CQ;EACE,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cpFlGqB;EoFmGrB,oBAAA;AhG+6/CV;AgG56/CQ;EACE,cpFtGsB;AZohgDhC;AgG56/CU;EACE,cpFzGoB;AZuhgDhC;AgGz6/CM;EACE,eAAA;AhG26/CR;AgGx6/CM;EACE,UAAA;AhG06/CR;AgGv6/CU;EACE,oCAAA;EACA,eAAA;EACA,cpF3HkB;AZoigD9B;AgGx6/CY;EACE,cpF3HkB;AZqigDhC;AgGt6/CU;EACE,UAAA;AhGw6/CZ;AgGr6/Cc;EACE,oCAAA;EACA,eAAA;AhGu6/ChB;;AgG75/CA;EACE,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,cpFvJ6B;EoFwJ7B,gBpFjGqB;AZiggDvB;;AgG75/CA;EACE,yBAAA;AhGg6/CF;AgG/5/CE;EACE,yBAAA;AhGi6/CJ;AgGh6/CI;EACE,yBAAA;AhGk6/CN;AgG/5/CE;EACE,yBAAA;AhGi6/CJ;AgG/5/CI;EACE,yBAAA;AhGi6/CN;AgG95/CE;EACE,yBAAA;AhGg6/CJ;;AgG55/CA;EACE;IACE,aAAA;EhG+5/CF;EgG55/CA;IACE,yBAAA;EhG85/CF;EgG15/CE;IACE,cAAA;EhG45/CJ;AACF;AgGt5/CE;EACE,iBpF9LsB;AZslgD1B;AgGr5/CE;EACE,sBAAA;AhGu5/CJ;AgGp5/CE;EACE,UpFtMsB;AZ4lgD1B;AgGr5/CI;EAFF;IAGI,OAAA;EhGw5/CJ;AACF;AgGp5/CI;EACE,aAAA;AhGs5/CN;AgGn5/CI;EACE,cAAA;AhGq5/CN;AgGh5/CE;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;AhGk5/CJ;AgGh5/CI;;EAEE,4BAAA;AhGk5/CN;AgG/4/CI;EACE,wBAAA;AhGi5/CN;AgG94/CI;EACE,oBAAA;AhGg5/CN;AgG34/CM;;;EAGE,wBAAA;AhG64/CR;AgG14/CM;EACE,0BAAA;AhG44/CR;AgGx4/CQ;EACE,aAAA;AhG04/CV;AgGr4/CQ;EACE,kBAAA;EACA,mBAAA;AhGu4/CV;AgGr4/CU;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AhGu4/CZ;AgGr4/CY;EAGE,cpF3QkB;AZgpgDhC;AgGl4/CY;EACE,kBAAA;EACA,gBAAA;AhGo4/Cd;AgGj4/CY;EACE,aAAA;EACA,kBAAA;AhGm4/Cd;AgG93/CY;EACE,kBAAA;EACA,yBAAA;EACA,cpFxLP;EoFyLO,0CAAA;EACA,gBAAA;AhGg4/Cd;AgG93/Cc;EACE,cpF7LT;AZ6jgDP;AgG73/Cc;EACE,eAAA;AhG+3/ChB;AgG33/CY;EACE,cAAA;EACA,UpFzSY;EoF0SZ,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,gDAAA;AhG63/Cd;AgG33/Cc;EACE,gDAAA;AhG63/ChB;AgG13/Cc;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,cpF9Tc;AZ0rgD9B;AgG13/CgB;EACE,cpF/Tc;AZ2rgDhC;AgGr3/CQ;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,yBpF9UG;AZqsgDb;AgGn3/Cc;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AhGq3/ChB;AgGh3/Cc;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AhGk3/ChB;AgG52/CY;EACE,cpF5RH;AZ0ogDX;;AgGp2/CE;EACE,mBpFvWc;AZ8sgDlB;AgGj2/CQ;EACE,cpF7WqB;AZgtgD/B;AgGj2/CU;EACE,cpF9WwB;AZitgDpC;AgGh2/CU;EACE,cpFjXyB;AZmtgDrC;AgGh2/CY;EACE,cpFpXuB;AZstgDrC;AgG31/CY;EACE,cpF9XqB;AZ2tgDnC;AgG31/Cc;EACE,cpF/XqB;AZ4tgDrC;AgGp1/CE;EACE,kBpFhZ0B;AZsugD9B;AgGl1/CM;EACE,mBpFlZU;AZsugDlB;AgG70/Cc;EACE,4DAAA;EACA,cpFvZqB;AZsugDrC;AgG90/CgB;EACE,cpFzZmB;AZyugDrC;AgG30/CgB;EACE,cpFjaiB;AZ8ugDnC;AgG50/CkB;EACE,cpFjaiB;AZ+ugDrC;AgGv0/CU;EACE,yBpF7aM;AZsvgDlB;AgGn0/CY;EACE,yBAAA;AhGq0/Cd;AgGp0/Cc;EACE,yBAAA;AhGs0/ChB;AgG9z/CE;EACE,yBAAA;AhGg0/CJ;AgG/z/CI;EACE,yBAAA;AhGi0/CN;AgGh0/CM;EACE,yBAAA;AhGk0/CR;AgG/z/CI;EACE,yBAAA;AhGi0/CN;AgG/z/CI;EACE,yBAAA;AhGi0/CN;AgG/z/CM;EACE,yBAAA;AhGi0/CR;AgG5z/CE;EACE,cpFhdgC;AZ8wgDpC;;AgGzz/CE;EACE,yBAAA;AhG4z/CJ;;AgGrz/CE;EACE,YpFree;AZ6xgDnB;AgGtz/CE;EACE,YpFxee;EoFyef,kBAAA;AhGwz/CJ;AgGtz/CI;;EAEE,wBAAA;AhGwz/CN;AgGrz/CE;EACE,kBpFjfe;AZwygDnB;AgGrz/CE;EACE,WpFpfe;AZ2ygDnB;AgGtz/CI;EAFF;IAGI,OAAA;EhGyz/CJ;AACF;AgGtz/CE;EACE,WpF3fe;AZmzgDnB;AgGvz/CI;EAFF;IAGI,OAAA;EhG0z/CJ;EgGvz/CM;IACE,WAAA;EhGyz/CR;AACF;AgGjz/CQ;EACE,cAAA;AhGmz/CV;AgG9y/CU;EACE,oBAAA;AhGgz/CZ;AgG7y/CU;EACE,oBAAA;AhG+y/CZ;AgGxy/CI;EACE,iBpF9hBoB;AZw0gD1B;AgGvy/CM;EACE,gBAAA;AhGyy/CR;AgGry/Cc;EACE,qBAAA;AhGuy/ChB;AgGhy/CI;EACE,UpF/iBoB;AZi1gD1B;;AgGpx/CI;;;;;;EACE,aAAA;AhG4x/CN;AgG1x/CI;;;;;;EACE,cAAA;AhGiy/CN;AgG7x/CE;;;;;;EACE,sBAAA;AhGoy/CJ;AgGny/CI;;;;;;EACE,sBAAA;AhG0y/CN;AgGzy/CM;;;;;;EACE,sBAAA;AhGgz/CR;AgG7y/CI;;;;;;;;;;;;EAEE,sBAAA;AhGyz/CN;AgGlz/CQ;;;;;;EACE,+BAAA;AhGyz/CV;AgGtz/CQ;;;;;;EACE,+BAAA;AhG6z/CV;AgG5z/CU;;;;;;EACE,+BAAA;AhGm0/CZ;AgGh0/CY;;;;;;EACE,oCAAA;AhGu0/Cd;AgGn0/CU;;;;;;EACE,WpFliBJ;AZ42gDR;AgGx0/CY;;;;;;EACE,WpFriBN;AZo3gDR;AgGx0/CY;;;;;;EACE,+BAAA;AhG+0/Cd;AgG90/Cc;;;;;;EACE,WpF/iBR;AZo4gDR;AgGv0/CY;;;;;;EACE,WpF9jBN;AZ44gDR;AgG70/Cc;;;;;;EACE,WpFhkBR;AZo5gDR;AgG30/Cc;;;;;;EACE,yBAAA;AhGk1/ChB;AgG30/CkB;;;;;;EACE,cpFxpBa;AZ0+gDjC;AgG/0/CgB;;;;;;EACE,yBAAA;AhGs1/ClB;AgGr1/CkB;;;;;;EACE,yBAAA;AhG41/CpB;AgG31/CoB;;;;;;EACE,yBAAA;AhGk2/CtB;;AgGp1/CA;EACE,oCAAA;AhGu1/CF;;AgGp1/CE;EACE,yBpF/kBG;AZs6gDP;AgGl1/CM;EACE,yBpFrlBD;AZy6gDP;AgG/0/CY;EACE,oEAAA;AhGi1/Cd;AgGz0/CI;EACE,uBAAA;AhG20/CN;;AgGr0/CE;EACE,UAAA;AhGw0/CJ;;AgGj0/CE;EACE,6DAAA;EACA,2BAAA;AhGo0/CJ;AgG/z/CM;EACE,6DAAA;EACA,2BAAA;AhGi0/CR;AgG5z/CY;EACE,6DAAA;EACA,2BAAA;AhG8z/Cd;AgGrz/CI;EACE,6DAAA;AhGuz/CN;;AgG/y/CE;EACE,6DAAA;EACA,2BAAA;AhGkz/CJ;AgG7y/CM;EACE,6DAAA;EACA,2BAAA;AhG+y/CR;AgG1y/CY;EACE,6DAAA;EACA,2BAAA;AhG4y/Cd;AgGpy/CI;EACE,6DAAA;AhGsy/CN;;AgG9x/CE;EACE,6DAAA;EACA,2BAAA;AhGiy/CJ;AgG5x/CM;EACE,6DAAA;EACA,2BAAA;AhG8x/CR;AgGzx/CY;EACE,6DAAA;EACA,2BAAA;AhG2x/Cd;AgGnx/CI;EACE,6DAAA;AhGqx/CN;;AgG7w/CE;EACE,6DAAA;EACA,2BAAA;AhGgx/CJ;AgG3w/CM;EACE,6DAAA;EACA,2BAAA;AhG6w/CR;AgGxw/CY;EACE,6DAAA;EACA,2BAAA;AhG0w/Cd;AgGlw/CI;EACE,6DAAA;AhGow/CN;;AgG7v/CE;EACE,uGAAA;EACA,2BAAA;AhGgw/CJ;AgG3v/CM;EACE,uGAAA;EAKA,2BAAA;AhGyv/CR;AgGpv/CY;EACE,uGAAA;EAKA,2BAAA;AhGkv/Cd;AgG1u/CI;EACE,6DAAA;AhG4u/CN;;AgGvu/CA;EACE,YAAA;EACA,WAAA;AhG0u/CF;;AgGru/CI;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AhGwu/CN;AgGru/CI;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AhGuu/CN;AgGnu/CE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;AhGqu/CJ;;AgGhu/CE;EACE,0DAAA;AhGmu/CJ;;AgG9t/CE;EACE,0DAAA;AhGiu/CJ;;AgG5t/CE;EACE,0DAAA;AhG+t/CJ;;AgG1t/CE;EACE,0DAAA;AhG6t/CJ;;AgGzt/CA;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AhG4t/CF;;AgGzt/CA;EACE,WAAA;EACA,YAAA;AhG4t/CF;;AgG1t/CA;EACE,yBpFh3BK;AZ6khDP;;AgG3t/CA;EACE,6DAAA;EACA,2BAAA;AhG8t/CF;;AgG5t/CA;EACE,6DAAA;EACA,2BAAA;AhG+t/CF;;AgG7t/CA;EACE,6DAAA;AhGgu/CF;;AgG9t/CA;EACE,6DAAA;AhGiu/CF;;AgG/t/CA;EACE,uGAAA;AhGku/CF;;AiG/shDA;EACI,gBrFuCQ;EqFtCR,yBAAA;EACA,mDrFylBS;EqFxlBT,gBrFmBY;EqFlBZ,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AjGkthDJ;AiGhthDI;EACI,SAAA;EACA,UAAA;AjGkthDR;AiG7shDQ;EACI,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,crFqBM;AZ0rhDlB;AiG9shDY;EACI,eAAA;AjGgthDhB;AiG9shDY;EACI,crFiBS;EqFhBT,6BAAA;AjGgthDhB;AiG5shDQ;EACI,crFUM;AZoshDlB;AiG7shDY;EACI,crFSS;AZsshDzB;AiG1shDY;EACI,crFGS;AZyshDzB;AiGtshDc;EACM,crFJK;EqFKL,6BAAA;AjGwshDpB;;AiGhshDI;EACI,OAAA;AjGmshDR;;AoBjshDI;E6EKI;;IAEI,cAAA;EjGgshDV;AACF;AoBxshDI;E6EiBgB;IACI,eAAA;EjG0rhDtB;EiGprhDM;IACI,sBAAA;IACA,gBAAA;EjGsrhDV;EiGhrhDc;IACI,SAAA;IACA,WAAA;EjGkrhDlB;EiG/qhDU;IACI,aAAA;IACA,kCAAA;EjGirhDd;EiG9qhDkB;IACI,WAAA;IACA,2CAAA;IACA,kBAAA;EjGgrhDtB;EiG3qhDkB;IACI,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,aAAA;EjG6qhDtB;EiGvqhDc;IACI,cAAA;EjGyqhDlB;EiGpqhDM;IACI,cAAA;EjGsqhDV;EiGlqhDE;IACI,aAAA;EjGoqhDN;AACF;AiGjqhDA;EACI,qBAAA;AjGmqhDJ;AiGjqhDI;EACI,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;AjGmqhDR;;AoBlvhDI;E6E0FoB;IACI,WAAA;IACA,UAAA;EjG4phD1B;AACF;AoBzvhDI;E6EwGI;IACI,crF/HI;EZmxhDd;EiGnphDU;IACI,crFjIA;EZsxhDd;EiGjphDM;IACI,arFvIG;EZ0xhDb;EiG/ohDE;IACI,iBAAA;IACA,gBAAA;IACA,UAAA;EjGiphDN;EiG/ohDU;IACI,uBAAA;EjGiphDd;EiG5ohDU;IACI,6BAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EjG8ohDd;EiG7ohDc;IACI,WAAA;EjG+ohDlB;EiG7ohDkB;IACI,WAAA;EjG+ohDtB;EiG1ohDU;IACI,kBAAA;IACA,6BAAA;EjG4ohDd;EiG1ohDc;IAEI,crF/Gb;EZ0vhDL;EiGrohDU;IACI,WAAA;IACA,kBAAA;EjGuohDd;AACF;AoBhzhDI;E6EmLQ;IACI,crF7LA;EZ6zhDd;EiG7nhDU;IACI,arFlMD;EZi0hDb;EiG3nhDM;IACI,yBrF5IL;EZywhDL;EiG1nhDc;IACI,+BAAA;EjG4nhDlB;EiG1nhDkB;IACI,+BAAA;EjG4nhDtB;EiGtnhDkB;IACQ,0CAAA;EjGwnhD1B;AACF;AiG7mhDI;EACI,yBrFvKD;EqFwKC,gBAAA;AjG+mhDR;AiG5mhDI;EACI,aAAA;AjG8mhDR;AiG3mhDI;EACI,cAAA;AjG6mhDR;AiGxmhDQ;EACI,2CAAA;EACA,WrFrNJ;AZ+zhDR;AiGxmhDQ;;EAEI,+BAAA;AjG0mhDZ;AiGvmhDI;EACI,crF9QiB;AZu3hDzB;AiGvmhDQ;EACI,crFjRa;AZ03hDzB;AiGnmhDY;EACI,0CAAA;AjGqmhDhB;AiGjmhDQ;EACI,oCAAA;AjGmmhDZ;AiG9lhDQ;EACI,crFnSa;AZm4hDzB;AoBr2hDI;E6E0QI;IACI,yBrF1NL;EZwzhDL;EiG3lhDc;IACI,+BAAA;EjG6lhDlB;EiG3lhDkB;IACI,+BAAA;EjG6lhDtB;EiGvlhDoB;IACM,0CAAA;EjGylhD1B;AACF;;AkG96hDA;EACE,yBtFwDc;AZy3hDhB;AkGh7hDE;EACE,yBtFsdM;EsFrdN,iBtFoDiB;EsFnDjB,cAAA;EACA,mDtFslBS;AZ41gDb;AkG/6hDE;EACE,+BAAA;EACA,cAAA;AlGi7hDJ;AkG76hDI;EACE,8BAAA;EACA,cAAA;AlG+6hDN;AkG76hDI;EACE,kBtFRwB;AZu7hD9B;AkG16hDI;EACE,+BAAA;EACA,WtFhBa;AZ47hDnB;AkG36hDM;EAHF;IAII,OAAA;ElG86hDN;AACF;AkG16hDE;EACE,cAAA;EACA,+BAAA;AlG46hDJ;AkGx6hDI;EACE,8BAAA;AlG06hDN;;AkGl6hDE;;;EAGE,eAAA;AlGq6hDJ;AkGn6hDE;;EAEE,iBAAA;AlGq6hDJ;;AkG95hDE;EACE;;;IAGE,kBAAA;ElGi6hDJ;AACF;AkG75hDI;EACE;;IAEE,kBAAA;ElG+5hDN;EkG75hDI;IACE,kBAAA;ElG+5hDN;AACF;;AmGj/hDA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;AnGo/hDJ;;AmGl/hDE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;AnGq/hDJ;;AmGn/hDE;EACE,oCAAA;EAIA,6KAAA;AnGs/hDJ;;AmGp/hDE;EACE,8BAAA;AnGu/hDJ;;AmGr/hDE;EACE,oCAAA;AnGw/hDJ;;AmGt/hDE;EAIE,2BAAA;AnGy/hDJ;;AmGv/hDE;;EAME,wBAAA;EACA,2EAAA;AnG0/hDJ;;AmGx/hDE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AnG2/hDJ;;AmGz/hDE;EACE,qBAAA;EACA,oBAAA;AnG4/hDJ;;AmG1/hDE;EACE,SAAA;EACA,qBAAA;AnG6/hDJ;;AmG3/hDE;EACE,oBAAA;EACA,sBAAA;AnG8/hDJ;;AmG5/hDE;EACE,UAAA;AnG+/hDJ;;AmG7/hDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AnGggiDJ;;AmG9/hDE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AnGigiDJ;;AmG//hDE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;AnGkgiDJ;;AmGhgiDE;EAEE,+CAAA;AnGmgiDJ;;AmGjgiDE;EACE,cAAA;AnGogiDJ;;AmGhgiDI;EACI,0CAAA;AnGmgiDR;;AmG9/hDI;EACI,yCAAA;AnGigiDR;;AmG7/hDI;EACI,yCAAA;AnGggiDR;;AmG5/hDI;EACI,yCAAA;AnG+/hDR;;AmG3/hDI;EACI,yCAAA;AnG8/hDR;;AmG1/hDI;EACI,0CAAA;AnG6/hDR;;AoG9piDA;EACE,YAAA;EACA,WAAA;ApGiqiDF;;AoG9piDA;EACE,YAAA;EACA,WAAA;ApGiqiDF;;AoG9piDA;EACE,cAAA;EACA,aAAA;ApGiqiDF;;AoG9piDA;EACE,YAAA;EACA,WAAA;ApGiqiDF;;AoG9piDA;EACE,cAAA;EACA,aAAA;ApGiqiDF;;AoG9piDA;EACE,mBAAA;EACA,yBxFiFK;EwFhFL,WxFkDM;EwFjDN,aAAA;EACA,gBxF8BU;EwF7BV,YAAA;EACA,uBAAA;EACA,WAAA;ApGiqiDF;;AoG7piDA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;ApGgqiDF;AoG/piDE;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;ApGiqiDJ;AoGhqiDI;EACE,kBAAA;EACA,2BAAA;ApGkqiDN;;AqGhtiDI;EACI,aAAA;EACA,kBAAA;EACA,yBzF4EG;EyF3EH,kBAAA;EACA,czF8EG;EyF7EH,gBzFqDe;EyFpDf,mBAAA;EACA,8BAAA;ArGmtiDR;AqGhtiDgB;EACI,iBAAA;ArGktiDpB;AqG7siDQ;EACI,qBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBzFqDJ;EyFpDI,kBAAA;EACA,kBAAA;ArG+siDZ;AqGtsiDgB;EACI,iBAAA;ArGwsiDpB;AqGjsiDI;EACI,czFuCG;AZ4piDX;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsGhviDA;EACE,0BAAA;AtGmviDF;;AsG9uiDA;EACE,gB1FSU;AZwuiDZ;;AsG9uiDA;EACE,gB1FMqB;AZ2uiDvB;;AsG5uiDA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,c1FgBS;E0FfT,kBAAA;EACA,oBAAA;AtG+uiDF;AsG9uiDE;EACE,c1FaO;E0FZP,yB1FQO;AZwuiDX;;AsG3uiDA;EACE,eAAA;AtG8uiDF;;AsG5uiDA;EACE,eAAA;AtG+uiDF;;AsG7uiDA;EACE,gBAAA;AtGgviDF;;AsG9uiDA;EACE,gBAAA;AtGiviDF;;AsG9uiDA;EACE,gBAAA;AtGiviDF;;AsG5uiDA;EACE,aAAA;EACA,uBAAA;AtG+uiDF;;AsG5uiDA;EACE,SAAA;AtG+uiDF;;AsGzuiDE;EACE,eAAA;EACA,wBAAA;EACA,0FAAA;AtG4uiDJ;;AuG31iDA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sB3FwEI;E2FvEJ,aAAA;AvG81iDJ;;AuG31iDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;AvG81iDJ;;AuG31iDA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kDAAA;AvG81iDJ;;AuG31iDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,iDAAA;AvG81iDJ;AuG71iDI;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yB3FqED;E2FpEC,mBAAA;EACA,wDAAA;AvG+1iDR;AuG51iDI;EACI,sBAAA;AvG81iDR;AuG71iDQ;EACI,sBAAA;AvG+1iDZ;AuG51iDI;EACI,oBAAA;AvG81iDR;AuG71iDQ;EACI,oBAAA;AvG+1iDZ;AuG51iDI;EACI,sBAAA;AvG81iDR;AuG71iDQ;EACI,sBAAA;AvG+1iDZ;AuG51iDI;EACI,sBAAA;AvG81iDR;AuG71iDQ;EACI,sBAAA;AvG+1iDZ;AuG51iDI;EACI,sBAAA;AvG81iDR;AuG71iDQ;EACI,sBAAA;AvG+1iDZ;AuG51iDI;EACI,sBAAA;AvG81iDR;AuG71iDQ;EACI,sBAAA;AvG+1iDZ;;AuG11iDA;EACI;IACI,yBAAA;EvG61iDN;AACF;AuG11iDA;EACI;IACI,yBAAA;EvG41iDN;AACF;AuGz1iDA;EACI;IACI,qBAAA;EvG21iDN;EuGz1iDE;IACI,mBAAA;EvG21iDN;AACF;AwG37iDE;;;;EACE,gBAAA;AxGg8iDJ;;AwG57iDA;EACE,kBAAA;EACA,gBAAA;AxG+7iDF;;AwG17iDA;EACE,eAAA;EACA,qBAAA;EACA,oB5Fq7ByB;AZwghD3B;AwG57iDE;EACE,YAAA;EACA,cAAA;EACA,oBAAA;AxG87iDJ;AwG37iDE;EACE,cAAA;AxG67iDJ;;AwGt7iDE;EACE,iBAAA;EACA,sB5F0CI;AZ+4iDR;AwGv7iDI;EACE,YAAA;AxGy7iDN;AwGt7iDI;EACE,iCAAA;AxGw7iDN;AwGt7iDM;EACE,sBAAA;AxGw7iDR;AwGr7iDM;EACE,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,oBAAA;EACA,SAAA,EAAA,aAAA;EACA,eAAA;EACA,c5F8BG;AZy5iDX;;AwG96iDE;EACE,sB5FYI;E4FXJ,kBAAA;AxGi7iDJ;AwG/6iDI;EACE,YAAA;AxGi7iDN;AwG96iDI;EACE,iCAAA;AxGg7iDN;AwG96iDM;EACE,sBAAA;AxGg7iDR;AwG76iDM;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AxG+6iDR;;AwGp6iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZq3iDf;;AwGh6iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZ03iDf;AwGl6iDQ;EACE,yB5FuCK;AZ63iDf;;AwGj7iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZk4iDf;;AwG76iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZu4iDf;AwG/6iDQ;EACE,yB5FuCK;AZ04iDf;;AwG97iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZ+4iDf;;AwG17iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZo5iDf;AwG57iDQ;EACE,yB5FuCK;AZu5iDf;;AwG38iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZ45iDf;;AwGv8iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZi6iDf;AwGz8iDQ;EACE,yB5FuCK;AZo6iDf;;AwGx9iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZy6iDf;;AwGp9iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZ86iDf;AwGt9iDQ;EACE,yB5FuCK;AZi7iDf;;AwGr+iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZs7iDf;;AwGj+iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZ27iDf;AwGn+iDQ;EACE,yB5FuCK;AZ87iDf;;AwGl/iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZm8iDf;;AwG9+iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZw8iDf;AwGh/iDQ;EACE,yB5FuCK;AZ28iDf;;AwG//iDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZg9iDf;;AwG3/iDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZq9iDf;AwG7/iDQ;EACE,yB5FuCK;AZw9iDf;;AwG5gjDM;EACE,yB5FmDO;E4FlDP,qB5FkDO;AZ69iDf;;AwGxgjDM;EACE,qB5F0CO;E4FzCP,yB5FyCO;AZk+iDf;AwG1gjDQ;EACE,yB5FuCK;AZq+iDf;;AwGrgjDA;EACE,eAAA;EACA,gBAAA;AxGwgjDF;;AwGngjDA;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;AxGsgjDF;AwGrgjDE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AxGugjDJ;AwGpgjDE;EACE,sBAAA;AxGsgjDJ;;AwGlgjDA;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;AxGqgjDF;AwGpgjDE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AxGsgjDJ;;AwGlgjDA;EACE,kBAAA;AxGqgjDF;;AwGhgjDA;;EAEE,sB5FnFM;E4FoFN,qB5FhFS;E4FiFT,c5F9ES;AZiljDX;;AwG//iDE;EACE,c5FlFO;E4FmFP,qB5FzFO;E4F0FP,yB5F1FO;AZ4ljDX;AwG7/iDI;;EACE,yB5FhGK;AZgmjDX;;AwGv/iDI;EACE,4CAAA;EACA,qB5F3GK;AZqmjDX;;AwGr/iDA;EACE,yBAAA;AxGw/iDF;;AwGr/iDA;EACE,oCAAA;AxGw/iDF;;AyG5rjDI;EACI,gBAAA;EACA,kBAAA;AzG+rjDR;AyG9rjDQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,0CAAA;EACA,UAAA;EACA,wBAAA;EACA,SAAA;EACA,oBAAA;AzGgsjDZ;AyG7rjDQ;EACI,WAAA;EACA,WAAA;EACA,oBAAA;AzG+rjDZ;AyGzrjDY;EACI,UAAA;AzG2rjDhB;;A0GptjDA;EACI,iBAAA;EACA,oBAAA;A1GutjDJ;A0GrtjDI;EACI,mBAAA;EACA,gBAAA;A1GutjDR;;A0GjtjDA;EACI,iBAAA;A1GotjDJ;;A0G/sjDA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;A1GktjDJ;;A0G9sjDE;EACE,4BAAA;A1GitjDJ;;A0G5sjDA;EACI,kBAAA;EACA,c9F6CO;AZkqjDX;A0G7sjDI;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,c9FwCK;E8FvCL,oBAAA;A1G+sjDN;A0G5sjDI;EACE,gBAAA;A1G8sjDN;A0G3sjDQ;EACE,c9FuDH;E8FtDG,qBAAA;A1G6sjDV;;A0GnsjDI;EACI,yB9FcG;E8FbH,gBAAA;EACA,iBAAA;EACA,gB9FRI;E8FSJ,kBAAA;A1GssjDR;;A0G/rjDA;EACE,sB9FCM;E8FAN,yBAAA;EACA,sB9FqgBc;E8FpgBd,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A1GksjDF;A0GhsjDE;EACE,eAAA;A1GksjDJ;;A0G9rjDA;EACE,cAAA;A1GisjDF;;A0G7rjDA;EACE,aAAA;A1GgsjDF;A0G/rjDE;EACE,gCAAA;A1GisjDJ;;A0G5rjDE;EACI,gBAAA;A1G+rjDN;A0G9rjDM;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,qDAAA;EACA,yBAAA;EACA,0BAAA;A1GgsjDV;;A2GhzjDA;EACI;;;;;IAKI,wBAAA;E3GmzjDN;E2GjzjDE;;;;;IAKI,UAAA;IACA,SAAA;E3GmzjDN;E2GhzjDE;IACI,SAAA;E3GkzjDN;AACF;A4G10jDA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;A5G40jDF;;A4Gz0jDA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A5G40jDF;;A4Gz0jDA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A5G40jDF;;A4Gz0jDA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A5G40jDF;;A4Gz0jDA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA,EAAA,mFAAA;EACA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;EACA,qBAAA;EACA,uBAAA;A5G40jDF;;A4Gz0jDA;;EAEE,aAAA;A5G40jDF;;A4Gz0jDA;;EAEE,YAAA;EACA,cAAA;A5G40jDF;;A4Gz0jDA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A5G40jDF;;A4Gz0jDA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A5G40jDF;;A4Gz0jDA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A5G40jDF;;A4Gz0jDA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;A5G40jDF;;A4Gz0jDA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;A5G40jDF;;A4Gz0jDA;EACE,mBAAA;A5G40jDF;;A4Gz0jDA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A5G40jDF;;A4Gz0jDA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A5G40jDF;;A4Gz0jDA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;A5G40jDF;;A4Gz0jDA;EACE,MAAA;EACA,WAAA;A5G40jDF;;A4Gz0jDA;EACE,QAAA;EACA,WAAA;A5G40jDF;;A4Gz0jDA;EACE,OAAA;EACA,YAAA;A5G40jDF;;A4Gz0jDA;EACE,YAAA;EACA,SAAA;EACA,UAAA;A5G40jDF;;A4Gz0jDA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A5G40jDF;;A4Gz0jDA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;A5G40jDF;;A4Gz0jDA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A5G40jDF;;A4Gz0jDA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A5G40jDF;;A4Gz0jDA;EACE,YAAA;A5G40jDF;;A6G/hkDA;;oBAAA;AAIA;EACE,qBAAA;EACA,iBAAA;A7GiikDF;;A6G9hkDA;EACE,iBAAA;EACA,cAAA;A7GiikDF;;A6G9hkDA;EACE,iCAAA;A7GiikDF;;A6G9hkDA;;;;;;;EAOE,gCAAA;A7GiikDF;;A6G9hkDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBjG8CM;EiG7CN,cjGoDS;EiGnDT,qBjG8CS;AZm/jDX;;A6G9hkDA;EACE,yBAAA;A7GiikDF;;A6G9hkDA;EACE,gBjGmBqB;AZ8gkDvB;;A8G7kkDA;;oBAAA;AAKA;EACE,yBAAA;A9G8kkDF;;A8G3kkDA;EACI,qCAAA;EACA,oCAAA;A9G8kkDJ;;A+GtlkDI;EACI,aAAA;A/GylkDR;A+GtlkDI;EACI,cnG0GF;EmGzGE,gBnGqDI;AZmikDZ;A+GrlkDI;EACI,sBnGmEA;EmGlEA,cnGoGF;EmGnGE,gBAAA;A/GulkDR;;AgHnmkDA;EACE,sCpGqoBiB;AZi+iDnB;;AgHlmkDE;EACE,8BAAA;EACA,eAAA;AhHqmkDJ;AgHlmkDI;EACE,yBpGgGC;AZogkDP;AgHhmkDE;EACE,mBpGgEO;EoG/DP,qBpG+DO;AZmikDX;AgHhmkDE;EACE,eAAA;EACA,cpG4DO;AZsikDX;AgHhmkDE;EACE,cpGyDO;EoGxDP,mBpGuDO;EoGtDP,eAAA;AhHkmkDJ;AgH/lkDE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AhHimkDJ;;AiHnokDE;EACE,eAAA;EACA,gBrGyDQ;AZ6kkDZ;;AiHlokDA;EACE,eAAA;AjHqokDF;;AiHjokDE;EACE,qBrGwGG;EqGvGH,crGuGG;AZ6hkDP;AiHjokDI;EACE,yBrGiGE;AZkikDR;AiHhokDI;EACE,qCAAA;AjHkokDN;AiH/nkDE;EACE,qBrGwFK;EqGvFL,crGuFK;AZ0ikDT;;AiH5nkDE;EACE,gBAAA;AjH+nkDJ;;AiH1nkDE;EACE,mBrGqEG;AZwjkDP;AiH5nkDI;EACE,mBrGmEC;AZ2jkDP;AiH7nkDM;EAEE,mCAAA;AjH8nkDR;AiHznkDE;EACE,mBrG0DG;AZikkDP;;AiHvnkDA;EACE,qDAAA;AjH0nkDF;;AiHvnkDA;EACE,yBAAA;AjH0nkDF;AiHznkDE;EACE,oCAAA;AjH2nkDJ;;AkHvrkDA;EACE,kBtG4EM;AZ8mkDR;;AkHvrkDA;EACE,eAAA;AlH0rkDF;;AkHvrkDA;EACE,QAAA;AlH0rkDF;;AkHtrkDE;EACE,qBAAA;EACA,sBAAA;AlHyrkDJ;AkHvrkDI;EACE,gBAAA;AlHyrkDN;;AmH1skDA;;eAAA;AAII;EACI,mDvGqlBK;EuGplBL,UAAA;AnH4skDR;AmH3skDQ;EACI,mDvGklBC;EuGjlBD,YAAA;AnH6skDZ;AmHxskDQ;EACE,cAAA;EACA,gBAAA;AnH0skDV;;AmHlskDI;EACI,oCAAA;EACA,oDAAA;AnHqskDR;;AmHvskDI;EACI,oCAAA;EACA,qDAAA;AnH0skDR;;AmH5skDI;EACI,oCAAA;EACA,oDAAA;AnH+skDR;;AmHjtkDI;EACI,oCAAA;EACA,oDAAA;AnHotkDR;;AmHttkDI;EACI,oCAAA;EACA,oDAAA;AnHytkDR;;AmH3tkDI;EACI,oCAAA;EACA,qDAAA;AnH8tkDR;;AmHhukDI;EACI,oCAAA;EACA,oDAAA;AnHmukDR;;AmHrukDI;EACI,oCAAA;EACA,qDAAA;AnHwukDR;;AmH1ukDI;EACI,oCAAA;EACA,kDAAA;AnH6ukDR;;AmHtukDA;EACI,0CAAA;EACA,yBAAA;AnHyukDJ;;AmHtukDA;EACI,aAAA;EACA,4CAAA;EACA,gBAAA;EACA,yBAAA;AnHyukDJ;;AoHpxkDA;EACE,cxG8GI;AZyqkDN;;AoHpxkDA;EACE,qBxG0GI;AZ6qkDN;;AoHpxkDA;EACE,aAAA;EACA,SAAA;EACA,UAAA;ApHuxkDF;AoHtxkDE;EACE,cAAA;ApHwxkDJ;AoHtxkDE;EACE,eAAA;EACA,gBAAA;EACA,cxG6FE;EwG5FF,eAAA;ApHwxkDJ;;AqH3ykDE;EACE,sBzG4EI;EyG3EJ,yBAAA;EACA,YAAA;ArH8ykDJ;AqH7ykDI;EACE,aAAA;ArH+ykDN;AqH5ykDI;EACE,iBAAA;EACA,qBzG4xBgB;EyG3xBhB,czGyEK;AZqukDX;AqH3ykDI;EACE,YAAA;EACA,WAAA;EACA,UAAA;ArH6ykDN;AqH3ykDM;EACE,yDAAA;EACA,2BAAA;ArH6ykDR;AqHzykDI;EACE,czG0DK;AZivkDX;;AqHnykDM;EACE,oEAAA;EACA,sCAAA;ArHsykDR;;AqH/xkDE;EACE,aAAA;EACA,sBzGgCI;AZkwkDR;AqHjykDI;EACE,yBAAA;EACA,sBzG6BE;EyG5BF,czGkCK;EyGjCL,aAAA;ArHmykDN;AqHhykDE;EACE,yBzGqDG;AZ6ukDP;AqHhykDE;EACE,yBzGqBO;EyGpBP,czG2BO;AZuwkDX;AqHjykDI;EACE,yBzG+CC;EyG9CD,WzGgBE;AZmxkDR;;AqH9xkDA;EACE,iBAAA;ArHiykDF;;AqH/xkDA;EAGE,qBzG8tBoB;AZkkjDtB;;AqH7xkDA;EACE,qCAAA;EACA,sBAAA;EACA,mDzG6gBW;AZmxjDb;;AqH5xkDE;EACE,yBAAA;ArH+xkDJ;;AqH1xkDE;EACE,gBAAA;EACA,sBzGbI;EyGcJ,oCAAA;ArH6xkDJ;AqH3xkDI;EACE,oBAAA;ArH6xkDN;AqH3xkDI;EACE,SAAA;EACA,czGdK;AZ2ykDX;AqH5xkDM;EACE,czGhBG;AZ8ykDX;AqH3xkDI;EACE,yBzGzBK;EyG0BL,yBAAA;EACA,kBAAA;EACA,cAAA;ArH6xkDN;;AqHtxkDI;EACE,qBzGlCK;AZ2zkDX;AqHrxkDE;EACE,gBzG5DmB;AZm1kDvB;;AqHjxkDA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;ArHoxkDF;AqHnxkDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ArHqxkDJ;;AqHjxkDA;EACE,eAAA;ArHoxkDF;;AqHjxkDA;;;EAGE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,czGjES;AZq1kDX;AqHlxkDE;;;EACE,iBAAA;ArHsxkDJ;AqHnxkDM;;;EACE,gBAAA;EACA,kCAAA;ArHuxkDR;;AqHhxkDE;;;EAGE,+BAAA;ArHmxkDJ;;AqH/wkDA;EACE,gBAAA;ArHkxkDF;;AqH7wkDA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ArHgxkDF;;AqH7wkDA;EACE,iCAAA;EACA,gCAAA;ArHgxkDF;;AqH7wkDA;EACE,oCAAA;ArHgxkDF;;AqH5wkDE;EACE,wBAAA;ArH+wkDJ;;AqH3wkDA;EACE,yBAAA;ArH8wkDF;;AqH3wkDA;EACE,iCAAA;ArH8wkDF;;AsHx9kDA,eAAA;AACA;EACE,aAAA;AtH29kDF;AsH19kDE;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yB1G0EO;E0GzEP,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gB1G4CQ;E0G3CR,gCAAA;AtH49kDJ;AsH39kDI;EACE,c1GmEK;E0GlEL,6BAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AtH69kDN;AsH19kDI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,yB1GwCK;E0GvCL,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,gCAAA;AtH49kDN;AsHx9kDE;EACE,yB1GyDG;AZi6kDP;;AsHt9kDA;EACE,yB1GoDK;AZq6kDP;AsHx9kDE;EACE,W1GoBI;E0GnBJ,4BAAA;EACA,WAAA;EACA,SAAA;AtH09kDJ;AsHv9kDE;EACE,UAAA;EACA,yB1GcO;AZ28kDX;;AsHr9kDA;EACE,yB1GyCI;AZ+6kDN;;AsHt9kDA;;EAEE,W1GGM;AZs9kDR;;AsHt9kDA;EACE,yB1GoCM;AZq7kDR;;AsHt9kDA;EACE,yBAAA;AtHy9kDF;;AsHt9kDA;EACE,yB1GqBK;AZo8kDP;;AsHt9kDA;EACE,yB1GwBM;AZi8kDR;;AsHt9kDA;EACE,yB1GsBK;AZm8kDP;;AsHt9kDA;EACE,yB1GeO;AZ08kDT;;AsHt9kDA;EACE,yB1GSI;AZg9kDN;;AsHt9kDA;EACE,yB1GrBS;AZ8+kDX;AsHx9kDE;EACE,c1G7BO;AZu/kDX;;AsHt9kDA;EACE,iBAAA;AtHy9kDF;AsHx9kDE;EACE,kBAAA;AtH09kDJ;;AuH7klDA;EACE,sB3G4EM;AZoglDR;AuH/klDE;EACE,uBAAA;EACE,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c3G8EK;AZmglDX;AuH/klDM;EACE,yB3GqEG;AZ4glDX;AuH9klDM;EACE,yB3GoGA;E2GnGA,gBAAA;EACA,eAAA;AvHgllDR;;AuH3klDA;EACE,+BAAA;AvH8klDF;;AuH3klDA;EACE,sB3GmDM;E2GlDN,gCAAA;EACA,c3GwDS;AZshlDX;AuH7klDE;EACE,aAAA;AvH+klDJ;;AuHxklDE;EACE,cAAA;AvH2klDJ;AuHvklDI;EACE,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,yCAAA;AvHyklDN;AuHrklDE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,gC3G4hBY;E2G3hBZ,mC3G2hBY;AZ4ikDhB;;AwHlolDA,eAAA;AAIM;EACE,c5GkFG;AZgjlDX;AwHjolDQ;EACE,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,c5GoGH;E4GnGG,qBAAA;AxHmolDV;AwHholDM;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,c5GqEG;E4GpEH,yBAAA;EACA,sB5G4DA;AZsklDR;AwH5nlDE;EACE,4B5GuDO;AZuklDX;AwH5nlDE;EACE,yB5GoDO;AZ0klDX;;AwHznlDA;EACE,2CAAA;AxH4nlDF;;AwHznlDA;EACE,oBAAA;EACA,8CAAA;AxH4nlDF;;AwHznlDA;EACE,kBAAA;EACA,sBAAA;AxH4nlDF;;AwHtnlDI;EACE,SAAA;EACA,WAAA;AxHynlDN;AwHtnlDI;EACE,SAAA;EACA,WAAA;AxHwnlDN;;AyH/qlDE;EACE,mBAAA;EACA,UAAA;AzHkrlDJ;;AyH7qlDA;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;AzHgrlDF;AyH3qlDM;EACE,gBAAA;AzH6qlDR;AyH1qlDQ;;EAIE,oCAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AzH0qlDV;AyHvqlDQ;;;EAII,mB7G6CD;AZ2nlDX;AyHrqlDQ;;;EAII,c7GyCD;E6GxCC,YAAA;AzHsqlDZ;AyHnqlDQ;EACI,yB7GkCD;AZmolDX;;AyH7plDE;EACE,YAAA;AzHgqlDJ;;AyH3plDE;EACE,sBAAA;EACA,qBAAA;AzH8plDJ;;AyHvplDA;EACE,yBAAA;EACA,gBAAA;EACA,sB7GKM;AZqplDR;AyHxplDE;EACE,YAAA;AzH0plDJ;;AyHnplDI;EACE,sB7GNE;E6GOF,kBAAA;AzHsplDN;AyHpplDM;EACE,0CAAA;EACA,c7GmBD;AZmolDP;AyHnplDM;EACE,yB7GeD;E6GdC,W7GhBA;AZqqlDR;AyHjplDM;EACE,c7GhBG;E6GiBH,YAAA;AzHmplDR;AyH5olDM;EACE,gB7GhDI;AZ8rlDZ;AyH3olDM;EACE,sB7GlCA;AZ+qlDR;;A0HxvlDQ;EACA,0BAAA;EACA,6BAAA;A1H2vlDR;A0HpvlDQ;EACE,yBAAA;EACA,4BAAA;A1HsvlDV;;A2HpwlDA;EACE,oCAAA;A3HuwlDF;;A2HnwlDE;EACE,wCAAA;A3HswlDJ;A2HpwlDI;EACE,iCAAA;EACA,2BAAA;A3HswlDN;A2HpwlDI;EACE,yBAAA;A3HswlDN;A2HrwlDQ;EACI,oCAAA;A3HuwlDZ;A2HnwlDQ;EACI,oCAAA;A3HqwlDZ;A2HjwlDI;EACE,8BAAA;A3HmwlDN;A2HhwlDI;EACE,oCAAA;A3HkwlDN;A2H/vlDI;EACE,yBAAA;A3HiwlDN;A2HhwlDM;EACE,wBAAA;A3HkwlDR;A2H9vlDI;EACE,iCAAA;A3HgwlDN;A2H7vlDI;EACE,yBAAA;A3H+vlDN;A2H5vlDI;EACE,4DAAA;A3H8vlDN;;A2HrvlDE;EACE,qBAAA;A3HwvlDJ;;A2HpvlDA;EACE,gBAAA;A3HuvlDF;A2HtvlDE;EACE,gBAAA;A3HwvlDJ;;A4H1zlDA,aAAA;AACA;EACE,iBAAA;EACA,0BAAA;EACA,gBhHyEM;EgHxEN,kBAAA;A5H6zlDF;A4H3zlDE;EACE,eAAA;EACA,WAAA;A5H6zlDJ;A4H5zlDI;EACE,aAAA;A5H8zlDN;;A6Hx0lDE;EACE,eAAA;EACA,iBAAA;A7H20lDJ;;A6Hn0lDI;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A7Hs0lDN;A6Hp0lDM;EAPF;IAQI,sBAAA;E7Hu0lDN;AACF;A6Hr0lDM;EACE,aAAA;EACA,YAAA;A7Hu0lDR;A6Hp0lDM;EACE,WAAA;A7Hs0lDR;A6Hp0lDQ;EACE,cAAA;EACA,oBAAA;EACA,cjHmDC;EiHlDD,gBjHyBE;EiHvBF,yCAAA;A7Hq0lDV;A6Hj0lDM;EACE,kBAAA;EACA,YAAA;A7Hm0lDR;A6H7zlDI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,cjHqDC;EiHpDD,kBAAA;EACA,kBAAA;EACA,oBAAA;A7H+zlDN;A6H3zlDM;EACE,yCAAA;EACA,cjHqBG;AZwylDX;A6H5zlDQ;EACE,yBjH0CH;EiHzCG,WjHWF;AZmzlDR;A6HvzlDE;EACE,6BAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;A7HyzlDJ;A6HxzlDI;EACE,kBAAA;EACA,YAAA;A7H0zlDN;A6HxzlDI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;A7H0zlDN;A6HpzlDE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;A7HszlDJ;A6HrzlDI;EACI,cAAA;EACA,iBAAA;EACA,eAAA;A7HuzlDR;A6HtzlDU;EACE,qBAAA;EACA,eAAA;A7HwzlDZ;A6HpzlDM;EACE,yBjHFD;EiHGC,kBAAA;EACA,iBAAA;EACA,WjHnCA;AZy1lDR;A6HlzlDQ;EACE,aAAA;EACA,yBjHXH;EiHYG,WjH1CF;EiH2CE,mBAAA;A7HozlDV;A6H9ylDE;EACE,aAAA;EACA,eAAA;A7HgzlDJ;A6H5ylDM;EACE,sBAAA;A7H8ylDR;A6H5ylDQ;EACI,sBAAA;A7H8ylDZ;A6HxylDI;EACE,WAAA;A7H0ylDN;A6HtylDQ;EADJ;IAEM,UAAA;E7HyylDR;AACF;A6HtylDM;EACE,aAAA;A7HwylDR;A6HvylDQ;EAFF;IAGI,UAAA;IACA,kBAAA;E7H0ylDR;AACF;A6HxylDM;EACE,UAAA;A7H0ylDR;;A8H78lDA;;CAAA;AAOE;EACE,iBAAA;A9H48lDJ;A8H18lDI;EAHF;IAII,kBAAA;E9H68lDJ;AACF;A8H38lDI;EACE,kBAAA;EACA,eAAA;A9H68lDN;;A8Ht8lDI;EACE,kBAAA;A9Hy8lDN;A8Hx8lDM;EACE,kBAAA;A9H08lDR;A8Hz8lDQ;EACE,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WlH6CF;EkH5CE,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBlHmEH;AZw4lDP;;A+Hn/lDE;EACE,cAAA;A/Hs/lDJ;A+Hp/lDE;EACE,uBAAA;A/Hs/lDJ;A+Hn/lDI;EACE,yBnH2EK;EmH1EL,cnHsEK;EmHrEL,yBAAA;A/Hq/lDN;A+Hp/lDM;EACE,yBnH+FD;EmH9FC,qBnH8FD;EmH7FC,WnH+DA;EmH9DA,6CAAA;A/Hs/lDR;A+Hn/lDI;EACE,YAAA;A/Hq/lDN;A+Hp/lDM;EACE,QAAA;EACA,0BAAA;EACA,oBAAA;A/Hs/lDR;A+Hj/lDI;EACE,eAAA;EACA,mBAAA;A/Hm/lDN;A+H/+lDE;EACE,kBAAA;EACA,yBAAA;A/Hi/lDJ;A+H/+lDI;EACE,uDAAA;A/Hi/lDN;A+H9+lDI;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;A/Hg/lDN;A+H/+lDM;EACE,+BAAA;EACA,oCAAA;EACA,sBnH4BA;EmH3BA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,wBAAA;A/Hi/lDR;A+H/+lDM;EACE,cnHgBG;EmHfH,qBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;A/Hi/lDR;A+H9+lDI;EACE,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;A/Hg/lDN;A+H9+lDM;EACE,aAAA;A/Hg/lDR;A+H5+lDM;EACE,oBAAA;EACA,aAAA;A/H8+lDR;A+H1+lDM;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;A/H4+lDR;A+Hx+lDM;EACE,yBnHvBG;EmHwBH,mBAAA;A/H0+lDR;A+Ht+lDM;EACE,yBAAA;EACA,qBnHDD;AZy+lDP;A+Ht+lDM;EACE,WnHlCA;AZ0gmDR;A+Hl+lDI;EACE,oBAAA;EACA,yBnHZC;AZg/lDP;A+Hn+lDM;EACE,WnH5CA;AZihmDR;A+Hh+lDE;;;EAGE,mBnHtBG;EmHuBH,qBnHvBG;EmHwBH,WnHtDI;AZwhmDR;A+Hh+lDI;;;EACE,WnHzDE;AZ6hmDR;;A+H99lDE;EAEI;IACE,qBAAA;E/Hg+lDN;AACF;;A+H39lDA;EACE,wBAAA;EACA,8BAAA;A/H89lDF;;AgIpnmDE;EACE,kCpHq7Bc;EoHp7Bd,uBAAA;EACA,yBAAA;EACA,sBpHwEI;EoHvEJ,cpH8EO;EoH7EP,sBpH4kBY;AZ2ilDhB;AgItnmDI;EACE,aAAA;EACA,sCpHw5BqB;AZgukD3B;;AiInomDA;EACI,2BAAA;AjIsomDJ;AiIromDI;EACI,iDAAA;EACA,arH+EG;AZwjmDX;AiIromDI;EACI,cAAA;AjIuomDR;;AiInomDA;;EAEI,iDAAA;AjIsomDJ;;AiInomDA;EACI,gBrH2CQ;AZ2lmDZ;;AiInomDA;EACI,oBAAA;EACA,erH0Cc;AZ4lmDlB;;AiInomDA;EACI,yBAAA;EACA,iDAAA;EACA,0BAAA;AjIsomDJ;;AiInomDA;EACI,qBAAA;AjIsomDJ;;AiIjomDI;;EACI,iDAAA;EACA,arH4CG;AZylmDX;;AkI3qmDA;EACI,aAAA;AlI8qmDJ;;AmIlrmDA,eAAA;AACA;EACE,aAAA;AnIqrmDF;;AmIlrmDA;EACE,iBAAA;EACA,uCAAA;EACA,YAAA;EACA,cvHwES;EuHvET,mDvHolBW;EuHnlBX,kBAAA;AnIqrmDF;;AmIlrmDA;EACE,cvHsES;AZ+mmDX;;AoIlsmDA;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,4CxHwlBc;EwHvlBd,4BAAA;EACA,kBAAA;EACA,gCAAA;ApIqsmDF;;AoIlsmDA;EACE,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,iDAAA;EACA,2BAAA;ApIqsmDF;;AqIptmDA;EACE,wBAAA;EACA,mBzH4ES;EyH3ET,kBAAA;ArIutmDF;;AqIptmDA;EACE,cAAA;EACA,kBAAA;EACA,WzHoEM;EyHnEN,eAAA;EACA,iBAAA;EACA,mBzH+FK;EyH9FL,kBAAA;EACA,kBAAA;ArIutmDF;;AqIptmDA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;ArIutmDF;AqIttmDE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;ArIwtmDJ;AqIttmDE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;ArIwtmDJ;;AsI1vmDA;EACI,YAAA;EACA,mB1HoFO;E0HnFP,c1H4EO;E0H3EP,sC1HmoBe;E0HloBf,oB1HwoBa;E0HvoBb,gBAAA;AtI6vmDJ;;AuInwmDA;EACI,aAAA;AvIswmDJ;AuIrwmDI;EACI,WAAA;AvIuwmDR;;AwIxwmDA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AxI2wmDJ;;AwIrwmDI;EACI,c5HsCQ;AZkumDhB;AwItwmDI;EACI,a5HkCO;AZsumDf;;AwIpwmDA;EACI,sB5H0DI;AZ6smDR;;AwI/vmDQ;EACI,iBAAA;AxIkwmDZ;;AwI3vmDA;EACI,0CAAA;EACA,aAAA;AxI8vmDJ;AwI5vmDI;EAJJ;IAKQ,aAAA;ExI+vmDN;AACF;AwI5vmDI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AxI8vmDR;AwI3vmDI;EACI,oDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AxI6vmDR;;AwIzvmDA;EACI,aAAA;AxI4vmDJ;AwI1vmDI;EAHJ;IAIQ,iBAAA;ExI6vmDN;AACF;;AwItvmDgB;EACI,0CAAA;AxIyvmDpB;AwItvmDoB;EACI,yB5H8BjB;AZ0tmDP;;AyIn0mDI;EACI,mBAAA;EACA,kBAAA;AzIs0mDR;AyIp0mDI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,iBAAA;AzIs0mDR;;AyIh0mDQ;EACI,cAAA;EACA,gBAAA;EACA,c7HgED;AZmwmDX;;AyI5zmDQ;EACI,gBAAA;AzI+zmDZ;AyI7zmDQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AzI+zmDZ;;AyI1zmDA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AzI6zmDJ;;AyItzmDQ;EACI,eAAA;AzIyzmDZ;AyIvzmDY;EACI,yB7HwBL;AZiymDX;;AyIlzmDI;EACI,qBAAA;EACA,kBAAA;EACA,c7HkBG;AZmymDX;AyIpzmDQ;EACI,WAAA;AzIszmDZ;AyIpzmDQ;EACI,c7HoCL;AZkxmDP;AyIrzmDY;EACI,gCAAA;AzIuzmDhB;;AyI9ymDI;EACI,gBAAA;AzIizmDR;AyI9ymDI;EACI,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AzIgzmDR;;AyIvymDQ;EACI,mBAAA;EACA,kBAAA;EACA,sB7H3BJ;E6H4BI,mD7HkfC;AZwzlDb;AyIxymDY;EACI,yB7HDT;AZ2ymDP;AyIxymDY;EACI,eAAA;AzI0ymDhB;;A0I95mDA;;oBAAA;AAGA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;A1Ii6mDF;;A0I95mDA;EACE,kBAAA;A1Ii6mDF;;A0I75mDE;EACE,c9H0EO;E8HzEP,gBAAA;A1Ig6mDJ;A0I95mDE;EACE,eAAA;A1Ig6mDJ;;A0I55mDA;EACE;IACE,WAAA;IACA,WAAA;E1I+5mDF;E0I75mDA;IACE,SAAA;E1I+5mDF;AACF;A0I15mDE;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;A1I45mDJ;A0I35mDI;EACE,yBAAA;EACA,gBAAA;A1I65mDN;;A0Ix5mDA;EACE,aAAA;A1I25mDF;;A0Ix5mDA;EACE,cAAA;EACA,eAAA;A1I25mDF;A0Iz5mDE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;A1I25mDJ;A0Iz5mDI;EACE,c9HuBK;AZo4mDX;A0Ix5mDI;EACE,mB9HgBK;E8HfL,0BAAA;A1I05mDN;A0Iv5mDI;EACE,WAAA;EACA,kBAAA;A1Iy5mDN;A0It5mDI;EACE,YAAA;A1Iw5mDN;A0It5mDM;;;EAGE,cAAA;EACA,WAAA;A1Iw5mDR;A0Ir5mDM;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;A1Iu5mDR;A0Ip5mDM;EACE,wBAAA;A1Is5mDR;A0In5mDM;EACE,gBAAA;EACA,gBAAA;A1Iq5mDR;A0Il5mDM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A1Io5mDR;A0Ih5mDI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;A1Ik5mDN;A0Ih5mDM;;EAEE,kBAAA;EACA,MAAA;A1Ik5mDR;A0I/4mDM;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A1Ii5mDR;A0I94mDM;EACE,QAAA;EACA,YAAA;EACA,kBAAA;A1Ig5mDR;A0I54mDI;EAEE,iCAAA;A1I64mDN;A0Iz4mDE;EACE,yB9HrEO;E8HsEP,gBAAA;EACA,+CAAA;A1I24mDJ;A0I14mDM;EACE,+CAAA;EACA,gBAAA;A1I44mDR;A0It4mDE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;A1Iw4mDJ;A0It4mDI;EACE,UAAA;EACA,eAAA;A1Iw4mDN;A0It4mDI;EACE,UAAA;A1Iw4mDN;A0Ir4mDI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,MAAA;A1Iu4mDN;A0It4mDM;EACE,iBAAA;EACA,oCAAA;EACA,MAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;A1Iw4mDR;;A0Il4mDA;EACE;IACI,YAAA;E1Iq4mDJ;AACF;A2IhlnDI;EAFJ;IAGQ,gBAAA;IACA,gBAAA;E3ImlnDN;AACF;A2IjlnDI;EAPJ;IAQQ,gBAAA;IACA,gBAAA;E3IolnDN;AACF;;A2IhlnDA;EACI,cAAA;A3ImlnDJ;A2IjlnDQ;EACI,cAAA;EACA,iBAAA;EACA,c/H+DD;E+H9DC,gB/HqCA;AZ8inDZ;A2I/knDY;EACI,c/HgFT;AZignDP;A2I7knDQ;EACI,kBAAA;A3I+knDZ;A2I7knDgB;EACI,iBAAA;EACA,c/H+CT;E+H9CS,eAAA;EACA,gB/H4mBC;AZm+lDrB;;A4IrnnDE;EADF;IAEI,gBAAA;E5IynnDF;AACF;A4IvnnDE;EALF;IAMI,gBAAA;E5I0nnDF;AACF;A4IvnnDI;EACE,sBhImEE;AZsjnDR;A4ItnnDI;EACE,iBAAA;A5IwnnDN;;A4IjnnDI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBhIqFA;EgIpFA,kBAAA;EACA,QAAA;A5IonnDN;A4IhnnDE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A5IknnDJ;;A4I7mnDE;EACE,SAAA;A5IgnnDJ;;A4I5mnDA;EACE,SAAA;A5I+mnDF;A4I5mnDM;EACE,sBhI2BA;EgI1BA,yBAAA;EACA,mDhIuiBK;AZukmDb;A4I3mnDI;EACE,cAAA;EACA,kBAAA;EACA,chIyBK;EgIxBL,oBAAA;EACA,6BAAA;EACA,kBAAA;A5I6mnDN;A4I5mnDM;EACE,sBhIcA;EgIbA,yBAAA;EACA,mDhI0hBK;AZolmDb;;A4IpmnDI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,yBhIHK;EgIIL,kBAAA;A5IumnDN;A4IpmnDI;EACE,mDhIogBO;EgIngBP,yBAAA;A5IsmnDN;;A4I/lnDE;EACE,WAAA;A5IkmnDJ;A4I/lnDE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;A5IimnDJ;A4I/lnDI;EACE,sBhI5BE;EgI6BF,kBAAA;EACA,UAAA;EACA,iBAAA;A5IimnDN;A4I9lnDI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,yBhIvCK;EgIwCL,SAAA;A5IgmnDN;A4I9lnDI;EACE,eAAA;A5IgmnDN;A4I7lnDE;EACE,mBAAA;EACA,qBAAA;EACA,kBAAA;A5I+lnDJ;A4I7lnDI;EACE,kBAAA;EACA,yCAAA;EACA,8BAAA;EACA,gBAAA;A5I+lnDN;A4I7lnDM;EACE,gBhI7Ee;EgI8Ef,chI/BD;EgIgCC,kBAAA;A5I+lnDR;A4I3lnDI;EACE,YAAA;A5I6lnDN;A4I5lnDM;EACE,eAAA;EACA,YAAA;EACA,chIjEG;AZ+pnDX;A4I7lnDQ;EAJF;IAKI,aAAA;E5IgmnDR;AACF;A4I7lnDM;EACE,mDhIgcK;EgI/bL,yBAAA;A5I+lnDR;A4I3lnDI;EACE,eAAA;A5I6lnDN;A4IxlnDI;EACE,YAAA;A5I0lnDN;A4IzlnDM;EACE,yBhI1FG;EgI2FH,iBAAA;EACA,8BAAA;A5I2lnDR;A4IzlnDM;EACE,WAAA;A5I2lnDR;A4ItlnDU;EACE,QAAA;EACA,UAAA;A5IwlnDZ;A4I9knDM;EACE,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,chIxFD;EgIyFC,QAAA;EACA,SAAA;EACA,eAAA;A5IglnDR;A4I9knDI;EATE;IAUA,aAAA;E5IilnDJ;AACF;;A4I3knDA;EACE,6BAAA;A5I8knDF;;A4I3knDA;EACE,mBAAA;EACA,oCAAA;EACA,gCAAA;EACA,oBAAA;A5I8knDF;;A4I3knDA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;A5I8knDF;A4I5knDI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;A5I8knDN;;A4IxknDE;EADF;IAEI,eAAA;E5I4knDF;AACF;;A6IxznDA;EACI,yBAAA;EACA,sBAAA;A7I2znDJ;A6I1znDE;EACE,sBjIwEI;AZovnDR;;A8Ij0nDE;EACE,clImFO;AZivnDX;;A8I9znDA;EACE,iBAAA;A9Ii0nDF;;A8I9znDA;EACC,oCAAA;A9Ii0nDD;;A8I9znDA;EACC,oCAAA;A9Ii0nDD;;A8I9znDA;EACE,8BAAA;A9Ii0nDF;;A8I9znDA;EACE,6BAAA;A9Ii0nDF;;A+I11nDA;EACI;IACI,kBAAA;E/I61nDN;E+I51nDM;IACI,iBAAA;IACA,oCAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,QAAA;IACA,QAAA;IACA,2BAAA;IACA,yBnI4FL;ImI3FK,WnI6DJ;ImI5DI,UAAA;IACA,YAAA;E/I81nDV;AACF;A+Iz1nDA;EACI,yBAAA;EACA,aAAA;A/I21nDJ;;A+Ip1nDI;EACI,iBAAA;A/Iu1nDR;A+It1nDQ;EACI,gBAAA;A/Iw1nDZ;;A+Il1nDA;;mBAAA;AAIA;EACI,kBAAA;EACA,iBAAA;EACA,oBAAA;A/Io1nDJ;A+Il1nDI;EACI,iCAAA;A/Io1nDR;;A+Ih1nDA;EACI,cnI0BO;EmIzBP,kBAAA;A/Im1nDJ;;A+I70nDA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,iDAAA;A/Ig1nDJ;A+I90nDI;EARJ;IASQ,sBnIlCI;EZm3nDV;AACF;A+I/0nDI;EACI,iBAAA;EACA,oBAAA;A/Ii1nDR;A+Ih1nDQ;EACI,aAAA;A/Ik1nDZ;A+Ij1nDY;EAFJ;IAGQ,cAAA;E/Io1nDd;AACF;A+Il1nDQ;EACI,cAAA;A/Io1nDZ;A+In1nDY;EAFJ;IAGQ,aAAA;E/Is1nDd;AACF;A+I/0nDY;EACI,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBnIzCJ;EmI0CI,oBAAA;A/Ii1nDhB;A+I/0nDgB;EAPJ;IAQQ,cnIhFA;EZk6nDlB;AACF;A+Ih1nDgB;EACI,+BAAA;A/Ik1nDpB;A+Ih1nDoB;EAHJ;IAIQ,cnIJjB;EZu1nDL;AACF;A+Ih1nDgB;EAnBJ;IAoBQ,4BAAA;E/Im1nDlB;AACF;A+I90nDI;EACI,sBnIpFI;EmIqFJ,mDnI+dK;AZi3mDb;A+I/0nDQ;EACI,iBAAA;A/Ii1nDZ;A+I/0nDY;EACI,cnIhFA;AZi6nDhB;A+I/0nDY;EACI,anIpFD;AZq6nDf;A+I30nDgB;EACI,iBAAA;EACA,cnIpHA;AZi8nDpB;A+I50nDoB;EACI,cnInCjB;AZi3nDP;;A+It0nDA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,sBnIxEI;AZi5nDR;;A+It0nDA;EACI,kBAAA;EACA,qBAAA;A/Iy0nDJ;A+Iv0nDI;EACI,0DAAA;EACA,sBAAA;EACA,wBAAA;A/Iy0nDR;A+It0nDI;EAVJ;IAWQ,kBAAA;IACA,oBAAA;E/Iy0nDN;AACF;A+Iv0nDI;EACI,eAAA;A/Iy0nDR;A+Ix0nDQ;EAFJ;IAGQ,eAAA;E/I20nDV;AACF;A+Ix0nDI;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;A/I00nDR;A+Iz0nDQ;EAJJ;IAKQ,cAAA;E/I40nDV;AACF;A+I30nDQ;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBnIxHJ;AZq8nDR;A+I30nDY;EARJ;IASQ,qBAAA;IACA,UAAA;IACA,mBAAA;E/I80nDd;AACF;A+I50nDY;EACI,yBnI/HL;EmIgIK,eAAA;EACA,YAAA;EACA,eAAA;A/I80nDhB;A+Iz0nDI;EACI,iBAAA;A/I20nDR;A+Iz0nDQ;EACI,iBAAA;A/I20nDZ;A+Ix0nDQ;EACI,kBAAA;EACA,iBAAA;EACA,cnI5ID;EmI6IC,YAAA;EACA,eAAA;EACA,gBnIxKA;AZk/nDZ;;A+Il0nDA;EACI,kBAAA;EACA,YAAA;A/Iq0nDJ;;A+I9znDI;EACI,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;A/Ii0nDR;;A+I1znDA;EACI,YAAA;A/I6znDJ;;A+IrznDQ;EACI,cnItLD;EmIuLC,eAAA;A/IwznDZ;;A+IhznDI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;A/ImznDR;;A+I7ynDA;EACI,oBAAA;EACA,yBnIhRc;EmIiRd,+BAAA;A/IgznDJ;A+I9ynDI;EACI,+BAAA;A/IgznDR;A+I3ynDY;EACI,cAAA;EACA,+BAAA;EACA,mBAAA;EACA,oBAAA;A/I6ynDhB;A+I5ynDgB;EACI,+BAAA;A/I8ynDpB;A+ItynDQ;EACI,cAAA;EACA,+BAAA;EACA,iBAAA;EACA,iDAAA;A/IwynDZ;A+IvynDY;EACI,+BAAA;EACA,eAAA;A/IyynDhB;A+ItynDY;EACI,cAAA;A/IwynDhB;A+IrynDY;EACI,iBAAA;EACA,gBAAA;A/IuynDhB;A+IlynDI;EACI,sCAAA;A/IoynDR;;AgJhnoDA;EACI,eAAA;EACA,gBpI2DmB;EoI1DnB,kBAAA;EACA,aAAA;AhJmnoDJ;AgJlnoDI;EACI,eAAA;EACA,gBpI4oBa;EoI3oBb,cAAA;EACA,gBAAA;AhJonoDR;;AgJhnoDA;EACI,UAAA;AhJmnoDJ;;AiJjooDA,kDAAA;AAKQ;EACI,kBAAA;EACA,cAAA;AjJgooDZ;AiJ9noDY;EACI,kBAAA;AjJgooDhB;AiJ/noDgB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iCAAA;AjJiooDpB;AiJ/noDgB;EACI,kBAAA;EACA,sBrIwDZ;EqIvDY,YAAA;AjJiooDpB;AiJ5noDgB;EACI,yCAAA;AjJ8noDpB;AiJznoDgB;EACI,yCAAA;AjJ2noDpB;AiJ1noDoB;EACI,gBAAA;AjJ4noDxB;;AiJnnoDA,gDAAA;AAEA;EACI,+BAAA;EACA,cAAA;AjJqnoDJ;AiJpnoDI;EACI,kBAAA;EACA,0BAAA;AjJsnoDR;AiJpnoDQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AjJsnoDZ;AiJpnoDQ;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;AjJsnoDZ;AiJlnoDY;EACI,crIsCT;AZ8koDP;AiJhnoDQ;EACI,mBAAA;AjJknoDZ;;AkJxroDI;EACI,kBAAA;AlJ2roDR;AkJzroDQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBtIoED;EsInEC,SAAA;EACA,UAAA;EACA,SAAA;AlJ2roDZ;;AkJlroDA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;AlJqroDJ;;AmJxtoDA;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;AnJ2toDF;;AmJxtoDA;EACE,SAAA;EACA,iBAAA;AnJ2toDF;;AmJxtoDA;EACE,eAAA;EACA,mBAAA;AnJ2toDF;;AmJxtoDA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;AnJ2toDF;;AmJxtoDA;EACE,gBAAA;EACA,mBAAA;AnJ2toDF;;AmJxtoDA;EACE,aAAA;AnJ2toDF;;AmJxtoDA;EACE,kBAAA;AnJ2toDF;;AmJztoDA;EACE,mBAAA;AnJ4toDF;;AoJ/voDA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;ApJkwoDF;;AoJ/voDA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;ApJkwoDF;;AoJ/voDA;EACE,WAAA;EACA,mBAAA;ApJkwoDF;;AoJ/voDA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;ApJkwoDF;;AoJ/voDA;EACE,yBAAA;ApJkwoDF;;AoJhwoDA;EACE,cAAA;EACA,eAAA;ApJmwoDF;;AoJjwoDA;EACE,eAAA;EACA,YAAA;ApJowoDF;;AoJjwoDA;EACE,kCAAA;EACA,UAAA;EACA,oBAAA;ApJowoDF;;AoJjwoDA;EACE,SAAA;ApJowoDF;;AoJjwoDA;EACE,2BAAA;EACA,yCAAA;EACA,8BAAA;ApJowoDF;;AqJ3zoDA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;ArJ8zoDF;;AqJ5zoDA;EACE,UAAA;EACA,QAAA;EACA,SAAA;ArJ+zoDF;;AqJ7zoDA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;ArJg0oDF;;AqJ9zoDA;EACE,mBAAA;ArJi0oDF;;AqJ/zoDA;EACE,yBAAA;ArJk0oDF;;AqJh0oDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;ArJm0oDF;;AqJj0oDA;EACE,kBAAA;ArJo0oDF;;AqJl0oDA;EAGE,2BAAA;ArJq0oDF;;AsJl3oDA;EACI,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AtJq3oDJ;;AsJl3oDA;EACI,aAAA;EACA,eAAA;AtJq3oDJ;;AsJl3oDA;EACI,cAAA;EACA,WAAA;EACA,QAAA;AtJq3oDJ;;AsJl3oDA;EACI,QAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AtJq3oDJ;;AsJl3oDA;EACI,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;AtJq3oDJ;;AuJz5oDA;EACE,kBAAA;EACA,oBAAA;AvJ45oDF;;AuJ15oDA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AvJ65oDF;;AuJ35oDA;EACE,SAAA;AvJ85oDF;;AuJ55oDA;EACE,SAAA;AvJ+5oDF;;AuJ75oDA;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AvJg6oDF;;AuJ95oDA;EACE,oBAAA;EACA,gCAAA;EACA,mBAAA;AvJi6oDF;;AuJ/5oDA;EACE,kBAAA;EACA,oBAAA;AvJk6oDF;;AuJ/5oDA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AvJk6oDF;;AuJ/5oDA;;EAEE,kBAAA;EACA,oBAAA;EACA,cAAA;AvJk6oDF;;AuJ/5oDA;;EAEE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AvJk6oDF;;AuJh6oDA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AvJm6oDF;;AuJj6oDA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AvJo6oDF;;AwJt+oDA;EACE,wBAAA;EACA,uBAAA;AxJy+oDF;AwJv+oDE;EAJF;IAKI,wBAAA;IACA,uBAAA;ExJ0+oDF;AACF;AwJx+oDE;EATF;IAUI,wBAAA;IACA,uBAAA;ExJ2+oDF;AACF;AwJz+oDE;EAdF;IAeI,wBAAA;IACA,uBAAA;ExJ4+oDF;AACF;AwJ1+oDE;EAnBF;IAoBI,wBAAA;IACA,uBAAA;ExJ6+oDF;AACF;;AA7+oDE;EACE,aAAA;AAg/oDJ;;AAx+oDQ;EACE,eAAA;AA2+oDV;;AAp+oDA;EACE,UAAA;AAu+oDF;;AAr+oDA;EACE,0BAAA;AAw+oDF;;AAt+oDA;;EAEE,YAAA;AAy+oDF;;AAv+oDA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;AA0+oDF;;AAx+oDA;EACE,kBAAA;EACA,aAAA;AA2+oDF;;AAx+oDA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,mBAAA;AA2+oDF;;AAz+oDA;;EAEE,iCAAA;EACA,6BAAA;AA4+oDF;;AA1+oDA;EACE,yBAAA;AA6+oDF;;AA3+oDA;EACE,sBAAA;AA8+oDF;;AA5+oDA;EACE,wBAAA;AA++oDF;;AA5+oDE;EACE,eAAA;AA++oDJ;;AA5+oDA;EACE,eAAA;AA++oDF;;AA7+oDA;EACE,wCAAA;AAg/oDF;;AA9+oDA;EACE,UAAA;AAi/oDF;;AA/+oDA;EACE,yBAAA;AAk/oDF;;AAh/oDA;EACE,kBAAA;EACA,UAAA;AAm/oDF;;AAj/oDA;EACE,oCAAA;AAo/oDF;;AAj/oDA;EACE,qBAAA;EACA,mBAAA;AAo/oDF;;AAj/oDA;EACE,8BAAA;AAo/oDF;;AAl/oDA;EACE,8BAAA;AAq/oDF;;AAn/oDA;EACE,8BAAA;AAs/oDF;;AAp/oDA;EACE,8BAAA;AAu/oDF;;AAr/oDA;EACE,sBAAA;AAw/oDF;;AAt/oDA;EACE,8BAAA;AAy/oDF;;AAt/oDA;EACE,sBAAA;AAy/oDF;;AAp/oDE;EACE,gBAAA;AAu/oDJ;;AAj/oDE;EACE,2BAAA;AAo/oDJ;AAj/oDE;;;EAGE,wBAAA;AAm/oDJ;;AA/+oDE;EACE,gBAAA;AAk/oDJ;AAh/oDE;EACE,8BAAA;EACA,qBAAA;EACA,sBAAA;AAk/oDJ;;AA3+oDI;EACE,YAAA;EACA,wBAAA;AA8+oDN;;AAz+oDA;EAEI;IACE,sBAAA;EA2+oDJ;AACF;AAv+oDA;EAEI;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EAw+oDJ;AACF;AAj+oDI;EACE,YAAA;EACA,wBAAA;AAm+oDN;;AA99oDA;EAEI;IACE,sBAAA;IACA,eAAA;EAg+oDJ;AACF;AA59oDA;EAEI;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EA69oDJ;AACF;AAx9oDA;;EAEE,uBAAA;EACA,0BAAA;EACA,iBAAA;AA09oDF;;AoBlnpDI;EpB4JF;IACE,yBAAA;IACA,kBAAA;EA09oDF;EAz9oDE;;;IAGE,WAAA;IACA,cAAA;IACA,WAAA;IACA,cAAA;EA29oDJ;EAr9oDM;IACE,WAAA;EAu9oDR;EAl9oDA;IACE,aAAA;EAo9oDF;AACF;AAh9oDA;EACE,0BAAA;AAk9oDF;;AAh9oDA;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;EACA,0FAAA;EAEA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAk9oDF;AAj9oDE;EACE,aAAA;AAm9oDJ;;AA18oDE;EACE,mBY8RgB;AZ+qoDpB;AoB7qpDI;EpB8NJ;IAMI,eAAA;IACA,mBAAA;IACA,UAAA;IACA,SAAA;EA68oDF;EA38oDE;IACE,qBAAA;IACA,WAAA;EA68oDJ;AACF;;AAz8oDA,WAAA;AACA;EACE,aAAA;EACA,gBAAA;AA48oDF;;AA18oDA;EACE,gBAAA;EACA,mBAAA;AA68oDF;;AA38oDA;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;AA88oDF;;AA58oDA;EACE,cAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA+8oDF;;AA78oDA;EACE,sBAAA;EACA,oCAAA;AAg9oDF;;AA98oDA;EACE,wBAAA;AAi9oDF;;AA/8oDA;EACE,aAAA;AAk9oDF;;AA/8oDA;EACE,uBAAA;AAk9oDF;;AAh9oDA;EACE,YAAA;AAm9oDF;;AAj9oDA;EACE,aAAA;AAo9oDF;;AA58oDM;EACE,cAAA;AA+8oDR;;AAz8oDA;EACE,oCAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,yBAAA;EACA,6BAAA;EACA,6BAAA;AA48oDF;;AAx8oDA;EACE,mCAAA;AA28oDF;;AAz8oDA;EACE,0CAAA;AA48oDF;;AAz8oDA,gBAAA;AACA;EACE,qBAAA;AA48oDF","sourcesContent":["@import \"./icons.scss\";\n\n// Dark Theme\n// @import \"./bootstrap-dark.scss\";\n// @import \"./app-dark.scss\";\n\n// Light Theme\n@import \"./bootstrap.scss\";\n@import \"./app.scss\";\n\n// // RTL Mode\n// @import \"./rtl/bootstrap-rtl\";\n// @import \"./rtl/components-rtl\";\n// @import \"./rtl/float-rtl\";\n// @import \"./rtl/general-rtl\";\n// @import \"./rtl/pages-rtl\";\n// @import \"./rtl/plugins-rtl\";\n// @import \"./rtl/spacing-rtl\";\n// @import \"./rtl/structure-rtl\";\n// @import \"./rtl/text-rtl\";\n\nbody {\n  * {\n    outline: none;\n  }\n}\n\n#sidebar-menu {\n  ul {\n    li {\n      a {\n        i {\n          min-width: 2rem;\n        }\n      }\n    }\n  }\n}\n\n.leaflet-pane {\n  z-index: 1;\n}\nsvg > rect:first-child {\n  fill-opacity: 0 !important;\n}\n.dataTables_filter,\n.dataTables_paginate {\n  float: right;\n}\n.rdw-editor-main {\n  border: 1px solid $gray-300;\n  height: 239px;\n  padding-left: 15px;\n}\n.dz-message {\n  text-align: center;\n  padding: 30px;\n}\n// kanban board\n.react-kanban-column {\n  height: 100%;\n  min-height: 28px;\n  display: inline-block;\n  padding: 15px;\n  border-radius: 2px;\n  background-color: rgb(238, 238, 238);\n  margin: 5px;\n  vertical-align: top;\n}\n.fcYNFc,\n.sc-AxmLO.gmtmqV {\n  background-color: $card-bg !important;\n  margin: 0 20px 0 0 !important;\n}\n.task-box {\n  border: 1px solid $border-color;\n}\n.react-datepicker-wrapper {\n  width: 100% !important;\n}\n.ReactModal__Overlay {\n  z-index: 1001 !important;\n}\n.external-event {\n  &:hover {\n    cursor: pointer;\n  }\n}\na:hover {\n  cursor: pointer;\n}\n.rating-container {\n  background-color: transparent !important;\n}\n.input-group-append {\n  z-index: 0;\n}\n.input-color {\n  color: $input-color !important;\n}\n.sketch-picker {\n  position: absolute;\n  z-index: 1;\n}\n.rangeslider__fill {\n  background-color: $primary !important;\n}\n\n.dropdown-menu-end {\n  left: auto !important;\n  right: 0 !important;\n}\n\n.flatpickr-months .flatpickr-month {\n  background: $primary !important;\n}\n.flatpickr-weekdays {\n  background: $primary !important;\n}\nspan.flatpickr-weekday {\n  background: $primary !important;\n}\n.flatpickr-current-month .flatpickr-monthDropdown-months {\n  background: $primary !important;\n}\nspan.flatpickr-weekday {\n  color: $white !important;\n}\n.flatpickr-day.selected {\n  background: $primary !important;\n}\n\n.bs-select select {\n  width: auto !important;\n}\n\n//File-manager\n.file-manager {\n  .table td {\n    padding: 0.35rem;\n  }\n}\n\n//Authenication carousel\n.slider_css {\n  .slide {\n    background: none !important;\n  }\n\n  .carousel-status,\n  .control-next,\n  .control-prev {\n    display: none !important;\n  }\n}\n.carousel {\n  .control-dots {\n    margin: -5px 0px;\n  }\n  .dot {\n    background: #556ee6 !important;\n    width: 9px !important;\n    height: 9px !important;\n  }\n}\n\n//Two verification Page\n.verification {\n  input {\n    &:focus {\n      border: none;\n      outline: none !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .verification {\n    input {\n      width: 40px !important;\n    }\n  }\n}\n\n@media (max-width: 320px) {\n  .verification {\n    input {\n      width: 30px !important;\n      height: 30px !important;\n      font-size: 15px !important;\n    }\n  }\n}\n\n//Two verification Page - 2\n.verification-2 {\n  input {\n    &:focus {\n      border: none;\n      outline: none !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .verification-2 {\n    input {\n      width: 40px !important;\n      font-size: 14px;\n    }\n  }\n}\n\n@media (max-width: 320px) {\n  .verification-2 {\n    input {\n      width: 30px !important;\n      height: 35px !important;\n      font-size: 15px !important;\n    }\n  }\n}\n\n//Calendar\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  padding: 5px !important;\n  font-size: 12px !important;\n  margin-right: 2px;\n}\n\n@include media-breakpoint-down(sm) {\n  .fc-toolbar {\n    display: block !important;\n    text-align: center;\n    .fc-left,\n    .fc-right,\n    .fc-center {\n      float: none;\n      display: block;\n      clear: both;\n      margin: 10px 0;\n    }\n  }\n  .fc {\n    .fc-toolbar {\n      > * {\n        > * {\n          float: none;\n        }\n      }\n    }\n  }\n  .fc-today-button {\n    display: none;\n  }\n}\n\n//Chat Scrollbar\n.ps__rail-y {\n  z-index: 999999 !important;\n}\n.close {\n  background: transparent;\n  border: 0;\n  font-size: 10px;\n  padding: 1.35rem 1.25rem;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width\n    auto no-repeat;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  width: 1em;\n  height: 1em;\n  z-index: 2;\n  span {\n    display: none;\n  }\n}\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $grid-gutter-width;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n/* drawer */\n.react-drawer-drawer {\n  z-index: 9999;\n  background: #fff;\n}\n.drawer-main-menu {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.drawer-menu a i {\n  min-width: 2rem;\n  display: inline-block;\n  min-width: 1.75rem;\n  padding-bottom: 0.125em;\n  font-size: 1.25rem;\n  line-height: 1.40625rem;\n  vertical-align: middle;\n  color: #7f8387;\n  transition: all 0.4s;\n}\n.drawer-menu a {\n  display: block;\n  padding: 0.625rem 1.5rem;\n  color: #545a6d;\n  position: relative;\n  font-size: 13px;\n  transition: all 0.4s;\n}\n.drawer-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n.ReactModal__Overlay {\n  z-index: 5000 !important;\n}\n.rangeslider__handle:focus {\n  outline: none;\n}\n// React Table next css\n.react-bootstrap-table-page-btns-ul {\n  float: right !important;\n}\n.search-label {\n  float: right;\n}\n.react-drawer-overlay {\n  z-index: 9999;\n}\n\n// datatable\n\n.react-bs-table-sizePerPage-dropdown {\n  .dropdown-menu {\n    .dropdown-item {\n      a {\n        display: block;\n      }\n    }\n  }\n}\n\n.rightbar-title .right-bar-toggle {\n  background-color: #444c54 !important;\n  height: 24px !important;\n  width: 24px !important;\n  line-height: 24px !important;\n  display: block !important;\n  color: #eff2f7 !important;\n  text-align: center !important;\n  border-radius: 50% !important;\n}\n\n//rightbar drawer\n.css-sourceMap-modules-importLoaders-1-localIdentName-animate__animated___2O131 {\n  animation-duration: 0.6s !important;\n}\n.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\n\n/*  tui charts**/\n.tui-chart .tui-chart-chartExportMenu-area {\n  z-index: 1 !important;\n}\n","/*\nFile: Icons Css File\n*/\n\n// Plugins\n@import \"custom/plugins/icons\";","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=5.8.55\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=5.8.55\") format(\"embedded-opentype\"), url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=5.8.55\") format(\"woff2\"), url(\"../../../../fonts/materialdesignicons-webfont.woff?v=5.8.55\") format(\"woff\"), url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=5.8.55\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-adobe::before {\n  content: \"\\F0936\";\n}\n\n.mdi-adobe-acrobat::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-amazon::before {\n  content: \"\\F002D\";\n}\n\n.mdi-amazon-alexa::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-auto::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-android-debug-bridge::before {\n  content: \"\\F0033\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-airplay::before {\n  content: \"\\F001F\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F1555\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bandcamp::before {\n  content: \"\\F0675\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-battlenet::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blogger::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolnisi-cross::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buddhism::before {\n  content: \"\\F094B\";\n}\n\n.mdi-buffer::before {\n  content: \"\\F0619\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cash-usd::before {\n  content: \"\\F1176\";\n}\n\n.mdi-cash-usd-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-android::before {\n  content: \"\\F011D\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-erase::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-iphone::before {\n  content: \"\\F0120\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-celtic-cross::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-box-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-check-box-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-christianity::before {\n  content: \"\\F0953\";\n}\n\n.mdi-christianity-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-concourse-ci::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-circle::before {\n  content: \"\\F116B\";\n}\n\n.mdi-currency-usd-circle-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-do-not-disturb::before {\n  content: \"\\F0698\";\n}\n\n.mdi-do-not-disturb-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-douban::before {\n  content: \"\\F069A\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-profile-woman::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-pdf-box-outline::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-file-pdf-outline::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gif::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-photos::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-hinduism::before {\n  content: \"\\F0973\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-currency-usd::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-iframe::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-iframe-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-iframe-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-iframe-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-iframe-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-iframe-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-iframe-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-iframe-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-iframe-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-iframe-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-islam::before {\n  content: \"\\F0979\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-judaism::before {\n  content: \"\\F097A\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-chromebook::before {\n  content: \"\\F0323\";\n}\n\n.mdi-laptop-mac::before {\n  content: \"\\F0324\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laptop-windows::before {\n  content: \"\\F0325\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-edge-legacy::before {\n  content: \"\\F1250\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microsoft-yammer::before {\n  content: \"\\F0789\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-clean::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-pdf-box::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-pharmacy::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-one::before {\n  content: \"\\F041B\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-poll-box::before {\n  content: \"\\F0420\";\n}\n\n.mdi-poll-box-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-sparkles::before {\n  content: \"\\F1545\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-tablet-ipad::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teach::before {\n  content: \"\\F0890\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-telegram::before {\n  content: \"\\F0501\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-clean::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-subject::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-twitter-retweet::before {\n  content: \"\\F0547\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-untappd::before {\n  content: \"\\F0551\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vk::before {\n  content: \"\\F0579\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xamarin-outline::before {\n  content: \"\\F0846\";\n}\n\n.mdi-xing::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-y-combinator::before {\n  content: \"\\F0624\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","@font-face\n{\n    font-family: 'boxicons';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('../../../../fonts/boxicons.eot');\n    src: url('../../../../fonts/boxicons.eot') format('embedded-opentype'),\n    url('../../../../fonts/boxicons.woff2') format('woff2'),\n    url('../../../../fonts/boxicons.woff') format('woff'),\n    url('../../../../fonts/boxicons.ttf') format('truetype'),\n    url('../../../../fonts/boxicons.svg?#boxicons') format('svg');\n}\n.bx\n{\n    font-family: 'boxicons' !important;\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n\n    display: inline-block;\n\n    text-transform: none;\n\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.bx-ul\n{\n    margin-left: 2em;\n    padding-left: 0;\n\n    list-style: none;\n}\n.bx-ul > li\n{\n    position: relative;\n}\n.bx-ul .bx\n{\n    font-size: inherit;\n    line-height: inherit;\n\n    position: absolute;\n    left: -2em;\n\n    width: 2em;\n\n    text-align: center;\n}\n@-webkit-keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@-webkit-keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@-webkit-keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n@keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n                transform: rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n.bx-spin\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n.bx-spin-hover:hover\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n\n.bx-tada\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n.bx-tada-hover:hover\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n\n.bx-flashing\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n.bx-flashing-hover:hover\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n\n.bx-burst\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-burst-hover:hover\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-fade-up\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-up-hover:hover\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-down\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-down-hover:hover\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-left\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-left-hover:hover\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-right\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-fade-right-hover:hover\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-xs\n{\n    font-size: 1rem!important;\n}\n.bx-sm\n{\n    font-size: 1.55rem!important;\n}\n.bx-md\n{\n    font-size: 2.25rem!important;\n}\n.bx-fw\n{\n    font-size: 1.2857142857em;\n    line-height: .8em;\n\n    width: 1.2857142857em;\n    height: .8em;\n    margin-top: -.2em!important;\n\n    vertical-align: middle;\n}\n\n.bx-lg\n{\n    font-size: 3.0rem!important;\n}\n.bx-pull-left\n{\n    float: left;\n\n    margin-right: .3em!important;\n}\n\n.bx-pull-right\n{\n    float: right;\n\n    margin-left: .3em!important;\n}\n.bx-rotate-90\n{\n    transform: rotate(90deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n}\n.bx-rotate-180\n{\n    transform: rotate(180deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n}\n.bx-rotate-270\n{\n    transform: rotate(270deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n}\n.bx-flip-horizontal\n{\n    transform: scaleX(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n}\n.bx-flip-vertical\n{\n    transform: scaleY(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n.bx-border\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n.bx-border-circle\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n\n.bxl-adobe:before {\n  content: \"\\e900\";\n}\n.bxl-algolia:before {\n  content: \"\\e901\";\n}\n.bxl-audible:before {\n  content: \"\\e902\";\n}\n.bxl-figma:before {\n  content: \"\\e903\";\n}\n.bxl-redbubble:before {\n  content: \"\\e904\";\n}\n.bxl-etsy:before {\n  content: \"\\e905\";\n}\n.bxl-gitlab:before {\n  content: \"\\e906\";\n}\n.bxl-patreon:before {\n  content: \"\\e907\";\n}\n.bxl-facebook-circle:before {\n  content: \"\\e908\";\n}\n.bxl-imdb:before {\n  content: \"\\e909\";\n}\n.bxl-jquery:before {\n  content: \"\\e90a\";\n}\n.bxl-pinterest-alt:before {\n  content: \"\\e90b\";\n}\n.bxl-500px:before {\n  content: \"\\e90c\";\n}\n.bxl-airbnb:before {\n  content: \"\\e90d\";\n}\n.bxl-amazon:before {\n  content: \"\\e90e\";\n}\n.bxl-android:before {\n  content: \"\\e90f\";\n}\n.bxl-angular:before {\n  content: \"\\e910\";\n}\n.bxl-apple:before {\n  content: \"\\e911\";\n}\n.bxl-baidu:before {\n  content: \"\\e912\";\n}\n.bxl-behance:before {\n  content: \"\\e913\";\n}\n.bxl-bing:before {\n  content: \"\\e914\";\n}\n.bxl-bitcoin:before {\n  content: \"\\e915\";\n}\n.bxl-blogger:before {\n  content: \"\\e916\";\n}\n.bxl-bootstrap:before {\n  content: \"\\e917\";\n}\n.bxl-chrome:before {\n  content: \"\\e918\";\n}\n.bxl-codepen:before {\n  content: \"\\e919\";\n}\n.bxl-creative-commons:before {\n  content: \"\\e91a\";\n}\n.bxl-css3:before {\n  content: \"\\e91b\";\n}\n.bxl-dailymotion:before {\n  content: \"\\e91c\";\n}\n.bxl-deviantart:before {\n  content: \"\\e91d\";\n}\n.bxl-digg:before {\n  content: \"\\e91e\";\n}\n.bxl-digitalocean:before {\n  content: \"\\e91f\";\n}\n.bxl-discord:before {\n  content: \"\\e920\";\n}\n.bxl-discourse:before {\n  content: \"\\e921\";\n}\n.bxl-dribbble:before {\n  content: \"\\e922\";\n}\n.bxl-dropbox:before {\n  content: \"\\e923\";\n}\n.bxl-drupal:before {\n  content: \"\\e924\";\n}\n.bxl-ebay:before {\n  content: \"\\e925\";\n}\n.bxl-edge:before {\n  content: \"\\e926\";\n}\n.bxl-facebook:before {\n  content: \"\\e927\";\n}\n.bxl-facebook-square:before {\n  content: \"\\e928\";\n}\n.bxl-firefox:before {\n  content: \"\\e929\";\n}\n.bxl-flickr:before {\n  content: \"\\e92a\";\n}\n.bxl-flickr-square:before {\n  content: \"\\e92b\";\n}\n.bxl-foursquare:before {\n  content: \"\\e92c\";\n}\n.bxl-git:before {\n  content: \"\\e92d\";\n}\n.bxl-github:before {\n  content: \"\\e92e\";\n}\n.bxl-google:before {\n  content: \"\\e92f\";\n}\n.bxl-google-plus:before {\n  content: \"\\e930\";\n}\n.bxl-google-plus-circle:before {\n  content: \"\\e931\";\n}\n.bxl-html5:before {\n  content: \"\\e932\";\n}\n.bxl-instagram:before {\n  content: \"\\e933\";\n}\n.bxl-instagram-alt:before {\n  content: \"\\e934\";\n}\n.bxl-internet-explorer:before {\n  content: \"\\e935\";\n}\n.bxl-invision:before {\n  content: \"\\e936\";\n}\n.bxl-javascript:before {\n  content: \"\\e937\";\n}\n.bxl-joomla:before {\n  content: \"\\e938\";\n}\n.bxl-jsfiddle:before {\n  content: \"\\e939\";\n}\n.bxl-kickstarter:before {\n  content: \"\\e93a\";\n}\n.bxl-less:before {\n  content: \"\\e93b\";\n}\n.bxl-linkedin:before {\n  content: \"\\e93c\";\n}\n.bxl-linkedin-square:before {\n  content: \"\\e93d\";\n}\n.bxl-magento:before {\n  content: \"\\e93e\";\n}\n.bxl-mailchimp:before {\n  content: \"\\e93f\";\n}\n.bxl-mastercard:before {\n  content: \"\\e940\";\n}\n.bxl-medium:before {\n  content: \"\\e941\";\n}\n.bxl-medium-old:before {\n  content: \"\\e942\";\n}\n.bxl-medium-square:before {\n  content: \"\\e943\";\n}\n.bxl-messenger:before {\n  content: \"\\e944\";\n}\n.bxl-microsoft:before {\n  content: \"\\e945\";\n}\n.bxl-nodejs:before {\n  content: \"\\e946\";\n}\n.bxl-opera:before {\n  content: \"\\e947\";\n}\n.bxl-paypal:before {\n  content: \"\\e948\";\n}\n.bxl-periscope:before {\n  content: \"\\e949\";\n}\n.bxl-pinterest:before {\n  content: \"\\e94a\";\n}\n.bxl-play-store:before {\n  content: \"\\e94b\";\n}\n.bxl-pocket:before {\n  content: \"\\e94c\";\n}\n.bxl-product-hunt:before {\n  content: \"\\e94d\";\n}\n.bxl-quora:before {\n  content: \"\\e94e\";\n}\n.bxl-react:before {\n  content: \"\\e94f\";\n}\n.bxl-reddit:before {\n  content: \"\\e950\";\n}\n.bxl-redux:before {\n  content: \"\\e951\";\n}\n.bxl-sass:before {\n  content: \"\\e952\";\n}\n.bxl-shopify:before {\n  content: \"\\e953\";\n}\n.bxl-skype:before {\n  content: \"\\e954\";\n}\n.bxl-slack:before {\n  content: \"\\e955\";\n}\n.bxl-slack-old:before {\n  content: \"\\e956\";\n}\n.bxl-snapchat:before {\n  content: \"\\e957\";\n}\n.bxl-soundcloud:before {\n  content: \"\\e958\";\n}\n.bxl-spotify:before {\n  content: \"\\e959\";\n}\n.bxl-squarespace:before {\n  content: \"\\e95a\";\n}\n.bxl-stack-overflow:before {\n  content: \"\\e95b\";\n}\n.bxl-stripe:before {\n  content: \"\\e95c\";\n}\n.bxl-telegram:before {\n  content: \"\\e95d\";\n}\n.bxl-trello:before {\n  content: \"\\e95e\";\n}\n.bxl-tumblr:before {\n  content: \"\\e95f\";\n}\n.bxl-twitch:before {\n  content: \"\\e960\";\n}\n.bxl-twitter:before {\n  content: \"\\e961\";\n}\n.bxl-unsplash:before {\n  content: \"\\e962\";\n}\n.bxl-vimeo:before {\n  content: \"\\e963\";\n}\n.bxl-visa:before {\n  content: \"\\e964\";\n}\n.bxl-vk:before {\n  content: \"\\e965\";\n}\n.bxl-vuejs:before {\n  content: \"\\e966\";\n}\n.bxl-whatsapp:before {\n  content: \"\\e967\";\n}\n.bxl-whatsapp-square:before {\n  content: \"\\e968\";\n}\n.bxl-wikipedia:before {\n  content: \"\\e969\";\n}\n.bxl-windows:before {\n  content: \"\\e96a\";\n}\n.bxl-wix:before {\n  content: \"\\e96b\";\n}\n.bxl-wordpress:before {\n  content: \"\\e96c\";\n}\n.bxl-yahoo:before {\n  content: \"\\e96d\";\n}\n.bxl-yelp:before {\n  content: \"\\e96e\";\n}\n.bxl-youtube:before {\n  content: \"\\e96f\";\n}\n.bx-accessibility:before {\n  content: \"\\e970\";\n}\n.bx-add-to-queue:before {\n  content: \"\\e971\";\n}\n.bx-adjust:before {\n  content: \"\\e972\";\n}\n.bx-alarm:before {\n  content: \"\\e973\";\n}\n.bx-alarm-add:before {\n  content: \"\\e974\";\n}\n.bx-alarm-off:before {\n  content: \"\\e975\";\n}\n.bx-album:before {\n  content: \"\\e976\";\n}\n.bx-align-justify:before {\n  content: \"\\e977\";\n}\n.bx-align-left:before {\n  content: \"\\e978\";\n}\n.bx-align-middle:before {\n  content: \"\\e979\";\n}\n.bx-align-right:before {\n  content: \"\\e97a\";\n}\n.bx-analyse:before {\n  content: \"\\e97b\";\n}\n.bx-anchor:before {\n  content: \"\\e97c\";\n}\n.bx-angry:before {\n  content: \"\\e97d\";\n}\n.bx-aperture:before {\n  content: \"\\e97e\";\n}\n.bx-archive:before {\n  content: \"\\e97f\";\n}\n.bx-archive-in:before {\n  content: \"\\e980\";\n}\n.bx-archive-out:before {\n  content: \"\\e981\";\n}\n.bx-area:before {\n  content: \"\\e982\";\n}\n.bx-arrow-back:before {\n  content: \"\\e983\";\n}\n.bx-at:before {\n  content: \"\\e984\";\n}\n.bx-award:before {\n  content: \"\\e985\";\n}\n.bx-badge:before {\n  content: \"\\e986\";\n}\n.bx-badge-check:before {\n  content: \"\\e987\";\n}\n.bx-ball:before {\n  content: \"\\e988\";\n}\n.bx-band-aid:before {\n  content: \"\\e989\";\n}\n.bx-bar-chart:before {\n  content: \"\\e98a\";\n}\n.bx-bar-chart-alt:before {\n  content: \"\\e98b\";\n}\n.bx-bar-chart-alt-2:before {\n  content: \"\\e98c\";\n}\n.bx-bar-chart-square:before {\n  content: \"\\e98d\";\n}\n.bx-barcode:before {\n  content: \"\\e98e\";\n}\n.bx-basket:before {\n  content: \"\\e98f\";\n}\n.bx-basketball:before {\n  content: \"\\e990\";\n}\n.bx-bath:before {\n  content: \"\\e991\";\n}\n.bx-battery:before {\n  content: \"\\e992\";\n}\n.bx-bed:before {\n  content: \"\\e993\";\n}\n.bx-bell:before {\n  content: \"\\e994\";\n}\n.bx-bell-minus:before {\n  content: \"\\e995\";\n}\n.bx-bell-off:before {\n  content: \"\\e996\";\n}\n.bx-bell-plus:before {\n  content: \"\\e997\";\n}\n.bx-bitcoin:before {\n  content: \"\\e998\";\n}\n.bx-block:before {\n  content: \"\\e999\";\n}\n.bx-bluetooth:before {\n  content: \"\\e99a\";\n}\n.bx-body:before {\n  content: \"\\e99b\";\n}\n.bx-bold:before {\n  content: \"\\e99c\";\n}\n.bx-bolt-circle:before {\n  content: \"\\e99d\";\n}\n.bx-book:before {\n  content: \"\\e99e\";\n}\n.bx-book-bookmark:before {\n  content: \"\\e99f\";\n}\n.bx-book-content:before {\n  content: \"\\e9a0\";\n}\n.bx-bookmark:before {\n  content: \"\\e9a1\";\n}\n.bx-bookmark-minus:before {\n  content: \"\\e9a2\";\n}\n.bx-bookmark-plus:before {\n  content: \"\\e9a3\";\n}\n.bx-bookmarks:before {\n  content: \"\\e9a4\";\n}\n.bx-book-open:before {\n  content: \"\\e9a5\";\n}\n.bx-border-all:before {\n  content: \"\\e9a6\";\n}\n.bx-border-bottom:before {\n  content: \"\\e9a7\";\n}\n.bx-border-left:before {\n  content: \"\\e9a8\";\n}\n.bx-border-radius:before {\n  content: \"\\e9a9\";\n}\n.bx-border-right:before {\n  content: \"\\e9aa\";\n}\n.bx-border-top:before {\n  content: \"\\e9ab\";\n}\n.bx-bot:before {\n  content: \"\\e9ac\";\n}\n.bx-bowling-ball:before {\n  content: \"\\e9ad\";\n}\n.bx-box:before {\n  content: \"\\e9ae\";\n}\n.bx-briefcase:before {\n  content: \"\\e9af\";\n}\n.bx-briefcase-alt:before {\n  content: \"\\e9b0\";\n}\n.bx-briefcase-alt-2:before {\n  content: \"\\e9b1\";\n}\n.bx-brightness:before {\n  content: \"\\e9b2\";\n}\n.bx-brightness-half:before {\n  content: \"\\e9b3\";\n}\n.bx-broadcast:before {\n  content: \"\\e9b4\";\n}\n.bx-brush:before {\n  content: \"\\e9b5\";\n}\n.bx-brush-alt:before {\n  content: \"\\e9b6\";\n}\n.bx-bug:before {\n  content: \"\\e9b7\";\n}\n.bx-bug-alt:before {\n  content: \"\\e9b8\";\n}\n.bx-building:before {\n  content: \"\\e9b9\";\n}\n.bx-building-house:before {\n  content: \"\\e9ba\";\n}\n.bx-buildings:before {\n  content: \"\\e9bb\";\n}\n.bx-bulb:before {\n  content: \"\\e9bc\";\n}\n.bx-bullseye:before {\n  content: \"\\e9bd\";\n}\n.bx-buoy:before {\n  content: \"\\e9be\";\n}\n.bx-bus:before {\n  content: \"\\e9bf\";\n}\n.bx-cake:before {\n  content: \"\\e9c0\";\n}\n.bx-calculator:before {\n  content: \"\\e9c1\";\n}\n.bx-calendar:before {\n  content: \"\\e9c2\";\n}\n.bx-calendar-alt:before {\n  content: \"\\e9c3\";\n}\n.bx-calendar-check:before {\n  content: \"\\e9c4\";\n}\n.bx-calendar-event:before {\n  content: \"\\e9c5\";\n}\n.bx-calendar-minus:before {\n  content: \"\\e9c6\";\n}\n.bx-calendar-plus:before {\n  content: \"\\e9c7\";\n}\n.bx-calendar-x:before {\n  content: \"\\e9c8\";\n}\n.bx-camera:before {\n  content: \"\\e9c9\";\n}\n.bx-camera-off:before {\n  content: \"\\e9ca\";\n}\n.bx-captions:before {\n  content: \"\\e9cb\";\n}\n.bx-car:before {\n  content: \"\\e9cc\";\n}\n.bx-card:before {\n  content: \"\\e9cd\";\n}\n.bx-caret-down:before {\n  content: \"\\e9ce\";\n}\n.bx-caret-left:before {\n  content: \"\\e9cf\";\n}\n.bx-caret-right:before {\n  content: \"\\e9d0\";\n}\n.bx-caret-up:before {\n  content: \"\\e9d1\";\n}\n.bx-carousel:before {\n  content: \"\\e9d2\";\n}\n.bx-cart:before {\n  content: \"\\e9d3\";\n}\n.bx-cart-alt:before {\n  content: \"\\e9d4\";\n}\n.bx-cast:before {\n  content: \"\\e9d5\";\n}\n.bx-certification:before {\n  content: \"\\e9d6\";\n}\n.bx-chalkboard:before {\n  content: \"\\e9d7\";\n}\n.bx-chart:before {\n  content: \"\\e9d8\";\n}\n.bx-chat:before {\n  content: \"\\e9d9\";\n}\n.bx-check:before {\n  content: \"\\e9da\";\n}\n.bx-checkbox:before {\n  content: \"\\e9db\";\n}\n.bx-checkbox-checked:before {\n  content: \"\\e9dc\";\n}\n.bx-checkbox-square:before {\n  content: \"\\e9dd\";\n}\n.bx-check-circle:before {\n  content: \"\\e9de\";\n}\n.bx-check-double:before {\n  content: \"\\e9df\";\n}\n.bx-check-shield:before {\n  content: \"\\e9e0\";\n}\n.bx-check-square:before {\n  content: \"\\e9e1\";\n}\n.bx-chevron-down:before {\n  content: \"\\e9e2\";\n}\n.bx-chevron-left:before {\n  content: \"\\e9e3\";\n}\n.bx-chevron-right:before {\n  content: \"\\e9e4\";\n}\n.bx-chevrons-down:before {\n  content: \"\\e9e5\";\n}\n.bx-chevrons-left:before {\n  content: \"\\e9e6\";\n}\n.bx-chevrons-right:before {\n  content: \"\\e9e7\";\n}\n.bx-chevrons-up:before {\n  content: \"\\e9e8\";\n}\n.bx-chevron-up:before {\n  content: \"\\e9e9\";\n}\n.bx-chip:before {\n  content: \"\\e9ea\";\n}\n.bx-circle:before {\n  content: \"\\e9eb\";\n}\n.bx-clinic:before {\n  content: \"\\e9ec\";\n}\n.bx-clipboard:before {\n  content: \"\\e9ed\";\n}\n.bx-closet:before {\n  content: \"\\e9ee\";\n}\n.bx-cloud:before {\n  content: \"\\e9ef\";\n}\n.bx-cloud-download:before {\n  content: \"\\e9f0\";\n}\n.bx-cloud-drizzle:before {\n  content: \"\\e9f1\";\n}\n.bx-cloud-lightning:before {\n  content: \"\\e9f2\";\n}\n.bx-cloud-light-rain:before {\n  content: \"\\e9f3\";\n}\n.bx-cloud-rain:before {\n  content: \"\\e9f4\";\n}\n.bx-cloud-snow:before {\n  content: \"\\e9f5\";\n}\n.bx-cloud-upload:before {\n  content: \"\\e9f6\";\n}\n.bx-code:before {\n  content: \"\\e9f7\";\n}\n.bx-code-alt:before {\n  content: \"\\e9f8\";\n}\n.bx-code-block:before {\n  content: \"\\e9f9\";\n}\n.bx-code-curly:before {\n  content: \"\\e9fa\";\n}\n.bx-coffee:before {\n  content: \"\\e9fb\";\n}\n.bx-cog:before {\n  content: \"\\e9fc\";\n}\n.bx-collapse:before {\n  content: \"\\e9fd\";\n}\n.bx-collection:before {\n  content: \"\\e9fe\";\n}\n.bx-columns:before {\n  content: \"\\e9ff\";\n}\n.bx-command:before {\n  content: \"\\ea00\";\n}\n.bx-comment:before {\n  content: \"\\ea01\";\n}\n.bx-comment-dots:before {\n  content: \"\\ea02\";\n}\n.bx-compass:before {\n  content: \"\\ea03\";\n}\n.bx-confused:before {\n  content: \"\\ea04\";\n}\n.bx-conversation:before {\n  content: \"\\ea05\";\n}\n.bx-cool:before {\n  content: \"\\ea06\";\n}\n.bx-copy:before {\n  content: \"\\ea07\";\n}\n.bx-copy-alt:before {\n  content: \"\\ea08\";\n}\n.bx-copyright:before {\n  content: \"\\ea09\";\n}\n.bx-credit-card:before {\n  content: \"\\ea0a\";\n}\n.bx-credit-card-alt:before {\n  content: \"\\ea0b\";\n}\n.bx-crop:before {\n  content: \"\\ea0c\";\n}\n.bx-crosshair:before {\n  content: \"\\ea0d\";\n}\n.bx-crown:before {\n  content: \"\\ea0e\";\n}\n.bx-cube:before {\n  content: \"\\ea0f\";\n}\n.bx-cube-alt:before {\n  content: \"\\ea10\";\n}\n.bx-cuboid:before {\n  content: \"\\ea11\";\n}\n.bx-customize:before {\n  content: \"\\ea12\";\n}\n.bx-cut:before {\n  content: \"\\ea13\";\n}\n.bx-cycling:before {\n  content: \"\\ea14\";\n}\n.bx-cylinder:before {\n  content: \"\\ea15\";\n}\n.bx-data:before {\n  content: \"\\ea16\";\n}\n.bx-desktop:before {\n  content: \"\\ea17\";\n}\n.bx-detail:before {\n  content: \"\\ea18\";\n}\n.bx-devices:before {\n  content: \"\\ea19\";\n}\n.bx-dialpad:before {\n  content: \"\\ea1a\";\n}\n.bx-dialpad-alt:before {\n  content: \"\\ea1b\";\n}\n.bx-diamond:before {\n  content: \"\\ea1c\";\n}\n.bx-directions:before {\n  content: \"\\ea1d\";\n}\n.bx-disc:before {\n  content: \"\\ea1e\";\n}\n.bx-dish:before {\n  content: \"\\ea1f\";\n}\n.bx-dislike:before {\n  content: \"\\ea20\";\n}\n.bx-dizzy:before {\n  content: \"\\ea21\";\n}\n.bx-dna:before {\n  content: \"\\ea22\";\n}\n.bx-dock-bottom:before {\n  content: \"\\ea23\";\n}\n.bx-dock-left:before {\n  content: \"\\ea24\";\n}\n.bx-dock-right:before {\n  content: \"\\ea25\";\n}\n.bx-dock-top:before {\n  content: \"\\ea26\";\n}\n.bx-dollar:before {\n  content: \"\\ea27\";\n}\n.bx-dollar-circle:before {\n  content: \"\\ea28\";\n}\n.bx-dots-horizontal:before {\n  content: \"\\ea29\";\n}\n.bx-dots-horizontal-rounded:before {\n  content: \"\\ea2a\";\n}\n.bx-dots-vertical:before {\n  content: \"\\ea2b\";\n}\n.bx-dots-vertical-rounded:before {\n  content: \"\\ea2c\";\n}\n.bx-doughnut-chart:before {\n  content: \"\\ea2d\";\n}\n.bx-down-arrow:before {\n  content: \"\\ea2e\";\n}\n.bx-down-arrow-alt:before {\n  content: \"\\ea2f\";\n}\n.bx-down-arrow-circle:before {\n  content: \"\\ea30\";\n}\n.bx-download:before {\n  content: \"\\ea31\";\n}\n.bx-downvote:before {\n  content: \"\\ea32\";\n}\n.bx-droplet:before {\n  content: \"\\ea33\";\n}\n.bx-dumbbell:before {\n  content: \"\\ea34\";\n}\n.bx-duplicate:before {\n  content: \"\\ea35\";\n}\n.bx-edit:before {\n  content: \"\\ea36\";\n}\n.bx-edit-alt:before {\n  content: \"\\ea37\";\n}\n.bx-envelope:before {\n  content: \"\\ea38\";\n}\n.bx-equalizer:before {\n  content: \"\\ea39\";\n}\n.bx-error:before {\n  content: \"\\ea3a\";\n}\n.bx-error-alt:before {\n  content: \"\\ea3b\";\n}\n.bx-error-circle:before {\n  content: \"\\ea3c\";\n}\n.bx-euro:before {\n  content: \"\\ea3d\";\n}\n.bx-exit:before {\n  content: \"\\ea3e\";\n}\n.bx-exit-fullscreen:before {\n  content: \"\\ea3f\";\n}\n.bx-expand:before {\n  content: \"\\ea40\";\n}\n.bx-export:before {\n  content: \"\\ea41\";\n}\n.bx-extension:before {\n  content: \"\\ea42\";\n}\n.bx-face:before {\n  content: \"\\ea43\";\n}\n.bx-fast-forward:before {\n  content: \"\\ea44\";\n}\n.bx-fast-forward-circle:before {\n  content: \"\\ea45\";\n}\n.bx-female:before {\n  content: \"\\ea46\";\n}\n.bx-female-sign:before {\n  content: \"\\ea47\";\n}\n.bx-file:before {\n  content: \"\\ea48\";\n}\n.bx-file-blank:before {\n  content: \"\\ea49\";\n}\n.bx-file-find:before {\n  content: \"\\ea4a\";\n}\n.bx-film:before {\n  content: \"\\ea4b\";\n}\n.bx-filter:before {\n  content: \"\\ea4c\";\n}\n.bx-filter-alt:before {\n  content: \"\\ea4d\";\n}\n.bx-fingerprint:before {\n  content: \"\\ea4e\";\n}\n.bx-first-aid:before {\n  content: \"\\ea4f\";\n}\n.bx-first-page:before {\n  content: \"\\ea50\";\n}\n.bx-flag:before {\n  content: \"\\ea51\";\n}\n.bx-folder:before {\n  content: \"\\ea52\";\n}\n.bx-folder-minus:before {\n  content: \"\\ea53\";\n}\n.bx-folder-open:before {\n  content: \"\\ea54\";\n}\n.bx-folder-plus:before {\n  content: \"\\ea55\";\n}\n.bx-font:before {\n  content: \"\\ea56\";\n}\n.bx-font-color:before {\n  content: \"\\ea57\";\n}\n.bx-font-family:before {\n  content: \"\\ea58\";\n}\n.bx-font-size:before {\n  content: \"\\ea59\";\n}\n.bx-food-menu:before {\n  content: \"\\ea5a\";\n}\n.bx-food-tag:before {\n  content: \"\\ea5b\";\n}\n.bx-football:before {\n  content: \"\\ea5c\";\n}\n.bx-fridge:before {\n  content: \"\\ea5d\";\n}\n.bx-fullscreen:before {\n  content: \"\\ea5e\";\n}\n.bx-gas-pump:before {\n  content: \"\\ea5f\";\n}\n.bx-ghost:before {\n  content: \"\\ea60\";\n}\n.bx-gift:before {\n  content: \"\\ea61\";\n}\n.bx-git-branch:before {\n  content: \"\\ea62\";\n}\n.bx-git-commit:before {\n  content: \"\\ea63\";\n}\n.bx-git-compare:before {\n  content: \"\\ea64\";\n}\n.bx-git-merge:before {\n  content: \"\\ea65\";\n}\n.bx-git-pull-request:before {\n  content: \"\\ea66\";\n}\n.bx-git-repo-forked:before {\n  content: \"\\ea67\";\n}\n.bx-globe:before {\n  content: \"\\ea68\";\n}\n.bx-globe-alt:before {\n  content: \"\\ea69\";\n}\n.bx-grid:before {\n  content: \"\\ea6a\";\n}\n.bx-grid-alt:before {\n  content: \"\\ea6b\";\n}\n.bx-grid-horizontal:before {\n  content: \"\\ea6c\";\n}\n.bx-grid-small:before {\n  content: \"\\ea6d\";\n}\n.bx-grid-vertical:before {\n  content: \"\\ea6e\";\n}\n.bx-group:before {\n  content: \"\\ea6f\";\n}\n.bx-handicap:before {\n  content: \"\\ea70\";\n}\n.bx-happy:before {\n  content: \"\\ea71\";\n}\n.bx-happy-alt:before {\n  content: \"\\ea72\";\n}\n.bx-happy-beaming:before {\n  content: \"\\ea73\";\n}\n.bx-happy-heart-eyes:before {\n  content: \"\\ea74\";\n}\n.bx-hash:before {\n  content: \"\\ea75\";\n}\n.bx-hdd:before {\n  content: \"\\ea76\";\n}\n.bx-heading:before {\n  content: \"\\ea77\";\n}\n.bx-headphone:before {\n  content: \"\\ea78\";\n}\n.bx-health:before {\n  content: \"\\ea79\";\n}\n.bx-heart:before {\n  content: \"\\ea7a\";\n}\n.bx-help-circle:before {\n  content: \"\\ea7b\";\n}\n.bx-hide:before {\n  content: \"\\ea7c\";\n}\n.bx-highlight:before {\n  content: \"\\ea7d\";\n}\n.bx-history:before {\n  content: \"\\ea7e\";\n}\n.bx-hive:before {\n  content: \"\\ea7f\";\n}\n.bx-home:before {\n  content: \"\\ea80\";\n}\n.bx-home-alt:before {\n  content: \"\\ea81\";\n}\n.bx-home-circle:before {\n  content: \"\\ea82\";\n}\n.bx-horizontal-center:before {\n  content: \"\\ea83\";\n}\n.bx-hotel:before {\n  content: \"\\ea84\";\n}\n.bx-hourglass:before {\n  content: \"\\ea85\";\n}\n.bx-id-card:before {\n  content: \"\\ea86\";\n}\n.bx-image:before {\n  content: \"\\ea87\";\n}\n.bx-image-add:before {\n  content: \"\\ea88\";\n}\n.bx-image-alt:before {\n  content: \"\\ea89\";\n}\n.bx-images:before {\n  content: \"\\ea8a\";\n}\n.bx-import:before {\n  content: \"\\ea8b\";\n}\n.bx-infinite:before {\n  content: \"\\ea8c\";\n}\n.bx-info-circle:before {\n  content: \"\\ea8d\";\n}\n.bx-italic:before {\n  content: \"\\ea8e\";\n}\n.bx-joystick:before {\n  content: \"\\ea8f\";\n}\n.bx-joystick-alt:before {\n  content: \"\\ea90\";\n}\n.bx-joystick-button:before {\n  content: \"\\ea91\";\n}\n.bx-key:before {\n  content: \"\\ea92\";\n}\n.bx-label:before {\n  content: \"\\ea93\";\n}\n.bx-landscape:before {\n  content: \"\\ea94\";\n}\n.bx-laptop:before {\n  content: \"\\ea95\";\n}\n.bx-last-page:before {\n  content: \"\\ea96\";\n}\n.bx-laugh:before {\n  content: \"\\ea97\";\n}\n.bx-layer:before {\n  content: \"\\ea98\";\n}\n.bx-layout:before {\n  content: \"\\ea99\";\n}\n.bx-left-arrow:before {\n  content: \"\\ea9a\";\n}\n.bx-left-arrow-alt:before {\n  content: \"\\ea9b\";\n}\n.bx-left-arrow-circle:before {\n  content: \"\\ea9c\";\n}\n.bx-left-down-arrow-circle:before {\n  content: \"\\ea9d\";\n}\n.bx-left-indent:before {\n  content: \"\\ea9e\";\n}\n.bx-left-top-arrow-circle:before {\n  content: \"\\ea9f\";\n}\n.bx-like:before {\n  content: \"\\eaa0\";\n}\n.bx-line-chart:before {\n  content: \"\\eaa1\";\n}\n.bx-link:before {\n  content: \"\\eaa2\";\n}\n.bx-link-alt:before {\n  content: \"\\eaa3\";\n}\n.bx-link-external:before {\n  content: \"\\eaa4\";\n}\n.bx-lira:before {\n  content: \"\\eaa5\";\n}\n.bx-list-check:before {\n  content: \"\\eaa6\";\n}\n.bx-list-minus:before {\n  content: \"\\eaa7\";\n}\n.bx-list-ol:before {\n  content: \"\\eaa8\";\n}\n.bx-list-plus:before {\n  content: \"\\eaa9\";\n}\n.bx-list-ul:before {\n  content: \"\\eaaa\";\n}\n.bx-loader:before {\n  content: \"\\eaab\";\n}\n.bx-loader-alt:before {\n  content: \"\\eaac\";\n}\n.bx-loader-circle:before {\n  content: \"\\eaad\";\n}\n.bx-lock:before {\n  content: \"\\eaae\";\n}\n.bx-lock-alt:before {\n  content: \"\\eaaf\";\n}\n.bx-lock-open:before {\n  content: \"\\eab0\";\n}\n.bx-lock-open-alt:before {\n  content: \"\\eab1\";\n}\n.bx-log-in:before {\n  content: \"\\eab2\";\n}\n.bx-log-in-circle:before {\n  content: \"\\eab3\";\n}\n.bx-log-out:before {\n  content: \"\\eab4\";\n}\n.bx-log-out-circle:before {\n  content: \"\\eab5\";\n}\n.bx-magnet:before {\n  content: \"\\eab6\";\n}\n.bx-mail-send:before {\n  content: \"\\eab7\";\n}\n.bx-male:before {\n  content: \"\\eab8\";\n}\n.bx-male-sign:before {\n  content: \"\\eab9\";\n}\n.bx-map:before {\n  content: \"\\eaba\";\n}\n.bx-map-alt:before {\n  content: \"\\eabb\";\n}\n.bx-map-pin:before {\n  content: \"\\eabc\";\n}\n.bx-meh:before {\n  content: \"\\eabd\";\n}\n.bx-meh-alt:before {\n  content: \"\\eabe\";\n}\n.bx-meh-blank:before {\n  content: \"\\eabf\";\n}\n.bx-memory-card:before {\n  content: \"\\eac0\";\n}\n.bx-menu:before {\n  content: \"\\eac1\";\n}\n.bx-menu-alt-left:before {\n  content: \"\\eac2\";\n}\n.bx-menu-alt-right:before {\n  content: \"\\eac3\";\n}\n.bx-message:before {\n  content: \"\\eac4\";\n}\n.bx-message-alt:before {\n  content: \"\\eac5\";\n}\n.bx-message-alt-dots:before {\n  content: \"\\eac6\";\n}\n.bx-message-dots:before {\n  content: \"\\eac7\";\n}\n.bx-message-rounded:before {\n  content: \"\\eac8\";\n}\n.bx-message-rounded-dots:before {\n  content: \"\\eac9\";\n}\n.bx-message-square:before {\n  content: \"\\eaca\";\n}\n.bx-message-square-dots:before {\n  content: \"\\eacb\";\n}\n.bx-microphone:before {\n  content: \"\\eacc\";\n}\n.bx-microphone-off:before {\n  content: \"\\eacd\";\n}\n.bx-minus:before {\n  content: \"\\eace\";\n}\n.bx-minus-circle:before {\n  content: \"\\eacf\";\n}\n.bx-mobile:before {\n  content: \"\\ead0\";\n}\n.bx-mobile-alt:before {\n  content: \"\\ead1\";\n}\n.bx-mobile-landscape:before {\n  content: \"\\ead2\";\n}\n.bx-mobile-vibration:before {\n  content: \"\\ead3\";\n}\n.bx-money:before {\n  content: \"\\ead4\";\n}\n.bx-moon:before {\n  content: \"\\ead5\";\n}\n.bx-mouse:before {\n  content: \"\\ead6\";\n}\n.bx-mouse-alt:before {\n  content: \"\\ead7\";\n}\n.bx-move:before {\n  content: \"\\ead8\";\n}\n.bx-move-horizontal:before {\n  content: \"\\ead9\";\n}\n.bx-move-vertical:before {\n  content: \"\\eada\";\n}\n.bx-movie:before {\n  content: \"\\eadb\";\n}\n.bx-music:before {\n  content: \"\\eadc\";\n}\n.bx-navigation:before {\n  content: \"\\eadd\";\n}\n.bx-news:before {\n  content: \"\\eade\";\n}\n.bx-no-entry:before {\n  content: \"\\eadf\";\n}\n.bx-note:before {\n  content: \"\\eae0\";\n}\n.bx-notepad:before {\n  content: \"\\eae1\";\n}\n.bx-notification:before {\n  content: \"\\eae2\";\n}\n.bx-notification-off:before {\n  content: \"\\eae3\";\n}\n.bx-package:before {\n  content: \"\\eae4\";\n}\n.bx-paint:before {\n  content: \"\\eae5\";\n}\n.bx-paint-roll:before {\n  content: \"\\eae6\";\n}\n.bx-palette:before {\n  content: \"\\eae7\";\n}\n.bx-paperclip:before {\n  content: \"\\eae8\";\n}\n.bx-paper-plane:before {\n  content: \"\\eae9\";\n}\n.bx-paragraph:before {\n  content: \"\\eaea\";\n}\n.bx-paste:before {\n  content: \"\\eaeb\";\n}\n.bx-pause:before {\n  content: \"\\eaec\";\n}\n.bx-pause-circle:before {\n  content: \"\\eaed\";\n}\n.bx-pen:before {\n  content: \"\\eaee\";\n}\n.bx-pencil:before {\n  content: \"\\eaef\";\n}\n.bx-phone:before {\n  content: \"\\eaf0\";\n}\n.bx-phone-call:before {\n  content: \"\\eaf1\";\n}\n.bx-phone-incoming:before {\n  content: \"\\eaf2\";\n}\n.bx-phone-outgoing:before {\n  content: \"\\eaf3\";\n}\n.bx-photo-album:before {\n  content: \"\\eaf4\";\n}\n.bx-pie-chart:before {\n  content: \"\\eaf5\";\n}\n.bx-pie-chart-alt:before {\n  content: \"\\eaf6\";\n}\n.bx-pie-chart-alt-2:before {\n  content: \"\\eaf7\";\n}\n.bx-pin:before {\n  content: \"\\eaf8\";\n}\n.bx-planet:before {\n  content: \"\\eaf9\";\n}\n.bx-play:before {\n  content: \"\\eafa\";\n}\n.bx-play-circle:before {\n  content: \"\\eafb\";\n}\n.bx-plug:before {\n  content: \"\\eafc\";\n}\n.bx-plus:before {\n  content: \"\\eafd\";\n}\n.bx-plus-circle:before {\n  content: \"\\eafe\";\n}\n.bx-plus-medical:before {\n  content: \"\\eaff\";\n}\n.bx-poll:before {\n  content: \"\\eb00\";\n}\n.bx-polygon:before {\n  content: \"\\eb01\";\n}\n.bx-pound:before {\n  content: \"\\eb02\";\n}\n.bx-power-off:before {\n  content: \"\\eb03\";\n}\n.bx-printer:before {\n  content: \"\\eb04\";\n}\n.bx-pulse:before {\n  content: \"\\eb05\";\n}\n.bx-purchase-tag:before {\n  content: \"\\eb06\";\n}\n.bx-purchase-tag-alt:before {\n  content: \"\\eb07\";\n}\n.bx-pyramid:before {\n  content: \"\\eb08\";\n}\n.bx-question-mark:before {\n  content: \"\\eb09\";\n}\n.bx-radar:before {\n  content: \"\\eb0a\";\n}\n.bx-radio:before {\n  content: \"\\eb0b\";\n}\n.bx-radio-circle:before {\n  content: \"\\eb0c\";\n}\n.bx-radio-circle-marked:before {\n  content: \"\\eb0d\";\n}\n.bx-receipt:before {\n  content: \"\\eb0e\";\n}\n.bx-rectangle:before {\n  content: \"\\eb0f\";\n}\n.bx-redo:before {\n  content: \"\\eb10\";\n}\n.bx-rename:before {\n  content: \"\\eb11\";\n}\n.bx-repeat:before {\n  content: \"\\eb12\";\n}\n.bx-reply:before {\n  content: \"\\eb13\";\n}\n.bx-reply-all:before {\n  content: \"\\eb14\";\n}\n.bx-repost:before {\n  content: \"\\eb15\";\n}\n.bx-reset:before {\n  content: \"\\eb16\";\n}\n.bx-restaurant:before {\n  content: \"\\eb17\";\n}\n.bx-revision:before {\n  content: \"\\eb18\";\n}\n.bx-rewind:before {\n  content: \"\\eb19\";\n}\n.bx-rewind-circle:before {\n  content: \"\\eb1a\";\n}\n.bx-right-arrow:before {\n  content: \"\\eb1b\";\n}\n.bx-right-arrow-alt:before {\n  content: \"\\eb1c\";\n}\n.bx-right-arrow-circle:before {\n  content: \"\\eb1d\";\n}\n.bx-right-down-arrow-circle:before {\n  content: \"\\eb1e\";\n}\n.bx-right-indent:before {\n  content: \"\\eb1f\";\n}\n.bx-right-top-arrow-circle:before {\n  content: \"\\eb20\";\n}\n.bx-rocket:before {\n  content: \"\\eb21\";\n}\n.bx-rotate-left:before {\n  content: \"\\eb22\";\n}\n.bx-rotate-right:before {\n  content: \"\\eb23\";\n}\n.bx-rss:before {\n  content: \"\\eb24\";\n}\n.bx-ruble:before {\n  content: \"\\eb25\";\n}\n.bx-ruler:before {\n  content: \"\\eb26\";\n}\n.bx-run:before {\n  content: \"\\eb27\";\n}\n.bx-rupee:before {\n  content: \"\\eb28\";\n}\n.bx-sad:before {\n  content: \"\\eb29\";\n}\n.bx-save:before {\n  content: \"\\eb2a\";\n}\n.bx-screenshot:before {\n  content: \"\\eb2b\";\n}\n.bx-search:before {\n  content: \"\\eb2c\";\n}\n.bx-search-alt:before {\n  content: \"\\eb2d\";\n}\n.bx-search-alt-2:before {\n  content: \"\\eb2e\";\n}\n.bx-selection:before {\n  content: \"\\eb2f\";\n}\n.bx-select-multiple:before {\n  content: \"\\eb30\";\n}\n.bx-send:before {\n  content: \"\\eb31\";\n}\n.bx-server:before {\n  content: \"\\eb32\";\n}\n.bx-shape-circle:before {\n  content: \"\\eb33\";\n}\n.bx-shape-square:before {\n  content: \"\\eb34\";\n}\n.bx-shape-triangle:before {\n  content: \"\\eb35\";\n}\n.bx-share:before {\n  content: \"\\eb36\";\n}\n.bx-share-alt:before {\n  content: \"\\eb37\";\n}\n.bx-shekel:before {\n  content: \"\\eb38\";\n}\n.bx-shield:before {\n  content: \"\\eb39\";\n}\n.bx-shield-alt:before {\n  content: \"\\eb3a\";\n}\n.bx-shield-alt-2:before {\n  content: \"\\eb3b\";\n}\n.bx-shield-quarter:before {\n  content: \"\\eb3c\";\n}\n.bx-shocked:before {\n  content: \"\\eb3d\";\n}\n.bx-shopping-bag:before {\n  content: \"\\eb3e\";\n}\n.bx-show:before {\n  content: \"\\eb3f\";\n}\n.bx-show-alt:before {\n  content: \"\\eb40\";\n}\n.bx-shuffle:before {\n  content: \"\\eb41\";\n}\n.bx-sidebar:before {\n  content: \"\\eb42\";\n}\n.bx-sitemap:before {\n  content: \"\\eb43\";\n}\n.bx-skip-next:before {\n  content: \"\\eb44\";\n}\n.bx-skip-next-circle:before {\n  content: \"\\eb45\";\n}\n.bx-skip-previous:before {\n  content: \"\\eb46\";\n}\n.bx-skip-previous-circle:before {\n  content: \"\\eb47\";\n}\n.bx-sleepy:before {\n  content: \"\\eb48\";\n}\n.bx-slider:before {\n  content: \"\\eb49\";\n}\n.bx-slider-alt:before {\n  content: \"\\eb4a\";\n}\n.bx-slideshow:before {\n  content: \"\\eb4b\";\n}\n.bx-smile:before {\n  content: \"\\eb4c\";\n}\n.bx-sort:before {\n  content: \"\\eb4d\";\n}\n.bx-sort-a-z:before {\n  content: \"\\eb4e\";\n}\n.bx-sort-down:before {\n  content: \"\\eb4f\";\n}\n.bx-sort-up:before {\n  content: \"\\eb50\";\n}\n.bx-sort-z-a:before {\n  content: \"\\eb51\";\n}\n.bx-spa:before {\n  content: \"\\eb52\";\n}\n.bx-space-bar:before {\n  content: \"\\eb53\";\n}\n.bx-spreadsheet:before {\n  content: \"\\eb54\";\n}\n.bx-square:before {\n  content: \"\\eb55\";\n}\n.bx-square-rounded:before {\n  content: \"\\eb56\";\n}\n.bx-star:before {\n  content: \"\\eb57\";\n}\n.bx-station:before {\n  content: \"\\eb58\";\n}\n.bx-stats:before {\n  content: \"\\eb59\";\n}\n.bx-sticker:before {\n  content: \"\\eb5a\";\n}\n.bx-stop:before {\n  content: \"\\eb5b\";\n}\n.bx-stop-circle:before {\n  content: \"\\eb5c\";\n}\n.bx-stopwatch:before {\n  content: \"\\eb5d\";\n}\n.bx-store:before {\n  content: \"\\eb5e\";\n}\n.bx-store-alt:before {\n  content: \"\\eb5f\";\n}\n.bx-street-view:before {\n  content: \"\\eb60\";\n}\n.bx-strikethrough:before {\n  content: \"\\eb61\";\n}\n.bx-subdirectory-left:before {\n  content: \"\\eb62\";\n}\n.bx-subdirectory-right:before {\n  content: \"\\eb63\";\n}\n.bx-sun:before {\n  content: \"\\eb64\";\n}\n.bx-support:before {\n  content: \"\\eb65\";\n}\n.bx-swim:before {\n  content: \"\\eb66\";\n}\n.bx-sync:before {\n  content: \"\\eb67\";\n}\n.bx-tab:before {\n  content: \"\\eb68\";\n}\n.bx-table:before {\n  content: \"\\eb69\";\n}\n.bx-tag:before {\n  content: \"\\eb6a\";\n}\n.bx-target-lock:before {\n  content: \"\\eb6b\";\n}\n.bx-task:before {\n  content: \"\\eb6c\";\n}\n.bx-taxi:before {\n  content: \"\\eb6d\";\n}\n.bx-tennis-ball:before {\n  content: \"\\eb6e\";\n}\n.bx-terminal:before {\n  content: \"\\eb6f\";\n}\n.bx-test-tube:before {\n  content: \"\\eb70\";\n}\n.bx-text:before {\n  content: \"\\eb71\";\n}\n.bx-time:before {\n  content: \"\\eb72\";\n}\n.bx-time-five:before {\n  content: \"\\eb73\";\n}\n.bx-timer:before {\n  content: \"\\eb74\";\n}\n.bx-tired:before {\n  content: \"\\eb75\";\n}\n.bx-toggle-left:before {\n  content: \"\\eb76\";\n}\n.bx-toggle-right:before {\n  content: \"\\eb77\";\n}\n.bx-tone:before {\n  content: \"\\eb78\";\n}\n.bx-train:before {\n  content: \"\\eb79\";\n}\n.bx-transfer:before {\n  content: \"\\eb7a\";\n}\n.bx-transfer-alt:before {\n  content: \"\\eb7b\";\n}\n.bx-trash:before {\n  content: \"\\eb7c\";\n}\n.bx-trash-alt:before {\n  content: \"\\eb7d\";\n}\n.bx-trending-down:before {\n  content: \"\\eb7e\";\n}\n.bx-trending-up:before {\n  content: \"\\eb7f\";\n}\n.bx-trophy:before {\n  content: \"\\eb80\";\n}\n.bx-tv:before {\n  content: \"\\eb81\";\n}\n.bx-underline:before {\n  content: \"\\eb82\";\n}\n.bx-undo:before {\n  content: \"\\eb83\";\n}\n.bx-unlink:before {\n  content: \"\\eb84\";\n}\n.bx-up-arrow:before {\n  content: \"\\eb85\";\n}\n.bx-up-arrow-alt:before {\n  content: \"\\eb86\";\n}\n.bx-up-arrow-circle:before {\n  content: \"\\eb87\";\n}\n.bx-upload:before {\n  content: \"\\eb88\";\n}\n.bx-upside-down:before {\n  content: \"\\eb89\";\n}\n.bx-upvote:before {\n  content: \"\\eb8a\";\n}\n.bx-usb:before {\n  content: \"\\eb8b\";\n}\n.bx-user:before {\n  content: \"\\eb8c\";\n}\n.bx-user-check:before {\n  content: \"\\eb8d\";\n}\n.bx-user-circle:before {\n  content: \"\\eb8e\";\n}\n.bx-user-minus:before {\n  content: \"\\eb8f\";\n}\n.bx-user-pin:before {\n  content: \"\\eb90\";\n}\n.bx-user-plus:before {\n  content: \"\\eb91\";\n}\n.bx-user-voice:before {\n  content: \"\\eb92\";\n}\n.bx-user-x:before {\n  content: \"\\eb93\";\n}\n.bx-vertical-center:before {\n  content: \"\\eb94\";\n}\n.bx-video:before {\n  content: \"\\eb95\";\n}\n.bx-video-off:before {\n  content: \"\\eb96\";\n}\n.bx-video-plus:before {\n  content: \"\\eb97\";\n}\n.bx-video-recording:before {\n  content: \"\\eb98\";\n}\n.bx-voicemail:before {\n  content: \"\\eb99\";\n}\n.bx-volume:before {\n  content: \"\\eb9a\";\n}\n.bx-volume-full:before {\n  content: \"\\eb9b\";\n}\n.bx-volume-low:before {\n  content: \"\\eb9c\";\n}\n.bx-volume-mute:before {\n  content: \"\\eb9d\";\n}\n.bx-walk:before {\n  content: \"\\eb9e\";\n}\n.bx-wallet:before {\n  content: \"\\eb9f\";\n}\n.bx-wallet-alt:before {\n  content: \"\\eba0\";\n}\n.bx-water:before {\n  content: \"\\eba1\";\n}\n.bx-wifi:before {\n  content: \"\\eba2\";\n}\n.bx-wifi-off:before {\n  content: \"\\eba3\";\n}\n.bx-wind:before {\n  content: \"\\eba4\";\n}\n.bx-window:before {\n  content: \"\\eba5\";\n}\n.bx-window-close:before {\n  content: \"\\eba6\";\n}\n.bx-window-open:before {\n  content: \"\\eba7\";\n}\n.bx-windows:before {\n  content: \"\\eba8\";\n}\n.bx-wink-smile:before {\n  content: \"\\eba9\";\n}\n.bx-wink-tongue:before {\n  content: \"\\ebaa\";\n}\n.bx-won:before {\n  content: \"\\ebab\";\n}\n.bx-world:before {\n  content: \"\\ebac\";\n}\n.bx-wrench:before {\n  content: \"\\ebad\";\n}\n.bx-x:before {\n  content: \"\\ebae\";\n}\n.bx-x-circle:before {\n  content: \"\\ebaf\";\n}\n.bx-yen:before {\n  content: \"\\ebb0\";\n}\n.bx-zoom-in:before {\n  content: \"\\ebb1\";\n}\n.bx-zoom-out:before {\n  content: \"\\ebb2\";\n}\n.bxs-add-to-queue:before {\n  content: \"\\ebb3\";\n}\n.bxs-adjust:before {\n  content: \"\\ebb4\";\n}\n.bxs-adjust-alt:before {\n  content: \"\\ebb5\";\n}\n.bxs-alarm:before {\n  content: \"\\ebb6\";\n}\n.bxs-alarm-add:before {\n  content: \"\\ebb7\";\n}\n.bxs-alarm-off:before {\n  content: \"\\ebb8\";\n}\n.bxs-album:before {\n  content: \"\\ebb9\";\n}\n.bxs-ambulance:before {\n  content: \"\\ebba\";\n}\n.bxs-analyse:before {\n  content: \"\\ebbb\";\n}\n.bxs-angry:before {\n  content: \"\\ebbc\";\n}\n.bxs-archive:before {\n  content: \"\\ebbd\";\n}\n.bxs-archive-in:before {\n  content: \"\\ebbe\";\n}\n.bxs-archive-out:before {\n  content: \"\\ebbf\";\n}\n.bxs-area:before {\n  content: \"\\ebc0\";\n}\n.bxs-award:before {\n  content: \"\\ebc1\";\n}\n.bxs-baby-carriage:before {\n  content: \"\\ebc2\";\n}\n.bxs-badge:before {\n  content: \"\\ebc3\";\n}\n.bxs-badge-check:before {\n  content: \"\\ebc4\";\n}\n.bxs-ball:before {\n  content: \"\\ebc5\";\n}\n.bxs-band-aid:before {\n  content: \"\\ebc6\";\n}\n.bxs-bank:before {\n  content: \"\\ebc7\";\n}\n.bxs-bar-chart-alt-2:before {\n  content: \"\\ebc8\";\n}\n.bxs-bar-chart-square:before {\n  content: \"\\ebc9\";\n}\n.bxs-barcode:before {\n  content: \"\\ebca\";\n}\n.bxs-basket:before {\n  content: \"\\ebcb\";\n}\n.bxs-bath:before {\n  content: \"\\ebcc\";\n}\n.bxs-battery:before {\n  content: \"\\ebcd\";\n}\n.bxs-battery-charging:before {\n  content: \"\\ebce\";\n}\n.bxs-battery-full:before {\n  content: \"\\ebcf\";\n}\n.bxs-battery-low:before {\n  content: \"\\ebd0\";\n}\n.bxs-bed:before {\n  content: \"\\ebd1\";\n}\n.bxs-bell:before {\n  content: \"\\ebd2\";\n}\n.bxs-bell-minus:before {\n  content: \"\\ebd3\";\n}\n.bxs-bell-off:before {\n  content: \"\\ebd4\";\n}\n.bxs-bell-plus:before {\n  content: \"\\ebd5\";\n}\n.bxs-bell-ring:before {\n  content: \"\\ebd6\";\n}\n.bxs-bolt:before {\n  content: \"\\ebd7\";\n}\n.bxs-bolt-circle:before {\n  content: \"\\ebd8\";\n}\n.bxs-book:before {\n  content: \"\\ebd9\";\n}\n.bxs-book-bookmark:before {\n  content: \"\\ebda\";\n}\n.bxs-book-content:before {\n  content: \"\\ebdb\";\n}\n.bxs-bookmark:before {\n  content: \"\\ebdc\";\n}\n.bxs-bookmark-minus:before {\n  content: \"\\ebdd\";\n}\n.bxs-bookmark-plus:before {\n  content: \"\\ebde\";\n}\n.bxs-bookmarks:before {\n  content: \"\\ebdf\";\n}\n.bxs-bookmark-star:before {\n  content: \"\\ebe0\";\n}\n.bxs-book-open:before {\n  content: \"\\ebe1\";\n}\n.bxs-bot:before {\n  content: \"\\ebe2\";\n}\n.bxs-bowling-ball:before {\n  content: \"\\ebe3\";\n}\n.bxs-box:before {\n  content: \"\\ebe4\";\n}\n.bxs-briefcase:before {\n  content: \"\\ebe5\";\n}\n.bxs-briefcase-alt:before {\n  content: \"\\ebe6\";\n}\n.bxs-briefcase-alt-2:before {\n  content: \"\\ebe7\";\n}\n.bxs-brightness:before {\n  content: \"\\ebe8\";\n}\n.bxs-brightness-half:before {\n  content: \"\\ebe9\";\n}\n.bxs-brush:before {\n  content: \"\\ebea\";\n}\n.bxs-brush-alt:before {\n  content: \"\\ebeb\";\n}\n.bxs-bug:before {\n  content: \"\\ebec\";\n}\n.bxs-bug-alt:before {\n  content: \"\\ebed\";\n}\n.bxs-building:before {\n  content: \"\\ebee\";\n}\n.bxs-building-house:before {\n  content: \"\\ebef\";\n}\n.bxs-buildings:before {\n  content: \"\\ebf0\";\n}\n.bxs-bulb:before {\n  content: \"\\ebf1\";\n}\n.bxs-buoy:before {\n  content: \"\\ebf2\";\n}\n.bxs-bus:before {\n  content: \"\\ebf3\";\n}\n.bxs-business:before {\n  content: \"\\ebf4\";\n}\n.bxs-cake:before {\n  content: \"\\ebf5\";\n}\n.bxs-calculator:before {\n  content: \"\\ebf6\";\n}\n.bxs-calendar:before {\n  content: \"\\ebf7\";\n}\n.bxs-calendar-alt:before {\n  content: \"\\ebf8\";\n}\n.bxs-calendar-check:before {\n  content: \"\\ebf9\";\n}\n.bxs-calendar-event:before {\n  content: \"\\ebfa\";\n}\n.bxs-calendar-minus:before {\n  content: \"\\ebfb\";\n}\n.bxs-calendar-plus:before {\n  content: \"\\ebfc\";\n}\n.bxs-calendar-x:before {\n  content: \"\\ebfd\";\n}\n.bxs-camera:before {\n  content: \"\\ebfe\";\n}\n.bxs-camera-off:before {\n  content: \"\\ebff\";\n}\n.bxs-camera-plus:before {\n  content: \"\\ec00\";\n}\n.bxs-capsule:before {\n  content: \"\\ec01\";\n}\n.bxs-captions:before {\n  content: \"\\ec02\";\n}\n.bxs-car:before {\n  content: \"\\ec03\";\n}\n.bxs-card:before {\n  content: \"\\ec04\";\n}\n.bxs-caret-down-circle:before {\n  content: \"\\ec05\";\n}\n.bxs-caret-left-circle:before {\n  content: \"\\ec06\";\n}\n.bxs-caret-right-circle:before {\n  content: \"\\ec07\";\n}\n.bxs-caret-up-circle:before {\n  content: \"\\ec08\";\n}\n.bxs-carousel:before {\n  content: \"\\ec09\";\n}\n.bxs-cart:before {\n  content: \"\\ec0a\";\n}\n.bxs-cart-alt:before {\n  content: \"\\ec0b\";\n}\n.bxs-certification:before {\n  content: \"\\ec0c\";\n}\n.bxs-chalkboard:before {\n  content: \"\\ec0d\";\n}\n.bxs-chart:before {\n  content: \"\\ec0e\";\n}\n.bxs-chat:before {\n  content: \"\\ec0f\";\n}\n.bxs-checkbox:before {\n  content: \"\\ec10\";\n}\n.bxs-checkbox-checked:before {\n  content: \"\\ec11\";\n}\n.bxs-check-circle:before {\n  content: \"\\ec12\";\n}\n.bxs-check-shield:before {\n  content: \"\\ec13\";\n}\n.bxs-check-square:before {\n  content: \"\\ec14\";\n}\n.bxs-chip:before {\n  content: \"\\ec15\";\n}\n.bxs-circle:before {\n  content: \"\\ec16\";\n}\n.bxs-city:before {\n  content: \"\\ec17\";\n}\n.bxs-clinic:before {\n  content: \"\\ec18\";\n}\n.bxs-cloud:before {\n  content: \"\\ec19\";\n}\n.bxs-cloud-download:before {\n  content: \"\\ec1a\";\n}\n.bxs-cloud-lightning:before {\n  content: \"\\ec1b\";\n}\n.bxs-cloud-rain:before {\n  content: \"\\ec1c\";\n}\n.bxs-cloud-upload:before {\n  content: \"\\ec1d\";\n}\n.bxs-coffee:before {\n  content: \"\\ec1e\";\n}\n.bxs-coffee-alt:before {\n  content: \"\\ec1f\";\n}\n.bxs-cog:before {\n  content: \"\\ec20\";\n}\n.bxs-collection:before {\n  content: \"\\ec21\";\n}\n.bxs-color-fill:before {\n  content: \"\\ec22\";\n}\n.bxs-comment:before {\n  content: \"\\ec23\";\n}\n.bxs-comment-add:before {\n  content: \"\\ec24\";\n}\n.bxs-comment-detail:before {\n  content: \"\\ec25\";\n}\n.bxs-comment-dots:before {\n  content: \"\\ec26\";\n}\n.bxs-comment-error:before {\n  content: \"\\ec27\";\n}\n.bxs-compass:before {\n  content: \"\\ec28\";\n}\n.bxs-component:before {\n  content: \"\\ec29\";\n}\n.bxs-confused:before {\n  content: \"\\ec2a\";\n}\n.bxs-contact:before {\n  content: \"\\ec2b\";\n}\n.bxs-conversation:before {\n  content: \"\\ec2c\";\n}\n.bxs-cool:before {\n  content: \"\\ec2d\";\n}\n.bxs-copy:before {\n  content: \"\\ec2e\";\n}\n.bxs-copy-alt:before {\n  content: \"\\ec2f\";\n}\n.bxs-coupon:before {\n  content: \"\\ec30\";\n}\n.bxs-credit-card:before {\n  content: \"\\ec31\";\n}\n.bxs-credit-card-alt:before {\n  content: \"\\ec32\";\n}\n.bxs-crown:before {\n  content: \"\\ec33\";\n}\n.bxs-cube:before {\n  content: \"\\ec34\";\n}\n.bxs-cube-alt:before {\n  content: \"\\ec35\";\n}\n.bxs-cuboid:before {\n  content: \"\\ec36\";\n}\n.bxs-customize:before {\n  content: \"\\ec37\";\n}\n.bxs-cylinder:before {\n  content: \"\\ec38\";\n}\n.bxs-dashboard:before {\n  content: \"\\ec39\";\n}\n.bxs-data:before {\n  content: \"\\ec3a\";\n}\n.bxs-detail:before {\n  content: \"\\ec3b\";\n}\n.bxs-devices:before {\n  content: \"\\ec3c\";\n}\n.bxs-direction-left:before {\n  content: \"\\ec3d\";\n}\n.bxs-direction-right:before {\n  content: \"\\ec3e\";\n}\n.bxs-directions:before {\n  content: \"\\ec3f\";\n}\n.bxs-disc:before {\n  content: \"\\ec40\";\n}\n.bxs-discount:before {\n  content: \"\\ec41\";\n}\n.bxs-dish:before {\n  content: \"\\ec42\";\n}\n.bxs-dislike:before {\n  content: \"\\ec43\";\n}\n.bxs-dizzy:before {\n  content: \"\\ec44\";\n}\n.bxs-dock-bottom:before {\n  content: \"\\ec45\";\n}\n.bxs-dock-left:before {\n  content: \"\\ec46\";\n}\n.bxs-dock-right:before {\n  content: \"\\ec47\";\n}\n.bxs-dock-top:before {\n  content: \"\\ec48\";\n}\n.bxs-dollar-circle:before {\n  content: \"\\ec49\";\n}\n.bxs-doughnut-chart:before {\n  content: \"\\ec4a\";\n}\n.bxs-down-arrow:before {\n  content: \"\\ec4b\";\n}\n.bxs-down-arrow-circle:before {\n  content: \"\\ec4c\";\n}\n.bxs-down-arrow-square:before {\n  content: \"\\ec4d\";\n}\n.bxs-download:before {\n  content: \"\\ec4e\";\n}\n.bxs-downvote:before {\n  content: \"\\ec4f\";\n}\n.bxs-drink:before {\n  content: \"\\ec50\";\n}\n.bxs-droplet:before {\n  content: \"\\ec51\";\n}\n.bxs-droplet-half:before {\n  content: \"\\ec52\";\n}\n.bxs-duplicate:before {\n  content: \"\\ec53\";\n}\n.bxs-edit:before {\n  content: \"\\ec54\";\n}\n.bxs-edit-alt:before {\n  content: \"\\ec55\";\n}\n.bxs-eject:before {\n  content: \"\\ec56\";\n}\n.bxs-envelope:before {\n  content: \"\\ec57\";\n}\n.bxs-eraser:before {\n  content: \"\\ec58\";\n}\n.bxs-error:before {\n  content: \"\\ec59\";\n}\n.bxs-error-alt:before {\n  content: \"\\ec5a\";\n}\n.bxs-error-circle:before {\n  content: \"\\ec5b\";\n}\n.bxs-exit:before {\n  content: \"\\ec5c\";\n}\n.bxs-extension:before {\n  content: \"\\ec5d\";\n}\n.bxs-eyedropper:before {\n  content: \"\\ec5e\";\n}\n.bxs-face:before {\n  content: \"\\ec5f\";\n}\n.bxs-factory:before {\n  content: \"\\ec60\";\n}\n.bxs-fast-forward-circle:before {\n  content: \"\\ec61\";\n}\n.bxs-file:before {\n  content: \"\\ec62\";\n}\n.bxs-file-blank:before {\n  content: \"\\ec63\";\n}\n.bxs-file-css:before {\n  content: \"\\ec64\";\n}\n.bxs-file-doc:before {\n  content: \"\\ec65\";\n}\n.bxs-file-find:before {\n  content: \"\\ec66\";\n}\n.bxs-file-gif:before {\n  content: \"\\ec67\";\n}\n.bxs-file-html:before {\n  content: \"\\ec68\";\n}\n.bxs-file-image:before {\n  content: \"\\ec69\";\n}\n.bxs-file-jpg:before {\n  content: \"\\ec6a\";\n}\n.bxs-file-js:before {\n  content: \"\\ec6b\";\n}\n.bxs-file-json:before {\n  content: \"\\ec6c\";\n}\n.bxs-file-md:before {\n  content: \"\\ec6d\";\n}\n.bxs-file-pdf:before {\n  content: \"\\ec6e\";\n}\n.bxs-file-plus:before {\n  content: \"\\ec6f\";\n}\n.bxs-file-png:before {\n  content: \"\\ec70\";\n}\n.bxs-file-txt:before {\n  content: \"\\ec71\";\n}\n.bxs-film:before {\n  content: \"\\ec72\";\n}\n.bxs-filter-alt:before {\n  content: \"\\ec73\";\n}\n.bxs-first-aid:before {\n  content: \"\\ec74\";\n}\n.bxs-flag:before {\n  content: \"\\ec75\";\n}\n.bxs-flag-alt:before {\n  content: \"\\ec76\";\n}\n.bxs-flame:before {\n  content: \"\\ec77\";\n}\n.bxs-flask:before {\n  content: \"\\ec78\";\n}\n.bxs-folder:before {\n  content: \"\\ec79\";\n}\n.bxs-folder-minus:before {\n  content: \"\\ec7a\";\n}\n.bxs-folder-open:before {\n  content: \"\\ec7b\";\n}\n.bxs-folder-plus:before {\n  content: \"\\ec7c\";\n}\n.bxs-food-menu:before {\n  content: \"\\ec7d\";\n}\n.bxs-fridge:before {\n  content: \"\\ec7e\";\n}\n.bxs-gas-pump:before {\n  content: \"\\ec7f\";\n}\n.bxs-ghost:before {\n  content: \"\\ec80\";\n}\n.bxs-gift:before {\n  content: \"\\ec81\";\n}\n.bxs-graduation:before {\n  content: \"\\ec82\";\n}\n.bxs-grid:before {\n  content: \"\\ec83\";\n}\n.bxs-grid-alt:before {\n  content: \"\\ec84\";\n}\n.bxs-group:before {\n  content: \"\\ec85\";\n}\n.bxs-hand-down:before {\n  content: \"\\ec86\";\n}\n.bxs-hand-left:before {\n  content: \"\\ec87\";\n}\n.bxs-hand-right:before {\n  content: \"\\ec88\";\n}\n.bxs-hand-up:before {\n  content: \"\\ec89\";\n}\n.bxs-happy:before {\n  content: \"\\ec8a\";\n}\n.bxs-happy-alt:before {\n  content: \"\\ec8b\";\n}\n.bxs-happy-beaming:before {\n  content: \"\\ec8c\";\n}\n.bxs-happy-heart-eyes:before {\n  content: \"\\ec8d\";\n}\n.bxs-hdd:before {\n  content: \"\\ec8e\";\n}\n.bxs-heart:before {\n  content: \"\\ec8f\";\n}\n.bxs-help-circle:before {\n  content: \"\\ec90\";\n}\n.bxs-hide:before {\n  content: \"\\ec91\";\n}\n.bxs-home:before {\n  content: \"\\ec92\";\n}\n.bxs-home-circle:before {\n  content: \"\\ec93\";\n}\n.bxs-hot:before {\n  content: \"\\ec94\";\n}\n.bxs-hotel:before {\n  content: \"\\ec95\";\n}\n.bxs-hourglass:before {\n  content: \"\\ec96\";\n}\n.bxs-hourglass-bottom:before {\n  content: \"\\ec97\";\n}\n.bxs-hourglass-top:before {\n  content: \"\\ec98\";\n}\n.bxs-id-card:before {\n  content: \"\\ec99\";\n}\n.bxs-image:before {\n  content: \"\\ec9a\";\n}\n.bxs-image-add:before {\n  content: \"\\ec9b\";\n}\n.bxs-image-alt:before {\n  content: \"\\ec9c\";\n}\n.bxs-inbox:before {\n  content: \"\\ec9d\";\n}\n.bxs-info-circle:before {\n  content: \"\\ec9e\";\n}\n.bxs-institution:before {\n  content: \"\\ec9f\";\n}\n.bxs-joystick:before {\n  content: \"\\eca0\";\n}\n.bxs-joystick-alt:before {\n  content: \"\\eca1\";\n}\n.bxs-joystick-button:before {\n  content: \"\\eca2\";\n}\n.bxs-key:before {\n  content: \"\\eca3\";\n}\n.bxs-keyboard:before {\n  content: \"\\eca4\";\n}\n.bxs-label:before {\n  content: \"\\eca5\";\n}\n.bxs-landmark:before {\n  content: \"\\eca6\";\n}\n.bxs-landscape:before {\n  content: \"\\eca7\";\n}\n.bxs-laugh:before {\n  content: \"\\eca8\";\n}\n.bxs-layer:before {\n  content: \"\\eca9\";\n}\n.bxs-layout:before {\n  content: \"\\ecaa\";\n}\n.bxs-left-arrow:before {\n  content: \"\\ecab\";\n}\n.bxs-left-arrow-circle:before {\n  content: \"\\ecac\";\n}\n.bxs-left-arrow-square:before {\n  content: \"\\ecad\";\n}\n.bxs-left-down-arrow-circle:before {\n  content: \"\\ecae\";\n}\n.bxs-left-top-arrow-circle:before {\n  content: \"\\ecaf\";\n}\n.bxs-like:before {\n  content: \"\\ecb0\";\n}\n.bxs-lock:before {\n  content: \"\\ecb1\";\n}\n.bxs-lock-alt:before {\n  content: \"\\ecb2\";\n}\n.bxs-lock-open:before {\n  content: \"\\ecb3\";\n}\n.bxs-lock-open-alt:before {\n  content: \"\\ecb4\";\n}\n.bxs-log-in:before {\n  content: \"\\ecb5\";\n}\n.bxs-log-in-circle:before {\n  content: \"\\ecb6\";\n}\n.bxs-log-out:before {\n  content: \"\\ecb7\";\n}\n.bxs-log-out-circle:before {\n  content: \"\\ecb8\";\n}\n.bxs-magic-wand:before {\n  content: \"\\ecb9\";\n}\n.bxs-magnet:before {\n  content: \"\\ecba\";\n}\n.bxs-map:before {\n  content: \"\\ecbb\";\n}\n.bxs-map-alt:before {\n  content: \"\\ecbc\";\n}\n.bxs-map-pin:before {\n  content: \"\\ecbd\";\n}\n.bxs-megaphone:before {\n  content: \"\\ecbe\";\n}\n.bxs-meh:before {\n  content: \"\\ecbf\";\n}\n.bxs-meh-alt:before {\n  content: \"\\ecc0\";\n}\n.bxs-meh-blank:before {\n  content: \"\\ecc1\";\n}\n.bxs-memory-card:before {\n  content: \"\\ecc2\";\n}\n.bxs-message:before {\n  content: \"\\ecc3\";\n}\n.bxs-message-alt:before {\n  content: \"\\ecc4\";\n}\n.bxs-message-alt-dots:before {\n  content: \"\\ecc5\";\n}\n.bxs-message-dots:before {\n  content: \"\\ecc6\";\n}\n.bxs-message-rounded:before {\n  content: \"\\ecc7\";\n}\n.bxs-message-rounded-dots:before {\n  content: \"\\ecc8\";\n}\n.bxs-message-square:before {\n  content: \"\\ecc9\";\n}\n.bxs-message-square-dots:before {\n  content: \"\\ecca\";\n}\n.bxs-microphone:before {\n  content: \"\\eccb\";\n}\n.bxs-microphone-alt:before {\n  content: \"\\eccc\";\n}\n.bxs-microphone-off:before {\n  content: \"\\eccd\";\n}\n.bxs-minus-circle:before {\n  content: \"\\ecce\";\n}\n.bxs-minus-square:before {\n  content: \"\\eccf\";\n}\n.bxs-mobile:before {\n  content: \"\\ecd0\";\n}\n.bxs-mobile-vibration:before {\n  content: \"\\ecd1\";\n}\n.bxs-moon:before {\n  content: \"\\ecd2\";\n}\n.bxs-mouse:before {\n  content: \"\\ecd3\";\n}\n.bxs-mouse-alt:before {\n  content: \"\\ecd4\";\n}\n.bxs-movie:before {\n  content: \"\\ecd5\";\n}\n.bxs-music:before {\n  content: \"\\ecd6\";\n}\n.bxs-navigation:before {\n  content: \"\\ecd7\";\n}\n.bxs-news:before {\n  content: \"\\ecd8\";\n}\n.bxs-no-entry:before {\n  content: \"\\ecd9\";\n}\n.bxs-note:before {\n  content: \"\\ecda\";\n}\n.bxs-notepad:before {\n  content: \"\\ecdb\";\n}\n.bxs-notification:before {\n  content: \"\\ecdc\";\n}\n.bxs-notification-off:before {\n  content: \"\\ecdd\";\n}\n.bxs-offer:before {\n  content: \"\\ecde\";\n}\n.bxs-package:before {\n  content: \"\\ecdf\";\n}\n.bxs-paint:before {\n  content: \"\\ece0\";\n}\n.bxs-paint-roll:before {\n  content: \"\\ece1\";\n}\n.bxs-palette:before {\n  content: \"\\ece2\";\n}\n.bxs-paper-plane:before {\n  content: \"\\ece3\";\n}\n.bxs-parking:before {\n  content: \"\\ece4\";\n}\n.bxs-paste:before {\n  content: \"\\ece5\";\n}\n.bxs-pen:before {\n  content: \"\\ece6\";\n}\n.bxs-pencil:before {\n  content: \"\\ece7\";\n}\n.bxs-phone:before {\n  content: \"\\ece8\";\n}\n.bxs-phone-call:before {\n  content: \"\\ece9\";\n}\n.bxs-phone-incoming:before {\n  content: \"\\ecea\";\n}\n.bxs-phone-outgoing:before {\n  content: \"\\eceb\";\n}\n.bxs-photo-album:before {\n  content: \"\\ecec\";\n}\n.bxs-pie-chart:before {\n  content: \"\\eced\";\n}\n.bxs-pie-chart-alt:before {\n  content: \"\\ecee\";\n}\n.bxs-pie-chart-alt-2:before {\n  content: \"\\ecef\";\n}\n.bxs-pin:before {\n  content: \"\\ecf0\";\n}\n.bxs-plane:before {\n  content: \"\\ecf1\";\n}\n.bxs-plane-alt:before {\n  content: \"\\ecf2\";\n}\n.bxs-plane-land:before {\n  content: \"\\ecf3\";\n}\n.bxs-planet:before {\n  content: \"\\ecf4\";\n}\n.bxs-plane-take-off:before {\n  content: \"\\ecf5\";\n}\n.bxs-playlist:before {\n  content: \"\\ecf6\";\n}\n.bxs-plug:before {\n  content: \"\\ecf7\";\n}\n.bxs-plus-circle:before {\n  content: \"\\ecf8\";\n}\n.bxs-plus-square:before {\n  content: \"\\ecf9\";\n}\n.bxs-polygon:before {\n  content: \"\\ecfa\";\n}\n.bxs-printer:before {\n  content: \"\\ecfb\";\n}\n.bxs-purchase-tag:before {\n  content: \"\\ecfc\";\n}\n.bxs-purchase-tag-alt:before {\n  content: \"\\ecfd\";\n}\n.bxs-pyramid:before {\n  content: \"\\ecfe\";\n}\n.bxs-quote-alt-left:before {\n  content: \"\\ecff\";\n}\n.bxs-quote-alt-right:before {\n  content: \"\\ed00\";\n}\n.bxs-quote-left:before {\n  content: \"\\ed01\";\n}\n.bxs-quote-right:before {\n  content: \"\\ed02\";\n}\n.bxs-quote-single-left:before {\n  content: \"\\ed03\";\n}\n.bxs-quote-single-right:before {\n  content: \"\\ed04\";\n}\n.bxs-radio:before {\n  content: \"\\ed05\";\n}\n.bxs-receipt:before {\n  content: \"\\ed06\";\n}\n.bxs-rectangle:before {\n  content: \"\\ed07\";\n}\n.bxs-rename:before {\n  content: \"\\ed08\";\n}\n.bxs-report:before {\n  content: \"\\ed09\";\n}\n.bxs-rewind-circle:before {\n  content: \"\\ed0a\";\n}\n.bxs-right-arrow:before {\n  content: \"\\ed0b\";\n}\n.bxs-right-arrow-circle:before {\n  content: \"\\ed0c\";\n}\n.bxs-right-arrow-square:before {\n  content: \"\\ed0d\";\n}\n.bxs-right-down-arrow-circle:before {\n  content: \"\\ed0e\";\n}\n.bxs-right-top-arrow-circle:before {\n  content: \"\\ed0f\";\n}\n.bxs-rocket:before {\n  content: \"\\ed10\";\n}\n.bxs-ruler:before {\n  content: \"\\ed11\";\n}\n.bxs-sad:before {\n  content: \"\\ed12\";\n}\n.bxs-save:before {\n  content: \"\\ed13\";\n}\n.bxs-school:before {\n  content: \"\\ed14\";\n}\n.bxs-search:before {\n  content: \"\\ed15\";\n}\n.bxs-search-alt-2:before {\n  content: \"\\ed16\";\n}\n.bxs-select-multiple:before {\n  content: \"\\ed17\";\n}\n.bxs-send:before {\n  content: \"\\ed18\";\n}\n.bxs-server:before {\n  content: \"\\ed19\";\n}\n.bxs-share:before {\n  content: \"\\ed1a\";\n}\n.bxs-share-alt:before {\n  content: \"\\ed1b\";\n}\n.bxs-shield:before {\n  content: \"\\ed1c\";\n}\n.bxs-shield-alt-2:before {\n  content: \"\\ed1d\";\n}\n.bxs-ship:before {\n  content: \"\\ed1e\";\n}\n.bxs-shocked:before {\n  content: \"\\ed1f\";\n}\n.bxs-shopping-bag:before {\n  content: \"\\ed20\";\n}\n.bxs-shopping-bag-alt:before {\n  content: \"\\ed21\";\n}\n.bxs-show:before {\n  content: \"\\ed22\";\n}\n.bxs-skip-next-circle:before {\n  content: \"\\ed23\";\n}\n.bxs-skip-previous-circle:before {\n  content: \"\\ed24\";\n}\n.bxs-skull:before {\n  content: \"\\ed25\";\n}\n.bxs-sleepy:before {\n  content: \"\\ed26\";\n}\n.bxs-slideshow:before {\n  content: \"\\ed27\";\n}\n.bxs-smile:before {\n  content: \"\\ed28\";\n}\n.bxs-sort-alt:before {\n  content: \"\\ed29\";\n}\n.bxs-spa:before {\n  content: \"\\ed2a\";\n}\n.bxs-spreadsheet:before {\n  content: \"\\ed2b\";\n}\n.bxs-square:before {\n  content: \"\\ed2c\";\n}\n.bxs-square-rounded:before {\n  content: \"\\ed2d\";\n}\n.bxs-star:before {\n  content: \"\\ed2e\";\n}\n.bxs-star-half:before {\n  content: \"\\ed2f\";\n}\n.bxs-stopwatch:before {\n  content: \"\\ed30\";\n}\n.bxs-store:before {\n  content: \"\\ed31\";\n}\n.bxs-store-alt:before {\n  content: \"\\ed32\";\n}\n.bxs-sun:before {\n  content: \"\\ed33\";\n}\n.bxs-tag:before {\n  content: \"\\ed34\";\n}\n.bxs-tag-x:before {\n  content: \"\\ed35\";\n}\n.bxs-taxi:before {\n  content: \"\\ed36\";\n}\n.bxs-tennis-ball:before {\n  content: \"\\ed37\";\n}\n.bxs-terminal:before {\n  content: \"\\ed38\";\n}\n.bxs-time:before {\n  content: \"\\ed39\";\n}\n.bxs-time-five:before {\n  content: \"\\ed3a\";\n}\n.bxs-timer:before {\n  content: \"\\ed3b\";\n}\n.bxs-tired:before {\n  content: \"\\ed3c\";\n}\n.bxs-toggle-left:before {\n  content: \"\\ed3d\";\n}\n.bxs-toggle-right:before {\n  content: \"\\ed3e\";\n}\n.bxs-tone:before {\n  content: \"\\ed3f\";\n}\n.bxs-torch:before {\n  content: \"\\ed40\";\n}\n.bxs-to-top:before {\n  content: \"\\ed41\";\n}\n.bxs-traffic:before {\n  content: \"\\ed42\";\n}\n.bxs-traffic-barrier:before {\n  content: \"\\ed43\";\n}\n.bxs-train:before {\n  content: \"\\ed44\";\n}\n.bxs-trash:before {\n  content: \"\\ed45\";\n}\n.bxs-trash-alt:before {\n  content: \"\\ed46\";\n}\n.bxs-tree:before {\n  content: \"\\ed47\";\n}\n.bxs-trophy:before {\n  content: \"\\ed48\";\n}\n.bxs-truck:before {\n  content: \"\\ed49\";\n}\n.bxs-t-shirt:before {\n  content: \"\\ed4a\";\n}\n.bxs-up-arrow:before {\n  content: \"\\ed4b\";\n}\n.bxs-up-arrow-circle:before {\n  content: \"\\ed4c\";\n}\n.bxs-up-arrow-square:before {\n  content: \"\\ed4d\";\n}\n.bxs-upside-down:before {\n  content: \"\\ed4e\";\n}\n.bxs-upvote:before {\n  content: \"\\ed4f\";\n}\n.bxs-user:before {\n  content: \"\\ed50\";\n}\n.bxs-user-badge:before {\n  content: \"\\ed51\";\n}\n.bxs-user-check:before {\n  content: \"\\ed52\";\n}\n.bxs-user-circle:before {\n  content: \"\\ed53\";\n}\n.bxs-user-detail:before {\n  content: \"\\ed54\";\n}\n.bxs-user-minus:before {\n  content: \"\\ed55\";\n}\n.bxs-user-pin:before {\n  content: \"\\ed56\";\n}\n.bxs-user-plus:before {\n  content: \"\\ed57\";\n}\n.bxs-user-rectangle:before {\n  content: \"\\ed58\";\n}\n.bxs-user-voice:before {\n  content: \"\\ed59\";\n}\n.bxs-user-x:before {\n  content: \"\\ed5a\";\n}\n.bxs-vial:before {\n  content: \"\\ed5b\";\n}\n.bxs-video:before {\n  content: \"\\ed5c\";\n}\n.bxs-video-off:before {\n  content: \"\\ed5d\";\n}\n.bxs-video-plus:before {\n  content: \"\\ed5e\";\n}\n.bxs-video-recording:before {\n  content: \"\\ed5f\";\n}\n.bxs-videos:before {\n  content: \"\\ed60\";\n}\n.bxs-volume:before {\n  content: \"\\ed61\";\n}\n.bxs-volume-full:before {\n  content: \"\\ed62\";\n}\n.bxs-volume-low:before {\n  content: \"\\ed63\";\n}\n.bxs-volume-mute:before {\n  content: \"\\ed64\";\n}\n.bxs-wallet:before {\n  content: \"\\ed65\";\n}\n.bxs-wallet-alt:before {\n  content: \"\\ed66\";\n}\n.bxs-watch:before {\n  content: \"\\ed67\";\n}\n.bxs-watch-alt:before {\n  content: \"\\ed68\";\n}\n.bxs-widget:before {\n  content: \"\\ed69\";\n}\n.bxs-wine:before {\n  content: \"\\ed6a\";\n}\n.bxs-wink-smile:before {\n  content: \"\\ed6b\";\n}\n.bxs-wink-tongue:before {\n  content: \"\\ed6c\";\n}\n.bxs-wrench:before {\n  content: \"\\ed6d\";\n}\n.bxs-x-circle:before {\n  content: \"\\ed6e\";\n}\n.bxs-x-square:before {\n  content: \"\\ed6f\";\n}\n.bxs-yin-yang:before {\n  content: \"\\ed70\";\n}\n.bxs-zap:before {\n  content: \"\\ed71\";\n}\n.bxs-zoom-in:before {\n  content: \"\\ed72\";\n}\n.bxs-zoom-out:before {\n  content: \"\\ed73\";\n}\n","/*!\n * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */\n.fa,\n.fas,\n.far,\n.fal,\n.fad,\n.fab {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.fa-stack-1x {\n  line-height: inherit; }\n\n.fa-stack-2x {\n  font-size: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.fa-500px:before {\n  content: \"\\f26e\"; }\n\n.fa-accessible-icon:before {\n  content: \"\\f368\"; }\n\n.fa-accusoft:before {\n  content: \"\\f369\"; }\n\n.fa-acquisitions-incorporated:before {\n  content: \"\\f6af\"; }\n\n.fa-ad:before {\n  content: \"\\f641\"; }\n\n.fa-address-book:before {\n  content: \"\\f2b9\"; }\n\n.fa-address-card:before {\n  content: \"\\f2bb\"; }\n\n.fa-adjust:before {\n  content: \"\\f042\"; }\n\n.fa-adn:before {\n  content: \"\\f170\"; }\n\n.fa-adobe:before {\n  content: \"\\f778\"; }\n\n.fa-adversal:before {\n  content: \"\\f36a\"; }\n\n.fa-affiliatetheme:before {\n  content: \"\\f36b\"; }\n\n.fa-air-freshener:before {\n  content: \"\\f5d0\"; }\n\n.fa-airbnb:before {\n  content: \"\\f834\"; }\n\n.fa-algolia:before {\n  content: \"\\f36c\"; }\n\n.fa-align-center:before {\n  content: \"\\f037\"; }\n\n.fa-align-justify:before {\n  content: \"\\f039\"; }\n\n.fa-align-left:before {\n  content: \"\\f036\"; }\n\n.fa-align-right:before {\n  content: \"\\f038\"; }\n\n.fa-alipay:before {\n  content: \"\\f642\"; }\n\n.fa-allergies:before {\n  content: \"\\f461\"; }\n\n.fa-amazon:before {\n  content: \"\\f270\"; }\n\n.fa-amazon-pay:before {\n  content: \"\\f42c\"; }\n\n.fa-ambulance:before {\n  content: \"\\f0f9\"; }\n\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.fa-amilia:before {\n  content: \"\\f36d\"; }\n\n.fa-anchor:before {\n  content: \"\\f13d\"; }\n\n.fa-android:before {\n  content: \"\\f17b\"; }\n\n.fa-angellist:before {\n  content: \"\\f209\"; }\n\n.fa-angle-double-down:before {\n  content: \"\\f103\"; }\n\n.fa-angle-double-left:before {\n  content: \"\\f100\"; }\n\n.fa-angle-double-right:before {\n  content: \"\\f101\"; }\n\n.fa-angle-double-up:before {\n  content: \"\\f102\"; }\n\n.fa-angle-down:before {\n  content: \"\\f107\"; }\n\n.fa-angle-left:before {\n  content: \"\\f104\"; }\n\n.fa-angle-right:before {\n  content: \"\\f105\"; }\n\n.fa-angle-up:before {\n  content: \"\\f106\"; }\n\n.fa-angry:before {\n  content: \"\\f556\"; }\n\n.fa-angrycreative:before {\n  content: \"\\f36e\"; }\n\n.fa-angular:before {\n  content: \"\\f420\"; }\n\n.fa-ankh:before {\n  content: \"\\f644\"; }\n\n.fa-app-store:before {\n  content: \"\\f36f\"; }\n\n.fa-app-store-ios:before {\n  content: \"\\f370\"; }\n\n.fa-apper:before {\n  content: \"\\f371\"; }\n\n.fa-apple:before {\n  content: \"\\f179\"; }\n\n.fa-apple-alt:before {\n  content: \"\\f5d1\"; }\n\n.fa-apple-pay:before {\n  content: \"\\f415\"; }\n\n.fa-archive:before {\n  content: \"\\f187\"; }\n\n.fa-archway:before {\n  content: \"\\f557\"; }\n\n.fa-arrow-alt-circle-down:before {\n  content: \"\\f358\"; }\n\n.fa-arrow-alt-circle-left:before {\n  content: \"\\f359\"; }\n\n.fa-arrow-alt-circle-right:before {\n  content: \"\\f35a\"; }\n\n.fa-arrow-alt-circle-up:before {\n  content: \"\\f35b\"; }\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\"; }\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\"; }\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\"; }\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\"; }\n\n.fa-arrow-down:before {\n  content: \"\\f063\"; }\n\n.fa-arrow-left:before {\n  content: \"\\f060\"; }\n\n.fa-arrow-right:before {\n  content: \"\\f061\"; }\n\n.fa-arrow-up:before {\n  content: \"\\f062\"; }\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\"; }\n\n.fa-arrows-alt-h:before {\n  content: \"\\f337\"; }\n\n.fa-arrows-alt-v:before {\n  content: \"\\f338\"; }\n\n.fa-artstation:before {\n  content: \"\\f77a\"; }\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\"; }\n\n.fa-asterisk:before {\n  content: \"\\f069\"; }\n\n.fa-asymmetrik:before {\n  content: \"\\f372\"; }\n\n.fa-at:before {\n  content: \"\\f1fa\"; }\n\n.fa-atlas:before {\n  content: \"\\f558\"; }\n\n.fa-atlassian:before {\n  content: \"\\f77b\"; }\n\n.fa-atom:before {\n  content: \"\\f5d2\"; }\n\n.fa-audible:before {\n  content: \"\\f373\"; }\n\n.fa-audio-description:before {\n  content: \"\\f29e\"; }\n\n.fa-autoprefixer:before {\n  content: \"\\f41c\"; }\n\n.fa-avianex:before {\n  content: \"\\f374\"; }\n\n.fa-aviato:before {\n  content: \"\\f421\"; }\n\n.fa-award:before {\n  content: \"\\f559\"; }\n\n.fa-aws:before {\n  content: \"\\f375\"; }\n\n.fa-baby:before {\n  content: \"\\f77c\"; }\n\n.fa-baby-carriage:before {\n  content: \"\\f77d\"; }\n\n.fa-backspace:before {\n  content: \"\\f55a\"; }\n\n.fa-backward:before {\n  content: \"\\f04a\"; }\n\n.fa-bacon:before {\n  content: \"\\f7e5\"; }\n\n.fa-bahai:before {\n  content: \"\\f666\"; }\n\n.fa-balance-scale:before {\n  content: \"\\f24e\"; }\n\n.fa-balance-scale-left:before {\n  content: \"\\f515\"; }\n\n.fa-balance-scale-right:before {\n  content: \"\\f516\"; }\n\n.fa-ban:before {\n  content: \"\\f05e\"; }\n\n.fa-band-aid:before {\n  content: \"\\f462\"; }\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\"; }\n\n.fa-barcode:before {\n  content: \"\\f02a\"; }\n\n.fa-bars:before {\n  content: \"\\f0c9\"; }\n\n.fa-baseball-ball:before {\n  content: \"\\f433\"; }\n\n.fa-basketball-ball:before {\n  content: \"\\f434\"; }\n\n.fa-bath:before {\n  content: \"\\f2cd\"; }\n\n.fa-battery-empty:before {\n  content: \"\\f244\"; }\n\n.fa-battery-full:before {\n  content: \"\\f240\"; }\n\n.fa-battery-half:before {\n  content: \"\\f242\"; }\n\n.fa-battery-quarter:before {\n  content: \"\\f243\"; }\n\n.fa-battery-three-quarters:before {\n  content: \"\\f241\"; }\n\n.fa-battle-net:before {\n  content: \"\\f835\"; }\n\n.fa-bed:before {\n  content: \"\\f236\"; }\n\n.fa-beer:before {\n  content: \"\\f0fc\"; }\n\n.fa-behance:before {\n  content: \"\\f1b4\"; }\n\n.fa-behance-square:before {\n  content: \"\\f1b5\"; }\n\n.fa-bell:before {\n  content: \"\\f0f3\"; }\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\"; }\n\n.fa-bezier-curve:before {\n  content: \"\\f55b\"; }\n\n.fa-bible:before {\n  content: \"\\f647\"; }\n\n.fa-bicycle:before {\n  content: \"\\f206\"; }\n\n.fa-biking:before {\n  content: \"\\f84a\"; }\n\n.fa-bimobject:before {\n  content: \"\\f378\"; }\n\n.fa-binoculars:before {\n  content: \"\\f1e5\"; }\n\n.fa-biohazard:before {\n  content: \"\\f780\"; }\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\"; }\n\n.fa-bitbucket:before {\n  content: \"\\f171\"; }\n\n.fa-bitcoin:before {\n  content: \"\\f379\"; }\n\n.fa-bity:before {\n  content: \"\\f37a\"; }\n\n.fa-black-tie:before {\n  content: \"\\f27e\"; }\n\n.fa-blackberry:before {\n  content: \"\\f37b\"; }\n\n.fa-blender:before {\n  content: \"\\f517\"; }\n\n.fa-blender-phone:before {\n  content: \"\\f6b6\"; }\n\n.fa-blind:before {\n  content: \"\\f29d\"; }\n\n.fa-blog:before {\n  content: \"\\f781\"; }\n\n.fa-blogger:before {\n  content: \"\\f37c\"; }\n\n.fa-blogger-b:before {\n  content: \"\\f37d\"; }\n\n.fa-bluetooth:before {\n  content: \"\\f293\"; }\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\"; }\n\n.fa-bold:before {\n  content: \"\\f032\"; }\n\n.fa-bolt:before {\n  content: \"\\f0e7\"; }\n\n.fa-bomb:before {\n  content: \"\\f1e2\"; }\n\n.fa-bone:before {\n  content: \"\\f5d7\"; }\n\n.fa-bong:before {\n  content: \"\\f55c\"; }\n\n.fa-book:before {\n  content: \"\\f02d\"; }\n\n.fa-book-dead:before {\n  content: \"\\f6b7\"; }\n\n.fa-book-medical:before {\n  content: \"\\f7e6\"; }\n\n.fa-book-open:before {\n  content: \"\\f518\"; }\n\n.fa-book-reader:before {\n  content: \"\\f5da\"; }\n\n.fa-bookmark:before {\n  content: \"\\f02e\"; }\n\n.fa-bootstrap:before {\n  content: \"\\f836\"; }\n\n.fa-border-all:before {\n  content: \"\\f84c\"; }\n\n.fa-border-none:before {\n  content: \"\\f850\"; }\n\n.fa-border-style:before {\n  content: \"\\f853\"; }\n\n.fa-bowling-ball:before {\n  content: \"\\f436\"; }\n\n.fa-box:before {\n  content: \"\\f466\"; }\n\n.fa-box-open:before {\n  content: \"\\f49e\"; }\n\n.fa-box-tissue:before {\n  content: \"\\f95b\"; }\n\n.fa-boxes:before {\n  content: \"\\f468\"; }\n\n.fa-braille:before {\n  content: \"\\f2a1\"; }\n\n.fa-brain:before {\n  content: \"\\f5dc\"; }\n\n.fa-bread-slice:before {\n  content: \"\\f7ec\"; }\n\n.fa-briefcase:before {\n  content: \"\\f0b1\"; }\n\n.fa-briefcase-medical:before {\n  content: \"\\f469\"; }\n\n.fa-broadcast-tower:before {\n  content: \"\\f519\"; }\n\n.fa-broom:before {\n  content: \"\\f51a\"; }\n\n.fa-brush:before {\n  content: \"\\f55d\"; }\n\n.fa-btc:before {\n  content: \"\\f15a\"; }\n\n.fa-buffer:before {\n  content: \"\\f837\"; }\n\n.fa-bug:before {\n  content: \"\\f188\"; }\n\n.fa-building:before {\n  content: \"\\f1ad\"; }\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\"; }\n\n.fa-bullseye:before {\n  content: \"\\f140\"; }\n\n.fa-burn:before {\n  content: \"\\f46a\"; }\n\n.fa-buromobelexperte:before {\n  content: \"\\f37f\"; }\n\n.fa-bus:before {\n  content: \"\\f207\"; }\n\n.fa-bus-alt:before {\n  content: \"\\f55e\"; }\n\n.fa-business-time:before {\n  content: \"\\f64a\"; }\n\n.fa-buy-n-large:before {\n  content: \"\\f8a6\"; }\n\n.fa-buysellads:before {\n  content: \"\\f20d\"; }\n\n.fa-calculator:before {\n  content: \"\\f1ec\"; }\n\n.fa-calendar:before {\n  content: \"\\f133\"; }\n\n.fa-calendar-alt:before {\n  content: \"\\f073\"; }\n\n.fa-calendar-check:before {\n  content: \"\\f274\"; }\n\n.fa-calendar-day:before {\n  content: \"\\f783\"; }\n\n.fa-calendar-minus:before {\n  content: \"\\f272\"; }\n\n.fa-calendar-plus:before {\n  content: \"\\f271\"; }\n\n.fa-calendar-times:before {\n  content: \"\\f273\"; }\n\n.fa-calendar-week:before {\n  content: \"\\f784\"; }\n\n.fa-camera:before {\n  content: \"\\f030\"; }\n\n.fa-camera-retro:before {\n  content: \"\\f083\"; }\n\n.fa-campground:before {\n  content: \"\\f6bb\"; }\n\n.fa-canadian-maple-leaf:before {\n  content: \"\\f785\"; }\n\n.fa-candy-cane:before {\n  content: \"\\f786\"; }\n\n.fa-cannabis:before {\n  content: \"\\f55f\"; }\n\n.fa-capsules:before {\n  content: \"\\f46b\"; }\n\n.fa-car:before {\n  content: \"\\f1b9\"; }\n\n.fa-car-alt:before {\n  content: \"\\f5de\"; }\n\n.fa-car-battery:before {\n  content: \"\\f5df\"; }\n\n.fa-car-crash:before {\n  content: \"\\f5e1\"; }\n\n.fa-car-side:before {\n  content: \"\\f5e4\"; }\n\n.fa-caravan:before {\n  content: \"\\f8ff\"; }\n\n.fa-caret-down:before {\n  content: \"\\f0d7\"; }\n\n.fa-caret-left:before {\n  content: \"\\f0d9\"; }\n\n.fa-caret-right:before {\n  content: \"\\f0da\"; }\n\n.fa-caret-square-down:before {\n  content: \"\\f150\"; }\n\n.fa-caret-square-left:before {\n  content: \"\\f191\"; }\n\n.fa-caret-square-right:before {\n  content: \"\\f152\"; }\n\n.fa-caret-square-up:before {\n  content: \"\\f151\"; }\n\n.fa-caret-up:before {\n  content: \"\\f0d8\"; }\n\n.fa-carrot:before {\n  content: \"\\f787\"; }\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\"; }\n\n.fa-cart-plus:before {\n  content: \"\\f217\"; }\n\n.fa-cash-register:before {\n  content: \"\\f788\"; }\n\n.fa-cat:before {\n  content: \"\\f6be\"; }\n\n.fa-cc-amazon-pay:before {\n  content: \"\\f42d\"; }\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\"; }\n\n.fa-cc-apple-pay:before {\n  content: \"\\f416\"; }\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\"; }\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\"; }\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\"; }\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\"; }\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\"; }\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\"; }\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\"; }\n\n.fa-centercode:before {\n  content: \"\\f380\"; }\n\n.fa-centos:before {\n  content: \"\\f789\"; }\n\n.fa-certificate:before {\n  content: \"\\f0a3\"; }\n\n.fa-chair:before {\n  content: \"\\f6c0\"; }\n\n.fa-chalkboard:before {\n  content: \"\\f51b\"; }\n\n.fa-chalkboard-teacher:before {\n  content: \"\\f51c\"; }\n\n.fa-charging-station:before {\n  content: \"\\f5e7\"; }\n\n.fa-chart-area:before {\n  content: \"\\f1fe\"; }\n\n.fa-chart-bar:before {\n  content: \"\\f080\"; }\n\n.fa-chart-line:before {\n  content: \"\\f201\"; }\n\n.fa-chart-pie:before {\n  content: \"\\f200\"; }\n\n.fa-check:before {\n  content: \"\\f00c\"; }\n\n.fa-check-circle:before {\n  content: \"\\f058\"; }\n\n.fa-check-double:before {\n  content: \"\\f560\"; }\n\n.fa-check-square:before {\n  content: \"\\f14a\"; }\n\n.fa-cheese:before {\n  content: \"\\f7ef\"; }\n\n.fa-chess:before {\n  content: \"\\f439\"; }\n\n.fa-chess-bishop:before {\n  content: \"\\f43a\"; }\n\n.fa-chess-board:before {\n  content: \"\\f43c\"; }\n\n.fa-chess-king:before {\n  content: \"\\f43f\"; }\n\n.fa-chess-knight:before {\n  content: \"\\f441\"; }\n\n.fa-chess-pawn:before {\n  content: \"\\f443\"; }\n\n.fa-chess-queen:before {\n  content: \"\\f445\"; }\n\n.fa-chess-rook:before {\n  content: \"\\f447\"; }\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\"; }\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\"; }\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\"; }\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\"; }\n\n.fa-chevron-down:before {\n  content: \"\\f078\"; }\n\n.fa-chevron-left:before {\n  content: \"\\f053\"; }\n\n.fa-chevron-right:before {\n  content: \"\\f054\"; }\n\n.fa-chevron-up:before {\n  content: \"\\f077\"; }\n\n.fa-child:before {\n  content: \"\\f1ae\"; }\n\n.fa-chrome:before {\n  content: \"\\f268\"; }\n\n.fa-chromecast:before {\n  content: \"\\f838\"; }\n\n.fa-church:before {\n  content: \"\\f51d\"; }\n\n.fa-circle:before {\n  content: \"\\f111\"; }\n\n.fa-circle-notch:before {\n  content: \"\\f1ce\"; }\n\n.fa-city:before {\n  content: \"\\f64f\"; }\n\n.fa-clinic-medical:before {\n  content: \"\\f7f2\"; }\n\n.fa-clipboard:before {\n  content: \"\\f328\"; }\n\n.fa-clipboard-check:before {\n  content: \"\\f46c\"; }\n\n.fa-clipboard-list:before {\n  content: \"\\f46d\"; }\n\n.fa-clock:before {\n  content: \"\\f017\"; }\n\n.fa-clone:before {\n  content: \"\\f24d\"; }\n\n.fa-closed-captioning:before {\n  content: \"\\f20a\"; }\n\n.fa-cloud:before {\n  content: \"\\f0c2\"; }\n\n.fa-cloud-download-alt:before {\n  content: \"\\f381\"; }\n\n.fa-cloud-meatball:before {\n  content: \"\\f73b\"; }\n\n.fa-cloud-moon:before {\n  content: \"\\f6c3\"; }\n\n.fa-cloud-moon-rain:before {\n  content: \"\\f73c\"; }\n\n.fa-cloud-rain:before {\n  content: \"\\f73d\"; }\n\n.fa-cloud-showers-heavy:before {\n  content: \"\\f740\"; }\n\n.fa-cloud-sun:before {\n  content: \"\\f6c4\"; }\n\n.fa-cloud-sun-rain:before {\n  content: \"\\f743\"; }\n\n.fa-cloud-upload-alt:before {\n  content: \"\\f382\"; }\n\n.fa-cloudscale:before {\n  content: \"\\f383\"; }\n\n.fa-cloudsmith:before {\n  content: \"\\f384\"; }\n\n.fa-cloudversify:before {\n  content: \"\\f385\"; }\n\n.fa-cocktail:before {\n  content: \"\\f561\"; }\n\n.fa-code:before {\n  content: \"\\f121\"; }\n\n.fa-code-branch:before {\n  content: \"\\f126\"; }\n\n.fa-codepen:before {\n  content: \"\\f1cb\"; }\n\n.fa-codiepie:before {\n  content: \"\\f284\"; }\n\n.fa-coffee:before {\n  content: \"\\f0f4\"; }\n\n.fa-cog:before {\n  content: \"\\f013\"; }\n\n.fa-cogs:before {\n  content: \"\\f085\"; }\n\n.fa-coins:before {\n  content: \"\\f51e\"; }\n\n.fa-columns:before {\n  content: \"\\f0db\"; }\n\n.fa-comment:before {\n  content: \"\\f075\"; }\n\n.fa-comment-alt:before {\n  content: \"\\f27a\"; }\n\n.fa-comment-dollar:before {\n  content: \"\\f651\"; }\n\n.fa-comment-dots:before {\n  content: \"\\f4ad\"; }\n\n.fa-comment-medical:before {\n  content: \"\\f7f5\"; }\n\n.fa-comment-slash:before {\n  content: \"\\f4b3\"; }\n\n.fa-comments:before {\n  content: \"\\f086\"; }\n\n.fa-comments-dollar:before {\n  content: \"\\f653\"; }\n\n.fa-compact-disc:before {\n  content: \"\\f51f\"; }\n\n.fa-compass:before {\n  content: \"\\f14e\"; }\n\n.fa-compress:before {\n  content: \"\\f066\"; }\n\n.fa-compress-alt:before {\n  content: \"\\f422\"; }\n\n.fa-compress-arrows-alt:before {\n  content: \"\\f78c\"; }\n\n.fa-concierge-bell:before {\n  content: \"\\f562\"; }\n\n.fa-confluence:before {\n  content: \"\\f78d\"; }\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\"; }\n\n.fa-contao:before {\n  content: \"\\f26d\"; }\n\n.fa-cookie:before {\n  content: \"\\f563\"; }\n\n.fa-cookie-bite:before {\n  content: \"\\f564\"; }\n\n.fa-copy:before {\n  content: \"\\f0c5\"; }\n\n.fa-copyright:before {\n  content: \"\\f1f9\"; }\n\n.fa-cotton-bureau:before {\n  content: \"\\f89e\"; }\n\n.fa-couch:before {\n  content: \"\\f4b8\"; }\n\n.fa-cpanel:before {\n  content: \"\\f388\"; }\n\n.fa-creative-commons:before {\n  content: \"\\f25e\"; }\n\n.fa-creative-commons-by:before {\n  content: \"\\f4e7\"; }\n\n.fa-creative-commons-nc:before {\n  content: \"\\f4e8\"; }\n\n.fa-creative-commons-nc-eu:before {\n  content: \"\\f4e9\"; }\n\n.fa-creative-commons-nc-jp:before {\n  content: \"\\f4ea\"; }\n\n.fa-creative-commons-nd:before {\n  content: \"\\f4eb\"; }\n\n.fa-creative-commons-pd:before {\n  content: \"\\f4ec\"; }\n\n.fa-creative-commons-pd-alt:before {\n  content: \"\\f4ed\"; }\n\n.fa-creative-commons-remix:before {\n  content: \"\\f4ee\"; }\n\n.fa-creative-commons-sa:before {\n  content: \"\\f4ef\"; }\n\n.fa-creative-commons-sampling:before {\n  content: \"\\f4f0\"; }\n\n.fa-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\"; }\n\n.fa-creative-commons-share:before {\n  content: \"\\f4f2\"; }\n\n.fa-creative-commons-zero:before {\n  content: \"\\f4f3\"; }\n\n.fa-credit-card:before {\n  content: \"\\f09d\"; }\n\n.fa-critical-role:before {\n  content: \"\\f6c9\"; }\n\n.fa-crop:before {\n  content: \"\\f125\"; }\n\n.fa-crop-alt:before {\n  content: \"\\f565\"; }\n\n.fa-cross:before {\n  content: \"\\f654\"; }\n\n.fa-crosshairs:before {\n  content: \"\\f05b\"; }\n\n.fa-crow:before {\n  content: \"\\f520\"; }\n\n.fa-crown:before {\n  content: \"\\f521\"; }\n\n.fa-crutch:before {\n  content: \"\\f7f7\"; }\n\n.fa-css3:before {\n  content: \"\\f13c\"; }\n\n.fa-css3-alt:before {\n  content: \"\\f38b\"; }\n\n.fa-cube:before {\n  content: \"\\f1b2\"; }\n\n.fa-cubes:before {\n  content: \"\\f1b3\"; }\n\n.fa-cut:before {\n  content: \"\\f0c4\"; }\n\n.fa-cuttlefish:before {\n  content: \"\\f38c\"; }\n\n.fa-d-and-d:before {\n  content: \"\\f38d\"; }\n\n.fa-d-and-d-beyond:before {\n  content: \"\\f6ca\"; }\n\n.fa-dailymotion:before {\n  content: \"\\f952\"; }\n\n.fa-dashcube:before {\n  content: \"\\f210\"; }\n\n.fa-database:before {\n  content: \"\\f1c0\"; }\n\n.fa-deaf:before {\n  content: \"\\f2a4\"; }\n\n.fa-delicious:before {\n  content: \"\\f1a5\"; }\n\n.fa-democrat:before {\n  content: \"\\f747\"; }\n\n.fa-deploydog:before {\n  content: \"\\f38e\"; }\n\n.fa-deskpro:before {\n  content: \"\\f38f\"; }\n\n.fa-desktop:before {\n  content: \"\\f108\"; }\n\n.fa-dev:before {\n  content: \"\\f6cc\"; }\n\n.fa-deviantart:before {\n  content: \"\\f1bd\"; }\n\n.fa-dharmachakra:before {\n  content: \"\\f655\"; }\n\n.fa-dhl:before {\n  content: \"\\f790\"; }\n\n.fa-diagnoses:before {\n  content: \"\\f470\"; }\n\n.fa-diaspora:before {\n  content: \"\\f791\"; }\n\n.fa-dice:before {\n  content: \"\\f522\"; }\n\n.fa-dice-d20:before {\n  content: \"\\f6cf\"; }\n\n.fa-dice-d6:before {\n  content: \"\\f6d1\"; }\n\n.fa-dice-five:before {\n  content: \"\\f523\"; }\n\n.fa-dice-four:before {\n  content: \"\\f524\"; }\n\n.fa-dice-one:before {\n  content: \"\\f525\"; }\n\n.fa-dice-six:before {\n  content: \"\\f526\"; }\n\n.fa-dice-three:before {\n  content: \"\\f527\"; }\n\n.fa-dice-two:before {\n  content: \"\\f528\"; }\n\n.fa-digg:before {\n  content: \"\\f1a6\"; }\n\n.fa-digital-ocean:before {\n  content: \"\\f391\"; }\n\n.fa-digital-tachograph:before {\n  content: \"\\f566\"; }\n\n.fa-directions:before {\n  content: \"\\f5eb\"; }\n\n.fa-discord:before {\n  content: \"\\f392\"; }\n\n.fa-discourse:before {\n  content: \"\\f393\"; }\n\n.fa-disease:before {\n  content: \"\\f7fa\"; }\n\n.fa-divide:before {\n  content: \"\\f529\"; }\n\n.fa-dizzy:before {\n  content: \"\\f567\"; }\n\n.fa-dna:before {\n  content: \"\\f471\"; }\n\n.fa-dochub:before {\n  content: \"\\f394\"; }\n\n.fa-docker:before {\n  content: \"\\f395\"; }\n\n.fa-dog:before {\n  content: \"\\f6d3\"; }\n\n.fa-dollar-sign:before {\n  content: \"\\f155\"; }\n\n.fa-dolly:before {\n  content: \"\\f472\"; }\n\n.fa-dolly-flatbed:before {\n  content: \"\\f474\"; }\n\n.fa-donate:before {\n  content: \"\\f4b9\"; }\n\n.fa-door-closed:before {\n  content: \"\\f52a\"; }\n\n.fa-door-open:before {\n  content: \"\\f52b\"; }\n\n.fa-dot-circle:before {\n  content: \"\\f192\"; }\n\n.fa-dove:before {\n  content: \"\\f4ba\"; }\n\n.fa-download:before {\n  content: \"\\f019\"; }\n\n.fa-draft2digital:before {\n  content: \"\\f396\"; }\n\n.fa-drafting-compass:before {\n  content: \"\\f568\"; }\n\n.fa-dragon:before {\n  content: \"\\f6d5\"; }\n\n.fa-draw-polygon:before {\n  content: \"\\f5ee\"; }\n\n.fa-dribbble:before {\n  content: \"\\f17d\"; }\n\n.fa-dribbble-square:before {\n  content: \"\\f397\"; }\n\n.fa-dropbox:before {\n  content: \"\\f16b\"; }\n\n.fa-drum:before {\n  content: \"\\f569\"; }\n\n.fa-drum-steelpan:before {\n  content: \"\\f56a\"; }\n\n.fa-drumstick-bite:before {\n  content: \"\\f6d7\"; }\n\n.fa-drupal:before {\n  content: \"\\f1a9\"; }\n\n.fa-dumbbell:before {\n  content: \"\\f44b\"; }\n\n.fa-dumpster:before {\n  content: \"\\f793\"; }\n\n.fa-dumpster-fire:before {\n  content: \"\\f794\"; }\n\n.fa-dungeon:before {\n  content: \"\\f6d9\"; }\n\n.fa-dyalog:before {\n  content: \"\\f399\"; }\n\n.fa-earlybirds:before {\n  content: \"\\f39a\"; }\n\n.fa-ebay:before {\n  content: \"\\f4f4\"; }\n\n.fa-edge:before {\n  content: \"\\f282\"; }\n\n.fa-edit:before {\n  content: \"\\f044\"; }\n\n.fa-egg:before {\n  content: \"\\f7fb\"; }\n\n.fa-eject:before {\n  content: \"\\f052\"; }\n\n.fa-elementor:before {\n  content: \"\\f430\"; }\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\"; }\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\"; }\n\n.fa-ello:before {\n  content: \"\\f5f1\"; }\n\n.fa-ember:before {\n  content: \"\\f423\"; }\n\n.fa-empire:before {\n  content: \"\\f1d1\"; }\n\n.fa-envelope:before {\n  content: \"\\f0e0\"; }\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\"; }\n\n.fa-envelope-open-text:before {\n  content: \"\\f658\"; }\n\n.fa-envelope-square:before {\n  content: \"\\f199\"; }\n\n.fa-envira:before {\n  content: \"\\f299\"; }\n\n.fa-equals:before {\n  content: \"\\f52c\"; }\n\n.fa-eraser:before {\n  content: \"\\f12d\"; }\n\n.fa-erlang:before {\n  content: \"\\f39d\"; }\n\n.fa-ethereum:before {\n  content: \"\\f42e\"; }\n\n.fa-ethernet:before {\n  content: \"\\f796\"; }\n\n.fa-etsy:before {\n  content: \"\\f2d7\"; }\n\n.fa-euro-sign:before {\n  content: \"\\f153\"; }\n\n.fa-evernote:before {\n  content: \"\\f839\"; }\n\n.fa-exchange-alt:before {\n  content: \"\\f362\"; }\n\n.fa-exclamation:before {\n  content: \"\\f12a\"; }\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\"; }\n\n.fa-exclamation-triangle:before {\n  content: \"\\f071\"; }\n\n.fa-expand:before {\n  content: \"\\f065\"; }\n\n.fa-expand-alt:before {\n  content: \"\\f424\"; }\n\n.fa-expand-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\"; }\n\n.fa-external-link-alt:before {\n  content: \"\\f35d\"; }\n\n.fa-external-link-square-alt:before {\n  content: \"\\f360\"; }\n\n.fa-eye:before {\n  content: \"\\f06e\"; }\n\n.fa-eye-dropper:before {\n  content: \"\\f1fb\"; }\n\n.fa-eye-slash:before {\n  content: \"\\f070\"; }\n\n.fa-facebook:before {\n  content: \"\\f09a\"; }\n\n.fa-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.fa-facebook-messenger:before {\n  content: \"\\f39f\"; }\n\n.fa-facebook-square:before {\n  content: \"\\f082\"; }\n\n.fa-fan:before {\n  content: \"\\f863\"; }\n\n.fa-fantasy-flight-games:before {\n  content: \"\\f6dc\"; }\n\n.fa-fast-backward:before {\n  content: \"\\f049\"; }\n\n.fa-fast-forward:before {\n  content: \"\\f050\"; }\n\n.fa-faucet:before {\n  content: \"\\f905\"; }\n\n.fa-fax:before {\n  content: \"\\f1ac\"; }\n\n.fa-feather:before {\n  content: \"\\f52d\"; }\n\n.fa-feather-alt:before {\n  content: \"\\f56b\"; }\n\n.fa-fedex:before {\n  content: \"\\f797\"; }\n\n.fa-fedora:before {\n  content: \"\\f798\"; }\n\n.fa-female:before {\n  content: \"\\f182\"; }\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\"; }\n\n.fa-figma:before {\n  content: \"\\f799\"; }\n\n.fa-file:before {\n  content: \"\\f15b\"; }\n\n.fa-file-alt:before {\n  content: \"\\f15c\"; }\n\n.fa-file-archive:before {\n  content: \"\\f1c6\"; }\n\n.fa-file-audio:before {\n  content: \"\\f1c7\"; }\n\n.fa-file-code:before {\n  content: \"\\f1c9\"; }\n\n.fa-file-contract:before {\n  content: \"\\f56c\"; }\n\n.fa-file-csv:before {\n  content: \"\\f6dd\"; }\n\n.fa-file-download:before {\n  content: \"\\f56d\"; }\n\n.fa-file-excel:before {\n  content: \"\\f1c3\"; }\n\n.fa-file-export:before {\n  content: \"\\f56e\"; }\n\n.fa-file-image:before {\n  content: \"\\f1c5\"; }\n\n.fa-file-import:before {\n  content: \"\\f56f\"; }\n\n.fa-file-invoice:before {\n  content: \"\\f570\"; }\n\n.fa-file-invoice-dollar:before {\n  content: \"\\f571\"; }\n\n.fa-file-medical:before {\n  content: \"\\f477\"; }\n\n.fa-file-medical-alt:before {\n  content: \"\\f478\"; }\n\n.fa-file-pdf:before {\n  content: \"\\f1c1\"; }\n\n.fa-file-powerpoint:before {\n  content: \"\\f1c4\"; }\n\n.fa-file-prescription:before {\n  content: \"\\f572\"; }\n\n.fa-file-signature:before {\n  content: \"\\f573\"; }\n\n.fa-file-upload:before {\n  content: \"\\f574\"; }\n\n.fa-file-video:before {\n  content: \"\\f1c8\"; }\n\n.fa-file-word:before {\n  content: \"\\f1c2\"; }\n\n.fa-fill:before {\n  content: \"\\f575\"; }\n\n.fa-fill-drip:before {\n  content: \"\\f576\"; }\n\n.fa-film:before {\n  content: \"\\f008\"; }\n\n.fa-filter:before {\n  content: \"\\f0b0\"; }\n\n.fa-fingerprint:before {\n  content: \"\\f577\"; }\n\n.fa-fire:before {\n  content: \"\\f06d\"; }\n\n.fa-fire-alt:before {\n  content: \"\\f7e4\"; }\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\"; }\n\n.fa-firefox:before {\n  content: \"\\f269\"; }\n\n.fa-firefox-browser:before {\n  content: \"\\f907\"; }\n\n.fa-first-aid:before {\n  content: \"\\f479\"; }\n\n.fa-first-order:before {\n  content: \"\\f2b0\"; }\n\n.fa-first-order-alt:before {\n  content: \"\\f50a\"; }\n\n.fa-firstdraft:before {\n  content: \"\\f3a1\"; }\n\n.fa-fish:before {\n  content: \"\\f578\"; }\n\n.fa-fist-raised:before {\n  content: \"\\f6de\"; }\n\n.fa-flag:before {\n  content: \"\\f024\"; }\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\"; }\n\n.fa-flag-usa:before {\n  content: \"\\f74d\"; }\n\n.fa-flask:before {\n  content: \"\\f0c3\"; }\n\n.fa-flickr:before {\n  content: \"\\f16e\"; }\n\n.fa-flipboard:before {\n  content: \"\\f44d\"; }\n\n.fa-flushed:before {\n  content: \"\\f579\"; }\n\n.fa-fly:before {\n  content: \"\\f417\"; }\n\n.fa-folder:before {\n  content: \"\\f07b\"; }\n\n.fa-folder-minus:before {\n  content: \"\\f65d\"; }\n\n.fa-folder-open:before {\n  content: \"\\f07c\"; }\n\n.fa-folder-plus:before {\n  content: \"\\f65e\"; }\n\n.fa-font:before {\n  content: \"\\f031\"; }\n\n.fa-font-awesome:before {\n  content: \"\\f2b4\"; }\n\n.fa-font-awesome-alt:before {\n  content: \"\\f35c\"; }\n\n.fa-font-awesome-flag:before {\n  content: \"\\f425\"; }\n\n.fa-font-awesome-logo-full:before {\n  content: \"\\f4e6\"; }\n\n.fa-fonticons:before {\n  content: \"\\f280\"; }\n\n.fa-fonticons-fi:before {\n  content: \"\\f3a2\"; }\n\n.fa-football-ball:before {\n  content: \"\\f44e\"; }\n\n.fa-fort-awesome:before {\n  content: \"\\f286\"; }\n\n.fa-fort-awesome-alt:before {\n  content: \"\\f3a3\"; }\n\n.fa-forumbee:before {\n  content: \"\\f211\"; }\n\n.fa-forward:before {\n  content: \"\\f04e\"; }\n\n.fa-foursquare:before {\n  content: \"\\f180\"; }\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\"; }\n\n.fa-freebsd:before {\n  content: \"\\f3a4\"; }\n\n.fa-frog:before {\n  content: \"\\f52e\"; }\n\n.fa-frown:before {\n  content: \"\\f119\"; }\n\n.fa-frown-open:before {\n  content: \"\\f57a\"; }\n\n.fa-fulcrum:before {\n  content: \"\\f50b\"; }\n\n.fa-funnel-dollar:before {\n  content: \"\\f662\"; }\n\n.fa-futbol:before {\n  content: \"\\f1e3\"; }\n\n.fa-galactic-republic:before {\n  content: \"\\f50c\"; }\n\n.fa-galactic-senate:before {\n  content: \"\\f50d\"; }\n\n.fa-gamepad:before {\n  content: \"\\f11b\"; }\n\n.fa-gas-pump:before {\n  content: \"\\f52f\"; }\n\n.fa-gavel:before {\n  content: \"\\f0e3\"; }\n\n.fa-gem:before {\n  content: \"\\f3a5\"; }\n\n.fa-genderless:before {\n  content: \"\\f22d\"; }\n\n.fa-get-pocket:before {\n  content: \"\\f265\"; }\n\n.fa-gg:before {\n  content: \"\\f260\"; }\n\n.fa-gg-circle:before {\n  content: \"\\f261\"; }\n\n.fa-ghost:before {\n  content: \"\\f6e2\"; }\n\n.fa-gift:before {\n  content: \"\\f06b\"; }\n\n.fa-gifts:before {\n  content: \"\\f79c\"; }\n\n.fa-git:before {\n  content: \"\\f1d3\"; }\n\n.fa-git-alt:before {\n  content: \"\\f841\"; }\n\n.fa-git-square:before {\n  content: \"\\f1d2\"; }\n\n.fa-github:before {\n  content: \"\\f09b\"; }\n\n.fa-github-alt:before {\n  content: \"\\f113\"; }\n\n.fa-github-square:before {\n  content: \"\\f092\"; }\n\n.fa-gitkraken:before {\n  content: \"\\f3a6\"; }\n\n.fa-gitlab:before {\n  content: \"\\f296\"; }\n\n.fa-gitter:before {\n  content: \"\\f426\"; }\n\n.fa-glass-cheers:before {\n  content: \"\\f79f\"; }\n\n.fa-glass-martini:before {\n  content: \"\\f000\"; }\n\n.fa-glass-martini-alt:before {\n  content: \"\\f57b\"; }\n\n.fa-glass-whiskey:before {\n  content: \"\\f7a0\"; }\n\n.fa-glasses:before {\n  content: \"\\f530\"; }\n\n.fa-glide:before {\n  content: \"\\f2a5\"; }\n\n.fa-glide-g:before {\n  content: \"\\f2a6\"; }\n\n.fa-globe:before {\n  content: \"\\f0ac\"; }\n\n.fa-globe-africa:before {\n  content: \"\\f57c\"; }\n\n.fa-globe-americas:before {\n  content: \"\\f57d\"; }\n\n.fa-globe-asia:before {\n  content: \"\\f57e\"; }\n\n.fa-globe-europe:before {\n  content: \"\\f7a2\"; }\n\n.fa-gofore:before {\n  content: \"\\f3a7\"; }\n\n.fa-golf-ball:before {\n  content: \"\\f450\"; }\n\n.fa-goodreads:before {\n  content: \"\\f3a8\"; }\n\n.fa-goodreads-g:before {\n  content: \"\\f3a9\"; }\n\n.fa-google:before {\n  content: \"\\f1a0\"; }\n\n.fa-google-drive:before {\n  content: \"\\f3aa\"; }\n\n.fa-google-play:before {\n  content: \"\\f3ab\"; }\n\n.fa-google-plus:before {\n  content: \"\\f2b3\"; }\n\n.fa-google-plus-g:before {\n  content: \"\\f0d5\"; }\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\"; }\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\"; }\n\n.fa-gopuram:before {\n  content: \"\\f664\"; }\n\n.fa-graduation-cap:before {\n  content: \"\\f19d\"; }\n\n.fa-gratipay:before {\n  content: \"\\f184\"; }\n\n.fa-grav:before {\n  content: \"\\f2d6\"; }\n\n.fa-greater-than:before {\n  content: \"\\f531\"; }\n\n.fa-greater-than-equal:before {\n  content: \"\\f532\"; }\n\n.fa-grimace:before {\n  content: \"\\f57f\"; }\n\n.fa-grin:before {\n  content: \"\\f580\"; }\n\n.fa-grin-alt:before {\n  content: \"\\f581\"; }\n\n.fa-grin-beam:before {\n  content: \"\\f582\"; }\n\n.fa-grin-beam-sweat:before {\n  content: \"\\f583\"; }\n\n.fa-grin-hearts:before {\n  content: \"\\f584\"; }\n\n.fa-grin-squint:before {\n  content: \"\\f585\"; }\n\n.fa-grin-squint-tears:before {\n  content: \"\\f586\"; }\n\n.fa-grin-stars:before {\n  content: \"\\f587\"; }\n\n.fa-grin-tears:before {\n  content: \"\\f588\"; }\n\n.fa-grin-tongue:before {\n  content: \"\\f589\"; }\n\n.fa-grin-tongue-squint:before {\n  content: \"\\f58a\"; }\n\n.fa-grin-tongue-wink:before {\n  content: \"\\f58b\"; }\n\n.fa-grin-wink:before {\n  content: \"\\f58c\"; }\n\n.fa-grip-horizontal:before {\n  content: \"\\f58d\"; }\n\n.fa-grip-lines:before {\n  content: \"\\f7a4\"; }\n\n.fa-grip-lines-vertical:before {\n  content: \"\\f7a5\"; }\n\n.fa-grip-vertical:before {\n  content: \"\\f58e\"; }\n\n.fa-gripfire:before {\n  content: \"\\f3ac\"; }\n\n.fa-grunt:before {\n  content: \"\\f3ad\"; }\n\n.fa-guitar:before {\n  content: \"\\f7a6\"; }\n\n.fa-gulp:before {\n  content: \"\\f3ae\"; }\n\n.fa-h-square:before {\n  content: \"\\f0fd\"; }\n\n.fa-hacker-news:before {\n  content: \"\\f1d4\"; }\n\n.fa-hacker-news-square:before {\n  content: \"\\f3af\"; }\n\n.fa-hackerrank:before {\n  content: \"\\f5f7\"; }\n\n.fa-hamburger:before {\n  content: \"\\f805\"; }\n\n.fa-hammer:before {\n  content: \"\\f6e3\"; }\n\n.fa-hamsa:before {\n  content: \"\\f665\"; }\n\n.fa-hand-holding:before {\n  content: \"\\f4bd\"; }\n\n.fa-hand-holding-heart:before {\n  content: \"\\f4be\"; }\n\n.fa-hand-holding-medical:before {\n  content: \"\\f95c\"; }\n\n.fa-hand-holding-usd:before {\n  content: \"\\f4c0\"; }\n\n.fa-hand-holding-water:before {\n  content: \"\\f4c1\"; }\n\n.fa-hand-lizard:before {\n  content: \"\\f258\"; }\n\n.fa-hand-middle-finger:before {\n  content: \"\\f806\"; }\n\n.fa-hand-paper:before {\n  content: \"\\f256\"; }\n\n.fa-hand-peace:before {\n  content: \"\\f25b\"; }\n\n.fa-hand-point-down:before {\n  content: \"\\f0a7\"; }\n\n.fa-hand-point-left:before {\n  content: \"\\f0a5\"; }\n\n.fa-hand-point-right:before {\n  content: \"\\f0a4\"; }\n\n.fa-hand-point-up:before {\n  content: \"\\f0a6\"; }\n\n.fa-hand-pointer:before {\n  content: \"\\f25a\"; }\n\n.fa-hand-rock:before {\n  content: \"\\f255\"; }\n\n.fa-hand-scissors:before {\n  content: \"\\f257\"; }\n\n.fa-hand-sparkles:before {\n  content: \"\\f95d\"; }\n\n.fa-hand-spock:before {\n  content: \"\\f259\"; }\n\n.fa-hands:before {\n  content: \"\\f4c2\"; }\n\n.fa-hands-helping:before {\n  content: \"\\f4c4\"; }\n\n.fa-hands-wash:before {\n  content: \"\\f95e\"; }\n\n.fa-handshake:before {\n  content: \"\\f2b5\"; }\n\n.fa-handshake-alt-slash:before {\n  content: \"\\f95f\"; }\n\n.fa-handshake-slash:before {\n  content: \"\\f960\"; }\n\n.fa-hanukiah:before {\n  content: \"\\f6e6\"; }\n\n.fa-hard-hat:before {\n  content: \"\\f807\"; }\n\n.fa-hashtag:before {\n  content: \"\\f292\"; }\n\n.fa-hat-cowboy:before {\n  content: \"\\f8c0\"; }\n\n.fa-hat-cowboy-side:before {\n  content: \"\\f8c1\"; }\n\n.fa-hat-wizard:before {\n  content: \"\\f6e8\"; }\n\n.fa-hdd:before {\n  content: \"\\f0a0\"; }\n\n.fa-head-side-cough:before {\n  content: \"\\f961\"; }\n\n.fa-head-side-cough-slash:before {\n  content: \"\\f962\"; }\n\n.fa-head-side-mask:before {\n  content: \"\\f963\"; }\n\n.fa-head-side-virus:before {\n  content: \"\\f964\"; }\n\n.fa-heading:before {\n  content: \"\\f1dc\"; }\n\n.fa-headphones:before {\n  content: \"\\f025\"; }\n\n.fa-headphones-alt:before {\n  content: \"\\f58f\"; }\n\n.fa-headset:before {\n  content: \"\\f590\"; }\n\n.fa-heart:before {\n  content: \"\\f004\"; }\n\n.fa-heart-broken:before {\n  content: \"\\f7a9\"; }\n\n.fa-heartbeat:before {\n  content: \"\\f21e\"; }\n\n.fa-helicopter:before {\n  content: \"\\f533\"; }\n\n.fa-highlighter:before {\n  content: \"\\f591\"; }\n\n.fa-hiking:before {\n  content: \"\\f6ec\"; }\n\n.fa-hippo:before {\n  content: \"\\f6ed\"; }\n\n.fa-hips:before {\n  content: \"\\f452\"; }\n\n.fa-hire-a-helper:before {\n  content: \"\\f3b0\"; }\n\n.fa-history:before {\n  content: \"\\f1da\"; }\n\n.fa-hockey-puck:before {\n  content: \"\\f453\"; }\n\n.fa-holly-berry:before {\n  content: \"\\f7aa\"; }\n\n.fa-home:before {\n  content: \"\\f015\"; }\n\n.fa-hooli:before {\n  content: \"\\f427\"; }\n\n.fa-hornbill:before {\n  content: \"\\f592\"; }\n\n.fa-horse:before {\n  content: \"\\f6f0\"; }\n\n.fa-horse-head:before {\n  content: \"\\f7ab\"; }\n\n.fa-hospital:before {\n  content: \"\\f0f8\"; }\n\n.fa-hospital-alt:before {\n  content: \"\\f47d\"; }\n\n.fa-hospital-symbol:before {\n  content: \"\\f47e\"; }\n\n.fa-hospital-user:before {\n  content: \"\\f80d\"; }\n\n.fa-hot-tub:before {\n  content: \"\\f593\"; }\n\n.fa-hotdog:before {\n  content: \"\\f80f\"; }\n\n.fa-hotel:before {\n  content: \"\\f594\"; }\n\n.fa-hotjar:before {\n  content: \"\\f3b1\"; }\n\n.fa-hourglass:before {\n  content: \"\\f254\"; }\n\n.fa-hourglass-end:before {\n  content: \"\\f253\"; }\n\n.fa-hourglass-half:before {\n  content: \"\\f252\"; }\n\n.fa-hourglass-start:before {\n  content: \"\\f251\"; }\n\n.fa-house-damage:before {\n  content: \"\\f6f1\"; }\n\n.fa-house-user:before {\n  content: \"\\f965\"; }\n\n.fa-houzz:before {\n  content: \"\\f27c\"; }\n\n.fa-hryvnia:before {\n  content: \"\\f6f2\"; }\n\n.fa-html5:before {\n  content: \"\\f13b\"; }\n\n.fa-hubspot:before {\n  content: \"\\f3b2\"; }\n\n.fa-i-cursor:before {\n  content: \"\\f246\"; }\n\n.fa-ice-cream:before {\n  content: \"\\f810\"; }\n\n.fa-icicles:before {\n  content: \"\\f7ad\"; }\n\n.fa-icons:before {\n  content: \"\\f86d\"; }\n\n.fa-id-badge:before {\n  content: \"\\f2c1\"; }\n\n.fa-id-card:before {\n  content: \"\\f2c2\"; }\n\n.fa-id-card-alt:before {\n  content: \"\\f47f\"; }\n\n.fa-ideal:before {\n  content: \"\\f913\"; }\n\n.fa-igloo:before {\n  content: \"\\f7ae\"; }\n\n.fa-image:before {\n  content: \"\\f03e\"; }\n\n.fa-images:before {\n  content: \"\\f302\"; }\n\n.fa-imdb:before {\n  content: \"\\f2d8\"; }\n\n.fa-inbox:before {\n  content: \"\\f01c\"; }\n\n.fa-indent:before {\n  content: \"\\f03c\"; }\n\n.fa-industry:before {\n  content: \"\\f275\"; }\n\n.fa-infinity:before {\n  content: \"\\f534\"; }\n\n.fa-info:before {\n  content: \"\\f129\"; }\n\n.fa-info-circle:before {\n  content: \"\\f05a\"; }\n\n.fa-instagram:before {\n  content: \"\\f16d\"; }\n\n.fa-instagram-square:before {\n  content: \"\\f955\"; }\n\n.fa-intercom:before {\n  content: \"\\f7af\"; }\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\"; }\n\n.fa-invision:before {\n  content: \"\\f7b0\"; }\n\n.fa-ioxhost:before {\n  content: \"\\f208\"; }\n\n.fa-italic:before {\n  content: \"\\f033\"; }\n\n.fa-itch-io:before {\n  content: \"\\f83a\"; }\n\n.fa-itunes:before {\n  content: \"\\f3b4\"; }\n\n.fa-itunes-note:before {\n  content: \"\\f3b5\"; }\n\n.fa-java:before {\n  content: \"\\f4e4\"; }\n\n.fa-jedi:before {\n  content: \"\\f669\"; }\n\n.fa-jedi-order:before {\n  content: \"\\f50e\"; }\n\n.fa-jenkins:before {\n  content: \"\\f3b6\"; }\n\n.fa-jira:before {\n  content: \"\\f7b1\"; }\n\n.fa-joget:before {\n  content: \"\\f3b7\"; }\n\n.fa-joint:before {\n  content: \"\\f595\"; }\n\n.fa-joomla:before {\n  content: \"\\f1aa\"; }\n\n.fa-journal-whills:before {\n  content: \"\\f66a\"; }\n\n.fa-js:before {\n  content: \"\\f3b8\"; }\n\n.fa-js-square:before {\n  content: \"\\f3b9\"; }\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\"; }\n\n.fa-kaaba:before {\n  content: \"\\f66b\"; }\n\n.fa-kaggle:before {\n  content: \"\\f5fa\"; }\n\n.fa-key:before {\n  content: \"\\f084\"; }\n\n.fa-keybase:before {\n  content: \"\\f4f5\"; }\n\n.fa-keyboard:before {\n  content: \"\\f11c\"; }\n\n.fa-keycdn:before {\n  content: \"\\f3ba\"; }\n\n.fa-khanda:before {\n  content: \"\\f66d\"; }\n\n.fa-kickstarter:before {\n  content: \"\\f3bb\"; }\n\n.fa-kickstarter-k:before {\n  content: \"\\f3bc\"; }\n\n.fa-kiss:before {\n  content: \"\\f596\"; }\n\n.fa-kiss-beam:before {\n  content: \"\\f597\"; }\n\n.fa-kiss-wink-heart:before {\n  content: \"\\f598\"; }\n\n.fa-kiwi-bird:before {\n  content: \"\\f535\"; }\n\n.fa-korvue:before {\n  content: \"\\f42f\"; }\n\n.fa-landmark:before {\n  content: \"\\f66f\"; }\n\n.fa-language:before {\n  content: \"\\f1ab\"; }\n\n.fa-laptop:before {\n  content: \"\\f109\"; }\n\n.fa-laptop-code:before {\n  content: \"\\f5fc\"; }\n\n.fa-laptop-house:before {\n  content: \"\\f966\"; }\n\n.fa-laptop-medical:before {\n  content: \"\\f812\"; }\n\n.fa-laravel:before {\n  content: \"\\f3bd\"; }\n\n.fa-lastfm:before {\n  content: \"\\f202\"; }\n\n.fa-lastfm-square:before {\n  content: \"\\f203\"; }\n\n.fa-laugh:before {\n  content: \"\\f599\"; }\n\n.fa-laugh-beam:before {\n  content: \"\\f59a\"; }\n\n.fa-laugh-squint:before {\n  content: \"\\f59b\"; }\n\n.fa-laugh-wink:before {\n  content: \"\\f59c\"; }\n\n.fa-layer-group:before {\n  content: \"\\f5fd\"; }\n\n.fa-leaf:before {\n  content: \"\\f06c\"; }\n\n.fa-leanpub:before {\n  content: \"\\f212\"; }\n\n.fa-lemon:before {\n  content: \"\\f094\"; }\n\n.fa-less:before {\n  content: \"\\f41d\"; }\n\n.fa-less-than:before {\n  content: \"\\f536\"; }\n\n.fa-less-than-equal:before {\n  content: \"\\f537\"; }\n\n.fa-level-down-alt:before {\n  content: \"\\f3be\"; }\n\n.fa-level-up-alt:before {\n  content: \"\\f3bf\"; }\n\n.fa-life-ring:before {\n  content: \"\\f1cd\"; }\n\n.fa-lightbulb:before {\n  content: \"\\f0eb\"; }\n\n.fa-line:before {\n  content: \"\\f3c0\"; }\n\n.fa-link:before {\n  content: \"\\f0c1\"; }\n\n.fa-linkedin:before {\n  content: \"\\f08c\"; }\n\n.fa-linkedin-in:before {\n  content: \"\\f0e1\"; }\n\n.fa-linode:before {\n  content: \"\\f2b8\"; }\n\n.fa-linux:before {\n  content: \"\\f17c\"; }\n\n.fa-lira-sign:before {\n  content: \"\\f195\"; }\n\n.fa-list:before {\n  content: \"\\f03a\"; }\n\n.fa-list-alt:before {\n  content: \"\\f022\"; }\n\n.fa-list-ol:before {\n  content: \"\\f0cb\"; }\n\n.fa-list-ul:before {\n  content: \"\\f0ca\"; }\n\n.fa-location-arrow:before {\n  content: \"\\f124\"; }\n\n.fa-lock:before {\n  content: \"\\f023\"; }\n\n.fa-lock-open:before {\n  content: \"\\f3c1\"; }\n\n.fa-long-arrow-alt-down:before {\n  content: \"\\f309\"; }\n\n.fa-long-arrow-alt-left:before {\n  content: \"\\f30a\"; }\n\n.fa-long-arrow-alt-right:before {\n  content: \"\\f30b\"; }\n\n.fa-long-arrow-alt-up:before {\n  content: \"\\f30c\"; }\n\n.fa-low-vision:before {\n  content: \"\\f2a8\"; }\n\n.fa-luggage-cart:before {\n  content: \"\\f59d\"; }\n\n.fa-lungs:before {\n  content: \"\\f604\"; }\n\n.fa-lungs-virus:before {\n  content: \"\\f967\"; }\n\n.fa-lyft:before {\n  content: \"\\f3c3\"; }\n\n.fa-magento:before {\n  content: \"\\f3c4\"; }\n\n.fa-magic:before {\n  content: \"\\f0d0\"; }\n\n.fa-magnet:before {\n  content: \"\\f076\"; }\n\n.fa-mail-bulk:before {\n  content: \"\\f674\"; }\n\n.fa-mailchimp:before {\n  content: \"\\f59e\"; }\n\n.fa-male:before {\n  content: \"\\f183\"; }\n\n.fa-mandalorian:before {\n  content: \"\\f50f\"; }\n\n.fa-map:before {\n  content: \"\\f279\"; }\n\n.fa-map-marked:before {\n  content: \"\\f59f\"; }\n\n.fa-map-marked-alt:before {\n  content: \"\\f5a0\"; }\n\n.fa-map-marker:before {\n  content: \"\\f041\"; }\n\n.fa-map-marker-alt:before {\n  content: \"\\f3c5\"; }\n\n.fa-map-pin:before {\n  content: \"\\f276\"; }\n\n.fa-map-signs:before {\n  content: \"\\f277\"; }\n\n.fa-markdown:before {\n  content: \"\\f60f\"; }\n\n.fa-marker:before {\n  content: \"\\f5a1\"; }\n\n.fa-mars:before {\n  content: \"\\f222\"; }\n\n.fa-mars-double:before {\n  content: \"\\f227\"; }\n\n.fa-mars-stroke:before {\n  content: \"\\f229\"; }\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\"; }\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\"; }\n\n.fa-mask:before {\n  content: \"\\f6fa\"; }\n\n.fa-mastodon:before {\n  content: \"\\f4f6\"; }\n\n.fa-maxcdn:before {\n  content: \"\\f136\"; }\n\n.fa-mdb:before {\n  content: \"\\f8ca\"; }\n\n.fa-medal:before {\n  content: \"\\f5a2\"; }\n\n.fa-medapps:before {\n  content: \"\\f3c6\"; }\n\n.fa-medium:before {\n  content: \"\\f23a\"; }\n\n.fa-medium-m:before {\n  content: \"\\f3c7\"; }\n\n.fa-medkit:before {\n  content: \"\\f0fa\"; }\n\n.fa-medrt:before {\n  content: \"\\f3c8\"; }\n\n.fa-meetup:before {\n  content: \"\\f2e0\"; }\n\n.fa-megaport:before {\n  content: \"\\f5a3\"; }\n\n.fa-meh:before {\n  content: \"\\f11a\"; }\n\n.fa-meh-blank:before {\n  content: \"\\f5a4\"; }\n\n.fa-meh-rolling-eyes:before {\n  content: \"\\f5a5\"; }\n\n.fa-memory:before {\n  content: \"\\f538\"; }\n\n.fa-mendeley:before {\n  content: \"\\f7b3\"; }\n\n.fa-menorah:before {\n  content: \"\\f676\"; }\n\n.fa-mercury:before {\n  content: \"\\f223\"; }\n\n.fa-meteor:before {\n  content: \"\\f753\"; }\n\n.fa-microblog:before {\n  content: \"\\f91a\"; }\n\n.fa-microchip:before {\n  content: \"\\f2db\"; }\n\n.fa-microphone:before {\n  content: \"\\f130\"; }\n\n.fa-microphone-alt:before {\n  content: \"\\f3c9\"; }\n\n.fa-microphone-alt-slash:before {\n  content: \"\\f539\"; }\n\n.fa-microphone-slash:before {\n  content: \"\\f131\"; }\n\n.fa-microscope:before {\n  content: \"\\f610\"; }\n\n.fa-microsoft:before {\n  content: \"\\f3ca\"; }\n\n.fa-minus:before {\n  content: \"\\f068\"; }\n\n.fa-minus-circle:before {\n  content: \"\\f056\"; }\n\n.fa-minus-square:before {\n  content: \"\\f146\"; }\n\n.fa-mitten:before {\n  content: \"\\f7b5\"; }\n\n.fa-mix:before {\n  content: \"\\f3cb\"; }\n\n.fa-mixcloud:before {\n  content: \"\\f289\"; }\n\n.fa-mixer:before {\n  content: \"\\f956\"; }\n\n.fa-mizuni:before {\n  content: \"\\f3cc\"; }\n\n.fa-mobile:before {\n  content: \"\\f10b\"; }\n\n.fa-mobile-alt:before {\n  content: \"\\f3cd\"; }\n\n.fa-modx:before {\n  content: \"\\f285\"; }\n\n.fa-monero:before {\n  content: \"\\f3d0\"; }\n\n.fa-money-bill:before {\n  content: \"\\f0d6\"; }\n\n.fa-money-bill-alt:before {\n  content: \"\\f3d1\"; }\n\n.fa-money-bill-wave:before {\n  content: \"\\f53a\"; }\n\n.fa-money-bill-wave-alt:before {\n  content: \"\\f53b\"; }\n\n.fa-money-check:before {\n  content: \"\\f53c\"; }\n\n.fa-money-check-alt:before {\n  content: \"\\f53d\"; }\n\n.fa-monument:before {\n  content: \"\\f5a6\"; }\n\n.fa-moon:before {\n  content: \"\\f186\"; }\n\n.fa-mortar-pestle:before {\n  content: \"\\f5a7\"; }\n\n.fa-mosque:before {\n  content: \"\\f678\"; }\n\n.fa-motorcycle:before {\n  content: \"\\f21c\"; }\n\n.fa-mountain:before {\n  content: \"\\f6fc\"; }\n\n.fa-mouse:before {\n  content: \"\\f8cc\"; }\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\"; }\n\n.fa-mug-hot:before {\n  content: \"\\f7b6\"; }\n\n.fa-music:before {\n  content: \"\\f001\"; }\n\n.fa-napster:before {\n  content: \"\\f3d2\"; }\n\n.fa-neos:before {\n  content: \"\\f612\"; }\n\n.fa-network-wired:before {\n  content: \"\\f6ff\"; }\n\n.fa-neuter:before {\n  content: \"\\f22c\"; }\n\n.fa-newspaper:before {\n  content: \"\\f1ea\"; }\n\n.fa-nimblr:before {\n  content: \"\\f5a8\"; }\n\n.fa-node:before {\n  content: \"\\f419\"; }\n\n.fa-node-js:before {\n  content: \"\\f3d3\"; }\n\n.fa-not-equal:before {\n  content: \"\\f53e\"; }\n\n.fa-notes-medical:before {\n  content: \"\\f481\"; }\n\n.fa-npm:before {\n  content: \"\\f3d4\"; }\n\n.fa-ns8:before {\n  content: \"\\f3d5\"; }\n\n.fa-nutritionix:before {\n  content: \"\\f3d6\"; }\n\n.fa-object-group:before {\n  content: \"\\f247\"; }\n\n.fa-object-ungroup:before {\n  content: \"\\f248\"; }\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\"; }\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\"; }\n\n.fa-oil-can:before {\n  content: \"\\f613\"; }\n\n.fa-old-republic:before {\n  content: \"\\f510\"; }\n\n.fa-om:before {\n  content: \"\\f679\"; }\n\n.fa-opencart:before {\n  content: \"\\f23d\"; }\n\n.fa-openid:before {\n  content: \"\\f19b\"; }\n\n.fa-opera:before {\n  content: \"\\f26a\"; }\n\n.fa-optin-monster:before {\n  content: \"\\f23c\"; }\n\n.fa-orcid:before {\n  content: \"\\f8d2\"; }\n\n.fa-osi:before {\n  content: \"\\f41a\"; }\n\n.fa-otter:before {\n  content: \"\\f700\"; }\n\n.fa-outdent:before {\n  content: \"\\f03b\"; }\n\n.fa-page4:before {\n  content: \"\\f3d7\"; }\n\n.fa-pagelines:before {\n  content: \"\\f18c\"; }\n\n.fa-pager:before {\n  content: \"\\f815\"; }\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\"; }\n\n.fa-paint-roller:before {\n  content: \"\\f5aa\"; }\n\n.fa-palette:before {\n  content: \"\\f53f\"; }\n\n.fa-palfed:before {\n  content: \"\\f3d8\"; }\n\n.fa-pallet:before {\n  content: \"\\f482\"; }\n\n.fa-paper-plane:before {\n  content: \"\\f1d8\"; }\n\n.fa-paperclip:before {\n  content: \"\\f0c6\"; }\n\n.fa-parachute-box:before {\n  content: \"\\f4cd\"; }\n\n.fa-paragraph:before {\n  content: \"\\f1dd\"; }\n\n.fa-parking:before {\n  content: \"\\f540\"; }\n\n.fa-passport:before {\n  content: \"\\f5ab\"; }\n\n.fa-pastafarianism:before {\n  content: \"\\f67b\"; }\n\n.fa-paste:before {\n  content: \"\\f0ea\"; }\n\n.fa-patreon:before {\n  content: \"\\f3d9\"; }\n\n.fa-pause:before {\n  content: \"\\f04c\"; }\n\n.fa-pause-circle:before {\n  content: \"\\f28b\"; }\n\n.fa-paw:before {\n  content: \"\\f1b0\"; }\n\n.fa-paypal:before {\n  content: \"\\f1ed\"; }\n\n.fa-peace:before {\n  content: \"\\f67c\"; }\n\n.fa-pen:before {\n  content: \"\\f304\"; }\n\n.fa-pen-alt:before {\n  content: \"\\f305\"; }\n\n.fa-pen-fancy:before {\n  content: \"\\f5ac\"; }\n\n.fa-pen-nib:before {\n  content: \"\\f5ad\"; }\n\n.fa-pen-square:before {\n  content: \"\\f14b\"; }\n\n.fa-pencil-alt:before {\n  content: \"\\f303\"; }\n\n.fa-pencil-ruler:before {\n  content: \"\\f5ae\"; }\n\n.fa-penny-arcade:before {\n  content: \"\\f704\"; }\n\n.fa-people-arrows:before {\n  content: \"\\f968\"; }\n\n.fa-people-carry:before {\n  content: \"\\f4ce\"; }\n\n.fa-pepper-hot:before {\n  content: \"\\f816\"; }\n\n.fa-percent:before {\n  content: \"\\f295\"; }\n\n.fa-percentage:before {\n  content: \"\\f541\"; }\n\n.fa-periscope:before {\n  content: \"\\f3da\"; }\n\n.fa-person-booth:before {\n  content: \"\\f756\"; }\n\n.fa-phabricator:before {\n  content: \"\\f3db\"; }\n\n.fa-phoenix-framework:before {\n  content: \"\\f3dc\"; }\n\n.fa-phoenix-squadron:before {\n  content: \"\\f511\"; }\n\n.fa-phone:before {\n  content: \"\\f095\"; }\n\n.fa-phone-alt:before {\n  content: \"\\f879\"; }\n\n.fa-phone-slash:before {\n  content: \"\\f3dd\"; }\n\n.fa-phone-square:before {\n  content: \"\\f098\"; }\n\n.fa-phone-square-alt:before {\n  content: \"\\f87b\"; }\n\n.fa-phone-volume:before {\n  content: \"\\f2a0\"; }\n\n.fa-photo-video:before {\n  content: \"\\f87c\"; }\n\n.fa-php:before {\n  content: \"\\f457\"; }\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\"; }\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\"; }\n\n.fa-pied-piper-hat:before {\n  content: \"\\f4e5\"; }\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\"; }\n\n.fa-pied-piper-square:before {\n  content: \"\\f91e\"; }\n\n.fa-piggy-bank:before {\n  content: \"\\f4d3\"; }\n\n.fa-pills:before {\n  content: \"\\f484\"; }\n\n.fa-pinterest:before {\n  content: \"\\f0d2\"; }\n\n.fa-pinterest-p:before {\n  content: \"\\f231\"; }\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\"; }\n\n.fa-pizza-slice:before {\n  content: \"\\f818\"; }\n\n.fa-place-of-worship:before {\n  content: \"\\f67f\"; }\n\n.fa-plane:before {\n  content: \"\\f072\"; }\n\n.fa-plane-arrival:before {\n  content: \"\\f5af\"; }\n\n.fa-plane-departure:before {\n  content: \"\\f5b0\"; }\n\n.fa-plane-slash:before {\n  content: \"\\f969\"; }\n\n.fa-play:before {\n  content: \"\\f04b\"; }\n\n.fa-play-circle:before {\n  content: \"\\f144\"; }\n\n.fa-playstation:before {\n  content: \"\\f3df\"; }\n\n.fa-plug:before {\n  content: \"\\f1e6\"; }\n\n.fa-plus:before {\n  content: \"\\f067\"; }\n\n.fa-plus-circle:before {\n  content: \"\\f055\"; }\n\n.fa-plus-square:before {\n  content: \"\\f0fe\"; }\n\n.fa-podcast:before {\n  content: \"\\f2ce\"; }\n\n.fa-poll:before {\n  content: \"\\f681\"; }\n\n.fa-poll-h:before {\n  content: \"\\f682\"; }\n\n.fa-poo:before {\n  content: \"\\f2fe\"; }\n\n.fa-poo-storm:before {\n  content: \"\\f75a\"; }\n\n.fa-poop:before {\n  content: \"\\f619\"; }\n\n.fa-portrait:before {\n  content: \"\\f3e0\"; }\n\n.fa-pound-sign:before {\n  content: \"\\f154\"; }\n\n.fa-power-off:before {\n  content: \"\\f011\"; }\n\n.fa-pray:before {\n  content: \"\\f683\"; }\n\n.fa-praying-hands:before {\n  content: \"\\f684\"; }\n\n.fa-prescription:before {\n  content: \"\\f5b1\"; }\n\n.fa-prescription-bottle:before {\n  content: \"\\f485\"; }\n\n.fa-prescription-bottle-alt:before {\n  content: \"\\f486\"; }\n\n.fa-print:before {\n  content: \"\\f02f\"; }\n\n.fa-procedures:before {\n  content: \"\\f487\"; }\n\n.fa-product-hunt:before {\n  content: \"\\f288\"; }\n\n.fa-project-diagram:before {\n  content: \"\\f542\"; }\n\n.fa-pump-medical:before {\n  content: \"\\f96a\"; }\n\n.fa-pump-soap:before {\n  content: \"\\f96b\"; }\n\n.fa-pushed:before {\n  content: \"\\f3e1\"; }\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\"; }\n\n.fa-python:before {\n  content: \"\\f3e2\"; }\n\n.fa-qq:before {\n  content: \"\\f1d6\"; }\n\n.fa-qrcode:before {\n  content: \"\\f029\"; }\n\n.fa-question:before {\n  content: \"\\f128\"; }\n\n.fa-question-circle:before {\n  content: \"\\f059\"; }\n\n.fa-quidditch:before {\n  content: \"\\f458\"; }\n\n.fa-quinscape:before {\n  content: \"\\f459\"; }\n\n.fa-quora:before {\n  content: \"\\f2c4\"; }\n\n.fa-quote-left:before {\n  content: \"\\f10d\"; }\n\n.fa-quote-right:before {\n  content: \"\\f10e\"; }\n\n.fa-quran:before {\n  content: \"\\f687\"; }\n\n.fa-r-project:before {\n  content: \"\\f4f7\"; }\n\n.fa-radiation:before {\n  content: \"\\f7b9\"; }\n\n.fa-radiation-alt:before {\n  content: \"\\f7ba\"; }\n\n.fa-rainbow:before {\n  content: \"\\f75b\"; }\n\n.fa-random:before {\n  content: \"\\f074\"; }\n\n.fa-raspberry-pi:before {\n  content: \"\\f7bb\"; }\n\n.fa-ravelry:before {\n  content: \"\\f2d9\"; }\n\n.fa-react:before {\n  content: \"\\f41b\"; }\n\n.fa-reacteurope:before {\n  content: \"\\f75d\"; }\n\n.fa-readme:before {\n  content: \"\\f4d5\"; }\n\n.fa-rebel:before {\n  content: \"\\f1d0\"; }\n\n.fa-receipt:before {\n  content: \"\\f543\"; }\n\n.fa-record-vinyl:before {\n  content: \"\\f8d9\"; }\n\n.fa-recycle:before {\n  content: \"\\f1b8\"; }\n\n.fa-red-river:before {\n  content: \"\\f3e3\"; }\n\n.fa-reddit:before {\n  content: \"\\f1a1\"; }\n\n.fa-reddit-alien:before {\n  content: \"\\f281\"; }\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\"; }\n\n.fa-redhat:before {\n  content: \"\\f7bc\"; }\n\n.fa-redo:before {\n  content: \"\\f01e\"; }\n\n.fa-redo-alt:before {\n  content: \"\\f2f9\"; }\n\n.fa-registered:before {\n  content: \"\\f25d\"; }\n\n.fa-remove-format:before {\n  content: \"\\f87d\"; }\n\n.fa-renren:before {\n  content: \"\\f18b\"; }\n\n.fa-reply:before {\n  content: \"\\f3e5\"; }\n\n.fa-reply-all:before {\n  content: \"\\f122\"; }\n\n.fa-replyd:before {\n  content: \"\\f3e6\"; }\n\n.fa-republican:before {\n  content: \"\\f75e\"; }\n\n.fa-researchgate:before {\n  content: \"\\f4f8\"; }\n\n.fa-resolving:before {\n  content: \"\\f3e7\"; }\n\n.fa-restroom:before {\n  content: \"\\f7bd\"; }\n\n.fa-retweet:before {\n  content: \"\\f079\"; }\n\n.fa-rev:before {\n  content: \"\\f5b2\"; }\n\n.fa-ribbon:before {\n  content: \"\\f4d6\"; }\n\n.fa-ring:before {\n  content: \"\\f70b\"; }\n\n.fa-road:before {\n  content: \"\\f018\"; }\n\n.fa-robot:before {\n  content: \"\\f544\"; }\n\n.fa-rocket:before {\n  content: \"\\f135\"; }\n\n.fa-rocketchat:before {\n  content: \"\\f3e8\"; }\n\n.fa-rockrms:before {\n  content: \"\\f3e9\"; }\n\n.fa-route:before {\n  content: \"\\f4d7\"; }\n\n.fa-rss:before {\n  content: \"\\f09e\"; }\n\n.fa-rss-square:before {\n  content: \"\\f143\"; }\n\n.fa-ruble-sign:before {\n  content: \"\\f158\"; }\n\n.fa-ruler:before {\n  content: \"\\f545\"; }\n\n.fa-ruler-combined:before {\n  content: \"\\f546\"; }\n\n.fa-ruler-horizontal:before {\n  content: \"\\f547\"; }\n\n.fa-ruler-vertical:before {\n  content: \"\\f548\"; }\n\n.fa-running:before {\n  content: \"\\f70c\"; }\n\n.fa-rupee-sign:before {\n  content: \"\\f156\"; }\n\n.fa-sad-cry:before {\n  content: \"\\f5b3\"; }\n\n.fa-sad-tear:before {\n  content: \"\\f5b4\"; }\n\n.fa-safari:before {\n  content: \"\\f267\"; }\n\n.fa-salesforce:before {\n  content: \"\\f83b\"; }\n\n.fa-sass:before {\n  content: \"\\f41e\"; }\n\n.fa-satellite:before {\n  content: \"\\f7bf\"; }\n\n.fa-satellite-dish:before {\n  content: \"\\f7c0\"; }\n\n.fa-save:before {\n  content: \"\\f0c7\"; }\n\n.fa-schlix:before {\n  content: \"\\f3ea\"; }\n\n.fa-school:before {\n  content: \"\\f549\"; }\n\n.fa-screwdriver:before {\n  content: \"\\f54a\"; }\n\n.fa-scribd:before {\n  content: \"\\f28a\"; }\n\n.fa-scroll:before {\n  content: \"\\f70e\"; }\n\n.fa-sd-card:before {\n  content: \"\\f7c2\"; }\n\n.fa-search:before {\n  content: \"\\f002\"; }\n\n.fa-search-dollar:before {\n  content: \"\\f688\"; }\n\n.fa-search-location:before {\n  content: \"\\f689\"; }\n\n.fa-search-minus:before {\n  content: \"\\f010\"; }\n\n.fa-search-plus:before {\n  content: \"\\f00e\"; }\n\n.fa-searchengin:before {\n  content: \"\\f3eb\"; }\n\n.fa-seedling:before {\n  content: \"\\f4d8\"; }\n\n.fa-sellcast:before {\n  content: \"\\f2da\"; }\n\n.fa-sellsy:before {\n  content: \"\\f213\"; }\n\n.fa-server:before {\n  content: \"\\f233\"; }\n\n.fa-servicestack:before {\n  content: \"\\f3ec\"; }\n\n.fa-shapes:before {\n  content: \"\\f61f\"; }\n\n.fa-share:before {\n  content: \"\\f064\"; }\n\n.fa-share-alt:before {\n  content: \"\\f1e0\"; }\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\"; }\n\n.fa-share-square:before {\n  content: \"\\f14d\"; }\n\n.fa-shekel-sign:before {\n  content: \"\\f20b\"; }\n\n.fa-shield-alt:before {\n  content: \"\\f3ed\"; }\n\n.fa-shield-virus:before {\n  content: \"\\f96c\"; }\n\n.fa-ship:before {\n  content: \"\\f21a\"; }\n\n.fa-shipping-fast:before {\n  content: \"\\f48b\"; }\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\"; }\n\n.fa-shoe-prints:before {\n  content: \"\\f54b\"; }\n\n.fa-shopify:before {\n  content: \"\\f957\"; }\n\n.fa-shopping-bag:before {\n  content: \"\\f290\"; }\n\n.fa-shopping-basket:before {\n  content: \"\\f291\"; }\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\"; }\n\n.fa-shopware:before {\n  content: \"\\f5b5\"; }\n\n.fa-shower:before {\n  content: \"\\f2cc\"; }\n\n.fa-shuttle-van:before {\n  content: \"\\f5b6\"; }\n\n.fa-sign:before {\n  content: \"\\f4d9\"; }\n\n.fa-sign-in-alt:before {\n  content: \"\\f2f6\"; }\n\n.fa-sign-language:before {\n  content: \"\\f2a7\"; }\n\n.fa-sign-out-alt:before {\n  content: \"\\f2f5\"; }\n\n.fa-signal:before {\n  content: \"\\f012\"; }\n\n.fa-signature:before {\n  content: \"\\f5b7\"; }\n\n.fa-sim-card:before {\n  content: \"\\f7c4\"; }\n\n.fa-simplybuilt:before {\n  content: \"\\f215\"; }\n\n.fa-sistrix:before {\n  content: \"\\f3ee\"; }\n\n.fa-sitemap:before {\n  content: \"\\f0e8\"; }\n\n.fa-sith:before {\n  content: \"\\f512\"; }\n\n.fa-skating:before {\n  content: \"\\f7c5\"; }\n\n.fa-sketch:before {\n  content: \"\\f7c6\"; }\n\n.fa-skiing:before {\n  content: \"\\f7c9\"; }\n\n.fa-skiing-nordic:before {\n  content: \"\\f7ca\"; }\n\n.fa-skull:before {\n  content: \"\\f54c\"; }\n\n.fa-skull-crossbones:before {\n  content: \"\\f714\"; }\n\n.fa-skyatlas:before {\n  content: \"\\f216\"; }\n\n.fa-skype:before {\n  content: \"\\f17e\"; }\n\n.fa-slack:before {\n  content: \"\\f198\"; }\n\n.fa-slack-hash:before {\n  content: \"\\f3ef\"; }\n\n.fa-slash:before {\n  content: \"\\f715\"; }\n\n.fa-sleigh:before {\n  content: \"\\f7cc\"; }\n\n.fa-sliders-h:before {\n  content: \"\\f1de\"; }\n\n.fa-slideshare:before {\n  content: \"\\f1e7\"; }\n\n.fa-smile:before {\n  content: \"\\f118\"; }\n\n.fa-smile-beam:before {\n  content: \"\\f5b8\"; }\n\n.fa-smile-wink:before {\n  content: \"\\f4da\"; }\n\n.fa-smog:before {\n  content: \"\\f75f\"; }\n\n.fa-smoking:before {\n  content: \"\\f48d\"; }\n\n.fa-smoking-ban:before {\n  content: \"\\f54d\"; }\n\n.fa-sms:before {\n  content: \"\\f7cd\"; }\n\n.fa-snapchat:before {\n  content: \"\\f2ab\"; }\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\"; }\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\"; }\n\n.fa-snowboarding:before {\n  content: \"\\f7ce\"; }\n\n.fa-snowflake:before {\n  content: \"\\f2dc\"; }\n\n.fa-snowman:before {\n  content: \"\\f7d0\"; }\n\n.fa-snowplow:before {\n  content: \"\\f7d2\"; }\n\n.fa-soap:before {\n  content: \"\\f96e\"; }\n\n.fa-socks:before {\n  content: \"\\f696\"; }\n\n.fa-solar-panel:before {\n  content: \"\\f5ba\"; }\n\n.fa-sort:before {\n  content: \"\\f0dc\"; }\n\n.fa-sort-alpha-down:before {\n  content: \"\\f15d\"; }\n\n.fa-sort-alpha-down-alt:before {\n  content: \"\\f881\"; }\n\n.fa-sort-alpha-up:before {\n  content: \"\\f15e\"; }\n\n.fa-sort-alpha-up-alt:before {\n  content: \"\\f882\"; }\n\n.fa-sort-amount-down:before {\n  content: \"\\f160\"; }\n\n.fa-sort-amount-down-alt:before {\n  content: \"\\f884\"; }\n\n.fa-sort-amount-up:before {\n  content: \"\\f161\"; }\n\n.fa-sort-amount-up-alt:before {\n  content: \"\\f885\"; }\n\n.fa-sort-down:before {\n  content: \"\\f0dd\"; }\n\n.fa-sort-numeric-down:before {\n  content: \"\\f162\"; }\n\n.fa-sort-numeric-down-alt:before {\n  content: \"\\f886\"; }\n\n.fa-sort-numeric-up:before {\n  content: \"\\f163\"; }\n\n.fa-sort-numeric-up-alt:before {\n  content: \"\\f887\"; }\n\n.fa-sort-up:before {\n  content: \"\\f0de\"; }\n\n.fa-soundcloud:before {\n  content: \"\\f1be\"; }\n\n.fa-sourcetree:before {\n  content: \"\\f7d3\"; }\n\n.fa-spa:before {\n  content: \"\\f5bb\"; }\n\n.fa-space-shuttle:before {\n  content: \"\\f197\"; }\n\n.fa-speakap:before {\n  content: \"\\f3f3\"; }\n\n.fa-speaker-deck:before {\n  content: \"\\f83c\"; }\n\n.fa-spell-check:before {\n  content: \"\\f891\"; }\n\n.fa-spider:before {\n  content: \"\\f717\"; }\n\n.fa-spinner:before {\n  content: \"\\f110\"; }\n\n.fa-splotch:before {\n  content: \"\\f5bc\"; }\n\n.fa-spotify:before {\n  content: \"\\f1bc\"; }\n\n.fa-spray-can:before {\n  content: \"\\f5bd\"; }\n\n.fa-square:before {\n  content: \"\\f0c8\"; }\n\n.fa-square-full:before {\n  content: \"\\f45c\"; }\n\n.fa-square-root-alt:before {\n  content: \"\\f698\"; }\n\n.fa-squarespace:before {\n  content: \"\\f5be\"; }\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\"; }\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\"; }\n\n.fa-stackpath:before {\n  content: \"\\f842\"; }\n\n.fa-stamp:before {\n  content: \"\\f5bf\"; }\n\n.fa-star:before {\n  content: \"\\f005\"; }\n\n.fa-star-and-crescent:before {\n  content: \"\\f699\"; }\n\n.fa-star-half:before {\n  content: \"\\f089\"; }\n\n.fa-star-half-alt:before {\n  content: \"\\f5c0\"; }\n\n.fa-star-of-david:before {\n  content: \"\\f69a\"; }\n\n.fa-star-of-life:before {\n  content: \"\\f621\"; }\n\n.fa-staylinked:before {\n  content: \"\\f3f5\"; }\n\n.fa-steam:before {\n  content: \"\\f1b6\"; }\n\n.fa-steam-square:before {\n  content: \"\\f1b7\"; }\n\n.fa-steam-symbol:before {\n  content: \"\\f3f6\"; }\n\n.fa-step-backward:before {\n  content: \"\\f048\"; }\n\n.fa-step-forward:before {\n  content: \"\\f051\"; }\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\"; }\n\n.fa-sticker-mule:before {\n  content: \"\\f3f7\"; }\n\n.fa-sticky-note:before {\n  content: \"\\f249\"; }\n\n.fa-stop:before {\n  content: \"\\f04d\"; }\n\n.fa-stop-circle:before {\n  content: \"\\f28d\"; }\n\n.fa-stopwatch:before {\n  content: \"\\f2f2\"; }\n\n.fa-stopwatch-20:before {\n  content: \"\\f96f\"; }\n\n.fa-store:before {\n  content: \"\\f54e\"; }\n\n.fa-store-alt:before {\n  content: \"\\f54f\"; }\n\n.fa-store-alt-slash:before {\n  content: \"\\f970\"; }\n\n.fa-store-slash:before {\n  content: \"\\f971\"; }\n\n.fa-strava:before {\n  content: \"\\f428\"; }\n\n.fa-stream:before {\n  content: \"\\f550\"; }\n\n.fa-street-view:before {\n  content: \"\\f21d\"; }\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\"; }\n\n.fa-stripe:before {\n  content: \"\\f429\"; }\n\n.fa-stripe-s:before {\n  content: \"\\f42a\"; }\n\n.fa-stroopwafel:before {\n  content: \"\\f551\"; }\n\n.fa-studiovinari:before {\n  content: \"\\f3f8\"; }\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\"; }\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\"; }\n\n.fa-subscript:before {\n  content: \"\\f12c\"; }\n\n.fa-subway:before {\n  content: \"\\f239\"; }\n\n.fa-suitcase:before {\n  content: \"\\f0f2\"; }\n\n.fa-suitcase-rolling:before {\n  content: \"\\f5c1\"; }\n\n.fa-sun:before {\n  content: \"\\f185\"; }\n\n.fa-superpowers:before {\n  content: \"\\f2dd\"; }\n\n.fa-superscript:before {\n  content: \"\\f12b\"; }\n\n.fa-supple:before {\n  content: \"\\f3f9\"; }\n\n.fa-surprise:before {\n  content: \"\\f5c2\"; }\n\n.fa-suse:before {\n  content: \"\\f7d6\"; }\n\n.fa-swatchbook:before {\n  content: \"\\f5c3\"; }\n\n.fa-swift:before {\n  content: \"\\f8e1\"; }\n\n.fa-swimmer:before {\n  content: \"\\f5c4\"; }\n\n.fa-swimming-pool:before {\n  content: \"\\f5c5\"; }\n\n.fa-symfony:before {\n  content: \"\\f83d\"; }\n\n.fa-synagogue:before {\n  content: \"\\f69b\"; }\n\n.fa-sync:before {\n  content: \"\\f021\"; }\n\n.fa-sync-alt:before {\n  content: \"\\f2f1\"; }\n\n.fa-syringe:before {\n  content: \"\\f48e\"; }\n\n.fa-table:before {\n  content: \"\\f0ce\"; }\n\n.fa-table-tennis:before {\n  content: \"\\f45d\"; }\n\n.fa-tablet:before {\n  content: \"\\f10a\"; }\n\n.fa-tablet-alt:before {\n  content: \"\\f3fa\"; }\n\n.fa-tablets:before {\n  content: \"\\f490\"; }\n\n.fa-tachometer-alt:before {\n  content: \"\\f3fd\"; }\n\n.fa-tag:before {\n  content: \"\\f02b\"; }\n\n.fa-tags:before {\n  content: \"\\f02c\"; }\n\n.fa-tape:before {\n  content: \"\\f4db\"; }\n\n.fa-tasks:before {\n  content: \"\\f0ae\"; }\n\n.fa-taxi:before {\n  content: \"\\f1ba\"; }\n\n.fa-teamspeak:before {\n  content: \"\\f4f9\"; }\n\n.fa-teeth:before {\n  content: \"\\f62e\"; }\n\n.fa-teeth-open:before {\n  content: \"\\f62f\"; }\n\n.fa-telegram:before {\n  content: \"\\f2c6\"; }\n\n.fa-telegram-plane:before {\n  content: \"\\f3fe\"; }\n\n.fa-temperature-high:before {\n  content: \"\\f769\"; }\n\n.fa-temperature-low:before {\n  content: \"\\f76b\"; }\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\"; }\n\n.fa-tenge:before {\n  content: \"\\f7d7\"; }\n\n.fa-terminal:before {\n  content: \"\\f120\"; }\n\n.fa-text-height:before {\n  content: \"\\f034\"; }\n\n.fa-text-width:before {\n  content: \"\\f035\"; }\n\n.fa-th:before {\n  content: \"\\f00a\"; }\n\n.fa-th-large:before {\n  content: \"\\f009\"; }\n\n.fa-th-list:before {\n  content: \"\\f00b\"; }\n\n.fa-the-red-yeti:before {\n  content: \"\\f69d\"; }\n\n.fa-theater-masks:before {\n  content: \"\\f630\"; }\n\n.fa-themeco:before {\n  content: \"\\f5c6\"; }\n\n.fa-themeisle:before {\n  content: \"\\f2b2\"; }\n\n.fa-thermometer:before {\n  content: \"\\f491\"; }\n\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\"; }\n\n.fa-thermometer-full:before {\n  content: \"\\f2c7\"; }\n\n.fa-thermometer-half:before {\n  content: \"\\f2c9\"; }\n\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\"; }\n\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\"; }\n\n.fa-think-peaks:before {\n  content: \"\\f731\"; }\n\n.fa-thumbs-down:before {\n  content: \"\\f165\"; }\n\n.fa-thumbs-up:before {\n  content: \"\\f164\"; }\n\n.fa-thumbtack:before {\n  content: \"\\f08d\"; }\n\n.fa-ticket-alt:before {\n  content: \"\\f3ff\"; }\n\n.fa-times:before {\n  content: \"\\f00d\"; }\n\n.fa-times-circle:before {\n  content: \"\\f057\"; }\n\n.fa-tint:before {\n  content: \"\\f043\"; }\n\n.fa-tint-slash:before {\n  content: \"\\f5c7\"; }\n\n.fa-tired:before {\n  content: \"\\f5c8\"; }\n\n.fa-toggle-off:before {\n  content: \"\\f204\"; }\n\n.fa-toggle-on:before {\n  content: \"\\f205\"; }\n\n.fa-toilet:before {\n  content: \"\\f7d8\"; }\n\n.fa-toilet-paper:before {\n  content: \"\\f71e\"; }\n\n.fa-toilet-paper-slash:before {\n  content: \"\\f972\"; }\n\n.fa-toolbox:before {\n  content: \"\\f552\"; }\n\n.fa-tools:before {\n  content: \"\\f7d9\"; }\n\n.fa-tooth:before {\n  content: \"\\f5c9\"; }\n\n.fa-torah:before {\n  content: \"\\f6a0\"; }\n\n.fa-torii-gate:before {\n  content: \"\\f6a1\"; }\n\n.fa-tractor:before {\n  content: \"\\f722\"; }\n\n.fa-trade-federation:before {\n  content: \"\\f513\"; }\n\n.fa-trademark:before {\n  content: \"\\f25c\"; }\n\n.fa-traffic-light:before {\n  content: \"\\f637\"; }\n\n.fa-trailer:before {\n  content: \"\\f941\"; }\n\n.fa-train:before {\n  content: \"\\f238\"; }\n\n.fa-tram:before {\n  content: \"\\f7da\"; }\n\n.fa-transgender:before {\n  content: \"\\f224\"; }\n\n.fa-transgender-alt:before {\n  content: \"\\f225\"; }\n\n.fa-trash:before {\n  content: \"\\f1f8\"; }\n\n.fa-trash-alt:before {\n  content: \"\\f2ed\"; }\n\n.fa-trash-restore:before {\n  content: \"\\f829\"; }\n\n.fa-trash-restore-alt:before {\n  content: \"\\f82a\"; }\n\n.fa-tree:before {\n  content: \"\\f1bb\"; }\n\n.fa-trello:before {\n  content: \"\\f181\"; }\n\n.fa-tripadvisor:before {\n  content: \"\\f262\"; }\n\n.fa-trophy:before {\n  content: \"\\f091\"; }\n\n.fa-truck:before {\n  content: \"\\f0d1\"; }\n\n.fa-truck-loading:before {\n  content: \"\\f4de\"; }\n\n.fa-truck-monster:before {\n  content: \"\\f63b\"; }\n\n.fa-truck-moving:before {\n  content: \"\\f4df\"; }\n\n.fa-truck-pickup:before {\n  content: \"\\f63c\"; }\n\n.fa-tshirt:before {\n  content: \"\\f553\"; }\n\n.fa-tty:before {\n  content: \"\\f1e4\"; }\n\n.fa-tumblr:before {\n  content: \"\\f173\"; }\n\n.fa-tumblr-square:before {\n  content: \"\\f174\"; }\n\n.fa-tv:before {\n  content: \"\\f26c\"; }\n\n.fa-twitch:before {\n  content: \"\\f1e8\"; }\n\n.fa-twitter:before {\n  content: \"\\f099\"; }\n\n.fa-twitter-square:before {\n  content: \"\\f081\"; }\n\n.fa-typo3:before {\n  content: \"\\f42b\"; }\n\n.fa-uber:before {\n  content: \"\\f402\"; }\n\n.fa-ubuntu:before {\n  content: \"\\f7df\"; }\n\n.fa-uikit:before {\n  content: \"\\f403\"; }\n\n.fa-umbraco:before {\n  content: \"\\f8e8\"; }\n\n.fa-umbrella:before {\n  content: \"\\f0e9\"; }\n\n.fa-umbrella-beach:before {\n  content: \"\\f5ca\"; }\n\n.fa-underline:before {\n  content: \"\\f0cd\"; }\n\n.fa-undo:before {\n  content: \"\\f0e2\"; }\n\n.fa-undo-alt:before {\n  content: \"\\f2ea\"; }\n\n.fa-uniregistry:before {\n  content: \"\\f404\"; }\n\n.fa-unity:before {\n  content: \"\\f949\"; }\n\n.fa-universal-access:before {\n  content: \"\\f29a\"; }\n\n.fa-university:before {\n  content: \"\\f19c\"; }\n\n.fa-unlink:before {\n  content: \"\\f127\"; }\n\n.fa-unlock:before {\n  content: \"\\f09c\"; }\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\"; }\n\n.fa-untappd:before {\n  content: \"\\f405\"; }\n\n.fa-upload:before {\n  content: \"\\f093\"; }\n\n.fa-ups:before {\n  content: \"\\f7e0\"; }\n\n.fa-usb:before {\n  content: \"\\f287\"; }\n\n.fa-user:before {\n  content: \"\\f007\"; }\n\n.fa-user-alt:before {\n  content: \"\\f406\"; }\n\n.fa-user-alt-slash:before {\n  content: \"\\f4fa\"; }\n\n.fa-user-astronaut:before {\n  content: \"\\f4fb\"; }\n\n.fa-user-check:before {\n  content: \"\\f4fc\"; }\n\n.fa-user-circle:before {\n  content: \"\\f2bd\"; }\n\n.fa-user-clock:before {\n  content: \"\\f4fd\"; }\n\n.fa-user-cog:before {\n  content: \"\\f4fe\"; }\n\n.fa-user-edit:before {\n  content: \"\\f4ff\"; }\n\n.fa-user-friends:before {\n  content: \"\\f500\"; }\n\n.fa-user-graduate:before {\n  content: \"\\f501\"; }\n\n.fa-user-injured:before {\n  content: \"\\f728\"; }\n\n.fa-user-lock:before {\n  content: \"\\f502\"; }\n\n.fa-user-md:before {\n  content: \"\\f0f0\"; }\n\n.fa-user-minus:before {\n  content: \"\\f503\"; }\n\n.fa-user-ninja:before {\n  content: \"\\f504\"; }\n\n.fa-user-nurse:before {\n  content: \"\\f82f\"; }\n\n.fa-user-plus:before {\n  content: \"\\f234\"; }\n\n.fa-user-secret:before {\n  content: \"\\f21b\"; }\n\n.fa-user-shield:before {\n  content: \"\\f505\"; }\n\n.fa-user-slash:before {\n  content: \"\\f506\"; }\n\n.fa-user-tag:before {\n  content: \"\\f507\"; }\n\n.fa-user-tie:before {\n  content: \"\\f508\"; }\n\n.fa-user-times:before {\n  content: \"\\f235\"; }\n\n.fa-users:before {\n  content: \"\\f0c0\"; }\n\n.fa-users-cog:before {\n  content: \"\\f509\"; }\n\n.fa-usps:before {\n  content: \"\\f7e1\"; }\n\n.fa-ussunnah:before {\n  content: \"\\f407\"; }\n\n.fa-utensil-spoon:before {\n  content: \"\\f2e5\"; }\n\n.fa-utensils:before {\n  content: \"\\f2e7\"; }\n\n.fa-vaadin:before {\n  content: \"\\f408\"; }\n\n.fa-vector-square:before {\n  content: \"\\f5cb\"; }\n\n.fa-venus:before {\n  content: \"\\f221\"; }\n\n.fa-venus-double:before {\n  content: \"\\f226\"; }\n\n.fa-venus-mars:before {\n  content: \"\\f228\"; }\n\n.fa-viacoin:before {\n  content: \"\\f237\"; }\n\n.fa-viadeo:before {\n  content: \"\\f2a9\"; }\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\"; }\n\n.fa-vial:before {\n  content: \"\\f492\"; }\n\n.fa-vials:before {\n  content: \"\\f493\"; }\n\n.fa-viber:before {\n  content: \"\\f409\"; }\n\n.fa-video:before {\n  content: \"\\f03d\"; }\n\n.fa-video-slash:before {\n  content: \"\\f4e2\"; }\n\n.fa-vihara:before {\n  content: \"\\f6a7\"; }\n\n.fa-vimeo:before {\n  content: \"\\f40a\"; }\n\n.fa-vimeo-square:before {\n  content: \"\\f194\"; }\n\n.fa-vimeo-v:before {\n  content: \"\\f27d\"; }\n\n.fa-vine:before {\n  content: \"\\f1ca\"; }\n\n.fa-virus:before {\n  content: \"\\f974\"; }\n\n.fa-virus-slash:before {\n  content: \"\\f975\"; }\n\n.fa-viruses:before {\n  content: \"\\f976\"; }\n\n.fa-vk:before {\n  content: \"\\f189\"; }\n\n.fa-vnv:before {\n  content: \"\\f40b\"; }\n\n.fa-voicemail:before {\n  content: \"\\f897\"; }\n\n.fa-volleyball-ball:before {\n  content: \"\\f45f\"; }\n\n.fa-volume-down:before {\n  content: \"\\f027\"; }\n\n.fa-volume-mute:before {\n  content: \"\\f6a9\"; }\n\n.fa-volume-off:before {\n  content: \"\\f026\"; }\n\n.fa-volume-up:before {\n  content: \"\\f028\"; }\n\n.fa-vote-yea:before {\n  content: \"\\f772\"; }\n\n.fa-vr-cardboard:before {\n  content: \"\\f729\"; }\n\n.fa-vuejs:before {\n  content: \"\\f41f\"; }\n\n.fa-walking:before {\n  content: \"\\f554\"; }\n\n.fa-wallet:before {\n  content: \"\\f555\"; }\n\n.fa-warehouse:before {\n  content: \"\\f494\"; }\n\n.fa-water:before {\n  content: \"\\f773\"; }\n\n.fa-wave-square:before {\n  content: \"\\f83e\"; }\n\n.fa-waze:before {\n  content: \"\\f83f\"; }\n\n.fa-weebly:before {\n  content: \"\\f5cc\"; }\n\n.fa-weibo:before {\n  content: \"\\f18a\"; }\n\n.fa-weight:before {\n  content: \"\\f496\"; }\n\n.fa-weight-hanging:before {\n  content: \"\\f5cd\"; }\n\n.fa-weixin:before {\n  content: \"\\f1d7\"; }\n\n.fa-whatsapp:before {\n  content: \"\\f232\"; }\n\n.fa-whatsapp-square:before {\n  content: \"\\f40c\"; }\n\n.fa-wheelchair:before {\n  content: \"\\f193\"; }\n\n.fa-whmcs:before {\n  content: \"\\f40d\"; }\n\n.fa-wifi:before {\n  content: \"\\f1eb\"; }\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\"; }\n\n.fa-wind:before {\n  content: \"\\f72e\"; }\n\n.fa-window-close:before {\n  content: \"\\f410\"; }\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\"; }\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\"; }\n\n.fa-window-restore:before {\n  content: \"\\f2d2\"; }\n\n.fa-windows:before {\n  content: \"\\f17a\"; }\n\n.fa-wine-bottle:before {\n  content: \"\\f72f\"; }\n\n.fa-wine-glass:before {\n  content: \"\\f4e3\"; }\n\n.fa-wine-glass-alt:before {\n  content: \"\\f5ce\"; }\n\n.fa-wix:before {\n  content: \"\\f5cf\"; }\n\n.fa-wizards-of-the-coast:before {\n  content: \"\\f730\"; }\n\n.fa-wolf-pack-battalion:before {\n  content: \"\\f514\"; }\n\n.fa-won-sign:before {\n  content: \"\\f159\"; }\n\n.fa-wordpress:before {\n  content: \"\\f19a\"; }\n\n.fa-wordpress-simple:before {\n  content: \"\\f411\"; }\n\n.fa-wpbeginner:before {\n  content: \"\\f297\"; }\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\"; }\n\n.fa-wpforms:before {\n  content: \"\\f298\"; }\n\n.fa-wpressr:before {\n  content: \"\\f3e4\"; }\n\n.fa-wrench:before {\n  content: \"\\f0ad\"; }\n\n.fa-x-ray:before {\n  content: \"\\f497\"; }\n\n.fa-xbox:before {\n  content: \"\\f412\"; }\n\n.fa-xing:before {\n  content: \"\\f168\"; }\n\n.fa-xing-square:before {\n  content: \"\\f169\"; }\n\n.fa-y-combinator:before {\n  content: \"\\f23b\"; }\n\n.fa-yahoo:before {\n  content: \"\\f19e\"; }\n\n.fa-yammer:before {\n  content: \"\\f840\"; }\n\n.fa-yandex:before {\n  content: \"\\f413\"; }\n\n.fa-yandex-international:before {\n  content: \"\\f414\"; }\n\n.fa-yarn:before {\n  content: \"\\f7e3\"; }\n\n.fa-yelp:before {\n  content: \"\\f1e9\"; }\n\n.fa-yen-sign:before {\n  content: \"\\f157\"; }\n\n.fa-yin-yang:before {\n  content: \"\\f6ad\"; }\n\n.fa-yoast:before {\n  content: \"\\f2b1\"; }\n\n.fa-youtube:before {\n  content: \"\\f167\"; }\n\n.fa-youtube-square:before {\n  content: \"\\f431\"; }\n\n.fa-zhihu:before {\n  content: \"\\f63f\"; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-brands-400.eot\");\n  src: url(\"../../../../fonts/fa-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-brands-400.woff\") format(\"woff\"), url(\"../../../../fonts/fa-brands-400.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-brands-400.svg#fontawesome\") format(\"svg\"); }\n\n.fab {\n  font-family: 'Font Awesome 5 Brands';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-regular-400.eot\");\n  src: url(\"../../../../fonts/fa-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-regular-400.woff\") format(\"woff\"), url(\"../../../../fonts/fa-regular-400.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-regular-400.svg#fontawesome\") format(\"svg\"); }\n\n.far {\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-solid-900.eot\");\n  src: url(\"../../../../fonts/fa-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-solid-900.woff\") format(\"woff\"), url(\"../../../../fonts/fa-solid-900.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-solid-900.svg#fontawesome\") format(\"svg\"); }\n\n.fa,\n.fas {\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900; }\n","@charset \"UTF-8\";\n\n@font-face {\n  font-family: \"dripicons-v2\";\n  src:url(\"../../../../fonts/dripicons-v2.eot\");\n  src:url(\"../../../../fonts/dripicons-v2.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"),\n    url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"),\n    url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n\n}\n\n[data-icon]:before {\n  font-family: \"dripicons-v2\" !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"dripicons-\"]:before,\n[class*=\" dripicons-\"]:before {\n  font-family: \"dripicons-v2\" !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.dripicons-alarm:before {\n  content: \"\\61\";\n}\n.dripicons-align-center:before {\n  content: \"\\62\";\n}\n.dripicons-align-justify:before {\n  content: \"\\63\";\n}\n.dripicons-align-left:before {\n  content: \"\\64\";\n}\n.dripicons-align-right:before {\n  content: \"\\65\";\n}\n.dripicons-anchor:before {\n  content: \"\\66\";\n}\n.dripicons-archive:before {\n  content: \"\\67\";\n}\n.dripicons-arrow-down:before {\n  content: \"\\68\";\n}\n.dripicons-arrow-left:before {\n  content: \"\\69\";\n}\n.dripicons-arrow-right:before {\n  content: \"\\6a\";\n}\n.dripicons-arrow-thin-down:before {\n  content: \"\\6b\";\n}\n.dripicons-arrow-thin-left:before {\n  content: \"\\6c\";\n}\n.dripicons-arrow-thin-right:before {\n  content: \"\\6d\";\n}\n.dripicons-arrow-thin-up:before {\n  content: \"\\6e\";\n}\n.dripicons-arrow-up:before {\n  content: \"\\6f\";\n}\n.dripicons-article:before {\n  content: \"\\70\";\n}\n.dripicons-backspace:before {\n  content: \"\\71\";\n}\n.dripicons-basket:before {\n  content: \"\\72\";\n}\n.dripicons-basketball:before {\n  content: \"\\73\";\n}\n.dripicons-battery-empty:before {\n  content: \"\\74\";\n}\n.dripicons-battery-full:before {\n  content: \"\\75\";\n}\n.dripicons-battery-low:before {\n  content: \"\\76\";\n}\n.dripicons-battery-medium:before {\n  content: \"\\77\";\n}\n.dripicons-bell:before {\n  content: \"\\78\";\n}\n.dripicons-blog:before {\n  content: \"\\79\";\n}\n.dripicons-bluetooth:before {\n  content: \"\\7a\";\n}\n.dripicons-bold:before {\n  content: \"\\41\";\n}\n.dripicons-bookmark:before {\n  content: \"\\42\";\n}\n.dripicons-bookmarks:before {\n  content: \"\\43\";\n}\n.dripicons-box:before {\n  content: \"\\44\";\n}\n.dripicons-briefcase:before {\n  content: \"\\45\";\n}\n.dripicons-brightness-low:before {\n  content: \"\\46\";\n}\n.dripicons-brightness-max:before {\n  content: \"\\47\";\n}\n.dripicons-brightness-medium:before {\n  content: \"\\48\";\n}\n.dripicons-broadcast:before {\n  content: \"\\49\";\n}\n.dripicons-browser:before {\n  content: \"\\4a\";\n}\n.dripicons-browser-upload:before {\n  content: \"\\4b\";\n}\n.dripicons-brush:before {\n  content: \"\\4c\";\n}\n.dripicons-calendar:before {\n  content: \"\\4d\";\n}\n.dripicons-camcorder:before {\n  content: \"\\4e\";\n}\n.dripicons-camera:before {\n  content: \"\\4f\";\n}\n.dripicons-card:before {\n  content: \"\\50\";\n}\n.dripicons-cart:before {\n  content: \"\\51\";\n}\n.dripicons-checklist:before {\n  content: \"\\52\";\n}\n.dripicons-checkmark:before {\n  content: \"\\53\";\n}\n.dripicons-chevron-down:before {\n  content: \"\\54\";\n}\n.dripicons-chevron-left:before {\n  content: \"\\55\";\n}\n.dripicons-chevron-right:before {\n  content: \"\\56\";\n}\n.dripicons-chevron-up:before {\n  content: \"\\57\";\n}\n.dripicons-clipboard:before {\n  content: \"\\58\";\n}\n.dripicons-clock:before {\n  content: \"\\59\";\n}\n.dripicons-clockwise:before {\n  content: \"\\5a\";\n}\n.dripicons-cloud:before {\n  content: \"\\30\";\n}\n.dripicons-cloud-download:before {\n  content: \"\\31\";\n}\n.dripicons-cloud-upload:before {\n  content: \"\\32\";\n}\n.dripicons-code:before {\n  content: \"\\33\";\n}\n.dripicons-contract:before {\n  content: \"\\34\";\n}\n.dripicons-contract-2:before {\n  content: \"\\35\";\n}\n.dripicons-conversation:before {\n  content: \"\\36\";\n}\n.dripicons-copy:before {\n  content: \"\\37\";\n}\n.dripicons-crop:before {\n  content: \"\\38\";\n}\n.dripicons-cross:before {\n  content: \"\\39\";\n}\n.dripicons-crosshair:before {\n  content: \"\\21\";\n}\n.dripicons-cutlery:before {\n  content: \"\\22\";\n}\n.dripicons-device-desktop:before {\n  content: \"\\23\";\n}\n.dripicons-device-mobile:before {\n  content: \"\\24\";\n}\n.dripicons-device-tablet:before {\n  content: \"\\25\";\n}\n.dripicons-direction:before {\n  content: \"\\26\";\n}\n.dripicons-disc:before {\n  content: \"\\27\";\n}\n.dripicons-document:before {\n  content: \"\\28\";\n}\n.dripicons-document-delete:before {\n  content: \"\\29\";\n}\n.dripicons-document-edit:before {\n  content: \"\\2a\";\n}\n.dripicons-document-new:before {\n  content: \"\\2b\";\n}\n.dripicons-document-remove:before {\n  content: \"\\2c\";\n}\n.dripicons-dot:before {\n  content: \"\\2d\";\n}\n.dripicons-dots-2:before {\n  content: \"\\2e\";\n}\n.dripicons-dots-3:before {\n  content: \"\\2f\";\n}\n.dripicons-download:before {\n  content: \"\\3a\";\n}\n.dripicons-duplicate:before {\n  content: \"\\3b\";\n}\n.dripicons-enter:before {\n  content: \"\\3c\";\n}\n.dripicons-exit:before {\n  content: \"\\3d\";\n}\n.dripicons-expand:before {\n  content: \"\\3e\";\n}\n.dripicons-expand-2:before {\n  content: \"\\3f\";\n}\n.dripicons-experiment:before {\n  content: \"\\40\";\n}\n.dripicons-export:before {\n  content: \"\\5b\";\n}\n.dripicons-feed:before {\n  content: \"\\5d\";\n}\n.dripicons-flag:before {\n  content: \"\\5e\";\n}\n.dripicons-flashlight:before {\n  content: \"\\5f\";\n}\n.dripicons-folder:before {\n  content: \"\\60\";\n}\n.dripicons-folder-open:before {\n  content: \"\\7b\";\n}\n.dripicons-forward:before {\n  content: \"\\7c\";\n}\n.dripicons-gaming:before {\n  content: \"\\7d\";\n}\n.dripicons-gear:before {\n  content: \"\\7e\";\n}\n.dripicons-graduation:before {\n  content: \"\\5c\";\n}\n.dripicons-graph-bar:before {\n  content: \"\\e000\";\n}\n.dripicons-graph-line:before {\n  content: \"\\e001\";\n}\n.dripicons-graph-pie:before {\n  content: \"\\e002\";\n}\n.dripicons-headset:before {\n  content: \"\\e003\";\n}\n.dripicons-heart:before {\n  content: \"\\e004\";\n}\n.dripicons-help:before {\n  content: \"\\e005\";\n}\n.dripicons-home:before {\n  content: \"\\e006\";\n}\n.dripicons-hourglass:before {\n  content: \"\\e007\";\n}\n.dripicons-inbox:before {\n  content: \"\\e008\";\n}\n.dripicons-information:before {\n  content: \"\\e009\";\n}\n.dripicons-italic:before {\n  content: \"\\e00a\";\n}\n.dripicons-jewel:before {\n  content: \"\\e00b\";\n}\n.dripicons-lifting:before {\n  content: \"\\e00c\";\n}\n.dripicons-lightbulb:before {\n  content: \"\\e00d\";\n}\n.dripicons-link:before {\n  content: \"\\e00e\";\n}\n.dripicons-link-broken:before {\n  content: \"\\e00f\";\n}\n.dripicons-list:before {\n  content: \"\\e010\";\n}\n.dripicons-loading:before {\n  content: \"\\e011\";\n}\n.dripicons-location:before {\n  content: \"\\e012\";\n}\n.dripicons-lock:before {\n  content: \"\\e013\";\n}\n.dripicons-lock-open:before {\n  content: \"\\e014\";\n}\n.dripicons-mail:before {\n  content: \"\\e015\";\n}\n.dripicons-map:before {\n  content: \"\\e016\";\n}\n.dripicons-media-loop:before {\n  content: \"\\e017\";\n}\n.dripicons-media-next:before {\n  content: \"\\e018\";\n}\n.dripicons-media-pause:before {\n  content: \"\\e019\";\n}\n.dripicons-media-play:before {\n  content: \"\\e01a\";\n}\n.dripicons-media-previous:before {\n  content: \"\\e01b\";\n}\n.dripicons-media-record:before {\n  content: \"\\e01c\";\n}\n.dripicons-media-shuffle:before {\n  content: \"\\e01d\";\n}\n.dripicons-media-stop:before {\n  content: \"\\e01e\";\n}\n.dripicons-medical:before {\n  content: \"\\e01f\";\n}\n.dripicons-menu:before {\n  content: \"\\e020\";\n}\n.dripicons-message:before {\n  content: \"\\e021\";\n}\n.dripicons-meter:before {\n  content: \"\\e022\";\n}\n.dripicons-microphone:before {\n  content: \"\\e023\";\n}\n.dripicons-minus:before {\n  content: \"\\e024\";\n}\n.dripicons-monitor:before {\n  content: \"\\e025\";\n}\n.dripicons-move:before {\n  content: \"\\e026\";\n}\n.dripicons-music:before {\n  content: \"\\e027\";\n}\n.dripicons-network-1:before {\n  content: \"\\e028\";\n}\n.dripicons-network-2:before {\n  content: \"\\e029\";\n}\n.dripicons-network-3:before {\n  content: \"\\e02a\";\n}\n.dripicons-network-4:before {\n  content: \"\\e02b\";\n}\n.dripicons-network-5:before {\n  content: \"\\e02c\";\n}\n.dripicons-pamphlet:before {\n  content: \"\\e02d\";\n}\n.dripicons-paperclip:before {\n  content: \"\\e02e\";\n}\n.dripicons-pencil:before {\n  content: \"\\e02f\";\n}\n.dripicons-phone:before {\n  content: \"\\e030\";\n}\n.dripicons-photo:before {\n  content: \"\\e031\";\n}\n.dripicons-photo-group:before {\n  content: \"\\e032\";\n}\n.dripicons-pill:before {\n  content: \"\\e033\";\n}\n.dripicons-pin:before {\n  content: \"\\e034\";\n}\n.dripicons-plus:before {\n  content: \"\\e035\";\n}\n.dripicons-power:before {\n  content: \"\\e036\";\n}\n.dripicons-preview:before {\n  content: \"\\e037\";\n}\n.dripicons-print:before {\n  content: \"\\e038\";\n}\n.dripicons-pulse:before {\n  content: \"\\e039\";\n}\n.dripicons-question:before {\n  content: \"\\e03a\";\n}\n.dripicons-reply:before {\n  content: \"\\e03b\";\n}\n.dripicons-reply-all:before {\n  content: \"\\e03c\";\n}\n.dripicons-return:before {\n  content: \"\\e03d\";\n}\n.dripicons-retweet:before {\n  content: \"\\e03e\";\n}\n.dripicons-rocket:before {\n  content: \"\\e03f\";\n}\n.dripicons-scale:before {\n  content: \"\\e040\";\n}\n.dripicons-search:before {\n  content: \"\\e041\";\n}\n.dripicons-shopping-bag:before {\n  content: \"\\e042\";\n}\n.dripicons-skip:before {\n  content: \"\\e043\";\n}\n.dripicons-stack:before {\n  content: \"\\e044\";\n}\n.dripicons-star:before {\n  content: \"\\e045\";\n}\n.dripicons-stopwatch:before {\n  content: \"\\e046\";\n}\n.dripicons-store:before {\n  content: \"\\e047\";\n}\n.dripicons-suitcase:before {\n  content: \"\\e048\";\n}\n.dripicons-swap:before {\n  content: \"\\e049\";\n}\n.dripicons-tag:before {\n  content: \"\\e04a\";\n}\n.dripicons-tag-delete:before {\n  content: \"\\e04b\";\n}\n.dripicons-tags:before {\n  content: \"\\e04c\";\n}\n.dripicons-thumbs-down:before {\n  content: \"\\e04d\";\n}\n.dripicons-thumbs-up:before {\n  content: \"\\e04e\";\n}\n.dripicons-ticket:before {\n  content: \"\\e04f\";\n}\n.dripicons-time-reverse:before {\n  content: \"\\e050\";\n}\n.dripicons-to-do:before {\n  content: \"\\e051\";\n}\n.dripicons-toggles:before {\n  content: \"\\e052\";\n}\n.dripicons-trash:before {\n  content: \"\\e053\";\n}\n.dripicons-trophy:before {\n  content: \"\\e054\";\n}\n.dripicons-upload:before {\n  content: \"\\e055\";\n}\n.dripicons-user:before {\n  content: \"\\e056\";\n}\n.dripicons-user-group:before {\n  content: \"\\e057\";\n}\n.dripicons-user-id:before {\n  content: \"\\e058\";\n}\n.dripicons-vibrate:before {\n  content: \"\\e059\";\n}\n.dripicons-view-apps:before {\n  content: \"\\e05a\";\n}\n.dripicons-view-list:before {\n  content: \"\\e05b\";\n}\n.dripicons-view-list-large:before {\n  content: \"\\e05c\";\n}\n.dripicons-view-thumb:before {\n  content: \"\\e05d\";\n}\n.dripicons-volume-full:before {\n  content: \"\\e05e\";\n}\n.dripicons-volume-low:before {\n  content: \"\\e05f\";\n}\n.dripicons-volume-medium:before {\n  content: \"\\e060\";\n}\n.dripicons-volume-off:before {\n  content: \"\\e061\";\n}\n.dripicons-wallet:before {\n  content: \"\\e062\";\n}\n.dripicons-warning:before {\n  content: \"\\e063\";\n}\n.dripicons-web:before {\n  content: \"\\e064\";\n}\n.dripicons-weight:before {\n  content: \"\\e065\";\n}\n.dripicons-wifi:before {\n  content: \"\\e066\";\n}\n.dripicons-wrong:before {\n  content: \"\\e067\";\n}\n.dripicons-zoom-in:before {\n  content: \"\\e068\";\n}\n.dripicons-zoom-out:before {\n  content: \"\\e069\";\n}\n","/*\nFile: Custom Bootstrap Css File\n*/\n\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";\n\n@import \"custom/components/reboot\";\n@import \"custom/components/backgrounds\";\n@import \"custom/components/badge\";\n@import \"custom/components/buttons\";\n@import \"custom/components/breadcrumb\";\n@import \"custom/components/card\";\n@import \"custom/components/dropdown\";\n@import \"custom/components/nav\";\n@import \"custom/components/table\";\n@import \"custom/components/pagination\";\n@import \"custom/components/progress\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.5 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n// Vertical Sidebar  Light\n$sidebar-bg: #ffffff;\n$sidebar-menu-item-color: #545a6d;\n$sidebar-menu-sub-item-color: #545a6d;\n$sidebar-menu-item-icon-color: #7f8387;\n$sidebar-menu-item-hover-color: #383c40;\n$sidebar-menu-item-active-color: #556ee6;\n$sidebar-width: 250px;\n$sidebar-collapsed-width: 70px;\n$sidebar-width-sm: 160px;\n$layout-collapsed-min-height: 1760px;\n\n// Vertical Sidebar - Dark\n$sidebar-dark-bg: #2a3042; //2c313a\n$sidebar-dark-menu-item-color: #a6b0cf;\n$sidebar-dark-menu-sub-item-color: #79829c;\n$sidebar-dark-menu-item-icon-color: #6a7187;\n$sidebar-dark-menu-item-hover-color: #ffffff;\n$sidebar-dark-menu-item-active-color: #ffffff;\n\n// Topbar - Deafult Light\n$header-height: 70px;\n$header-bg: #ffffff;\n$header-item-color: #555b6d;\n\n// Topbar - Dark\n$header-dark-bg: #2a3042;\n$header-dark-item-color: #e9ecef;\n\n// Topbar Search\n$topbar-search-bg: #f3f3f9;\n\n// Footer\n$footer-height: 60px;\n$footer-bg: #111233;\n$footer-color: #ffffff;\n\n// Horizontal nav\n$topnav-bg: #fff;\n\n$menu-item-color: #545a6d;\n$menu-item-active-color: #556ee6;\n\n// Right Sidebar\n$rightbar-width: 280px;\n\n// Display\n$display-none: none;\n$display-block: block;\n\n// Brand\n$navbar-brand-box-width: 250px;\n\n// Boxed layout width\n$boxed-layout-width: 1300px;\n$boxed-body-bg: #ebebf4;\n\n// Font Weight\n$fw-medium: 500;\n$font-weight-semibold: 600;\n\n// apex charts\n$apex-grid-color: #f8f9fa;\n\n// table\n$table-head-bg: $gray-100;\n$table-dark-border-color: tint-color($gray-800, 7.5%);\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white: #fff;\n$gray-100: #f8f9fa;\n$gray-200: #eff2f7;\n$gray-300: #f6f6f6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #74788d;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black: #000;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900,\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue: #556ee6;\n$indigo: #564ab1;\n$purple: #6f42c1;\n$pink: #e83e8c;\n$red: #f46a6a;\n$orange: #f1734f;\n$yellow: #f1b44c;\n$green: #34c38f;\n$teal: #050505;\n$cyan: #50a5f1;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\": $blue,\n  \"indigo\": $indigo,\n  \"purple\": $purple,\n  \"pink\": $pink,\n  \"red\": $red,\n  \"orange\": $orange,\n  \"yellow\": $yellow,\n  \"green\": $green,\n  \"teal\": $teal,\n  \"cyan\": $cyan,\n  \"white\": $white,\n  \"gray\": $gray-600,\n  \"gray-dark\": $gray-800,\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary: $blue;\n$secondary: $gray-600;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$light: $gray-200;\n$dark: $gray-800;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\": $primary,\n  \"secondary\": $secondary,\n  \"success\": $success,\n  \"info\": $info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"pink\": $pink,\n  \"light\": $light,\n  \"dark\": $dark,\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\n// scss-docs-end theme-colors-rgb\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio: 1.8;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark: $black;\n$color-contrast-light: $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900,\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900,\n);\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900,\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900,\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900,\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900,\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900,\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900,\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900,\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900,\n);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\")\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret: false;\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-reduced-motion: true;\n$enable-smooth-scroll: true;\n$enable-grid-classes: true;\n$enable-cssgrid: false;\n$enable-button-pointers: true;\n$enable-rfs: true;\n$enable-validation-icons: true;\n$enable-negative-margins: true;\n$enable-deprecation-messages: true;\n$enable-important-utilities: true;\n\n// Prefix for :root CSS variables\n\n$variable-prefix: bs-;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, 0.15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control th styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * 0.25,\n  2: $spacer * 0.5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%,\n);\n\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg: #f8f8fb;\n$body-color: $gray-700;\n$body-text-align: null;\n\n// Utilities maps\n//\n// Extends the default `$theme-colors` maps to help create our utilities.\n\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\n// scss-docs-start utilities-colors\n$utilities-colors: $theme-colors-rgb;\n// scss-docs-end utilities-colors\n\n// scss-docs-start utilities-text-colors\n$utilities-text: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-color),\n  )\n);\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\");\n// scss-docs-end utilities-text-colors\n\n// scss-docs-start utilities-bg-colors\n$utilities-bg: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-bg),\n  )\n);\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\");\n// scss-docs-end utilities-bg-colors\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $primary;\n$link-decoration: none;\n$link-shade-percentage: 20%;\n$link-hover-color: shift-color($link-color, $link-shade-percentage);\n$link-hover-decoration: underline;\n\n$stretched-link-pseudo-element: after;\n$stretched-link-z-index: 1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom: 1rem;\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px,\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px,\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns: 12;\n$grid-gutter-width: 24px;\n$grid-row-columns: 6;\n\n$gutters: $spacers;\n\n// Container padding\n\n$container-padding-x: calc($grid-gutter-width / 2);\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width: 1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px,\n);\n\n$border-color: $gray-200;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius: 0.25rem;\n$border-radius-lg: 0.4rem;\n$border-radius-sm: 0.2rem;\n$border-radius-pill: 50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow-sm: 0 0.125rem 0.25rem rgba($black, 0.075);\n$box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);\n$box-shadow-lg: 0 1rem 3rem rgba($black, 0.175);\n$box-shadow-inset: inset 0 1px 2px rgba($black, 0.075);\n// scss-docs-end box-shadow-variables\n\n$component-active-color: $white;\n$component-active-bg: $primary;\n\n// scss-docs-start caret-variables\n$caret-width: 0.3em;\n$caret-vertical-align: $caret-width * 0.85;\n$caret-spacing: $caret-width * 0.85;\n// scss-docs-end caret-variables\n\n$transition-base: all 0.2s ease-in-out;\n$transition-fade: opacity 0.15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse: height 0.35s ease;\n$transition-collapse-width: width 0.35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%),\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: \"Poppins\", sans-serif;\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,\n  \"Liberation Mono\", \"Courier New\", monospace;\n\n// stylelint-enable value-keyword-case\n$font-family-base: var(--#{$variable-prefix}font-sans-serif);\n$font-family-code: var(--#{$variable-prefix}font-monospace);\n\n// $font-size-root effects the value of `rem`, which is used for as well font sizes, paddings and margins\n// $font-size-base effects the font size of the body text\n$font-size-root: null;\n$font-size-base: 0.8125rem;\n$font-size-sm: $font-size-base * 0.875;\n$font-size-lg: $font-size-base * 1.25;\n\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-bold: 600;\n$font-weight-bolder: bolder;\n\n$font-weight-base: $font-weight-normal;\n$line-height-base: 1.5;\n$line-height-sm: 1.25;\n$line-height-lg: 2;\n\n$h1-font-size: $font-size-base * 2.5;\n$h2-font-size: $font-size-base * 2;\n$h3-font-size: $font-size-base * 1.75;\n$h4-font-size: $font-size-base * 1.5;\n$h5-font-size: $font-size-base * 1.25;\n$h6-font-size: $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size,\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom: calc($spacer / 2);\n$headings-font-family: null;\n$headings-font-style: null;\n$headings-font-weight: 500;\n$headings-line-height: 1.2;\n$headings-color: null;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 6rem,\n  2: 5.5rem,\n  3: 4.5rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem,\n);\n\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size: $font-size-base * 1.25;\n$lead-font-weight: 300;\n\n$small-font-size: 80%;\n\n$sub-sup-font-size: 0.75em;\n$text-muted: $gray-600;\n\n$initialism-font-size: $small-font-size;\n\n$blockquote-margin-y: $spacer;\n$blockquote-font-size: $font-size-base * 1.25;\n$blockquote-footer-color: $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y: $spacer;\n$hr-color: inherit;\n$hr-height: $border-width;\n$hr-opacity: 0.2;\n\n$legend-margin-bottom: 0.5rem;\n$legend-font-size: 1.5rem;\n$legend-font-weight: null;\n\n$mark-padding: 0.2em;\n\n$dt-font-weight: $font-weight-bold;\n\n$nested-kbd-font-weight: $font-weight-bold;\n\n$list-inline-padding: 0.5rem;\n\n$mark-bg: #fcf8e3;\n// scss-docs-end type-variables\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y: 0.75rem;\n$table-cell-padding-x: 0.75rem;\n$table-cell-padding-y-sm: 0.3rem;\n$table-cell-padding-x-sm: 0.3rem;\n\n$table-cell-vertical-align: top;\n\n$table-color: $body-color;\n$table-bg: null;\n$table-accent-bg: transparent;\n\n$table-th-font-weight: null;\n\n$table-striped-color: $table-color;\n$table-striped-bg-factor: 0.05;\n$table-striped-bg: $gray-100;\n\n$table-active-color: $table-color;\n$table-active-bg-factor: 0.1;\n$table-active-bg: $gray-100;\n\n$table-hover-color: $table-color;\n$table-hover-bg-factor: 0.075;\n$table-hover-bg: $gray-100;\n\n$table-border-factor: 0.1;\n$table-border-width: $border-width;\n$table-border-color: $border-color;\n\n$table-striped-order: odd;\n$table-group-separator-color: $border-color;\n\n$table-caption-color: $text-muted;\n\n$table-bg-scale: -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\": shift-color($primary, $table-bg-scale),\n  \"secondary\": shift-color($secondary, $table-bg-scale),\n  \"success\": shift-color($success, $table-bg-scale),\n  \"info\": shift-color($info, $table-bg-scale),\n  \"warning\": shift-color($warning, $table-bg-scale),\n  \"danger\": shift-color($danger, $table-bg-scale),\n  \"light\": $light,\n  \"dark\": $dark,\n);\n// scss-docs-end table-loop\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y: 0.47rem;\n$input-btn-padding-x: 0.75rem;\n$input-btn-font-family: null;\n$input-btn-font-size: $font-size-base;\n$input-btn-line-height: $line-height-base;\n\n$input-btn-focus-width: 0.15rem;\n$input-btn-focus-color-opacity: 0.25;\n$input-btn-focus-color: rgba(\n  $component-active-bg,\n  $input-btn-focus-color-opacity\n);\n$input-btn-focus-blur: 0;\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm: 0.25rem;\n$input-btn-padding-x-sm: 0.5rem;\n$input-btn-font-size-sm: $font-size-sm;\n\n$input-btn-padding-y-lg: 0.5rem;\n$input-btn-padding-x-lg: 1rem;\n$input-btn-font-size-lg: $font-size-lg;\n\n$input-btn-border-width: $border-width;\n// scss-docs-end input-btn-variables\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y: $input-btn-padding-y;\n$btn-padding-x: $input-btn-padding-x;\n$btn-font-family: $input-btn-font-family;\n$btn-font-size: $input-btn-font-size;\n$btn-line-height: $input-btn-line-height;\n$btn-white-space: null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm: $input-btn-padding-y-sm;\n$btn-padding-x-sm: $input-btn-padding-x-sm;\n$btn-font-size-sm: $input-btn-font-size-sm;\n\n$btn-padding-y-lg: $input-btn-padding-y-lg;\n$btn-padding-x-lg: $input-btn-padding-x-lg;\n$btn-font-size-lg: $input-btn-font-size-lg;\n\n$btn-border-width: $input-btn-border-width;\n\n$btn-font-weight: $font-weight-normal;\n$btn-box-shadow: inset 0 1px 0 rgba($white, 0.15), 0 1px 1px rgba($black, 0.075);\n$btn-focus-width: $input-btn-focus-width;\n$btn-focus-box-shadow: $input-btn-focus-box-shadow;\n$btn-disabled-opacity: 0.65;\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, 0.125);\n\n$btn-link-color: $link-color;\n$btn-link-hover-color: $link-hover-color;\n$btn-link-disabled-color: $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius: $border-radius;\n$btn-border-radius-sm: $border-radius-sm;\n$btn-border-radius-lg: $border-radius-lg;\n\n$btn-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n$btn-hover-bg-shade-amount: 15%;\n$btn-hover-bg-tint-amount: 15%;\n$btn-hover-border-shade-amount: 20%;\n$btn-hover-border-tint-amount: 10%;\n$btn-active-bg-shade-amount: 20%;\n$btn-active-bg-tint-amount: 20%;\n$btn-active-border-shade-amount: 25%;\n$btn-active-border-tint-amount: 10%;\n// scss-docs-end btn-variables\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top: 0.25rem;\n$form-text-font-size: $small-font-size;\n$form-text-font-style: null;\n$form-text-font-weight: null;\n$form-text-color: $text-muted;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom: 0.5rem;\n$form-label-font-size: null;\n$form-label-font-style: null;\n$form-label-font-weight: null;\n$form-label-color: null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y: $input-btn-padding-y;\n$input-padding-x: $input-btn-padding-x;\n$input-font-family: $input-btn-font-family;\n$input-font-size: $input-btn-font-size;\n$input-font-weight: $font-weight-base;\n$input-line-height: $input-btn-line-height;\n\n$input-padding-y-sm: $input-btn-padding-y-sm;\n$input-padding-x-sm: $input-btn-padding-x-sm;\n$input-font-size-sm: $input-btn-font-size-sm;\n\n$input-padding-y-lg: $input-btn-padding-y-lg;\n$input-padding-x-lg: $input-btn-padding-x-lg;\n$input-font-size-lg: $input-btn-font-size-lg;\n\n$input-bg: $white;\n$input-disabled-bg: $gray-200;\n$input-disabled-border-color: null;\n\n$input-color: $gray-700;\n$input-border-color: $gray-400;\n$input-border-width: $input-btn-border-width;\n$input-box-shadow: $box-shadow-inset;\n\n$input-border-radius: $border-radius;\n$input-border-radius-lg: $border-radius-lg;\n$input-border-radius-sm: $border-radius-sm;\n\n$input-focus-bg: $input-bg;\n$input-focus-border-color: shade-color($input-border-color, 10%);\n$input-focus-color: $input-color;\n$input-focus-width: $input-btn-focus-width;\n$input-focus-box-shadow: none;\n\n$input-placeholder-color: $gray-600;\n$input-plaintext-color: $body-color;\n\n$input-height-border: $input-border-width * 2;\n\n$input-height-inner: add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half: add($input-line-height * 0.5em, $input-padding-y);\n$input-height-inner-quarter: add(\n  $input-line-height * 0.25em,\n  calc($input-padding-y / 2)\n);\n\n$input-height: add(\n  $input-line-height * 1em,\n  add($input-padding-y * 2, $input-height-border, false)\n);\n$input-height-sm: add(\n  $input-line-height * 1em,\n  add($input-padding-y-sm * 2, $input-height-border, false)\n);\n$input-height-lg: add(\n  $input-line-height * 1em,\n  add($input-padding-y-lg * 2, $input-height-border, false)\n);\n\n$input-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n$form-color-width: 3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width: 1em;\n$form-check-min-height: $font-size-base * $line-height-base;\n$form-check-padding-start: $form-check-input-width + 0.5em;\n$form-check-margin-bottom: 0.125rem;\n$form-check-label-color: null;\n$form-check-label-cursor: null;\n$form-check-transition: background-color 0.15s ease-in-out,\n  background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$form-check-input-active-filter: brightness(90%);\n\n$form-check-input-bg: $card-bg;\n$form-check-input-border: 1px solid rgba(0, 0, 0, 0.25);\n$form-check-input-border-radius: 0.25em;\n$form-check-radio-border-radius: 50%;\n$form-check-input-focus-border: $input-focus-border-color;\n$form-check-input-focus-box-shadow: $input-btn-focus-box-shadow;\n\n$form-check-input-checked-color: $component-active-color;\n$form-check-input-checked-bg-color: $component-active-bg;\n$form-check-input-checked-border-color: $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color: $component-active-color;\n$form-check-input-indeterminate-bg-color: $component-active-bg;\n$form-check-input-indeterminate-border-color: $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity: 0.5;\n$form-check-label-disabled-opacity: $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity: $btn-disabled-opacity;\n\n$form-check-inline-margin-end: 1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color: rgba(0, 0, 0, 0.25);\n$form-switch-width: 2em;\n$form-switch-padding-start: $form-switch-width + 0.5em;\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius: $form-switch-width;\n$form-switch-transition: background-position 0.15s ease-in-out;\n\n$form-switch-focus-color: $input-focus-border-color;\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color: $component-active-color;\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y: $input-padding-y;\n$input-group-addon-padding-x: $input-padding-x;\n$input-group-addon-font-weight: $input-font-weight;\n$input-group-addon-color: $input-color;\n$input-group-addon-bg: $gray-200;\n$input-group-addon-border-color: $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y: $input-padding-y;\n$form-select-padding-x: $input-padding-x;\n$form-select-font-family: $input-font-family;\n$form-select-font-size: $input-font-size;\n$form-select-indicator-padding: 1.75rem; // Extra padding to account for the presence of the background-image based indicator\n$form-select-font-weight: $input-font-weight;\n$form-select-line-height: $input-line-height;\n$form-select-color: $input-color;\n$form-select-disabled-color: $gray-600;\n$form-select-bg: $input-bg;\n$form-select-disabled-bg: $gray-200;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position: right $form-select-padding-x center;\n$form-select-bg-size: 16px 12px; // In pixels because image dimensions\n$form-select-indicator-color: $gray-800;\n$form-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: add(\n  1em * 0.75,\n  (2 * $form-select-padding-y * 0.75) + $form-select-padding-x +\n    $form-select-indicator-padding\n);\n$form-select-feedback-icon-position: center right\n  ($form-select-padding-x + $form-select-indicator-padding);\n$form-select-feedback-icon-size: $input-height-inner-half\n  $input-height-inner-half;\n\n$form-select-border-width: $input-border-width;\n$form-select-border-color: $input-border-color;\n$form-select-border-radius: $border-radius;\n$form-select-box-shadow: $box-shadow-inset;\n\n$form-select-focus-border-color: $input-focus-border-color;\n$form-select-focus-width: $input-focus-width;\n$form-select-focus-box-shadow: 0 0 0 $form-select-focus-width\n  $input-btn-focus-color;\n\n$form-select-padding-y-sm: $input-padding-y-sm;\n$form-select-padding-x-sm: $input-padding-x-sm;\n$form-select-font-size-sm: $input-font-size-sm;\n\n$form-select-padding-y-lg: $input-padding-y-lg;\n$form-select-padding-x-lg: $input-padding-x-lg;\n$form-select-font-size-lg: $input-font-size-lg;\n\n$form-select-transition: $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width: 100%;\n$form-range-track-height: 0.5rem;\n$form-range-track-cursor: pointer;\n$form-range-track-bg: $gray-300;\n$form-range-track-border-radius: 1rem;\n$form-range-track-box-shadow: $box-shadow-inset;\n\n$form-range-thumb-width: 1rem;\n$form-range-thumb-height: $form-range-thumb-width;\n$form-range-thumb-bg: $component-active-bg;\n$form-range-thumb-border: 0;\n$form-range-thumb-border-radius: 1rem;\n$form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba($black, 0.1);\n$form-range-thumb-focus-box-shadow: 0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width: $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg: tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg: $gray-500;\n$form-range-thumb-transition: background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color: $input-color;\n$form-file-button-bg: $input-group-addon-bg;\n$form-file-button-hover-bg: shade-color($form-file-button-bg, 5%);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height: add(3.5rem, $input-height-border);\n$form-floating-line-height: 1.25;\n$form-floating-padding-x: $input-padding-x;\n$form-floating-padding-y: 1rem;\n$form-floating-input-padding-t: 1.625rem;\n$form-floating-input-padding-b: 0.625rem;\n$form-floating-label-opacity: 0.65;\n$form-floating-label-transform: scale(0.85) translateY(-0.5rem)\n  translateX(0.15rem);\n$form-floating-transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top: $form-text-margin-top;\n$form-feedback-font-size: $form-text-font-size;\n$form-feedback-font-style: $form-text-font-style;\n$form-feedback-valid-color: $success;\n$form-feedback-invalid-color: $danger;\n\n$form-feedback-icon-valid-color: $form-feedback-valid-color;\n$form-feedback-icon-valid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color: $form-feedback-invalid-color;\n$form-feedback-icon-invalid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid,\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid,\n  ),\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown: 1000;\n$zindex-sticky: 1020;\n$zindex-fixed: 1030;\n$zindex-offcanvas-backdrop: 1040;\n$zindex-offcanvas: 1045;\n$zindex-modal-backdrop: 1050;\n$zindex-modal: 1055;\n$zindex-popover: 1070;\n$zindex-tooltip: 1080;\n// scss-docs-end zindex-stack\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y: 0.5rem;\n$nav-link-padding-x: 1rem;\n$nav-link-font-size: null;\n$nav-link-font-weight: null;\n$nav-link-color: null;\n$nav-link-hover-color: null;\n$nav-link-transition: color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n$nav-link-disabled-color: $gray-600;\n\n$nav-tabs-border-color: $gray-400;\n$nav-tabs-border-width: $border-width;\n$nav-tabs-border-radius: $border-radius;\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color;\n$nav-tabs-link-active-color: $gray-700;\n$nav-tabs-link-active-bg: $card-bg;\n$nav-tabs-link-active-border-color: $gray-400 $gray-400 $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius: $border-radius;\n$nav-pills-link-active-color: $component-active-color;\n$nav-pills-link-active-bg: $component-active-bg;\n// scss-docs-end nav-variables\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y: calc($spacer / 2);\n$navbar-padding-x: null;\n\n$navbar-nav-link-padding-x: 0.5rem;\n\n$navbar-brand-font-size: $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y: calc(($nav-link-height - $navbar-brand-height) / 2);\n$navbar-brand-margin-end: 1rem;\n\n$navbar-toggler-padding-y: 0.25rem;\n$navbar-toggler-padding-x: 0.75rem;\n$navbar-toggler-font-size: $font-size-lg;\n$navbar-toggler-border-radius: $btn-border-radius;\n$navbar-toggler-focus-width: $btn-focus-width;\n$navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color: rgba($white, 0.55);\n$navbar-dark-hover-color: rgba($white, 0.75);\n$navbar-dark-active-color: $white;\n$navbar-dark-disabled-color: rgba($white, 0.25);\n$navbar-dark-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color: rgba($white, 0.1);\n\n$navbar-light-color: rgba($black, 0.55);\n$navbar-light-hover-color: rgba($black, 0.7);\n$navbar-light-active-color: rgba($black, 0.9);\n$navbar-light-disabled-color: rgba($black, 0.3);\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, 0.1);\n\n$navbar-light-brand-color: $navbar-light-active-color;\n$navbar-light-brand-hover-color: $navbar-light-active-color;\n$navbar-dark-brand-color: $navbar-dark-active-color;\n$navbar-dark-brand-hover-color: $navbar-dark-active-color;\n// scss-docs-end navbar-theme-variables\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width: 10rem;\n$dropdown-padding-x: 0;\n$dropdown-padding-y: 0.5rem;\n$dropdown-spacer: 0.125rem;\n$dropdown-font-size: $font-size-base;\n$dropdown-color: $body-color;\n$dropdown-bg: $white;\n$dropdown-border-color: rgba($black, 0.15);\n$dropdown-border-radius: $border-radius;\n$dropdown-border-width: 0;\n$dropdown-inner-border-radius: calc(\n  #{$dropdown-border-radius} - #{$dropdown-border-width}\n);\n$dropdown-divider-bg: $gray-200;\n$dropdown-divider-margin-y: calc($spacer / 2);\n$dropdown-box-shadow: $box-shadow;\n\n$dropdown-link-color: $gray-900;\n$dropdown-link-hover-color: shade-color($gray-900, 10%);\n$dropdown-link-hover-bg: $gray-100;\n\n$dropdown-link-active-color: $dark;\n$dropdown-link-active-bg: $gray-100;\n\n$dropdown-link-disabled-color: $gray-600;\n\n$dropdown-item-padding-y: 0.35rem;\n$dropdown-item-padding-x: 1.5rem;\n\n$dropdown-header-color: $gray-600;\n$dropdown-header-padding: $dropdown-padding-y $dropdown-item-padding-x;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color: $gray-300;\n$dropdown-dark-bg: $gray-800;\n$dropdown-dark-border-color: $dropdown-border-color;\n$dropdown-dark-divider-bg: $dropdown-divider-bg;\n$dropdown-dark-box-shadow: null;\n$dropdown-dark-link-color: $dropdown-dark-color;\n$dropdown-dark-link-hover-color: $white;\n$dropdown-dark-link-hover-bg: rgba($white, 0.15);\n$dropdown-dark-link-active-color: $dropdown-link-active-color;\n$dropdown-dark-link-active-bg: $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color: $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y: 0.5rem;\n$pagination-padding-x: 0.75rem;\n$pagination-padding-y-sm: 0.25rem;\n$pagination-padding-x-sm: 0.5rem;\n$pagination-padding-y-lg: 0.75rem;\n$pagination-padding-x-lg: 1.5rem;\n\n$pagination-color: $gray-600;\n$pagination-bg: $white;\n$pagination-border-width: $border-width;\n$pagination-border-radius: $border-radius;\n$pagination-margin-start: -$pagination-border-width;\n$pagination-border-color: $gray-400;\n\n$pagination-focus-color: $link-hover-color;\n$pagination-focus-bg: $gray-200;\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow;\n$pagination-focus-outline: 0;\n\n$pagination-hover-color: $link-hover-color;\n$pagination-hover-bg: $gray-200;\n$pagination-hover-border-color: $gray-400;\n\n$pagination-active-color: $component-active-color;\n$pagination-active-bg: $component-active-bg;\n$pagination-active-border-color: $pagination-active-bg;\n\n$pagination-disabled-color: $gray-400;\n$pagination-disabled-bg: $white;\n$pagination-disabled-border-color: $gray-400;\n\n$pagination-transition: color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$pagination-border-radius-sm: $border-radius-sm;\n$pagination-border-radius-lg: $border-radius-lg;\n// scss-docs-end pagination-variables\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max: 0.5;\n$placeholder-opacity-min: 0.2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y: 1.25rem;\n$card-spacer-x: 1.25rem;\n$card-title-spacer-y: calc($spacer / 2);\n$card-border-width: 0;\n$card-box-shadow: null;\n$card-border-radius: $border-radius;\n$card-border-color: $gray-300;\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width});\n$card-cap-padding-y: calc($card-spacer-y / 2);\n$card-cap-padding-x: $card-spacer-x;\n$card-cap-bg: rgba($black, 0.03);\n$card-cap-color: null;\n$card-height: null;\n$card-color: null;\n$card-bg: $white;\n$card-img-overlay-padding: $spacer;\n\n$card-title-desc: $gray-600;\n\n$card-group-margin: calc($grid-gutter-width / 2);\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y: 1rem;\n$accordion-padding-x: 1.25rem;\n$accordion-color: $body-color;\n$accordion-bg: transparent;\n$accordion-border-width: $border-width;\n$accordion-border-color: rgba($black, 0.125);\n$accordion-border-radius: $border-radius;\n$accordion-inner-border-radius: subtract(\n  $accordion-border-radius,\n  $accordion-border-width\n);\n\n$accordion-body-padding-y: $accordion-padding-y;\n$accordion-body-padding-x: $accordion-padding-x;\n\n$accordion-button-padding-y: $accordion-padding-y;\n$accordion-button-padding-x: $accordion-padding-x;\n$accordion-button-color: $accordion-color;\n$accordion-button-bg: $accordion-bg;\n$accordion-transition: $btn-transition, border-radius 0.15s ease;\n$accordion-button-active-bg: tint-color($component-active-bg, 90%);\n$accordion-button-active-color: shade-color($primary, 10%);\n\n$accordion-button-focus-border-color: $input-focus-border-color;\n$accordion-button-focus-box-shadow: none;\n\n$accordion-icon-width: 16px;\n$accordion-icon-color: $accordion-color;\n$accordion-icon-active-color: $accordion-button-active-color;\n$accordion-icon-transition: transform 0.2s ease-in-out;\n$accordion-icon-transform: rotate(180deg);\n\n$accordion-button-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size: $font-size-sm;\n$tooltip-max-width: 200px;\n$tooltip-color: $white;\n$tooltip-bg: $black;\n$tooltip-border-radius: $border-radius;\n$tooltip-opacity: 0.9;\n$tooltip-padding-y: 0.4rem;\n$tooltip-padding-x: 0.7rem;\n$tooltip-margin: 0;\n\n$tooltip-arrow-width: 0.8rem;\n$tooltip-arrow-height: 0.4rem;\n$tooltip-arrow-color: $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y: $tooltip-padding-y;\n$form-feedback-tooltip-padding-x: $tooltip-padding-x;\n$form-feedback-tooltip-font-size: $tooltip-font-size;\n$form-feedback-tooltip-line-height: $line-height-base;\n$form-feedback-tooltip-opacity: $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size: $font-size-sm;\n$popover-bg: $white;\n$popover-max-width: 276px;\n$popover-border-width: $border-width;\n$popover-border-color: $gray-300;\n$popover-border-radius: $border-radius-lg;\n$popover-inner-border-radius: subtract(\n  $popover-border-radius,\n  $popover-border-width\n);\n$popover-box-shadow: 0 0.25rem 0.5rem rgba($black, 0.2);\n\n$popover-header-bg: shade-color($popover-bg, 4%);\n$popover-header-color: $headings-color;\n$popover-header-padding-y: 0.5rem;\n$popover-header-padding-x: $spacer;\n\n$popover-body-color: $body-color;\n$popover-body-padding-y: $spacer;\n$popover-body-padding-x: $spacer;\n\n$popover-arrow-width: 1rem;\n$popover-arrow-height: 0.5rem;\n$popover-arrow-color: $popover-bg;\n\n$popover-arrow-outer-color: fade-in($popover-border-color, 0.05);\n// scss-docs-end popover-variables\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width: 350px;\n$toast-padding-x: 0.75rem;\n$toast-padding-y: 0.25rem;\n$toast-font-size: 0.875rem;\n$toast-color: null;\n$toast-background-color: rgba($white, 0.85);\n$toast-border-width: 1px;\n$toast-border-color: rgba(0, 0, 0, 0.1);\n$toast-border-radius: 0.25rem;\n$toast-box-shadow: $box-shadow;\n$toast-spacing: $container-padding-x;\n\n$toast-header-color: $gray-600;\n$toast-header-background-color: rgba($white, 0.85);\n$toast-header-border-color: rgba(0, 0, 0, 0.05);\n// scss-docs-end toast-variables\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size: 75%;\n$badge-font-weight: $fw-medium;\n$badge-color: $white;\n$badge-padding-y: 0.25em;\n$badge-padding-x: 0.4em;\n$badge-border-radius: $border-radius;\n// scss-docs-end badge-variables\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding: 1rem;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between: 0.5rem;\n$modal-dialog-margin: 0.5rem;\n$modal-dialog-margin-y-sm-up: 1.75rem;\n\n$modal-title-line-height: $line-height-base;\n\n$modal-content-color: null;\n$modal-content-bg: $white;\n$modal-content-border-color: $gray-300;\n$modal-content-border-width: $border-width;\n$modal-content-border-radius: $border-radius-lg;\n$modal-content-inner-border-radius: subtract(\n  $modal-content-border-radius,\n  $modal-content-border-width\n);\n$modal-content-box-shadow-xs: $box-shadow-sm;\n$modal-content-box-shadow-sm-up: $box-shadow;\n\n$modal-backdrop-bg: $black;\n$modal-backdrop-opacity: 0.5;\n$modal-header-border-color: $border-color;\n$modal-footer-border-color: $modal-header-border-color;\n$modal-header-border-width: $modal-content-border-width;\n$modal-footer-border-width: $modal-header-border-width;\n$modal-header-padding-y: $modal-inner-padding;\n$modal-header-padding-x: $modal-inner-padding;\n$modal-header-padding: $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-sm: 300px;\n$modal-md: 500px;\n$modal-lg: 800px;\n$modal-xl: 1140px;\n\n$modal-fade-transform: translate(0, -50px);\n$modal-show-transform: none;\n$modal-transition: transform 0.3s ease-out;\n$modal-scale-transform: scale(1.02);\n// scss-docs-end modal-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y: 0.75rem;\n$alert-padding-x: 1.25rem;\n$alert-margin-bottom: 1rem;\n$alert-border-radius: $border-radius;\n$alert-link-font-weight: $font-weight-bold;\n$alert-border-width: $border-width;\n\n$alert-bg-scale: -80%;\n$alert-border-scale: -70%;\n$alert-color-scale: 40%;\n\n$alert-dismissible-padding-r: $alert-padding-x * 3; // 3x covers width of x plu padding on either side\n// scss-docs-end alert-variables\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height: 0.625rem;\n$progress-font-size: $font-size-base * 0.75;\n$progress-bg: $gray-300;\n$progress-border-radius: $border-radius;\n$progress-box-shadow: $box-shadow-inset;\n$progress-bar-color: $white;\n$progress-bar-bg: $primary;\n$progress-bar-animation-timing: 1s linear infinite;\n$progress-bar-transition: width 0.6s ease;\n// scss-docs-end progress-variables\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color: null;\n$list-group-bg: $white;\n$list-group-border-color: $border-color;\n$list-group-border-width: $border-width;\n$list-group-border-radius: $border-radius;\n\n$list-group-item-padding-y: 0.75rem;\n$list-group-item-padding-x: 1.25rem;\n$list-group-item-bg-scale: -80%;\n$list-group-item-color-scale: 40%;\n\n$list-group-hover-bg: $gray-100;\n$list-group-active-color: $component-active-color;\n$list-group-active-bg: $component-active-bg;\n$list-group-active-border-color: $list-group-active-bg;\n\n$list-group-disabled-color: $gray-600;\n$list-group-disabled-bg: $list-group-bg;\n\n$list-group-action-color: $gray-700;\n$list-group-action-hover-color: $list-group-action-color;\n\n$list-group-action-active-color: $body-color;\n$list-group-action-active-bg: $gray-200;\n// scss-docs-end list-group-variables\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding: 0.25rem;\n$thumbnail-bg: $body-bg;\n$thumbnail-border-width: $border-width;\n$thumbnail-border-color: $gray-300;\n$thumbnail-border-radius: $border-radius;\n$thumbnail-box-shadow: $box-shadow-sm;\n// scss-docs-end thumbnail-variables\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size: $small-font-size;\n$figure-caption-color: $gray-600;\n// scss-docs-end figure-variables\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size: null;\n$breadcrumb-padding-y: 0.75rem;\n$breadcrumb-padding-x: 1rem;\n$breadcrumb-item-padding-x: 0.5rem;\n\n$breadcrumb-margin-bottom: 1rem;\n\n$breadcrumb-bg: null;\n$breadcrumb-divider-color: $gray-600;\n$breadcrumb-active-color: $gray-600;\n$breadcrumb-divider: quote(\"/\");\n$breadcrumb-divider-flipped: $breadcrumb-divider;\n$breadcrumb-border-radius: null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color: $white;\n$carousel-control-width: 15%;\n$carousel-control-opacity: 0.5;\n$carousel-control-hover-opacity: 0.9;\n$carousel-control-transition: opacity 0.15s ease;\n\n$carousel-indicator-width: 30px;\n$carousel-indicator-height: 3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer: 3px;\n$carousel-indicator-opacity: 0.5;\n$carousel-indicator-active-bg: $white;\n$carousel-indicator-active-opacity: 1;\n$carousel-indicator-transition: opacity 0.6s ease;\n\n$carousel-caption-width: 70%;\n$carousel-caption-color: $white;\n$carousel-caption-padding-y: 1.25rem;\n$carousel-caption-spacer: 1.25rem;\n\n$carousel-control-icon-width: 2rem;\n\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration: 0.6s;\n$carousel-transition: transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg: $black;\n$carousel-dark-caption-color: $black;\n$carousel-dark-control-icon-filter: invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width: 2rem;\n$spinner-height: $spinner-width;\n$spinner-vertical-align: -0.125em;\n$spinner-border-width: 0.25em;\n$spinner-animation-speed: 0.75s;\n\n$spinner-width-sm: 1rem;\n$spinner-height-sm: $spinner-width-sm;\n$spinner-border-width-sm: 0.2em;\n// scss-docs-end spinner-variables\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width: 1em;\n$btn-close-height: $btn-close-width;\n$btn-close-padding-x: 0.25em;\n$btn-close-padding-y: $btn-close-padding-x;\n$btn-close-color: $black;\n$btn-close-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-bg-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$black}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow: none;\n$btn-close-opacity: 0.5;\n$btn-close-hover-opacity: 0.75;\n$btn-close-focus-opacity: 1;\n$btn-close-disabled-opacity: 0.25;\n$btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y: $modal-inner-padding;\n$offcanvas-padding-x: $modal-inner-padding;\n$offcanvas-horizontal-width: 400px;\n$offcanvas-vertical-height: 30vh;\n$offcanvas-transition-duration: 0.3s;\n$offcanvas-border-color: $modal-content-border-color;\n$offcanvas-border-width: $modal-content-border-width;\n$offcanvas-title-line-height: $modal-title-line-height;\n$offcanvas-bg-color: $modal-content-bg;\n$offcanvas-color: $modal-content-color;\n$offcanvas-box-shadow: $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg: $modal-backdrop-bg;\n$offcanvas-backdrop-opacity: $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size: 87.5%;\n$code-color: $pink;\n\n$kbd-padding-y: 0.2rem;\n$kbd-padding-x: 0.4rem;\n$kbd-font-size: $code-font-size;\n$kbd-color: $white;\n$kbd-bg: $gray-900;\n\n$pre-color: $gray-900;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/* =============\n   General\n============= */\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\n.h1,.h2,.h3,.h4,.h5,.h6,\nh1,h2,h3,h4,h5,h6 {\n  color: $gray-700;\n}\n\na {\n  text-decoration: none !important;\n}\n\nlabel {\n  font-weight: 500;\n  margin-bottom: $form-label-margin-bottom;\n}\n\n// blockquote\n\n.blockquote {\n  padding: 10px 20px;\n  border-left: 4px solid $gray-300;\n}\n\n.blockquote-reverse {\n  border-left: 0;\n  border-right: 4px solid $gray-300;\n  text-align: right;\n}\n\n// container\n\n.container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl{\n  @media (min-width: 1200px){\n      max-width: 1140px;\n  }\n}\n\n// row\n\n.row{\n  > * {\n      position: relative;\n  }\n}\n","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-#{$color} {\n        &.bg-soft{\n            background-color: rgba(($value), 0.25) !important;\n        }\n    }\n}\n","// \n// _badge.scss\n// \n\n\n.badge {\n  &[href] {\n    &:hover,\n    &:focus {\n      color: $white;\n    }\n  }\n}\n\n// Soft badge\n@mixin badge-variant-soft($bg) {\n  color: $bg;\n  background-color: rgba($bg, 0.18);\n\n  &[href] {\n    &:hover,\n    &:focus {\n      color: $bg;\n      text-decoration: none;\n      background-color: rgba($bg, 0.4);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .badge {\n  &.bg-#{$color} {\n    &[href] {\n      &:hover,\n      &:focus {\n        background-color: darken($value, 4%) !important;\n      }\n    }\n  }\n}\n\n.badge{\n  &.bg-light{\n    color: $body-color;\n\n    &[href] {\n      &:hover,\n      &:focus {\n        color: $body-color;\n      }\n    }\n  }\n}\n\n  .badge-soft-#{$color} {\n      @include badge-variant-soft($value);\n  }\n  \n}\n\n.rounded-pill{\n   padding-right: .6em;\n    padding-left: .6em;\n}\n\n// Dark badge\n\n.badge.bg-dark{\n  color: $light;\n}","// \n// _buttons.scss\n// \n\nbutton,a {\n  outline: none !important;\n}\n\n\n// Rounded Buttons\n.btn-rounded {\n  border-radius: 30px;\n}\n\n.btn-dark, .btn-secondary{\n  color: $gray-200 !important;\n}\n\n.btn-outline-light{\n  color: $gray-900;\n}\n\n.btn-outline-dark, .btn-dark{\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle,\n  &:hover{\n    color: $light;\n  }\n}\n\n// example 1\n\n.btn-group-example{\n  .btn{\n    position: relative;\n\n    &:first-child{\n      &::before{\n        display: none;\n      }\n    }\n\n    &:before{\n      content: \"OR\";\n      position: absolute;\n      font-size: 10px;\n      width: 24px;\n      height: 24px;\n      line-height: 24px;\n      border-radius: 50%;\n      background-color: $gray-600;\n      color: $light;\n      border: 1px solid $white;\n      left: -12px;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: 1;\n    }\n  }\n}\n\n\n// Example 2\n\n.btn-label{\n  position: relative;\n  padding-left: 44px;\n  .label-icon{\n    position: absolute;\n    width: 32px;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background-color: rgba($white, 0.1);\n    border-right: 1px solid rgba($white, 0.1);\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &.btn-light{\n    .label-icon{\n      background-color: rgba($dark, 0.1);\n      border-right: 1px solid rgba($dark, 0.2);\n    }\n  }\n}","\n// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: $gray-700;\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n        }\n    }\n}\n  ","//\n// _card.scss\n//\n\n.card {\n  margin-bottom: $grid-gutter-width;\n  // box-shadow: $box-shadow;\n  box-shadow: none;\n  border: 0;\n  background: #fff !important;\n}\n\n.card-drop {\n  color: $body-color;\n}\n\n.card-title {\n  font-size: 15px;\n  margin: 0 0 7px 0;\n  font-weight: $font-weight-semibold;\n}\n\n.card-title-desc {\n  color: $card-title-desc;\n  margin-bottom: 24px;\n}\n","// \n// _dropdown.scss\n// \n\n.dropdown-menu {\n  box-shadow: $box-shadow-lg;\n  animation-name: DropDownSlide;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  margin: 0;\n  position: absolute;\n  z-index: 1000;\n\n  &.show {\n    top: 100%!important;\n  }\n}\n\n.dropdown-menu-end[style] {\n  left: auto!important;\n  right: 0!important;\n}\n\n.dropdown-menu[data-popper-placement^=right],.dropdown-menu[data-popper-placement^=top],.dropdown-menu[data-popper-placement^=left]{\n  top: auto !important;\n  animation: none !important;\n}\n\n.tooltip[x-placement^=\"top\"], .show[x-placement^=\"top\"]:not(.tooltip) {\n  top: auto!important;\n  -webkit-animation: none!important;\n  animation: none!important;\n}\n\n\n@keyframes DropDownSlide {\n  100% {\n      transform: translateY(0)\n  }\n  0% {\n      transform: translateY(10px)\n  }\n}\n\n@media (min-width: 600px) {\n  .dropdown-menu-lg {\n    width: 320px;\n  }\n\n  .dropdown-menu-md {\n    width: 240px;\n  }\n}\n\n.dropdown-divider{\n  border-top-color: $border-color;\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n  position: static!important;\n}\n\n.dropdown-megamenu[style] {\n  padding: 20px;\n  left: 20px !important;\n  right: 20px !important;\n}\n\n// Dropdown size\n\n.dropdown-mega-menu-xl{\n  width: 40rem;\n}\n\n.dropdown-mega-menu-lg{\n  width: 26rem;\n}","// Icon nav\n.icon-tab .nav-link{\n  border: 1px solid #e9e9e9;\n  color: #495057;\n}\n.icon-tab .active.nav-link{\n  background: #556ee6;\n  color: #fff;\n}\n\n.icon-tab li:first-child .nav-link{\n  border-top-left-radius: 21px !important;\n  border-bottom-left-radius: 21px !important;\n}\n.icon-tab li:last-child .nav-link{\n  border-top-right-radius: 21px !important;\n  border-bottom-right-radius: 21px !important;\n}\n.icon-tab .nav-link i,.vertical-icon .nav-link i{\n  padding-right: 3px;\n  font-size: 14px;\n}\n.vertical-icon .active.nav-link{\n  border: 1px solid #556ee6;\n  border-radius: 21px;\n  background: #556ee6;\n  color: #fff;\n}\n.vertical-icon .nav-link{\ncolor: #495057;\n}\n\n// \n// _nav.scss\n// \n\n.nav-tabs,.nav-pills {\n  > li {\n      > a {\n          color: $gray-700;\n          font-weight: $fw-medium;\n      }\n  }\n}\n\n.nav-pills {\n  > a {\n      color: $gray-700;  \n      font-weight: $fw-medium;\n  }\n}\n\n\n.nav-tabs-custom {\n  border-bottom: 2px solid $gray-300;\n\n  .nav-item {\n    position: relative;\n    color: $dark;\n    .nav-link {\n      border: none;\n\n      &::after {\n        content: \"\";\n        background: $primary;\n        height: 2px;\n        position: absolute;\n        width: 100%;\n        left: 0;\n        bottom: -1px;\n        transition: all 250ms ease 0s;\n        transform: scale(0);\n      }\n\n      &.active{\n        color: $primary;\n        &:after{\n          transform: scale(1);\n        }\n      }\n\n    }\n  }\n}\n\n\n// vertical nav\n\n.vertical-nav{\n  .nav{\n      .nav-link{\n          padding: 24px 16px;\n          text-align: center;\n          margin-bottom: 8px;\n          .nav-icon{\n              font-size: 24px;\n          }\n      }\n  }\n}\n\n\n","// \n// _table.scss\n// \n\n.table {\n  th {\n      font-weight: $font-weight-bold;\n  }\n\n  .table-light{\n    color: $body-color;\n    border-color: $table-border-color;\n    background-color: $table-head-bg;\n  }\n}\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n}\n\n\n.table-dark>:not(:last-child)>:last-child>*{\n  border-bottom-color:  $table-dark-border-color;\n}\n\n.table-nowrap {\n  th, td {\n    white-space: nowrap;\n  }\n}\n\n\n","// \n// _pagination.scss\n// \n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px !important;\n        border: none;\n        width: 32px;\n        height: 32px;\n        padding: 0;\n        text-align: center;\n        line-height: 32px;\n    }\n  }","// \n// _progress.scss\n// \n\n// Progress height small\n.progress-sm {\n  height: 5px;\n}\n\n\n// Progress height medium\n.progress-md {\n  height: 8px;\n}\n\n\n// Progress height large\n.progress-lg {\n  height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n  height: 16px;\n}\n\n.custom-progess{\n  position: relative;\n  .progress-icon{\n      position: absolute;\n      top: -12px;\n      .avatar-title{\n        background: $card-bg;\n      }\n  }\n}\n\n// animated-progess\n\n.animated-progess{\n  position: relative;\n  .progress-bar {\n    position: relative;\n    border-radius: 6px;\n    animation: animate-positive 2s;\n  }\n}\n\n@keyframes animate-positive {\n  0% {\n      width: 0;\n  }\n}\n","/*\nFile: Main Css File\n*/\n\n//Fonts\n@import \"custom/fonts/fonts\";\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/mixins.scss\";\n\n// Structure\n@import \"custom/structure/general\";\n@import \"custom/structure/topbar\";\n@import \"custom/structure/page-head\";\n@import \"custom/structure/footer\";\n@import \"custom/structure/right-sidebar\";\n@import \"custom/structure/vertical\";\n@import \"custom/structure/horizontal-nav\";\n@import \"custom/structure/layouts\";\n\n// Components\n@import \"custom/components/waves\";\n@import \"custom/components/avatar\";\n@import \"custom/components/accordion\";\n@import \"custom/components/helper\";\n@import \"custom/components/preloader\";\n@import \"custom/components/forms\";\n@import \"custom/components/widgets\";\n@import \"custom/components/demos\";\n@import \"custom/components/print\";\n\n// Plugins\n@import \"custom/plugins/custom-scrollbar\";\n@import \"custom/plugins/calendar\";\n@import \"custom/plugins/dragula\";\n@import \"custom/plugins/session-timeout\";\n@import \"custom/plugins/range-slider\";\n@import \"custom/plugins/sweatalert2\";\n@import \"custom/plugins/rating\";\n@import \"custom/plugins/toastr\";\n@import \"custom/plugins/parsley\";\n@import \"custom/plugins/select2\";\n\n@import \"custom/plugins/switch\";\n@import \"custom/plugins/colorpicker\";\n@import \"custom/plugins/timepicker\";\n@import \"custom/plugins/datepicker\";\n@import \"custom/plugins/bootstrap-touchspin\";\n@import \"custom/plugins/form-editors\";\n@import \"custom/plugins/form-upload\";\n@import \"custom/plugins/form-wizard\";\n@import \"custom/plugins/datatable\";\n@import \"custom/plugins/responsive-table\";\n@import \"custom/plugins/table-editable\";\n@import \"custom/plugins/apexcharts\";\n@import \"custom/plugins/echarts\";\n@import \"custom/plugins/flot\";\n@import \"custom/plugins/sparkline-chart\";\n@import \"custom/plugins/google-map\";\n@import \"custom/plugins/vector-maps\";\n@import \"custom/plugins/leaflet-maps\";\n\n// Pages\n@import \"custom/pages/authentication\";\n@import \"custom/pages/ecommerce\";\n@import \"custom/pages/email\";\n@import \"custom/pages/file-manager\";\n@import \"custom/pages/chat\";\n@import \"custom/pages/projects\";\n@import \"custom/pages/users\";\n@import \"custom/pages/crypto\";\n@import \"custom/pages/coming-soon\";\n@import \"custom/pages/timeline\";\n@import \"custom/pages/extras-pages\";\n@import \"custom/pages/applied-funding\";\n@import \"custom/pages/createPitch\";\n@import \"custom/pages/investors\";\n@import \"custom/pages/founder-list\";\n@import \"custom/pages/identifiedUsers\";\n@import \"custom/pages/event-report\"\n","//\n// _header.scss\n//\n\n#page-topbar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: $sidebar-width;\n  z-index: 1002;\n  background-color: $header-bg;\n  box-shadow: $box-shadow;\n  @media (max-width: 991.98px) {\n    left: 0;\n  }\n}\n\n.navbar-header {\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 auto;\n  height: $header-height;\n  padding: 0 calc(#{$grid-gutter-width} / 2) 0 0\n    /*rtl: 0 0 0 calc(#{$grid-gutter-width} / 2) */;\n\n  .dropdown {\n    &.show {\n      &.header-item {\n        background-color: $gray-100;\n      }\n    }\n    .dropdown-menu {\n      margin-top: 0;\n    }\n  }\n}\n\n.navbar-brand-box {\n  padding: 0 1.5rem;\n  text-align: center;\n}\n\n.logo {\n  line-height: 70px;\n\n  .logo-sm {\n    display: none;\n  }\n}\n\n.logo-light {\n  display: none;\n}\n\n/* Search */\n\n.app-search {\n  padding: calc(#{$header-height - 38px} / 2) 0;\n\n  .form-control {\n    border: none;\n    height: 38px;\n    padding-left: 40px;\n    padding-right: 20px;\n    background-color: $topbar-search-bg;\n    box-shadow: none;\n    border-radius: 30px;\n  }\n  span {\n    position: absolute;\n    z-index: 10;\n    font-size: 16px;\n    line-height: 38px;\n    left: 13px;\n    top: 0;\n    color: $gray-600;\n  }\n}\n\n// Mega menu\n\n.megamenu-list {\n  li {\n    position: relative;\n    padding: 5px 0px;\n    a {\n      color: $dropdown-color;\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .navbar-brand-box {\n    width: auto;\n  }\n\n  .logo {\n    span.logo-lg {\n      display: none;\n    }\n\n    span.logo-sm {\n      display: inline-block;\n    }\n  }\n}\n\n.page-content {\n  padding: calc(11px + 4px) calc(24px / 2) 60px calc(24px / 2);\n  background: #fff;\n}\n// .page-content {\n//   padding: calc(#{$header-height} + #{$grid-gutter-width})\n//     calc(#{$grid-gutter-width} / 2) $footer-height\n//     calc(#{$grid-gutter-width} / 2);\n//   background: #fff;\n// }\n\n.header-item {\n  height: $header-height;\n  box-shadow: none !important;\n  color: $header-item-color;\n  border: 0;\n  border-radius: 0px;\n  position: relative;\n\n  &:hover {\n    color: $header-item-color;\n  }\n}\n\n.header-profile-user {\n  height: 36px;\n  width: 36px;\n  background-color: $gray-300;\n  padding: 3px;\n}\n\n.noti-icon {\n  i {\n    font-size: 22px;\n    color: $header-item-color;\n  }\n\n  .badge {\n    position: absolute;\n    top: 12px;\n    right: 4px;\n  }\n}\n\n.notification-item {\n  .media {\n    padding: 0.75rem 1rem;\n\n    &:hover {\n      background-color: $gray-300;\n    }\n  }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n  display: block;\n  border-radius: 3px;\n  line-height: 34px;\n  text-align: center;\n  padding: 15px 0 9px;\n  display: block;\n  border: 1px solid transparent;\n  color: $gray-600;\n\n  img {\n    height: 24px;\n  }\n\n  span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    border-color: $border-color;\n  }\n}\n\n// Full Screen\n.fullscreen-enable {\n  [data-toggle=\"fullscreen\"] {\n    .bx-fullscreen::before {\n      content: \"\\ea3f\";\n    }\n  }\n}\n\nbody[data-topbar=\"dark\"] {\n  #page-topbar {\n    background-color: $header-dark-bg;\n  }\n  .navbar-header {\n    .dropdown .show {\n      &.header-item {\n        background-color: rgba($white, 0.05);\n      }\n    }\n\n    .waves-effect .waves-ripple {\n      background: rgba($white, 0.4);\n    }\n  }\n\n  .header-item {\n    color: $header-dark-item-color;\n\n    &:hover {\n      color: $header-dark-item-color;\n    }\n  }\n\n  .header-profile-user {\n    background-color: rgba($white, 0.25);\n  }\n\n  .noti-icon {\n    i {\n      color: $header-dark-item-color;\n    }\n  }\n\n  .logo-dark {\n    display: none;\n  }\n\n  .logo-light {\n    display: block;\n  }\n\n  .app-search {\n    .form-control {\n      background-color: rgba($topbar-search-bg, 0.07);\n      color: $white;\n    }\n    span,\n    input.form-control::-webkit-input-placeholder {\n      color: rgba($white, 0.5);\n    }\n  }\n}\n\nbody[data-sidebar=\"dark\"] {\n  .navbar-brand-box {\n    background: $sidebar-dark-bg;\n  }\n\n  .logo-dark {\n    display: none;\n  }\n\n  .logo-light {\n    display: block;\n  }\n}\n\n@media (max-width: 600px) {\n  .navbar-header {\n    .dropdown {\n      position: static;\n\n      .dropdown-menu {\n        left: 10px !important;\n        right: 10px !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 380px) {\n  .navbar-brand-box {\n    display: none;\n  }\n}\n\nbody[data-layout=\"horizontal\"] {\n  .navbar-brand-box {\n    width: auto;\n  }\n  .page-content {\n    margin-top: $header-height;\n    padding: calc(55px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2)\n      $footer-height calc(#{$grid-gutter-width} / 2);\n  }\n}\n\n@media (max-width: 992px) {\n  body[data-layout=\"horizontal\"] {\n    .page-content {\n      margin-top: 15px;\n    }\n  }\n}\n","//\n// Page-title\n//\n\n.page-title-box {\n  padding-bottom: $grid-gutter-width;\n  background: #fff;\n\n  .breadcrumb {\n    background-color: transparent;\n    padding: 0;\n  }\n\n  h4 {\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 16px !important;\n  }\n}\n","// \n// _footer.scss\n// \n\n.footer {\n    bottom: 0;\n    padding: 20px calc(#{$grid-gutter-width} / 2);\n    position: absolute;\n    right: 0;\n    color: $footer-color;\n    left: 250px;\n    height: $footer-height;\n    background-color: $footer-bg;\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n  \n// Enlarge menu\n.vertical-collpsed {\n    .footer {\n        left: $sidebar-collapsed-width;\n\n        @media (max-width: 991.98px) {\n            left: 0;\n        }\n    }\n}\n\nbody[data-layout=\"horizontal\"] {\n    .footer {\n        left: 0 !important;\n    }  \n}","//\n// right-sidebar.scss\n//\n\n.right-bar {\n  background-color: $card-bg;\n  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n  display: block;\n  position: fixed;\n  transition: all 200ms ease-out;\n  width: $rightbar-width;\n  z-index: 9999;\n  float: right !important;\n  right: -($rightbar-width + 10px);\n  top: 0;\n  bottom: 0;\n\n  .right-bar-toggle {\n    background-color: lighten($dark, 7%);\n    height: 24px;\n    width: 24px;\n    line-height: 24px;\n    display: block;\n    color: $gray-200;\n    text-align: center;\n    border-radius: 50%;\n\n    &:hover {\n      background-color: lighten($dark, 10%);\n    }\n  }\n}\n\n// Rightbar overlay\n.rightbar-overlay {\n  background-color: rgba($dark, 0.55);\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: none;\n  z-index: 9998;\n  transition: all 0.2s ease-out;\n}\n\n.right-bar-enabled {\n  .right-bar {\n    right: 0;\n  }\n  .rightbar-overlay {\n    display: block;\n  }\n}\n\n@include media-breakpoint-down(md) {\n  .right-bar {\n    overflow: auto;\n    .slimscroll-menu {\n      height: auto !important;\n    }\n  }\n}\n\n.react-drawer-drawer {\n  background-color: $card-bg !important;\n}\n","//\n// _menu.scss\n//\n\n.metismenu {\n  margin: 0;\n\n  li {\n    display: block;\n    width: 100%;\n  }\n\n  .mm-collapse {\n    display: none;\n\n    &:not(.mm-show) {\n      display: none;\n    }\n\n    &.mm-show {\n      display: block;\n    }\n  }\n\n  .mm-collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    transition-timing-function: ease;\n    transition-duration: 0.35s;\n    transition-property: height, visibility;\n  }\n}\n\n.vertical-menu {\n  width: $sidebar-width;\n  z-index: 1001;\n  background: $sidebar-bg;\n  bottom: 0;\n  margin-top: 0;\n  position: fixed;\n  top: 0;\n  padding-top: $header-height;\n  box-shadow: $box-shadow;\n  @media (max-width: 991.98px) {\n    top: $header-height;\n    padding-top: 0px;\n  }\n\n  .navbar-brand-box {\n    position: fixed;\n    top: 0px;\n    z-index: 99;\n    @media (max-width: 991.98px) {\n      display: none;\n    }\n  }\n}\n\n.main-content {\n  margin-left: $sidebar-width;\n  overflow: hidden;\n\n  .content {\n    padding: 0 15px 10px 15px;\n    margin-top: $header-height;\n  }\n}\n\n#sidebar-menu {\n  padding: 10px 0 30px 0;\n\n  .mm-active {\n    > .has-arrow {\n      &:after {\n        transform: rotate(-180deg);\n      }\n    }\n  }\n\n  .has-arrow {\n    &:after {\n      content: \"\\F0140\";\n      font-family: \"Material Design Icons\";\n      display: block;\n      float: right;\n      transition: transform 0.2s;\n      font-size: 1rem;\n    }\n  }\n\n  ul {\n    li {\n      a {\n        display: block;\n        padding: 0.625rem 1.5rem;\n        color: $sidebar-menu-item-color;\n        position: relative;\n        font-size: 13px;\n        transition: all 0.4s;\n\n        i {\n          display: inline-block;\n          min-width: 1.75rem;\n          padding-bottom: 0.125em;\n          font-size: 1.25rem;\n          line-height: 1.40625rem;\n          vertical-align: middle;\n          color: $sidebar-menu-item-icon-color;\n          transition: all 0.4s;\n        }\n\n        &:hover {\n          color: $sidebar-menu-item-hover-color;\n\n          i {\n            color: $sidebar-menu-item-hover-color;\n          }\n        }\n      }\n\n      .badge {\n        margin-top: 4px;\n      }\n\n      ul.sub-menu {\n        padding: 0;\n\n        li {\n          a {\n            padding: 0.4rem 1.5rem 0.4rem 3.5rem;\n            font-size: 13px;\n            color: $sidebar-menu-sub-item-color;\n            &:hover {\n              color: $sidebar-menu-item-hover-color;\n            }\n          }\n\n          ul.sub-menu {\n            padding: 0;\n\n            li {\n              a {\n                padding: 0.4rem 1.5rem 0.4rem 4.5rem;\n                font-size: 13px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.menu-title {\n  padding: 12px 20px !important;\n  letter-spacing: 0.05em;\n  pointer-events: none;\n  cursor: default;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: $sidebar-menu-item-icon-color;\n  font-weight: $font-weight-semibold;\n}\n\n.mm-active {\n  color: $sidebar-menu-item-active-color !important;\n  > a {\n    color: $sidebar-menu-item-active-color !important;\n    i {\n      color: $sidebar-menu-item-active-color !important;\n    }\n  }\n  .active {\n    color: $sidebar-menu-item-active-color !important;\n\n    i {\n      color: $sidebar-menu-item-active-color !important;\n    }\n  }\n  > i {\n    color: $sidebar-menu-item-active-color !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .vertical-menu {\n    display: none;\n  }\n\n  .main-content {\n    margin-left: 0 !important;\n  }\n\n  body.sidebar-enable {\n    .vertical-menu {\n      display: block;\n    }\n  }\n}\n\n// Enlarge menu\n.vertical-collpsed {\n  .main-content {\n    margin-left: $sidebar-collapsed-width;\n  }\n\n  .navbar-brand-box {\n    width: $sidebar-collapsed-width !important;\n  }\n\n  #page-topbar {\n    left: $sidebar-collapsed-width;\n    @media (max-width: 991.98px) {\n      left: 0;\n    }\n  }\n\n  .logo {\n    span.logo-lg {\n      display: none;\n    }\n\n    span.logo-sm {\n      display: block;\n    }\n  }\n\n  // Side menu\n  .vertical-menu {\n    position: absolute;\n    width: $sidebar-collapsed-width !important;\n    z-index: 5;\n\n    .simplebar-mask,\n    .simplebar-content-wrapper {\n      overflow: visible !important;\n    }\n\n    .simplebar-scrollbar {\n      display: none !important;\n    }\n\n    .simplebar-offset {\n      bottom: 0 !important;\n    }\n\n    // Sidebar Menu\n    #sidebar-menu {\n      .menu-title,\n      .badge,\n      .collapse.in {\n        display: none !important;\n      }\n\n      .nav.collapse {\n        height: inherit !important;\n      }\n\n      .has-arrow {\n        &:after {\n          display: none;\n        }\n      }\n\n      > ul {\n        > li {\n          position: relative;\n          white-space: nowrap;\n\n          > a {\n            padding: 15px 20px;\n            min-height: 55px;\n            transition: none;\n\n            &:hover,\n            &:active,\n            &:focus {\n              color: $sidebar-menu-item-hover-color;\n            }\n\n            i {\n              font-size: 1.45rem;\n              margin-left: 4px;\n            }\n\n            span {\n              display: none;\n              padding-left: 25px;\n            }\n          }\n\n          &:hover {\n            > a {\n              position: relative;\n              width: calc(190px + #{$sidebar-collapsed-width});\n              color: $primary;\n              background-color: darken($sidebar-bg, 4%);\n              transition: none;\n\n              i {\n                color: $primary;\n              }\n\n              span {\n                display: inline;\n              }\n            }\n\n            > ul {\n              display: block;\n              left: $sidebar-collapsed-width;\n              position: absolute;\n              width: 190px;\n              height: auto !important;\n              box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);\n\n              ul {\n                box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);\n              }\n\n              a {\n                box-shadow: none;\n                padding: 8px 20px;\n                position: relative;\n                width: 190px;\n                z-index: 6;\n                color: $sidebar-menu-sub-item-color;\n\n                &:hover {\n                  color: $sidebar-menu-item-hover-color;\n                }\n              }\n            }\n          }\n        }\n\n        ul {\n          padding: 5px 0;\n          z-index: 9999;\n          display: none;\n          background-color: $sidebar-bg;\n\n          li {\n            &:hover {\n              > ul {\n                display: block;\n                left: 190px;\n                height: auto !important;\n                margin-top: -36px;\n                position: absolute;\n                width: 190px;\n              }\n            }\n\n            > a {\n              span.pull-right {\n                position: absolute;\n                right: 20px;\n                top: 12px;\n                transform: rotate(270deg);\n              }\n            }\n          }\n\n          li.active {\n            a {\n              color: $gray-100;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nbody[data-sidebar=\"dark\"] {\n  .vertical-menu {\n    background: $sidebar-dark-bg;\n  }\n\n  #sidebar-menu {\n    ul {\n      li {\n        a {\n          color: $sidebar-dark-menu-item-color;\n\n          i {\n            color: $sidebar-dark-menu-item-icon-color;\n          }\n\n          &:hover {\n            color: $sidebar-dark-menu-item-hover-color;\n\n            i {\n              color: $sidebar-dark-menu-item-hover-color;\n            }\n          }\n        }\n\n        ul.sub-menu {\n          li {\n            a {\n              color: $sidebar-dark-menu-sub-item-color;\n\n              &:hover {\n                color: $sidebar-dark-menu-item-hover-color;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  // Enlarge menu\n  &.vertical-collpsed {\n    min-height: $layout-collapsed-min-height;\n\n    // Side menu\n    .vertical-menu {\n      .navbar-brand-box {\n        background: $sidebar-dark-bg;\n      }\n      // Sidebar Menu\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover {\n              > a {\n                background: lighten($sidebar-dark-bg, 2%);\n                color: $sidebar-dark-menu-item-hover-color;\n                i {\n                  color: $sidebar-dark-menu-item-hover-color;\n                }\n              }\n\n              > ul {\n                a {\n                  color: $sidebar-dark-menu-sub-item-color;\n                  &:hover {\n                    color: $sidebar-dark-menu-item-hover-color;\n                  }\n                }\n              }\n            }\n          }\n\n          ul {\n            background-color: $sidebar-dark-bg;\n          }\n        }\n\n        ul {\n          li {\n            &.mm-active .active {\n              color: $sidebar-dark-menu-item-active-color !important;\n              i {\n                color: $sidebar-dark-menu-item-active-color !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .mm-active {\n    color: $sidebar-dark-menu-item-active-color !important;\n    > a {\n      color: $sidebar-dark-menu-item-active-color !important;\n      i {\n        color: $sidebar-dark-menu-item-active-color !important;\n      }\n    }\n    > i {\n      color: $sidebar-dark-menu-item-active-color !important;\n    }\n    .active {\n      color: $sidebar-dark-menu-item-active-color !important;\n\n      i {\n        color: $sidebar-dark-menu-item-active-color !important;\n      }\n    }\n  }\n\n  .menu-title {\n    color: $sidebar-dark-menu-item-icon-color;\n  }\n}\n\nbody[data-layout=\"horizontal\"] {\n  .main-content {\n    margin-left: 0 !important;\n  }\n}\n\n// Compact Sidebar\n\nbody[data-sidebar-size=\"small\"] {\n  .navbar-brand-box {\n    width: $sidebar-width-sm;\n  }\n  .vertical-menu {\n    width: $sidebar-width-sm;\n    text-align: center;\n\n    .has-arrow:after,\n    .badge {\n      display: none !important;\n    }\n  }\n  .main-content {\n    margin-left: $sidebar-width-sm;\n  }\n  .footer {\n    left: $sidebar-width-sm;\n    @media (max-width: 991.98px) {\n      left: 0;\n    }\n  }\n\n  #page-topbar {\n    left: $sidebar-width-sm;\n    @media (max-width: 991.98px) {\n      left: 0;\n\n      .navbar-header {\n        .navbar-brand-box {\n          width: auto;\n        }\n      }\n    }\n  }\n\n  #sidebar-menu {\n    ul li {\n      a {\n        i {\n          display: block;\n        }\n      }\n      ul.sub-menu {\n        li {\n          a {\n            padding-left: 1.5rem;\n          }\n\n          ul.sub-menu li a {\n            padding-left: 1.5rem;\n          }\n        }\n      }\n    }\n  }\n  &.vertical-collpsed {\n    .main-content {\n      margin-left: $sidebar-collapsed-width;\n    }\n    .vertical-menu {\n      #sidebar-menu {\n        text-align: left;\n        > ul {\n          > li {\n            > a {\n              i {\n                display: inline-block;\n              }\n            }\n          }\n        }\n      }\n    }\n    .footer {\n      left: $sidebar-collapsed-width;\n    }\n  }\n}\n\n// colored sidebar\n\nbody[data-sidebar=\"colored\"],\nbody[data-sidebar=\"winter\"],\nbody[data-sidebar=\"ladylip\"],\nbody[data-sidebar=\"plumplate\"],\nbody[data-sidebar=\"strongbliss\"],\nbody[data-sidebar=\"greatwhale\"] {\n  .navbar-brand-box {\n    .logo-dark {\n      display: none;\n    }\n    .logo-light {\n      display: block;\n    }\n  }\n\n  .mm-active {\n    color: $white !important;\n    > a {\n      color: $white !important;\n      i {\n        color: $white !important;\n      }\n    }\n    > i,\n    .active {\n      color: $white !important;\n    }\n  }\n\n  #sidebar-menu {\n    ul {\n      li {\n        &.menu-title {\n          color: rgba($white, 0.6);\n        }\n\n        a {\n          color: rgba($white, 0.6);\n          i {\n            color: rgba($white, 0.6);\n          }\n          &.waves-effect {\n            .waves-ripple {\n              background: rgba($white, 0.1);\n            }\n          }\n\n          &:hover {\n            color: $white;\n\n            i {\n              color: $white;\n            }\n          }\n        }\n\n        ul.sub-menu {\n          li {\n            a {\n              color: rgba($white, 0.5);\n              &:hover {\n                color: $white;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              color: $white;\n              i {\n                color: $white;\n              }\n            }\n          }\n        }\n\n        ul {\n          li {\n            &.mm-active {\n              .active {\n                color: $sidebar-menu-item-active-color !important;\n              }\n            }\n\n            ul.sub-menu {\n              li {\n                a {\n                  &:hover {\n                    color: $sidebar-menu-item-active-color;\n                  }\n                }\n                &.mm-active {\n                  color: $sidebar-menu-item-active-color !important;\n                  > a {\n                    color: $sidebar-menu-item-active-color !important;\n                    i {\n                      color: $sidebar-menu-item-active-color !important;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// colored sidebar\n.bg-colored {\n  background-color: $primary !important;\n}\nbody[data-sidebar=\"colored\"] {\n  .vertical-menu {\n    background-color: $primary;\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      .navbar-brand-box {\n        background-color: $primary;\n      }\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              background-color: lighten($primary, 2%);\n            }\n          }\n        }\n      }\n    }\n  }\n  &[data-sidebar-size=\"small\"] {\n    .menu-title {\n      background: transparent;\n    }\n  }\n}\n\n.vertical-menu {\n  [data-simplebar] {\n    z-index: 9;\n  }\n}\n\n// winter sidebar\n\nbody[data-sidebar=\"winter\"] {\n  .vertical-menu {\n    background-image: linear-gradient(to right, #556ee6, #34c38f);\n    background-repeat: repeat-x;\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      .navbar-brand-box {\n        background-image: linear-gradient(to right, #556ee6, #34c38f);\n        background-repeat: repeat-x;\n      }\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              background-image: linear-gradient(to right, #556ee6, #34c38f);\n              background-repeat: repeat-x;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &[data-sidebar-size=\"small\"] {\n    .menu-title {\n      background-image: linear-gradient(to right, #556ee6, #34c38f);\n    }\n  }\n}\n\n// ladylip sidebar\n\nbody[data-sidebar=\"ladylip\"] {\n  .vertical-menu {\n    background-image: linear-gradient(to right, #556ee6, #f46a6a);\n    background-repeat: repeat-x;\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      .navbar-brand-box {\n        background-image: linear-gradient(to right, #556ee6, #f46a6a);\n        background-repeat: repeat-x;\n      }\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              background-image: linear-gradient(to right, #556ee6, #f46a6a);\n              background-repeat: repeat-x;\n            }\n          }\n        }\n      }\n    }\n  }\n  &[data-sidebar-size=\"small\"] {\n    .menu-title {\n      background-image: linear-gradient(to right, #556ee6, #f46a6a);\n    }\n  }\n}\n\n// plumplate sidebar\n\nbody[data-sidebar=\"plumplate\"] {\n  .vertical-menu {\n    background-image: linear-gradient(to right, #556ee6, #f1b44c);\n    background-repeat: repeat-x;\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      .navbar-brand-box {\n        background-image: linear-gradient(to right, #556ee6, #f1b44c);\n        background-repeat: repeat-x;\n      }\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              background-image: linear-gradient(to right, #556ee6, #f1b44c);\n              background-repeat: repeat-x;\n            }\n          }\n        }\n      }\n    }\n  }\n  &[data-sidebar-size=\"small\"] {\n    .menu-title {\n      background-image: linear-gradient(to right, #556ee6, #f1b44c);\n    }\n  }\n}\n\n// strongbliss sidebar\n\nbody[data-sidebar=\"strongbliss\"] {\n  .vertical-menu {\n    background-image: linear-gradient(to right, #f46a6a, #f1b44c);\n    background-repeat: repeat-x;\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      .navbar-brand-box {\n        background-image: linear-gradient(to right, #f46a6a, #f1b44c);\n        background-repeat: repeat-x;\n      }\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              background-image: linear-gradient(to right, #f46a6a, #f1b44c);\n              background-repeat: repeat-x;\n            }\n          }\n        }\n      }\n    }\n  }\n  &[data-sidebar-size=\"small\"] {\n    .menu-title {\n      background-image: linear-gradient(to right, #f46a6a, #f1b44c);\n    }\n  }\n}\n\n//greatwhale\nbody[data-sidebar=\"greatwhale\"] {\n  .vertical-menu {\n    background-image: linear-gradient(to right, darken($primary, 15%), #50a5f1);\n    background-repeat: repeat-x;\n  }\n\n  &.vertical-collpsed {\n    .vertical-menu {\n      .navbar-brand-box {\n        background-image: linear-gradient(\n          to right,\n          darken($primary, 15%),\n          #50a5f1\n        );\n        background-repeat: repeat-x;\n      }\n      #sidebar-menu {\n        > ul {\n          > li {\n            &:hover > a {\n              background-image: linear-gradient(\n                to right,\n                darken($primary, 15%),\n                #50a5f1\n              );\n              background-repeat: repeat-x;\n            }\n          }\n        }\n      }\n    }\n  }\n  &[data-sidebar-size=\"small\"] {\n    .menu-title {\n      background-image: linear-gradient(to right, #556ee6, #50a5f1);\n    }\n  }\n}\n\n.themesideimage {\n  height: 80px;\n  width: 40px;\n}\n\nbody[data-sidebar-image] {\n  .vertical-menu {\n    &:before {\n      opacity: 0.33;\n      display: block;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      z-index: 2;\n    }\n\n    &:after {\n      opacity: 0.77;\n      display: block;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      z-index: 2;\n    }\n  }\n\n  .sidebar-background {\n    position: absolute;\n    z-index: 1;\n    height: 100%;\n    width: 100%;\n    display: block;\n    top: 0;\n    left: 0;\n    background-size: cover;\n    background-position: 50%;\n    opacity: 0.07;\n  }\n}\n\nbody[data-sidebar-image=\"img1\"] {\n  .sidebar-background {\n    background-image: url(\"../../../images/sidebar/img1.jpg\");\n  }\n}\n\nbody[data-sidebar-image=\"img2\"] {\n  .sidebar-background {\n    background-image: url(\"../../../images/sidebar/img2.jpg\");\n  }\n}\n\nbody[data-sidebar-image=\"img3\"] {\n  .sidebar-background {\n    background-image: url(\"../../../images/sidebar/img3.jpg\");\n  }\n}\n\nbody[data-sidebar-image=\"img4\"] {\n  .sidebar-background {\n    background-image: url(\"../../../images/sidebar/img4.jpg\");\n  }\n}\n\n.verticalcontent {\n  writing-mode: vertical-rl;\n  text-orientation: upright;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: $dark !important;\n}\n\n.wh-30 {\n  width: 30px;\n  height: 30px;\n}\n.gradient-colored {\n  background-color: $primary;\n}\n.gradient-winter {\n  background-image: linear-gradient(to right, #556ee6, #34c38f);\n  background-repeat: repeat-x;\n}\n.gradient-lady-lip {\n  background-image: linear-gradient(to right, #556ee6, #f46a6a);\n  background-repeat: repeat-x;\n}\n.gradient-plum-plate {\n  background-image: linear-gradient(to right, #556ee6, #f1b44c);\n}\n.gradient-strong-bliss {\n  background-image: linear-gradient(to right, #f46a6a, #f1b44c);\n}\n.gradient-strong-great-whale {\n  background-image: linear-gradient(to right, darken($primary, 10%), #50a5f1);\n}\n","// \n// _horizontal.scss\n// \n\n.topnav {\n    background: $topnav-bg;\n    padding: 0 calc(#{$grid-gutter-width} / 2);\n    box-shadow: $box-shadow;\n    margin-top: $header-height;\n    position: fixed;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    \n    .topnav-menu {\n        margin: 0;\n        padding: 0;\n    }\n\n    .navbar-nav {\n        \n        .nav-link {\n            font-size: 14px;\n            position: relative;\n            padding: 1rem 1.3rem;\n            color: $menu-item-color;\n            i{\n                font-size: 15px;\n            }\n            &:focus, &:hover{\n                color: $menu-item-active-color;\n                background-color: transparent;\n            }\n        }\n        \n        .dropdown-item{\n            color: $menu-item-color;\n            &.active, &:hover{\n                color: $menu-item-active-color;\n            }\n        }\n        \n        .nav-item{\n            .nav-link.active{\n                color: $menu-item-active-color;\n            }\n        }\n\n        .dropdown{\n            &.active{\n              >a {\n                    color: $menu-item-active-color;\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n}\n\nbody[data-layout=\"horizontal\"] {\n    #page-topbar{\n        left: 0;\n    }\n}\n\n@include media-breakpoint-up(xl) {\n\n    body[data-layout=\"horizontal\"] {\n        .container-fluid,\n        .navbar-header {\n            max-width: 85%;\n        }\n    }\n}\n\n@include media-breakpoint-up(lg) {\n    .topnav {\n        .navbar-nav {\n            .nav-item {\n                &:first-of-type {\n                    .nav-link {\n                        padding-left: 0;\n                    }\n                }\n            }\n        }\n\n        .dropdown-item {\n            padding: .5rem 1.5rem;\n            min-width: 180px;\n        }\n\n        .dropdown {\n            &.mega-dropdown{\n                // position: static;\n                .mega-dropdown-menu{\n                    left: 0px;\n                    right: auto;\n                }\n            }\n            .dropdown-menu {\n                margin-top: 0;\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\n\n                .arrow-down {\n                    &::after {\n                        right: 15px;\n                        transform: rotate(-135deg) translateY(-50%);\n                        position: absolute;\n                    }\n                }\n\n                .dropdown {\n                    .dropdown-menu {\n                        position: absolute;\n                        top: 0 !important;\n                        left: 100%;\n                        display: none\n                    }\n                }\n            }\n\n            &:hover {\n                >.dropdown-menu {\n                    display: block;\n                }\n            }\n        }\n\n        .dropdown:hover>.dropdown-menu>.dropdown:hover>.dropdown-menu {\n            display: block\n        }\n    }\n\n    .navbar-toggle {\n        display: none;\n    }\n}\n\n.arrow-down {\n    display: inline-block;\n\n    &:after {\n        border-color: initial;\n        border-style: solid;\n        border-width: 0 0 1px 1px;\n        content: \"\";\n        height: .4em;\n        display: inline-block;\n        right: 5px;\n        top: 50%;\n        margin-left: 10px;\n        transform: rotate(-45deg) translateY(-50%);\n        transform-origin: top;\n        transition: all .3s ease-out;\n        width: .4em;\n    }\n}\n\n\n@include media-breakpoint-down(xl) {\n    .topnav-menu {\n        .navbar-nav {\n            li {\n                &:last-of-type {\n                    .dropdown {\n                        .dropdown-menu {\n                            right: 100%;\n                            left: auto;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(lg) {\n\n    .navbar-brand-box{\n        .logo-dark {\n            display: $display-block;\n            span.logo-sm{\n                display: $display-block;\n            }\n        }\n    \n        .logo-light {\n            display: $display-none;\n        }\n    }\n    \n    .topnav {\n        max-height: 360px;\n        overflow-y: auto;\n        padding: 0;\n        .navbar-nav {\n            .nav-link {\n                padding: 0.75rem 1.1rem;\n            }\n        }\n\n        .dropdown {\n            .dropdown-menu {\n                background-color: transparent;\n                border: none;\n                box-shadow: none;\n                padding-left: 15px;\n                &.dropdown-mega-menu-xl{\n                    width: auto;\n    \n                    .row{\n                        margin: 0px;\n                    }\n                }\n            }\n\n            .dropdown-item {\n                position: relative;\n                background-color: transparent;\n\n                &.active,\n                &:active {\n                    color: $primary;\n                }\n            }\n        }\n\n        .arrow-down {\n            &::after {\n                right: 15px;\n                position: absolute;\n            }\n        }\n    }\n}\n\n\n@include media-breakpoint-up(lg) {\n\n    body[data-layout=\"horizontal\"][data-topbar=\"light\"] {\n        .navbar-brand-box{\n            .logo-dark {\n                display: $display-block;\n            }\n        \n            .logo-light {\n                display: $display-none;\n            }\n        }\n\n        .topnav{\n            background-color: $primary;\n            .navbar-nav {\n        \n                .nav-link {\n                    color: rgba($white, 0.6);\n                    \n                    &:focus, &:hover{\n                        color: rgba($white, 0.9);\n                    }\n                }\n        \n                > .dropdown{\n                    &.active{\n                    >a {\n                            color: rgba($white, 0.9) !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Colored Topbar \n\nbody[data-layout=\"horizontal\"][data-topbar=\"colored\"] {\n    #page-topbar{\n        background-color: $primary;\n        box-shadow: none;\n    }\n\n    .logo-dark {\n        display: none;\n    }\n\n    .logo-light {\n        display: block;\n    }\n\n    .app-search {\n    \n        .form-control {\n            background-color: rgba($topbar-search-bg,0.07);\n            color: $white;\n        }\n        span,\n        input.form-control::-webkit-input-placeholder {\n            color: rgba($white,0.5);\n        }\n    }\n    .header-item {\n        color: $header-dark-item-color;\n    \n        &:hover {\n            color: $header-dark-item-color;\n        }\n    }\n\n    .navbar-header {\n        .dropdown .show {\n            &.header-item{\n                background-color: rgba($white,0.1);\n            }\n        }\n\n        .waves-effect .waves-ripple {\n            background: rgba($white, 0.4);\n        }\n    }\n\n    .noti-icon {\n        i {\n            color: $header-dark-item-color;\n        }\n    }\n\n    @include media-breakpoint-up(lg) {\n        .topnav{\n            background-color: $primary;\n            .navbar-nav {\n        \n                .nav-link {\n                    color: rgba($white, 0.6);\n                    \n                    &:focus, &:hover{\n                        color: rgba($white, 0.9);\n                    }\n                }\n        \n                > .dropdown{\n                    &.active{\n                      >a {\n                            color: rgba($white, 0.9) !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n","//\n// _layouts.scss\n//\n\nbody[data-layout-size=\"boxed\"] {\n  background-color: $boxed-body-bg;\n  #layout-wrapper {\n    background-color: $body-bg;\n    max-width: $boxed-layout-width;\n    margin: 0 auto;\n    box-shadow: $box-shadow;\n  }\n\n  #page-topbar {\n    max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\n    margin: 0 auto;\n  }\n\n  &.vertical-collpsed {\n    #page-topbar {\n      max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\n      margin: 0 auto;\n    }\n    .main-content {\n      min-height: $layout-collapsed-min-height;\n    }\n  }\n\n  &[data-sidebar-size=\"small\"] {\n    #page-topbar {\n      max-width: calc(#{$boxed-layout-width} - #{$sidebar-width-sm});\n      left: $sidebar-width-sm;\n      @media (max-width: 991.98px) {\n        left: 0;\n      }\n    }\n  }\n\n  .footer {\n    margin: 0 auto;\n    max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\n  }\n\n  &.vertical-collpsed {\n    .footer {\n      max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\n    }\n  }\n}\n\n// Horizontal Boxed Layout\n\nbody[data-layout=\"horizontal\"][data-layout-size=\"boxed\"] {\n  #page-topbar,\n  #layout-wrapper,\n  .footer {\n    max-width: 100%;\n  }\n  .container-fluid,\n  .navbar-header {\n    max-width: $boxed-layout-width;\n  }\n}\n\n// Scrollable layout\n\nbody[data-layout-scrollable=\"true\"] {\n  @media (min-width: 992px) {\n    #page-topbar,\n    .vertical-menu,\n    .navbar-brand-box {\n      position: absolute;\n    }\n  }\n\n  &[data-layout=\"horizontal\"] {\n    @media (min-width: 992px) {\n      #page-topbar,\n      .topnav {\n        position: absolute;\n      }\n      .navbar-brand-box {\n        position: relative;\n      }\n    }\n  }\n}\n","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xs {\n  height: 2rem;\n  width: 2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  background-color: $primary;\n  color: $white;\n  display: flex;\n  font-weight: $fw-medium;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n// avatar group\n.avatar-group {\n  padding-left: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  .avatar-group-item {\n    margin-left: -12px;\n    border: 2px solid $card-bg;\n    border-radius: 50%;\n    transition: all 0.2s;\n    &:hover{\n      position: relative;\n      transform: translateY(-2px);\n    }\n  }\n}","\n//\n// accordion.scss\n//\n\n.custom-accordion {\n    .accordion-list {\n        display: flex;\n        border-radius: 7px;\n        background-color: $gray-300;\n        padding: 12px 20px;\n        color: $body-color;\n        font-weight: $font-weight-semibold;\n        align-items: center;\n        justify-content: space-between;\n        &.collapsed {\n            i.accor-plus-icon {\n                &:before {\n                    content: \"\\F0415\";\n                }\n            }\n        }\n\n        .accor-plus-icon{\n            display: inline-block;\n            font-size: 16px;\n            height: 24px;\n            width: 24px;\n            line-height: 22px;\n            background-color: $card-bg;\n            text-align: center;\n            border-radius: 50%;\n        }\n    }\n\n    \n    a {\n\n        &.collapsed {\n            i.accor-down-icon {\n                &:before {\n                    content: \"\\F0140\";\n                }\n            }\n        }\n    }\n\n\n    .card-body {\n        color: $text-muted;\n    }\n}","//\n// _helper.scss\n//\n\n.font-size-10 {\n  font-size: 10px !important;\n}\n\n.font-size-11 {\n  font-size: 11px !important;\n}\n\n.font-size-12 {\n  font-size: 12px !important;\n}\n\n.font-size-13 {\n  font-size: 13px !important;\n}\n\n.font-size-14 {\n  font-size: 14px !important;\n}\n\n.font-size-15 {\n  font-size: 15px !important;\n}\n\n.font-size-16 {\n  font-size: 16px !important;\n}\n\n.font-size-17 {\n  font-size: 17px !important;\n}\n\n.font-size-18 {\n  font-size: 18px !important;\n}\n\n.font-size-20 {\n  font-size: 20px !important;\n}\n\n.font-size-22 {\n  font-size: 22px !important;\n}\n\n.font-size-24 {\n  font-size: 24px !important;\n}\n\n// Font weight help class\n\n.fw-medium {\n  font-weight: $fw-medium;\n}\n\n.font-weight-semibold {\n  font-weight: $font-weight-semibold;\n}\n\n// Social\n\n.social-list-item {\n  height: 2rem;\n  width: 2rem;\n  line-height: calc(2rem - 4px);\n  display: block;\n  border: 2px solid $gray-500;\n  border-radius: 50%;\n  color: $gray-500;\n  text-align: center;\n  transition: all 0.4s;\n  &:hover{\n    color: $gray-600;\n    background-color: $gray-200;\n  }\n}\n\n\n.w-xs {\n  min-width: 80px;\n}\n.w-sm {\n  min-width: 95px;\n}\n.w-md {\n  min-width: 110px;\n}\n.w-lg {\n  min-width: 140px;\n}\n\n.w-xl {\n  min-width: 160px;\n}\n\n// media\n\n.media{\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n// alert\n\n.alert-dismissible {\n  .btn-close{\n    font-size: 10px;\n    padding: $alert-padding-y * 1.4 $alert-padding-x;\n    background: transparent escape-svg($btn-close-bg-dark) center / $btn-close-width auto no-repeat;\n  }\n}","// \n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: $card-bg;\n    z-index: 9999;\n}\n\n#status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -20px 0 0 -20px;\n}\n\n.spinner-chase {\n    margin: 0 auto;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    animation: spinner-chase 2.5s infinite linear both;\n}\n\n.chase-dot {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0; \n    animation: chase-dot 2.0s infinite ease-in-out both; \n    &:before {\n        content: '';\n        display: block;\n        width: 25%;\n        height: 25%;\n        background-color: $primary;\n        border-radius: 100%;\n        animation: chase-dot-before 2.0s infinite ease-in-out both; \n    }\n\n    &:nth-child(1) { \n        animation-delay: -1.1s; \n        &:before{\n            animation-delay: -1.1s;\n        }\n    }\n    &:nth-child(2) { \n        animation-delay: -1.0s;\n        &:before{\n            animation-delay: -1.0s;\n        }\n    }\n    &:nth-child(3) { \n        animation-delay: -0.9s;\n        &:before{\n            animation-delay: -0.9s;\n        } \n    }\n    &:nth-child(4) { \n        animation-delay: -0.8s; \n        &:before{\n            animation-delay: -0.8s;\n        } \n    }\n    &:nth-child(5) { \n        animation-delay: -0.7s; \n        &:before{\n            animation-delay: -0.7s;\n        } \n    }\n    &:nth-child(6) { \n        animation-delay: -0.6s; \n        &:before{\n            animation-delay: -0.6s;\n        }\n    }\n}\n\n@keyframes spinner-chase {\n    100% { \n        transform: rotate(360deg); \n    } \n}\n\n@keyframes chase-dot {\n    80%, 100% { \n        transform: rotate(360deg); \n    } \n}\n\n@keyframes chase-dot-before {\n    50% {\n        transform: scale(0.4); \n    } \n    100%, 0% {\n        transform: scale(1.0); \n    } \n}","//\n// Forms.scss\n//\n\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  &::placeholder {\n    text-align: left /*rtl: right*/;\n  }\n}\n\n.form-check {\n  position: relative;\n  text-align: left /*rtl: right*/;\n}\n\n// checkbox input right\n\n.form-check-right {\n  padding-left: 0;\n  display: inline-block;\n  padding-right: $form-check-padding-start;\n  .form-check-input {\n    float: right;\n    margin-left: 0;\n    margin-right: $form-check-padding-start * -1;\n  }\n\n  .form-check-label {\n    display: block;\n  }\n}\n\n// checkbox\n\n.form-checkbox-outline {\n  .form-check-input {\n    border-width: 2px;\n    background-color: $card-bg;\n\n    &:active {\n      filter: none;\n    }\n\n    &:checked {\n      background-color: $card-bg !important;\n\n      &[type=\"checkbox\"] {\n        background-image: none;\n      }\n\n      &:after {\n        position: absolute;\n        content: \"\\F012C\";\n        font-family: \"Material Design Icons\";\n        top: -4px !important;\n        left: 1px; /*rtl: -4px */\n        font-size: 16px;\n        color: $dark;\n      }\n    }\n  }\n}\n\n// radio\n\n.form-radio-outline {\n  .form-check-input {\n    background-color: $card-bg;\n    position: relative;\n\n    &:active {\n      filter: none;\n    }\n\n    &:checked {\n      background-color: $card-bg !important;\n\n      &[type=\"checkbox\"] {\n        background-image: none;\n      }\n\n      &:after {\n        position: absolute;\n        content: \"\";\n        top: 3px !important;\n        left: 3px;\n        width: 5px;\n        height: 5px;\n        border-radius: 50%;\n      }\n    }\n  }\n}\n\n// checkbox color\n\n@each $color, $value in $theme-colors {\n  .form-check-#{$color} {\n    .form-check-input {\n      &:checked {\n        background-color: $value;\n        border-color: $value;\n      }\n    }\n  }\n\n  .form-radio-#{$color} {\n    .form-check-input {\n      &:checked {\n        border-color: $value;\n        background-color: $value;\n        &:after {\n          background-color: $value;\n        }\n      }\n    }\n  }\n}\n\n.form-check-label {\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n// Switch sizes\n\n.form-switch-md {\n  padding-left: 2.5rem;\n  min-height: 24px;\n  line-height: 24px;\n  .form-check-input {\n    width: 40px;\n    height: 20px;\n    left: -0.5rem;\n    position: relative;\n  }\n\n  .form-check-label {\n    vertical-align: middle;\n  }\n}\n\n.form-switch-lg {\n  padding-left: 2.75rem;\n  min-height: 28px;\n  line-height: 28px;\n  .form-check-input {\n    width: 48px;\n    height: 24px;\n    left: -0.75rem;\n    position: relative;\n  }\n}\n\n.input-group-text {\n  margin-bottom: 0px;\n}\n\n// transfer list\n\n.rdl-filter,\n.rdl-control {\n  background-color: $input-bg;\n  border-color: $input-border-color;\n  color: $input-color;\n}\n\n.react-dual-listbox {\n  button {\n    color: $dark;\n    border-color: $border-color;\n    background-color: $light;\n  }\n\n  input,\n  select {\n    &:disabled {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n\n.rdl-move {\n  &:hover,\n  &:active,\n  &:focus {\n    &:not(:disabled) {\n      background-color: darken($light, 2%);\n      border-color: $border-color;\n    }\n  }\n}\n\n.css-1uccc91-singleValue {\n  color: $input-color !important;\n}\n\n.react-kanban-column {\n  background-color: $light !important;\n}\n","// \n// Widgets.scss\n// \n\n.mini-stats-wid{\n    .mini-stat-icon{\n        overflow: hidden;\n        position: relative;\n        &:before, &:after{\n            content: \"\";\n            position: absolute;\n            width: 8px;\n            height: 54px;\n            background-color: rgba($white,.1);\n            left: 16px;\n            transform: rotate(32deg);\n            top: -5px;\n            transition: all 0.4s;\n        }\n\n        &::after{\n            left: -12px;\n            width: 12px;\n            transition: all 0.2s;\n        }\n    }\n\n    &:hover{\n        .mini-stat-icon{\n            &::after{\n                left: 60px;\n            }\n        }\n    }\n}\n\n\n","// \n// _demos.scss\n// \n\n// Demo Only\n.button-items {\n    margin-left: -8px;\n    margin-bottom: -12px;\n    \n    .btn {\n        margin-bottom: 12px;\n        margin-left: 8px;\n    }\n}\n\n// Lightbox \n\n.mfp-popup-form {\n    max-width: 1140px;\n}\n\n// Modals\n\n.bs-example-modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n  }\n\n[dir=\"rtl\"]{\n  .modal-open{\n    padding-left: 0px !important;\n  }\n}\n\n// Icon demo ( Demo only )\n.icon-demo-content {\n    text-align: center;\n    color: $gray-500;\n  \n    i{\n      display: block;\n      font-size: 24px;\n      margin-bottom: 16px;\n      color: $gray-600;\n      transition: all 0.4s;\n    }\n  \n    .col-lg-4 {\n      margin-top: 24px;\n  \n      &:hover {\n        i {\n          color: $primary;\n          transform: scale(1.5);\n        }\n      }\n    }\n}\n\n\n// Grid\n\n.grid-structure {\n    .grid-container {\n        background-color: $gray-100;\n        margin-top: 10px;\n        font-size: .8rem;\n        font-weight: $fw-medium;\n        padding: 10px 20px;\n    }\n}\n\n\n// card radio\n\n.card-radio{\n  background-color: $card-bg;\n  border: 2px solid $card-border-color;\n  border-radius: $border-radius;\n  padding: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:hover{\n    cursor: pointer;\n  }\n}\n\n.card-radio-label{\n  display: block;\n}\n\n\n.card-radio-input{\n  display: none;\n  &:checked + .card-radio {\n    border-color: $primary !important;\n  }\n}\n\n.navs-carousel{\n  .owl-nav{\n      margin-top: 16px;\n      button{\n          width: 30px;\n          height: 30px;\n          line-height: 28px !important;\n          font-size: 20px !important;\n          border-radius: 50% !important;\n          background-color: rgba($primary, 0.25) !important;\n          color: $primary !important;\n          margin: 4px 8px !important;\n      }\n  }\n}\n\n\n","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .vertical-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-header,\n    .footer {\n        display: none !important;\n    }\n    .card-body,\n    .main-content,\n    .right-bar,\n    .page-content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card{\n        border: 0;\n    }\n}","[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 4px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}","\n\n/* ==============\n  Calendar\n===================*/\n\n.lnb-calendars-item{\n  display: inline-block;\n  margin-right: 7px;\n}\n\ninput[type=checkbox].tui-full-calendar-checkbox-round+span{\n  margin-right: 4px /*rtl: 0*/;\n  margin-left: 0 /*rtl: 4px*/;\n}\n\n.tui-full-calendar-layout, .tui-full-calendar-timegrid-timezone{\n  background-color: $card-bg !important;\n}\n\n.tui-full-calendar-dayname-container, \n.tui-full-calendar-left, \n.tui-full-calendar-splitter,\n.tui-full-calendar-time-date,\n.tui-full-calendar-weekday-grid-line,\n.tui-full-calendar-timegrid-timezone,\n.tui-full-calendar-timegrid-gridline{\n  border-color: $gray-300 !important;\n}\n\n.tui-full-calendar-weekday-exceed-in-week{\n  text-align: center;\n  width: 30px;\n  height: 30px;\n  line-height: 28px;\n  border-radius: 4px;\n  background-color: $card-bg;\n  color: $body-color;\n  border-color: $border-color;\n}\n\n.tui-full-calendar-timegrid-hour{\n  color: $body-color !important;\n}\n\n.tui-full-calendar-weekday-schedule-title, .tui-full-calendar-time-schedule{\n  font-weight: $font-weight-semibold;\n}\n","\n\n/* ==============\n  Druafula\n===================*/\n\n\n.task-box{\n  border: 1px solid $gray-300;\n}\n\n.gu-transit {\n    border: 1px dashed $gray-600 !important;\n    background-color: $gray-200 !important;\n}","//\n// session-timeout.scss\n//\n\n#session-timeout-dialog {\n    .close {\n        display: none;\n    }\n\n    .countdown-holder {\n        color: $danger;\n        font-weight: $fw-medium;\n    }\n\n    .btn-default {\n        background-color: $white;\n        color: $danger;\n        box-shadow: none;\n    }\n}","\n//\n// Range slider\n//\n\n.irs {\n  font-family: $font-family-base;\n}\n\n.irs--square{\n  .irs-bar, .irs-to, .irs-from, .irs-single {\n    background: $primary !important;\n    font-size: 11px;\n  }\n  .irs-to, .irs-from, .irs-single{\n    &:before{\n      border-top-color: $primary;\n    }\n  }\n\n  .irs-line{\n    background: $gray-300;\n    border-color: $gray-300;\n  }\n  .irs-grid-text{\n    font-size: 11px;\n    color: $gray-400;\n  }\n  .irs-min, .irs-max{\n    color: $gray-400;\n    background: $gray-300;\n    font-size: 11px;\n  }\n\n  .irs-handle{\n    border: 2px solid $primary;\n    width: 12px;\n    height: 12px;\n    top: 26px;\n    background-color: $card-bg !important;\n  }\n}","//\n//  Sweetalert2\n//\n\n.swal2-container {\n  .swal2-title {\n    font-size: 20px;\n    font-weight: $fw-medium;\n  }\n}\n\n.swal2-modal {\n  font-size: 14px;\n}\n\n.swal2-icon {\n  &.swal2-question {\n    border-color: $info;\n    color: $info;\n  }\n  &.swal2-success {\n    [class^=\"swal2-success-line\"] {\n      background-color: $success;\n    }\n\n    .swal2-success-ring {\n      border-color: rgba($success, 0.3);\n    }\n  }\n  &.swal2-warning {\n    border-color: $warning;\n    color: $warning;\n  }\n}\n\n.swal2-styled {\n  &:focus {\n    box-shadow: none;\n  }\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step {\n    background: $primary;\n    &.swal2-active-progress-step {\n      background: $primary;\n      & ~ .swal2-progress-step,\n      & ~ .swal2-progress-step-line {\n        background: rgba($primary, 0.3);\n      }\n    }\n  }\n\n  .swal2-progress-step-line {\n    background: $primary;\n  }\n}\n\n.swal2-loader {\n  border-color: $primary transparent $primary transparent;\n}\n\n.sweet-alert {\n  color: $body-color !important;\n  h2 {\n    color: rgba($black, 0.6) !important;\n  }\n}\n","\n//\n// Rating\n//\n\n.symbol{\n  border-color: $card-bg;\n}\n\n.rating-symbol-background, .rating-symbol-foreground {\n  font-size: 24px;\n}\n\n.rating-symbol-foreground {\n  top: 0px;\n}\n\n.rating-star{\n  > span{\n    display: inline-block;\n    vertical-align: middle;\n\n    &.badge{\n      margin-left: 4px;\n    }\n  }\n}","\n//\n// toastr.scss\n//\n\n\n/* =============\n   Notification\n============= */\n#toast-container {\n    > div {\n        box-shadow: $box-shadow;\n        opacity: 1;\n        &:hover {\n            box-shadow: $box-shadow;\n            opacity: 0.9;\n        }\n    }\n\n    &.toast-top-full-width, &.toast-bottom-full-width{\n        > div{\n          min-width: 96%;\n          margin: 4px auto;\n        }\n      }\n\n}\n\n\n@each $color, $value in $theme-colors {\n    .toast-#{$color} {\n        border: 2px solid $value !important;\n        background-color: rgba(($value), 0.8) !important;\n    }\n}\n\n\n// for error\n\n.toast-error {\n    background-color: rgba($danger,0.8);\n    border: 2px solid $danger;\n}\n\n.toastr-options{\n    padding: 24px;\n    background-color: lighten($gray-200, 2%);\n    margin-bottom: 0;\n    border: 1px solid $border-color;\n}","\n//\n// Parsley\n//\n\n.error {\n  color: $danger;\n}\n\n.parsley-error {\n  border-color: $danger;\n}\n\n.parsley-errors-list {\n  display: none;\n  margin: 0;\n  padding: 0;\n  &.filled {\n    display: block;\n  }\n  > li {\n    font-size: 12px;\n    list-style: none;\n    color: $danger;\n    margin-top: 5px;\n  }\n}","//\n// Select 2\n//\n\n.select2-container {\n  .select2-selection--single {\n    background-color: $input-bg;\n    border: 1px solid $input-border-color;\n    height: 38px;\n    &:focus {\n      outline: none;\n    }\n\n    .select2-selection__rendered {\n      line-height: 36px;\n      padding-left: $input-padding-x;\n      color: $input-color;\n    }\n\n    .select2-selection__arrow {\n      height: 34px;\n      width: 34px;\n      right: 3px;\n\n      b {\n        border-color: $gray-500 transparent transparent transparent;\n        border-width: 6px 6px 0 6px;\n      }\n    }\n\n    .select2-selection__placeholder {\n      color: $body-color;\n    }\n  }\n}\n\n.select2-container--open {\n  .select2-selection--single {\n    .select2-selection__arrow {\n      b {\n        border-color: transparent transparent $gray-500 transparent !important;\n        border-width: 0 6px 6px 6px !important;\n      }\n    }\n  }\n}\n\n.select2-container--default {\n  .select2-search--dropdown {\n    padding: 10px;\n    background-color: $dropdown-bg;\n    .select2-search__field {\n      border: 1px solid $input-border-color;\n      background-color: $input-bg;\n      color: $gray-600;\n      outline: none;\n    }\n  }\n  .select2-results__option--highlighted[aria-selected] {\n    background-color: $primary;\n  }\n  .select2-results__option[aria-selected=\"true\"] {\n    background-color: $dropdown-link-active-bg;\n    color: $dropdown-link-active-color;\n    &:hover {\n      background-color: $primary;\n      color: $white;\n    }\n  }\n}\n\n.select2-results__option {\n  padding: 6px 12px;\n}\n.select2-container[dir=\"rtl\"]\n  .select2-selection--single\n  .select2-selection__rendered {\n  padding-left: $input-padding-x;\n}\n\n.select2-dropdown {\n  border: 1px solid $dropdown-border-color;\n  background-color: $dropdown-bg;\n  box-shadow: $box-shadow;\n}\n\n.select2-search {\n  input {\n    border: 1px solid $gray-300;\n  }\n}\n\n.select2-container {\n  .select2-selection--multiple {\n    min-height: 38px;\n    background-color: $input-bg;\n    border: 1px solid $input-border-color !important;\n\n    .select2-selection__rendered {\n      padding: 2px $input-padding-x;\n    }\n    .select2-search__field {\n      border: 0;\n      color: $input-color;\n      &::placeholder {\n        color: $input-color;\n      }\n    }\n    .select2-selection__choice {\n      background-color: $gray-200;\n      border: 1px solid $gray-300;\n      border-radius: 1px;\n      padding: 0 7px;\n    }\n  }\n}\n\n.select2-container--default {\n  &.select2-container--focus {\n    .select2-selection--multiple {\n      border-color: $gray-400;\n    }\n  }\n\n  .select2-results__group {\n    font-weight: $font-weight-semibold;\n  }\n}\n\n// ajax select\n\n.select2-result-repository__avatar {\n  float: left;\n  width: 60px;\n  margin-right: 10px;\n  img {\n    width: 100%;\n    height: auto;\n    border-radius: 2px;\n  }\n}\n\n.select2-result-repository__statistics {\n  margin-top: 7px;\n}\n\n.select2-result-repository__forks,\n.select2-result-repository__stargazers,\n.select2-result-repository__watchers {\n  display: inline-block;\n  font-size: 11px;\n  margin-right: 1em;\n  color: $gray-500;\n\n  .fa {\n    margin-right: 4px;\n\n    &.fa-flash {\n      &::before {\n        content: \"\\f0e7\";\n        font-family: \"Font Awesome 5 Free\";\n      }\n    }\n  }\n}\n\n.select2-results__option--highlighted {\n  .select2-result-repository__forks,\n  .select2-result-repository__stargazers,\n  .select2-result-repository__watchers {\n    color: rgba($white, 0.8);\n  }\n}\n\n.select2-result-repository__meta {\n  overflow: hidden;\n}\n\n// templating-select\n\n.img-flag {\n  margin-right: 7px;\n  height: 15px;\n  width: 18px;\n}\n\n.select2-selection__control {\n  background-color: $input-bg !important;\n  border-color: $input-border-color !important;\n}\n\n.select2-selection__indicator-separator {\n  background-color: $input-border-color !important;\n}\n\n.select2-selection__indicator {\n  svg {\n    fill: $input-color !important;\n  }\n}\n\n.select2-selection__placeholder {\n  color: $input-placeholder-color !important;\n}\n\n.select2-selection__menu {\n  background-color: $dropdown-bg !important;\n}","//\n//  Sweetalert2\n//\n\n/* CSS Switch */\ninput[switch] {\n  display: none;\n  + label {\n    font-size: 1em;\n    line-height: 1;\n    width: 56px;\n    height: 24px;\n    background-color: $gray-400;\n    background-image: none;\n    border-radius: 2rem;\n    padding: 0.16667rem;\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    position: relative;\n    font-weight: $fw-medium;\n    transition: all 0.1s ease-in-out;\n    &:before {\n      color: $dark;\n      content: attr(data-off-label);\n      display: block;\n      font-family: inherit;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 21px;\n      position: absolute;\n      right: 1px;\n      margin: 3px;\n      top: -2px;\n      text-align: center;\n      min-width: 1.66667rem;\n      overflow: hidden;\n      transition: all 0.1s ease-in-out;\n    }\n\n    &:after {\n      content: '';\n      position: absolute;\n      left: 3px;\n      background-color: $gray-200;\n      box-shadow: none;\n      border-radius: 2rem;\n      height: 20px;\n      width: 20px;\n      top: 2px;\n      transition: all 0.1s ease-in-out;\n    }\n  }\n\n  &:checked + label {\n    background-color: $primary;\n  }\n}\n\ninput[switch]:checked + label {\n  background-color: $primary;\n  &:before {\n    color: $white;\n    content: attr(data-on-label);\n    right: auto;\n    left: 3px;\n  }\n\n  &:after {\n    left: 33px;\n    background-color: $gray-200;\n  }\n}\n\ninput[switch=\"bool\"] + label {\n  background-color: $danger;\n}\ninput[switch=\"bool\"] + label:before,input[switch=\"bool\"]:checked + label:before,\ninput[switch=\"default\"]:checked + label:before{\n  color: $white;\n}\n\ninput[switch=\"bool\"]:checked + label {\n  background-color: $success;\n}\n\ninput[switch=\"default\"]:checked + label {\n  background-color: #a2a2a2;\n}\n\ninput[switch=\"primary\"]:checked + label {\n  background-color: $primary;\n}\n\ninput[switch=\"success\"]:checked + label {\n  background-color: $success;\n}\n\ninput[switch=\"info\"]:checked + label {\n  background-color: $info;\n}\n\ninput[switch=\"warning\"]:checked + label {\n  background-color: $warning;\n}\n\ninput[switch=\"danger\"]:checked + label {\n  background-color: $danger;\n}\n\ninput[switch=\"dark\"]:checked + label {\n  background-color: $dark;\n  &:before {\n    color: $light;\n  }\n}\n\n.square-switch{\n  margin-right: 7px;\n  input[switch]+label, input[switch]+label:after{\n    border-radius: 4px;\n  }\n}\n","\n//\n// colorpicker.scss\n//\n\n.sp-container{\n  background-color: $dropdown-bg;\n  button{\n    padding: .25rem .5rem;\n      font-size: .71094rem;\n      border-radius: .2rem;\n      font-weight: 400;\n      color: $dark;\n  \n      &.sp-palette-toggle{\n        background-color: $light;\n      }\n      \n      &.sp-choose{\n        background-color: $success;\n        margin-left: 5px;\n        margin-right: 0;\n      }\n  }\n}\n\n.sp-palette-container{\n  border-right: 1px solid $border-color;\n}\n\n.sp-input{\n  background-color: $input-bg;\n  border-color: $input-border-color !important;\n  color: $input-color;\n  &:focus{\n    outline: none;\n  }\n}\n\n\n[dir=\"rtl\"]{\n\n  .sp-alpha{\n    direction: ltr;\n  }\n\n  .sp-original-input-container {\n    .sp-add-on{\n      border-top-right-radius: 0!important;\n      border-bottom-right-radius: 0!important;\n      border-top-left-radius: 4px!important;\n      border-bottom-left-radius: 4px!important\n    }\n  } \n\n  input.spectrum.with-add-on{\n    border: 1px solid $input-border-color;\n    border-left: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: $input-border-radius;\n    border-bottom-right-radius: $input-border-radius;\n\n  }\n}","\n\n/* Timepicker */\n.bootstrap-timepicker-widget {\n  table {\n    td {\n      a {\n        color: $input-color;\n        &:hover {\n          background-color: transparent;\n          border-color: transparent;\n          border-radius: 4px;\n          color: $primary;\n          text-decoration: none;\n        }\n      }\n      input {\n        width: 32px;\n        height: 32px;\n        border: 0;\n        color: $body-color;\n        border: 1px solid $border-color;;\n        background-color: $input-bg;\n\n      }\n    }\n  }\n\n  &.dropdown-menu:after{\n    border-bottom-color: $gray-200;\n  }\n  &.timepicker-orient-bottom:after{\n    border-top-color: $gray-200;\n  }\n}\n\n\n.timepicker-orient-top{\n  top: $input-height !important;\n}\n\n.timepicker-orient-bottom{\n  top: auto !important;\n  bottom: $input-height !important;\n}\n\n.bootstrap-timepicker-widget{\n  left: 0 !important;\n  right: auto !important;\n}\n\n\n.bootstrap-timepicker-widget{\n  &.timepicker-orient-left{\n    &:before{\n      left: 6px;\n      right: auto;\n    }\n\n    &::after{\n      left: 7px;\n      right: auto;\n    }\n  }\n}","\n//\n// Datepicker\n//\n\n[dir=\"rtl\"]{\n  .datepicker {\n    right: 0 !important;\n    left: auto;\n  }\n}\n\n\n.datepicker {\n  border: 1px solid $border-color;\n  padding: 8px;\n  z-index: 999 !important;\n  \n\n  table{\n    tr{\n      th{\n        font-weight: 500;\n      }\n      td{\n        &.active, &.active:hover, .active.disabled, &.active.disabled:hover,\n        &.today,  &.today:hover, &.today.disabled, &.today.disabled:hover, \n        &.selected, &.selected:hover, &.selected.disabled, &.selected.disabled:hover,\n        span.active.active, span.active:hover.active{\n          background-color: $primary !important;\n          background-image: none;\n          box-shadow: none;\n          color: $white !important;\n        }\n\n        &.day.focused,\n        &.day:hover,\n        span.focused,\n        span:hover {\n            background: $light;\n        }\n\n        &.new,\n        &.old,\n        span.new,\n        span.old {\n            color: $gray-500;\n            opacity: 0.6;\n        }\n\n        &.range, &.range.disabled, &.range.disabled:hover, &.range:hover{\n            background-color: $gray-300;\n        }\n      }\n    }\n  }\n}\n\n.table-condensed{\n  >thead>tr>th, >tbody>tr>td {\n    padding: 7px;\n  }\n}\n\n.bootstrap-datepicker-inline{\n  .datepicker-inline{\n    width: auto !important;\n    display: inline-block;\n  }\n}\n\n\n// DATEPICKER\n\n.datepicker-container{\n  border: 1px solid $border-color;\n  box-shadow: none;\n  background-color: $dropdown-bg;\n\n  &.datepicker-inline{\n    width: 212px;\n  }\n}\n\n.datepicker-panel{\n  \n  >ul{\n    >li{\n      background-color: $dropdown-bg;\n      border-radius: 4px;\n\n      &.picked, &.picked:hover{\n        background-color: rgba($primary, 0.25);\n        color: $primary;\n      }\n\n      &.highlighted, &.highlighted:hover, &:hover{\n        background-color: $primary;\n        color: $white;\n      }\n\n      \n      &.muted, &.muted:hover{\n        color: $gray-500;\n        opacity: 0.6;\n      }\n    }\n\n    \n\n    &[data-view=week]{\n      >li{\n        font-weight: $fw-medium;\n      }\n\n      >li, >li:hover{\n        background-color: $dropdown-bg;\n      }\n    }\n  }\n}\n","\n//\n// Bootstrap touchspin\n//\n\n\n.bootstrap-touchspin{\n    &.input-group{\n      &>.input-group-prepend{\n        &>.btn, &>.input-group-text{\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        }\n      }\n    }\n  \n    &.input-group{\n      &>.input-group-append{\n        &>.btn, &>.input-group-text{\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n      }\n    }\n  }","//\n// Form editors.scss\n//\n\n// Tinymce \n\n.tox-tinymce {\n  border: 1px solid $input-border-color !important;\n}\n\n.tox {\n  .tox-statusbar {\n    border-top: 1px solid $light !important;\n  }\n    .tox-menubar, .tox-edit-area__iframe, .tox-statusbar{\n      background-color: $card-bg !important;\n      background: none !important;\n    }\n    .tox-mbtn{\n      color: $gray-700 !important;\n        &:hover:not(:disabled):not(.tox-mbtn--active){\n            background-color: $light !important;\n        }\n    }\n    .tox-tbtn{\n        &:hover{\n            background-color: $light !important;\n        }\n    }\n\n    .tox-toolbar, .tox-toolbar__overflow, .tox-toolbar__primary{\n      background: $light !important;\n    }\n\n    .tox-toolbar__primary{\n      border-top-color: $light !important;\n    }\n\n    .tox-tbtn{\n      color: $gray-700 !important;\n      svg{\n        fill: $gray-700 !important;\n      }\n    }\n\n    .tox-edit-area__iframe{\n      background-color: $card-bg !important;\n    }\n  \n    .tox-statusbar a, .tox-statusbar__path-item, .tox-statusbar__wordcount{\n      color: $gray-700 !important;\n    }\n\n    &:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {\n      border-right: 1px solid darken($light, 5%) !important;\n    } \n}\n\n\n\n// x editable\n\n.editable-input{\n  .form-control{\n    display: inline-block;\n  }\n}\n\n.editable-buttons{\n  margin-left: 7px;\n  .editable-cancel{\n    margin-left: 7px;\n  }\n}\n\n","\n//\n// Form-Upload\n//\n\n/* Dropzone */\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed $gray-400;\n  background: $card-bg;\n  border-radius: 6px;\n\n  .dz-message {\n    font-size: 24px;\n    width: 100%;\n    &:focus{\n      outline: none;\n    }\n  }\n}","//\n// Form Wizard\n//\n\n\n.form-wizard-wrapper {\n  label {\n    font-size: 14px;\n    text-align: right;\n  }\n}\n\n.wizard{\n\n  // step\n  .steps{\n    >ul{\n      display: flex;\n      flex-wrap: wrap;\n      padding-left: 0;\n      margin-bottom: 0;\n      list-style: none;\n\n      @media (max-width: 1199.98px) {\n        flex-direction: column;\n      }\n\n      > a, > li{\n        flex-basis: 0;\n        flex-grow: 1;\n      }\n\n      >li{\n        width: 100%;\n\n        a{\n          display: block;\n          padding: .5rem 1rem;\n          color: $gray-700;\n          font-weight: $fw-medium;\n\n          background-color: rgba($primary, 0.1);\n        }\n      }\n\n      .current-info{\n        position: absolute;\n        left: -999em;\n    }\n\n    \n    }\n\n    .number {\n      display: inline-block;\n      width: 38px;\n      height: 38px;\n      line-height: 34px;\n      border: 2px solid $primary;\n      color: $primary;\n      text-align: center;\n      border-radius: 50%;\n      margin-right: .5rem;\n    }\n\n    .current {\n      a, a:active, a:hover {\n        background-color: rgba($primary, 0.2);\n        color: $gray-700;\n        .number {\n          background-color: $primary;\n          color: $white;\n        }\n      }\n    }\n  }\n\n  // content\n  >.content {\n    background-color: transparent;\n    padding: 14px;\n    margin-top: 0;\n    border-radius: 0;\n    min-height: 150px;\n    > .title{\n      position: absolute;\n      left: -999em;\n    }\n    >.body {\n      width: 100%;\n      height: 100%;\n      padding: 14px 0 0;\n      position: static\n    }\n  }\n\n  // actions\n\n  >.actions {\n    position: relative;\n    display: block;\n    text-align: right;\n    width: 100%;\n    > ul {\n        display: block;\n        text-align: right;\n        padding-left: 0;\n          > li{\n            display: inline-block;\n            margin: 0 0.5em;\n\n          }\n      }\n      a, a:active, a:hover {\n        background-color: $primary;\n        border-radius: 4px;\n        padding: 8px 15px;\n        color: $white;\n      }\n\n      .disabled {\n        a, a:active, a:hover {\n          opacity: .65;\n          background-color: $primary;\n          color: $white;\n          cursor: not-allowed;\n        }\n      }\n  }\n\n  // verticl wixard\n  &.vertical-wizard{\n    display: flex;\n    flex-wrap: wrap;\n\n    // step\n    .steps{\n      >ul{\n        flex-direction: column;\n\n        >li{\n            width: 100% !important;\n        }\n        \n      }\n    }\n\n    .steps, .content, .actions{\n      width: 100%;\n    }\n\n    .steps{\n        @media (min-width: 1200px) {\n          width: 25%;\n      }\n    }\n\n      .content{\n        padding: 24px;\n        @media (min-width: 1200px) {\n          width: 75%;\n          padding: 12px 24px;\n      }\n\n      >.body{\n        padding: 0;\n      }\n      \n    }\n  }\n}\n","\n\n/* \nDatatable\n*/\n\n// datatable\n\ndiv.dataTables_wrapper {\n  div.dataTables_filter{\n    text-align: right;\n\n    @media (max-width: 767px){\n      text-align: center;\n    }\n    \n    input{\n      margin-left: 0.5em;\n      margin-right: 0;\n    }\n  }\n}\n\n.table, table{\n  &.dataTable{\n    &.dtr-inline.collapsed>tbody>tr>td{\n      position: relative;\n      &.dtr-control{\n        padding-left: 30px;\n        &:before{\n          top: 50%;\n          left: 5px;\n          height: 14px;\n          width: 14px;\n          margin-top: -9px;\n          display: block;\n          position: absolute;\n          color: $white;\n          border: 2px solid $white;\n          border-radius: 14px;\n          box-sizing: content-box;\n          text-align: center;\n          text-indent: 0 !important;\n          line-height: 14px;\n          content: '+';\n          background-color: $primary;\n        }\n      }\n    }\n  }\n\n}","//\n// Responsive Table\n//\n\n.table-rep-plugin {\n  .btn-toolbar {\n    display: block;\n  }\n  .table-responsive {\n    border: none !important;\n  }\n  .btn-group {\n    .btn-default {\n      background-color: $secondary;\n      color: $light;\n      border: 1px solid $secondary;\n      &.btn-primary {\n        background-color: $primary;\n        border-color: $primary;\n        color: $white;\n        box-shadow: 0 0 0 2px rgba($primary, 0.5);\n      }\n    }\n    &.pull-right {\n      float: right;\n      .dropdown-menu {\n        right: 0;\n        transform: none !important;\n        top: 100% !important;\n      }\n    }\n  }\n  tbody {\n    th {\n      font-size: 14px;\n      font-weight: normal;\n    }\n  }\n\n  .checkbox-row {\n    padding-left: 40px;\n    color: $dropdown-color !important;\n\n    &:hover {\n      background-color: lighten($gray-200, 2%) !important;\n    }\n\n    label {\n      display: inline-block;\n      padding-left: 5px;\n      position: relative;\n      &::before {\n        -o-transition: 0.3s ease-in-out;\n        -webkit-transition: 0.3s ease-in-out;\n        background-color: $white;\n        border-radius: 3px;\n        border: 1px solid $gray-300;\n        content: \"\";\n        display: inline-block;\n        height: 17px;\n        left: 0;\n        margin-left: -20px;\n        position: absolute;\n        transition: 0.3s ease-in-out;\n        width: 17px;\n        outline: none !important;\n      }\n      &::after {\n        color: $gray-200;\n        display: inline-block;\n        font-size: 11px;\n        height: 16px;\n        left: 0;\n        margin-left: -20px;\n        padding-left: 3px;\n        padding-top: 1px;\n        position: absolute;\n        top: -1px;\n        width: 16px;\n      }\n    }\n    input[type=\"checkbox\"] {\n      cursor: pointer;\n      opacity: 0;\n      z-index: 1;\n      outline: none !important;\n\n      &:disabled + label {\n        opacity: 0.65;\n      }\n    }\n    input[type=\"checkbox\"]:focus + label {\n      &::before {\n        outline-offset: -2px;\n        outline: none;\n      }\n    }\n    input[type=\"checkbox\"]:checked + label {\n      &::after {\n        content: \"\\f00c\";\n        font-family: \"Font Awesome 5 Free\";\n        font-weight: 900;\n      }\n    }\n    input[type=\"checkbox\"]:disabled + label {\n      &::before {\n        background-color: $gray-100;\n        cursor: not-allowed;\n      }\n    }\n    input[type=\"checkbox\"]:checked + label {\n      &::before {\n        background-color: $primary;\n        border-color: $primary;\n      }\n      &::after {\n        color: $white;\n      }\n    }\n  }\n\n  .fixed-solution {\n    .sticky-table-header {\n      top: $header-height !important;\n      background-color: $primary;\n      table {\n        color: $white;\n      }\n    }\n  }\n\n  table.focus-on tbody tr.focused th,\n  table.focus-on tbody tr.focused td,\n  .sticky-table-header {\n    background: $primary;\n    border-color: $primary;\n    color: $white;\n\n    table {\n      color: $white;\n    }\n  }\n}\n\nbody[data-layout=\"horizontal\"] {\n  @media (min-width: 992px) {\n    .fixed-solution {\n      .sticky-table-header {\n        top: $header-height + 50px !important;\n      }\n    }\n  }\n}\n\na.btn.btn-primary {\n  display: flex !important;\n  align-items: center !important;\n}\n","\n//\n// Table editable\n//\n\n.table-edits{\n  input, select{\n    height: $input-height-sm;\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    border: 1px solid $input-border-color;\n    background-color: $input-bg;\n    color: $input-color;\n    border-radius: $input-border-radius;\n    &:focus{\n      outline: none;\n      border-color: $input-focus-border-color;\n    }\n  }\n}","\n//\n// apexcharts.scss\n//\n.apex-charts {\n    min-height: 10px !important;\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text {\n    font-family: $font-family-base !important;\n}\n\n.apexcharts-legend-series {\n    font-weight: $fw-medium;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: $apex-grid-color;\n}\n\n.apexcharts-legend-text {\n    color: $gray-600 !important;\n    font-family: $font-family-base !important;\n    font-size: 13px !important;\n}\n\n.apexcharts-pie-label {\n    fill: $white !important;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n}","\n//\n// echarts.scss\n//\n\n.e-charts{\n    height: 350px;\n}","\n\n/* Flot chart */\n.flot-charts-height {\n  height: 320px;\n}\n\n.flotTip {\n  padding: 8px 12px;\n  background-color: rgba($dark, 0.9);\n  z-index: 100;\n  color: $gray-100;\n  box-shadow: $box-shadow;\n  border-radius: 4px;\n}\n\n.legendLabel{\n  color: $gray-500;\n}","//\n// sparkline.scss\n//\n\n.jqstooltip {\n  box-sizing: content-box;\n  width: auto !important;\n  height: auto !important;\n  background-color: $gray-800 !important;\n  box-shadow: $box-shadow-lg;\n  padding: 5px 10px !important;\n  border-radius: 3px;\n  border-color: $gray-900 !important;\n}\n\n.jqsfield {\n  color: $gray-200 !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  font-family: $font-family-base !important;\n  font-weight: $fw-medium !important;\n}\n","\n//\n// Google map\n//\n\n.gmaps, .gmaps-panaroma {\n  height: 300px !important;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: 16px;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n  \n}","//\n// vector-maps.scss\n//\n\n.jvectormap-label {\n    border: none;\n    background: $gray-800;\n    color: $gray-100;\n    font-family: $font-family-base;\n    font-size: $font-size-base;\n    padding: 5px 8px;\n}","//\n// leaflet-maps.scss\n//\n\n.leaflet-map {\n    height: 300px;\n    &.leaflet-container{\n        z-index: 99;\n    }\n}","// \n// authentication.scss\n//\n\n\n// authentication home icon\n.home-btn {\n    position: absolute;\n    top: 15px;\n    right: 25px;\n}\n\n// auth 2\n\n.auth-logo{\n    .auth-logo-dark{\n        display: $display-block;\n    }\n    .auth-logo-light{\n        display: $display-none;\n    }\n}\n\n.auth-body-bg{\n    background-color: $card-bg;\n}\n\n\n// auth-pass-inputgroup\n\n.auth-pass-inputgroup{\n    input[type=\"input\"] + .btn .mdi-eye-outline{\n        &:before{\n            content: \"\\F06D1\";\n        }\n    }\n}\n\n// authentication full page\n\n.auth-full-bg{\n    background-color: rgba($primary, 0.25);\n    display: flex;\n\n    @media (min-width: 1200px){\n        height: 100vh;\n    }\n    \n\n    &::before{\n        content: \"\";\n        position: absolute;\n        width: 300px;\n        height: 300px;\n        border-radius: 50%;\n    }\n\n    .bg-overlay{\n        background: url(\"../../../images/bg-auth-overlay.png\");\n        background-size: cover;\n        background-repeat: no-repeat;\n        background-position: center;\n    }\n}\n\n.auth-full-page-content{\n    display: flex;\n\n    @media (min-width: 1200px){\n        min-height: 100vh;\n    }\n}\n\n.auth-review-carousel{\n    &.owl-theme {\n        .owl-dots {\n            .owl-dot{\n                span{\n                    background-color: rgba($primary, 0.25);\n                }\n                &.active, &:hover{\n                    span{\n                        background-color: $primary;\n                    }\n                }\n            }\n        }\n    }\n}","// \n// ecommerce.scss\n//\n\n// product\n\n.search-box{\n    .form-control{\n        border-radius: 30px;\n        padding-left: 40px;\n    }\n    .search-icon{\n        font-size: 16px;    \n        position: absolute;\n        left: 13px;\n        top: 0;\n        line-height: 38px;\n    }\n}\n\n.product-list{\n    li{\n        a{\n            display: block;\n            padding: 4px 0px;\n            color: $body-color;\n        }\n    }\n}\n\n.product-view-nav{\n    &.nav-pills {\n        .nav-item{\n            margin-left: 4px;\n        }\n        .nav-link{\n            width: 36px;\n            height: 36px;\n            font-size: 16px;\n            padding: 0;\n            line-height: 36px;\n            text-align: center;\n            border-radius: 50%;\n        }\n    }\n}\n\n.product-ribbon{\n    position: absolute;\n    right: 0px;\n    top: 0px;\n}\n\n// Product Details\n\n.product-detai-imgs{\n    .nav{\n        .nav-link{\n            margin: 7px 0px;\n\n            &.active{\n                background-color: $gray-300;\n            }\n        }\n    }\n}\n\n.product-color{\n    a{\n        display: inline-block;\n        text-align: center;\n        color: $body-color;\n        .product-color-item{\n            margin: 7px;\n        }\n        &.active, &:hover{\n            color: $primary;\n            .product-color-item{\n                border-color: $primary !important;\n            }\n        }\n    }\n}\n\n// ecommerce cart\n\n.visa-card{\n    .visa-logo{\n        line-height: 0.5;\n    }\n\n    .visa-pattern{\n        position: absolute;\n        font-size: 385px;\n        color: rgba($white, 0.05);\n        line-height: 0.4;\n        right: 0px;\n        bottom: 0px;\n    }\n}\n\n\n// checkout\n\n.checkout-tabs{\n    .nav-pills{\n        .nav-link{\n            margin-bottom: 24px;\n            text-align: center;\n            background-color: $card-bg;\n            box-shadow: $box-shadow;\n\n            &.active{\n                background-color: $primary;\n            }\n            .check-nav-icon{\n                font-size: 36px;\n            }\n        }\n    }\n}","/* ==============\n  Email\n===================*/\n.email-leftbar {\n  width: 236px;\n  float: left;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.email-rightbar {\n  margin-left: 260px;\n}\n\n.chat-user-box {\n  p.user-title {\n    color: $dark;\n    font-weight: 500;\n  }\n  p {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 767px) {\n  .email-leftbar {\n    float: none;\n    width: 100%;\n  }\n  .email-rightbar {\n    margin: 0;\n  }\n}\n\n\n.mail-list {\n  a {\n    display: block;\n    color: $gray-600 !important;\n    line-height: 24px;\n    padding: 8px 5px;\n    &.active {\n      color: $danger !important;\n      font-weight: 500;\n    }\n  }\n}\n\n.mail-list .nav-tabs-custom .nav-item .nav-link::after{\n  content: none;\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n\n  li {\n    position: relative;\n    display: block;\n    height: 50px;\n    line-height: 50px;\n    cursor: default;\n    transition-duration: .3s;\n\n    a{\n      color: $gray-600;\n    }\n\n    &:hover {\n      background: $gray-300;\n      transition-duration: .05s;\n    }\n\n    .col-mail {\n      float: left;\n      position: relative;\n    }\n\n    .col-mail-1 {\n      width: 320px;\n\n      .star-toggle,\n      .checkbox-wrapper-mail,\n      .dot {\n        display: block;\n        float: left;\n      }\n\n      .dot {\n        border: 4px solid transparent;\n        border-radius: 100px;\n        margin: 22px 26px 0;\n        height: 0;\n        width: 0;\n        line-height: 0;\n        font-size: 0;\n      }\n\n      .checkbox-wrapper-mail {\n        margin: 15px 10px 0 20px;\n      }\n\n      .star-toggle {\n        margin-top: 18px;\n        margin-left: 5px;\n      }\n\n      .title {\n        position: absolute;\n        top: 0;\n        left: 110px;\n        right: 0;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        margin-bottom: 0;\n      }\n    }\n\n    .col-mail-2 {\n      position: absolute;\n      top: 0;\n      left: 320px;\n      right: 0;\n      bottom: 0;\n\n      .subject,\n      .date {\n        position: absolute;\n        top: 0;\n      }\n\n      .subject {\n        left: 0;\n        right: 200px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n      }\n\n      .date {\n        right: 0;\n        width: 170px;\n        padding-left: 80px;\n      }\n    }\n\n    &.active,\n    &.active:hover {\n      box-shadow: inset 3px 0 0 $primary;\n    }\n\n    \n  &.unread  {\n    background-color: $gray-300;\n    font-weight: 500;\n    color: darken($dark,5%);\n      a{\n        color: darken($dark,5%);\n        font-weight: 500;\n      }\n    }\n  }\n\n\n  .checkbox-wrapper-mail {\n    cursor: pointer;\n    height: 20px;\n    width: 20px;\n    position: relative;\n    display: inline-block;\n    box-shadow: inset 0 0 0 1px $gray-400;\n    border-radius: 1px;\n\n    input {\n      opacity: 0;\n      cursor: pointer;\n    }\n    input:checked ~ label {\n      opacity: 1;\n    }\n\n    label {\n      position: absolute;\n      height: 20px;\n      width: 20px;\n      left: 0;\n      cursor: pointer;\n      opacity: 0;\n      margin-bottom: 0;\n      transition-duration: .05s;\n      top: 0;\n      &:before {\n        content: \"\\F012C\";\n        font-family: \"Material Design Icons\";\n        top: 0;\n        height: 20px;\n        color: darken($dark,5%);\n        width: 20px;\n        position: absolute;\n        margin-top: -16px;\n        left: 4px;\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) { \n  .message-list li .col-mail-1 {\n      width: 200px;\n  }\n}","// \n// File manager.scss\n//\n\n// file manager\n\n.filemanager-sidebar{\n    \n    @media (min-width: 1200px){\n        min-width: 230px;\n        max-width: 230px;\n    }\n\n    @media (min-width: 1366px){\n        min-width: 280px;\n        max-width: 280px;\n    }\n\n}\n\n.categories-list{\n    padding: 4px 0;\n    li{\n        a{\n            display: block;\n            padding: 8px 12px;\n            color: $body-color;\n            font-weight: $fw-medium;\n        }\n\n        &.active{\n            a{\n                color: $primary;\n            }\n        }\n\n        ul{\n            padding-left: 16px;\n            li{\n                a{\n                    padding: 4px 12px;\n                    color: $text-muted;\n                    font-size: 13px;\n                    font-weight: $font-weight-normal;\n                }\n            }\n        }\n    }\n}\n\n\n","// \n// Chat.scss\n//\n\n.chat-leftsidebar{\n  @media (min-width: 992px) {\n    min-width: 260px;\n  }\n\n  @media (min-width: 1200px) {\n    min-width: 380px;\n  }\n\n  .chat-leftsidebar-nav{\n    .nav{\n      background-color: $card-bg;\n    }\n\n    .tab-content{\n      min-height: 488px;\n    }\n  }\n}\n\n.chat-noti-dropdown{\n  &.active{\n    &:before{\n      content: \"\";\n      position: absolute;\n      width: 8px;\n      height: 8px;\n      background-color: $danger;\n      border-radius: 50%;\n      right: 0;\n    }\n  }\n\n  .btn{\n    padding: 6px;\n    box-shadow: none;\n    font-size: 20px;\n  }\n}\n\n.chat-search-box{\n  .form-control{\n    border: 0;\n  }\n}\n\n.chat-list{\n  margin: 0;\n  li{\n    &.active{\n      a{\n        background-color: $card-bg;\n        border-color: transparent;\n        box-shadow: $box-shadow;\n      }\n    }\n    a{\n      display: block;\n      padding: 14px 16px;\n      color: $gray-600;\n      transition: all 0.4s;\n      border-top: 1px solid $border-color;\n      border-radius: 4px;\n      &:hover{\n        background-color: $card-bg;\n        border-color: transparent;\n        box-shadow: $box-shadow;\n\n      }\n    }\n  }\n}\n\n\n.user-chat-nav{\n  .dropdown{\n    .nav-btn{\n      height: 40px;\n      width: 40px;\n      line-height: 40px;\n      box-shadow: none;\n      padding: 0;\n      font-size: 16px;\n      background-color: $light;\n      border-radius: 50%;\n    }\n\n    .dropdown-menu{\n      box-shadow: $box-shadow;\n      border: 1px solid $border-color\n    }\n  }\n}\n\n\n.chat-conversation{\n  li{\n    clear: both;\n  }\n\n  .chat-day-title{\n    position: relative;\n    text-align: center;\n    margin-bottom: 24px;\n\n    .title{\n      background-color: $card-bg;\n      position: relative;\n      z-index: 1;\n      padding: 6px 24px;\n    }\n\n    &:before{\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 1px;\n      left: 0;\n      right: 0;\n      background-color: $border-color;\n      top: 10px;\n    }\n    .badge{\n      font-size: 12px;\n    }\n  }\n  .conversation-list{\n    margin-bottom: 24px;\n    display: inline-block;\n    position: relative;\n\n    .ctext-wrap{\n      padding: 12px 24px;\n      background-color: rgba($primary,0.1);\n      border-radius: 8px 8px 8px 0px;\n      overflow: hidden;\n\n      .conversation-name{\n        font-weight: $font-weight-semibold;\n        color: $primary;\n        margin-bottom: 4px;\n      }\n    }\n\n    .dropdown{\n      float: right;\n      .dropdown-toggle{\n        font-size: 18px;\n        padding: 4px;\n        color: $gray-600;\n        @media (max-width: 575.98px) {\n          display: none;\n        }\n      }\n\n      .dropdown-menu{\n        box-shadow: $box-shadow;\n        border: 1px solid $border-color\n      }\n    }\n\n    .chat-time{\n      font-size: 12px;\n    }\n  }\n\n  .right{\n    .conversation-list{\n      float: right;\n      .ctext-wrap{\n        background-color: $light;\n        text-align: right;\n        border-radius: 8px 8px 0px 8px;\n      }\n      .dropdown{\n        float: left;\n      }\n\n      &.last-chat{\n        .conversation-list{\n          &:before{\n            right: 0;\n            left: auto;\n          }\n        }\n      }\n    }\n\n  }\n\n  .last-chat{\n    .conversation-list{\n      &:before{\n        content: \"\\F0009\";\n        font-family: \"Material Design Icons\";\n        position: absolute;\n        color: $primary;\n        right: 0;\n        bottom: 0;\n        font-size: 16px;\n        \n    @media (max-width: 575.98px) {\n      display: none;\n    }\n      }\n    }\n  }\n}\n\n.chat-input-section{\n  border-top: 1px solid $border-color;\n}\n\n.chat-input{\n  border-radius: 30px;\n  background-color: $light !important;\n  border-color:  $light !important;\n  padding-right: 120px;\n}\n\n.chat-input-links{\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  li{\n    a{\n      font-size: 16px;\n      line-height: 36px;\n      padding: 0px 4px;\n      display: inline-block;\n    }\n  }\n}\n\n.chat-send{\n  @media (max-width: 575.98px) {\n    min-width: auto;\n  }\n}","// \n// projects.scss\n//\n\n// project list\n\n.project-list-table{\n    border-collapse:separate; \n    border-spacing:0 12px; \n  tr{\n    background-color: $card-bg;\n  }\n  \n}","// \n// Users.scss\n//\n\n.contact-links{\n  a{\n    color: $body-color;\n  }\n}\n\n// profile\n\n.profile-user-wid{\n  margin-top: -26px;\n}\n\n.payouts-table-success {\n\tbackground-color: #e4fce9 !important;\n}\n\n.payouts-table-danger {\n\tbackground-color: #fdeeee !important;\n}\n\n.height-fit-content {\n  height: fit-content !important;\n}\n\n.width-fit-content {\n  width: fit-content !important;\n}\n","// \n// crypto.scss\n//\n\n@media (min-width: 576px){\n    .currency-value{\n        position: relative;\n        &:after{\n            content: \"\\F04E1\";\n            font-family: \"Material Design Icons\";\n            font-size: 24px;\n            position: absolute;\n            width: 45px;\n            height: 45px;\n            line-height: 45px;\n            border-radius: 50%;\n            text-align: center;\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            background-color: $primary;\n            color: $white;\n            z-index: 9;\n            right: -34px;\n        }\n    }\n\n}\n\n.crypto-buy-sell-nav-content{\n    border: 2px solid $gray-300;\n    border-top: 0;\n}\n\n\n// KYC Application\n\n.kyc-doc-verification{\n    .dropzone{\n        min-height: 180px;\n        .dz-message{\n            margin: 24px 0px;\n        }\n    }\n}\n\n\n/******************\n    Ico Landing\n*******************/\n\n.section{\n    position: relative;\n    padding-top: 80px;\n    padding-bottom: 80px;\n\n    &.bg-white{\n        background-color: $card-bg !important;\n    }\n}\n\n.small-title{\n    color: $gray-600;\n    margin-bottom: 8px;\n}\n\n\n// Navigation\n\n.navigation {\n    padding: 0 16px;\n    width: 100%;\n    z-index: 999;\n    margin-bottom: 0px;\n    transition: all 0.5s ease-in-out;\n    border-bottom: 1px solid rgba($white, 0.1);\n\n    @media (max-width: 991.98px) {\n        background-color: $topnav-bg;\n    }\n    \n    .navbar-logo{\n        line-height: 70px;\n        transition: all 0.4s;\n        .logo-dark{\n            display: none;\n            @media (max-width: 991.98px) {\n                display: block;\n            }\n        }\n        .logo-light{\n            display: block;\n            @media (max-width: 991.98px) {\n                display: none;\n            }\n        }\n    }\n    \n\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                color: rgba($white, 0.6);\n                line-height: 58px;\n                padding: 6px 16px;\n                font-weight: $fw-medium;\n                transition: all 0.4s;\n\n                @media (max-width: 991.98px) {\n                    color: $header-item-color;\n                }\n\n                &:hover, &.active{\n                    color:  rgba($white, 0.9);\n\n                    @media (max-width: 991.98px) {\n                        color: $primary;\n                    }\n                }\n\n                @media (max-width: 991.98px) {\n                    line-height: 28px !important;\n                }\n            }\n        }\n    }\n\n    &.nav-sticky{\n        background-color: $topnav-bg;\n        box-shadow: $box-shadow;\n        .navbar-logo{\n            line-height: 60px;\n\n            .logo-dark{\n                display: $display-block;\n            }\n            .logo-light{\n                display: $display-none;\n            }\n        }\n\n        .navbar-nav {\n            .nav-item {\n                .nav-link{\n                    line-height: 48px;\n                    color: $header-item-color;\n                    &:hover, &.active{\n                        color: $primary;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.bg-overlay{\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    top: 0;\n    opacity: 0.7;\n    background-color: $black;\n}\n\n.hero-section{\n    padding-top: 220px;\n    padding-bottom: 190px;\n\n    &.bg-ico-hero{\n        background-image: url(\"../../../images/crypto/bg-ico-hero.jpg\");\n        background-size: cover;\n        background-position: top;\n    }\n\n    @media (max-width: 575.98px) {\n        padding-top: 140px;\n        padding-bottom: 80px;\n    }\n\n    .hero-title{\n        font-size: 42px;\n        @media (max-width: 575.98px) {\n            font-size: 26px;\n        }\n    }\n\n    .ico-countdown{\n        font-size: 22px;\n        margin-right: -12px;\n        margin-left: -12px;\n        @media (max-width: 575.98px) {\n            display: block;\n        }\n        .coming-box{\n            margin-right: 12px;\n            margin-left: 12px;\n            border: 1px solid $border-color;\n            border-radius: 4px;\n            padding: 8px;\n            background-color: $card-bg;\n\n            @media (max-width: 575.98px) {\n                display: inline-block;\n                width: 40%;\n                margin-bottom: 24px;\n            }\n\n            span{\n                background-color: $light;\n                font-size: 12px;\n                padding: 4px;\n                margin-top: 8px;\n            }\n        }\n    }\n\n    .softcap-progress{\n        overflow: visible;\n\n        .progress-bar{\n            overflow: visible;\n        }\n\n        .progress-label{\n            position: relative;\n            text-align: right;\n            color: $body-color;\n            bottom: 20px;\n            font-size: 12px;\n            font-weight: $fw-medium;\n        }\n    }\n}\n\n\n// currency price\n\n.currency-price{\n    position: relative;\n    bottom: 40px;\n}\n\n\n// Clients\n\n.client-images {\n    img {\n        max-height: 34px;\n        width: auto !important;\n        margin: 12px auto;\n        opacity: 0.7;\n        transition: all 0.4s;\n    }\n}\n\n\n// Features\n\n.features-number{\n    opacity: 0.1;\n}\n\n\n// Team\n\n.team-box{\n    .team-social-links{\n        a{\n            color: $body-color;\n            font-size: 14px;\n        }\n    }\n}\n\n// Blog\n\n.blog-box{\n    .blog-badge{\n        position: absolute;\n        top: 12px;\n        right: 12px;\n    }\n}\n\n// landing footer\n\n.landing-footer{\n    padding: 80px 0 40px;\n    background-color: $sidebar-dark-bg;\n    color: rgba($white, 0.5);\n\n    .footer-list-title{\n        color: rgba($white, 0.9);\n    }\n\n    .footer-list-menu {\n        li {\n            a {\n                display: block;\n                color: rgba($white, 0.5);\n                margin-bottom: 14px;\n                transition: all 0.4s;\n                &:hover{\n                    color: rgba($white, 0.8);\n                }\n            }\n        }\n    }\n\n    .blog-post{\n\n        .post{\n            display: block;\n            color: rgba($white, 0.5);\n            padding: 16px 0px;\n            border-bottom: 1px solid rgba($white, 0.1);\n            .post-title{\n                color: rgba($white, 0.8);\n                font-size: 14px;\n            }\n\n            &:first-of-type{\n                padding-top: 0;\n            }\n\n            &:last-of-type{\n                padding-bottom: 0;\n                border-bottom: 0;\n            }\n        }\n    }\n\n    .footer-border{\n        border-color: rgba($white, 0.1);\n    }\n}\n\n","// \n// coming-soon.scss\n//\n\n.counter-number {\n    font-size: 32px;\n    font-weight: $font-weight-semibold;\n    text-align: center;\n    display: flex;\n    span {\n        font-size: 16px;\n        font-weight: $font-weight-normal;\n        display: block;\n        padding-top: 5px;\n    }\n}\n\n.coming-box {\n    width: 25%;\n}\n","// \n// timeline.scss\n//\n\n/************** Horizontal timeline **************/ \n\n\n.hori-timeline{\n    .events{\n        .event-list{\n            text-align: center;\n            display: block;\n\n            .event-down-icon{\n                position: relative;\n                &::before{\n                    content: \"\";\n                    position: absolute;\n                    width: 100%;\n                    top: 16px;\n                    left: 0;\n                    right: 0;\n                    border-bottom: 3px dashed $gray-300;\n                }\n                .down-arrow-icon{\n                    position: relative;\n                    background-color: $card-bg;\n                    padding: 4px;\n                }\n            }\n\n            &:hover{\n                .down-arrow-icon{\n                    animation: fade-down 1.5s infinite linear;\n                }\n            }\n\n            &.active{\n                .down-arrow-icon{\n                    animation: fade-down 1.5s infinite linear;\n                    &:before {\n                        content: \"\\ec4c\";\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n/************** vertical timeline **************/ \n\n.verti-timeline{\n    border-left: 3px dashed $gray-300;\n    margin: 0 10px;\n    .event-list{\n        position: relative;\n        padding: 0px 0px 40px 30px;\n\n        .event-timeline-dot{\n            position: absolute;\n            left: -9px;\n            top: 0px;\n            z-index: 9;\n            font-size: 16px;\n        }\n        .event-content{\n            position: relative;\n            border: 2px solid $border-color;\n            border-radius: 7px;\n        }\n\n        &.active{\n            .event-timeline-dot{\n                color: $primary;\n            }\n        }\n\n        &:last-child{\n            padding-bottom: 0px;\n        }\n    }\n}","// \n// Extras pages.scss\n//\n\n\n// pricing\n\n\n.plan-box{\n    .plan-btn{\n        position: relative;\n\n        &::before{\n            content: \"\";\n            position: absolute;\n            width: 100%;\n            height: 2px;\n            background: $gray-300;\n            left: 0px;\n            right: 0px;\n            top: 12px;\n        }\n    }\n}\n\n\n\n// blog\n\n.blog-play-icon{\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    transform: translateY(-50%);\n    margin: 0px auto;\n}",".information-wrap span + span {\n  border-top: 1px solid #eff2f7;\n  padding-top: 8px;\n  margin-top: 8px;\n}\n\n.information-wrap span h6 {\n  margin: 0;\n  font-weight: bold;\n}\n\n.fundings-form h4 {\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n.information-wrap {\n  padding: 14px 10px;\n  border-radius: 5px;\n  border: 1px solid #eff2f7;\n}\n\n.status-box {\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n.status-box .form-control {\n  display: flex;\n}\n\n.status-box .form-control .form-check {\n  margin-right: 15px;\n}\n.coment-box {\n  margin-bottom: 20px;\n}\n",".inner-repeater ul {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 5px;\n  border-radius: 5px;\n  border: 1px solid #ced4da;\n  margin: 0;\n}\n\n.inner-repeater ul li {\n  color: #333;\n  margin: 4px 3px;\n  list-style: none;\n  border-radius: 5px;\n  background: #f2f2f2;\n  padding: 0 8px 0px 10px;\n  border: 1px solid #e3e1e1;\n}\n\n.moderator-table{\n  width: 100%;\n  table-layout: fixed;\n}\n\n.overflow-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.datepicker-container-error {\n  border: 1px solid#f46a6a;\n}\n.end_start_date_required{\n  color:#f46a6a;\n  font-size: 10px;\n}\n.more-text{\n  font-size: 11px;\n  opacity: 0.9;\n}\n\nli.placeHolder {\n  background: transparent !important;\n  padding: 0;\n  border: 0 !important;\n}\n\n.react-bootstrap-table-page-btns-ul {\n  margin: 0;\n}\n\n.pagination-rounded {\n  flex-direction: row-reverse;\n  justify-content: space-between !important;\n  align-items: center !important;\n}\n",".switch {\n  position: relative;\n  display: inline-block;\n  width: 45px;\n  height: 24px;\n  margin: 0;\n}\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n.slider.round {\n  border-radius: 34px;\n}\ninput:checked + .slider {\n  background-color: #556ee6;\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n.slider.round:before {\n  border-radius: 50%;\n}\n.switch input:checked + .slider:before {\n  -webkit-transform: translateX(21px);\n  -ms-transform: translateX(21px);\n  transform: translateX(21px);\n}\n","\n.multi-input .ReactTags__tagInput input {\n    display: inline-block;\n    border: 1px solid #ced4da;\n    padding: 7px 15px;\n    border-radius: 100px;\n    width: 100%;\n}\n\n.multi-input .ReactTags__selected {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.multi-input .ReactTags__selected .ReactTags__tagInput {\n    display: block;\n    width: 100%;\n    order: 1;\n}\n\n.multi-input .ReactTags__selected .tag-wrapper {\n    order: 2;\n    background: #556ee6;\n    color: #fff;\n    padding: 5px 10px;\n    font-size: 11px;\n    border-radius: 100px;\n    margin-right: 5px;\n    margin-top: 5px;\n}\n\n.multi-input .ReactTags__selected .tag-wrapper button {\n    background: transparent;\n    border: none;\n    color: #fff;\n    padding: 0;\n    margin-left: 10px;\n}",".question-table-wrp {\n  position: relative;\n  padding-bottom: 30px;\n}\n.faq-heading {\n  background: #f7f7fa;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n.faq-heading p {\n  margin: 0;\n}\n.faq-heading p span h6 {\n  margin: 0;\n}\n.question-table-wrp h3 {\n  color: #495057;\n  text-transform: uppercase;\n  font-weight: 600;\n  padding-bottom: 10px;\n  display: block;\n}\n.faq-list {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eff2f7;\n  margin-bottom: 30px;\n}\n.faq-desc {\n  position: relative;\n  padding-bottom: 20px;\n}\n\n.faq-desc-itme {\n  position: relative;\n  width: 100%;\n  padding-left: 25px;\n}\n\n.faq-quetion,\n.faq-answer {\n  position: relative;\n  padding-bottom: 10px;\n  display: block;\n}\n\n.faq-quetion label,\n.faq-answer label {\n  color: #000;\n  font-weight: 900;\n  font-size: 13px;\n  margin: 0;\n  display: block;\n  position: absolute;\n  top: 1px;\n  left: -21px;\n}\n.faq-quetion h6 {\n  margin: 0;\n  font-size: 14px;\n  color: #000;\n  line-height: 20px;\n}\n.faq-answer p {\n  margin: 0;\n  font-size: 13px;\n  color: #495057;\n  line-height: 18px;\n}\n",".event-images img {\n  height: 150px !important;\n  width: 200px !important;\n\n  @media (min-width: 576px) {\n    height: 240px !important;\n    width: 320px !important;\n  }\n\n  @media (min-width: 768px) {\n    height: 120px !important;\n    width: 160px !important;\n  }\n\n  @media (min-width: 992px) {\n    height: 180px !important;\n    width: 240px !important;\n  }\n\n  @media (min-width: 1200px) {\n    height: 240px !important;\n    width: 320px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
